webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.17.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i in momentProperties) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _ordinalParseLenient.
	    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return this._months;
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return this._monthsShort;
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    //can't just apply() to create a date:
	    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    //the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    //the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return this._weekdays;
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    ordinalParse: defaultOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(50)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	        hooks.createFromInputFallback(config);
	    }
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse)) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (input === undefined) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (typeof(input) === 'object') {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString () {
	    var m = this.clone().utc();
	    if (0 < m.year() && m.year() <= 9999) {
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            return this.toDate().toISOString();
	        } else {
	            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    } else {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$1 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$1;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this[units + 's']();
	}
	
	function makeGetter(name) {
	    return function () {
	        return this._data[name];
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    s: 45,  // seconds to minute
	    m: 45,  // minutes to hour
	    h: 22,  // hours to day
	    d: 26,  // days to month
	    M: 11   // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds < thresholds.s && ['s', seconds]  ||
	            minutes <= 1           && ['m']           ||
	            minutes < thresholds.m && ['mm', minutes] ||
	            hours   <= 1           && ['h']           ||
	            hours   < thresholds.h && ['hh', hours]   ||
	            days    <= 1           && ['d']           ||
	            days    < thresholds.d && ['dd', days]    ||
	            months  <= 1           && ['M']           ||
	            months  < thresholds.M && ['MM', months]  ||
	            years   <= 1           && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    return true;
	}
	
	function humanize (withSuffix) {
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.17.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(250)(module)))

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(98);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(324), __esModule: true };

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(310);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(308);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(53);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(53);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _weakMap = __webpack_require__(313);
	
	var _weakMap2 = _interopRequireDefault(_weakMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emitter = new _weakMap2.default();
	
	var Emitter = function () {
		function Emitter() {
			(0, _classCallCheck3.default)(this, Emitter);
	
			emitter.set(this, {
				events: {}
			});
	
			this.eventLength = 0;
		}
	
		(0, _createClass3.default)(Emitter, [{
			key: 'on',
			value: function on(event, cb) {
				if (typeof cb === 'undefined') {
					throw new Error('You must provide a callback method.');
				}
	
				if (typeof cb !== 'function') {
					throw new TypeError('Listener must be a function');
				}
	
				this.events[event] = this.events[event] || [];
				this.events[event].push(cb);
	
				this.eventLength++;
	
				return this;
			}
		}, {
			key: 'off',
			value: function off(event, cb) {
				if (typeof cb === 'undefined') {
					throw new Error('You must provide a callback method.');
				}
	
				if (typeof cb !== 'function') {
					throw new TypeError('Listener must be a function');
				}
	
				if (typeof this.events[event] === 'undefined') {
					throw new Error('Event not found - the event you provided is: ' + event);
				}
	
				var listeners = this.events[event];
	
				listeners.forEach(function (v, i) {
					if (v === cb) {
						listeners.splice(i, 1);
					}
				});
	
				if (listeners.length === 0) {
					delete this.events[event];
	
					this.eventLength--;
				}
	
				return this;
			}
		}, {
			key: 'trigger',
			value: function trigger(event) {
				var _this = this;
	
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					args[_key - 1] = arguments[_key];
				}
	
				if (typeof event === 'undefined') {
					throw new Error('You must provide an event to trigger.');
				}
	
				var listeners = this.events[event];
	
				if (typeof listeners !== 'undefined') {
					listeners = listeners.slice(0);
	
					listeners.forEach(function (v) {
						v.apply(_this, args);
					});
				}
	
				return this;
			}
		}, {
			key: 'events',
			get: function get() {
				return emitter.get(this).events;
			}
		}]);
		return Emitter;
	}();
	
	exports.default = Emitter;

/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//appState
	var ROTATE = exports.ROTATE = "Rotate";
	
	//appHome
	var OPENED_HOME = exports.OPENED_HOME = "OpenedHome";
	var CLICKED_SIGNIN_TOPNAV = exports.CLICKED_SIGNIN_TOPNAV = "ClickedSigninTopnav";
	var CLICKED_SIGNOUT_TOPNAV = exports.CLICKED_SIGNOUT_TOPNAV = "ClickedSignoutTopnav";
	var CLICKED_REGIONSELECT_TOPNAV = exports.CLICKED_REGIONSELECT_TOPNAV = "ClickedRegionselectTopnav";
	var CLICKED_HAMBURGER_HOME = exports.CLICKED_HAMBURGER_HOME = "ClickedHamburgerHome";
	
	//kiosque
	var SWIPED_ARCHIVE_HOME = exports.SWIPED_ARCHIVE_HOME = "SwipedArchiveHome";
	var SWIPED_PROMOSPOT_HOME = exports.SWIPED_PROMOSPOT_HOME = "SwipedPromospotHome";
	var SWIPED_SPECIALS_HOME = exports.SWIPED_SPECIALS_HOME = "SwipedSpecialsHome";
	var CLICKED_ARROW_ARCHIVE_HOME = exports.CLICKED_ARROW_ARCHIVE_HOME = "ClickedArrowArchiveHome";
	var CLICKED_ARROW_PROMOSPOT_HOME = exports.CLICKED_ARROW_PROMOSPOT_HOME = "ClickedArrowPromospotHome";
	var CLICKED_ARROW_SPECIALS_HOME = exports.CLICKED_ARROW_SPECIALS_HOME = "ClickedArrowSpecialsHome";
	var CLICKED_MAIN_HOME = exports.CLICKED_MAIN_HOME = "ClickedMainHome";
	var CLICKED_READ_HOME = exports.CLICKED_READ_HOME = "ClickedReadHome";
	var CLICKED_ARCHIVE_HOME = exports.CLICKED_ARCHIVE_HOME = "ClickedArchiveHome";
	var CLICKED_PROMOSPOT_HOME = exports.CLICKED_PROMOSPOT_HOME = "ClickedPromospotHome";
	var CLICKED_SPECIALS_HOME = exports.CLICKED_SPECIALS_HOME = "ClickedSpecialsHome";
	var CLICKED_NEWSSTAND = exports.CLICKED_NEWSSTAND = "ClickedNewsStand";
	
	//region
	var OPENED_REGIONSELECT = exports.OPENED_REGIONSELECT = "OpenedRegionselect";
	var CLICKED_REGION_REGIONSELECT = exports.CLICKED_REGION_REGIONSELECT = "ClickedRegionRegionselect";
	var CLICKED_PROCEED_REGIONSELECT = exports.CLICKED_PROCEED_REGIONSELECT = "ClickedProceedRegionselect";
	var CLICKEDAWAY_REGIONSELECT_TOPNAV = exports.CLICKEDAWAY_REGIONSELECT_TOPNAV = "ClickedAwayRegionSelectTopNav";
	var CLOSED_REGIONSELECT_TOPNAV = exports.CLOSED_REGIONSELECT_TOPNAV = "ClosedRegionSelectTopnav";
	
	//readerApp
	var CLICKED_HAMBURGER_READER = exports.CLICKED_HAMBURGER_READER = "ClickedHamburgerReader";
	var ACCESSED_SOCIALSHARING = exports.ACCESSED_SOCIALSHARING = "AccessedSocialSharing";
	
	//paywall
	var OPENED_PAYWALL = exports.OPENED_PAYWALL = "OpenedPaywall";
	var FOCUS_USERNAME_PAYWALL = exports.FOCUS_USERNAME_PAYWALL = "FocusUsernamePaywall";
	var FOCUS_PASSWORD_PAYWALL = exports.FOCUS_PASSWORD_PAYWALL = "FocusPasswordPaywall";
	var CLICKED_LOGIN_PAYWALL = exports.CLICKED_LOGIN_PAYWALL = "ClickedLoginPaywall";
	var CLICKED_FORGOTPW_PAYWALL = exports.CLICKED_FORGOTPW_PAYWALL = "ClickedForgotpwPaywall";
	var CLOSED_PAYWALL = exports.CLOSED_PAYWALL = "ClosePaywall";
	var CLICKED_BACK_PAYWALL = exports.CLICKED_BACK_PAYWALL = "ClickedBackPaywall";
	var CLICKED_CLOSE_PAYWALL = exports.CLICKED_CLOSE_PAYWALL = "ClickedClosePaywall";
	var REACHED_REDIRECT_LIMIT = exports.REACHED_REDIRECT_LIMIT = "ReachedRedirectLimit";
	var PAYWALL_LOGIN_AFTER_SHARE = exports.PAYWALL_LOGIN_AFTER_SHARE = "PaywallLoginAfterShare";
	
	//error popup
	
	var OPENED_ERRORPOPUP = exports.OPENED_ERRORPOPUP = "OpenedErrorPopup";
	var CLOSED_ERRORPOPUP = exports.CLOSED_ERRORPOPUP = "CloseErrorPopup";
	var CLICKED_BACK_ERRORPOPUP = exports.CLICKED_BACK_ERRORPOPUP = "ClickedBackErrorPopup";
	var CLICKED_CLOSE_ERRORPOPUP = exports.CLICKED_CLOSE_ERRORPOPUP = "ClickedCloseErrorPopup";
	
	//authentication
	var AUTHENTICATED = exports.AUTHENTICATED = "Authenticated";
	var AUTHORIZED = exports.AUTHORIZED = "Authorized";
	
	//sidemenu
	var SWIPED_RECENTLY_SIDEBAR = exports.SWIPED_RECENTLY_SIDEBAR = "SwipedRecentlySidebar";
	var SWIPED_SUPPLEMENTS_SIDEBAR = exports.SWIPED_SUPPLEMENTS_SIDEBAR = "SwipedSupplementsSidebar";
	var SWIPED_EXTRAS_SIDEBAR = exports.SWIPED_EXTRAS_SIDEBAR = "SwipedExtrasSidebar";
	var CLICKED_HOME_SIDEBAR = exports.CLICKED_HOME_SIDEBAR = "ClickedHomeSidebar";
	var CLICKED_SETTINGS_SIDEBAR = exports.CLICKED_SETTINGS_SIDEBAR = "ClickedSettingsSidebar";
	var SWIPED_CLOSE_SIDEBAR = exports.SWIPED_CLOSE_SIDEBAR = "SwipedCloseSidebar";
	var OPENED_SIDEBAR = exports.OPENED_SIDEBAR = "OpenedSidebar";
	var CLOSED_SIDEBAR = exports.CLOSED_SIDEBAR = "ClosedSidebar";
	var CLICKED_RECENTLY_SIDEBAR = exports.CLICKED_RECENTLY_SIDEBAR = "ClickedRecentlySidebar";
	var CLICKED_SUPPLEMENTS_SIDEBAR = exports.CLICKED_SUPPLEMENTS_SIDEBAR = "ClickedSupplementsSidebar";
	var CLICKED_EXTRAS_SIDEBAR = exports.CLICKED_EXTRAS_SIDEBAR = "ClickedExtrasSidebar";
	
	//settings
	var OPENED_SETTINGS = exports.OPENED_SETTINGS = "OpenedSettings";
	var CLICKED_REGIONSELECT_SETTINGS = exports.CLICKED_REGIONSELECT_SETTINGS = "ClickedRegionselectSettings";
	var CLICKED_ACCOUNT_SETTINGS = exports.CLICKED_ACCOUNT_SETTINGS = "ClickedAccountSettings";
	var CLICKED_HELP_SETTINGS = exports.CLICKED_HELP_SETTINGS = "ClickedHelpSettings";
	var CLICKED_ABOUT_SETTINGS = exports.CLICKED_ABOUT_SETTINGS = "ClickedAboutSettings";
	var CLICKED_CLOSE_SETTINGS = exports.CLICKED_CLOSE_SETTINGS = "ClickedCloseSettings";
	var CLICKED_LANDSCAPE_TOGGLE_SETTINGS = exports.CLICKED_LANDSCAPE_TOGGLE_SETTINGS = "ClickedLandscapeToggleSettings";
	
	var OPENED_READING_MODE_SETTINGS = exports.OPENED_READING_MODE_SETTINGS = "OpenedReadingModeSettings";
	var CLICKED_BACK_READING_MODE = exports.CLICKED_BACK_READING_MODE = "ClickedBackReadingMode";
	var CLICKED_CLOSE_READING_MODE = exports.CLICKED_CLOSE_READING_MODE = "ClickedCloseReadingMode";
	
	var OPENED_LANDSCAPE_TOGGLE_SETTINGS = exports.OPENED_LANDSCAPE_TOGGLE_SETTINGS = "OpenedLandscapeToggleSettings";
	var CLICKED_BACK_LANDSCAPE_TOGGLE = exports.CLICKED_BACK_LANDSCAPE_TOGGLE = "ClickedBackLandscapeToggle";
	var CLICKED_CLOSE_LANDSCAPE_TOGGLE = exports.CLICKED_CLOSE_LANDSCAPE_TOGGLE = "ClickedCloseLandscapeToggle";
	var CLICKED_DOUBLEPAGE_TOGGLE_SETTINGS = exports.CLICKED_DOUBLEPAGE_TOGGLE_SETTINGS = "ClickedDoublepageLandscapeToggleSettings";
	var CLICKED_SINGLEPAGE_TOGGLE_SETTINGS = exports.CLICKED_SINGLEPAGE_TOGGLE_SETTINGS = "ClickedSinglepageLandscapeToggleSettings";
	
	//regionSetting
	var OPENED_REGIONSELECT_SETTINGS = exports.OPENED_REGIONSELECT_SETTINGS = "OpenedRegionselectSettings";
	var CLICKED_BACK_REGIONSELECT = exports.CLICKED_BACK_REGIONSELECT = "ClickedBackRegionselect";
	var CLICKED_CLOSE_REGIONSELECT = exports.CLICKED_CLOSE_REGIONSELECT = "ClickedCloseRegionselect";
	//see also event from region
	
	//Accountsettings
	var CLICKED_LOGOUT_SETTINGS = exports.CLICKED_LOGOUT_SETTINGS = "ClickedLogoutSettings";
	//see also events from paywall
	
	//iframe
	var CLICKED_BACK_IFRAME = exports.CLICKED_BACK_IFRAME = "ClickedBackIframe";
	var CLICKED_CLOSE_IFRAME = exports.CLICKED_CLOSE_IFRAME = "ClickedCloseIframe";
	var OPENED_IFRAME_SETTINGS = exports.OPENED_IFRAME_SETTINGS = "OpenedIframeSettings";
	
	//about
	var OPENED_ABOUT_SETTINGS = exports.OPENED_ABOUT_SETTINGS = "OpenedAboutSettings";
	var CLICKED_BACK_ABOUT = exports.CLICKED_BACK_ABOUT = "ClickedBackAbout";
	var CLICKED_CLOSE_ABOUT = exports.CLICKED_CLOSE_ABOUT = "ClickedCloseAbout";
	
	var CLICKED_DISCLAIMER_SETTINGS = exports.CLICKED_DISCLAIMER_SETTINGS = "ClickedDislaimerSettings";
	var CLICKED_UUID_SETTINGS = exports.CLICKED_UUID_SETTINGS = "ClickedUuidSettings";
	var CLICKED_EDITOR_SETTINGS = exports.CLICKED_EDITOR_SETTINGS = "ClickedEditorSettings";
	var CLICKED_DEVELOPER_SETTINGS = exports.CLICKED_DEVELOPER_SETTINGS = "ClickedDeveloperSettings";
	
	//Viewer
	var OPENED_PUBLICATION_READER = exports.OPENED_PUBLICATION_READER = "OpenedPublicationReader";
	var RESIZED_READER = exports.RESIZED_READER = "ResizedReader";
	//appReader
	var INIT_READER = exports.INIT_READER = "InitReader";
	
	//reader
	var VIEW_PAGE = exports.VIEW_PAGE = "ViewPage";
	var VIEW_PAGE_IN_BACKGROUND = exports.VIEW_PAGE_IN_BACKGROUND = "ViewPageInBackground";
	var PERCENTAGE_IN_VIEW_COMPUTED = exports.PERCENTAGE_IN_VIEW_COMPUTED = "PercentageInViewComputed";
	var SWIPE_PAGE_FORWARD_READER = exports.SWIPE_PAGE_FORWARD_READER = "SwipePageForwardReader";
	var SWIPE_PAGE_BACKWARD_READER = exports.SWIPE_PAGE_BACKWARD_READER = "SwipePageBackwardReader";
	var CLICKED_PAGE_NEXT_READER = exports.CLICKED_PAGE_NEXT_READER = "ClickedPageNextReader";
	var CLICKED_PAGE_PREV_READER = exports.CLICKED_PAGE_PREV_READER = "ClickedPagePrevReader";
	var CLICKED_PAGE_NEXT_TOP_READER = exports.CLICKED_PAGE_NEXT_TOP_READER = "ClickedPageNextTopReader";
	var CLICKED_PAGE_NEXT_BOT_READER = exports.CLICKED_PAGE_NEXT_BOT_READER = "ClickedPageNextBotReader";
	var CLICKED_PAGE_PREV_TOP_READER = exports.CLICKED_PAGE_PREV_TOP_READER = "ClickedPagePrevTopReader";
	var CLICKED_PAGE_PREV_BOT_READER = exports.CLICKED_PAGE_PREV_BOT_READER = "ClickedPagePrevBotReader";
	var CLICKED_TOP_NAV_SINGLE_PAGE_MODE = exports.CLICKED_TOP_NAV_SINGLE_PAGE_MODE = "ClickedTopNavSinglePageMode";
	var CLICKED_TOP_NAV_DOUBLE_PAGE_MODE = exports.CLICKED_TOP_NAV_DOUBLE_PAGE_MODE = "ClickedTopNavDoublePageMode";
	
	//readerSlide
	var ZOOM_PAGE_IN_READER = exports.ZOOM_PAGE_IN_READER = "ZoomPageInReader";
	var ZOOM_PAGE_OUT_READER = exports.ZOOM_PAGE_OUT_READER = "ZoomPageOutReader";
	var ZOOM_PAGE_IN_READER_ON_DESKTOP = exports.ZOOM_PAGE_IN_READER_ON_DESKTOP = "ZoomPageInReaderOnDesktop";
	var ZOOM_PAGE_OUT_READER_ON_DESKTOP = exports.ZOOM_PAGE_OUT_READER_ON_DESKTOP = "ZoomPageOutReaderOnDesktop";
	var PAN_PAGE = exports.PAN_PAGE = "PanPageReader";
	var CLICKED_ZOOM_SLIDER_READER = exports.CLICKED_ZOOM_SLIDER_READER = "ClickedZoomSliderReader";
	
	//reader
	var CLICKED_PAGE_ENRICHMENTBUTTON_READER = exports.CLICKED_PAGE_ENRICHMENTBUTTON_READER = "ClickedPageEnrichmentbuttonReader";
	var CLICKED_PAGE_ARTICLE_READER = exports.CLICKED_PAGE_ARTICLE_READER = "ClickedPageArticleReader";
	var CLICKED_SUPPLEMENT_READER = exports.CLICKED_SUPPLEMENT_READER = "ClickedSupplementReader";
	
	//bottom navigation
	var CLICKED_BOTTOM_NAVIGATION_READER = exports.CLICKED_BOTTOM_NAVIGATION_READER = "ClickedBottomNavigationReader";
	var SWIPED_BOTTOM_NAVIGATION_READER = exports.SWIPED_BOTTOM_NAVIGATION_READER = "SwipedBottomNavigationReader";
	var RELEASE_BOTTOM_NAVIGATION_READER = exports.RELEASE_BOTTOM_NAVIGATION_READER = "ReleaseBottomNavigationReader";
	var CLICKED_FULLSCREEN_READER = exports.CLICKED_FULLSCREEN_READER = "ClickedFullScreenReader";
	var OPENED_FULLSCREEN_READER = exports.OPENED_FULLSCREEN_READER = "OpenedFullScreenReader";
	var EXIT_FULLSCREEN_READER = exports.EXIT_FULLSCREEN_READER = "ExitFullScreenReader";
	var CLICKED_ESCAPE_FULLSCREEN_READER = exports.CLICKED_ESCAPE_FULLSCREEN_READER = "ClickedEscapedFullScreenReader";
	
	//topnavigation
	var OPENED_CATEGORY_DROPDOWN_READER = exports.OPENED_CATEGORY_DROPDOWN_READER = "OpenedCategoryDropdownReader";
	var CLOSED_CATEGORY_DROPDOWN_READER = exports.CLOSED_CATEGORY_DROPDOWN_READER = "ClosedCategoryDropdownReader";
	var CLICKED_CATEGORY_READER = exports.CLICKED_CATEGORY_READER = "ClickedCategoryReader";
	var CLICKED_SUPPLEMENT_TOPNAV_READER = exports.CLICKED_SUPPLEMENT_TOPNAV_READER = "ClickedSupplementTopnavReader";
	var CLICKED_SUPPLEMENT_BUTTON_READER = exports.CLICKED_SUPPLEMENT_BUTTON_READER = "ClickedSupplementButtonReader";
	var CLICKED_BACK_TO_MAIN_READER = exports.CLICKED_BACK_TO_MAIN_READER = "ClickedBackToMainReader";
	var CLICKED_HOME_ICON_READER = exports.CLICKED_HOME_ICON_READER = "ClickedHomeIconReader";
	var CLICKED_SETTINGS = exports.CLICKED_SETTINGS = "ClickedSettings";
	var CLICKED_HELP = exports.CLICKED_HELP = "ClickedHelp";
	var CLICKED_FULLPDFDOWNLOAD_READER = exports.CLICKED_FULLPDFDOWNLOAD_READER = "ClickedFullPdfDownload";
	var CLICKED_SINGLEPAGEPDFDOWNLOAD_READER = exports.CLICKED_SINGLEPAGEPDFDOWNLOAD_READER = "ClickedSinglePagePdfDownload";
	
	//supplementView
	var OPENED_SUPPLEMENT_SCREEN_READER = exports.OPENED_SUPPLEMENT_SCREEN_READER = "OpenedSupplementScreenReader";
	var CLOSED_SUPPLEMENT_SCREEN_READER = exports.CLOSED_SUPPLEMENT_SCREEN_READER = "ClosedSupplementScreenReader";
	var CLICKED_SUPPLEMENT_SUPP_SCREEN = exports.CLICKED_SUPPLEMENT_SUPP_SCREEN = "ClickedSupplementSuppScreen";
	
	//alb controller
	var OPENED_ALB = exports.OPENED_ALB = "OpenedAlb";
	var CLOSED_ALB = exports.CLOSED_ALB = "ClosedAlb";
	var CLICKED_BACK_ALB = exports.CLICKED_BACK_ALB = "ClickedBackAlb";
	var CLICKED_FONT_ALB = exports.CLICKED_FONT_ALB = "ClickedFontAlb";
	var CLICKED_SHARE_ALB = exports.CLICKED_SHARE_ALB = "ClickedshareAlb";
	var CLICKED_NEXT_ALB = exports.CLICKED_NEXT_ALB = "ClickedNextAlb";
	var CLICKED_PREV_ALB = exports.CLICKED_PREV_ALB = "ClickedPrevAlb";
	var SWIPED_FORWARD_ALB = exports.SWIPED_FORWARD_ALB = "SwipedForwardAlb";
	var SWIPED_BACKWARD_ALB = exports.SWIPED_BACKWARD_ALB = "SwipedBackwardAlb";
	var VIEW_ARTICLE_ALB = exports.VIEW_ARTICLE_ALB = "ViewArticleAlb";
	var CLICKAWAY_OVERLAY_ALB = exports.CLICKAWAY_OVERLAY_ALB = "ClickedAwayOverlayAlb";
	var CLICKED_ENRICHEMENT_ALB = exports.CLICKED_ENRICHEMENT_ALB = "ClickedEnrichmentAlb";
	
	//SharingController
	var OPENED_SHARE_MENU_ALB = exports.OPENED_SHARE_MENU_ALB = "OpenedShareMenuAlb";
	var OPENED_SHARE_MENU_NEXTGEN = exports.OPENED_SHARE_MENU_NEXTGEN = "OpenedShareMenuNextgen";
	var CLICKED_WHATSAPP_SHARE = exports.CLICKED_WHATSAPP_SHARE = "ClickedWhatsappShare";
	var CLICKED_FACEBOOK_SHARE = exports.CLICKED_FACEBOOK_SHARE = "ClickedFacebookShare";
	var CLICKED_GOOGLE_SHARE = exports.CLICKED_GOOGLE_SHARE = "ClickedGoogleShare";
	var CLICKED_TWITTER_SHARE = exports.CLICKED_TWITTER_SHARE = "ClickedTwitterShare";
	var CLICKED_MAIL_SHARE = exports.CLICKED_MAIL_SHARE = "ClickedMailShare";
	var CLOSED_SHARE_MENU_ALB = exports.CLOSED_SHARE_MENU_ALB = "ClosedShareMenuAlb";
	
	//AlbImageSlider
	var CLICKED_IMAGE_ALB = exports.CLICKED_IMAGE_ALB = "ClickedImageAlb";
	var SWIPED_FORWARD_IMAGEVIEWER = exports.SWIPED_FORWARD_IMAGEVIEWER = "SwipedForwardImageviewer";
	var SWIPED_BACKWARD_IMAGEVIEWER = exports.SWIPED_BACKWARD_IMAGEVIEWER = "SwipedBackwardImageviewer";
	
	//imageviewer
	var OPENED_GALLERY_ALB = exports.OPENED_GALLERY_ALB = "OpenedGalleryAlb";
	var CLOSED_GALLERY_ALB = exports.CLOSED_GALLERY_ALB = "ClosedGalleryAlb";
	var SWIPED_FORWARD_GALLERY = exports.SWIPED_FORWARD_GALLERY = "SwipedForwardGallery";
	var SWIPED_BACKWARD_GALLERY = exports.SWIPED_BACKWARD_GALLERY = "SwipedBackwardGallery";
	var CLICKED_PREV_GALLERY = exports.CLICKED_PREV_GALLERY = "ClickedPrevGallery";
	var CLICKED_NEXT_GALLERY = exports.CLICKED_NEXT_GALLERY = "ClickedNextGallery";
	var CLICKED_BULLET_GALLERY = exports.CLICKED_BULLET_GALLERY = "ClickedBulletGallery";
	var VIEW_IMAGE_GALLERY = exports.VIEW_IMAGE_GALLERY = "ViewImageGallery";
	
	//imageViewerSlide
	var CLICKED_CAPTION_GALLERY = exports.CLICKED_CAPTION_GALLERY = "ClickedCaptionGallery";
	var ZOOM_IN_IMAGE_GALLERY = exports.ZOOM_IN_IMAGE_GALLERY = "ZoomInImageGallery";
	var ZOOM_OUT_IMAGE_GALLERY = exports.ZOOM_OUT_IMAGE_GALLERY = "ZoomOutImageGallery";
	var PAN_ZOOMEDINIMAGE_GALLERY = exports.PAN_ZOOMEDINIMAGE_GALLERY = "PanZoomedimageGallery";
	
	//print
	var CLICKED_PRINT_ALB = exports.CLICKED_PRINT_ALB = "ClickedPrintAlb";
	var CLICKED_PRINT_IMAGE_ALB = exports.CLICKED_PRINT_IMAGE_ALB = "ClickedPrintImageAlb";
	var CLICKED_PRINT_TEXT_ALB = exports.CLICKED_PRINT_TEXT_ALB = "ClickedPrintTextAlb";
	var CLICKED_PRINT_PDF = exports.CLICKED_PRINT_PDF = "ClickedPrintPDF";
	
	//cookie
	var CLICKED_COOKIEACCEPT = exports.CLICKED_COOKIEACCEPT = "ClickedCookieaccept";
	
	// nextgen
	var VIEW_PAGE_NEXGEN = exports.VIEW_PAGE_NEXGEN = "NextgenPageView";
	var CLICKED_NEXTGEN_READING_MODE_HOME = exports.CLICKED_NEXTGEN_READING_MODE_HOME = "ClickedNextgenReadingModeHome";
	var CLICKED_REPLICA_READING_MODE_HOME = exports.CLICKED_REPLICA_READING_MODE_HOME = "ClickedReplicaReadingModeHome";
	var CLICKED_NEXTGEN_READING_MODE_SIDEBAR = exports.CLICKED_NEXTGEN_READING_MODE_SIDEBAR = "ClickedNextgenReadingModeSidebar";
	var CLICKED_REPLICA_READING_MODE_SIDEBAR = exports.CLICKED_REPLICA_READING_MODE_SIDEBAR = "ClickedReplicaReadingModeSidebar";
	var CLICKED_REPLICA_READING_MODE_READER = exports.CLICKED_REPLICA_READING_MODE_READER = "ClickedReplicaReadingModeReader";
	var CLICKED_NEXTGEN_READING_MODE_READER = exports.CLICKED_NEXTGEN_READING_MODE_READER = "ClickedNextgenReadingModeReader";
	var CLICKED_READING_MODE_SETTINGS = exports.CLICKED_READING_MODE_SETTINGS = "ClickedReadingModeSettings";
	var CLICKED_NEXTGEN_READING_MODE_SETTINGS = exports.CLICKED_NEXTGEN_READING_MODE_SETTINGS = "ClickedNextgenReadingModeSettings";
	var CLICKED_REPLICA_READING_MODE_SETTINGS = exports.CLICKED_REPLICA_READING_MODE_SETTINGS = "ClickedReplicaReadingModeSettings";
	var VIEW_ARTICLE_ALB_NEXTGEN = exports.VIEW_ARTICLE_ALB_NEXTGEN = "ViewArticleAlbNextgen";
	
	var CLICKED_PRINT_READER = exports.CLICKED_PRINT_READER = "clickedPrintReader";
	var ADJUSTED_BOX_CROPPING = exports.ADJUSTED_BOX_CROPPING = "adjustedBoxCropping";
	var CLICKED_PRINT_CROPPING = exports.CLICKED_PRINT_CROPPING = "clickedPrintCropping";

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.noop = noop;
	exports.reflect = reflect;
	exports.requiredParam = requiredParam;
	exports.isHTML = isHTML;
	exports.disableAllScrolling = disableAllScrolling;
	exports.enableAllScrolling = enableAllScrolling;
	exports.enableScrollingWithTimeout = enableScrollingWithTimeout;
	exports.enableScrolling = enableScrolling;
	exports.getContent = getContent;
	exports.addDropCap = addDropCap;
	exports.generatePreview = generatePreview;
	exports.generateSecurePreviewURL = generateSecurePreviewURL;
	exports.generateImageURL = generateImageURL;
	exports.generateCoverURL = generateCoverURL;
	exports.generateSecureImageURL = generateSecureImageURL;
	exports.generateNextgenImageUrl = generateNextgenImageUrl;
	exports.createElement = createElement;
	exports.isHighDensity = isHighDensity;
	exports.createDivWithClass = createDivWithClass;
	exports.labelToDate = labelToDate;
	exports.labelToShortDate = labelToShortDate;
	exports.labelToFullDate = labelToFullDate;
	exports.goToHomeFromReader = goToHomeFromReader;
	exports.getGoToPublicationUrl = getGoToPublicationUrl;
	exports.goToPublication = goToPublication;
	exports.createSubArray = createSubArray;
	exports.createSharingUrls = createSharingUrls;
	exports.getParameterByName = getParameterByName;
	exports.removeURLParameter = removeURLParameter;
	exports.stripHtml = stripHtml;
	exports.getCorrectContentPackagePublication = getCorrectContentPackagePublication;
	exports.getFirst = getFirst;
	exports.generateError = generateError;
	exports.getErrorMessage = getErrorMessage;
	exports.createError = createError;
	exports.pad = pad;
	exports.constructCurrentDate = constructCurrentDate;
	exports.compact = compact;
	exports.isSamsungBrowser = isSamsungBrowser;
	exports.isAndroid = isAndroid;
	exports.getDeviceClasses = getDeviceClasses;
	exports.areEventsTracked = areEventsTracked;
	exports.replaceAt = replaceAt;
	exports.stripHtm = stripHtm;
	exports.createRedirectionLogoutUrl = createRedirectionLogoutUrl;
	exports.isParameterInUrl = isParameterInUrl;
	exports.sendMessageIfBackButtonEnabled = sendMessageIfBackButtonEnabled;
	exports.createRedirectionUrl = createRedirectionUrl;
	exports.isSinglePage = isSinglePage;
	
	var _mobileDetect = __webpack_require__(123);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function noop() {}
	
	function reflect(promise) {
	  return promise.then(function (v) {
	    return { v: v, status: "resolved" };
	  }, function (e) {
	    return { e: e, status: "rejected" };
	  });
	}
	
	function requiredParam() {
	  var paramName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Parameter";
	
	  throw new Error(paramName + " is required!");
	}
	
	function isHTML(str) {
	  var a = document.createElement("div");
	  a.innerHTML = str;
	  for (var c = a.childNodes, i = c.length; i--;) {
	    if (c[i].nodeType === 1) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function disableAllScrolling(except) {
	  var allDivs = document.querySelectorAll(".overflow");
	  var result = [];
	  for (var i = 0; i < allDivs.length; i++) {
	    if (except !== allDivs[i]) {
	      result.push(allDivs[i]);
	      allDivs[i].classList.remove("overflow");
	    }
	  }
	  return result;
	}
	
	function enableAllScrolling(allDivs) {
	  for (var i = 0; i < allDivs.length; i++) {
	    allDivs[i].classList.add("overflow");
	  }
	}
	
	/**
	 * Hack to enable scrolling when dynamicly adding content for IOS
	 */
	function enableScrollingWithTimeout(div, timeout) {
	  var time = 0;
	  if (timeout) {
	    time = timeout;
	  }
	  setTimeout(function () {
	    enableScrolling(div);
	  }, time);
	}
	
	/**
	 * Hack to enable scrolling when dynamicly adding content for IOS
	 */
	function enableScrolling(div) {
	  if (div) {
	    div.classList.remove("overflow");
	    setTimeout(function () {
	      div.classList.add("overflow");
	    }, 100);
	  }
	}
	
	/**
	 * Processes a content for the alb and extras
	 * @return {[type]} [description]
	 */
	function getContent(contentItems, publicationPage, changeDropCap, sessionId, userId, downloadId) {
	  var category = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "";
	
	  if (!sessionId) return;
	  var result = {};
	  result.images = [];
	  result.extras = [];
	  result.extraType = null;
	  result.extraPlacement = null;
	
	  var imageViewerImageEnrichments = [];
	  var imageViewerImageEnrichmentsId = 0;
	
	  contentItems.forEach(function (contentItem) {
	    switch (contentItem.ContentType) {
	      case "text/xml":
	        result.article = contentItem;
	        result.title = contentItem.Title;
	        result.wordCount = stripHtml(contentItem.Introduction).split(" ").length + stripHtml(contentItem.HtmlText).split(" ").length;
	        if (changeDropCap) {
	          contentItem.HtmlText = addDropCap(contentItem.HtmlText);
	        }
	        break;
	      case "graphic/jpeg":
	        {
	          var graphic = contentItem;
	          // TODO
	          graphic.src = generateSecureImageURL("250/0", contentItem.ContentItemId, sessionId, userId, downloadId);
	          graphic.srcHD = generateSecureImageURL("0/0", contentItem.ContentItemId, sessionId, userId, downloadId);
	          result.images.push(graphic);
	          break;
	        }
	      case "image/jpeg":
	        {
	          var image = contentItem;
	          result.images.push(image);
	          break;
	        }
	      case "quote/xml":
	        result.quote = contentItem; //TODO: quote is empty for NB
	        break;
	      case "author/xml":
	        result.author = contentItem;
	        break;
	      //start extras
	      case "ad/url":
	        if (!result.extraType) {
	          result.extraType = "url";
	        } else if (result.extraType !== "url") {
	          result.extraType = "mixed";
	        }
	        if (publicationPage && !result.extraPlacement && publicationPage.RelatedContents.some(function (rc) {
	          return rc.RelatedContentItemId === contentItem.ContentItemId;
	        })) {
	          result.extraPlacement = publicationPage;
	        }
	        if (!result.extraPlacement && publicationPage && publicationPage.ContentItemID == contentItem.ContentItemId) {
	          result.extraPlacement = publicationPage;
	        }
	
	        result.extras.push(contentItem);
	        break;
	      case "video/url":
	        if (!result.extraType) {
	          result.extraType = "video";
	        } else if (result.extraType !== "video") {
	          result.extraType = "mixed";
	        }
	        if (publicationPage && !result.extraPlacement && publicationPage.RelatedContents.some(function (rc) {
	          return rc.RelatedContentItemId === contentItem.ContentItemId;
	        })) {
	          result.extraPlacement = publicationPage;
	        }
	        result.extras.push(contentItem);
	        break;
	      case "imageEnrichment/jpeg":
	        {
	          if (!result.extraType) {
	            result.extraType = "image";
	          } else if (result.extraType !== "image") {
	            result.extraType = "mixed";
	          }
	          if (publicationPage && !result.extraPlacement && publicationPage.RelatedContents.some(function (rc) {
	            return rc.RelatedContentItemId === contentItem.ContentItemId;
	          })) {
	            result.extraPlacement = publicationPage;
	          }
	          var extraImage = contentItem;
	          // TODO
	          extraImage.src = generateSecureImageURL("250/0", contentItem.ContentItemId, sessionId, userId, downloadId);
	          extraImage.srcHD = generateSecureImageURL("0/0", contentItem.ContentItemId, sessionId, userId, downloadId);
	          extraImage.id = imageViewerImageEnrichmentsId;
	          imageViewerImageEnrichmentsId++;
	          imageViewerImageEnrichments.push(extraImage);
	          result.extras.push(extraImage);
	          break;
	        }
	      case "share/url":
	        result.sharing = contentItem;
	        break;
	      default:
	        // eslint-disable-next-line
	        console.log("new contentType: " + contentItem.ContentType);
	    }
	  });
	  result.extraImageViewer = {};
	  result.extraImageViewer.images = imageViewerImageEnrichments;
	  result.category = category;
	  return result;
	}
	
	/**
	 * adds dropcapp class to html if only first letter is in bold tag
	 */
	function addDropCap(html) {
	  var result = html;
	  var beginningOfHtml = result.substr(0, 15);
	  var newBeginning = beginningOfHtml;
	  if (beginningOfHtml.substr(0, 6).toLowerCase() === "<p><b>" && beginningOfHtml.substr(7, 8).toLowerCase() === "</b></p>") {
	    newBeginning = "<b class=\"dropcap\">" + beginningOfHtml.substr(6, 1) + "</b>";
	  }
	  result = newBeginning + result.substr(15);
	  return result;
	}
	
	/**
	 * Get the correct API endpoint for each page and environment
	 * @return {[string]} the api uri
	 */
	function getApiEndpoint() {
	  return window.location.pathname.includes("prodreader.html") || window.location.pathname.includes("prod_index.html") ? ("mhu-ds-production-backend-api.twipecloud.net") : ("mhu-ds-production-backend-api.twipecloud.net");
	}
	
	/**
	 * generates preview URL for  given image id and size
	 * @param  {[string]} size [description]
	 * @param  {[int]} id   [description]
	 * @return {[string]}      [description]
	 */
	function generatePreview(size, id, api) {
	  return "https://" + (api || getApiEndpoint()) + "/Preview/" + size + "/" + id;
	}
	
	/**
	 * Generates secure link that contains session data. Use this method
	 * to get url for protected resources (like page images etc.)
	 * @param  {string} size       image width/height
	 * @param  {number} id         image identifier
	 * @param  {number} sessionid  user session identifier
	 * @param  {number} userid     user identifier
	 * @param  {number} downloadId download identifier
	 * @return {string}            secure url to resource
	 */
	function generateSecurePreviewURL(size, id, sessionId, userId, downloadId) {
	  return generatePreview(size, id) + "/" + ("3.9.4") + "/" + sessionId + "/" + userId + "/" + downloadId;
	}
	
	/**
	 * generates image URL for  given image id and size
	 * @param  {[string]} size [description]
	 * @param  {[int]} id   [description]
	 * @return {[string]}      [description]
	 */
	function generateImageURL(size, id) {
	  return "//" + getApiEndpoint() + "/Image/" + size + "/" + id;
	}
	
	function generateCoverURL(contentPackageId, size, thumbID, timestamp) {
	  var domain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	  var targetDomain = domain || (window.location.pathname.includes("prodreader.html") || window.location.pathname.includes("prod_index.html") ? ("mhu-ds-webreader-production.twipemobile.com") : ("mhu-ds-webreader-production.twipemobile.com"));
	  var time = timestamp;
	  if (!time) {
	    var rounding = 1000 * 60 * 1; // round by one minute
	    time = Math.round(new Date().getTime() / rounding) * rounding;
	  }
	  return "//" + targetDomain + "/data/" + contentPackageId + "/covers/Preview-" + size + "-" + thumbID + ".jpg?t=" + time;
	}
	
	/**
	 * Generates secure link that contains session data. Use this method
	 * to get url for protected images
	 * @param  {string} size       image width/height
	 * @param  {number} id         image identifier
	 * @param  {number} sessionid  user session identifier
	 * @param  {number} userid     user identifier
	 * @param  {number} downloadId download identifier
	 * @return {string}            secure url to resource
	 */
	function generateSecureImageURL(size, id, sessionId, userId, downloadId) {
	  return generateImageURL(size, id) + "/" + ("3.9.4") + "/" + sessionId + "/" + userId + "/" + downloadId;
	}
	
	/**
	 * Generates image URL for nextgen reader
	 * @param  {number} contentPackageId content package id
	 * @param  {sting} fileName          file name
	 * @return {string}                  URL
	 */
	function generateNextgenImageUrl(contentPackageId, fileName) {
	  return "//" + ("mhu-ds-webreader-production.twipemobile.com") + "/data/" + contentPackageId + "/NextGenData/" + fileName;
	}
	
	function createElement() {
	  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "div";
	
	  return document.createElement(name);
	}
	
	function isHighDensity() {
	  return window.matchMedia && (window.matchMedia("only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)").matches || window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)").matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
	}
	
	function createDivWithClass(name) {
	  var div = createElement();
	  div.classList.add(name);
	  return div;
	}
	
	function labelToDate(dateString, language, format) {
	  var moment = __webpack_require__(1);
	  __webpack_require__(50)("./" + language);
	  var date = moment(dateString);
	  var result = date.format(format);
	  return result;
	}
	
	function labelToShortDate(dateString, language) {
	  var moment = __webpack_require__(1);
	  __webpack_require__(50)("./" + language);
	  var date = moment(dateString);
	  var result = date.format("ddd D MMM");
	  return result;
	}
	
	function labelToFullDate(dateString, language) {
	  var moment = __webpack_require__(1);
	  __webpack_require__(50)("./" + language);
	  var date = moment(dateString);
	  var result = date.format("dddd D MMMM YYYY");
	  return result;
	}
	
	function goToHomeFromReader() {
	  var prefix = "";
	  var timestamp = Date.now();
	  prefix = "../../../index.html?t=" + timestamp + "#";
	  window.location = prefix;
	}
	
	function getGoToPublicationUrl(publicationData) {
	  var relativeDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var postfix = "";
	  var prefix = "";
	  var timestamp = Date.now();
	  if (false) {
	    prefix = "/reader/reader.html?t=" + timestamp + "#!";
	  } else {
	    prefix = "data/" + publicationData.contentPackageId + "/reader/reader.html?t=" + timestamp + "#!";
	    if (relativeDepth == 0) {
	      prefix = "/" + prefix;
	    }
	    for (var i = 0; i < relativeDepth; i++) {
	      prefix = "../" + prefix;
	    }
	  }
	  if (publicationData.publicationId > 0) {
	    postfix = "preferred/0/package/" + publicationData.contentPackageId + "/pub/" + publicationData.publicationId + "/page/1";
	  } else {
	    postfix = "" + publicationData.contentPackageId;
	  }
	  return prefix + postfix;
	}
	
	function goToPublication(publicationData) {
	  var relativeDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  if (window.location.pathname.includes("prod_index.html")) {
	    window.top.location = "prodreader.html?#!" + publicationData.contentPackageId;
	  } else {
	    window.top.location = getGoToPublicationUrl(publicationData, relativeDepth);
	  }
	}
	
	function createSubArray(array, chunckLength) {
	  if (chunckLength === 1) {
	    return array.map(function (entry) {
	      return [entry];
	    });
	  }
	
	  var sets = [];
	  var length = array.length;
	  var chunks = length / chunckLength;
	
	  for (var i = 0, j = -1; i <= chunks; i += 1, j += chunckLength) {
	    if (j === -1) {
	      sets[i] = [null, array[0]];
	    } else if (j + 1 === length) {
	      sets[i] = [array[length - 1], null];
	    } else {
	      sets[i] = array.slice(j, j + chunckLength);
	    }
	  }
	
	  return sets;
	}
	
	//reader:
	//
	function createSharingUrls(sharingUrl, articleDetails, sharingOptions, isDesktop) {
	  var url = encodeURIComponent(sharingUrl);
	  var shareUrls = [];
	  var index = 0;
	  if (sharingOptions.Facebook) {
	    shareUrls.push({
	      title: "Facebook",
	      url: "//www.facebook.com/sharer/sharer.php?u=" + url,
	      id: index
	    });
	    index++;
	  }
	  if (sharingOptions.WhatsApp) {
	    var mailUrl = getParameterByName("url", sharingUrl);
	    var watsappPrefix = isDesktop ? "//web.whatsapp.com/send?text=" : "whatsapp://send?text=";
	    shareUrls.push({
	      title: "WhatsApp",
	      url: "" + watsappPrefix + mailUrl,
	      id: index
	    });
	    index++;
	  }
	  if (sharingOptions.GooglePlus) {
	    shareUrls.push({
	      title: "GooglePlus",
	      url: "//plus.google.com/share?url=" + url,
	      id: index
	    });
	    index++;
	  }
	  if (sharingOptions.Twitter) {
	    var twitParams = "";
	    if (articleDetails.title) {
	      twitParams = "text=" + encodeURIComponent(articleDetails.title);
	    }
	
	    shareUrls.push({
	      title: "Twitter",
	      url: "//twitter.com/intent/tweet?" + twitParams + "&url=" + url,
	      id: index
	    });
	    index++;
	  }
	  if (sharingOptions.Mail) {
	    var body = "";
	    if (articleDetails.title) {
	      body += encodeURIComponent(articleDetails.title + " \n\n ");
	    }
	    if (articleDetails.intro) {
	      body += encodeURIComponent(articleDetails.intro + " \n\n ");
	    }
	    var _mailUrl = getParameterByName("url", sharingUrl);
	    shareUrls.push({
	      title: "Mail",
	      url: "mailto:?subject=" + (sharingOptions.MailSubject ? sharingOptions.MailSubject : sharingOptions.MailSubjectIntro + articleDetails.title) + "&body=" + body + (_mailUrl || sharingUrl),
	      id: index
	    });
	    index++;
	  }
	  return shareUrls;
	}
	
	function getParameterByName(name) {
	  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
	
	  var paramName = name.replace(/[\[\]]/g, "\\$&");
	  var regex = new RegExp("[?&]" + paramName + "(=([^&#]*)|&|#|$)");
	  var results = regex.exec(url);
	  if (!results) {
	    return null;
	  }
	  if (!results[2]) {
	    return "";
	  }
	  return results[2].replace(/\+/g, " ");
	}
	
	function removeURLParameter(parameter) {
	  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
	
	  var urlparts = url.split("?");
	  if (urlparts.length >= 2) {
	    var prefix = encodeURIComponent(parameter) + "=";
	    var pars = urlparts[1].split(/[&;]/g);
	    for (var i = pars.length; i-- > 0;) {
	      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
	        pars.splice(i, 1);
	      }
	    }
	
	    return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
	  }
	  return url;
	}
	
	function stripHtml(html) {
	  var tmp = document.createElement("DIV");
	  tmp.innerHTML = html;
	  return tmp.textContent || tmp.innerText || "";
	}
	
	function getCorrectContentPackagePublication(cp) {
	  //TODO: Upparcase
	  return cp.PublicationType === "Main" && cp.PublicationTitleFormat === "Newspaper";
	}
	
	function getFirst(data) {
	  return new _promise2.default(function (resolve, reject) {
	    if (data.length !== 1) {
	      reject();
	    } else {
	      resolve(data[0]);
	    }
	  });
	}
	
	/**
	 * This method collects all the errors thrown by the RequestDownload, ValidateSubscription and ValidateSubscriptionToken
	 * to generate an error message that will be translated by getErrorMessage.
	 * @param {*} errorData
	 */
	function generateError(errorData) {
	  var data = errorData.data ? errorData.data : errorData;
	
	  if (typeof data.StatusMessage !== "string") {
	    if (errorData.call === "validateSubscription") {
	      return createError("VS-SM", "ValidateSubscription without StatusMessage", errorData);
	    } else if (errorData.call === "validateSubscriptionToken") {
	      return createError("VST-SM", "ValidateSubscriptionToken without StatusMessage", errorData);
	    }
	
	    return createError("RD-SM", "RequestDownload without StatusMessage", errorData);
	  }
	  var error = null;
	
	  switch (data.StatusMessage) {
	    case "E1":
	      error = createError("E1", "System unavailable", errorData);
	      break;
	
	    case "E4":
	      error = createError("E4", "System unavailable", errorData);
	      break;
	
	    case "E5":
	      error = createError("E5", "", errorData);
	      break;
	
	    case "E6":
	      error = createError("E6", "", errorData);
	      break;
	
	    case "E7":
	      error = createError("E7", "", errorData);
	      break;
	
	    case "E8":
	      error = createError("E8", "", errorData);
	      break;
	
	    case "E9":
	      error = createError("E9", "System unavailable", errorData);
	      break;
	
	    case "E11":
	      error = createError("E11", "", errorData);
	      break;
	
	    case "E13":
	      error = createError("E13", "System unavailable", errorData);
	      break;
	
	    case "E15":
	      error = createError("E15", "System unavailable", errorData);
	      break;
	
	    case "E24":
	      error = createError("E24", "", errorData);
	      break;
	
	    case "E25":
	      error = createError("E25", "", errorData);
	      break;
	
	    case "E26":
	      error = createError("E26", "", errorData);
	      break;
	
	    default:
	      if (errorData.call === "validateSubscription") {
	        error = createError("VS-KO", "ValidateSubscription returned an error", errorData);
	      } else if (errorData.call === "validateSubscriptionToken") {
	        error = createError("VST-KO", "ValidateSubscriptionToken returned an error", errorData);
	      } else if (errorData.errorType === "authentication") {
	        // on a request download there can still be an authentication error
	        error = createError("RD-AU", "RequestDownload returned an authentication error", errorData);
	      } else {
	        error = createError("RD-KO", "RequestDownload returned an error", errorData);
	      }
	  }
	  return error;
	}
	
	function getErrorMessage(error, language) {
	  var message = void 0;
	
	  if (error && error.data && error.data.CustomStatusMessage) {
	    return "" + error.data.CustomStatusMessage;
	  }
	
	  if (error && error.type) {
	    switch (error.type) {
	      //Errors originating from ValidateSubscription
	      case "VS-ERR":
	        message = validStatusMessage(error) ? language.ValidationFailed + " (" + error.data.StatusMessage + ")" : "" + language.ValidationFailed;
	        break;
	      case "VS-SM":
	        message = validStatusMessage(error) ? language.ValidationFailed + " (" + error.data.StatusMessage + ")" : "" + language.ValidationFailed;
	        break;
	      case "E1":
	        message = validStatusMessage(error) ? language.E1 + " (" + error.data.StatusMessage + ")" : "" + language.E1;
	        break;
	      case "E4":
	        message = validStatusMessage(error) ? language.E4 + " (" + error.data.StatusMessage + ")" : "" + language.E4;
	        break;
	      case "E5":
	        message = validStatusMessage(error) ? language.E5 + " (" + error.data.StatusMessage + ")" : "" + language.E5;
	        break;
	      case "E6":
	        message = validStatusMessage(error) ? language.E6 + " (" + error.data.StatusMessage + ")" : "" + language.E6;
	        break;
	      case "E7":
	        message = validStatusMessage(error) ? language.E7 + " (" + error.data.StatusMessage + ")" : "" + language.E7;
	        break;
	      case "E8":
	        message = validStatusMessage(error) ? language.E8 + " (" + error.data.StatusMessage + ")" : "" + language.E8;
	        break;
	      case "E9":
	        message = validStatusMessage(error) ? language.E9 + " (" + error.data.StatusMessage + ")" : "" + language.E9;
	        break;
	      case "E11":
	        message = validStatusMessage(error) ? language.E11 + " (" + error.data.StatusMessage + ")" : "" + language.E11;
	        break;
	      case "E13":
	        message = validStatusMessage(error) ? language.E13 + " (" + error.data.StatusMessage + ")" : "" + language.E13;
	        break;
	      case "E15":
	        message = validStatusMessage(error) ? language.E15 + " (" + error.data.StatusMessage + ")" : "" + language.E15;
	        break;
	      case "E24":
	        message = validStatusMessage(error) ? language.E24 + " (" + error.data.StatusMessage + ")" : "" + language.E24;
	        break;
	      case "E25":
	        message = validStatusMessage(error) ? language.E25 + " (" + error.data.StatusMessage + ")" : "" + language.E25;
	        break;
	      case "E26":
	        message = validStatusMessage(error) ? language.E26 + " (" + error.data.StatusMessage + ")" : "" + language.E26;
	        break;
	      case "VS-KO":
	        message = validStatusMessage(error) ? language.ValidationFailed + " (" + error.data.StatusMessage + ")" : "" + language.ValidationFailed;
	        break;
	
	      //Errors originating from ValidateSubscriptionToken
	      case "VST-ERR":
	        message = validStatusMessage(error) ? language.SSOValidationFailed + " (" + error.data.StatusMessage + ")" : "" + language.SSOValidationFailed;
	        break;
	      case "VST-SM":
	        message = validStatusMessage(error) ? language.SSOValidationFailed + " (" + error.data.StatusMessage + ")" : "" + language.SSOValidationFailed;
	        break;
	      case "VST-KO":
	        message = validStatusMessage(error) ? language.SSOValidationFailed + " (" + error.data.StatusMessage + ")" : "" + language.SSOValidationFailed;
	        break;
	
	      //Errors originating from RequestOrder
	      case "RO-ERR":
	        message = validStatusMessage(error) ? language.NewspaperCurrentlyUnavailable + " (" + error.data.StatusMessage + ")" : "" + language.NewspaperCurrentlyUnavailable;
	        break;
	      case "RO-SM":
	        message = validStatusMessage(error) ? language.NewspaperCurrentlyUnavailable + " (" + error.data.StatusMessage + ")" : "" + language.NewspaperCurrentlyUnavailable;
	        break;
	      case "RO-KO":
	        message = validStatusMessage(error) ? language.NewspaperCurrentlyUnavailable + " (" + error.data.StatusMessage + ")" : "" + language.NewspaperCurrentlyUnavailable;
	        break;
	
	      //Errors originating from RequestDownload
	      case "RD-AU":
	        message = validStatusMessage(error) ? language.ValidationFailed + " (" + error.data.StatusMessage + ")" : "" + language.ValidationFailed;
	        break;
	      case "RD-ERR":
	        message = validStatusMessage(error) ? language.NewspaperCurrentlyUnavailable + " (" + error.data.StatusMessage + ")" : "" + language.NewspaperCurrentlyUnavailable;
	        break;
	      case "RD-SM":
	        message = validStatusMessage(error) ? language.NewspaperCurrentlyUnavailable + " (" + error.data.StatusMessage + ")" : "" + language.NewspaperCurrentlyUnavailable;
	        break;
	
	      case "RD-KO":
	        message = validStatusMessage(error) ? language.NewspaperCurrentlyUnavailable + " (" + error.data.StatusMessage + ")" : "" + language.NewspaperCurrentlyUnavailable;
	        break;
	
	      //Errors originating from ConfirmDownload
	      case "CD-ERR":
	        message = validStatusMessage(error) ? language.NewspaperCurrentlyUnavailable + " (" + error.data.StatusMessage + ")" : "" + language.NewspaperCurrentlyUnavailable;
	        break;
	
	      //paywall
	      case "PW-FIELDS":
	        message = validStatusMessage(error) ? language.PleaseFillInAllFields + " (" + error.data.StatusMessage + ")" : "" + language.PleaseFillInAllFields;
	        break;
	      case "PW-EMAIL":
	        message = validStatusMessage(error) ? language.PleaseFillInAValidEmail + " (" + error.data.StatusMessage + ")" : "" + language.PleaseFillInAValidEmail;
	        break;
	      default:
	        message = validStatusMessage(error) && error.data.StatusMessage.toLowerCase() != "ok" ? language.UnknownError + " (" + error.data.StatusMessage + ")" : "" + language.UnknownError;
	    }
	  } else {
	    message = validStatusMessage(error) ? language.UnknownError + " (" + error.data.StatusMessage + ")" : "" + language.UnknownError;
	  }
	
	  return message;
	}
	
	function validStatusMessage(error) {
	  return error.data && error.data.StatusMessage && error.data.StatusMessage != null && error.data.StatusMessage.toLowerCase() != "ok";
	}
	
	function createError(type, message, data) {
	  return { type: type, message: message, data: data };
	}
	
	function pad(number, length) {
	  var str = "" + number;
	  while (str.length < length) {
	    str = "0" + str;
	  }
	  return str;
	}
	
	function constructCurrentDate() {
	  var now = new Date();
	  var timezoneOffset = now.getTimezoneOffset();
	
	  timezoneOffset = (timezoneOffset < 0 ? "+" : "-") + // Note the reversed sign!
	  pad(parseInt(Math.abs(timezoneOffset / 60), 10), 2) + pad(Math.abs(timezoneOffset % 60), 2);
	
	  return now.getFullYear() + "-" + pad(now.getMonth() + 1, 2) + "-" + pad(now.getDate(), 2) + "T" + pad(now.getHours(), 2) + ":" + pad(now.getMinutes(), 2) + ":" + pad(now.getSeconds(), 2) + timezoneOffset;
	}
	
	/**
	 * Removes null or undefined elements from array
	 * @param  {Array} array
	 * @return {Array} array without null or undefined elements
	 */
	function compact() {
	  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return list.reduce(function (acc, el) {
	    if (el !== null && el !== undefined) {
	      acc.push(el);
	    }
	    return acc;
	  }, []);
	}
	
	function isSamsungBrowser() {
	  return navigator.userAgent.indexOf("SamsungBrowser") !== -1;
	}
	
	var android = null;
	
	function isAndroid() {
	  if (android === null) {
	    android = document.body.classList.contains("AndroidOS");
	  }
	
	  return android;
	}
	
	/**
	 * Check kind of device (for touch)
	 *
	 * possible returns:
	 *
	 * mobile       if mobile
	 *
	 * phone        if phone
	 * tablet       if tablet
	 *
	 * kind of phone/tablet
	 *    iPhone, iPad, iPod,
	 *
	 * browser
	 *    Chrome, Safari
	 *
	 * OS
	 *    iOS, AndroidOS
	 */
	function getDeviceClasses() {
	  var classNames = [];
	
	  var md = new _mobileDetect2.default(navigator.userAgent);
	
	  // mobile or tablet:
	  if (md.mobile()) {
	    classNames.push("mobile");
	    if (md.phone()) {
	      classNames.push("phone");
	      classNames.push(md.phone());
	    } else if (md.tablet()) {
	      classNames.push("tablet");
	      classNames.push(md.tablet());
	    }
	    //browser
	    //  Chrome
	    //  Safari
	    if (md.userAgent()) {
	      classNames.push(md.userAgent()); //TODO: sometimes it says it is on safari while it is not
	    }
	    //os
	    var os = md.os();
	    if (os) {
	      classNames.push(os);
	      if (os === "AndroidOS") {
	        classNames.push("version_" + md.version("Android"));
	      } else if (os === "iOS") {
	        classNames.push("version_" + md.version("Version"));
	      }
	    }
	
	    if (isSamsungBrowser()) {
	      classNames.push("samsung-browser");
	    }
	  } else {
	    if (navigator.platform.indexOf("Mac") > -1) {
	      if (navigator.maxTouchPoints > 1 && !window.MSStream) {
	        classNames.push("mobile");
	        classNames.push("tablet");
	        classNames.push(md.tablet());
	      } else {
	        classNames.push("desktop");
	        classNames.push("mac");
	      }
	    } else {
	      classNames.push("desktop");
	      if (navigator.platform.indexOf("Win") > -1) {
	        classNames.push("windows");
	      }
	      if (navigator.userAgent.indexOf("Chrome") > -1) {
	        classNames.push("chrome");
	      }
	    }
	  }
	
	  var ua = window.navigator.userAgent;
	  var msie = ua.indexOf("MSIE ");
	
	  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
	    // check if IE
	    classNames.push("IE");
	  }
	
	  return classNames;
	
	  //navigator:
	  // appCodeName:'Mozilla'
	  // appName:'Netscape'
	  // appVersion:'5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/48.0.2564.23 Mobile Safari/537.36'
	  // cookieEnabled:true
	  // credentials:CredentialsContainer
	  // doNotTrack:null
	  // geolocation:Geolocation
	  // hardwareConcurrency:8
	  // language:'nl'
	  // languages:Array[4]
	  // maxTouchPoints:1
	  // mediaDevices:MediaDevices
	  // mimeTypes:MimeTypeArray
	  // onLine:true
	  // permissions:Permissions
	  // platform:'Win32'
	  // plugins:PluginArray
	  // presentation:Presentation
	  // product:'Gecko'
	  // productSub:'20030107'
	  // serviceWorker:ServiceWorkerContainer
	  // userAgent:'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/48.0.2564.23 Mobile Safari/537.36'
	  // vendor:'Google Inc.'
	  // vendorSub:''
	}
	
	/**
	 * Check if tracking events is turned on
	 * @return {boolean}
	 */
	function areEventsTracked() {
	  return !!localStorage.getItem("trackEvents");
	}
	
	/**
	 * Replace a character of a string based on its index
	 * @param  {[type]} string  [description]
	 * @param  {[type]} index   [description]
	 * @param  {[type]} replace [description]
	 * @return {[type]}         [description]
	 */
	
	function replaceAt(string, index, replace) {
	  return string.substring(0, index) + replace + string.substring(index + 1);
	}
	
	/**
	 * Extract the text of a string containing text and html tags.
	 * e.g Title sometimes contains some html tags that are not needed for analytics
	 * @param  {[type]} html [description]
	 * @return {[type]}      [description]
	 */
	
	function stripHtm(html) {
	  var div = document.createElement("div");
	  div.innerHTML = html;
	  var title = div.textContent || div.innerText || "";
	  return title.trim();
	}
	
	function createRedirectionLogoutUrl(paywallRedirectionUrl) {
	  var url = paywallRedirectionUrl;
	  if (url.indexOf("{0}") > 0) {
	    url = url.replace(/\{0\}/g, encodeURIComponent(location.href));
	  }
	  return url;
	}
	function isParameterInUrl(param) {
	  if (window.location.search.indexOf(param) !== -1) {
	    return true;
	  }
	  return false;
	}
	
	function sendMessageIfBackButtonEnabled() {
	  if (window.webkit) {
	    // ios
	    window.webkit.messageHandlers.twipeClose.postMessage("");
	  } else if (window.TwipeAndroidMessage) {
	    // android
	    window.TwipeAndroidMessage.twipeClose("");
	  }
	}
	
	function createRedirectionUrl(paywallRedirectionUrl, component, options) {
	  var publicationData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var url = "";
	  var link = "";
	  var encodedUrl = "";
	  if (publicationData) {
	    link = location.origin + getGoToPublicationUrl(publicationData);
	    encodedUrl = encodeURIComponent(link);
	  }
	
	  if (options.generateSSOState) {
	    if (encodedUrl !== "") {
	      component.createSSOStateCookie(encodedUrl);
	    } else {
	      /*
	      create cookie to store the state and redirectUrl
	      LUX authentication system can only redirect to 1 specific url (home). That url is hardcorded in their paywall Url template.
	      In case the user click directly on the publication he wants to read we save that url in the cookie.
	      To redirect him directly in the reader once he has been authenticate.
	      */
	      component.createSSOStateCookie();
	    }
	
	    url = paywallRedirectionUrl.replace(/\{0\}/g, component.getSSOState());
	  } else {
	    var connector = "?";
	    if (paywallRedirectionUrl.match(/\?./)) {
	      var splittedUrl = paywallRedirectionUrl.split("?");
	      connector = splittedUrl[1] !== "" ? "&" : connector;
	    }
	    if (encodedUrl !== "") {
	      url = "" + paywallRedirectionUrl + connector + options.urlRedirectParameter + "=" + encodedUrl;
	    } else {
	      url = "" + paywallRedirectionUrl + connector + options.urlRedirectParameter + "=" + encodeURIComponent(location.href);
	    }
	  }
	  return url;
	}
	
	function isSinglePage(appState) {
	  var activePages = appState.activePages;
	
	  if (activePages.length == 1 || appState.isDoublePage == false) {
	    return true;
	  } else {
	    return activePages[0] == null || activePages[1] == null;
	  }
	}
	/**
	 * This method is used by testers to check events implementation. Check docs:
	 * http://confluence.twipemobile.net/display/PLT/Analytics+implementation
	 * @param  {boolean} shouldTrack
	 */
	if (typeof window !== "undefined") {
	  // fix unit tests
	  window.webappTrackEvents = function webappTrackEvents(shouldTrack) {
	    if (shouldTrack) {
	      localStorage.setItem("trackEvents", true);
	    } else {
	      localStorage.removeItem("trackEvents", false);
	    }
	  };
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(327), __esModule: true };

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable */
	var dictionary = __webpack_require__(252).default;
	
	//TODO: add in all languages and romove here!!
	//dictionary.test = 'test';
	
	exports.default = dictionary;

/***/ },
/* 13 */,
/* 14 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _utils = __webpack_require__(10);
	
	var _apimanager = __webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var APIManager = function () {
	  function APIManager() {
	    (0, _classCallCheck3.default)(this, APIManager);
	  }
	
	  (0, _createClass3.default)(APIManager, null, [{
	    key: "getUserProfileValue",
	    value: function getUserProfileValue(type) {
	      var url = "https://" + this.api_url + "/Data/DataService.svc/GetProfileValues/" + type;
	      return (0, _apimanager.getRequest)(url);
	    }
	  }, {
	    key: "getRedirectorUrl",
	    value: function getRedirectorUrl(type, version, userId, downloadToken) {
	      // neede to add a trailing slash due to some API strangeness on https it
	      // redirects to https with a 307 in case the / is not there
	      var url = "https://" + this.api_url + "/Redirector/RedirectorService.svc/GetRedirection/" + version + "/webapp/" + userId + "/" + type + "/";
	
	      var promise = new _promise2.default(function (resolve, reject) {
	        // if the redirection url exist, then we get a 200
	        // if it does not exist we get a 404
	        fetch(url).then(function (resp) {
	          if (resp && resp.ok) {
	            // we resolve with the original url, since on IE and older version of
	            // chrome and firefox and opera the resp.url is not filled in, but this
	            // one is correct since the redirects ended up here
	            resolve(url);
	          } else {
	            reject("No url available");
	          }
	        }).catch(function () {
	          // in case the url exists and it redirects, it might give a
	          // cors error due to the fact that the url will be on the customer
	          // domain, we can only hit this case if a url was defined, since otherwise
	          // the API would have returned a 404, so we consider the original url
	          // valid
	          if (downloadToken) {
	            url = "" + url + downloadToken + "/";
	          }
	          resolve(url);
	        });
	      });
	      return promise;
	    }
	  }, {
	    key: "getRegions",
	    value: function getRegions() {
	      return (0, _apimanager.getRequest)("https://" + this.api_url + "/Data/DataService.svc/GetProfileValues/Regio");
	    }
	  }, {
	    key: "getProfileValues",
	    value: function getProfileValues(value) {
	      return (0, _apimanager.getRequest)("https://" + this.api_url + "/Data/DataService.svc/GetProfileValues/" + value);
	    }
	  }, {
	    key: "getContentPackagePublications",
	    value: function getContentPackagePublications(contentPackageId) {
	      return (0, _apimanager.getRequest)("https://" + this.api_url + "/data/dataService.svc/GetContentPackagePublications-" + contentPackageId + "-V3.json");
	    }
	  }, {
	    key: "getNonExpiredShelfPublications",
	    value: function getNonExpiredShelfPublications(downloadToken) {
	      return (0, _apimanager.getRequest)("https://" + this.api_url + "/data/dataService.svc/GetNonExpiredShelfPublications/" + downloadToken + "?format=json");
	    }
	  }, {
	    key: "getContentPackageList",
	    value: function getContentPackageList(downloadToken) {
	      var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
	      var api = arguments[2];
	
	      return (0, _apimanager.getRequest)("https://" + (api ? api : this.api_url) + "/Data/DataService.svc/getcontentpackagelist/" + downloadToken + "/0/" + number);
	    }
	  }, {
	    key: "getPromospot",
	    value: function getPromospot(downloadToken) {
	      return (0, _apimanager.getRequest)("https://" + this.api_url + "/api/data/KiosquePublications/" + downloadToken + "?format=json");
	    }
	    // eslint-disable-next-line camelcase
	
	  }, {
	    key: "openSession",
	    value: function openSession(version, userId, OS_Version, UUID) {
	      // eslint-disable-next-line camelcase
	      return (0, _apimanager.getRequest)("https://" + this.api_url + "/Session/SessionService.svc/json/OpenSession/" + _apimanager.appName + "/" + userId + "/" + UUID + "/" + OS_Version + "/" + version);
	    }
	  }, {
	    key: "getAdditionalDownloadTokens",
	    value: function getAdditionalDownloadTokens() {
	      return (0, _apimanager.getRequest)("https://" + this.api_url + "/Data/DataService.svc/GetProfileValues/AdditionalDownloadTokens");
	    }
	  }, {
	    key: "validateSubscriptionToken",
	    value: function validateSubscriptionToken(userId, sessionId, ssoToken, downloadToken, subsType) {
	      return (0, _apimanager.getRequest)("https://" + this.api_url + "/Session/SessionService.svc/json/ValidateSubscriptionToken?UserID=" + userId + "&SessionID=" + sessionId + "&subscriptionToken=" + encodeURIComponent(ssoToken) + "&downloadToken=" + downloadToken + "&subscriptionType=" + subsType);
	    }
	  }, {
	    key: "validateSubscription",
	    value: function validateSubscription(sessionId, downloadToken, userName, password, subscriptionType, version, userId, authenticationProvider) {
	      return (0, _apimanager.postRequest)("https://" + this.api_url + "/Session/SessionService.svc/json/Validate_Subscription", {
	        Device: _apimanager.appName,
	        DownloadToken: downloadToken,
	        Email: userName,
	        Password: password,
	        SessionId: sessionId,
	        UserId: userId,
	        SubscriptionType: subscriptionType,
	        AuthenticationProvider: authenticationProvider,
	        Version: version
	      });
	    }
	  }, {
	    key: "getContentPackageInfo",
	    value: function getContentPackageInfo(contentPackageId) {
	      return (0, _apimanager.postRequest)("https://" + this.api_url + "/Data/DataService.svc/GetContentPackageInfo", { ContentPackageId: contentPackageId });
	    }
	  }, {
	    key: "requestDownload",
	    value: function requestDownload(userId, sessionId, subsId, cpId, orderId, paymentMethod) {
	      return (0, _apimanager.getRequest)("https://" + this.api_url + "/Session/SessionService.svc/json/RequestDownload/" + userId + "/" + sessionId + "/" + subsId + "/" + cpId + "/" + orderId + "/" + paymentMethod);
	    }
	  }, {
	    key: "requestOrderPost",
	    value: function requestOrderPost(userId, sessionId, cpId, version, paymentMethod) {
	      var postData = {
	        UserId: userId,
	        SessionId: sessionId,
	        ContentPackageId: cpId,
	        PaymentMethod: paymentMethod,
	        Version: version,
	        Device: _apimanager.appName
	      };
	      return (0, _apimanager.postRequest)("https://" + this.api_url + "/Session/SessionService.svc/json/Request_Order", postData);
	    }
	  }, {
	    key: "confirmDownload",
	    value: function confirmDownload(_ref) {
	      var userId = _ref.userId,
	          sessionId = _ref.sessionId,
	          contentPackageId = _ref.contentPackageId,
	          downloadId = _ref.downloadId,
	          downloadStatus = _ref.downloadStatus;
	
	      var postData = {
	        UserId: userId,
	        SessionId: sessionId,
	        Version: ("3.9.4"),
	        DownloadPublicationStatusHistory: {
	          PublicationId: contentPackageId,
	          PublicationQuality: "Full", //TODO: amways full?
	          RequestedPublicationTitleFormat: "Newspaper", //TODO: viewer: currentViewer === 'nextgen' ? 'TabletOptimized' : 'Newspaper',
	          StatusInfo: "",
	          StatusTime: (0, _utils.constructCurrentDate)()
	        },
	        DownloadId: downloadId,
	        Device: "WebApp",
	        DownloadStatus: downloadStatus
	      };
	      return (0, _apimanager.postRequest)("https://" + this.api_url + "/Session/SessionService.svc/json/Confirm_Download", postData);
	    }
	  }, {
	    key: "requestFullPDFDownload",
	    value: function requestFullPDFDownload(userId, sessionId) {
	      var orderId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var subsId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	      var cpId = arguments[4];
	      var pubId = arguments[5];
	
	      var postfix = pubId ? "/" + pubId + ".json" : ".json";
	      return (0, _apimanager.getRequest)("https://" + this.api_url + "/api/downloadservice/requestfullpdfdownload/" + userId + "/" + sessionId + "/" + orderId + "/" + subsId + "/" + cpId + postfix + "?_=" + Date.now());
	    }
	  }, {
	    key: "retreivePdfUrl",
	    value: function retreivePdfUrl(pageId, sessionId, userId, downloadId) {
	      var _this = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        fetch("https://" + _this.api_url + "/Pdf/" + pageId + "/" + ("3.9.4") + "/" + sessionId + "/" + userId + "/" + downloadId + "/url").then(function (resp) {
	          return resp.json();
	        }).then(function (json) {
	          resolve(json.ReturnMessage);
	        }).catch(function (error) {
	          reject(error);
	        });
	      });
	    }
	  }, {
	    key: "getDownloadCredentials",
	    value: function getDownloadCredentials(userId, sessionId, downloadId) {
	      var url = "https://" + this.api_url + "/GetDownloadCredentials/" + userId + "/" + sessionId + "/" + downloadId;
	      return fetch(url);
	    }
	  }]);
	  return APIManager;
	}();
	
	APIManager.api_url = window.location.pathname.includes("prodreader.html") || window.location.pathname.includes("prod_index.html") ? ("mhu-ds-production-backend-api.twipecloud.net") : ("mhu-ds-production-backend-api.twipecloud.net");
	exports.default = APIManager;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(14);
	var core = __webpack_require__(13);
	var ctx = __webpack_require__(25);
	var hide = __webpack_require__(27);
	var has = __webpack_require__(26);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(74)('wks');
	var uid = __webpack_require__(48);
	var Symbol = __webpack_require__(14).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(28)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(20);
	var IE8_DOM_DEFINE = __webpack_require__(102);
	var toPrimitive = __webpack_require__(76);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(21) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 23 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// paywall
	var ABO_BANNER_DESKTOP = exports.ABO_BANNER_DESKTOP = "AboBannerDesktop";
	var ABO_BANNER_MOBILE = exports.ABO_BANNER_MOBILE = "AboBannerMobile";
	var PASSWORD_FORGOTTEN = exports.PASSWORD_FORGOTTEN = "PasswordForgotten";
	//kiosque
	var PAYWALL_REDIRECTION = exports.PAYWALL_REDIRECTION = "paywallRedirectionUrl";
	var LOGOUT_REDIRECTION = exports.LOGOUT_REDIRECTION = "logoutlRedirectionUrl";
	var TOPNAV_BUTTON = exports.TOPNAV_BUTTON = "button_topnav";
	//settings
	var HELP = exports.HELP = "Help";
	var DISCLAIMER = exports.DISCLAIMER = "Disclaimer";
	var DATAPOLICY = exports.DATAPOLICY = "DataPolicy";
	var PRIVACYPOLICY = exports.PRIVACYPOLICY = "PrivacyPolicy";
	//contact
	var CONTACT_CLIENT = exports.CONTACT_CLIENT = "ContactClient";
	var CONTACT_TWIPE = exports.CONTACT_TWIPE = "ContactTwipe";
	
	var COOKIE_MORE_INFO = exports.COOKIE_MORE_INFO = "CookieMoreInfo";
	
	var IFRAME_KIOSQUE_MOBILE = exports.IFRAME_KIOSQUE_MOBILE = "IframeKiosqueMobile";
	var IFRAME_KIOSQUE_TOP = exports.IFRAME_KIOSQUE_TOP = "IframeKiosqueTop";
	var IFRAME_KIOSQUE_BOTTOM = exports.IFRAME_KIOSQUE_BOTTOM = "IframeKiosqueBottom";
	var IFRAME_KIOSQUE_ARCHIVE = exports.IFRAME_KIOSQUE_ARCHIVE = "IframeKiosqueArchive";
	var IFRAME_KIOSQUE_ARCHIVE_BOTTOM = exports.IFRAME_KIOSQUE_ARCHIVE_BOTTOM = "IframeKiosqueArchiveBottom";

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _md = __webpack_require__(373);
	
	var _md2 = _interopRequireDefault(_md);
	
	var _config = __webpack_require__(83);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var config = {
	  cookiePostFix: undefined,
	  secureCookie: true,
	  defaults: {
	    expires: 365,
	    path: "/"
	  }
	};
	var cookieOptions = _config2.default.cookie;
	
	function raw(s) {
	  return s;
	}
	
	function decoded(s) {
	  var pluses = /\+/g;
	  try {
	    return decodeURIComponent(s.replace(pluses, " "));
	  } catch (e) {
	    return null;
	  }
	}
	
	function converted(s) {
	  if (s.indexOf('"') === 0) {
	    // This is a quoted cookie as according to RFC2068, unescape
	    s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
	  }
	  try {
	    return config.json ? JSON.parse(s) : s;
	  } catch (er) {}
	}
	
	// here we will append for TW_* cookies the optional prefix
	// this needs to be set in the options when required
	function buildCookieKey(key) {
	  if (config.cookiePostFix && key.indexOf("TW_") == 0) {
	    return key + "_" + config.cookiePostFix;
	  } else return key;
	}
	
	var CookieManager = function () {
	  function CookieManager() {
	    (0, _classCallCheck3.default)(this, CookieManager);
	  }
	
	  (0, _createClass3.default)(CookieManager, null, [{
	    key: "setPostFix",
	    value: function setPostFix(postFix) {
	      config.cookiePostFix = postFix;
	    }
	
	    /*
	      These are cookies that should never expire and we
	      want to refresh their expiration date everytime user opens
	      the reader
	    */
	
	  }, {
	    key: "getCookie",
	    value: function getCookie(key) {
	      // read
	      // uset the client as postfix on the cookies
	      key = buildCookieKey(key);
	      var decode = config.raw ? raw : decoded;
	      var cookies = document.cookie.split("; ");
	      var result = key ? undefined : {};
	      for (var i = 0, l = cookies.length; i < l; i++) {
	        var parts = cookies[i].split("=");
	        var name = decode(parts.shift());
	        var cookie = decode(parts.join("="));
	
	        if (cookie && key && key === name) {
	          result = converted(cookie);
	          break;
	        }
	
	        if (cookie && !key) {
	          result[name] = converted(cookie);
	        }
	      }
	
	      if (result && config.secureCookie) {
	        // the converted function will do all the logic to check if the
	        // jsonparsing is safe and correct
	        var jsonValue = converted(result);
	        if (typeof value !== "boolean" && jsonValue.hash) {
	          var hash = jsonValue.hash;
	          var hashkey = "hash";
	          jsonValue[hashkey] = null;
	          delete jsonValue[hashkey];
	
	          var stringJson = (0, _stringify2.default)(jsonValue);
	          var shouldBeHash = (0, _md2.default)(stringJson).toString();
	
	          if (hash === shouldBeHash) {
	            result = stringJson;
	            //everything oke
	          } else {
	            //TODO: remove cookie?
	            return null;
	          }
	        } else if (typeof value !== "boolean") {
	          //TODO: create cookie with hash
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: "createCookie",
	    value: function createCookie(key, value) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      if (config.secureCookie && typeof value != "boolean" && typeof value != "string" && value != "") {
	        var jsonValue = JSON.parse(value);
	        var hash = (0, _md2.default)(value).toString();
	        jsonValue.hash = hash;
	        value = (0, _stringify2.default)(jsonValue);
	      }
	
	      if (value !== undefined) {
	        options = $.extend({}, config.defaults, options);
	        if (typeof options.expires === "number") {
	          if (options.useExpires) {
	            options.expires = new Date(options.expires);
	          } else if (options.useTime) {
	            var ms = options.expires,
	                t = options.expires = new Date();
	            t.setTime(t.getTime() + ms);
	          } else {
	            var days = options.expires,
	                _t = options.expires = new Date();
	            _t.setDate(_t.getDate() + days);
	          }
	        }
	        value = String(value);
	        return document.cookie = [encodeURIComponent(buildCookieKey(key)), "=", config.raw ? value : encodeURIComponent(value), options.expires ? "; expires=" + options.expires.toUTCString() : "", // use expires attribute, max-age is not supported by IE
	        options.path ? "; path=" + options.path : "", options.domain ? "; domain=" + options.domain : "", cookieOptions.disableCookieSameSitePolicy && ("production") == "production" ? "; sameSite=none ; secure " : ""].join("");
	      }
	    }
	  }, {
	    key: "removeCookie",
	    value: function removeCookie(key, options) {
	      if (!options) {
	        options = {};
	      }
	      options.expires = -1;
	      if (this.getCookie(key)) {
	        this.createCookie(key, "", options);
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: "refreshCookies",
	    value: function refreshCookies() {
	      CookieManager.longExpirationCookieKeys.forEach(function (key) {
	        var cookie = CookieManager.getCookie(key);
	        if (cookie) {
	          CookieManager.createCookie(key, cookie);
	        }
	      });
	    }
	  }, {
	    key: "getNumberOfRedirects",
	    value: function getNumberOfRedirects() {
	      var cookie = this.getCookie(this.cookieKeys.REDIRECTIONS);
	      if (cookie) {
	        return Number(cookie);
	      }
	      return 0;
	    }
	  }, {
	    key: "setNumberOfRedirects",
	    value: function setNumberOfRedirects(number, time) {
	      this.createCookie(this.cookieKeys.REDIRECTIONS, number.toString(), {
	        expires: time,
	        path: "/",
	        useTime: true
	      });
	    }
	  }]);
	  return CookieManager;
	}();
	
	CookieManager.cookieKeys = {
	  REGION: "TW_REGION",
	  DOUBLEPAGE_LANDSCAPEDISPLAY: "TW_DOUBLEPAGE_LANDSCAPEDISPLAY",
	  LOGIN: "TW_LOGGED_IN",
	  UUID: "TW_USER_DATA",
	  UUIDV1: "TW_GUID",
	  COOKIE: "cookie-agreed-1",
	  FONTSIZE: "TW_FONTSIZE",
	  PREFERRED_VIEWER: "TW_PREFERRED_VIEWER",
	  READER_SESSION: "TW_READER_SESSION",
	  REDIRECTIONS: "TW_REDIRECTIONS",
	  SSO_STATE: "TW_SSO_STATE",
	  DESKTOP_DOUBLEPAGE: "TW_DESKTOP_DOUBLEPAGE"
	};
	CookieManager.longExpirationCookieKeys = [CookieManager.cookieKeys.FONTSIZE, CookieManager.cookieKeys.DOUBLEPAGE_LANDSCAPEDISPLAY, CookieManager.cookieKeys.PREFERRED_VIEWER, CookieManager.cookieKeys.REGION, CookieManager.cookieKeys.LOGIN, CookieManager.cookieKeys.UUID, CookieManager.cookieKeys.DESKTOP_DOUBLEPAGE];
	exports.default = CookieManager;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(34);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 26 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(22);
	var createDesc = __webpack_require__(38);
	module.exports = __webpack_require__(21) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(65);
	var defined = __webpack_require__(62);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(62);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 31 */,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(242);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 35 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(111);
	var enumBugKeys = __webpack_require__(64);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(22).f;
	var has = __webpack_require__(26);
	var TAG = __webpack_require__(17)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _createHashHistory = __webpack_require__(402);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this class abstracts the setting and geting of the URL in the browser
	// it handles the getters out of the current URL
	// the setters will change the URL and can impact other params as wel:
	// page --> only changes the page-number
	// publicationId --> sets the page to the default page number
	// contentpackageId --> sets the publicationId to undefined and pageId to undefined
	// prefered --> only changes the prefered
	var URLRouter = function () {
	  function URLRouter() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { default_pagenubmer: 0, prefered: 0 };
	    (0, _classCallCheck3.default)(this, URLRouter);
	    this.history = undefined;
	    this.options = {};
	    this._page = undefined;
	    this._cpid = undefined;
	    this._pubid = undefined;
	    this._prefered = undefined;
	    this._contentid = undefined;
	
	    this.options = options;
	    var hash = location.hash.toString();
	    if (hash && hash.length > 1 && hash.charAt(0) == "#" && hash.charAt(1) != "!") {
	      location.hash = hash.substring(0, 1) + "!" + hash.substring(1, hash.length);
	    }
	    this.history = new _createHashHistory2.default({
	      hashType: "hashbang" // Google's legacy AJAX URL format
	    });
	  }
	
	  (0, _createClass3.default)(URLRouter, [{
	    key: "updateLocation",
	    value: function updateLocation(cp, pub, page, prefered) {
	      var contentid = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
	      var replace = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	      if (this._page !== page || this._cpid !== cp || this._pubid !== pub || this._prefered !== prefered || this._contentid !== contentid) {
	        this._page = page;
	        this._cpid = cp;
	        this._pubid = pub;
	        this._prefered = prefered;
	        this._contentid = contentid;
	        this.setLocation(replace);
	      }
	    }
	  }, {
	    key: "listen",
	    value: function listen(fnc) {
	      this.history.listen(fnc);
	    }
	
	    // private methods
	
	  }, {
	    key: "setLocation",
	    value: function setLocation() {
	      var replace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var alb = this._contentid ? "/alb/" + this._contentid : "";
	      var location = "!preferred/" + this._prefered + "/package/" + this._cpid + "/pub/" + this._pubid + "/page/" + this._page + alb;
	      if (location.indexOf("undefined") !== -1) return;
	      if (replace) {
	        this.history.replace(location);
	      } else {
	        this.history.push(location);
	      }
	    }
	  }, {
	    key: "parseLocation",
	    value: function parseLocation() {
	      // Get the current location.
	      var location = this.history.location.pathname;
	      if (!isNaN(location)) {
	        this._page = undefined;
	        this._cpid = parseInt(location, 10);
	        this._pubid = undefined;
	        this._prefered = undefined;
	      } else {
	        // try to parse out all the rest;
	        // it should be this syntax preferred/PREFERENCE/package/CPID/pub/PUBID/page/PAGENR
	        var regexToMatch = /[?.*#!p|p]referred\/(.*)\/package\/(.*)\/pub\/(.*)\/page\/(.*)/g;
	        var regexToMatchAlb = /[?.*#!p|p]referred\/(.*)\/package\/(.*)\/pub\/(.*)\/page\/(.*)\/(?:alb|content)\/(.*)/g;
	        var match = regexToMatch.exec(location);
	        var matchAlb = regexToMatchAlb.exec(location);
	        if (matchAlb) {
	          this._prefered = parseInt(matchAlb[1], 10);
	          this._cpid = parseInt(matchAlb[2], 10);
	          this._pubid = parseInt(matchAlb[3], 10);
	          this._page = parseInt(matchAlb[4], 10);
	          this._contentid = parseInt(matchAlb[5], 10);
	          URLRouter.page = this._page;
	        } else if (match) {
	          this._prefered = parseInt(match[1], 10);
	          this._cpid = parseInt(match[2], 10);
	          this._pubid = parseInt(match[3], 10);
	          this._page = parseInt(match[4], 10);
	          this._contentid = undefined;
	          URLRouter.page = this._page;
	        } else {
	          this._page = undefined;
	          this._cpid = undefined;
	          this._pubid = undefined;
	          this._prefered = undefined;
	          this._contentid = undefined;
	        }
	      }
	    }
	  }, {
	    key: "page",
	    get: function get() {
	      this.parseLocation();
	      return this._page;
	    },
	    set: function set(value) {
	      if (this._page !== value) {
	        this._page = value;
	        this.setLocation();
	      }
	    }
	  }, {
	    key: "contentid",
	    get: function get() {
	      this.parseLocation();
	      return this._contentid;
	    },
	    set: function set(value) {
	      if (this._contentid !== value) {
	        this._contentid = value;
	        this.setLocation();
	      }
	    }
	  }, {
	    key: "publicationId",
	    get: function get() {
	      this.parseLocation();
	      return this._pubid;
	    }
	  }, {
	    key: "contentpackageId",
	    get: function get() {
	      this.parseLocation();
	      return this._cpid;
	    }
	  }, {
	    key: "prefered",
	    get: function get() {
	      this.parseLocation();
	      return this._prefered;
	    }
	  }], [{
	    key: "isAlbURL",
	    value: function isAlbURL() {
	      var albRegex = /(?:alb|content)/g;
	      return window.location.href.search(albRegex) !== -1;
	    }
	  }]);
	  return URLRouter;
	}();
	
	exports.default = URLRouter;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(349)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(106)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(354);
	var global = __webpack_require__(14);
	var hide = __webpack_require__(27);
	var Iterators = __webpack_require__(33);
	var TO_STRING_TAG = __webpack_require__(17)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _swiper = __webpack_require__(51);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _imageGallerySlide = __webpack_require__(91);
	
	var _imageGallerySlide2 = _interopRequireDefault(_imageGallerySlide);
	
	var _imagegallery = __webpack_require__(382);
	
	var _imagegallery2 = _interopRequireDefault(_imagegallery);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGallery = function () {
	  function ImageGallery(_ref) {
	    var _this = this;
	
	    var appState = _ref.appState,
	        slideNumber = _ref.slideNumber,
	        context = _ref.context,
	        options = _ref.options,
	        _ref$loadedCallback = _ref.loadedCallback,
	        loadedCallback = _ref$loadedCallback === undefined ? _utils.noop : _ref$loadedCallback,
	        _ref$loopSwiper = _ref.loopSwiper,
	        loopSwiper = _ref$loopSwiper === undefined ? false : _ref$loopSwiper;
	    (0, _classCallCheck3.default)(this, ImageGallery);
	    this.appState = null;
	    this.options = null;
	    this.DOMContainer = null;
	    this.context = null;
	    this.swiper = null;
	    this.slideNumber = null;
	    this.lastIndex = null;
	    this.nextBtnClicked = false;
	    this.prevBtnClicked = false;
	    this.loadedCallback = _utils.noop;
	    this.loopSwiper = false;
	    this.imageSlides = [];
	
	    this._onEscapeButtonKeyUp = function (e) {
	      if (e.keyCode === 27) {
	        _this.close(e);
	      }
	    };
	
	    this.appState = appState;
	    this.DOMContainer = document.querySelector("#imageviewer");
	    this.options = options;
	    this.context = context;
	    this.context.navigation = this.appState.isDesktop && context.images && context.images.length > 1;
	    this.slideNumber = slideNumber;
	    this.loadedCallback = loadedCallback;
	    this.loopSwiper = loopSwiper;
	    this.render();
	  }
	
	  (0, _createClass3.default)(ImageGallery, [{
	    key: "createImageViewerSlide",
	    value: function createImageViewerSlide(image) {
	      var slide = new _imageGallerySlide2.default(this.appState, image, (0, _extends3.default)({}, this.options.imageviewerslide, {
	        loopSwiper: this.loopSwiper
	      }));
	      return slide;
	    }
	  }, {
	    key: "addImages",
	    value: function addImages() {
	      var _this2 = this;
	
	      var resultPromise = new _promise2.default(function (resolve, reject) {
	        var promiseData = {};
	        promiseData.reject = reject;
	        promiseData.resolve = resolve;
	        var wrapper = _this2.DOMContainer.querySelector(".swiper-wrapper-imageviewer");
	        var promises = [];
	        if (wrapper) {
	          _this2.context.images.forEach(function (image) {
	            image.singleImage = _this2.context.singleImage;
	            var slide = _this2.createImageViewerSlide(image);
	            _this2.imageSlides.push(slide);
	            promises.push(slide.render());
	          });
	          _promise2.default.all(promises).then(function (values) {
	            values.forEach(function (value) {
	              wrapper.appendChild(value);
	            });
	            promiseData.resolve(true);
	          });
	        }
	      });
	      return resultPromise;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      if (this.DOMContainer) {
	        Dust.render(_imagegallery2.default, this.context, function (err, result) {
	          _this3.DOMContainer.innerHTML = result;
	          _this3.addImages().then(function () {
	            // set swiper
	            _this3.createSwiper();
	            _this3.open();
	          }).finally(function () {
	            _this3.loadedCallback();
	          });
	        });
	      }
	    }
	  }, {
	    key: "createSwiper",
	    value: function createSwiper() {
	      var _this4 = this;
	
	      var selector = "#imageviewer .swiper-container-imageviewer";
	      var a = document.querySelector(selector);
	      if (a) {
	        this.swiper = new _swiper2.default($(a), {
	          keyboardControl: true,
	          initialSlide: this.slideNumber,
	          centeredSlides: true,
	          pagination: $(a).find(" .swiper-pagination-imageviewer"),
	          paginationClickable: true,
	          loopedSlides: this.DOMContainer.querySelector(".swiper-wrapper-imageviewer").children.length,
	          loop: this.loopSwiper,
	          nextButton: $(a).find(" .swiper-button-next"),
	          prevButton: $(a).find(" .swiper-button-prev"),
	          onInit: function onInit() {
	            _this4.appState.triggerEvent(_analyticsevents.VIEW_IMAGE_GALLERY);
	          },
	          onSlideNextEnd: function onSlideNextEnd() {
	            if (_this4.nextBtnClicked) {
	              _this4.nextBtnClicked = false;
	              _this4.appState.triggerEvent(_analyticsevents.CLICKED_NEXT_GALLERY);
	            } else {
	              _this4.appState.triggerEvent(_analyticsevents.SWIPED_FORWARD_GALLERY);
	            }
	            _this4.appState.triggerEvent(_analyticsevents.VIEW_IMAGE_GALLERY);
	          },
	          onSlidePrevEnd: function onSlidePrevEnd() {
	            if (_this4.prevBtnClicked) {
	              _this4.prevBtnClicked = false;
	              _this4.appState.triggerEvent(_analyticsevents.CLICKED_PREV_GALLERY);
	            } else {
	              _this4.appState.triggerEvent(_analyticsevents.SWIPED_BACKWARD_GALLERY);
	            }
	            _this4.appState.triggerEvent(_analyticsevents.VIEW_IMAGE_GALLERY);
	          },
	          onTransitionEnd: function onTransitionEnd(_ref2) {
	            var activeIndex = _ref2.activeIndex;
	
	            // if active index is not 0, it is called in the beginning
	            if (!_this4.appState.isDesktop) {
	              _this4.imageSlides[activeIndex].renderHd();
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "initHammerSlide",
	    value: function initHammerSlide() {}
	  }, {
	    key: "open",
	    value: function open() {
	      if (this.DOMContainer) {
	        this.DOMContainer.classList.remove("hidden");
	        this.initHammerSlide();
	        //pagination bug
	        this.swiper.update();
	        this.swiper.slideTo(this.slideNumber, 0);
	        this.swiper.update();
	        this.attatchClickHandlers();
	        this.appState.triggerEvent(_analyticsevents.OPENED_GALLERY_ALB);
	        document.addEventListener("keyup", this._onEscapeButtonKeyUp);
	        this.appState.trigger("imageGallery:opened");
	      }
	    }
	  }, {
	    key: "close",
	    value: function close(e) {
	      var _this5 = this;
	
	      if (this.DOMContainer) {
	        if (e.target.classList.contains("imageviewer-caption")) {
	          return;
	        }
	        this.DOMContainer.innerHTML = "";
	        this.context = null;
	        this.swiper = null;
	        this.imageSlides = null;
	        this.DOMContainer.classList.add("hidden");
	        var a = this.DOMContainer.querySelector(".swiper-wrapper-imageviewer");
	        if (a) {
	          a.removeEventListener("click", function () {
	            _this5.close();
	          });
	        }
	        this.removeListeners();
	        this.DOMContainer = null;
	        if (this.mc) {
	          this.mc.destroy();
	        }
	        this.appState.triggerEvent(_analyticsevents.CLOSED_GALLERY_ALB);
	        document.removeEventListener("keyup", this._onEscapeButtonKeyUp);
	        if (window.app && window.app.state) {
	          // check if nextgen instance is there
	          window.app.state.imageViewerClosed();
	        }
	        this.appState.trigger("imageGallery:closed");
	      }
	    }
	  }, {
	    key: "removeListeners",
	    value: function removeListeners() {}
	  }, {
	    key: "attatchClickHandlers",
	    value: function attatchClickHandlers() {
	      var _this6 = this;
	
	      var a = this.DOMContainer.querySelector(".swiper-wrapper-imageviewer");
	      var viewerBullet = $(this.swiper.paginationContainer).find(".swiper-pagination-bullet ");
	      if (a) {
	        a.addEventListener("click", function (e) {
	          _this6.close(e);
	        });
	      }
	      var close = this.DOMContainer.querySelector(".imageviewer-nav-back");
	      if (close) {
	        close.addEventListener("click", function (e) {
	          _this6.close(e);
	        });
	      }
	
	      $(this.swiper.nextButton).on("click", function () {
	        _this6.nextBtnClicked = true;
	      });
	
	      $(this.swiper.prevButton).on("click", function () {
	        _this6.prevBtnClicked = true;
	      });
	
	      $(viewerBullet).on("click", function () {
	        _this6.appState.triggerEvent(_analyticsevents.CLICKED_BULLET_GALLERY);
	      });
	    }
	  }]);
	  return ImageGallery;
	}();
	
	exports.default = ImageGallery;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(25);
	var call = __webpack_require__(105);
	var isArrayIter = __webpack_require__(103);
	var anObject = __webpack_require__(20);
	var toLength = __webpack_require__(47);
	var getIterFn = __webpack_require__(80);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(48)('meta');
	var isObject = __webpack_require__(18);
	var has = __webpack_require__(26);
	var setDesc = __webpack_require__(22).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(28)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 46 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(75);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 48 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("spinner",body_0);function body_0(chk,ctx){return chk.w("<div class=\"spinner-wrapper\"><div class=\"spinner-container ").x(ctx.get(["spinnerText"], false),ctx,{"block":body_1},{}).w("\"><div class=\"spinner-icon\"> </div>").x(ctx.get(["spinnerText"], false),ctx,{"block":body_2},{}).w("</div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("spinnerText");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"spinner-text\">").f(ctx.get(["spinnerText"], false),ctx,"h").w("</div>");}body_2.__dustBody=!0;return body_0}(dust));
	module.exports = 'spinner';

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 124,
		"./af.js": 124,
		"./ar": 130,
		"./ar-dz": 125,
		"./ar-dz.js": 125,
		"./ar-ly": 126,
		"./ar-ly.js": 126,
		"./ar-ma": 127,
		"./ar-ma.js": 127,
		"./ar-sa": 128,
		"./ar-sa.js": 128,
		"./ar-tn": 129,
		"./ar-tn.js": 129,
		"./ar.js": 130,
		"./az": 131,
		"./az.js": 131,
		"./be": 132,
		"./be.js": 132,
		"./bg": 133,
		"./bg.js": 133,
		"./bn": 134,
		"./bn.js": 134,
		"./bo": 135,
		"./bo.js": 135,
		"./br": 136,
		"./br.js": 136,
		"./bs": 137,
		"./bs.js": 137,
		"./ca": 138,
		"./ca.js": 138,
		"./cs": 139,
		"./cs.js": 139,
		"./cv": 140,
		"./cv.js": 140,
		"./cy": 141,
		"./cy.js": 141,
		"./da": 142,
		"./da.js": 142,
		"./de": 144,
		"./de-at": 143,
		"./de-at.js": 143,
		"./de.js": 144,
		"./dv": 145,
		"./dv.js": 145,
		"./el": 146,
		"./el.js": 146,
		"./en-au": 147,
		"./en-au.js": 147,
		"./en-ca": 148,
		"./en-ca.js": 148,
		"./en-gb": 149,
		"./en-gb.js": 149,
		"./en-ie": 150,
		"./en-ie.js": 150,
		"./en-nz": 151,
		"./en-nz.js": 151,
		"./eo": 152,
		"./eo.js": 152,
		"./es": 154,
		"./es-do": 153,
		"./es-do.js": 153,
		"./es.js": 154,
		"./et": 155,
		"./et.js": 155,
		"./eu": 156,
		"./eu.js": 156,
		"./fa": 157,
		"./fa.js": 157,
		"./fi": 158,
		"./fi.js": 158,
		"./fo": 159,
		"./fo.js": 159,
		"./fr": 162,
		"./fr-ca": 160,
		"./fr-ca.js": 160,
		"./fr-ch": 161,
		"./fr-ch.js": 161,
		"./fr.js": 162,
		"./fy": 163,
		"./fy.js": 163,
		"./gd": 164,
		"./gd.js": 164,
		"./gl": 165,
		"./gl.js": 165,
		"./he": 166,
		"./he.js": 166,
		"./hi": 167,
		"./hi.js": 167,
		"./hr": 168,
		"./hr.js": 168,
		"./hu": 169,
		"./hu.js": 169,
		"./hy-am": 170,
		"./hy-am.js": 170,
		"./id": 171,
		"./id.js": 171,
		"./is": 172,
		"./is.js": 172,
		"./it": 173,
		"./it.js": 173,
		"./ja": 174,
		"./ja.js": 174,
		"./jv": 175,
		"./jv.js": 175,
		"./ka": 176,
		"./ka.js": 176,
		"./kk": 177,
		"./kk.js": 177,
		"./km": 178,
		"./km.js": 178,
		"./ko": 179,
		"./ko.js": 179,
		"./ky": 180,
		"./ky.js": 180,
		"./lb": 181,
		"./lb.js": 181,
		"./lo": 182,
		"./lo.js": 182,
		"./lt": 183,
		"./lt.js": 183,
		"./lv": 184,
		"./lv.js": 184,
		"./me": 185,
		"./me.js": 185,
		"./mi": 186,
		"./mi.js": 186,
		"./mk": 187,
		"./mk.js": 187,
		"./ml": 188,
		"./ml.js": 188,
		"./mr": 189,
		"./mr.js": 189,
		"./ms": 191,
		"./ms-my": 190,
		"./ms-my.js": 190,
		"./ms.js": 191,
		"./my": 192,
		"./my.js": 192,
		"./nb": 193,
		"./nb.js": 193,
		"./ne": 194,
		"./ne.js": 194,
		"./nl": 196,
		"./nl-be": 195,
		"./nl-be.js": 195,
		"./nl.js": 196,
		"./nn": 197,
		"./nn.js": 197,
		"./pa-in": 198,
		"./pa-in.js": 198,
		"./pl": 199,
		"./pl.js": 199,
		"./pt": 201,
		"./pt-br": 200,
		"./pt-br.js": 200,
		"./pt.js": 201,
		"./ro": 202,
		"./ro.js": 202,
		"./ru": 203,
		"./ru.js": 203,
		"./se": 204,
		"./se.js": 204,
		"./si": 205,
		"./si.js": 205,
		"./sk": 206,
		"./sk.js": 206,
		"./sl": 207,
		"./sl.js": 207,
		"./sq": 208,
		"./sq.js": 208,
		"./sr": 210,
		"./sr-cyrl": 209,
		"./sr-cyrl.js": 209,
		"./sr.js": 210,
		"./ss": 211,
		"./ss.js": 211,
		"./sv": 212,
		"./sv.js": 212,
		"./sw": 213,
		"./sw.js": 213,
		"./ta": 214,
		"./ta.js": 214,
		"./te": 215,
		"./te.js": 215,
		"./tet": 216,
		"./tet.js": 216,
		"./th": 217,
		"./th.js": 217,
		"./tl-ph": 218,
		"./tl-ph.js": 218,
		"./tlh": 219,
		"./tlh.js": 219,
		"./tr": 220,
		"./tr.js": 220,
		"./tzl": 221,
		"./tzl.js": 221,
		"./tzm": 223,
		"./tzm-latn": 222,
		"./tzm-latn.js": 222,
		"./tzm.js": 223,
		"./uk": 224,
		"./uk.js": 224,
		"./uz": 225,
		"./uz.js": 225,
		"./vi": 226,
		"./vi.js": 226,
		"./x-pseudo": 227,
		"./x-pseudo.js": 227,
		"./yo": 228,
		"./yo.js": 228,
		"./zh-cn": 229,
		"./zh-cn.js": 229,
		"./zh-hk": 230,
		"./zh-hk.js": 230,
		"./zh-tw": 231,
		"./zh-tw.js": 231
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 50;


/***/ },
/* 51 */,
/* 52 */,
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(312);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(311);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defaultAnalyticsConfig = __webpack_require__(255);
	
	var _defaultAnalyticsConfig2 = _interopRequireDefault(_defaultAnalyticsConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsConfig = function (_defaultAnalyticsConf) {
	  (0, _inherits3.default)(analyticsConfig, _defaultAnalyticsConf);
	
	  function analyticsConfig() {
	    (0, _classCallCheck3.default)(this, analyticsConfig);
	    return (0, _possibleConstructorReturn3.default)(this, (analyticsConfig.__proto__ || (0, _getPrototypeOf2.default)(analyticsConfig)).apply(this, arguments));
	  }
	
	  return analyticsConfig;
	}(_defaultAnalyticsConfig2.default);
	
	analyticsConfig.erTag = _defaultAnalyticsConfig2.default.erTag;
	exports.default = analyticsConfig;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.requestDownload = requestDownload;
	exports.setReaderSession = setReaderSession;
	exports.resetReaderSession = resetReaderSession;
	exports.checkReaderSession = checkReaderSession;
	
	var _utils = __webpack_require__(10);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _cookiemanager = __webpack_require__(24);
	
	var _cookiemanager2 = _interopRequireDefault(_cookiemanager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authenticationErrors = ["E3", "E5", "E6", "E7", "E17", "E20", "E21", "E26"];
	
	function requestDownload(_ref) {
	  var sessionManager = _ref.sessionManager,
	      paymentMethod = _ref.paymentMethod,
	      contentPackageId = _ref.contentPackageId,
	      subsId = _ref.subsId,
	      orderId = _ref.orderId,
	      confirmDownload = _ref.confirmDownload;
	
	  // when requesting a new download we need to clean the old download
	  _cookiemanager2.default.removeCookie(_cookiemanager2.default.cookieKeys.READER_SESSION);
	  return sessionManager.getSessionInfo().then(function (sessionId) {
	    return _apimanager2.default.requestDownload(sessionManager.userId, sessionId, subsId, contentPackageId, orderId, paymentMethod).then(function (downloadData) {
	      if (downloadData.StatusMessage.toLowerCase() != "ok" || downloadData.DownloadStatus.toLowerCase() === "refused") {
	        downloadData.call = "requestDownload";
	        downloadData.errorType = _setErrorType(downloadData.StatusMessage);
	        var error = (0, _utils.generateError)(downloadData);
	        return _promise2.default.reject(error);
	      }
	
	      setReaderSession({
	        userId: sessionManager.userId,
	        sessionId: sessionId,
	        subscriptionId: subsId,
	        orderId: downloadData.OrderID,
	        downloadId: downloadData.DownloadID,
	        cpId: contentPackageId
	      });
	      if (!confirmDownload) return _promise2.default.resolve();
	      return _apimanager2.default.confirmDownload({
	        userId: sessionManager.userId,
	        sessionId: sessionId,
	        contentPackageId: contentPackageId,
	        downloadId: downloadData.DownloadID,
	        downloadStatus: downloadData.DownloadStatus
	      }).then(function () {
	        return _promise2.default.resolve();
	      }).catch(function (confirmData) {
	        var error = (0, _utils.createError)("CD-ERR", "ConfirmDownload failed", confirmData);
	        return _promise2.default.reject(error);
	      });
	    }).catch(function (errorData) {
	      //const error = createError('RD-ERR', 'RequestDownload failed', errorData);
	      return _promise2.default.reject(errorData);
	    });
	  });
	}
	
	/**
	 * Sets the reader session cookie
	 */
	function setReaderSession(_ref2) {
	  var userId = _ref2.userId,
	      sessionId = _ref2.sessionId,
	      subscriptionId = _ref2.subscriptionId,
	      orderId = _ref2.orderId,
	      downloadId = _ref2.downloadId,
	      cpId = _ref2.cpId;
	
	  var date = new Date();
	  var expires = date.setTime(date.getTime() + 1000 * 60 * 60 * 2);
	  var info = {
	    userId: userId,
	    sessionId: sessionId,
	    subsId: subscriptionId,
	    orderId: orderId,
	    downloadId: downloadId,
	    cpId: cpId,
	    expires: expires
	  };
	  _cookiemanager2.default.createCookie(_cookiemanager2.default.cookieKeys.READER_SESSION, (0, _stringify2.default)(info), {
	    expires: 1000 * 60 * 60 * 2,
	    path: "/",
	    useTime: true
	  });
	}
	
	function resetReaderSession(cookieManager, cookie) {
	  if (cookie) {
	    var expires = JSON.parse(cookie).expires;
	    cookieManager.createCookie(cookieManager.cookieKeys.READER_SESSION, cookie, {
	      expires: expires,
	      path: "/",
	      useExpires: true
	    });
	  }
	}
	
	/**
	 * Checks if the reader session cookie exists
	 * @param {*} publicationData
	 */
	function checkReaderSession(publicationData, cookieManager) {
	  var cookie = cookieManager.getCookie(cookieManager.cookieKeys.READER_SESSION);
	  if (cookie) {
	    var json = JSON.parse(cookie);
	    if (json) {
	      if (json.cpId && json.cpId.toString() === publicationData.contentPackageId.toString()) {
	        //check if its expired
	        var now = new Date();
	        return now.getTime() <= json.expires;
	      }
	    }
	  }
	  return false;
	}
	
	/**
	 * This method identifies the type of error authentication or authorization
	 * @param {*} errorCode -  backend code of the error E1,E5...
	 */
	function _setErrorType(errorCode) {
	  var errorType = authenticationErrors.some(function (code) {
	    return code === errorCode;
	  }) ? "authentication" : "authorization";
	
	  return errorType;
	}

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(99);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _utils = __webpack_require__(10);
	
	var _redirectorKeys = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this class will implement al the necessary API communication
	// and cookie management to authenticate users and authorize
	// downloads. It does not implement any UI elements.
	var SubScriptionManagerBase = function (_Emitter) {
	  (0, _inherits3.default)(SubScriptionManagerBase, _Emitter);
	
	  // _authenticationPromiseData = {};
	  // _authorizationPromiseData = {};
	  // // note the description is purely internal, the errorcode needs to
	  // // be translated in the translation files based on the code
	  // _errors = {
	  //   'E1': {
	  //     code: 'E1',
	  //     description: 'Can`t connect to server. Application only available for offline use.'
	  //   },
	  //   'E2': {
	  //     code: 'E2',
	  //     description: 'Can`t connect to server. Application only available for offline use.'
	  //   },
	  //   'E3': {
	  //     code: 'E3',
	  //     description: 'Fatal error. Connection with server impossible.'
	  //   },
	  //   'E4': {
	  //     code: 'E4',
	  //     description: 'Can`t connect to server. Application only available for offline use.'
	  //   },
	  //   'E5': {
	  //     code: 'E5',
	  //     description: 'You don`t have an active subscription, take a subscription for unlimited access.'
	  //   },
	  //   'E6': {
	  //     code: 'E6',
	  //     description: 'Your information is invalid. Try again or take a subscription for unlimited access.'
	  //   },
	  //   'E7': {
	  //     code: 'E7',
	  //     description: 'Password invalid. Check your password.'
	  //   },
	  //   'E8': {
	  //     code: 'E8',
	  //     description: 'Fatal error. Information can not be retrieved from the server.'
	  //   },
	  //   'E9': {
	  //     code: 'E9',
	  //     description: 'Fatal error. Information can not be retrieved from the server.'
	  //   },
	  //   'E10': {
	  //     code: 'E10',
	  //     description: 'Fatal error. Information can not be retrieved from the server.'
	  //   },
	  //   'E11': {
	  //     code: 'E11',
	  //     description: 'You have reached the maximum number of downloads with your subscription.'
	  //   },
	  //   'E12': {
	  //     code: 'E12',
	  //     description: 'Fatal error. Information can not be retrieved from the server.'
	  //   },
	  //   'E13': {
	  //     code: 'E13',
	  //     description: 'Fatal error. Information can not be retrieved from the server.'
	  //   },
	  //   'E14': {
	  //     code: 'E14',
	  //     description: 'There has been an error when verifying your credentials. Try again or contact our customer service.'
	  //   },
	  //   'E15': {
	  //     code: 'E15',
	  //     description: 'There has been an error when verifying your credentials. Try again or contact our customer service.'
	  //   },
	  //   'E16': {
	  //     code: 'E16',
	  //     description: 'Unexpected Error'
	  //   },
	  //   'E17': {
	  //     code: 'E17',
	  //     description: 'Unknown email address. Change it and try again'
	  //   },
	  //   'E18': {
	  //     code: 'E18',
	  //     description: 'An error has occurred when downloading your newspaper. Please try again or contact customer service.'
	  //   },
	  //   'E21': {
	  //     code: 'E21',
	  //     description: 'Subscription expired'
	  //   },
	  //   'E24': {
	  //     code: 'E24',
	  //     description: 'Subscription OK but not valid for this download'
	  //   },
	  //   'E100': {
	  //     code: 'E100',
	  //     description: 'Braintree Payment Gateway general error'
	  //   },
	  //   'E101': {
	  //     code: 'E101',
	  //     description: 'An account with the specified email already exists'
	  //   },
	  //   'E102': {
	  //     code: 'E102',
	  //     description: 'Either the account does not exist or the password is wrong'
	  //   },
	  //   'E103': {
	  //     code: 'E103',
	  //     description: 'This email is not associated with any account'
	  //   },
	  //   'NotAllowed': {
	  //     code: 'Not_Allowed',
	  //     description: 'Operation not allowed in this subscriptionmanager'
	  //   },
	  //   'Unknown': {
	  //     code: 'Unknown_Error',
	  //     description: 'Unknown Error occured'
	  //   },
	  //   'Session': {
	  //     code: 'Session_error',
	  //     description: 'No valid session'
	  //   },
	  //   'InvalidInformation': {
	  //     code: 'Invalid_information_error',
	  //     description: 'The information is not vallid.'
	  //   }
	  // }
	
	  function SubScriptionManagerBase(appState, sessionManager, apiManager, cookieManager) {
	    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	    (0, _classCallCheck3.default)(this, SubScriptionManagerBase);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SubScriptionManagerBase.__proto__ || (0, _getPrototypeOf2.default)(SubScriptionManagerBase)).call(this));
	
	    _this._appState = null;
	    _this._sessionManager = null;
	    _this._cookieManager = null;
	    _this._apiManager = null;
	    _this._options = null;
	    _this._subscriptionId = undefined;
	    _this._authenticated = false;
	    _this.isFreePublication = false;
	
	    _this._appState = appState;
	    _this._sessionManager = sessionManager;
	    _this._apiManager = apiManager;
	    _this._cookieManager = cookieManager;
	    _this._options = options;
	    // check the cookie for authentication and set the status.
	
	    //set UUID
	    _this._appState.uuid = _this._sessionManager.UUID;
	    return _this;
	  }
	
	  // Returns the current authentication state.
	
	
	  (0, _createClass3.default)(SubScriptionManagerBase, [{
	    key: "authenticateByUserNamePassword",
	
	
	    // returns a promise that will either reject with an error code when authentication
	    // fails, either resolves to success
	    // in any case it will also trigger the authenticationstatuschanged event.
	    value: function authenticateByUserNamePassword(username, password) {
	      var _this2 = this;
	
	      var authenticationPromise = new _promise2.default(function (resolve, reject) {
	        // check if there is an SSO cookie if the settings are SSO enabled,
	        // else check for the subscription cookie.
	        _this2._authenticated = username === "test@twipemobile.com" && password === "test";
	        if (_this2._authenticated) {
	          _this2.trigger("subscriptionmanager:authenticationstatuschanged");
	          resolve();
	        } else {
	          _this2.trigger("subscriptionmanager:authenticationstatuschanged");
	          //TODO: right error
	          reject("not authenticated");
	        }
	      });
	      return authenticationPromise;
	    }
	
	    // returns a promise that will either reject with an error code when authentication
	    // fails, either resolves to success. This is to be used in case of SSO, or
	    // to check if you are autenticated
	    // in any case it will also trigger the authenticationstatuschanged event if
	    // the current status changed.
	    // eslint-disable-next-line
	
	  }, {
	    key: "authenticate",
	    value: function authenticate(downloadToken) {
	      var _this3 = this;
	
	      var authenticationPromise = new _promise2.default(function (resolve) {
	        // check if there is an SSO cookie if the settings are SSO enabled,
	        // else check for the subscription cookie.
	        _this3._authenticated = true;
	        _this3.trigger("subscriptionmanager:authenticationstatuschanged");
	        resolve();
	      });
	      return authenticationPromise;
	    }
	
	    // returns a promise that will either reject with an error code when authorization
	    // fails, either resolves to success. It will also execute the authentication
	    // if not yet authenticated. It will also potentially triger the
	    // authenticationstatuschanged event
	
	  }, {
	    key: "authorize",
	    value: function authorize() {
	      var _this4 = this;
	
	      var publicationData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        contentPackageId: -1,
	        publicationId: -1,
	        price: -1
	      };
	
	      var authorizationPromise = new _promise2.default(function (resolve, reject) {
	        _this4._appState.isFreePublication = publicationData && publicationData.price === 0;
	        if (publicationData.price !== 0) {
	          _this4.authenticate().then(function () {
	            if (publicationData && publicationData.contentPackageId && publicationData.contentPackageId === 513887) {
	              // call Authorization methods and return the promises
	              resolve();
	            } else {
	              // for testing now resolve false
	              reject("error: no rights");
	            }
	          }).catch(function (error) {
	            // something went wrong reject it.
	            reject(error);
	          });
	        } else {
	          // 0 priced publications are always authorized
	          resolve();
	        }
	      });
	      return authorizationPromise;
	    }
	  }, {
	    key: "authorizeArticle",
	    value: function authorizeArticle(contentPackageId, publicationId, pageId, contentItemId) {
	      if (this._authenticated) {
	        return true;
	      } else {
	        if (this.isFreePublication) {
	          return true;
	        }
	        if (this._appState.socialSharing) {
	          if (this._appState.socialSharingReset === "session") {
	            if (this._appState.viewedArticles.indexOf(contentItemId) >= 0) {
	              return true;
	            } else if (this._appState.viewedArticles.length < this._appState.socialSharingNumberOfArticles) {
	              this._appState.viewedArticles.push(contentItemId);
	              return true;
	            } else if (this._appState.viewedArticles.length == this._appState.socialSharingNumberOfArticles) {
	              if (parent) {
	                parent.postMessage({
	                  MessageName: "SHARING_LIMIT_REACHED",
	                  SharingFreemiumLimit: this._appState.socialSharingNumberOfArticles,
	                  SocialSharingReset: this._appState.socialSharingReset,
	                  Url: window.location.href
	                }, "*");
	              }
	              return false;
	            } else {
	              return false;
	            }
	          } else if (this._appState.socialSharingReset === "contentpackage") {
	            if (typeof Storage !== "undefined" && this._appState.socialSharingNumberOfArticles > 0) {
	              var item = JSON.parse(localStorage.getItem(contentPackageId.toString()));
	              if (!item) {
	                item = {};
	              }
	              if (item[contentItemId.toString()]) {
	                return true;
	              } else if ((0, _keys2.default)(item).length < this._appState.socialSharingNumberOfArticles) {
	                item[contentItemId.toString()] = true;
	                localStorage.setItem(contentPackageId.toString(), (0, _stringify2.default)(item));
	                return true;
	              } else {
	                return false;
	              }
	            } else {
	              return false;
	            }
	          } else if (this._appState.socialSharingReset === "week") {
	            if (typeof Storage !== "undefined" && this._appState.socialSharingNumberOfArticles > 0) {
	              var _item = JSON.parse(localStorage.getItem("contentItemsWeek"));
	              if (_item && _item["items"]) {
	                var items = _item["items"];
	                if (items[contentItemId.toString()]) {
	                  return true;
	                } else if ((0, _keys2.default)(items).length < this._appState.socialSharingNumberOfArticles) {
	                  items[contentItemId.toString()] = true;
	                  localStorage.setItem("contentItemsWeek", (0, _stringify2.default)(_item));
	                  return true;
	                } else {
	                  return false;
	                }
	              }
	            }
	          } else {
	            return false;
	          }
	        } else {
	          return false;
	        }
	      }
	    }
	
	    // returns a promise that will either reject with an error code when authorization
	    // fails, either resolves to success. It will tagke as the assumption that
	    // the CP and Publication is authorized and only uses the pageId for freemium
	    // and metered model implementations
	    // eslint-disable-next-line
	
	  }, {
	    key: "authorizePage",
	    value: function authorizePage(contentPackageId, publicationId, pageId) {
	      if (this._appState.isNextgenSharing() && !this.authorizeArticle(contentPackageId, publicationId, pageId, contentPackageId + "_" + pageId)) {
	        return _promise2.default.reject(false);
	      }
	      return _promise2.default.resolve(true);
	    }
	
	    // delete the subscriptionCookie and fire event if authenticationstatuschanged
	
	  }, {
	    key: "logOut",
	    value: function logOut() {
	      var _this5 = this;
	
	      var promise = new _promise2.default(function (resolve, reject) {
	        if (_this5._options.paywallRedirectionUrl) {
	          _apimanager2.default.getUserProfileValue(_redirectorKeys.LOGOUT_REDIRECTION).then(function (result) {
	            _this5.removeAuthenticationCookies();
	            if (result && result[0] && result[0].Value) {
	              window.top.location.href = (0, _utils.createRedirectionLogoutUrl)(result[0].Value);
	            } else {
	              _this5.removeAuthenticationCookies();
	              reject();
	            }
	            resolve();
	          }).catch(function () {
	            _this5.removeAuthenticationCookies();
	            reject();
	          });
	        } else {
	          _this5.removeAuthenticationCookies();
	        }
	      });
	      return promise;
	    }
	  }, {
	    key: "removeAuthenticationCookies",
	    value: function removeAuthenticationCookies() {
	      if (this._authenticated) {
	        this._cookieManager.removeCookie(this._cookieManager.cookieKeys.REDIRECTIONS);
	        this._authenticated = false;
	        this._deleteSubscriptionCookie();
	        this._deleteReaderSessionCookie();
	        this.trigger("subscriptionmanager:authenticationstatuschanged");
	      }
	    }
	  }, {
	    key: "_deleteSubscriptionCookie",
	    value: function _deleteSubscriptionCookie() {
	      this._cookieManager.removeCookie(this._cookieManager.cookieKeys.LOGIN);
	      this._appState.loginInformation = null;
	    }
	  }, {
	    key: "_deleteReaderSessionCookie",
	    value: function _deleteReaderSessionCookie() {
	      this._cookieManager.removeCookie(this._cookieManager.cookieKeys.READER_SESSION);
	    }
	  }, {
	    key: "_setLoginInformationFromCookie",
	    value: function _setLoginInformationFromCookie() {
	      var cookie = this._cookieManager.getCookie(this._cookieManager.cookieKeys.LOGIN);
	      if (cookie) {
	        var _JSON$parse = JSON.parse(cookie),
	            subscriptionReference = _JSON$parse.subscriptionReference,
	            subscriptionUserReference = _JSON$parse.subscriptionUserReference,
	            userSubscriptionType = _JSON$parse.userSubscriptionType;
	
	        this._appState.setUserInfo({
	          subscriptionReference: subscriptionReference,
	          subscriptionUserReference: subscriptionUserReference,
	          userSubscriptionType: userSubscriptionType
	        });
	      }
	    }
	  }, {
	    key: "_createSubscriptionCookie",
	    value: function _createSubscriptionCookie(subsId, subscriptionReference, subscriptionUserReference, userSubscriptionType, userName) {
	      this._appState.setUserInfo({
	        subscriptionReference: subscriptionReference,
	        subscriptionUserReference: subscriptionUserReference,
	        userSubscriptionType: userSubscriptionType
	      });
	      var info = {
	        subsId: subsId,
	        subscriptionReference: subscriptionReference,
	        subscriptionUserReference: subscriptionUserReference,
	        userSubscriptionType: userSubscriptionType
	      };
	      if (userName) {
	        info.userName = userName;
	      }
	
	      this._cookieManager.createCookie(this._cookieManager.cookieKeys.LOGIN, (0, _stringify2.default)(info));
	    }
	  }, {
	    key: "isAuthenticated",
	    get: function get() {
	      return this._authenticated;
	    }
	  }]);
	  return SubScriptionManagerBase;
	}(_es6EventEmitter2.default);
	
	exports.default = SubScriptionManagerBase;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.showPagination = showPagination;
	exports.hidePagination = hidePagination;
	
	var _hammerjs = __webpack_require__(119);
	
	var _imageGallerySlideMobile = __webpack_require__(304);
	
	var _imageGallerySlideMobile2 = _interopRequireDefault(_imageGallerySlideMobile);
	
	var _imageGallery = __webpack_require__(43);
	
	var _imageGallery2 = _interopRequireDefault(_imageGallery);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGalleryMobile = function (_ImageGallery) {
	  (0, _inherits3.default)(ImageGalleryMobile, _ImageGallery);
	
	  function ImageGalleryMobile() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ImageGalleryMobile);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImageGalleryMobile.__proto__ || (0, _getPrototypeOf2.default)(ImageGalleryMobile)).call.apply(_ref, [this].concat(args))), _this), _this.resizedEnd = function () {
	      var height = _this.DOMContainer.querySelector(".swiper-wrapper-imageviewer").getBoundingClientRect().height;
	      //call update before and after, otherwise siwper is shifted when first zooming in 2the image and then rotating
	      _this.swiper.update(true);
	      _this.imageSlides.forEach(function (slide) {
	        slide.resize(height, _this.options.imageviewerKeepScale);
	      });
	      _this.swiper.update(true);
	    }, _this.preventDefault = function (e) {
	      e.preventDefault();
	    }, _this.panning = function (e) {
	      var slide = _this.imageSlides[_this.swiper.activeIndex];
	      slide.panning(e);
	    }, _this.panningEnd = function (e) {
	      _this.imageSlides[_this.swiper.activeIndex].panningEnd(e);
	      _this.checkSwiping();
	    }, _this.onPinch = function (e) {
	      _this.imageSlides[_this.swiper.activeIndex].onPinch(e);
	    }, _this.onPinchEnd = function (e) {
	      var slide = _this.imageSlides[_this.swiper.activeIndex];
	      slide.onPinchEnd(e);
	      _this.checkSwiping();
	    }, _this.onPinchStart = function (e) {
	      _this.swiper.lockSwipeToPrev();
	      _this.swiper.lockSwipeToNext();
	      _this.imageSlides[_this.swiper.activeIndex].onPinchStart(e);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ImageGalleryMobile, [{
	    key: "createImageViewerSlide",
	    value: function createImageViewerSlide(image) {
	      var _this2 = this;
	
	      var slide = new _imageGallerySlideMobile2.default(this.appState, image, this.options.imageviewerslide);
	      slide.on("imageViewerSlide:detachSwiperEvents", function () {
	        _this2.detachSwiperEvents();
	      });
	      slide.on("imageViewerSlide:attachSwiperEvents", function () {
	        _this2.attachSwiperEvents();
	      });
	      return slide;
	    }
	  }, {
	    key: "attachSwiperEvents",
	    value: function attachSwiperEvents() {
	      if (this.swiper) {
	        this.swiper.attachEvents();
	      }
	    }
	  }, {
	    key: "detachSwiperEvents",
	    value: function detachSwiperEvents() {
	      if (this.swiper) {
	        this.swiper.detachEvents();
	      }
	    }
	  }, {
	    key: "createSwiper",
	    value: function createSwiper() {
	      var _this3 = this;
	
	      var selector = "#imageviewer .swiper-container-imageviewer";
	      var a = document.querySelector(selector);
	      if (a) {
	        this.swiper = new Swiper($(a), {
	          initialSlide: this.slideNumber,
	          centeredSlides: true,
	          pagination: $(a).find(" .swiper-pagination-imageviewer"),
	          loopedSlides: this.DOMContainer.querySelector(".swiper-wrapper-imageviewer").children.length,
	          onInit: function onInit() {
	            _this3.appState.triggerEvent(_analyticsevents.VIEW_IMAGE_GALLERY);
	          },
	          onTransitionEnd: function onTransitionEnd(_ref2) {
	            var activeIndex = _ref2.activeIndex;
	
	            // if active index is not 0, it is called in the beginning
	            _this3.imageSlides[activeIndex].renderHd();
	            if (_this3.imageSlides[activeIndex].isZoomed()) {
	              _this3.zoomed();
	            } else {
	              _this3.notZoomed();
	            }
	            if (_this3.lastIndex !== null && _this3.swiper.activeIndex !== _this3.lastIndex) {
	              if (_this3.lastIndex < activeIndex) {
	                _this3.appState.triggerEvent(_analyticsevents.SWIPED_FORWARD_GALLERY);
	                _this3.appState.triggerEvent(_analyticsevents.VIEW_IMAGE_GALLERY);
	              } else {
	                _this3.appState.triggerEvent(_analyticsevents.SWIPED_BACKWARD_GALLERY);
	                _this3.appState.triggerEvent(_analyticsevents.VIEW_IMAGE_GALLERY);
	              }
	            }
	            _this3.lastIndex = activeIndex;
	          },
	          onTouchEnd: function onTouchEnd(swiper) {
	            swiper.unlockSwipeToPrev();
	            swiper.unlockSwipeToNext();
	          },
	          onTouchStart: function onTouchStart() {
	            _this3.checkSwiping();
	          }
	        });
	      }
	      this.appState.on("appState:heightChanged", this.resizedEnd);
	    }
	  }, {
	    key: "initHammerSlide",
	    value: function initHammerSlide() {
	      var _this4 = this;
	
	      this.imageSlides.forEach(function (slide) {
	        slide.on("imageViewerSlide:notZoomed", function () {
	          _this4.notZoomed();
	        });
	        slide.on("imageViewerSlide:zoomed", function () {
	          _this4.zoomed();
	        });
	      });
	      this.attachHammer();
	    }
	  }, {
	    key: "removeListeners",
	    value: function removeListeners() {
	      this.appState.off("appState:heightChanged", this.resizedEnd);
	    }
	  }, {
	    key: "zoomed",
	    value: function zoomed() {
	      hidePagination();
	    }
	  }, {
	    key: "notZoomed",
	    value: function notZoomed() {
	      showPagination();
	    }
	  }, {
	    key: "checkSwiping",
	    value: function checkSwiping(e) {
	      if (!this.swiper) {
	        return;
	      }
	      var slide = this.imageSlides[this.swiper.activeIndex];
	      var number = slide.allowSwiping(e);
	      switch (number) {
	        case 1:
	          this.swiper.unlockSwipeToPrev();
	          this.swiper.unlockSwipeToNext();
	          break;
	        case 2:
	          this.swiper.lockSwipeToPrev();
	          this.swiper.unlockSwipeToNext();
	          break;
	        case 3:
	          this.swiper.unlockSwipeToPrev();
	          this.swiper.lockSwipeToNext();
	          break;
	        default:
	          this.swiper.lockSwipeToPrev();
	          this.swiper.lockSwipeToNext();
	      }
	    }
	  }, {
	    key: "attachHammer",
	    value: function attachHammer() {
	      $(this.DOMContainer.querySelector(".swiper-wrapper-imageviewer")).on("touchmove", this.preventDefault);
	      this.mc = new _hammerjs.Manager(this.DOMContainer.querySelector(".swiper-wrapper-imageviewer"));
	      var pinch = new _hammerjs.Pinch({
	        threshold: 0.1
	      });
	      var pan = new _hammerjs.Pan();
	      this.mc.add(pan);
	      this.mc.add(pinch);
	      this.mc.on("pan", this.panning);
	      this.mc.on("panend", this.panningEnd);
	      this.mc.on("pinch", this.onPinch);
	      this.mc.on("pinchend", this.onPinchEnd);
	      this.mc.on("pinchcancel", this.onPinchEnd);
	      this.mc.on("pinchstart", this.onPinchStart);
	    }
	  }]);
	  return ImageGalleryMobile;
	}(_imageGallery2.default);
	
	exports.default = ImageGalleryMobile;
	function showPagination() {
	  var selector = "#imageviewer .swiper-container-imageviewer .swiper-pagination-imageviewer";
	  var a = document.querySelector(selector);
	  if (a) {
	    a.classList.remove("hidden");
	  }
	}
	
	function hidePagination() {
	  var selector = "#imageviewer .swiper-container-imageviewer .swiper-pagination-imageviewer";
	  var a = document.querySelector(selector);
	  if (a) {
	    a.classList.add("hidden");
	  }
	}

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(314);


/***/ },
/* 60 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(25);
	var IObject = __webpack_require__(65);
	var toObject = __webpack_require__(30);
	var toLength = __webpack_require__(47);
	var asc = __webpack_require__(334);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 62 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var document = __webpack_require__(14).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 64 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(35);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(34);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(20);
	var dPs = __webpack_require__(343);
	var enumBugKeys = __webpack_require__(64);
	var IE_PROTO = __webpack_require__(73)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(63)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(101).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(46);
	var createDesc = __webpack_require__(38);
	var toIObject = __webpack_require__(29);
	var toPrimitive = __webpack_require__(76);
	var has = __webpack_require__(26);
	var IE8_DOM_DEFINE = __webpack_require__(102);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(21) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 69 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(16);
	var core = __webpack_require__(13);
	var fails = __webpack_require__(28);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(27);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(27);


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(74)('keys');
	var uid = __webpack_require__(48);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(13);
	var global = __webpack_require__(14);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(36) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 75 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(18);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(14);
	var core = __webpack_require__(13);
	var LIBRARY = __webpack_require__(36);
	var wksExt = __webpack_require__(79);
	var defineProperty = __webpack_require__(22).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(17);


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(86);
	var ITERATOR = __webpack_require__(17)('iterator');
	var Iterators = __webpack_require__(33);
	module.exports = __webpack_require__(13).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 81 */
/***/ function(module, exports) {



/***/ },
/* 82 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var customerConfig = __webpack_require__(251).default;
	
	var options = function options() {
	  (0, _classCallCheck3.default)(this, options);
	};
	
	options.authenticatorauthorisationcontroller = {
	  subscriptionOptions: customerConfig.subscriptionOptions,
	  SSOCookieName: customerConfig.SSOCookieName,
	  SSOEnabled: customerConfig.SSOEnabled,
	  SSOCookieOptions: customerConfig.SSOCookieOptions,
	  deleteSSOCookie: customerConfig.deleteSSOCookie,
	  getSSOTokenFromUrl: customerConfig.getSSOTokenFromUrl,
	  generateSSOState: customerConfig.generateSSOState,
	  paywallRedirectionUrl: customerConfig.paywallRedirectionUrl,
	  urlSSOTokenParameter: customerConfig.urlSSOTokenParameter,
	  urlRedirectParameter: customerConfig.urlRedirectParameter
	};
	options.useSlider = {
	  useSliderForPromospot: customerConfig.useSliderForPromospot,
	  useSliderForHorsSeries: customerConfig.useSliderForHorsSeries,
	  useSliderForArchive: customerConfig.useSliderForArchive
	};
	options.regionmanager = {
	  defaultRegion: customerConfig.defaultRegion,
	  defaultDownloadToken: customerConfig.defaultDownloadToken,
	  forceRegionCookie: customerConfig.forceRegionCookie,
	  forceRegionCookieOptions: customerConfig.forceRegionCookieOptions,
	  deleteForceRegionCookie: customerConfig.deleteForceRegionCookie,
	  downloadToken: customerConfig.newsStandDownloadToken //used for par-eco, par-etudiant
	};
	options.downloadComponent = {
	  paywallRedirectionUrl: customerConfig.paywallRedirectionUrl,
	  paywallRedirectionTimeReset: customerConfig.paywallRedirectionTimeReset,
	  paywallRedirectionNumber: customerConfig.paywallRedirectionNumber,
	  generateSSOState: customerConfig.generateSSOState,
	  homeRedirectionLink: customerConfig.homeRedirectionLink,
	  showBackButtonParam: customerConfig.showBackButtonParam,
	  urlRedirectParameter: customerConfig.urlRedirectParameter
	};
	options.sizes = {
	  covers: {
	    S: customerConfig.namedSizeCoverS,
	    M: customerConfig.namedSizeCoverM
	  },
	  previews: {
	    thumbs: {
	      nonNamedSize: customerConfig.sizePreviewS,
	      namedSize: customerConfig.namedSizePreviewS
	    },
	    nonHD: {
	      nonNamedSize: customerConfig.sizePreviewM,
	      namedSize: customerConfig.namedSizePreviewM
	    },
	    HD: {
	      nonNamedSize: customerConfig.sizePreviewL,
	      namedSize: customerConfig.namedSizePreviewL
	    }
	  },
	  images: {
	    nonHD: {
	      nonNamedSize: customerConfig.sizeImageM,
	      namedSize: customerConfig.namedSizeImageM
	    },
	    HD: {
	      nonNamedSize: customerConfig.sizeImageL,
	      namedSize: customerConfig.namedSizeImageL
	    }
	  }
	};
	options.promospot = {
	  onlySupplementsInPromospot: customerConfig.onlySupplementsInPromospot
	};
	options.paywallcomponent = {
	  subscription_validate_email: customerConfig.subscription_validate_email,
	  noPasswordLogin: customerConfig.noPasswordLogin
	};
	options.about = {
	  editor: customerConfig.editor,
	  developer: customerConfig.developer,
	  openHelpOnNewtab: customerConfig.openHelpOnNewtab,
	  hideDisclaimer: customerConfig.hideDisclaimer
	};
	options.settings = {
	  subscriptionOptions: customerConfig.subscriptionOptions,
	  about: options.about,
	  displayViewerOptions: customerConfig.displayViewerOptions,
	  turnOnSettings: customerConfig.turnOnSettings,
	  useCustomTooltips: customerConfig.useCustomTooltips,
	  displayTopNavButtonlabel: customerConfig.displayTopNavButtonlabel,
	  replicaReadingModeToggle: customerConfig.replicaReadingModeToggle,
	  toggleSubscriptionTopNavButtonOnUserLoggedIn: customerConfig.toggleSubscriptionTopNavButtonOnUserLoggedIn,
	  paywallRedirectionUrl: customerConfig.paywallRedirectionUrl,
	  paywallRedirectionTimeReset: customerConfig.paywallRedirectionTimeReset,
	  paywallRedirectionNumber: customerConfig.paywallRedirectionNumber,
	  generateSSOState: customerConfig.generateSSOState,
	  urlRedirectParameter: customerConfig.urlRedirectParameter,
	  openHelpOnNewtab: customerConfig.openHelpOnNewtab,
	  openPrivacyOnNewtab: customerConfig.openPrivacyOnNewtab,
	  showPrivacyPolicy: customerConfig.showPrivacyPolicy
	};
	options.help = {
	  turnOnHeaderHelp: customerConfig.turnOnHeaderHelp
	};
	options.sidemenuswiper = {
	  numberOfSlidesVisible: customerConfig.numberOfSlidesVisibleSideMenu,
	  spaceBetweenSlides: customerConfig.spaceBetweenSlidesSideMenu
	};
	options.sidemenu = {
	  sidemenuThema: customerConfig.sidemenuThema,
	  extraInfo: customerConfig.extraInfo,
	  sidemenuswiper: options.sidemenuswiper,
	  settings: options.settings,
	  recentlyLength: customerConfig.recentlyLength,
	  homeRedirectionLink: customerConfig.homeRedirectionLink,
	  sidemenuWidth: customerConfig.sidemenuWidth,
	  sidemenuAnimationDuration: customerConfig.sidemenuAnimationDuration,
	  displayViewerOptions: customerConfig.displayViewerOptions,
	  logoRedirect: customerConfig.logoRedirect
	};
	options.swiper = {
	  numberOfSlidesVisible: customerConfig.numberOfSlidesVisible,
	  spaceBetweenSlides: customerConfig.spaceBetweenSlides
	};
	options.kiosque = {
	  usePromoSpot: customerConfig.usePromoSpot,
	  customKiosqueTitle: customerConfig.customKiosqueTitle,
	  topNavButtonLabel: customerConfig.topNavButtonLabel,
	  topNavButtonHasFunction: customerConfig.topNavButtonHasFunction /* this config is enaled if a function is called when the top nav button is clicked and not a redirection url*/
	  , topNavBtnCookieConsent: customerConfig.topNavBtnCookieConsent /*this config is enabled if the cookie consent used the top nav button to show the cookie setting screen (cfr dum)*/
	  , displayArchive: customerConfig.displayArchive,
	  displayHorsSerieArchive: customerConfig.displayHorsSerieArchive,
	  swiper: options.swiper,
	  archiveLength: customerConfig.archiveLength,
	  sizes: options.sizes.covers,
	  displayViewerOptions: customerConfig.displayViewerOptions,
	  useSlider: options.useSlider,
	  toggleSubscriptionTopNavButtonOnUserLoggedIn: customerConfig.toggleSubscriptionTopNavButtonOnUserLoggedIn,
	  homeRelativeDepth: customerConfig.homeRelativeDepth
	};
	options.slidernavigation = {
	  thumbsNavigation: customerConfig.thumbsNavigation,
	  sizes: options.sizes.previews.thumbs
	};
	options.pdfPage = {
	  pdfThreshold: customerConfig.pdfThreshold,
	  pdfThresholdTouch: customerConfig.pdfThresholdTouch,
	  pdfLoadingTimeout: customerConfig.pdfLoadingTimeout,
	  pdfCleanupDelta: customerConfig.pdfCleanupDelta
	};
	options.readerPage = {
	  normal_size: customerConfig.normal_size,
	  hd_size: customerConfig.hd_size,
	  sizes: options.sizes.previews,
	  page_width_reference: customerConfig.page_width_reference,
	  page_height_reference: customerConfig.page_height_reference,
	  enrichment_placement_vertical: customerConfig.enrichment_placement_vertical,
	  enrichment_placement_horizontal: customerConfig.enrichment_placement_horizontal,
	  pdfPage: options.pdfPage,
	  /*if article only contains an enrichment link then add the link to the clickable area so that when clicked we directly open
	  the link in a new window*/
	  extraLinkDirectAccess: customerConfig.extraLinkDirectAccess
	};
	options.hammerslide = {
	  max_zoom: customerConfig.max_zoom,
	  pinchPanTimeInterval: customerConfig.pinchPanTimeInterval,
	  pinchTreshold: customerConfig.pinchTreshold,
	  activeAreaPercentage: customerConfig.activeAreaPercentage
	};
	options.readerSlide = {
	  readerPage: options.readerPage,
	  hammerslide: options.hammerslide
	};
	options.reader = {
	  useFullWidthLandscapeSinglePage: customerConfig.useFullWidthLandscapeSinglePage,
	  useFullWidthLandscapeDoublePage: customerConfig.useFullWidthLandscapeDoublePage,
	  preloadingHdPages: customerConfig.preloadingHdPages,
	  readerSlide: options.readerSlide,
	  touchDownloadPdf: customerConfig.touchDownloadPdf,
	  fullPdfDownloadOnly: customerConfig.fullPdfDownloadOnly,
	  allowFullPdfDownload: customerConfig.allowFullPdfDownload,
	  enableTopNavDropdown: customerConfig.enableTopNavDropdown
	};
	options.imageviewerslide = {
	  imageViewerCaptionOnlyFirstLines: customerConfig.imageViewerCaptionOnlyFirstLines,
	  hammerslide: options.hammerslide,
	  sizes: options.sizes.images
	};
	options.imageviewer = {
	  imageviewerKeepScale: customerConfig.imageviewerKeepScale,
	  imageviewerslide: options.imageviewerslide
	};
	options.albslide = {
	  fixedImgHeight: customerConfig.fixedImgHeight,
	  captionMaxLines: customerConfig.captionMaxLines,
	  extraButtonInTitle: customerConfig.extraButtonInTitle,
	  hideExtraButtonWhenInExtras: customerConfig.hideExtraButtonWhenInExtras,
	  extraButtonOnSlider: customerConfig.extraButtonOnSlider,
	  fullWidthImage: customerConfig.fullWidthImage,
	  extraButtonOnEachPage: customerConfig.extraButtonOnEachPage,
	  marginScrollExtraInView: customerConfig.marginScrollExtraInView,
	  extrasInViewMargin: customerConfig.extrasInViewMargin,
	  imageviewer: options.imageviewer,
	  sizes: options.sizes.images,
	  displayPageCategory: customerConfig.displayPageCategory
	};
	options.fontSizeService = {
	  maxfontSize: customerConfig.maxfontSize,
	  fontSizeStep: customerConfig.fontSizeStep,
	  rootFontSize: customerConfig.rootFontSize
	};
	options.sharing = {
	  printArticle: customerConfig.printArticle,
	  shareFromReader: customerConfig.shareFromReader,
	  shareFromNextgen: customerConfig.shareFromNextgen,
	  sharingOptions: customerConfig.sharingOptions,
	  printSize: customerConfig.printImageSize,
	  printExtraMargin: customerConfig.printExtraMargin,
	  printPadding: customerConfig.printPadding,
	  printMarginLeft: customerConfig.printMarginLeft
	};
	options.albcontroller = {
	  extraButtonOnSlider: customerConfig.extraButtonOnSlider,
	  increaseFontSizeEnabled: customerConfig.increaseFontSizeEnabled,
	  albSlideOnlyOnePage: customerConfig.albSlideOnlyOnePage,
	  sharingEnabled: customerConfig.sharingEnabled,
	  albslide: options.albslide,
	  fontSizeService: options.fontSizeService,
	  sharing: options.sharing,
	  printArticle: customerConfig.printArticle,
	  shareFromReader: customerConfig.shareFromReader
	};
	options.cookie = {
	  cookie_info_cookie_name: customerConfig.cookie_info_cookie_name,
	  cookieEnabled: customerConfig.cookieEnabled,
	  disableCookieSameSitePolicy: customerConfig.disableCookieSameSitePolicy
	};
	options.contentPackageStore = {
	  useNameAsLabel: customerConfig.useNameAsLabel,
	  downloadToken: customerConfig.newsStandDownloadToken //used for par-eco, par-etudiant
	};
	options.horsserieStore = {
	  useHSNameAsLabel: customerConfig.useHSNameAsLabel
	};
	options.pubStore = {
	  pageWidth: customerConfig.page_width_reference,
	  pageHeight: customerConfig.page_height_reference,
	  activePageArea: customerConfig.page_width_reference * customerConfig.page_height_reference * customerConfig.activeAreaPercentage,
	  dropCapIfFirstBold: customerConfig.dropCapIfFirstBold,
	  sizes: options.sizes.covers,
	  page_ratio: customerConfig.page_ratio,
	  replicaImageSize: options.reader.readerSlide.readerPage.hd_size
	};
	options.cpStore = {
	  shareFromReader: customerConfig.shareFromReader,
	  shareFromNextgen: customerConfig.shareFromNextgen,
	  channel: customerConfig.channel,
	  product_name_for_engage_readers: customerConfig.product_name_for_engage_readers,
	  sizes: options.sizes.covers
	};
	options.print = {
	  imageSize: customerConfig.printImageSize,
	  printCroppedPdf: customerConfig.printCroppedPdf
	};
	options.desktopReader = {
	  readerEnableHorsseries: customerConfig.readerEnableHorsseries,
	  toggleSubscriptionTopNavButtonOnUserLoggedIn: customerConfig.toggleSubscriptionTopNavButtonOnUserLoggedIn
	};
	options.zoom = {
	  desktopMaxZoom: customerConfig.desktopMaxZoom,
	  zoomSteps: customerConfig.zoomSteps
	};
	options.usePdf = {
	  usePdfPhone: customerConfig.usePdfPhone,
	  usePdfPhoneNot: customerConfig.usePdfPhoneNot,
	  usePdfTablet: customerConfig.usePdfTablet,
	  usePdfTabletNot: customerConfig.usePdfTabletNot,
	  usePdfDesktop: customerConfig.usePdfDesktop,
	  usePdfDesktopNot: customerConfig.usePdfDesktopNot
	};
	options.nextgen = {
	  redirectUrl: customerConfig.homeRedirectionLink
	};
	options.analytics = {
	  showBackButtonParam: customerConfig.showBackButtonParam
	};
	options.app = {
	  useCookiePostfix: customerConfig.useCookiePostfix,
	  //common
	  regionmanager: options.regionmanager,
	  authenticatorauthorisationcontroller: options.authenticatorauthorisationcontroller,
	  sidemenu: options.sidemenu,
	  defaultPreferredViewer: customerConfig.defaultPreferredViewer,
	  //home
	  kiosque: options.kiosque,
	  //reader
	  channel: customerConfig.channel,
	  replicaReadingModeToggle: customerConfig.replicaReadingModeToggle,
	  replicaReadingModeDefault: customerConfig.replicaReadingModeDefault, //double page is default
	  reader: options.reader,
	  slidernavigation: options.slidernavigation,
	  albcontroller: options.albcontroller,
	  cookie: options.cookie,
	  pubStore: options.pubStore,
	  cpStore: options.cpStore,
	  sizes: options.sizes,
	  dateFormat: customerConfig.dateFormat,
	  promospot: options.promospot,
	  newsstandRedirecting: customerConfig.newsstandRedirecting,
	  print: options.print,
	  desktopReader: options.desktopReader,
	  settings: options.settings,
	  help: options.help,
	  usePdf: options.usePdf,
	  zoom: options.zoom,
	  homeRedirectionLink: customerConfig.homeRedirectionLink,
	  homeRedirectionLinkUAT: customerConfig.homeRedirectionLinkUAT,
	  homeRedirectionLinkPROD: customerConfig.homeRedirectionLinkPROD,
	  logo404: customerConfig.logo404,
	  activePageArea: customerConfig.activeAreaPercentage,
	  pdfPage: options.pdfPage,
	  socialSharingHash: customerConfig.socialSharingHash,
	  allowNextgenPageSharing: customerConfig.allowNextgenPageSharing,
	  nextgen: options.nextgen,
	  imageviewer: options.imageviewer,
	  displayViewerOptions: customerConfig.displayViewerOptions,
	  useCustomTooltips: customerConfig.useCustomTooltips,
	  displayTopNavButtonlabel: customerConfig.displayTopNavButtonlabel,
	  toggleSubscriptionTopNavButtonOnUserLoggedIn: customerConfig.toggleSubscriptionTopNavButtonOnUserLoggedIn, //When the user is logged in, we hide the se connecter button as well as the other top nav button.
	  logoRedirect: customerConfig.logoRedirect,
	  contentPackageStore: options.contentPackageStore,
	  horsserie: options.horsserieStore,
	  downloadComponent: options.downloadComponent,
	  sharing: options.sharing,
	  paywallcomponent: options.paywallcomponent,
	  cmpScript: customerConfig.cmpScript,
	  enableCookieConsent: customerConfig.enableCookieConsent,
	  showBackButtonParam: customerConfig.showBackButtonParam,
	  hasConsentScript: customerConfig.hasConsentScript,
	  displayPublicationNameInSidebar: customerConfig.displayPublicationNameInSidebar,
	  featuresToBeEnabledByBE: customerConfig.featuresToBeEnabledByBE,
	  singlePageDisplayedProportion: customerConfig.singlePageDisplayedProportion,
	  redirectReaderFromIframe: customerConfig.redirectReaderFromIframe,
	  returnToIframeUrl: customerConfig.returnToIframeUrl
	};
	exports.default = options;

/***/ },
/* 84 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EUserProfileValues = exports.EUserProfileValues = {
	  ENABLED_FEATURES: "EnabledFeatures"
	};
	
	var EEnabledFeatures = exports.EEnabledFeatures = {
	  PRINT: "print",
	  DOWNLOAD_PDF: "downloadPdf"
	};
	
	var CmpType = exports.CmpType = {
	  DIDOMI: "didomi",
	  LMO: "lmo",
	  SOURCEPOINT: "sourcepoint"
	};
	
	var XitiMode = exports.XitiMode = {
	  MINIMAL: "minimal",
	  FULL: "full"
	};
	
	var deviceType = exports.deviceType = {
	  PHONE: "smartphone",
	  TABLET: "tablet",
	  DESKTOP: "desktop"
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(306);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(35);
	var TAG = __webpack_require__(17)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 87 */,
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _analyticsmanagerbase = __webpack_require__(253);
	
	var _analyticsmanagerbase2 = _interopRequireDefault(_analyticsmanagerbase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsManager = function (_AnalyticsManagerBase) {
	  (0, _inherits3.default)(AnalyticsManager, _AnalyticsManagerBase);
	
	  function AnalyticsManager(options) {
	    (0, _classCallCheck3.default)(this, AnalyticsManager);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsManager.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsManager)).call(this, options));
	
	    _this._initEngines();
	    return _this;
	  }
	
	  (0, _createClass3.default)(AnalyticsManager, [{
	    key: "_initEngines",
	    value: function _initEngines() {}
	  }]);
	  return AnalyticsManager;
	}(_analyticsmanagerbase2.default);
	
	exports.default = AnalyticsManager;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _appStateBase = __webpack_require__(254);
	
	var _appStateBase2 = _interopRequireDefault(_appStateBase);
	
	var _cookiemanager = __webpack_require__(24);
	
	var _cookiemanager2 = _interopRequireDefault(_cookiemanager);
	
	var _utils = __webpack_require__(10);
	
	__webpack_require__(296);
	
	var _eventBus = __webpack_require__(238);
	
	var _eventBus2 = _interopRequireDefault(_eventBus);
	
	var _eventBusActions = __webpack_require__(239);
	
	var _eventBusActions2 = _interopRequireDefault(_eventBusActions);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _resizer = __webpack_require__(303);
	
	var _resizer2 = _interopRequireDefault(_resizer);
	
	var _subscriptionUtilities = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppState = function (_AppStateBase) {
	  (0, _inherits3.default)(AppState, _AppStateBase);
	
	  function AppState(analyticsManager) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    (0, _classCallCheck3.default)(this, AppState);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AppState.__proto__ || (0, _getPrototypeOf2.default)(AppState)).call(this, analyticsManager));
	
	    _this._isLoggedIn = false;
	    _this._downloadToken = null;
	    _this.isTablet = false;
	    _this.isDesktop = true;
	    _this._isIOS = null;
	    _this._isWindows = null;
	    _this.inFullScreenMode = false;
	    _this._isDoublePage = true;
	    _this._readerSessionCookie = null;
	    _this._newDownloaderFallbackMode = false;
	    _this._authenticatorAuthorisationController = null;
	    _this.cdnAssetsDownloader = null;
	    _this._currentPage = null;
	    _this._totalPages = 0;
	    _this._contentPackageId = null;
	    _this._publicationId = null;
	    _this._articleLightBoxDisplayed = false;
	    _this._authorized = false;
	    _this._contentid = null;
	    _this._sharingUrl = null;
	    _this._username = null;
	    _this.socialSharingNumberOfArticles = 0;
	    _this._socialSharingReset = null;
	    _this.viewedArticles = [];
	    _this.nextgenSharingArticle = null;
	    _this.classNames = null;
	    _this._timeBasedUnlimitedAccessEnabled = false;
	    _this.portrait = window.innerWidth < window.innerHeight;
	    _this.width = window.innerWidth;
	    _this.height = window.innerHeight;
	    _this._preferredViewer = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.PREFERRED_VIEWER);
	    _this._isFreePublication = false;
	    _this.isReplica = false;
	
	    _this.isReader = options.isReader;
	    _this._options = options;
	    _this._eventListeners();
	    _this.initDevice();
	    _this._checkSocialSharing();
	    _this._checkNextgenSharingArticle();
	    return _this;
	  }
	
	  (0, _createClass3.default)(AppState, [{
	    key: "initResizer",
	    value: function initResizer() {
	      this.resizer = new _resizer2.default(document.querySelector("#main-app"), this.classNames);
	      this.initResizerListeners();
	    }
	  }, {
	    key: "initResizerListeners",
	    value: function initResizerListeners() {
	      var _this2 = this;
	
	      this.resizer.on("resizer:heightChanged", function () {
	        _this2.trigger("appState:heightChanged");
	        _this2.heightChanged();
	      });
	      this.resizer.on("resizer:rotated", function () {
	        if (!_this2.isDesktop) _this2.triggerEvent(_analyticsevents.ROTATE);
	      });
	    }
	  }, {
	    key: "nextgenLoaded",
	    value: function nextgenLoaded() {
	      this.trigger("nextgen:loaded");
	    }
	  }, {
	    key: "heightChanged",
	    value: function heightChanged() {
	      //analytics
	      this.checkHeightChanged();
	    }
	  }, {
	    key: "setMobileDoublePage",
	    value: function setMobileDoublePage(toggle, defaultValue) {
	      if (toggle) {
	        var cookieValue = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.DOUBLEPAGE_LANDSCAPEDISPLAY);
	        if (cookieValue) {
	          this._isDoublePage = cookieValue === "true";
	        } else {
	          this._isDoublePage = defaultValue;
	          _cookiemanager2.default.createCookie(_cookiemanager2.default.cookieKeys.DOUBLEPAGE_LANDSCAPEDISPLAY, this._isDoublePage);
	        }
	      } else {
	        this._isDoublePage = defaultValue;
	      }
	    }
	  }, {
	    key: "setDesktopDoublePage",
	    value: function setDesktopDoublePage(toggle, defaultValue) {
	      if (toggle) {
	        var cookieValue = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.DESKTOP_DOUBLEPAGE);
	        if (cookieValue) {
	          this._isDoublePage = cookieValue === "true";
	        } else {
	          this._isDoublePage = defaultValue;
	          _cookiemanager2.default.createCookie(_cookiemanager2.default.cookieKeys.DESKTOP_DOUBLEPAGE, this._isDoublePage);
	        }
	        if (this._isDoublePage && document.body.classList.contains("singlePage") || this._preferredViewer == "nextgen") {
	          document.body.classList.remove("singlePage");
	        } else {
	          document.body.classList.add("singlePage");
	        }
	      } else {
	        this._isDoublePage = defaultValue;
	        if (document.body.classList.contains("singlePage")) document.body.classList.remove("singlePage");
	      }
	    }
	  }, {
	    key: "initDoublePage",
	    value: function initDoublePage() {
	      if (this.isDesktop) {
	        this.setDesktopDoublePage(this._options.replicaReadingModeToggle.desktop, this._options.replicaReadingModeDefault.desktop);
	      } else if (this.isTablet) {
	        this.setMobileDoublePage(this._options.replicaReadingModeToggle.tablet, this._options.replicaReadingModeDefault.tablet);
	      } else {
	        this.setMobileDoublePage(this._options.replicaReadingModeToggle.phone, this._options.replicaReadingModeDefault.phone);
	      }
	    }
	  }, {
	    key: "initDevice",
	    value: function initDevice() {
	      //desktop or touch
	      this.classNames = (0, _utils.getDeviceClasses)();
	      this.classNames.forEach(function (className) {
	        document.body.classList.add(className);
	      });
	      this.isTablet = this.classNames.indexOf("tablet") >= 0;
	      this.isDesktop = !(this.classNames.indexOf("mobile") >= 0);
	
	      this.initDoublePage();
	    }
	  }, {
	    key: "_eventListeners",
	    value: function _eventListeners() {
	      if (!this.isDesktop || !this._options.replicaReadingModeToggle.desktop) {
	        return;
	      }
	      _eventBus2.default.on(_eventBusActions2.default.PUBLICATION_SWITCHED, function (_ref) {
	        var isNextgen = _ref.isNextgen;
	
	        if (isNextgen) {
	          document.body.classList.remove("singlePage");
	        } else {
	          document.body.classList.add("singlePage");
	        }
	      });
	    }
	  }, {
	    key: "_checkNextgenSharingArticle",
	    value: function _checkNextgenSharingArticle() {
	      var regexToMatch = /(?:article|content)\/(.*)/g;
	      var found = window.location.hash.match(regexToMatch);
	      if (found && found[0]) {
	        var parts = found[0].split("/");
	        if (parts && parts.length > 1 && parts[1]) {
	          this.nextgenSharingArticle = parseInt(parts[1], 10);
	        }
	      }
	      return null;
	    }
	  }, {
	    key: "_checkSocialSharing",
	    value: function _checkSocialSharing() {
	      if (this._options.socialSharingHash && window.location.search.indexOf("&" + this._options.socialSharingHash) !== -1) {
	        this.socialSharing = true;
	        window.history.replaceState(null, null, window.location.href.replace("&" + this._options.socialSharingHash, ""));
	      } else if (this._options.socialSharingHash && window.location.search.indexOf(this._options.socialSharingHash + "&") !== -1) {
	        this.socialSharing = true;
	        window.history.replaceState(null, null, window.location.href.replace(this._options.socialSharingHash + "&", ""));
	      } else if (this._options.socialSharingHash && window.location.search.indexOf("" + this._options.socialSharingHash) !== -1) {
	        this.socialSharing = true;
	        window.history.replaceState(null, null, window.location.href.replace("" + this._options.socialSharingHash, ""));
	      }
	    }
	  }, {
	    key: "_inClassNames",
	    value: function _inClassNames(array) {
	      for (var i = 0; i < array.length; i++) {
	        if (this.classNames.indexOf(array[i]) < 0) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }, {
	    key: "_oneInClassNames",
	    value: function _oneInClassNames(array) {
	      for (var i = 0; i < array.length; i++) {
	        if (this._inClassNames(array[i])) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: "initUsePdf",
	    value: function initUsePdf(usePdf) {
	      if (this.isDesktop) {
	        if (usePdf.usePdfDesktopNot && this._oneInClassNames(usePdf.usePdfDesktopNot)) {
	          return;
	        }
	        if (usePdf.usePdfDesktop === true) {
	          this.usePdf = true;
	          return;
	        }
	        if (usePdf.usePdfDesktop && this._oneInClassNames(usePdf.usePdfDesktop)) {
	          this.usePdf = true;
	          return;
	        }
	      } else if (this.isTablet) {
	        if (usePdf.usePdfTabletNot && this._oneInClassNames(usePdf.usePdfTabletNot)) {
	          return;
	        }
	        if (usePdf.usePdfTablet === true) {
	          this.usePdf = true;
	          return;
	        }
	        if (usePdf.usePdfTablet && this._oneInClassNames(usePdf.usePdfTablet)) {
	          this.usePdf = true;
	          return;
	        }
	      } else {
	        if (usePdf.usePdfPhoneNot && this._oneInClassNames(usePdf.usePdfPhoneNot)) {
	          return;
	        }
	        if (usePdf.usePdfPhone === true) {
	          this.usePdf = true;
	          return;
	        }
	        if (usePdf.usePdfPhone && this._oneInClassNames(usePdf.usePdfPhone)) {
	          this.usePdf = true;
	          return;
	        }
	      }
	    }
	  }, {
	    key: "checkHeightChanged",
	    value: function checkHeightChanged() {
	      this.portrait = window.innerWidth < window.innerHeight;
	      if (!this.articleLightBoxDisplayed) {
	        this.trigger("appState:heightChangedALBClosed");
	      }
	    }
	  }, {
	    key: "changeCurrentPage",
	    value: function changeCurrentPage(index) {
	      var doNotTriggerEvents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var _this3 = this;
	
	      var socialSharingAllowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var originIsReader = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      var newIndex = parseInt(index, 10);
	      var promise = new _promise2.default(function (resolve, reject) {
	        if (doNotTriggerEvents) {
	          _this3._currentPage = newIndex;
	          resolve();
	        }
	        if (index === _this3._currentPage) {
	          resolve(true);
	        } else if (_this3.socialSharing && !socialSharingAllowed && _this3.articleLightBoxDisplayed) {
	          _this3.trigger("appState:currentpagechanged", _this3._currentPage, originIsReader);
	          _this3.trigger("appState:pageChangeNotAuthorised");
	          reject(false);
	        } else {
	          _this3.canGoToPage(newIndex).then(function () {
	            _this3._currentPage = newIndex;
	            _this3.trigger("appState:currentpagechanged", newIndex, originIsReader);
	            resolve(true);
	          }).catch(function () {
	            _this3.trigger("appState:pageChangeNotAuthorised");
	            _this3.trigger("appState:currentpagechanged", _this3._currentPage, originIsReader);
	            //TODO show dialog
	            reject(false);
	          });
	        }
	      });
	      return promise;
	    }
	  }, {
	    key: "isNextgenSharing",
	    value: function isNextgenSharing() {
	      return !this.isReplica && this.socialSharing && (this.nextgenSharingArticle !== null || this._options.allowNextgenPageSharing);
	    }
	
	    /**
	     * Check if user may go to that page (authorized, possible, ...)
	     */
	
	  }, {
	    key: "canGoToPage",
	    value: function canGoToPage(index) {
	      var _this4 = this;
	
	      //TODO: authorized?
	      var goToPagePromise = new _promise2.default(function (resolve, reject) {
	        var promiseData = {};
	        promiseData.reject = reject;
	        promiseData.resolve = resolve;
	        var publicationData = {
	          contentPackageId: _this4._contentPackageId,
	          publicationId: _this4._publicationId,
	          pageId: index
	        };
	        _this4._authenticatorAuthorisationController.authorizePage(publicationData).then(function () {
	          promiseData.resolve(true);
	        }).catch(function (error) {
	          promiseData.reject(error);
	        });
	      });
	      return goToPagePromise;
	    }
	  }, {
	    key: "canGoToArticle",
	    value: function canGoToArticle(pageId, contentItemId) {
	      var contentId = this.isNextgenSharing() ? this._contentPackageId + "_" + pageId : contentItemId;
	      if (this._authenticatorAuthorisationController.authorizeArticle(this._contentPackageId, this._publicationId, pageId, contentId)) {
	        return true;
	      } else {
	        this.trigger("appState:authorizeArticleFailed");
	        return false;
	      }
	    }
	  }, {
	    key: "getUserSubscriptionType",
	    value: function getUserSubscriptionType() {
	      if (!this.isLoggedIn) {
	        return "ANONYMOUS";
	      }
	      if (this.userSubscriptionType === "metered") {
	        return this.userSubscriptionType.toUpperCase();
	      }
	      return "SUBSCRIPTION";
	    }
	  }, {
	    key: "isReaderSessionCookieValid",
	    value: function isReaderSessionCookieValid() {
	      var cookie = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.READER_SESSION);
	      if (cookie) {
	        var contentPackageId = JSON.parse(cookie).cpId;
	        if (contentPackageId === this.contentPackageId) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: "saveReaderSessionCookie",
	    value: function saveReaderSessionCookie() {
	      this._readerSessionCookie = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.READER_SESSION);
	    }
	  }, {
	    key: "replaceReaderSessionCookie",
	    value: function replaceReaderSessionCookie() {
	      if (this._readerSessionCookie) {
	        (0, _subscriptionUtilities.resetReaderSession)(_cookiemanager2.default, this._readerSessionCookie);
	      }
	    }
	
	    //getters
	
	  }, {
	    key: "newDownloaderFallbackMode",
	    get: function get() {
	      return this._newDownloaderFallbackMode;
	    },
	    set: function set(newDownloaderFallbackMode) {
	      this._newDownloaderFallbackMode = newDownloaderFallbackMode;
	    }
	  }, {
	    key: "currentPage",
	    get: function get() {
	      return this._currentPage;
	    }
	  }, {
	    key: "totalPages",
	    get: function get() {
	      return this._totalPages;
	    },
	    set: function set(pages) {
	      this._totalPages = pages;
	    }
	  }, {
	    key: "socialSharingReset",
	    get: function get() {
	      return this._socialSharingReset;
	    },
	    set: function set(socialSharingReset) {
	      if (!socialSharingReset) {
	        return;
	      }
	      var lowerCase = socialSharingReset.toLowerCase();
	      if (lowerCase == "session") {
	        this._socialSharingReset = lowerCase;
	      } else if (lowerCase == "contentpackage") {
	        this._socialSharingReset = lowerCase;
	      } else if (lowerCase == "week") {
	        this._socialSharingReset = lowerCase;
	        if (typeof Storage !== "undefined" && this.socialSharingNumberOfArticles > 0 && this.socialSharing) {
	          var now = new Date();
	          var item = JSON.parse(localStorage.getItem("contentItemsWeek"));
	          if (!item || item["year"] < now.getWeekYear() || item["week"] < now.getWeek()) {
	            item = {};
	            item["year"] = now.getWeekYear();
	            item["week"] = now.getWeek();
	            item["items"] = {};
	            localStorage.setItem("contentItemsWeek", (0, _stringify2.default)(item));
	          }
	        }
	      }
	    }
	  }, {
	    key: "authorized",
	    get: function get() {
	      return this._authorized;
	    },
	    set: function set(authorized) {
	      this._authorized = authorized;
	    }
	  }, {
	    key: "contentPackageId",
	    get: function get() {
	      return this._contentPackageId;
	    },
	    set: function set(contentPackageId) {
	      this._contentPackageId = contentPackageId;
	    }
	  }, {
	    key: "publicationId",
	    get: function get() {
	      return this._publicationId;
	    },
	    set: function set(publicationId) {
	      this._publicationId = publicationId;
	      this.trigger("appState:publicationChanged", publicationId);
	    }
	  }, {
	    key: "subscriptionId",
	    get: function get() {
	      var cookie = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.LOGIN);
	      if (cookie) {
	        return JSON.parse(_cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.LOGIN)).subsId;
	      }
	    }
	  }, {
	    key: "username",
	    get: function get() {
	      if (this._username === null) {
	        var cookie = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.LOGIN);
	        if (cookie) {
	          return JSON.parse(_cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.LOGIN)).userName;
	        }
	      } else {
	        return this._username;
	      }
	    }
	  }, {
	    key: "downloadId",
	    get: function get() {
	      var cookie = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.READER_SESSION);
	      if (cookie) {
	        if (JSON.parse(cookie).downloadId) {
	          return JSON.parse(cookie).downloadId;
	        } else {
	          return 0;
	        }
	      } else {
	        return 0;
	      }
	    }
	  }, {
	    key: "orderId",
	    get: function get() {
	      var cookie = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.READER_SESSION);
	      if (cookie) {
	        return JSON.parse(cookie).orderId || 0;
	      } else {
	        return 0;
	      }
	    }
	  }, {
	    key: "articleLightBoxDisplayed",
	    get: function get() {
	      return this._articleLightBoxDisplayed;
	    },
	    set: function set(articleLightBoxDisplayed) {
	      this._articleLightBoxDisplayed = articleLightBoxDisplayed;
	      if (!articleLightBoxDisplayed) {
	        this.albClosed();
	        if (this.lastHeightNoALB !== this.resizer.oldAppHeight) {
	          this.trigger("appState:heightChangedALBClosed");
	        }
	      } else {
	        this.lastHeightNoALB = this.resizer.oldAppHeight;
	      }
	    }
	  }, {
	    key: "timeBasedUnlimitedAccessEnabled",
	    get: function get() {
	      return this._timeBasedUnlimitedAccessEnabled;
	    },
	    set: function set(timeBasedUnlimitedAccessEnabled) {
	      this._timeBasedUnlimitedAccessEnabled = timeBasedUnlimitedAccessEnabled === true;
	    }
	  }, {
	    key: "contentid",
	    set: function set(value) {
	      if (value && this._contentid !== value) {
	        /*
	        The webapp reloads for the second time when the NG is ready to be opened, the articleViewed saved is "contentPackageId_pageId".
	        When the NG is reloaded with a sharing url we need to ensure that the article saved is compared with the correct contentId.
	        */
	        if (this.canGoToArticle(this.currentPage, value)) {
	          this._contentid = value;
	          this.trigger("appState:contentIdChanged");
	        } else {
	          if (!this._contentid) {
	            this._contentid = value;
	          }
	          this.trigger("appState:authorizeArticleFailed");
	        }
	      } else if (!value && this._contentid) {
	        this._contentid = null;
	        this.trigger("appState:contentIdChanged");
	      }
	    },
	    get: function get() {
	      return this._contentid;
	    }
	  }, {
	    key: "isLoggedIn",
	    get: function get() {
	      return this._isLoggedIn;
	    }
	  }, {
	    key: "logedIn",
	    set: function set(login) {
	      this._isLoggedIn = login;
	      this.trigger("appState:authenticationstatuschanged");
	    }
	  }, {
	    key: "downloadToken",
	    get: function get() {
	      return this._downloadToken;
	    },
	    set: function set(downloadToken) {
	      this._downloadToken = downloadToken;
	      this.trigger("appState:downloadtokenchanged");
	    }
	  }, {
	    key: "isIOS",
	    get: function get() {
	      if (this._isIOS == null) {
	        if (document.querySelector("body").classList.contains("iOS")) {
	          this._isIOS = true;
	        } else {
	          this._isIOS = false;
	        }
	      }
	      return this._isIOS;
	    }
	  }, {
	    key: "isAndroid",
	    get: function get() {
	      if (this._isAndroid == null) {
	        if (document.querySelector("body").classList.contains("AndroidOS")) {
	          this._isAndroid = true;
	        } else {
	          this._isAndroid = false;
	        }
	      }
	      return this._isAndroid;
	    }
	  }, {
	    key: "isWindows",
	    get: function get() {
	      if (this._isWindows == null) {
	        if (document.querySelector("body").classList.contains("windows")) {
	          this._isWindows = true;
	        } else {
	          this._isWindows = false;
	        }
	      }
	      return this._isWindows;
	    }
	  }, {
	    key: "preferredViewer",
	    get: function get() {
	      if (!this._preferredViewer) {
	        var cookieValue = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.PREFERRED_VIEWER);
	
	        if (cookieValue) {
	          this._preferredViewer = cookieValue;
	        } else {
	          _cookiemanager2.default.createCookie(_cookiemanager2.default.cookieKeys.PREFERRED_VIEWER, this._options.defaultPreferredViewer);
	          this._preferredViewer = this._options.defaultPreferredViewer;
	        }
	      }
	
	      return this._preferredViewer;
	    },
	    set: function set(preferredViewer) {
	      var previousValue = this._preferredViewer;
	      this._preferredViewer = preferredViewer;
	      _cookiemanager2.default.createCookie(_cookiemanager2.default.cookieKeys.PREFERRED_VIEWER, preferredViewer);
	
	      // only trigger event when preferred viewer really changed value
	      if (previousValue !== undefined && previousValue !== this._preferredViewer) {
	        this.trigger("preferredViewer:changed", this._preferredViewer);
	      }
	    }
	  }, {
	    key: "isDoublePage",
	    get: function get() {
	      if (this.isDesktop) {
	        if (this._options.replicaReadingModeToggle.desktop) {
	          this._isDoublePage = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.DESKTOP_DOUBLEPAGE) === "true";
	        } else {
	          this._isDoublePage = this._options.replicaReadingModeDefault.desktop;
	        }
	      } else if (this.isTablet) {
	        if (this._options.replicaReadingModeToggle.tablet) this._isDoublePage = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.DOUBLEPAGE_LANDSCAPEDISPLAY) === "true";else this._isDoublePage = this._options.replicaReadingModeDefault.tablet;
	      } else {
	        this._isDoublePage = this._options.replicaReadingModeDefault.phone;
	      }
	      return this._isDoublePage;
	    },
	    set: function set(isDoublePage) {
	      if (isDoublePage !== this._isDoublePage) {
	        this._isDoublePage = isDoublePage;
	        if (!this.isDesktop) {
	          _cookiemanager2.default.createCookie(_cookiemanager2.default.cookieKeys.DOUBLEPAGE_LANDSCAPEDISPLAY, this._isDoublePage);
	        } else {
	          _cookiemanager2.default.createCookie(_cookiemanager2.default.cookieKeys.DESKTOP_DOUBLEPAGE, this._isDoublePage);
	        }
	
	        this.trigger("appState:isDoublePageChanged", this._preferredViewer);
	      }
	    }
	  }, {
	    key: "jumpToPageNumber",
	    set: function set(pageNumber) {
	      this._jumpToPageNumber = pageNumber;
	
	      if (pageNumber != null) {
	        this.trigger("appState:jumpToPageChanged", pageNumber);
	      }
	    }
	  }, {
	    key: "jumpToPageReference",
	    set: function set(pageNumber) {
	      var pageRefererNumber = this._jumpToPageReference;
	      this._jumpToPageReference = pageNumber;
	
	      if (pageNumber === null) {
	        this.trigger("appState:backToPageReferer", pageRefererNumber);
	        this._jumpToPageNumber = null;
	      }
	    }
	  }, {
	    key: "isFreePublication",
	    set: function set(isfreePub) {
	      this._isFreePublication = isfreePub;
	    },
	    get: function get() {
	      return this._isFreePublication;
	    }
	  }]);
	  return AppState;
	}(_appStateBase2.default);
	
	exports.default = AppState;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _redirectorKeys = __webpack_require__(23);
	
	var _cookiemanager = __webpack_require__(24);
	
	var _cookiemanager2 = _interopRequireDefault(_cookiemanager);
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DownloadComponent = function (_Emitter) {
	  (0, _inherits3.default)(DownloadComponent, _Emitter);
	
	  function DownloadComponent(authenticatorAuthorisationController, paywall, options, APIManager, appState) {
	    var errorPopup = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	    (0, _classCallCheck3.default)(this, DownloadComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DownloadComponent.__proto__ || (0, _getPrototypeOf2.default)(DownloadComponent)).call(this));
	    // paywallIframeBannerSource    forgotPasswordLink
	
	
	    _this._authenticatorAuthorisationController = null;
	    _this.paywall = null;
	
	    _this.onAuthorizeSucces = function (publicationData) {
	      _this.removeEventListeners();
	      _this.trigger("downloadComponent:succes", publicationData);
	    };
	
	    _this.onClose = function () {
	      _this.removeEventListeners();
	      _this.trigger("downloadComponent:close");
	    };
	
	    _this.onErrorPopupClosed = function () {
	      var publicationData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      _this.removeEventListeners(true);
	      if (err.data && err.data.errorType == "authorization") {
	        if ((0, _utils.isParameterInUrl)(_this.options.showBackButtonParam)) {
	          (0, _utils.sendMessageIfBackButtonEnabled)();
	        } else if (_this.options.homeRedirectionLink) {
	          window.top.location.href = _this.options.homeRedirectionLink;
	        } else {
	          _this.trigger("downloadComponent:close");
	        }
	      } else {
	        _this._authenticatorAuthorisationController.logOut().catch(function () {
	          //if LOGOUT_REDIRECTION failed show paywall
	          _this.APIManager.getUserProfileValue(_redirectorKeys.PAYWALL_REDIRECTION).then(function (result) {
	            if (result && result[0] && result[0].Value && result[0].Value.length > 0) {
	              window.top.location.href = (0, _utils.createRedirectionUrl)(result[0].Value, _this._authenticatorAuthorisationController, _this.options, publicationData);
	            }
	          }).catch(function () {
	            _this.paywall.show(publicationData, false);
	          });
	        });
	      }
	    };
	
	    _this._authenticatorAuthorisationController = authenticatorAuthorisationController;
	    _this.paywall = paywall;
	    _this.errorPopup = errorPopup;
	    _this.options = options;
	    _this.APIManager = APIManager;
	    _this._appState = appState;
	    return _this;
	  }
	
	  (0, _createClass3.default)(DownloadComponent, [{
	    key: "validateDownload",
	    value: function validateDownload(publicationData, confirmdownload) {
	      var _this2 = this;
	
	      var showPaywall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      //TODO: confirmdownload
	      this._authenticatorAuthorisationController.authorize(publicationData, confirmdownload).then(function () {
	        _this2.trigger("downloadComponent:succes", publicationData);
	      }).catch(function (err) {
	        if (showPaywall) {
	          if (err) {
	            //authorization errors are displayed on the error popup
	            if (err.data && err.data.errorType == "authorization") {
	              _this2.errorPopup.show(err);
	              _this2.errorPopup.on("errorPopup:close", function () {
	                _this2.onErrorPopupClosed(publicationData, err);
	              });
	              return;
	            }
	            if (_this2.options.paywallRedirectionUrl) {
	              //for customers with custom paywall always display errors on the error popup
	              _this2.errorPopup.show(err);
	              _this2.errorPopup.on("errorPopup:close", function () {
	                _this2.onErrorPopupClosed(publicationData, err);
	              });
	              return;
	            }
	          }
	          _this2.paywall.showError(err);
	          _this2.paywall.on("paywall:close", _this2.onClose);
	          _this2.paywall.on("paywall:authorizeSucces", _this2.onAuthorizeSucces);
	          if (_this2.options.paywallRedirectionUrl) {
	            var number = _cookiemanager2.default.getNumberOfRedirects();
	            if (number >= _this2.options.paywallRedirectionNumber) {
	              _this2._appState.triggerEvent(_analyticsevents.REACHED_REDIRECT_LIMIT);
	              _this2.paywall.show(publicationData, false);
	            } else {
	              _this2.APIManager.getUserProfileValue(_redirectorKeys.PAYWALL_REDIRECTION).then(function (result) {
	                if (result && result[0] && result[0].Value) {
	                  _cookiemanager2.default.setNumberOfRedirects(number + 1, _this2.options.paywallRedirectionTimeReset);
	
	                  window.top.location.href = (0, _utils.createRedirectionUrl)(result[0].Value, _this2._authenticatorAuthorisationController, _this2.options, publicationData);
	                } else {
	                  _this2.paywall.show(publicationData, false);
	                }
	              }).catch(function () {
	                _this2.paywall.show(publicationData, false);
	              });
	            }
	          } else {
	            _this2.paywall.show(publicationData, false);
	          }
	        } else {
	          _this2.trigger("downloadComponent:fail", publicationData);
	        }
	      });
	    }
	  }, {
	    key: "removeEventListeners",
	    value: function removeEventListeners() {
	      var _this3 = this;
	
	      var isErrorPopupListners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (isErrorPopupListners) {
	        this.errorPopup.off("errorPopup:close", function () {
	          _this3.onErrorPopupClosed();
	        });
	      } else {
	        this.paywall.off("paywall:close", this.onClose);
	        this.paywall.off("paywall:authorizeSucces", this.onAuthorizeSucces);
	      }
	    }
	  }]);
	  return DownloadComponent;
	}(_es6EventEmitter2.default);
	// this class will implement al UI necessary to authenticate users
	// and authorize downloads.
	
	
	exports.default = DownloadComponent;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _imagegalleryslide = __webpack_require__(383);
	
	var _imagegalleryslide2 = _interopRequireDefault(_imagegalleryslide);
	
	var _utils = __webpack_require__(10);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGallerySlide = function (_Emitter) {
	  (0, _inherits3.default)(ImageGallerySlide, _Emitter);
	
	  function ImageGallerySlide(appState, image, options) {
	    (0, _classCallCheck3.default)(this, ImageGallerySlide);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ImageGallerySlide.__proto__ || (0, _getPrototypeOf2.default)(ImageGallerySlide)).call(this));
	
	    _this.appState = null;
	    _this.image = null;
	    _this.options = null;
	    _this.DOMContainer = null;
	    _this.caption = null;
	    _this.onlyFirstLines = null;
	    _this._slideCounter = 0;
	    _this.contentItemId = null;
	
	    _this.appState = appState;
	    _this.image = image;
	    _this.options = options;
	    return _this;
	  }
	
	  (0, _createClass3.default)(ImageGallerySlide, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var resultPromise = new _promise2.default(function (resolve, reject) {
	        var promiseData = {};
	        promiseData.reject = reject;
	        promiseData.resolve = resolve;
	        _this2.DOMContainer = document.createElement("div");
	        _this2.DOMContainer.classList.add("swiper-slide");
	        _this2.DOMContainer.classList.add("swiper-slide-imageviewer");
	        var context = _this2.image;
	        _this2.onlyFirstLines = _this2.options.imageViewerCaptionOnlyFirstLines && !(0, _utils.isHTML)(_this2.image.HtmlText);
	        context.captionOnlyFirstLines = _this2.onlyFirstLines;
	        context.desktop = _this2.appState.isDesktop;
	        _this2._generateImageIdentifier(context);
	        Dust.render(_imagegalleryslide2.default, context, function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	          _this2.caption = _this2.DOMContainer.querySelector(".imageviewer-caption");
	          _this2.attatchClickHandlers();
	          if (_this2.appState.isDesktop && _this2.options.loopSwiper) {
	            _this2._loadImage(context).then(function () {
	              promiseData.resolve(_this2.DOMContainer);
	            });
	          } else {
	            promiseData.resolve(_this2.DOMContainer);
	            _this2._loadImage(context);
	          }
	        });
	      });
	      return resultPromise;
	    }
	  }, {
	    key: "_generateImageIdentifier",
	    value: function _generateImageIdentifier(context) {
	      context.imageIdentifier = "imgSlide_" + this._slideCounter;
	      context.hDImageIdentifier = "hDImgSlide_" + this._slideCounter;
	      this._slideCounter++;
	    }
	  }, {
	    key: "_loadImage",
	    value: function _loadImage(galleryimage) {
	      var _this3 = this;
	
	      this.contentItemId = galleryimage.ContentItemId || galleryimage.Id;
	      var element = this.DOMContainer.querySelector("." + galleryimage.imageIdentifier);
	      if (this.appState.isDesktop) {
	        return this.appState.cdnAssetsDownloader.loadImageOnElement(this.options.sizes.HD, this.contentItemId, element, false, true);
	      } else {
	        element.classList.add("hidden");
	        return this.appState.cdnAssetsDownloader.loadImageOnElement(this.options.sizes.nonHD, this.contentItemId, element, true, false).then(function (ratio) {
	          element.classList.remove("hidden");
	          _this3.initHammerSlide(ratio);
	        });
	      }
	    }
	  }, {
	    key: "renderHd",
	    value: function renderHd() {
	      if (!this.hd) {
	        var hdElement = this.DOMContainer.querySelector(".slide-imageviewer.hd");
	        if (this.appState.isDesktop) {
	          this.appState.cdnAssetsDownloader.loadImageOnElement(this.options.sizes.HD, this.contentItemId, hdElement, false, true);
	        } else {
	          this.appState.cdnAssetsDownloader.loadImageOnElement(this.options.sizes.HD, this.contentItemId, hdElement, false, false);
	        }
	        this.hd = true;
	      }
	    }
	  }, {
	    key: "attatchClickHandlers",
	    value: function attatchClickHandlers() {
	      var _this4 = this;
	
	      if (this.onlyFirstLines && this.caption) {
	        this.caption.addEventListener("click", function (e) {
	          _this4.captionClicked(e);
	        });
	      }
	    }
	  }, {
	    key: "captionClicked",
	    value: function captionClicked(e) {
	      if (this.onlyFirstLines && this.caption) {
	        e.preventDefault();
	        if (this.caption.classList.contains("maxlines")) {
	          this.openCaption();
	        } else {
	          this.closeCaption();
	        }
	      }
	      this.appState.triggerEvent(_analyticsevents.CLICKED_CAPTION_GALLERY);
	    }
	  }, {
	    key: "openCaption",
	    value: function openCaption() {
	      if (this.caption) {
	        this.caption.classList.remove("maxlines");
	        this.caption.classList.add("maxHeight");
	      }
	    }
	  }, {
	    key: "closeCaption",
	    value: function closeCaption() {
	      if (this.caption) {
	        this.caption.classList.remove("maxHeight");
	        this.caption.classList.add("maxlines");
	      }
	    }
	  }]);
	  return ImageGallerySlide;
	}(_es6EventEmitter2.default);
	
	exports.default = ImageGallerySlide;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _settingIframe = __webpack_require__(392);
	
	var _settingIframe2 = _interopRequireDefault(_settingIframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingIFrame = function (_Emitter) {
	  (0, _inherits3.default)(SettingIFrame, _Emitter);
	
	  function SettingIFrame(appState, container, name, title, url) {
	    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	    (0, _classCallCheck3.default)(this, SettingIFrame);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingIFrame.__proto__ || (0, _getPrototypeOf2.default)(SettingIFrame)).call(this));
	
	    _this._appState = null;
	    _this.DOMContainer = null;
	    _this.name = null;
	    _this.title = null;
	    _this.url = null;
	
	    _this._appState = appState;
	    _this.DOMContainer = container;
	    _this.name = name;
	    _this.title = title;
	    _this._options = options;
	    _this.url = url;
	    _this.render();
	    return _this;
	  }
	
	  (0, _createClass3.default)(SettingIFrame, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var context = {};
	      context.back = true;
	      context.close = true;
	
	      context.name = this.name;
	      context.title = this.title;
	
	      //render layout with context
	      if (this.DOMContainer !== null) {
	        Dust.render(_settingIframe2.default, context, function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	
	          _this2.attachClickHandlers();
	
	          _this2.show();
	        });
	      }
	    }
	  }, {
	    key: "attachClickHandlers",
	    value: function attachClickHandlers() {
	      var _this3 = this;
	
	      var backButton = this.DOMContainer.querySelector(".overlay-navigation-back .overlay-navigation-icon");
	      if (backButton) {
	        backButton.addEventListener("click", function (e) {
	          _this3.onBackButtonClick(e);
	        });
	      }
	
	      var closeButton = this.DOMContainer.querySelector(".overlay-navigation-close .overlay-navigation-icon");
	      if (closeButton) {
	        closeButton.addEventListener("click", function (e) {
	          _this3.onCloseButtonClick(e);
	        });
	      }
	    }
	  }, {
	    key: "onBackButtonClick",
	    value: function onBackButtonClick(e) {
	      e.stopPropagation();
	      this.hide();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_BACK_IFRAME);
	    }
	  }, {
	    key: "onCloseButtonClick",
	    value: function onCloseButtonClick(e) {
	      e.stopPropagation();
	      this.close();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_CLOSE_IFRAME);
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      if (this.DOMContainer !== null) {
	        this.DOMContainer.classList.add("hidden");
	      }
	      this.trigger("settingIframe:closed");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (this.DOMContainer !== null) {
	        this.DOMContainer.classList.add("hidden");
	      }
	    }
	  }, {
	    key: "isEmpty",
	    value: function isEmpty() {
	      return this.DOMContainer.innerHTML === "";
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (this.DOMContainer !== null) {
	        var iframe = this.DOMContainer.querySelector("iframe");
	        if (iframe) {
	          iframe.src = this.url;
	        }
	        this.DOMContainer.classList.remove("hidden");
	        this._appState.triggerEvent(_analyticsevents.OPENED_IFRAME_SETTINGS);
	      }
	    }
	  }]);
	  return SettingIFrame;
	}(_es6EventEmitter2.default);
	
	exports.default = SettingIFrame;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _sharing = __webpack_require__(397);
	
	var _sharing2 = _interopRequireDefault(_sharing);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _utils = __webpack_require__(10);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SharingComponent = function () {
	  function SharingComponent(appState, sharingUrls, DOMContainer) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var eventName = arguments[4];
	    (0, _classCallCheck3.default)(this, SharingComponent);
	
	    this.appState = appState;
	    this.sharingUrls = sharingUrls;
	    this.options = options;
	    this.DOMContainer = DOMContainer;
	    this.sharingEventName = eventName;
	    this.body = document.getElementsByTagName("BODY")[0];
	    this.render();
	  }
	
	  (0, _createClass3.default)(SharingComponent, [{
	    key: "close",
	    value: function close(e, force) {
	      if (this.rendered) {
	        var print = this.DOMContainer.querySelector(".sharing-item.print");
	        if (force || !print || print !== e.target && !$.contains(print, e.target)) {
	          this.DOMContainer.classList.add("hidden");
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      if (this.DOMContainer) {
	        var context = {};
	        context.sharing = this.sharingUrls;
	        context.print = this.options.printArticle;
	        context.image = _dictionary2.default.printImage;
	        context.text = _dictionary2.default.printText;
	        context.print = _dictionary2.default.print;
	        Dust.render(_sharing2.default, context, function (err, result) {
	          _this.DOMContainer.innerHTML = result;
	          _this.attatchClickHandlers();
	          _this.rendered = true;
	          _this.appState.triggerEvent(_this.sharingEventName);
	          if (context.print && !context.sharing) {
	            _this.appState.triggerEvent(_analyticsevents.CLICKED_PRINT_ALB);
	          }
	        });
	      }
	    }
	  }, {
	    key: "attatchClickHandlers",
	    value: function attatchClickHandlers() {
	      var _this2 = this;
	
	      var shareItems = this.DOMContainer.querySelectorAll(".sharing-item");
	      shareItems.forEach(function (item) {
	        var share = item.getAttribute("data-share");
	        var id = item.getAttribute("data-id");
	        var url = null;
	        if (_this2.sharingUrls && id) {
	          url = _this2.sharingUrls[parseInt(id, 10)];
	        }
	        item.addEventListener("click", function () {
	          switch (share) {
	            case "Facebook":
	              _this2.appState.triggerEvent(_analyticsevents.CLICKED_FACEBOOK_SHARE);
	              if (url) {
	                window.open(url.url);
	              }
	              break;
	            case "WhatsApp":
	              _this2.appState.triggerEvent(_analyticsevents.CLICKED_WHATSAPP_SHARE);
	              if (url) {
	                window.open(url.url);
	              }
	              break;
	            case "GooglePlus":
	              _this2.appState.triggerEvent(_analyticsevents.CLICKED_GOOGLE_SHARE);
	              if (url) {
	                window.open(url.url);
	              }
	              break;
	            case "Twitter":
	              _this2.appState.triggerEvent(_analyticsevents.CLICKED_TWITTER_SHARE);
	              if (url) {
	                window.open(url.url);
	              }
	              break;
	            case "Mail":
	              _this2.appState.triggerEvent(_analyticsevents.CLICKED_MAIL_SHARE);
	              if (url) {
	                window.location.href = url.url;
	              }
	              break;
	            case "print":
	              _this2.openPrint();
	              break;
	            case "print-image":
	              _this2.printImage();
	              break;
	            case "print-text":
	              _this2.printText();
	              break;
	            default:
	          }
	        });
	      });
	    }
	  }, {
	    key: "openPrint",
	    value: function openPrint() {
	      var printItems = this.DOMContainer.querySelector(".print-items");
	      if (printItems) {
	        printItems.classList.toggle("hidden");
	        this.appState.triggerEvent(_analyticsevents.CLICKED_PRINT_ALB);
	      }
	    }
	  }, {
	    key: "printImage",
	    value: function printImage() {
	      var _this3 = this;
	
	      var click = document.querySelectorAll(".swiper-slide-page-click-container .swiper-slide-page-click[data-contentID=\"" + this.appState.contentid + "\"]");
	      //This will help us create styling specific to text and image printing.
	      if (this.body.classList.contains("textPrinting")) {
	        this.body.classList.remove("textPrinting");
	      }
	      if (!this.body.classList.contains("imagePrinting")) {
	        this.body.classList.add("imagePrinting");
	      }
	      var printing = document.querySelector("#printing");
	      printing.innerHTML = "";
	      var container = document.createElement("div");
	      container.classList.add("canvas-container");
	      printing.appendChild(container);
	      var promises = [];
	      if (click && click.length > 0) {
	        for (var i = 0; i < click.length; i++) {
	          var _appState = this.appState,
	              userId = _appState.userId,
	              sessionId = _appState.sessionId,
	              downloadId = _appState.downloadId;
	
	          var url = (0, _utils.generateSecurePreviewURL)(this.options.printSize, click[i].getAttribute("data-pageid"), sessionId, userId, downloadId);
	          var top = parseFloat(click[i].style.top) / 100;
	          var left = parseFloat(click[i].style.left) / 100;
	          var width = parseFloat(click[i].style.width) / 100;
	          var height = parseFloat(click[i].style.height) / 100;
	          var canvas = document.createElement("canvas");
	          var ctx = canvas.getContext("2d");
	          var img = new Image();
	          container.appendChild(canvas);
	          promises.push(this.loadImage(img, top, left, width, height, canvas, ctx));
	          img.src = url;
	        }
	
	        _promise2.default.all(promises).then(function () {
	          if (typeof window.print === "function") {
	            window.print();
	          }
	        }).finally(function () {
	          _this3.body.classList.remove("imagePrinting");
	        });
	      }
	      this.appState.triggerEvent(_analyticsevents.CLICKED_PRINT_IMAGE_ALB);
	    }
	  }, {
	    key: "loadImage",
	    value: function loadImage(img, top, left, width, height, canvas, ctx) {
	      var _this4 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        img.onload = function () {
	          var margin = _this4.options.printExtraMargin;
	          var marginLeft = _this4.options.printMarginLeft;
	          var w = img.width;
	          var h = img.height;
	          var sx = w * left - marginLeft;
	          var sy = h * top - marginLeft;
	          var sw = w * width + margin * 2;
	          var sh = h * height + margin * 2;
	          canvas.width = sw;
	          canvas.height = sh;
	          var dw = sw;
	          var dh = sh;
	          ctx.drawImage(img, sx, sy, sw, sh, 0, 0, dw, dh);
	          resolve();
	        };
	        img.onerror = function () {
	          reject();
	        };
	      });
	    }
	  }, {
	    key: "printText",
	    value: function printText() {
	      var _this5 = this;
	
	      var printing = document.querySelector("#printing");
	      var slide = document.querySelector(".swiper-slide-active .alb-content-scroll");
	      var container = document.createElement("div");
	      printing.innerHTML = "";
	      if (!this.body.classList.contains("textPrinting")) {
	        this.body.classList.add("textPrinting");
	      }
	      container.classList.add("swiper-container-alb");
	      container.innerHTML = slide.innerHTML;
	      printing.appendChild(container);
	      if (typeof window.print === "function") {
	        setTimeout(function () {
	          window.print();
	          printing.innerHTML = "";
	          _this5.body.classList.remove("textPrinting");
	        }, 250); // To give the image more time to load before the page can be printed
	      }
	      this.appState.triggerEvent(_analyticsevents.CLICKED_PRINT_TEXT_ALB);
	    }
	  }, {
	    key: "printArticleImage",
	    value: function printArticleImage() {}
	  }]);
	  return SharingComponent;
	}();
	
	exports.default = SharingComponent;

/***/ },
/* 94 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var paymentMethods = {
	  FREE: "free",
	  SUBSCRIPTION: "Subscription",
	  TIME_BASED_UNLIMITED_ACCESS: "TimeBasedUnlimitedAccess"
	};
	
	exports.default = paymentMethods;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.injectScript = injectScript;
	exports.injectStyles = injectStyles;
	exports.insertGAScriptTag = insertGAScriptTag;
	exports.insertGTMScriptTag = insertGTMScriptTag;
	exports.injectNoScript = injectNoScript;
	exports.insertCxenseScriptTag = insertCxenseScriptTag;
	exports.getBrowser = getBrowser;
	exports.injectDidomiScript = injectDidomiScript;
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Inserts a script tag
	 * @param  {string} url      script URL
	 * @param  {function} onload callback that is run after script is loaded
	 */
	function injectScript(url, onload) {
	  var appendToBody = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var scriptAttributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	  var async = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	  var scriptEl = document.createElement("script");
	  scriptEl.src = url;
	  scriptEl.type = "text/javascript";
	  scriptEl.async = async;
	  scriptEl.onload = onload;
	
	  if (scriptAttributes) {
	    for (var key in scriptAttributes) {
	      // check if the property/key is defined in the object itself, not in parent
	      if (scriptAttributes.hasOwnProperty(key)) {
	        scriptEl.setAttribute(key, scriptAttributes[key]);
	      }
	    }
	  }
	
	  if (appendToBody) {
	    document.body.appendChild(scriptEl);
	  } else {
	    var el = document.getElementsByTagName("script")[0];
	    el.parentNode.insertBefore(scriptEl, el);
	  }
	}
	
	/**
	 * Injects link to stylesheet file
	 * @param  {string} url stylesheet file URL
	 */
	function injectStyles(url) {
	  var linkEl = document.createElement("link");
	  linkEl.rel = "stylesheet";
	  linkEl.type = "text/css";
	  linkEl.href = url;
	
	  var el = document.querySelectorAll("link[rel=stylesheet]")[0];
	  if (el) {
	    el.parentNode.insertBefore(linkEl, el);
	  } else {
	    document.head.appendChild(linkEl);
	  }
	}
	
	/**
	 * Inserts Google Analytics script tag
	 * @param  {string} gaTag client specific Google Analytics tag (UA-xxxxxxxx-xx)
	 */
	function insertGAScriptTag() {
	  var gaTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _utils.requiredParam)("GA Tag");
	  var isEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  /* eslint-disable */
	  (function (i, s, o, g, r, a, m) {
	    i["GoogleAnalyticsObject"] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, "script", "//www.google-analytics.com/analytics.js", "ga");
	
	  if (isEnabled) {
	    window["ga-disable-" + gaTag] = false;
	  } else {
	    window["ga-disable-" + gaTag] = true;
	  }
	
	  ga("create", gaTag, "auto");
	  /* eslint-enable */
	}
	
	/**
	 * Inserts Google Tag Manager script
	 * @param  {string} gaTag client specific Google Analytics tag (GTM-xxxxxxxx)
	 */
	function insertGTMScriptTag() {
	  var gtmTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _utils.requiredParam)("GTM Tag");
	
	  /* eslint-disable */
	  (function (w, d, s, l, i) {
	    w[l] = w[l] || [];
	    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
	    var f = d.getElementsByTagName(s)[0],
	        j = d.createElement(s),
	        dl = l != "dataLayer" ? "&l=" + l : "";
	    j.async = true;
	    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
	    f.parentNode.insertBefore(j, f);
	  })(window, document, "script", "dataLayer", gtmTag);
	}
	
	/**
	 * Inserts a noscript tag with an iframe in it
	 * @param  {string} url      iframe URL
	 */
	function injectNoScript(url) {
	  var noScriptEl = document.createElement("noscript");
	  var iframe = document.createElement("iframe");
	  iframe.style.display = "none";
	  iframe.style.visibility = "hidden";
	  iframe.src = url;
	  iframe.width = 0;
	  iframe.height = 0;
	  noScriptEl.appendChild(iframe);
	  //element.prepend does not work on IE
	
	  var bodyFirstElement = document.body.firstElementChild;
	  document.body.insertBefore(noScriptEl, bodyFirstElement);
	  //document.body.prepend(noScriptEl);
	}
	
	function insertCxenseScriptTag() {
	  /* eslint-disable */
	  (function (d, s, e, t) {
	    e = d.createElement(s);
	    e.type = "text/java" + s;
	    e.async = "async";
	    e.src = "http" + ("https:" === location.protocol ? "s://s" : "://") + "cdn.cxense.com/cx.js";
	    t = d.getElementsByTagName(s)[0];
	    t.parentNode.insertBefore(e, t);
	  })(document, "script");
	  /* eslint-enable */
	}
	
	var browser = null;
	
	function getBrowser() {
	  if (browser === null) {
	    var ua = navigator.userAgent;
	    var tem = null;
	    var match = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	
	    if (/trident/i.test(match[1])) {
	      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
	      browser = {
	        name: "IE",
	        version: tem[1] || ""
	      };
	    }
	    if (match[1] === "Chrome") {
	      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
	      if (tem != null) {
	        browser = {
	          name: tem[1].replace("OPR", "Opera"),
	          version: tem[2]
	        };
	      }
	    }
	    match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, "-?"];
	    tem = ua.match(/version\/(\d+)/i);
	    if (tem != null) match.splice(1, 1, tem[1]);
	
	    browser = {
	      name: match[0],
	      version: match[1]
	    };
	  }
	
	  return browser;
	}
	
	function injectDidomiScript() {
	  var didomiKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _utils.requiredParam)("Didomi Key");
	
	  window.gdprAppliesGlobally = true;
	  (function () {
	    function a(e) {
	      if (!window.frames[e]) {
	        if (document.body && document.body.firstChild) {
	          var t = document.body;
	          var n = document.createElement("iframe");
	          n.style.display = "none";
	          n.name = e;
	          n.title = e;
	          t.insertBefore(n, t.firstChild);
	        } else {
	          setTimeout(function () {
	            a(e);
	          }, 5);
	        }
	      }
	    }
	    function e(n, r, o, c, s) {
	      function e(e, t, n, a) {
	        if (typeof n !== "function") {
	          return;
	        }
	        if (!window[r]) {
	          window[r] = [];
	        }
	        var i = false;
	        if (s) {
	          i = s(e, t, n);
	        }
	        if (!i) {
	          window[r].push({ command: e, parameter: t, callback: n, version: a });
	        }
	      }
	      e.stub = true;
	      function t(a) {
	        if (!window[n] || window[n].stub !== true) {
	          return;
	        }
	        if (!a.data) {
	          return;
	        }
	        var i = typeof a.data === "string";
	        var e;
	        try {
	          e = i ? JSON.parse(a.data) : a.data;
	        } catch (t) {
	          return;
	        }
	        if (e[o]) {
	          var r = e[o];
	          window[n](r.command, r.parameter, function (e, t) {
	            var n = {};
	            n[c] = { returnValue: e, success: t, callId: r.callId };
	            a.source.postMessage(i ? (0, _stringify2.default)(n) : n, "*");
	          }, r.version);
	        }
	      }
	      if (typeof window[n] !== "function") {
	        window[n] = e;
	        if (window.addEventListener) {
	          window.addEventListener("message", t, false);
	        } else {
	          window.attachEvent("onmessage", t);
	        }
	      }
	    }
	    e("__tcfapi", "__tcfapiBuffer", "__tcfapiCall", "__tcfapiReturn");
	    a("__tcfapiLocator");
	    (function (e) {
	      var t = document.createElement("script");
	      t.id = "spcloader";
	      t.type = "text/javascript";
	      t.async = true;
	      t.src = "https://sdk.privacy-center.org/" + e + "/loader.js?target=" + document.location.hostname;
	      t.charset = "utf-8";
	      var n = document.getElementsByTagName("script")[0];
	      n.parentNode.insertBefore(t, n);
	    })(didomiKey);
	  })();
	}

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	////////// internals
	var _domain = "data";
	function request(url) {
	  return fetch(url).then(function (resp) {
	    return resp.json();
	  });
	}
	
	function _getVersion(version) {
	  var v = version;
	  if (!v) {
	    var rounding = 1000 * 60 * 1; // round by one minute
	    v = Math.round(new Date().getTime() / rounding) * rounding;
	  }
	  return v;
	}
	
	var ContentManager = function () {
	  function ContentManager() {
	    (0, _classCallCheck3.default)(this, ContentManager);
	  }
	
	  (0, _createClass3.default)(ContentManager, null, [{
	    key: "getURL",
	    value: function getURL() {
	      if (false) {
	        if (window.location.pathname.includes("prodreader.html") || window.location.pathname.includes("prod_index.html")) {
	          return "https://" + process.env.TARGET_DOMAIN_PROD + "/data";
	        } else if (process.env.NODE_ENV === "production") {
	          return "../..";
	        } else {
	          return _domain;
	        }
	      } else {
	        if (true) {
	          return "../..";
	        } else {
	          return _domain;
	        }
	      }
	    }
	  }, {
	    key: "getContentPackagePublications",
	    value: function getContentPackagePublications(contentPackageId) {
	      return request(this.domain_url + "/" + contentPackageId + "/data/GetContentPackagePublications-" + contentPackageId + "-V3.json?t=" + new Date().getTime());
	    }
	  }, {
	    key: "getNonExpiredShelfPublications",
	    value: function getNonExpiredShelfPublications(contentPackageId) {
	      return request(this.domain_url + "/" + contentPackageId + "/data/GetNonExpiredShelfPublications.json?t=" + new Date().getTime());
	    }
	  }, {
	    key: "getPublicationTDM",
	    value: function getPublicationTDM(contentPackageId, publicationId) {
	      return request(this.domain_url + "/" + contentPackageId + "/NextGenData/publicationTDM-" + publicationId + ".json");
	    }
	  }, {
	    key: "getPublicationPages",
	    value: function getPublicationPages(contentPackageId, publicationId, version) {
	      return request(this.domain_url + "/" + contentPackageId + "/data/GetPublicationPages-" + publicationId + ".json?t=" + _getVersion(version));
	    }
	  }, {
	    key: "getPublicationPageContent",
	    value: function getPublicationPageContent(contentPackageId, publicationId, version) {
	      return request(this.domain_url + "/" + contentPackageId + "/data/GetPublicationPageContent-" + publicationId + ".json?t=" + _getVersion(version));
	    }
	  }, {
	    key: "getPublicationContentItems",
	    value: function getPublicationContentItems(contentPackageId, publicationId, version) {
	      return request(this.domain_url + "/" + contentPackageId + "/data/GetPublicationContentItems-" + publicationId + ".json?t=" + _getVersion(version));
	    }
	  }, {
	    key: "getPublicationPageContentItems",
	    value: function getPublicationPageContentItems(contentPackageId, publicationId, version) {
	      return request(this.domain_url + "/" + contentPackageId + "/data/GetPublicationPageContentItems-" + publicationId + ".json?t=" + _getVersion(version));
	    }
	  }, {
	    key: "requestJson",
	    value: function requestJson(url) {
	      return fetch(url).then(function (resp) {
	        if (resp.ok) {
	          return resp.json();
	        } else {
	          throw resp.status;
	        }
	      }).catch(function (err) {
	        throw err;
	      });
	    }
	  }]);
	  return ContentManager;
	}();
	
	ContentManager.domain_url = ContentManager.getURL();
	exports.default = ContentManager;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(317), __esModule: true };

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(322), __esModule: true };

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(325), __esModule: true };

/***/ },
/* 100 */,
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(14).document;
	module.exports = document && document.documentElement;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(21) && !__webpack_require__(28)(function () {
	  return Object.defineProperty(__webpack_require__(63)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(33);
	var ITERATOR = __webpack_require__(17)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(35);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(20);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(36);
	var $export = __webpack_require__(16);
	var redefine = __webpack_require__(72);
	var hide = __webpack_require__(27);
	var Iterators = __webpack_require__(33);
	var $iterCreate = __webpack_require__(340);
	var setToStringTag = __webpack_require__(39);
	var getPrototypeOf = __webpack_require__(110);
	var ITERATOR = __webpack_require__(17)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(17)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(21);
	var getKeys = __webpack_require__(37);
	var gOPS = __webpack_require__(69);
	var pIE = __webpack_require__(46);
	var toObject = __webpack_require__(30);
	var IObject = __webpack_require__(65);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(28)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(111);
	var hiddenKeys = __webpack_require__(64).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(26);
	var toObject = __webpack_require__(30);
	var IE_PROTO = __webpack_require__(73)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(26);
	var toIObject = __webpack_require__(29);
	var arrayIndexOf = __webpack_require__(332)(false);
	var IE_PROTO = __webpack_require__(73)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 112 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(18);
	var newPromiseCapability = __webpack_require__(66);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(20);
	var aFunction = __webpack_require__(34);
	var SPECIES = __webpack_require__(17)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(25);
	var invoke = __webpack_require__(339);
	var html = __webpack_require__(101);
	var cel = __webpack_require__(63);
	var global = __webpack_require__(14);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(35)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 116 */,
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("enrichmentButton",body_0);function body_0(chk,ctx){return chk.w("<div class=\"enrichment-button pointer\"><div class=\"enrichment-type-container\" ><div class=\"enrichment-type\" data-type=").f(ctx.get(["type"], false),ctx,"h").w("></div></div><div class=\"enrichment-number-container\"><div class=\"enrichment-number\">").f(ctx.get(["number"], false),ctx,"h").w("</div></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'enrichmentButton';

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("topNavigationOverlay",body_0);function body_0(chk,ctx){return chk.w("<div class=\"overlay-navigation\">").x(ctx.get(["back"], false),ctx,{"block":body_1},{}).w("<div class=\"overlay-navigation-title\">").f(ctx.get(["title"], false),ctx,"h").w("</div>").x(ctx.get(["close"], false),ctx,{"block":body_2},{}).w("</div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"overlay-navigation-back overlay-navigation-outeritem\"><div class=\"overlay-navigation-icon pointer\"></div></div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"overlay-navigation-close  overlay-navigation-outeritem\"><div class=\"overlay-navigation-icon pointer\"></div></div>");}body_2.__dustBody=!0;return body_0}(dust));
	module.exports = 'topNavigationOverlay';

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ },
/* 120 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var stripPrefix = exports.stripPrefix = function stripPrefix(path, prefix) {
	  return path.indexOf(prefix) === 0 ? path.substr(prefix.length) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname;
	  var search = location.search;
	  var hash = location.hash;
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 121 */,
/* 122 */
/***/ function(module, exports) {

	module.exports = {
		"client": "mhu-ds",
		"client_fullname": "Mediahuis - De Standaard",
		"version": "1.0.0.0",
		"production_url": "mhu-ds-webreader-production.twipemobile.com",
		"uat_url": "mhu-ds-webreader-uat.twipemobile.com",
		"production_api": "mhu-ds-production-backend-api.twipecloud.net",
		"uat_api": "mhu-ds-uat-backend-api.twipecloud.net",
		"html_title": "Mediahuis - De Standaard",
		"nextgen": true,
		"replica": true
	};

/***/ },
/* 123 */,
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    ordinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    ordinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    ordinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[I dag kl.] LT',
	        nextDay : '[I morgen kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[I går kl.] LT',
	        lastWeek : '[sidste] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    ordinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	    weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-an de] MMMM, YYYY',
	        LLL : 'D[-an de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'je %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    ordinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چندین ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    ordinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : '');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    ordinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'Ah時m分',
	        LTS : 'Ah時m分s秒',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah時m分',
	        LLLL : 'YYYY年M月D日Ah時m分 dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    ordinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის წინ');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის წინ');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h시 m분',
	        LTS : 'A h시 m분 s초',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h시 m분',
	        LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '일분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    ordinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    ordinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    ordinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    ordinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    ordinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    },
	    nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    ordinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah点mm分',
	        LTS : 'Ah点m分s秒',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah点mm分',
	        llll : 'YYYY年MMMD日ddddAh点mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : function () {
	            return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	        },
	        nextDay : function () {
	            return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	        },
	        lastDay : function () {
	            return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	        },
	        nextWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        lastWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        sameElse : 'LL'
	    },
	    ordinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _preferredViewerSwitcher = __webpack_require__(386);
	
	var _preferredViewerSwitcher2 = _interopRequireDefault(_preferredViewerSwitcher);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PreferredViewerSwitcher = function (_Emitter) {
	  (0, _inherits3.default)(PreferredViewerSwitcher, _Emitter);
	
	  function PreferredViewerSwitcher(appState, DOMContainer) {
	    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "segmentButton";
	    var options = arguments[3];
	    (0, _classCallCheck3.default)(this, PreferredViewerSwitcher);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PreferredViewerSwitcher.__proto__ || (0, _getPrototypeOf2.default)(PreferredViewerSwitcher)).call(this));
	
	    _this._appState = appState;
	    _this._DOMContainer = DOMContainer;
	    _this.type = type;
	    _this._options = options;
	    return _this;
	  }
	
	  (0, _createClass3.default)(PreferredViewerSwitcher, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var context = {
	        i18n: _dictionary2.default,
	        preferredViewer: this._appState.preferredViewer,
	        type: this.type,
	        useCustomToolTip: this._options ? this._options.useCustomTooltips : false,
	        displayTopNavButtonlabel: this._options ? this._options.displayTopNavButtonlabel : false
	      };
	
	      if (this._options && this._options.displayTopNavButtonlabel) {
	        this._DOMContainer.classList.add("labelDisplayed");
	      }
	
	      Dust.render(_preferredViewerSwitcher2.default, context, function (err, result) {
	        _this2._DOMContainer.innerHTML = result;
	        _this2._attachListeners();
	      });
	    }
	
	    ///////////////
	
	  }, {
	    key: "_attachListeners",
	    value: function _attachListeners() {
	      this.viewerSwitcherEl = document.getElementById("viewer-switcher");
	
	      if (this.viewerSwitcherEl) {
	        this.viewerSwitcherEl.addEventListener("click", this._viewerSelectorClickHandler.bind(this));
	      }
	
	      this._appState.on("preferredViewer:changed", this._onPreferredViewerChanged.bind(this));
	    }
	  }, {
	    key: "_viewerSelectorClickHandler",
	    value: function _viewerSelectorClickHandler(e) {
	      if (this._options && this._options.displayTopNavButtonlabel) {
	        this.trigger("readingModeSwitcher:clicked", e.target.parentNode.value);
	        this._appState.preferredViewer = e.target.parentNode.value;
	      } else {
	        this.trigger("readingModeSwitcher:clicked", e.target.value);
	        this._appState.preferredViewer = e.target.value;
	      }
	
	      [].forEach.call(this.viewerSwitcherEl.children, function (node) {
	        node.classList.remove("active");
	      });
	      if (this._options && this._options.displayTopNavButtonlabel) {
	        e.target.parentNode.classList.add("active");
	      } else {
	        e.target.classList.add("active");
	      }
	    }
	  }, {
	    key: "_onPreferredViewerChanged",
	    value: function _onPreferredViewerChanged(type) {
	      [].forEach.call(this.viewerSwitcherEl.children, function (node) {
	        node.classList.remove("active");
	      });
	
	      this.viewerSwitcherEl.querySelector("[value=" + type + "]").classList.add("active");
	    }
	  }]);
	  return PreferredViewerSwitcher;
	}(_es6EventEmitter2.default);
	
	exports.default = PreferredViewerSwitcher;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _setting = __webpack_require__(389);
	
	var _setting2 = _interopRequireDefault(_setting);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _cookiemanager = __webpack_require__(24);
	
	var _cookiemanager2 = _interopRequireDefault(_cookiemanager);
	
	var _redirectorKeys = __webpack_require__(23);
	
	var _utils = __webpack_require__(10);
	
	var _settingAbout = __webpack_require__(276);
	
	var _settingAbout2 = _interopRequireDefault(_settingAbout);
	
	var _settingaccount = __webpack_require__(280);
	
	var _settingaccount2 = _interopRequireDefault(_settingaccount);
	
	var _settingIFrame = __webpack_require__(92);
	
	var _settingIFrame2 = _interopRequireDefault(_settingIFrame);
	
	var _settingLandscapeToggle = __webpack_require__(277);
	
	var _settingLandscapeToggle2 = _interopRequireDefault(_settingLandscapeToggle);
	
	var _settingPreferredViewer = __webpack_require__(278);
	
	var _settingPreferredViewer2 = _interopRequireDefault(_settingPreferredViewer);
	
	var _settingRegion = __webpack_require__(279);
	
	var _settingRegion2 = _interopRequireDefault(_settingRegion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Setting = function (_Emitter) {
	  (0, _inherits3.default)(Setting, _Emitter);
	
	  // state when settings opened
	  function Setting(appState, regionManager, sessionManager, paywall, options) {
	    (0, _classCallCheck3.default)(this, Setting);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Setting.__proto__ || (0, _getPrototypeOf2.default)(Setting)).call(this));
	
	    _this.regionManager = null;
	    _this.sessionManager = null;
	    _this.options = null;
	    _this.disabledScrolling = [];
	    _this.lastRegion = null;
	    _this.lastLoginChanged = false;
	
	    _this.onKeyUpHandler = function (e) {
	      if (e.which === 27) _this.close();
	    };
	
	    _this.onCMPSettingClick = function (e) {
	      e.stopPropagation();
	      _this._appState.analyticsManager.cmpManager.showPreference();
	    };
	
	    _this.onPolicySettingClick = function (e) {
	      e.stopPropagation();
	      if (_this._appState.isDesktop || _this.options.openPrivacyOnNewtab) {
	        _this._openInNewtab(_this.policyurl);
	        return;
	      }
	      if (_this.policy && !_this.policy.isEmpty()) {
	        _this.policy.show();
	      } else {
	        _this.policy = new _settingIFrame2.default(_this._appState, _this.DOMContainer.querySelector("#sidemenu-policy-container"), "policy", _dictionary2.default.dataPolicy, _this.policyurl, _this.options);
	        _this.policy.on("settingIframe:closed", function () {
	          _this.close();
	        });
	      }
	    };
	
	    _this.onPrivacyPolicySettingClick = function (e) {
	      e.stopPropagation();
	      if (_this._appState.isDesktop || _this.options.openPrivacyOnNewtab) {
	        _this._openInNewtab(_this.privacyPolicyUrl);
	      } else if (_this.privacyPolicy && !_this.privacyPolicy.isEmpty()) {
	        _this.privacyPolicy.show();
	      } else {
	        _this.privacyPolicy = new _settingIFrame2.default(_this._appState, _this.DOMContainer.querySelector("#sidemenu-privacypolicy-container"), "policy", _dictionary2.default.privacyPolicy, _this.privacyPolicyUrl, _this.options);
	        _this.privacyPolicy.on("settingIframe:closed", function () {
	          _this.close();
	        });
	      }
	    };
	
	    _this.updateSettingLandscapeToggle = function () {
	      var landscapeSettingValue = document.querySelector("#landscape-toggle-extra");
	      if (landscapeSettingValue) {
	        landscapeSettingValue.innerHTML = _this._appState.isDoublePage ? _dictionary2.default.doublePageShort : _dictionary2.default.singlePageShort;
	      }
	    };
	
	    _this._appState = appState;
	    _this.paywall = paywall;
	    _this.regionManager = regionManager;
	    _this.sessionManager = sessionManager;
	    _this.options = options;
	    _this.render();
	    /*To avoid the browser to block window.open if it is not called in direct response to a user action*/
	    _this.fetchSettingsUrls();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Setting, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var context = {};
	      context.i18n = _dictionary2.default;
	      context.close = true;
	      context.settings = _dictionary2.default.settings;
	      context.region = _dictionary2.default.region;
	      context.username = this._appState.username;
	      context.showCMP = this._appState.analyticsManager.cmpManager ? this._appState.analyticsManager.cmpManager._options.hasPreferenceView : false;
	      context.settingclass = this._appState.analyticsManager.cmpManager && this._appState.analyticsManager.cmpManager._options.settingClass ? this._appState.analyticsManager.cmpManager._options.settingClass : "";
	      if (this.options.subscriptionOptions.subscriptionType !== "free") {
	        context.showAccount = true;
	        context.account = _dictionary2.default.account;
	        if (this._appState.isLoggedIn) {
	          context.isLoggedIn = this._appState.username || _dictionary2.default.accountLoggedIn;
	        } else {
	          context.isLoggedIn = _dictionary2.default.accountLoggedOut;
	          context.extraLogoutButtonClass = "hidden";
	          context.isLoggedOut = true;
	        }
	      }
	      context.help = _dictionary2.default.help;
	      context.about = _dictionary2.default.about;
	      context.SignOut = _dictionary2.default.SignOut;
	      var currentRegion = this.regionManager.getCurrentRegion();
	      if (currentRegion) {
	        context.currentRegion = currentRegion.Description;
	      }
	      context.displayViewerOptions = this.options.displayViewerOptions;
	      context.preferredViewerLabel = this.getPreferredViewerLabel(this._appState.preferredViewer);
	      context.isDesktop = this._appState.isDesktop;
	
	      if (this._appState.isDesktop) {
	        context.displayLandscapeToggle = this.options.replicaReadingModeToggle.desktop;
	      } else {
	        context.displayLandscapeToggle = this._appState.isTablet ? this.options.replicaReadingModeToggle.tablet : this.options.replicaReadingModeToggle.phone;
	      }
	      context.landscapeToggleLabel = this.getLandscapeToggleLabel(this._appState.isDoublePage);
	      context.showLogoutButton = this._appState.isDesktop && this.options.toggleSubscriptionTopNavButtonOnUserLoggedIn ? true : false;
	      context.showPrivacyPolicy = this.options.showPrivacyPolicy;
	
	      //render layout with context
	      this.DOMContainer = document.querySelector("#settings");
	      if (this.DOMContainer !== null) {
	        Dust.render(_setting2.default, context, function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	          _this2.attachEventHandlers();
	        });
	      }
	    }
	  }, {
	    key: "fetchSettingsUrls",
	    value: function fetchSettingsUrls() {
	      var _this3 = this;
	
	      _apimanager2.default.getRedirectorUrl(_redirectorKeys.HELP, this._appState.buildVersion, this._appState.userId, this._appState.downloadToken).then(function (result) {
	        _this3.helpurl = result;
	      }).catch(function () {});
	
	      if (this._appState.analyticsManager.cmpManager && this._appState.analyticsManager.cmpManager._options.hasPreferenceView) {
	        _apimanager2.default.getRedirectorUrl(_redirectorKeys.DATAPOLICY, this._appState.buildVersion, this._appState.userId, this._appState.downloadToken).then(function (result) {
	          _this3.policyurl = result;
	        }).catch(function () {});
	      }
	
	      if (this.options.showPrivacyPolicy) {
	        _apimanager2.default.getRedirectorUrl(_redirectorKeys.PRIVACYPOLICY, this._appState.buildVersion, this._appState.userId, this._appState.downloadToken).then(function (result) {
	          _this3.privacyPolicyUrl = result;
	        }).catch(function () {});
	      }
	    }
	  }, {
	    key: "attachEventHandlers",
	    value: function attachEventHandlers() {
	      var _this4 = this;
	
	      var closeButton = this.DOMContainer.querySelector(".overlay-navigation-close .overlay-navigation-icon");
	      if (closeButton) {
	        closeButton.addEventListener("click", function (e) {
	          _this4.onCloseButtonClick(e);
	        });
	      }
	
	      var region = this.DOMContainer.querySelector(".settings-region");
	      if (region) {
	        region.addEventListener("click", function (e) {
	          _this4.onRegionClick(e);
	        });
	      }
	
	      var login = this.DOMContainer.querySelector(".settings-login");
	      if (login) {
	        login.addEventListener("click", function (e) {
	          _this4.onLoginClick(e);
	        });
	      }
	
	      if (this._appState.isDesktop) {
	        var logOut = this.DOMContainer.querySelector(".settings-signOut");
	        if (logOut) {
	          logOut.addEventListener("click", function (e) {
	            _this4.onLogoutClick(e);
	          });
	        }
	      }
	
	      var help = this.DOMContainer.querySelector(".settings-help");
	      if (help) {
	        help.addEventListener("click", function () {
	          _this4.onHelpClick(false);
	        });
	      }
	
	      var about = this.DOMContainer.querySelector(".settings-about");
	      if (about) {
	        about.addEventListener("click", function (e) {
	          _this4.onAboutClick(e);
	        });
	      }
	
	      var preferredViewer = this.DOMContainer.querySelector(".settings-preferred-viewer");
	      if (preferredViewer) {
	        preferredViewer.addEventListener("click", this.onPrefferedViewerClick.bind(this));
	      }
	
	      var landscapeToggle = this.DOMContainer.querySelector(".settings-landscape-toggle");
	      if (landscapeToggle) {
	        landscapeToggle.addEventListener("click", this.onLandscapeToggleClick.bind(this));
	      }
	
	      var cmpSetting = this.DOMContainer.querySelector(".settings-cmp");
	      if (cmpSetting && !this._appState.analyticsManager.cmpManager._options.settingClass) {
	        cmpSetting.addEventListener("click", this.onCMPSettingClick.bind(this));
	      }
	
	      var policySetting = this.DOMContainer.querySelector(".settings-policy");
	      if (policySetting) {
	        policySetting.addEventListener("click", function (e) {
	          _this4.onPolicySettingClick(e);
	        });
	      }
	
	      var privacyPolicySetting = this.DOMContainer.querySelector(".settings-privacypolicy");
	      if (privacyPolicySetting) {
	        privacyPolicySetting.addEventListener("click", function (e) {
	          _this4.onPrivacyPolicySettingClick(e);
	        });
	      }
	
	      if (this._appState.isDesktop) {
	        this._appState.on("appState:isDoublePageChanged", this.updateSettingLandscapeToggle);
	      }
	
	      document.addEventListener("keyup", this.onKeyUpHandler);
	
	      this.initListeners();
	    }
	  }, {
	    key: "initListeners",
	    value: function initListeners() {
	      var _this5 = this;
	
	      this._appState.on("appState:authenticationstatuschanged", function () {
	        _this5.onAuthenticationStatusChanged();
	      });
	      this.regionManager.on("regionManager:regionChanged", function () {
	        _this5.onRegionChanged();
	      });
	      this._appState.on("preferredViewer:changed", this.preferredViewerChanged.bind(this));
	    }
	  }, {
	    key: "onAuthenticationStatusChanged",
	    value: function onAuthenticationStatusChanged() {
	      var login = this.DOMContainer.querySelector(".settings-login-extra");
	      var logout = this.DOMContainer.querySelector(".settings-signOut");
	      if (login) {
	        login.innerHTML = this._appState.isLoggedIn ? this._appState.username || _dictionary2.default.accountLoggedIn : _dictionary2.default.accountLoggedOut;
	      }
	      this.lastLoginChanged = true;
	      if (logout) {
	        if (this._appState.isLoggedIn) {
	          logout.classList.remove("hidden");
	        } else {
	          logout.classList.add("hidden");
	        }
	      }
	    }
	  }, {
	    key: "onCloseButtonClick",
	    value: function onCloseButtonClick(e) {
	      e.stopPropagation();
	      this.close();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_CLOSE_SETTINGS);
	    }
	  }, {
	    key: "onRegionClick",
	    value: function onRegionClick() {
	      var _this6 = this;
	
	      this.region = new _settingRegion2.default(this._appState, this.regionManager, this.options);
	      this.region.on("settingRegion:regionChanged", function () {
	        _this6.onRegionChanged();
	      });
	      this.region.on("settingRegion:closed", function () {
	        _this6.close();
	      });
	      this._appState.triggerEvent(_analyticsevents.CLICKED_REGIONSELECT_SETTINGS);
	    }
	  }, {
	    key: "onRegionChanged",
	    value: function onRegionChanged() {
	      var currentRegion = this.regionManager.getCurrentRegion();
	      var region = this.DOMContainer.querySelector(".settings-region-extra");
	      if (currentRegion && region) {
	        region.innerHTML = currentRegion.Description;
	      }
	    }
	  }, {
	    key: "preferredViewerChanged",
	    value: function preferredViewerChanged(type) {
	      var label = this.getPreferredViewerLabel(type);
	      document.getElementById("preferred-viewer-extra").textContent = label;
	    }
	  }, {
	    key: "onLoginClick",
	    value: function onLoginClick() {
	      var _this7 = this;
	
	      if (!this._appState.isLoggedIn && this.options.paywallRedirectionUrl) {
	        var number = _cookiemanager2.default.getNumberOfRedirects();
	        if (number >= this.options.paywallRedirectionNumber) {
	          this._appState.triggerEvent(_analyticsevents.REACHED_REDIRECT_LIMIT);
	          this.account = new _settingaccount2.default(this._appState, this.paywall, this.options);
	          this.account.on("settingAccount:closed", function () {
	            _this7.close();
	          });
	        } else {
	          _apimanager2.default.getUserProfileValue(_redirectorKeys.PAYWALL_REDIRECTION).then(function (result) {
	            if (result && result[0] && result[0].Value && result[0].Value.length > 0) {
	              _cookiemanager2.default.setNumberOfRedirects(number + 1, _this7.options.paywallRedirectionTimeReset);
	              window.top.location.href = (0, _utils.createRedirectionUrl)(result[0].Value, _this7.paywall.authenticatorAuthorisationController, _this7.options);
	            } else {
	              _this7.account.on("settingAccount:closed", function () {
	                _this7.close();
	              });
	            }
	          }).catch(function () {
	            _this7.account = new _settingaccount2.default(_this7._appState, _this7.paywall, _this7.options);
	            _this7.account.on("settingAccount:closed", function () {
	              _this7.close();
	            });
	          });
	        }
	      } else {
	        this.account = new _settingaccount2.default(this._appState, this.paywall, this.options);
	        this.account.on("settingAccount:closed", function () {
	          _this7.close();
	        });
	      }
	      this._appState.triggerEvent(_analyticsevents.CLICKED_ACCOUNT_SETTINGS);
	    }
	  }, {
	    key: "onLogoutClick",
	    value: function onLogoutClick() {
	      this.account = new _settingaccount2.default(this._appState, this.paywall, this.options);
	      this.account.onLogoutClick();
	    }
	  }, {
	    key: "onHelpClick",
	    value: function onHelpClick() {
	      var _this8 = this;
	
	      var isTopNavHelpButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!isTopNavHelpButton) {
	        this._appState.triggerEvent(_analyticsevents.CLICKED_HELP_SETTINGS);
	      }
	      if (this._appState.isDesktop || this.options.openHelpOnNewtab) {
	        this._openInNewtab(this.helpurl);
	        return;
	      }
	      if (this.help && !this.help.isEmpty()) {
	        this.help.show();
	      } else {
	        this.help = new _settingIFrame2.default(this._appState, this.DOMContainer.querySelector("#sidemenu-help-container"), "help", _dictionary2.default.help, this.helpurl, this.options);
	        this.help.on("settingIframe:closed", function () {
	          _this8.close();
	        });
	      }
	    }
	  }, {
	    key: "onAboutClick",
	    value: function onAboutClick() {
	      var _this9 = this;
	
	      if (this.about) {
	        this.about.show();
	      } else {
	        this.about = new _settingAbout2.default(this._appState, this.sessionManager, this.options.about);
	        this.about.on("settingAbout:closed", function () {
	          _this9.close();
	        });
	      }
	      this._appState.triggerEvent(_analyticsevents.CLICKED_ABOUT_SETTINGS);
	    }
	  }, {
	    key: "onLandscapeToggleClick",
	    value: function onLandscapeToggleClick() {
	      var _this10 = this;
	
	      var preferredViewerSetting = new _settingLandscapeToggle2.default(this._appState);
	      preferredViewerSetting.on("settingLandscapeToggle:closed", this.close.bind(this));
	      preferredViewerSetting.on("settingLandscapeToggle:changed", function (chosenOption) {
	        var landscapeSettingValue = _this10.DOMContainer.querySelector("#landscape-toggle-extra");
	        if (landscapeSettingValue) {
	          if (chosenOption === "doublePage") {
	            landscapeSettingValue.innerHTML = _dictionary2.default.doublePageShort;
	          } else {
	            landscapeSettingValue.innerHTML = _dictionary2.default.singlePageShort;
	          }
	        }
	      });
	      preferredViewerSetting.render();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_LANDSCAPE_TOGGLE_SETTINGS);
	    }
	  }, {
	    key: "onPrefferedViewerClick",
	    value: function onPrefferedViewerClick() {
	      var preferredViewerSetting = new _settingPreferredViewer2.default(this._appState);
	      preferredViewerSetting.on("settingPreferredViewer:closed", this.close.bind(this));
	      preferredViewerSetting.render();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_READING_MODE_SETTINGS);
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (this.DOMContainer !== null) {
	        this.DOMContainer.classList.add("hidden");
	      }
	    }
	  }, {
	    key: "onSubscriptionButtonClick",
	    value: function onSubscriptionButtonClick(e) {
	      e.stopPropagation();
	      this.subscription.show();
	      this.trigger("setting:onReadingPreferenceButtonClick", e);
	    }
	  }, {
	    key: "onReadingPreferenceButtonClick",
	    value: function onReadingPreferenceButtonClick(e) {
	      e.stopPropagation();
	      this.readingPreference.show();
	      this.trigger("setting:onSubscriptionButtonClick", e);
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (this.DOMContainer !== null) {
	        this.DOMContainer.classList.remove("hidden");
	      }
	    }
	  }, {
	    key: "open",
	    value: function open() {
	      this.show();
	      //keep state
	      this.lastRegion = this._appState.downloadToken;
	      this.lastLoginChanged = false;
	      var region = this.DOMContainer.querySelector(".settings-region");
	      if (region) {
	        if (this.regionManager.singleRegion) {
	          region.classList.add("hidden");
	        } else {
	          region.classList.remove("hidden");
	        }
	      }
	      this.disabledScrolling = (0, _utils.disableAllScrolling)();
	      this._appState.triggerEvent(_analyticsevents.OPENED_SETTINGS);
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.hide();
	      (0, _utils.enableAllScrolling)(this.disabledScrolling);
	      if (this.lastRegion !== this._appState.downloadToken) {
	        this.trigger("setting:onRegionChanged");
	      }
	      if (this.lastLoginChanged) {
	        this.trigger("setting:onLoginChanged");
	      }
	    }
	  }, {
	    key: "getPreferredViewerLabel",
	    value: function getPreferredViewerLabel(type) {
	      return type === "nextgen" ? _dictionary2.default.DigitalVersion : _dictionary2.default.PaperVersion;
	    }
	  }, {
	    key: "getLandscapeToggleLabel",
	    value: function getLandscapeToggleLabel(isDoublePage) {
	      return isDoublePage ? _dictionary2.default.doublePageShort : _dictionary2.default.singlePageShort;
	    }
	  }, {
	    key: "_openInNewtab",
	    value: function _openInNewtab(url) {
	      var newWindow = window.open(url, "_blank");
	      newWindow.focus();
	    }
	  }]);
	  return Setting;
	}(_es6EventEmitter2.default);
	
	exports.default = Setting;

/***/ },
/* 235 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PAGE_POSITION_TYPE = exports.PAGE_POSITION_TYPE = {
	  FRONT: "Front",
	  BACK: "Back",
	  LEFT: "Left",
	  RIGHT: "Right"
	};

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentPackageStore = function (_Emitter) {
	  (0, _inherits3.default)(ContentPackageStore, _Emitter);
	
	  function ContentPackageStore(apiManager, locale, imageSizes, dateFormat, options) {
	    (0, _classCallCheck3.default)(this, ContentPackageStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ContentPackageStore.__proto__ || (0, _getPrototypeOf2.default)(ContentPackageStore)).call(this));
	
	    _this.contentPackagesJson = null;
	    _this._apiManager = null;
	    _this._locale = "";
	    _this._imageSizes = null;
	    _this._dateFormat = null;
	    _this._options = null;
	
	    if (!locale) {
	      throw "locale not defined";
	    }
	    _this._apiManager = apiManager;
	    _this._locale = locale;
	    _this._imageSizes = imageSizes;
	    _this._dateFormat = dateFormat;
	    _this._options = options;
	    return _this;
	  }
	
	  (0, _createClass3.default)(ContentPackageStore, [{
	    key: "getAllContentPackages",
	    value: function getAllContentPackages() {
	      return this.contentPackagesJson;
	    }
	  }, {
	    key: "loadContentPackages",
	    value: function loadContentPackages(downloadToken, numberToRetrieve) {
	      var _this2 = this;
	
	      var domain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var token = downloadToken;
	      if (this._options.downloadToken && this._options.downloadToken !== "") {
	        token = this._options.downloadToken;
	      }
	
	      this._apiManager.getContentPackageList(token, numberToRetrieve).then(function (json) {
	        _this2.contentPackagesJson = json;
	        for (var i = 0; i < _this2.contentPackagesJson.length; i++) {
	          var pub = _this2.contentPackagesJson[i];
	          _this2.contentPackagesJson[i] = _this2.normalizePubForSwiper(pub, domain);
	        }
	        _this2.trigger("contentPackages:loaded");
	      });
	    }
	  }, {
	    key: "beautifyDate",
	    value: function beautifyDate(uglyDate) {
	      return (0, _utils.labelToDate)(uglyDate, this._locale, this._dateFormat);
	    }
	  }, {
	    key: "normalizePubForSwiper",
	    value: function normalizePubForSwiper(pub) {
	      var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var result = pub;
	      if (this._options.useNameAsLabel) {
	        result.label = pub.ContentPackageName;
	      } else {
	        result.label = this.beautifyDate(pub.PublicationDate);
	      }
	      result.imageUrl = (0, _utils.generateCoverURL)(pub.ContentPackageId, this._imageSizes.S, pub.ThumbnailId, pub.Version, domain);
	      return result;
	    }
	
	    /**
	     * Returns content package price based on content package id
	     * @param  {Integer} cpId content package id
	     * @return {Float}        contant package price
	     */
	
	  }, {
	    key: "getContentPackagePrice",
	    value: function getContentPackagePrice(cpId) {
	      var contentPackage = this.contentPackagesJson.find(function (cp) {
	        return cp.ContentPackageId == cpId; // eslint-disable-line
	      });
	
	      if (contentPackage) {
	        return contentPackage.StoreProducts[0].Price;
	      }
	    }
	  }]);
	  return ContentPackageStore;
	}(_es6EventEmitter2.default);
	
	exports.default = ContentPackageStore;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HorsseriesStore = function (_Emitter) {
	  (0, _inherits3.default)(HorsseriesStore, _Emitter);
	
	  function HorsseriesStore(apiManager, additionalDownloadTokens, imageSizes, options, locale, dateFormat) {
	    (0, _classCallCheck3.default)(this, HorsseriesStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (HorsseriesStore.__proto__ || (0, _getPrototypeOf2.default)(HorsseriesStore)).call(this));
	
	    _this.additionalDownloadTokens = null;
	    _this.packages = [];
	    _this._apiManager = null;
	    _this._imageSizes = null;
	
	    _this._apiManager = apiManager;
	    _this.additionalDownloadTokens = additionalDownloadTokens;
	    _this._imageSizes = imageSizes;
	    _this._options = options;
	    _this._dateFormat = dateFormat;
	    _this._locale = locale;
	    return _this;
	  }
	
	  (0, _createClass3.default)(HorsseriesStore, [{
	    key: "loadHorsseries",
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var promiseArray, results;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                // load Horsseries for all tokens + sort by date
	                promiseArray = [];
	
	                this.additionalDownloadTokens.forEach(function (token) {
	                  promiseArray.push(_this2._apiManager.getContentPackageList(token.Value));
	                });
	
	                _context.prev = 2;
	                _context.next = 5;
	                return _promise2.default.all(promiseArray);
	
	              case 5:
	                results = _context.sent;
	
	                results.forEach(function (result) {
	                  result.forEach(function (hsPub) {
	                    if (!_this2.packages.find(function (packageEl) {
	                      return packageEl.ContentPackageId === hsPub.ContentPackageId;
	                    })) _this2.packages.push(_this2.normalizePubForSwiper(hsPub));
	                  });
	                });
	
	                this.packages.sort(function (a, b) {
	                  if (a.ContentPackagePublishTime === b.ContentPackagePublishTime) {
	                    return a.ContentPackageName > b.ContentPackageName ? 1 : -1;
	                  }
	                  return a.ContentPackagePublishTime < b.ContentPackagePublishTime ? 1 : -1;
	                });
	                _context.next = 12;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context["catch"](2);
	
	              case 12:
	                //FIXME Touch reader depends on this event
	                this.trigger("horsseries:loaded");
	
	              case 13:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[2, 10]]);
	      }));
	
	      function loadHorsseries() {
	        return _ref.apply(this, arguments);
	      }
	
	      return loadHorsseries;
	    }()
	  }, {
	    key: "getHorsseries",
	    value: function getHorsseries() {
	      return this.packages;
	    }
	  }, {
	    key: "normalizePubForSwiper",
	    value: function normalizePubForSwiper(pub) {
	      if (pub.ContentPackageFormat === "Extra") {
	        return null;
	      }
	      var result = pub;
	
	      if (this._options.useHSNameAsLabel) {
	        result.label = pub.ContentPackageName;
	      } else {
	        result.label = this.beautifyDate(pub.PublicationDate);
	      }
	
	      result.imageUrl = (0, _utils.generateCoverURL)(pub.ContentPackageId, this._imageSizes.S, pub.ThumbnailId, pub.Version);
	
	      return result;
	    }
	  }, {
	    key: "beautifyDate",
	    value: function beautifyDate(uglyDate) {
	      return (0, _utils.labelToDate)(uglyDate, this._locale, this._dateFormat);
	    }
	
	    /**
	     * Returns content package price based on content package id
	     * @param  {Integer} cpId content package id
	     * @return {Float}        contant package price
	     */
	
	  }, {
	    key: "getContentPackagePrice",
	    value: function getContentPackagePrice(cpId) {
	      var contentPackage = this.packages.find(function (cp) {
	        return cp.ContentPackageId == cpId; // eslint-disable-line
	      });
	
	      if (contentPackage) {
	        if (contentPackage.StoreProducts[0]) {
	          return contentPackage.StoreProducts[0].Price;
	        }
	      }
	    }
	  }]);
	  return HorsseriesStore;
	}(_es6EventEmitter2.default);
	
	exports.default = HorsseriesStore;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get3 = __webpack_require__(244);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventBus = function (_Emitter) {
	  (0, _inherits3.default)(EventBus, _Emitter);
	
	  function EventBus() {
	    (0, _classCallCheck3.default)(this, EventBus);
	    return (0, _possibleConstructorReturn3.default)(this, (EventBus.__proto__ || (0, _getPrototypeOf2.default)(EventBus)).call(this));
	  }
	
	  (0, _createClass3.default)(EventBus, [{
	    key: "trigger",
	    value: function trigger() {
	      var _get2;
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      if (false) {
	        var _console;
	
	        (_console = console).info.apply(_console, args); // eslint-disable-line
	      }
	
	      (_get2 = (0, _get4.default)(EventBus.prototype.__proto__ || (0, _getPrototypeOf2.default)(EventBus.prototype), "trigger", this)).call.apply(_get2, [this].concat(args));
	    }
	  }]);
	  return EventBus;
	}(_es6EventEmitter2.default);
	
	var eventBus = new EventBus();
	exports.default = eventBus;

/***/ },
/* 239 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ACTIONS = {
	  PUBLICATION_SWITCHED: "PUBLICATION_SWITCHED"
	};
	
	exports.default = ACTIONS;

/***/ },
/* 240 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.countPercentOfContainerInZoom = countPercentOfContainerInZoom;
	exports.getPercentInViewForSinglePage = getPercentInViewForSinglePage;
	/**
	 * Returns how much in percent a child container overlaps container that is
	 * treated as a viewport
	 * @param  {Object} viewportDimentions
	 * @param  {Object} coordinates
	 * @param  {Number} [whitespaceModifier=1]
	 * @return [Number]
	 */
	function countPercentOfContainerInZoom(viewportDimentions, coordinates) {
	  var whitespaceModifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  var intersection = {};
	  intersection.left = Math.max(viewportDimentions.left, coordinates.left);
	  intersection.right = Math.min(viewportDimentions.right, coordinates.right);
	  intersection.top = Math.max(viewportDimentions.top, coordinates.top);
	  intersection.bottom = Math.min(viewportDimentions.bottom, coordinates.bottom);
	  intersection.width = Math.max(0, intersection.right - intersection.left);
	  intersection.height = Math.max(0, intersection.bottom - intersection.top);
	  intersection.area = intersection.width * intersection.height;
	  var viewportArea = viewportDimentions.surfaceArea * whitespaceModifier;
	  var percentageInView = 100 * Math.min(1, intersection.area / viewportArea);
	  return percentageInView;
	}
	
	/**
	 * Returns percentage in view for articles and page when
	 * we are in double page mode but we see only one page. For this case, when the page
	 * is not zoomed, page should always get 100% and articles get defaultPercentageInView * 2
	 * @param  {object} page
	 * @return {object} percentageInView object
	 */
	function getPercentInViewForSinglePage(page) {
	  if (!page || !page.content) return;
	  var percentageInView = page.content.reduce(function (obj, article) {
	    obj["article_" + article.ContentID] = article.defaultPercentageInView;
	    return obj;
	  }, {});
	  percentageInView["page_" + page.PublicationPageID] = 100;
	  return percentageInView;
	}

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(243);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _utils = __webpack_require__(10);
	
	var _percentageInViewUtils = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HammerSlide = function (_Emitter) {
	  (0, _inherits3.default)(HammerSlide, _Emitter);
	
	  function HammerSlide(DOMContainer, DOMContent, pages, options, ratio) {
	    (0, _classCallCheck3.default)(this, HammerSlide);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (HammerSlide.__proto__ || (0, _getPrototypeOf2.default)(HammerSlide)).call(this));
	
	    _this.ratio = null;
	    _this.DOMContainer = null;
	    _this.DOMContent = null;
	    _this.swiperInstance = null;
	    _this.currentScale = 1;
	    _this.currentScrollLeft = 0;
	    _this.currentScrollTop = 0;
	    _this.cps = null;
	    _this.lastPinchTime = 0;
	    _this.doublePages = false;
	    _this.options = null;
	    _this.width = null;
	    _this.height = null;
	    _this.rightPagesArticlesIds = [];
	
	    _this.DOMContainer = DOMContainer;
	    _this.DOMContent = DOMContent;
	    _this.ratio = ratio;
	    _this.pages = pages;
	    _this.doublePages = pages.length >= 2;
	    _this.options = options;
	    _this.viewportDimentionsData = {
	      left: 0,
	      top: 0,
	      right: DOMContainer.clientWidth,
	      bottom: DOMContainer.clientHeight,
	      surfaceArea: DOMContainer.clientWidth * DOMContainer.clientHeight
	    };
	    _this._getRightPageArticles();
	    return _this;
	  }
	
	  (0, _createClass3.default)(HammerSlide, [{
	    key: "adaptMaxZoom",
	    value: function adaptMaxZoom() {
	      if (document.querySelector("body").classList.contains("iOS") && document.querySelector("body").classList.contains("Safari")) {
	        //pdf rendering, and safari and ios
	        var basicArea = this.width * this.height;
	        var maxArea = 16777246;
	        var maxScale = Math.sqrt(maxArea / basicArea);
	        this.options.max_zoom = Math.min(maxScale, this.options.max_zoom);
	      }
	    }
	  }, {
	    key: "isZoomed",
	    value: function isZoomed() {
	      return this.currentScale > 1;
	    }
	  }, {
	    key: "init",
	    value: function init(fullWidth) {
	      this.setRatio();
	      this.renderStyle(this.currentScale, this.currentScrollLeft, this.currentScrollTop);
	      if (fullWidth) {
	        this.zoomFullWidth();
	      }
	    }
	  }, {
	    key: "onPinchStart",
	    value: function onPinchStart() {
	      this.cps = this.currentScale;
	    }
	  }, {
	    key: "onPinch",
	    value: function onPinch(e) {
	      //TODO: bug on double pages zoom
	      // if no additionalEvent (pinchIn or pinchOut) it is a cancel event and should be rendered
	      if (!e.additionalEvent) {
	        return;
	      }
	
	      this.lastPinchTime = e.timeStamp;
	
	      var lastScale = this.cps;
	      var eScale = 1;
	      this.cps = Math.min(this.options.max_zoom, Math.max(1, this.currentScale * e.scale * eScale));
	      if (this.cps <= 1) {
	        this.cps = 1;
	      }
	
	      var resultX = this.currentScrollLeft + e.center.x;
	      resultX *= this.cps / lastScale;
	      resultX -= e.center.x;
	      this.currentScrollLeft = resultX;
	
	      var resultY = this.currentScrollTop + e.center.y;
	      resultY *= this.cps / lastScale;
	      resultY -= e.center.y;
	      this.currentScrollTop = resultY;
	
	      this.renderStyle(this.cps, this.currentScrollLeft, this.currentScrollTop);
	    }
	  }, {
	    key: "onPinchEnd",
	    value: function onPinchEnd(e) {
	      var eventData = this.cps !== this.currentScale ? this.getPercentageInView() : null;
	      this.lastPinchTime = e.timeStamp;
	
	      if (this.cps > this.currentScale) {
	        this.trigger("hammerSlide:zoominend", eventData);
	      } else if (this.cps < this.currentScale) {
	        this.trigger("hammerSlide:zoomoutend", eventData);
	      }
	      this.currentScale = this.cps;
	    }
	  }, {
	    key: "allowSwiping",
	    value: function allowSwiping(e) {
	      if (this.currentScale === 1) {
	        return 1; //allow everything
	      }
	      var left = this.currentScrollLeft;
	      if (e && e.deltaX) {
	        left -= e.deltaX;
	      }
	      var max = this.DOMContent.offsetWidth - this.DOMContainer.offsetWidth - 1;
	      if (max < 0) {
	        max = 0;
	      }
	      if (left < 0) {
	        left = 0;
	      } else if (left > max) {
	        left = max;
	      }
	      var scroll = left;
	      if (scroll === 0 && scroll >= max) {
	        return 1;
	      } else if (scroll >= max) {
	        return 2;
	      } else if (scroll === 0) {
	        return 3;
	      }
	      return 0;
	    }
	  }, {
	    key: "panningEnd",
	    value: function panningEnd(e) {
	      //don't take pan events into account right after pinching (jumping after zooming bug)
	      if (e.timeStamp < this.lastPinchTime + this.options.pinchPanTimeInterval || this.currentScale <= 1) {
	        return;
	      }
	      //// only on ios
	      var left = this.currentScrollLeft;
	      var top = this.currentScrollTop;
	      left -= e.deltaX;
	      top -= e.deltaY;
	
	      var max = this.DOMContent.offsetWidth - this.DOMContainer.offsetWidth - 1;
	      if (left < 0) {
	        left = 0;
	      } else if (left > max) {
	        left = max;
	      }
	
	      this.currentScrollLeft = left;
	      this.currentScrollTop = top;
	
	      this.DOMContainer.scrollLeft = left;
	      this.DOMContainer.scrollTop = top;
	
	      this.trigger("hammerSlide:panend", this.getPercentageInView());
	    }
	  }, {
	    key: "panning",
	    value: function panning(e) {
	      //don't take pan events into account right after pinching (jumping after zooming bug)
	      if (e.timeStamp < this.lastPinchTime + this.options.pinchPanTimeInterval || this.currentScale <= 1) {
	        return;
	      }
	      //// only on ios
	      var left = this.currentScrollLeft;
	      var top = this.currentScrollTop;
	      left -= e.deltaX;
	      top -= e.deltaY;
	
	      var max = this.DOMContent.offsetWidth - this.DOMContainer.offsetWidth - 1;
	      if (left < 0) {
	        left = 0;
	      } else if (left > max) {
	        left = max;
	      }
	
	      this.DOMContainer.scrollLeft = left;
	      this.DOMContainer.scrollTop = top;
	    }
	
	    // get x and y to put content in middle of container
	
	  }, {
	    key: "getBasicPan",
	    value: function getBasicPan(width, height) {
	      if (!this.slideRect) {
	        this.slideRect = this.DOMContainer.getBoundingClientRect();
	      }
	
	      var w = this.slideRect.width - width;
	      var h = this.slideRect.height - height;
	
	      return {
	        basicX: Math.max(0, w / 2),
	        basicY: Math.max(0, h / 2)
	      };
	    }
	  }, {
	    key: "renderStyle",
	    value: function renderStyle(scale, offsetX, offsetY) {
	      if (scale <= 1) {
	        if (this.DOMContent.classList.contains("zoomed")) {
	          this.DOMContent.classList.remove("zoomed");
	          this.trigger("hammerSlide:notZoomed");
	        }
	      } else if (!this.DOMContent.classList.contains("zoomed")) {
	        this.DOMContent.classList.add("zoomed");
	        this.trigger("hammerSlide:zoomed");
	      }
	
	      if (!this.width && !this.height) {
	        this.setWidthHeightRatio();
	      }
	
	      var finalWidth = this.width * scale;
	      var finalHeight = this.height * scale;
	      var finalTop = offsetY; // * scale;
	      var finalLeft = offsetX; // * scale;
	
	      var basic = this.getBasicPan(finalWidth, finalHeight);
	
	      this.DOMContent.setAttribute("style", "width:" + finalWidth + "px;height:" + finalHeight + "px;left:" + basic.basicX + "px;top:" + basic.basicY + "px;");
	
	      this.lastDOMContentRect = this.DOMContent.getBoundingClientRect();
	
	      this.DOMContainer.scrollTop = finalTop;
	      this.DOMContainer.scrollLeft = finalLeft;
	    }
	  }, {
	    key: "setWidthHeightRatio",
	    value: function setWidthHeightRatio() {
	      var _DOMContainer$getBoun = this.DOMContainer.getBoundingClientRect(),
	          width = _DOMContainer$getBoun.width;
	
	      var _DOMContainer$getBoun2 = this.DOMContainer.getBoundingClientRect(),
	          height = _DOMContainer$getBoun2.height;
	
	      if (this.doublePages) {
	        width /= 2;
	      }
	
	      var finalWidth = height / this.ratio;
	      var finalHeight = width * this.ratio;
	
	      finalWidth = Math.min(finalWidth, width);
	      if (this.doublePages) {
	        finalWidth *= 2;
	      }
	      finalHeight = Math.min(finalHeight, height);
	
	      this.width = finalWidth;
	      this.height = finalHeight;
	
	      this.adaptMaxZoom();
	    }
	  }, {
	    key: "resize",
	    value: function resize(height, keepScale, fullWidth) {
	      var prevHeight = this.height;
	      var prevWidth = this.width;
	      var prevSlideRect = this.slideRect;
	
	      this.DOMContainer.setAttribute("style", "height:" + height + "px");
	
	      if (fullWidth) {
	        this.currentScale = 1;
	        this.currentScrollLeft = 0;
	        this.currentScrollTop = 0;
	        this.setRatio();
	        this.renderStyle(this.currentScale, this.currentScrollLeft, this.currentScrollTop);
	        this.zoomFullWidth();
	      } else {
	        this.slideRect = this.DOMContainer.getBoundingClientRect();
	        this.setWidthHeightRatio();
	        if (!keepScale) {
	          // dont keep scale
	          this.currentScale = 1;
	          this.currentScrollLeft = 0;
	          this.currentScrollTop = 0;
	        } else {
	          this.renderStyle(1, 0, 0); //first render with no scale, otherwise swiper doesnt work anymore
	          this.currentScrollLeft = (this.currentScrollLeft + prevSlideRect.width / 2) * this.width / prevWidth - this.slideRect.width / 2;
	          this.currentScrollTop = (this.currentScrollTop + prevSlideRect.height / 2) * this.height / prevHeight - this.slideRect.height / 2;
	          if (this.currentScrollTop < 0) {
	            this.currentScrollTop = 0;
	          }
	          if (this.currentScrollLeft < 0) {
	            this.currentScrollLeft = 0;
	          }
	        }
	        this.renderStyle(this.currentScale, this.currentScrollLeft, this.currentScrollTop);
	      }
	      this.viewportDimentionsData = {
	        left: 0,
	        top: 0,
	        right: this.DOMContainer.clientWidth,
	        bottom: this.DOMContainer.clientHeight,
	        surfaceArea: this.DOMContainer.clientWidth * this.DOMContainer.clientHeight
	      };
	    }
	  }, {
	    key: "setRatio",
	    value: function setRatio() {
	      if (!this.width && !this.height) {
	        this.setWidthHeightRatio();
	      }
	      var basic = this.getBasicPan(this.width, this.height);
	
	      this.DOMContent.setAttribute("style", "width:" + this.width + "px;height:" + this.height + "px;left:" + basic.basicX + "px;top:" + basic.basicY + "px;");
	    }
	  }, {
	    key: "zoomFullWidth",
	    value: function zoomFullWidth() {
	      var slideRect = this.DOMContainer.getBoundingClientRect();
	      var domRect = this.DOMContent.getBoundingClientRect();
	      var scale = slideRect.width / domRect.width;
	      this.currentScale = scale;
	      this.currentScrollLeft = 0;
	      this.currentScrollTop = 0;
	
	      this.renderStyle(this.currentScale, this.currentScrollLeft, this.currentScrollTop);
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      //TODO: removeListeners
	      this.ratio = null;
	      this.DOMContainer = null;
	      this.DOMContent = null;
	      this.swiperInstance = null;
	      this.currentScale = 1;
	      this.currentScrollLeft = 0;
	      this.currentScrollTop = 0;
	      this.cps = null;
	      this.lastPinchTime = 0;
	      this.doublePages = false;
	      this.options = null;
	      this.width = null;
	      this.height = null;
	    }
	  }, {
	    key: "getPercentageInView",
	    value: function getPercentageInView() {
	      if (this.DOMContainer.clientHeight < this.DOMContent.clientHeight || this.DOMContainer.clientWidth < this.DOMContent.clientWidth) {
	        var pagesData = this._calculatePagesPercentageInView();
	        var articlesData = this._calculateArticlesPercentageInView();
	
	        return (0, _extends3.default)({}, pagesData, articlesData);
	      } else if (this._isEdgePageNotZoomed()) {
	        // This is special case. When we are in doubled page mode
	        // but user can see only one page (first or last page).
	        // If the page is not zoomed, we return default values
	        // for articles' percentageInView and 100% for the page.
	        return this._countEdgePagePercentageInView();
	      }
	    }
	
	    ////////////
	
	  }, {
	    key: "_calculateArticlesPercentageInView",
	    value: function _calculateArticlesPercentageInView() {
	      var _this2 = this;
	
	      var articlesData = {};
	
	      this.DOMContainer.querySelectorAll(".swiper-slide-page-click").forEach(function (el) {
	        var xModifier = _this2.rightPagesArticlesIds.indexOf(el.dataset.contentid) !== -1 ? _this2.DOMContent.clientWidth / 2 : 0;
	
	        var left = el.offsetLeft - _this2.DOMContainer.scrollLeft + xModifier;
	        var top = el.offsetTop - _this2.DOMContainer.scrollTop;
	        var right = left + el.clientWidth;
	        var bottom = top + el.clientHeight;
	        var articleCoordinates = {
	          left: left,
	          top: top,
	          right: right,
	          bottom: bottom
	        };
	
	        articlesData["article_" + el.dataset.contentid] = (0, _percentageInViewUtils.countPercentOfContainerInZoom)(_this2.viewportDimentionsData, articleCoordinates, _this2.options.activeAreaPercentage);
	      });
	
	      return articlesData;
	    }
	  }, {
	    key: "_calculatePagesPercentageInView",
	    value: function _calculatePagesPercentageInView() {
	      if (this.doublePages) {
	        var leftPageId = this.pages[0] ? this.pages[0].PublicationPageID : null;
	        var rightPageId = this.pages[1] ? this.pages[1].PublicationPageID : null;
	
	        var pageEl = this.DOMContainer.querySelector("[data-page-id=\"" + (leftPageId || rightPageId) + "\"]");
	
	        var pagePositionLeft = pageEl.offsetLeft;
	        var pagePositionTop = pageEl.offsetTop;
	
	        var pageCoordinates = {
	          left: pagePositionLeft - this.DOMContainer.scrollLeft,
	          top: pagePositionTop - this.DOMContainer.scrollTop,
	          right: pagePositionLeft - this.DOMContainer.scrollLeft + pageEl.clientWidth,
	          bottom: pagePositionTop - this.DOMContainer.scrollTop + pageEl.clientHeight
	        };
	
	        var percentOfLeftPageInView = (0, _percentageInViewUtils.countPercentOfContainerInZoom)(this.viewportDimentionsData, pageCoordinates);
	
	        if (leftPageId && rightPageId) {
	          var _ref;
	
	          return _ref = {}, (0, _defineProperty3.default)(_ref, "page_" + leftPageId, percentOfLeftPageInView), (0, _defineProperty3.default)(_ref, "page_" + rightPageId, Math.max(0, 100 - percentOfLeftPageInView)), _ref;
	        }
	        return (0, _defineProperty3.default)({}, "page_" + (leftPageId || rightPageId), percentOfLeftPageInView);
	      }
	    }
	  }, {
	    key: "_countEdgePagePercentageInView",
	    value: function _countEdgePagePercentageInView() {
	      return (0, _utils.compact)(this.pages).map(_percentageInViewUtils.getPercentInViewForSinglePage)[0];
	    }
	  }, {
	    key: "_getRightPageArticles",
	    value: function _getRightPageArticles() {
	      if (this.doublePages && this.pages[1]) {
	        this.rightPagesArticlesIds = this.pages[1].content.reduce(function (acc, article) {
	          acc.push(String(article.ContentID));
	          return acc;
	        }, []);
	      }
	    }
	  }, {
	    key: "_isEdgePageNotZoomed",
	    value: function _isEdgePageNotZoomed() {
	      return (!this.DOMContainer.clientHeight < this.DOMContent.clientHeight || !this.DOMContainer.clientWidth < this.DOMContent.clientWidth) && this.doublePages && (0, _utils.compact)(this.pages).length !== 2;
	    }
	  }]);
	  return HammerSlide;
	}(_es6EventEmitter2.default);
	
	exports.default = HammerSlide;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(320), __esModule: true };

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(98);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(309);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ },
/* 245 */,
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! nouislider - 9.2.0 - 2017-01-11 10:35:34 */
	
	(function (factory) {
	
	    if ( true ) {
	
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	    } else if ( typeof exports === 'object' ) {
	
	        // Node/CommonJS
	        module.exports = factory();
	
	    } else {
	
	        // Browser globals
	        window.noUiSlider = factory();
	    }
	
	}(function( ){
	
		'use strict';
	
		var VERSION = '9.2.0';
	
	
		// Creates a node, adds it to target, returns the new node.
		function addNodeTo ( target, className ) {
			var div = document.createElement('div');
			addClass(div, className);
			target.appendChild(div);
			return div;
		}
	
		// Removes duplicates from an array.
		function unique ( array ) {
			return array.filter(function(a){
				return !this[a] ? this[a] = true : false;
			}, {});
		}
	
		// Round a value to the closest 'to'.
		function closest ( value, to ) {
			return Math.round(value / to) * to;
		}
	
		// Current position of an element relative to the document.
		function offset ( elem, orientation ) {
	
		var rect = elem.getBoundingClientRect(),
			doc = elem.ownerDocument,
			docElem = doc.documentElement,
			pageOffset = getPageOffset();
	
			// getBoundingClientRect contains left scroll in Chrome on Android.
			// I haven't found a feature detection that proves this. Worst case
			// scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
			if ( /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) ) {
				pageOffset.x = 0;
			}
	
			return orientation ? (rect.top + pageOffset.y - docElem.clientTop) : (rect.left + pageOffset.x - docElem.clientLeft);
		}
	
		// Checks whether a value is numerical.
		function isNumeric ( a ) {
			return typeof a === 'number' && !isNaN( a ) && isFinite( a );
		}
	
		// Sets a class and removes it after [duration] ms.
		function addClassFor ( element, className, duration ) {
			if (duration > 0) {
			addClass(element, className);
				setTimeout(function(){
					removeClass(element, className);
				}, duration);
			}
		}
	
		// Limits a value to 0 - 100
		function limit ( a ) {
			return Math.max(Math.min(a, 100), 0);
		}
	
		// Wraps a variable as an array, if it isn't one yet.
		// Note that an input array is returned by reference!
		function asArray ( a ) {
			return Array.isArray(a) ? a : [a];
		}
	
		// Counts decimals
		function countDecimals ( numStr ) {
			numStr = String(numStr);
			var pieces = numStr.split(".");
			return pieces.length > 1 ? pieces[1].length : 0;
		}
	
		// http://youmightnotneedjquery.com/#add_class
		function addClass ( el, className ) {
			if ( el.classList ) {
				el.classList.add(className);
			} else {
				el.className += ' ' + className;
			}
		}
	
		// http://youmightnotneedjquery.com/#remove_class
		function removeClass ( el, className ) {
			if ( el.classList ) {
				el.classList.remove(className);
			} else {
				el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		}
	
		// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
		function hasClass ( el, className ) {
			return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
		}
	
		// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
		function getPageOffset ( ) {
	
			var supportPageOffset = window.pageXOffset !== undefined,
				isCSS1Compat = ((document.compatMode || "") === "CSS1Compat"),
				x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
				y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
	
			return {
				x: x,
				y: y
			};
		}
	
		// we provide a function to compute constants instead
		// of accessing window.* as soon as the module needs it
		// so that we do not compute anything if not needed
		function getActions ( ) {
	
			// Determine the events to bind. IE11 implements pointerEvents without
			// a prefix, which breaks compatibility with the IE10 implementation.
			return window.navigator.pointerEnabled ? {
				start: 'pointerdown',
				move: 'pointermove',
				end: 'pointerup'
			} : window.navigator.msPointerEnabled ? {
				start: 'MSPointerDown',
				move: 'MSPointerMove',
				end: 'MSPointerUp'
			} : {
				start: 'mousedown touchstart',
				move: 'mousemove touchmove',
				end: 'mouseup touchend'
			};
		}
	
	
	// Value calculation
	
		// Determine the size of a sub-range in relation to a full range.
		function subRangeRatio ( pa, pb ) {
			return (100 / (pb - pa));
		}
	
		// (percentage) How many percent is this value of this range?
		function fromPercentage ( range, value ) {
			return (value * 100) / ( range[1] - range[0] );
		}
	
		// (percentage) Where is this value on this range?
		function toPercentage ( range, value ) {
			return fromPercentage( range, range[0] < 0 ?
				value + Math.abs(range[0]) :
					value - range[0] );
		}
	
		// (value) How much is this percentage on this range?
		function isPercentage ( range, value ) {
			return ((value * ( range[1] - range[0] )) / 100) + range[0];
		}
	
	
	// Range conversion
	
		function getJ ( value, arr ) {
	
			var j = 1;
	
			while ( value >= arr[j] ){
				j += 1;
			}
	
			return j;
		}
	
		// (percentage) Input a value, find where, on a scale of 0-100, it applies.
		function toStepping ( xVal, xPct, value ) {
	
			if ( value >= xVal.slice(-1)[0] ){
				return 100;
			}
	
			var j = getJ( value, xVal ), va, vb, pa, pb;
	
			va = xVal[j-1];
			vb = xVal[j];
			pa = xPct[j-1];
			pb = xPct[j];
	
			return pa + (toPercentage([va, vb], value) / subRangeRatio (pa, pb));
		}
	
		// (value) Input a percentage, find where it is on the specified range.
		function fromStepping ( xVal, xPct, value ) {
	
			// There is no range group that fits 100
			if ( value >= 100 ){
				return xVal.slice(-1)[0];
			}
	
			var j = getJ( value, xPct ), va, vb, pa, pb;
	
			va = xVal[j-1];
			vb = xVal[j];
			pa = xPct[j-1];
			pb = xPct[j];
	
			return isPercentage([va, vb], (value - pa) * subRangeRatio (pa, pb));
		}
	
		// (percentage) Get the step that applies at a certain value.
		function getStep ( xPct, xSteps, snap, value ) {
	
			if ( value === 100 ) {
				return value;
			}
	
			var j = getJ( value, xPct ), a, b;
	
			// If 'snap' is set, steps are used as fixed points on the slider.
			if ( snap ) {
	
				a = xPct[j-1];
				b = xPct[j];
	
				// Find the closest position, a or b.
				if ((value - a) > ((b-a)/2)){
					return b;
				}
	
				return a;
			}
	
			if ( !xSteps[j-1] ){
				return value;
			}
	
			return xPct[j-1] + closest(
				value - xPct[j-1],
				xSteps[j-1]
			);
		}
	
	
	// Entry parsing
	
		function handleEntryPoint ( index, value, that ) {
	
			var percentage;
	
			// Wrap numerical input in an array.
			if ( typeof value === "number" ) {
				value = [value];
			}
	
			// Reject any invalid input, by testing whether value is an array.
			if ( Object.prototype.toString.call( value ) !== '[object Array]' ){
				throw new Error("noUiSlider (" + VERSION + "): 'range' contains invalid value.");
			}
	
			// Covert min/max syntax to 0 and 100.
			if ( index === 'min' ) {
				percentage = 0;
			} else if ( index === 'max' ) {
				percentage = 100;
			} else {
				percentage = parseFloat( index );
			}
	
			// Check for correct input.
			if ( !isNumeric( percentage ) || !isNumeric( value[0] ) ) {
				throw new Error("noUiSlider (" + VERSION + "): 'range' value isn't numeric.");
			}
	
			// Store values.
			that.xPct.push( percentage );
			that.xVal.push( value[0] );
	
			// NaN will evaluate to false too, but to keep
			// logging clear, set step explicitly. Make sure
			// not to override the 'step' setting with false.
			if ( !percentage ) {
				if ( !isNaN( value[1] ) ) {
					that.xSteps[0] = value[1];
				}
			} else {
				that.xSteps.push( isNaN(value[1]) ? false : value[1] );
			}
	
			that.xHighestCompleteStep.push(0);
		}
	
		function handleStepPoint ( i, n, that ) {
	
			// Ignore 'false' stepping.
			if ( !n ) {
				return true;
			}
	
			// Factor to range ratio
			that.xSteps[i] = fromPercentage([
				 that.xVal[i]
				,that.xVal[i+1]
			], n) / subRangeRatio (
				that.xPct[i],
				that.xPct[i+1] );
	
			var totalSteps = (that.xVal[i+1] - that.xVal[i]) / that.xNumSteps[i];
			var highestStep = Math.ceil(Number(totalSteps.toFixed(3)) - 1);
			var step = that.xVal[i] + (that.xNumSteps[i] * highestStep);
	
			that.xHighestCompleteStep[i] = step;
		}
	
	
	// Interface
	
		// The interface to Spectrum handles all direction-based
		// conversions, so the above values are unaware.
	
		function Spectrum ( entry, snap, direction, singleStep ) {
	
			this.xPct = [];
			this.xVal = [];
			this.xSteps = [ singleStep || false ];
			this.xNumSteps = [ false ];
			this.xHighestCompleteStep = [];
	
			this.snap = snap;
			this.direction = direction;
	
			var index, ordered = [ /* [0, 'min'], [1, '50%'], [2, 'max'] */ ];
	
			// Map the object keys to an array.
			for ( index in entry ) {
				if ( entry.hasOwnProperty(index) ) {
					ordered.push([entry[index], index]);
				}
			}
	
			// Sort all entries by value (numeric sort).
			if ( ordered.length && typeof ordered[0][0] === "object" ) {
				ordered.sort(function(a, b) { return a[0][0] - b[0][0]; });
			} else {
				ordered.sort(function(a, b) { return a[0] - b[0]; });
			}
	
	
			// Convert all entries to subranges.
			for ( index = 0; index < ordered.length; index++ ) {
				handleEntryPoint(ordered[index][1], ordered[index][0], this);
			}
	
			// Store the actual step values.
			// xSteps is sorted in the same order as xPct and xVal.
			this.xNumSteps = this.xSteps.slice(0);
	
			// Convert all numeric steps to the percentage of the subrange they represent.
			for ( index = 0; index < this.xNumSteps.length; index++ ) {
				handleStepPoint(index, this.xNumSteps[index], this);
			}
		}
	
		Spectrum.prototype.getMargin = function ( value ) {
	
			var step = this.xNumSteps[0];
	
			if ( step && ((value / step) % 1) !== 0 ) {
				throw new Error("noUiSlider (" + VERSION + "): 'limit', 'margin' and 'padding' must be divisible by step.");
			}
	
			return this.xPct.length === 2 ? fromPercentage(this.xVal, value) : false;
		};
	
		Spectrum.prototype.toStepping = function ( value ) {
	
			value = toStepping( this.xVal, this.xPct, value );
	
			return value;
		};
	
		Spectrum.prototype.fromStepping = function ( value ) {
	
			return fromStepping( this.xVal, this.xPct, value );
		};
	
		Spectrum.prototype.getStep = function ( value ) {
	
			value = getStep(this.xPct, this.xSteps, this.snap, value );
	
			return value;
		};
	
		Spectrum.prototype.getNearbySteps = function ( value ) {
	
			var j = getJ(value, this.xPct);
	
			return {
				stepBefore: { startValue: this.xVal[j-2], step: this.xNumSteps[j-2], highestStep: this.xHighestCompleteStep[j-2] },
				thisStep: { startValue: this.xVal[j-1], step: this.xNumSteps[j-1], highestStep: this.xHighestCompleteStep[j-1] },
				stepAfter: { startValue: this.xVal[j-0], step: this.xNumSteps[j-0], highestStep: this.xHighestCompleteStep[j-0] }
			};
		};
	
		Spectrum.prototype.countStepDecimals = function () {
			var stepDecimals = this.xNumSteps.map(countDecimals);
			return Math.max.apply(null, stepDecimals);
	 	};
	
		// Outside testing
		Spectrum.prototype.convert = function ( value ) {
			return this.getStep(this.toStepping(value));
		};
	
	/*	Every input option is tested and parsed. This'll prevent
		endless validation in internal methods. These tests are
		structured with an item for every option available. An
		option can be marked as required by setting the 'r' flag.
		The testing function is provided with three arguments:
			- The provided value for the option;
			- A reference to the options object;
			- The name for the option;
	
		The testing function returns false when an error is detected,
		or true when everything is OK. It can also modify the option
		object, to make sure all values can be correctly looped elsewhere. */
	
		var defaultFormatter = { 'to': function( value ){
			return value !== undefined && value.toFixed(2);
		}, 'from': Number };
	
		function testStep ( parsed, entry ) {
	
			if ( !isNumeric( entry ) ) {
				throw new Error("noUiSlider (" + VERSION + "): 'step' is not numeric.");
			}
	
			// The step option can still be used to set stepping
			// for linear sliders. Overwritten if set in 'range'.
			parsed.singleStep = entry;
		}
	
		function testRange ( parsed, entry ) {
	
			// Filter incorrect input.
			if ( typeof entry !== 'object' || Array.isArray(entry) ) {
				throw new Error("noUiSlider (" + VERSION + "): 'range' is not an object.");
			}
	
			// Catch missing start or end.
			if ( entry.min === undefined || entry.max === undefined ) {
				throw new Error("noUiSlider (" + VERSION + "): Missing 'min' or 'max' in 'range'.");
			}
	
			// Catch equal start or end.
			if ( entry.min === entry.max ) {
				throw new Error("noUiSlider (" + VERSION + "): 'range' 'min' and 'max' cannot be equal.");
			}
	
			parsed.spectrum = new Spectrum(entry, parsed.snap, parsed.dir, parsed.singleStep);
		}
	
		function testStart ( parsed, entry ) {
	
			entry = asArray(entry);
	
			// Validate input. Values aren't tested, as the public .val method
			// will always provide a valid location.
			if ( !Array.isArray( entry ) || !entry.length ) {
				throw new Error("noUiSlider (" + VERSION + "): 'start' option is incorrect.");
			}
	
			// Store the number of handles.
			parsed.handles = entry.length;
	
			// When the slider is initialized, the .val method will
			// be called with the start options.
			parsed.start = entry;
		}
	
		function testSnap ( parsed, entry ) {
	
			// Enforce 100% stepping within subranges.
			parsed.snap = entry;
	
			if ( typeof entry !== 'boolean' ){
				throw new Error("noUiSlider (" + VERSION + "): 'snap' option must be a boolean.");
			}
		}
	
		function testAnimate ( parsed, entry ) {
	
			// Enforce 100% stepping within subranges.
			parsed.animate = entry;
	
			if ( typeof entry !== 'boolean' ){
				throw new Error("noUiSlider (" + VERSION + "): 'animate' option must be a boolean.");
			}
		}
	
		function testAnimationDuration ( parsed, entry ) {
	
			parsed.animationDuration = entry;
	
			if ( typeof entry !== 'number' ){
				throw new Error("noUiSlider (" + VERSION + "): 'animationDuration' option must be a number.");
			}
		}
	
		function testConnect ( parsed, entry ) {
	
			var connect = [false];
			var i;
	
			// Map legacy options
			if ( entry === 'lower' ) {
				entry = [true, false];
			}
	
			else if ( entry === 'upper' ) {
				entry = [false, true];
			}
	
			// Handle boolean options
			if ( entry === true || entry === false ) {
	
				for ( i = 1; i < parsed.handles; i++ ) {
					connect.push(entry);
				}
	
				connect.push(false);
			}
	
			// Reject invalid input
			else if ( !Array.isArray( entry ) || !entry.length || entry.length !== parsed.handles + 1 ) {
				throw new Error("noUiSlider (" + VERSION + "): 'connect' option doesn't match handle count.");
			}
	
			else {
				connect = entry;
			}
	
			parsed.connect = connect;
		}
	
		function testOrientation ( parsed, entry ) {
	
			// Set orientation to an a numerical value for easy
			// array selection.
			switch ( entry ){
			  case 'horizontal':
				parsed.ort = 0;
				break;
			  case 'vertical':
				parsed.ort = 1;
				break;
			  default:
				throw new Error("noUiSlider (" + VERSION + "): 'orientation' option is invalid.");
			}
		}
	
		function testMargin ( parsed, entry ) {
	
			if ( !isNumeric(entry) ){
				throw new Error("noUiSlider (" + VERSION + "): 'margin' option must be numeric.");
			}
	
			// Issue #582
			if ( entry === 0 ) {
				return;
			}
	
			parsed.margin = parsed.spectrum.getMargin(entry);
	
			if ( !parsed.margin ) {
				throw new Error("noUiSlider (" + VERSION + "): 'margin' option is only supported on linear sliders.");
			}
		}
	
		function testLimit ( parsed, entry ) {
	
			if ( !isNumeric(entry) ){
				throw new Error("noUiSlider (" + VERSION + "): 'limit' option must be numeric.");
			}
	
			parsed.limit = parsed.spectrum.getMargin(entry);
	
			if ( !parsed.limit || parsed.handles < 2 ) {
				throw new Error("noUiSlider (" + VERSION + "): 'limit' option is only supported on linear sliders with 2 or more handles.");
			}
		}
	
		function testPadding ( parsed, entry ) {
	
			if ( !isNumeric(entry) ){
				throw new Error("noUiSlider (" + VERSION + "): 'padding' option must be numeric.");
			}
	
			if ( entry === 0 ) {
				return;
			}
	
			parsed.padding = parsed.spectrum.getMargin(entry);
	
			if ( !parsed.padding ) {
				throw new Error("noUiSlider (" + VERSION + "): 'padding' option is only supported on linear sliders.");
			}
	
			if ( parsed.padding < 0 ) {
				throw new Error("noUiSlider (" + VERSION + "): 'padding' option must be a positive number.");
			}
	
			if ( parsed.padding >= 50 ) {
				throw new Error("noUiSlider (" + VERSION + "): 'padding' option must be less than half the range.");
			}
		}
	
		function testDirection ( parsed, entry ) {
	
			// Set direction as a numerical value for easy parsing.
			// Invert connection for RTL sliders, so that the proper
			// handles get the connect/background classes.
			switch ( entry ) {
			  case 'ltr':
				parsed.dir = 0;
				break;
			  case 'rtl':
				parsed.dir = 1;
				break;
			  default:
				throw new Error("noUiSlider (" + VERSION + "): 'direction' option was not recognized.");
			}
		}
	
		function testBehaviour ( parsed, entry ) {
	
			// Make sure the input is a string.
			if ( typeof entry !== 'string' ) {
				throw new Error("noUiSlider (" + VERSION + "): 'behaviour' must be a string containing options.");
			}
	
			// Check if the string contains any keywords.
			// None are required.
			var tap = entry.indexOf('tap') >= 0;
			var drag = entry.indexOf('drag') >= 0;
			var fixed = entry.indexOf('fixed') >= 0;
			var snap = entry.indexOf('snap') >= 0;
			var hover = entry.indexOf('hover') >= 0;
	
			if ( fixed ) {
	
				if ( parsed.handles !== 2 ) {
					throw new Error("noUiSlider (" + VERSION + "): 'fixed' behaviour must be used with 2 handles");
				}
	
				// Use margin to enforce fixed state
				testMargin(parsed, parsed.start[1] - parsed.start[0]);
			}
	
			parsed.events = {
				tap: tap || snap,
				drag: drag,
				fixed: fixed,
				snap: snap,
				hover: hover
			};
		}
	
		function testTooltips ( parsed, entry ) {
	
			if ( entry === false ) {
				return;
			}
	
			else if ( entry === true ) {
	
				parsed.tooltips = [];
	
				for ( var i = 0; i < parsed.handles; i++ ) {
					parsed.tooltips.push(true);
				}
			}
	
			else {
	
				parsed.tooltips = asArray(entry);
	
				if ( parsed.tooltips.length !== parsed.handles ) {
					throw new Error("noUiSlider (" + VERSION + "): must pass a formatter for all handles.");
				}
	
				parsed.tooltips.forEach(function(formatter){
					if ( typeof formatter !== 'boolean' && (typeof formatter !== 'object' || typeof formatter.to !== 'function') ) {
						throw new Error("noUiSlider (" + VERSION + "): 'tooltips' must be passed a formatter or 'false'.");
					}
				});
			}
		}
	
		function testFormat ( parsed, entry ) {
	
			parsed.format = entry;
	
			// Any object with a to and from method is supported.
			if ( typeof entry.to === 'function' && typeof entry.from === 'function' ) {
				return true;
			}
	
			throw new Error("noUiSlider (" + VERSION + "): 'format' requires 'to' and 'from' methods.");
		}
	
		function testCssPrefix ( parsed, entry ) {
	
			if ( entry !== undefined && typeof entry !== 'string' && entry !== false ) {
				throw new Error("noUiSlider (" + VERSION + "): 'cssPrefix' must be a string or `false`.");
			}
	
			parsed.cssPrefix = entry;
		}
	
		function testCssClasses ( parsed, entry ) {
	
			if ( entry !== undefined && typeof entry !== 'object' ) {
				throw new Error("noUiSlider (" + VERSION + "): 'cssClasses' must be an object.");
			}
	
			if ( typeof parsed.cssPrefix === 'string' ) {
				parsed.cssClasses = {};
	
				for ( var key in entry ) {
					if ( !entry.hasOwnProperty(key) ) { continue; }
	
					parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
				}
			} else {
				parsed.cssClasses = entry;
			}
		}
	
		function testUseRaf ( parsed, entry ) {
			if ( entry === true || entry === false ) {
				parsed.useRequestAnimationFrame = entry;
			} else {
				throw new Error("noUiSlider (" + VERSION + "): 'useRequestAnimationFrame' option should be true (default) or false.");
			}
		}
	
		// Test all developer settings and parse to assumption-safe values.
		function testOptions ( options ) {
	
			// To prove a fix for #537, freeze options here.
			// If the object is modified, an error will be thrown.
			// Object.freeze(options);
	
			var parsed = {
				margin: 0,
				limit: 0,
				padding: 0,
				animate: true,
				animationDuration: 300,
				format: defaultFormatter
			};
	
			// Tests are executed in the order they are presented here.
			var tests = {
				'step': { r: false, t: testStep },
				'start': { r: true, t: testStart },
				'connect': { r: true, t: testConnect },
				'direction': { r: true, t: testDirection },
				'snap': { r: false, t: testSnap },
				'animate': { r: false, t: testAnimate },
				'animationDuration': { r: false, t: testAnimationDuration },
				'range': { r: true, t: testRange },
				'orientation': { r: false, t: testOrientation },
				'margin': { r: false, t: testMargin },
				'limit': { r: false, t: testLimit },
				'padding': { r: false, t: testPadding },
				'behaviour': { r: true, t: testBehaviour },
				'format': { r: false, t: testFormat },
				'tooltips': { r: false, t: testTooltips },
				'cssPrefix': { r: false, t: testCssPrefix },
				'cssClasses': { r: false, t: testCssClasses },
				'useRequestAnimationFrame': { r: false, t: testUseRaf }
			};
	
			var defaults = {
				'connect': false,
				'direction': 'ltr',
				'behaviour': 'tap',
				'orientation': 'horizontal',
				'cssPrefix' : 'noUi-',
				'cssClasses': {
					target: 'target',
					base: 'base',
					origin: 'origin',
					handle: 'handle',
					handleLower: 'handle-lower',
					handleUpper: 'handle-upper',
					horizontal: 'horizontal',
					vertical: 'vertical',
					background: 'background',
					connect: 'connect',
					ltr: 'ltr',
					rtl: 'rtl',
					draggable: 'draggable',
					drag: 'state-drag',
					tap: 'state-tap',
					active: 'active',
					tooltip: 'tooltip',
					pips: 'pips',
					pipsHorizontal: 'pips-horizontal',
					pipsVertical: 'pips-vertical',
					marker: 'marker',
					markerHorizontal: 'marker-horizontal',
					markerVertical: 'marker-vertical',
					markerNormal: 'marker-normal',
					markerLarge: 'marker-large',
					markerSub: 'marker-sub',
					value: 'value',
					valueHorizontal: 'value-horizontal',
					valueVertical: 'value-vertical',
					valueNormal: 'value-normal',
					valueLarge: 'value-large',
					valueSub: 'value-sub'
				},
				'useRequestAnimationFrame': true
			};
	
			// Run all options through a testing mechanism to ensure correct
			// input. It should be noted that options might get modified to
			// be handled properly. E.g. wrapping integers in arrays.
			Object.keys(tests).forEach(function( name ){
	
				// If the option isn't set, but it is required, throw an error.
				if ( options[name] === undefined && defaults[name] === undefined ) {
	
					if ( tests[name].r ) {
						throw new Error("noUiSlider (" + VERSION + "): '" + name + "' is required.");
					}
	
					return true;
				}
	
				tests[name].t( parsed, options[name] === undefined ? defaults[name] : options[name] );
			});
	
			// Forward pips options
			parsed.pips = options.pips;
	
			var styles = [['left', 'top'], ['right', 'bottom']];
	
			// Pre-define the styles.
			parsed.style = styles[parsed.dir][parsed.ort];
			parsed.styleOposite = styles[parsed.dir?0:1][parsed.ort];
	
			return parsed;
		}
	
	
	function closure ( target, options, originalOptions ){
	
		var actions = getActions( );
	
		// All variables local to 'closure' are prefixed with 'scope_'
		var scope_Target = target;
		var scope_Locations = [];
		var scope_Base;
		var scope_Handles;
		var scope_HandleNumbers = [];
		var scope_ActiveHandle = false;
		var scope_Connects;
		var scope_Spectrum = options.spectrum;
		var scope_Values = [];
		var scope_Events = {};
		var scope_Self;
	
	
		// Append a origin to the base
		function addOrigin ( base, handleNumber ) {
	
			var origin = addNodeTo(base, options.cssClasses.origin);
			var handle = addNodeTo(origin, options.cssClasses.handle);
	
			handle.setAttribute('data-handle', handleNumber);
	
			if ( handleNumber === 0 ) {
				addClass(handle, options.cssClasses.handleLower);
			}
	
			else if ( handleNumber === options.handles - 1 ) {
				addClass(handle, options.cssClasses.handleUpper);
			}
	
			return origin;
		}
	
		// Insert nodes for connect elements
		function addConnect ( base, add ) {
	
			if ( !add ) {
				return false;
			}
	
			return addNodeTo(base, options.cssClasses.connect);
		}
	
		// Add handles to the slider base.
		function addElements ( connectOptions, base ) {
	
			scope_Handles = [];
			scope_Connects = [];
	
			scope_Connects.push(addConnect(base, connectOptions[0]));
	
			// [::::O====O====O====]
			// connectOptions = [0, 1, 1, 1]
	
			for ( var i = 0; i < options.handles; i++ ) {
				// Keep a list of all added handles.
				scope_Handles.push(addOrigin(base, i));
				scope_HandleNumbers[i] = i;
				scope_Connects.push(addConnect(base, connectOptions[i + 1]));
			}
		}
	
		// Initialize a single slider.
		function addSlider ( target ) {
	
			// Apply classes and data to the target.
			addClass(target, options.cssClasses.target);
	
			if ( options.dir === 0 ) {
				addClass(target, options.cssClasses.ltr);
			} else {
				addClass(target, options.cssClasses.rtl);
			}
	
			if ( options.ort === 0 ) {
				addClass(target, options.cssClasses.horizontal);
			} else {
				addClass(target, options.cssClasses.vertical);
			}
	
			scope_Base = addNodeTo(target, options.cssClasses.base);
		}
	
	
		function addTooltip ( handle, handleNumber ) {
	
			if ( !options.tooltips[handleNumber] ) {
				return false;
			}
	
			return addNodeTo(handle.firstChild, options.cssClasses.tooltip);
		}
	
		// The tooltips option is a shorthand for using the 'update' event.
		function tooltips ( ) {
	
			// Tooltips are added with options.tooltips in original order.
			var tips = scope_Handles.map(addTooltip);
	
			bindEvent('update', function(values, handleNumber, unencoded) {
	
				if ( !tips[handleNumber] ) {
					return;
				}
	
				var formattedValue = values[handleNumber];
	
				if ( options.tooltips[handleNumber] !== true ) {
					formattedValue = options.tooltips[handleNumber].to(unencoded[handleNumber]);
				}
	
				tips[handleNumber].innerHTML = formattedValue;
			});
		}
	
	
		function getGroup ( mode, values, stepped ) {
	
			// Use the range.
			if ( mode === 'range' || mode === 'steps' ) {
				return scope_Spectrum.xVal;
			}
	
			if ( mode === 'count' ) {
	
				if ( !values ) {
					throw new Error("noUiSlider (" + VERSION + "): 'values' required for mode 'count'.");
				}
	
				// Divide 0 - 100 in 'count' parts.
				var spread = ( 100 / (values - 1) );
				var v;
				var i = 0;
	
				values = [];
	
				// List these parts and have them handled as 'positions'.
				while ( (v = i++ * spread) <= 100 ) {
					values.push(v);
				}
	
				mode = 'positions';
			}
	
			if ( mode === 'positions' ) {
	
				// Map all percentages to on-range values.
				return values.map(function( value ){
					return scope_Spectrum.fromStepping( stepped ? scope_Spectrum.getStep( value ) : value );
				});
			}
	
			if ( mode === 'values' ) {
	
				// If the value must be stepped, it needs to be converted to a percentage first.
				if ( stepped ) {
	
					return values.map(function( value ){
	
						// Convert to percentage, apply step, return to value.
						return scope_Spectrum.fromStepping( scope_Spectrum.getStep( scope_Spectrum.toStepping( value ) ) );
					});
	
				}
	
				// Otherwise, we can simply use the values.
				return values;
			}
		}
	
		function generateSpread ( density, mode, group ) {
	
			function safeIncrement(value, increment) {
				// Avoid floating point variance by dropping the smallest decimal places.
				return (value + increment).toFixed(7) / 1;
			}
	
			var indexes = {};
			var firstInRange = scope_Spectrum.xVal[0];
			var lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length-1];
			var ignoreFirst = false;
			var ignoreLast = false;
			var prevPct = 0;
	
			// Create a copy of the group, sort it and filter away all duplicates.
			group = unique(group.slice().sort(function(a, b){ return a - b; }));
	
			// Make sure the range starts with the first element.
			if ( group[0] !== firstInRange ) {
				group.unshift(firstInRange);
				ignoreFirst = true;
			}
	
			// Likewise for the last one.
			if ( group[group.length - 1] !== lastInRange ) {
				group.push(lastInRange);
				ignoreLast = true;
			}
	
			group.forEach(function ( current, index ) {
	
				// Get the current step and the lower + upper positions.
				var step;
				var i;
				var q;
				var low = current;
				var high = group[index+1];
				var newPct;
				var pctDifference;
				var pctPos;
				var type;
				var steps;
				var realSteps;
				var stepsize;
	
				// When using 'steps' mode, use the provided steps.
				// Otherwise, we'll step on to the next subrange.
				if ( mode === 'steps' ) {
					step = scope_Spectrum.xNumSteps[ index ];
				}
	
				// Default to a 'full' step.
				if ( !step ) {
					step = high-low;
				}
	
				// Low can be 0, so test for false. If high is undefined,
				// we are at the last subrange. Index 0 is already handled.
				if ( low === false || high === undefined ) {
					return;
				}
	
				// Make sure step isn't 0, which would cause an infinite loop (#654)
				step = Math.max(step, 0.0000001);
	
				// Find all steps in the subrange.
				for ( i = low; i <= high; i = safeIncrement(i, step) ) {
	
					// Get the percentage value for the current step,
					// calculate the size for the subrange.
					newPct = scope_Spectrum.toStepping( i );
					pctDifference = newPct - prevPct;
	
					steps = pctDifference / density;
					realSteps = Math.round(steps);
	
					// This ratio represents the ammount of percentage-space a point indicates.
					// For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-devided.
					// Round the percentage offset to an even number, then divide by two
					// to spread the offset on both sides of the range.
					stepsize = pctDifference/realSteps;
	
					// Divide all points evenly, adding the correct number to this subrange.
					// Run up to <= so that 100% gets a point, event if ignoreLast is set.
					for ( q = 1; q <= realSteps; q += 1 ) {
	
						// The ratio between the rounded value and the actual size might be ~1% off.
						// Correct the percentage offset by the number of points
						// per subrange. density = 1 will result in 100 points on the
						// full range, 2 for 50, 4 for 25, etc.
						pctPos = prevPct + ( q * stepsize );
						indexes[pctPos.toFixed(5)] = ['x', 0];
					}
	
					// Determine the point type.
					type = (group.indexOf(i) > -1) ? 1 : ( mode === 'steps' ? 2 : 0 );
	
					// Enforce the 'ignoreFirst' option by overwriting the type for 0.
					if ( !index && ignoreFirst ) {
						type = 0;
					}
	
					if ( !(i === high && ignoreLast)) {
						// Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
						indexes[newPct.toFixed(5)] = [i, type];
					}
	
					// Update the percentage count.
					prevPct = newPct;
				}
			});
	
			return indexes;
		}
	
		function addMarking ( spread, filterFunc, formatter ) {
	
			var element = document.createElement('div');
			var out = '';
			var valueSizeClasses = [
				options.cssClasses.valueNormal,
				options.cssClasses.valueLarge,
				options.cssClasses.valueSub
			];
			var markerSizeClasses = [
				options.cssClasses.markerNormal,
				options.cssClasses.markerLarge,
				options.cssClasses.markerSub
			];
			var valueOrientationClasses = [
				options.cssClasses.valueHorizontal,
				options.cssClasses.valueVertical
			];
			var markerOrientationClasses = [
				options.cssClasses.markerHorizontal,
				options.cssClasses.markerVertical
			];
	
			addClass(element, options.cssClasses.pips);
			addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);
	
			function getClasses( type, source ){
				var a = source === options.cssClasses.value;
				var orientationClasses = a ? valueOrientationClasses : markerOrientationClasses;
				var sizeClasses = a ? valueSizeClasses : markerSizeClasses;
	
				return source + ' ' + orientationClasses[options.ort] + ' ' + sizeClasses[type];
			}
	
			function getTags( offset, source, values ) {
				return 'class="' + getClasses(values[1], source) + '" style="' + options.style + ': ' + offset + '%"';
			}
	
			function addSpread ( offset, values ){
	
				// Apply the filter function, if it is set.
				values[1] = (values[1] && filterFunc) ? filterFunc(values[0], values[1]) : values[1];
	
				// Add a marker for every point
				out += '<div ' + getTags(offset, options.cssClasses.marker, values) + '></div>';
	
				// Values are only appended for points marked '1' or '2'.
				if ( values[1] ) {
					out += '<div ' + getTags(offset, options.cssClasses.value, values) + '>' + formatter.to(values[0]) + '</div>';
				}
			}
	
			// Append all points.
			Object.keys(spread).forEach(function(a){
				addSpread(a, spread[a]);
			});
	
			element.innerHTML = out;
	
			return element;
		}
	
		function pips ( grid ) {
	
			var mode = grid.mode;
			var density = grid.density || 1;
			var filter = grid.filter || false;
			var values = grid.values || false;
			var stepped = grid.stepped || false;
			var group = getGroup( mode, values, stepped );
			var spread = generateSpread( density, mode, group );
			var format = grid.format || {
				to: Math.round
			};
	
			return scope_Target.appendChild(addMarking(
				spread,
				filter,
				format
			));
		}
	
	
		// Shorthand for base dimensions.
		function baseSize ( ) {
			var rect = scope_Base.getBoundingClientRect(), alt = 'offset' + ['Width', 'Height'][options.ort];
			return options.ort === 0 ? (rect.width||scope_Base[alt]) : (rect.height||scope_Base[alt]);
		}
	
		// Handler for attaching events trough a proxy.
		function attachEvent ( events, element, callback, data ) {
	
			// This function can be used to 'filter' events to the slider.
			// element is a node, not a nodeList
	
			var method = function ( e ){
	
				if ( scope_Target.hasAttribute('disabled') ) {
					return false;
				}
	
				// Stop if an active 'tap' transition is taking place.
				if ( hasClass(scope_Target, options.cssClasses.tap) ) {
					return false;
				}
	
				e = fixEvent(e, data.pageOffset);
	
				// Handle reject of multitouch
				if ( !e ) {
					return false;
				}
	
				// Ignore right or middle clicks on start #454
				if ( events === actions.start && e.buttons !== undefined && e.buttons > 1 ) {
					return false;
				}
	
				// Ignore right or middle clicks on start #454
				if ( data.hover && e.buttons ) {
					return false;
				}
	
				e.calcPoint = e.points[ options.ort ];
	
				// Call the event handler with the event [ and additional data ].
				callback ( e, data );
			};
	
			var methods = [];
	
			// Bind a closure on the target for every event type.
			events.split(' ').forEach(function( eventName ){
				element.addEventListener(eventName, method, false);
				methods.push([eventName, method]);
			});
	
			return methods;
		}
	
		// Provide a clean event with standardized offset values.
		function fixEvent ( e, pageOffset ) {
	
			// Prevent scrolling and panning on touch events, while
			// attempting to slide. The tap event also depends on this.
			e.preventDefault();
	
			// Filter the event to register the type, which can be
			// touch, mouse or pointer. Offset changes need to be
			// made on an event specific basis.
			var touch = e.type.indexOf('touch') === 0;
			var mouse = e.type.indexOf('mouse') === 0;
			var pointer = e.type.indexOf('pointer') === 0;
			var x;
			var y;
	
			// IE10 implemented pointer events with a prefix;
			if ( e.type.indexOf('MSPointer') === 0 ) {
				pointer = true;
			}
	
			if ( touch ) {
	
				// Fix bug when user touches with two or more fingers on mobile devices.
				// It's useful when you have two or more sliders on one page,
				// that can be touched simultaneously.
				// #649, #663, #668
				if ( e.touches.length > 1 ) {
					return false;
				}
	
				// noUiSlider supports one movement at a time,
				// so we can select the first 'changedTouch'.
				x = e.changedTouches[0].pageX;
				y = e.changedTouches[0].pageY;
			}
	
			pageOffset = pageOffset || getPageOffset();
	
			if ( mouse || pointer ) {
				x = e.clientX + pageOffset.x;
				y = e.clientY + pageOffset.y;
			}
	
			e.pageOffset = pageOffset;
			e.points = [x, y];
			e.cursor = mouse || pointer; // Fix #435
	
			return e;
		}
	
		// Translate a coordinate in the document to a percentage on the slider
		function calcPointToPercentage ( calcPoint ) {
			var location = calcPoint - offset(scope_Base, options.ort);
			var proposal = ( location * 100 ) / baseSize();
			return options.dir ? 100 - proposal : proposal;
		}
	
		// Find handle closest to a certain percentage on the slider
		function getClosestHandle ( proposal ) {
	
			var closest = 100;
			var handleNumber = false;
	
			scope_Handles.forEach(function(handle, index){
	
				// Disabled handles are ignored
				if ( handle.hasAttribute('disabled') ) {
					return;
				}
	
				var pos = Math.abs(scope_Locations[index] - proposal);
	
				if ( pos < closest ) {
					handleNumber = index;
					closest = pos;
				}
			});
	
			return handleNumber;
		}
	
		// Moves handle(s) by a percentage
		// (bool, % to move, [% where handle started, ...], [index in scope_Handles, ...])
		function moveHandles ( upward, proposal, locations, handleNumbers ) {
	
			var proposals = locations.slice();
	
			var b = [!upward, upward];
			var f = [upward, !upward];
	
			// Copy handleNumbers so we don't change the dataset
			handleNumbers = handleNumbers.slice();
	
			// Check to see which handle is 'leading'.
			// If that one can't move the second can't either.
			if ( upward ) {
				handleNumbers.reverse();
			}
	
			// Step 1: get the maximum percentage that any of the handles can move
			if ( handleNumbers.length > 1 ) {
	
				handleNumbers.forEach(function(handleNumber, o) {
	
					var to = checkHandlePosition(proposals, handleNumber, proposals[handleNumber] + proposal, b[o], f[o]);
	
					// Stop if one of the handles can't move.
					if ( to === false ) {
						proposal = 0;
					} else {
						proposal = to - proposals[handleNumber];
						proposals[handleNumber] = to;
					}
				});
			}
	
			// If using one handle, check backward AND forward
			else {
				b = f = [true];
			}
	
			var state = false;
	
			// Step 2: Try to set the handles with the found percentage
			handleNumbers.forEach(function(handleNumber, o) {
				state = setHandle(handleNumber, locations[handleNumber] + proposal, b[o], f[o]) || state;
			});
	
			// Step 3: If a handle moved, fire events
			if ( state ) {
				handleNumbers.forEach(function(handleNumber){
					fireEvent('update', handleNumber);
					fireEvent('slide', handleNumber);
				});
			}
		}
	
		// External event handling
		function fireEvent ( eventName, handleNumber, tap ) {
	
			Object.keys(scope_Events).forEach(function( targetEvent ) {
	
				var eventType = targetEvent.split('.')[0];
	
				if ( eventName === eventType ) {
					scope_Events[targetEvent].forEach(function( callback ) {
	
						callback.call(
							// Use the slider public API as the scope ('this')
							scope_Self,
							// Return values as array, so arg_1[arg_2] is always valid.
							scope_Values.map(options.format.to),
							// Handle index, 0 or 1
							handleNumber,
							// Unformatted slider values
							scope_Values.slice(),
							// Event is fired by tap, true or false
							tap || false,
							// Left offset of the handle, in relation to the slider
							scope_Locations.slice()
						);
					});
				}
			});
		}
	
	
		// Fire 'end' when a mouse or pen leaves the document.
		function documentLeave ( event, data ) {
			if ( event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null ){
				eventEnd (event, data);
			}
		}
	
		// Handle movement on document for handle and range drag.
		function eventMove ( event, data ) {
	
			// Fix #498
			// Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
			// https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
			// IE9 has .buttons and .which zero on mousemove.
			// Firefox breaks the spec MDN defines.
			if ( navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0 ) {
				return eventEnd(event, data);
			}
	
			// Check if we are moving up or down
			var movement = (options.dir ? -1 : 1) * (event.calcPoint - data.startCalcPoint);
	
			// Convert the movement into a percentage of the slider width/height
			var proposal = (movement * 100) / data.baseSize;
	
			moveHandles(movement > 0, proposal, data.locations, data.handleNumbers);
		}
	
		// Unbind move events on document, call callbacks.
		function eventEnd ( event, data ) {
	
			// The handle is no longer active, so remove the class.
			if ( scope_ActiveHandle ) {
				removeClass(scope_ActiveHandle, options.cssClasses.active);
				scope_ActiveHandle = false;
			}
	
			// Remove cursor styles and text-selection events bound to the body.
			if ( event.cursor ) {
				document.body.style.cursor = '';
				document.body.removeEventListener('selectstart', document.body.noUiListener);
			}
	
			// Unbind the move and end events, which are added on 'start'.
			document.documentElement.noUiListeners.forEach(function( c ) {
				document.documentElement.removeEventListener(c[0], c[1]);
			});
	
			// Remove dragging class.
			removeClass(scope_Target, options.cssClasses.drag);
	
			setZindex();
	
			data.handleNumbers.forEach(function(handleNumber){
				fireEvent('set', handleNumber);
				fireEvent('change', handleNumber);
				fireEvent('end', handleNumber);
			});
		}
	
		// Bind move events on document.
		function eventStart ( event, data ) {
	
			if ( data.handleNumbers.length === 1 ) {
	
				var handle = scope_Handles[data.handleNumbers[0]];
	
				// Ignore 'disabled' handles
				if ( handle.hasAttribute('disabled') ) {
					return false;
				}
	
				// Mark the handle as 'active' so it can be styled.
				scope_ActiveHandle = handle.children[0];
				addClass(scope_ActiveHandle, options.cssClasses.active);
			}
	
			// Fix #551, where a handle gets selected instead of dragged.
			event.preventDefault();
	
			// A drag should never propagate up to the 'tap' event.
			event.stopPropagation();
	
			// Attach the move and end events.
			var moveEvent = attachEvent(actions.move, document.documentElement, eventMove, {
				startCalcPoint: event.calcPoint,
				baseSize: baseSize(),
				pageOffset: event.pageOffset,
				handleNumbers: data.handleNumbers,
				buttonsProperty: event.buttons,
				locations: scope_Locations.slice()
			});
	
			var endEvent = attachEvent(actions.end, document.documentElement, eventEnd, {
				handleNumbers: data.handleNumbers
			});
	
			var outEvent = attachEvent("mouseout", document.documentElement, documentLeave, {
				handleNumbers: data.handleNumbers
			});
	
			document.documentElement.noUiListeners = moveEvent.concat(endEvent, outEvent);
	
			// Text selection isn't an issue on touch devices,
			// so adding cursor styles can be skipped.
			if ( event.cursor ) {
	
				// Prevent the 'I' cursor and extend the range-drag cursor.
				document.body.style.cursor = getComputedStyle(event.target).cursor;
	
				// Mark the target with a dragging state.
				if ( scope_Handles.length > 1 ) {
					addClass(scope_Target, options.cssClasses.drag);
				}
	
				var f = function(){
					return false;
				};
	
				document.body.noUiListener = f;
	
				// Prevent text selection when dragging the handles.
				document.body.addEventListener('selectstart', f, false);
			}
	
			data.handleNumbers.forEach(function(handleNumber){
				fireEvent('start', handleNumber);
			});
		}
	
		// Move closest handle to tapped location.
		function eventTap ( event ) {
	
			// The tap event shouldn't propagate up
			event.stopPropagation();
	
			var proposal = calcPointToPercentage(event.calcPoint);
			var handleNumber = getClosestHandle(proposal);
	
			// Tackle the case that all handles are 'disabled'.
			if ( handleNumber === false ) {
				return false;
			}
	
			// Flag the slider as it is now in a transitional state.
			// Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
			if ( !options.events.snap ) {
				addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
			}
	
			setHandle(handleNumber, proposal, true, true);
	
			setZindex();
	
			fireEvent('slide', handleNumber, true);
			fireEvent('set', handleNumber, true);
			fireEvent('change', handleNumber, true);
			fireEvent('update', handleNumber, true);
	
			if ( options.events.snap ) {
				eventStart(event, { handleNumbers: [handleNumber] });
			}
		}
	
		// Fires a 'hover' event for a hovered mouse/pen position.
		function eventHover ( event ) {
	
			var proposal = calcPointToPercentage(event.calcPoint);
	
			var to = scope_Spectrum.getStep(proposal);
			var value = scope_Spectrum.fromStepping(to);
	
			Object.keys(scope_Events).forEach(function( targetEvent ) {
				if ( 'hover' === targetEvent.split('.')[0] ) {
					scope_Events[targetEvent].forEach(function( callback ) {
						callback.call( scope_Self, value );
					});
				}
			});
		}
	
		// Attach events to several slider parts.
		function bindSliderEvents ( behaviour ) {
	
			// Attach the standard drag event to the handles.
			if ( !behaviour.fixed ) {
	
				scope_Handles.forEach(function( handle, index ){
	
					// These events are only bound to the visual handle
					// element, not the 'real' origin element.
					attachEvent ( actions.start, handle.children[0], eventStart, {
						handleNumbers: [index]
					});
				});
			}
	
			// Attach the tap event to the slider base.
			if ( behaviour.tap ) {
				attachEvent (actions.start, scope_Base, eventTap, {});
			}
	
			// Fire hover events
			if ( behaviour.hover ) {
				attachEvent (actions.move, scope_Base, eventHover, { hover: true });
			}
	
			// Make the range draggable.
			if ( behaviour.drag ){
	
				scope_Connects.forEach(function( connect, index ){
	
					if ( connect === false || index === 0 || index === scope_Connects.length - 1 ) {
						return;
					}
	
					var handleBefore = scope_Handles[index - 1];
					var handleAfter = scope_Handles[index];
					var eventHolders = [connect];
	
					addClass(connect, options.cssClasses.draggable);
	
					// When the range is fixed, the entire range can
					// be dragged by the handles. The handle in the first
					// origin will propagate the start event upward,
					// but it needs to be bound manually on the other.
					if ( behaviour.fixed ) {
						eventHolders.push(handleBefore.children[0]);
						eventHolders.push(handleAfter.children[0]);
					}
	
					eventHolders.forEach(function( eventHolder ) {
						attachEvent ( actions.start, eventHolder, eventStart, {
							handles: [handleBefore, handleAfter],
							handleNumbers: [index - 1, index]
						});
					});
				});
			}
		}
	
	
		// Split out the handle positioning logic so the Move event can use it, too
		function checkHandlePosition ( reference, handleNumber, to, lookBackward, lookForward ) {
	
			// For sliders with multiple handles, limit movement to the other handle.
			// Apply the margin option by adding it to the handle positions.
			if ( scope_Handles.length > 1 ) {
	
				if ( lookBackward && handleNumber > 0 ) {
					to = Math.max(to, reference[handleNumber - 1] + options.margin);
				}
	
				if ( lookForward && handleNumber < scope_Handles.length - 1 ) {
					to = Math.min(to, reference[handleNumber + 1] - options.margin);
				}
			}
	
			// The limit option has the opposite effect, limiting handles to a
			// maximum distance from another. Limit must be > 0, as otherwise
			// handles would be unmoveable.
			if ( scope_Handles.length > 1 && options.limit ) {
	
				if ( lookBackward && handleNumber > 0 ) {
					to = Math.min(to, reference[handleNumber - 1] + options.limit);
				}
	
				if ( lookForward && handleNumber < scope_Handles.length - 1 ) {
					to = Math.max(to, reference[handleNumber + 1] - options.limit);
				}
			}
	
			// The padding option keeps the handles a certain distance from the
			// edges of the slider. Padding must be > 0.
			if ( options.padding ) {
	
				if ( handleNumber === 0 ) {
					to = Math.max(to, options.padding);
				}
	
				if ( handleNumber === scope_Handles.length - 1 ) {
					to = Math.min(to, 100 - options.padding);
				}
			}
	
			to = scope_Spectrum.getStep(to);
	
			// Limit percentage to the 0 - 100 range
			to = limit(to);
	
			// Return false if handle can't move
			if ( to === reference[handleNumber] ) {
				return false;
			}
	
			return to;
		}
	
		function toPct ( pct ) {
			return pct + '%';
		}
	
		// Updates scope_Locations and scope_Values, updates visual state
		function updateHandlePosition ( handleNumber, to ) {
	
			// Update locations.
			scope_Locations[handleNumber] = to;
	
			// Convert the value to the slider stepping/range.
			scope_Values[handleNumber] = scope_Spectrum.fromStepping(to);
	
			// Called synchronously or on the next animationFrame
			var stateUpdate = function() {
				scope_Handles[handleNumber].style[options.style] = toPct(to);
				updateConnect(handleNumber);
				updateConnect(handleNumber + 1);
			};
	
			// Set the handle to the new position.
			// Use requestAnimationFrame for efficient painting.
			// No significant effect in Chrome, Edge sees dramatic performace improvements.
			// Option to disable is useful for unit tests, and single-step debugging.
			if ( window.requestAnimationFrame && options.useRequestAnimationFrame ) {
				window.requestAnimationFrame(stateUpdate);
			} else {
				stateUpdate();
			}
		}
	
		function setZindex ( ) {
	
			scope_HandleNumbers.forEach(function(handleNumber){
				// Handles before the slider middle are stacked later = higher,
				// Handles after the middle later is lower
				// [[7] [8] .......... | .......... [5] [4]
				var dir = (scope_Locations[handleNumber] > 50 ? -1 : 1);
				var zIndex = 3 + (scope_Handles.length + (dir * handleNumber));
				scope_Handles[handleNumber].childNodes[0].style.zIndex = zIndex;
			});
		}
	
		// Test suggested values and apply margin, step.
		function setHandle ( handleNumber, to, lookBackward, lookForward ) {
	
			to = checkHandlePosition(scope_Locations, handleNumber, to, lookBackward, lookForward);
	
			if ( to === false ) {
				return false;
			}
	
			updateHandlePosition(handleNumber, to);
	
			return true;
		}
	
		// Updates style attribute for connect nodes
		function updateConnect ( index ) {
	
			// Skip connects set to false
			if ( !scope_Connects[index] ) {
				return;
			}
	
			var l = 0;
			var h = 100;
	
			if ( index !== 0 ) {
				l = scope_Locations[index - 1];
			}
	
			if ( index !== scope_Connects.length - 1 ) {
				h = scope_Locations[index];
			}
	
			scope_Connects[index].style[options.style] = toPct(l);
			scope_Connects[index].style[options.styleOposite] = toPct(100 - h);
		}
	
		// ...
		function setValue ( to, handleNumber ) {
	
			// Setting with null indicates an 'ignore'.
			// Inputting 'false' is invalid.
			if ( to === null || to === false ) {
				return;
			}
	
			// If a formatted number was passed, attemt to decode it.
			if ( typeof to === 'number' ) {
				to = String(to);
			}
	
			to = options.format.from(to);
	
			// Request an update for all links if the value was invalid.
			// Do so too if setting the handle fails.
			if ( to !== false && !isNaN(to) ) {
				setHandle(handleNumber, scope_Spectrum.toStepping(to), false, false);
			}
		}
	
		// Set the slider value.
		function valueSet ( input, fireSetEvent ) {
	
			var values = asArray(input);
			var isInit = scope_Locations[0] === undefined;
	
			// Event fires by default
			fireSetEvent = (fireSetEvent === undefined ? true : !!fireSetEvent);
	
			values.forEach(setValue);
	
			// Animation is optional.
			// Make sure the initial values were set before using animated placement.
			if ( options.animate && !isInit ) {
				addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
			}
	
			// Now that all base values are set, apply constraints
			scope_HandleNumbers.forEach(function(handleNumber){
				setHandle(handleNumber, scope_Locations[handleNumber], true, false);
			});
	
			setZindex();
	
			scope_HandleNumbers.forEach(function(handleNumber){
	
				fireEvent('update', handleNumber);
	
				// Fire the event only for handles that received a new value, as per #579
				if ( values[handleNumber] !== null && fireSetEvent ) {
					fireEvent('set', handleNumber);
				}
			});
		}
	
		// Reset slider to initial values
		function valueReset ( fireSetEvent ) {
			valueSet(options.start, fireSetEvent);
		}
	
		// Get the slider value.
		function valueGet ( ) {
	
			var values = scope_Values.map(options.format.to);
	
			// If only one handle is used, return a single value.
			if ( values.length === 1 ){
				return values[0];
			}
	
			return values;
		}
	
		// Removes classes from the root and empties it.
		function destroy ( ) {
	
			for ( var key in options.cssClasses ) {
				if ( !options.cssClasses.hasOwnProperty(key) ) { continue; }
				removeClass(scope_Target, options.cssClasses[key]);
			}
	
			while (scope_Target.firstChild) {
				scope_Target.removeChild(scope_Target.firstChild);
			}
	
			delete scope_Target.noUiSlider;
		}
	
		// Get the current step size for the slider.
		function getCurrentStep ( ) {
	
			// Check all locations, map them to their stepping point.
			// Get the step point, then find it in the input list.
			return scope_Locations.map(function( location, index ){
	
				var nearbySteps = scope_Spectrum.getNearbySteps( location );
				var value = scope_Values[index];
				var increment = nearbySteps.thisStep.step;
				var decrement = null;
	
				// If the next value in this step moves into the next step,
				// the increment is the start of the next step - the current value
				if ( increment !== false ) {
					if ( value + increment > nearbySteps.stepAfter.startValue ) {
						increment = nearbySteps.stepAfter.startValue - value;
					}
				}
	
	
				// If the value is beyond the starting point
				if ( value > nearbySteps.thisStep.startValue ) {
					decrement = nearbySteps.thisStep.step;
				}
	
				else if ( nearbySteps.stepBefore.step === false ) {
					decrement = false;
				}
	
				// If a handle is at the start of a step, it always steps back into the previous step first
				else {
					decrement = value - nearbySteps.stepBefore.highestStep;
				}
	
	
				// Now, if at the slider edges, there is not in/decrement
				if ( location === 100 ) {
					increment = null;
				}
	
				else if ( location === 0 ) {
					decrement = null;
				}
	
				// As per #391, the comparison for the decrement step can have some rounding issues.
				var stepDecimals = scope_Spectrum.countStepDecimals();
	
				// Round per #391
				if ( increment !== null && increment !== false ) {
					increment = Number(increment.toFixed(stepDecimals));
				}
	
				if ( decrement !== null && decrement !== false ) {
					decrement = Number(decrement.toFixed(stepDecimals));
				}
	
				return [decrement, increment];
			});
		}
	
		// Attach an event to this slider, possibly including a namespace
		function bindEvent ( namespacedEvent, callback ) {
			scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
			scope_Events[namespacedEvent].push(callback);
	
			// If the event bound is 'update,' fire it immediately for all handles.
			if ( namespacedEvent.split('.')[0] === 'update' ) {
				scope_Handles.forEach(function(a, index){
					fireEvent('update', index);
				});
			}
		}
	
		// Undo attachment of event
		function removeEvent ( namespacedEvent ) {
	
			var event = namespacedEvent && namespacedEvent.split('.')[0];
			var namespace = event && namespacedEvent.substring(event.length);
	
			Object.keys(scope_Events).forEach(function( bind ){
	
				var tEvent = bind.split('.')[0],
					tNamespace = bind.substring(tEvent.length);
	
				if ( (!event || event === tEvent) && (!namespace || namespace === tNamespace) ) {
					delete scope_Events[bind];
				}
			});
		}
	
		// Updateable: margin, limit, padding, step, range, animate, snap
		function updateOptions ( optionsToUpdate, fireSetEvent ) {
	
			// Spectrum is created using the range, snap, direction and step options.
			// 'snap' and 'step' can be updated, 'direction' cannot, due to event binding.
			// If 'snap' and 'step' are not passed, they should remain unchanged.
			var v = valueGet();
	
			var updateAble = ['margin', 'limit', 'padding', 'range', 'animate', 'snap', 'step', 'format'];
	
			// Only change options that we're actually passed to update.
			updateAble.forEach(function(name){
				if ( optionsToUpdate[name] !== undefined ) {
					originalOptions[name] = optionsToUpdate[name];
				}
			});
	
			var newOptions = testOptions(originalOptions);
	
			// Load new options into the slider state
			updateAble.forEach(function(name){
				if ( optionsToUpdate[name] !== undefined ) {
					options[name] = newOptions[name];
				}
			});
	
			// Save current spectrum direction as testOptions in testRange call
			// doesn't rely on current direction
			newOptions.spectrum.direction = scope_Spectrum.direction;
			scope_Spectrum = newOptions.spectrum;
	
			// Limit, margin and padding depend on the spectrum but are stored outside of it. (#677)
			options.margin = newOptions.margin;
			options.limit = newOptions.limit;
			options.padding = newOptions.padding;
	
			// Invalidate the current positioning so valueSet forces an update.
			scope_Locations = [];
			valueSet(optionsToUpdate.start || v, fireSetEvent);
		}
	
		// Throw an error if the slider was already initialized.
		if ( scope_Target.noUiSlider ) {
			throw new Error("noUiSlider (" + VERSION + "): Slider was already initialized.");
		}
	
		// Create the base element, initialise HTML and set classes.
		// Add handles and connect elements.
		addSlider(scope_Target);
		addElements(options.connect, scope_Base);
	
		scope_Self = {
			destroy: destroy,
			steps: getCurrentStep,
			on: bindEvent,
			off: removeEvent,
			get: valueGet,
			set: valueSet,
			reset: valueReset,
			// Exposed for unit testing, don't use this in your application.
			__moveHandles: function(a, b, c) { moveHandles(a, b, scope_Locations, c); },
			options: originalOptions, // Issue #600, #678
			updateOptions: updateOptions,
			target: scope_Target, // Issue #597
			pips: pips // Issue #594
		};
	
		// Attach user events.
		bindSliderEvents(options.events);
	
		// Use the public value method to set the start values.
		valueSet(options.start);
	
		if ( options.pips ) {
			pips(options.pips);
		}
	
		if ( options.tooltips ) {
			tooltips();
		}
	
		return scope_Self;
	
	}
	
	
		// Run the standard initializer
		function initialize ( target, originalOptions ) {
	
			if ( !target.nodeName ) {
				throw new Error("noUiSlider (" + VERSION + "): create requires a single element.");
			}
	
			// Test the options and create the slider environment;
			var options = testOptions( originalOptions, target );
			var api = closure( target, options, originalOptions );
	
			target.noUiSlider = api;
	
			return api;
		}
	
		// Use an object instead of a function for future expansibility;
		return {
			version: VERSION,
			create: initialize
		};
	
	}));

/***/ },
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _default_config = __webpack_require__(284);
	
	var _default_config2 = _interopRequireDefault(_default_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var options = function (_config) {
	  (0, _inherits3.default)(options, _config);
	
	  function options() {
	    (0, _classCallCheck3.default)(this, options);
	    return (0, _possibleConstructorReturn3.default)(this, (options.__proto__ || (0, _getPrototypeOf2.default)(options)).apply(this, arguments));
	  }
	
	  return options;
	}(_default_config2.default);
	
	options.editor = "Mediahuis";
	options.redirectReaderFromIframe = true;
	options.returnToIframeUrl = "https://standaard.be/digitalekrant";
	options.page_ratio = 1.4745;
	options.page_width_reference = 100000;
	options.page_height_reference = 100000;
	options.page_ratio = 1.4745;
	options.page_width_reference = 100000;
	options.page_height_reference = 100000;
	options.usePdfDesktop = true;
	options.usePdfPhoneNot = [["Safari", "iOS", "version_8"], ["Safari", "iOS", "version_7"]];
	options.usePdfPhone = true;
	options.usePdfTabletNot = [["Safari", "iOS", "version_8"], ["Safari", "iOS", "version_7"]];
	options.usePdfTablet = true;
	options.replicaReadingModeToggle = {
	  phone: false,
	  tablet: true,
	  desktop: true
	};
	options.pdfThreshold = { width: 825, height: 1050 };
	options.displayViewerOptions = true;
	options.printCroppedPdf = true;
	options.zoomSteps = 5;
	options.useSliderForPromospot = true;
	options.useSliderForHorsSeries = true;
	options.useSliderForArchive = true;
	options.subscriptionOptions = {
	  subscriptionType: "subscription",
	  subscriptionProvider: "MHU1P"
	};
	options.SSOEnabled = true;
	options.getSSOTokenFromUrl = true;
	options.urlSSOTokenParameter = "token";
	options.urlRedirectParameter = "goto";
	options.shareFromReader = true;
	options.shareFromNextgen = false;
	options.sharingEnabled = true;
	options.sharingOptions = {
	  Facebook: true,
	  WhatsApp: true,
	  GooglePlus: false,
	  Twitter: true,
	  Mail: true,
	  MailSubject: null,
	  MailSubjectIntro: ""
	};
	options.socialSharingHash = "social";
	exports.default = options;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _nl_BE = __webpack_require__(406);
	
	var _nl_BE2 = _interopRequireDefault(_nl_BE);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import language from "./../../src/common/i18n/da_DK.json";
	
	var dictionary = _nl_BE2.default; //eslint-disable-line
	// if needed change some strings here or add some
	// select the correct language here
	// import language from "./../../src/common/i18n/en_uk.json";
	// import language from "./../../src/common/i18n/de_de.json";
	// import language from "./../../src/common/i18n/et_EE.json";
	// import language from "./../../src/common/i18n/fr_FR.json";
	// import language from "./../../src/common/i18n/fr_BE.json";
	// import language from "./../../src/common/i18n/nl_NL.json";
	dictionary.notifications_title = "oops";
	dictionary.Promospot = "Andere bijlagen";
	dictionary.HorsSeries = "Weekendbijlagen";
	exports.default = dictionary;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _analyticsevents = __webpack_require__(9);
	
	var analyticsEvents = _interopRequireWildcard(_analyticsevents);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsManagerBase = function (_Emitter) {
	  (0, _inherits3.default)(AnalyticsManagerBase, _Emitter);
	
	  function AnalyticsManagerBase() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var appAnalyticOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    (0, _classCallCheck3.default)(this, AnalyticsManagerBase);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsManagerBase.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsManagerBase)).call(this));
	
	    _this._events = analyticsEvents;
	    _this._options = options;
	    _this.cmpManager = null;
	    _this._appAnalyticOptions = appAnalyticOptions;
	    return _this;
	  }
	
	  (0, _createClass3.default)(AnalyticsManagerBase, [{
	    key: "handleEvent",
	    value: function handleEvent(eventType, appState) {
	      // TODO handle some error handling on the event here
	      this.trigger(eventType, appState);
	    }
	
	    /**
	     * Returns a new, modified URL to be used when clicking on enrichments.
	     *
	     * This method should be overwritten in the `AnalyticsManager` of a client,
	     * if such behaviour is required. The default implementation returns `undefined`,
	     * resulting in no modifications to the URL.
	     * @param {string} url the base URL.
	     * @returns {string | undefined} a modified URL, or `undefined` if no modifications are required.
	     */
	    // eslint-disable-next-line no-unused-vars
	
	  }, {
	    key: "checkEnrichmentUrl",
	    value: function checkEnrichmentUrl(url) {
	      return undefined;
	    }
	  }]);
	  return AnalyticsManagerBase;
	}(_es6EventEmitter2.default);
	
	exports.default = AnalyticsManagerBase;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _DOMUtils = __webpack_require__(95);
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clientPackage = __webpack_require__(122);
	var clientConfig = __webpack_require__(54).default;
	
	/**
	 * Appstate base handles the analytics
	 */
	
	var AppStateBase = function (_Emitter) {
	  (0, _inherits3.default)(AppStateBase, _Emitter);
	
	  //changed when authenticated
	  //done
	  // set in the beginning of new SessionManager if in cookie,
	  // if new session/old session is checked in sessionmanager this changes
	
	  // Name
	  // Label
	  // Date
	  // Id
	  // ExternalReference
	  // PublicationType(Main, suplement)
	  // PublicationFormat(Replica, NextGen)
	
	  /**
	   * Content
	   */
	  // changed when cpStore is loaded again
	  function AppStateBase(analyticsManager) {
	    (0, _classCallCheck3.default)(this, AppStateBase);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AppStateBase.__proto__ || (0, _getPrototypeOf2.default)(AppStateBase)).call(this));
	
	    _this.contentPackage = null;
	    _this.activePublication = null;
	    _this.activePages = [];
	    _this.uuid = null;
	    _this.userId = null;
	    _this.sessionId = null;
	    _this.loginInformation = null;
	    _this.defaultPagePercentageInView = 100;
	    _this.buildVersion = null;
	    _this.platformVersion = null;
	    _this.lastActivePageData = null;
	    _this.socialSharing = null;
	
	    _this.buildVersion = clientPackage.version;
	    _this.browserDetails = {
	      navigatorName: (0, _DOMUtils.getBrowser)().name,
	      navigatorVersion: (0, _DOMUtils.getBrowser)().version
	    };
	    //TODO: create in app
	    _this.analyticsManager = analyticsManager;
	    return _this;
	  } //done
	  // subscriptionId
	  // SubscriptionReference
	  // UserSubscriptionReference
	  // SubscriptionType
	
	  // if new session/old session is checked in sessionmanager this changes
	
	
	  /**
	   * User info
	   */
	  //only set once when a new SessionManager is created (in App)
	
	  // Name
	  // Label
	  // Date
	  // Id
	  // ContentPackageType (Hors Serie, Free, ...)
	  // Price
	  // changed when pubStore is loaded again
	
	
	  (0, _createClass3.default)(AppStateBase, [{
	    key: "triggerEvent",
	    value: function triggerEvent(event) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var merge = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var eventData = this._getAnalyticAppState(event);
	      if (data) {
	        if (merge) {
	          eventData = (0, _extends3.default)({}, eventData, data);
	        } else {
	          eventData = data;
	        }
	      }
	      this.analyticsManager.handleEvent(event, eventData);
	      if ((0, _utils.areEventsTracked)()) console.log(event, this._getAnalyticAppState(event)); // eslint-disable-line
	    }
	  }, {
	    key: "setPagesPercentageInView",
	    value: function setPagesPercentageInView(singlePageMode) {
	      this.defaultPagePercentageInView = singlePageMode ? 100 : 50;
	    }
	
	    /**
	     * Sets pages that are currently active (viewed by user) in replica reader
	     * @param {Array} data List of pages (one or two depending on view mode) with articles
	     * @param {Object} percentageInView Object containing percentageInView for pages and articles
	     */
	
	  }, {
	    key: "setActivePages",
	    value: function setActivePages(data) {
	      var _this2 = this;
	
	      var percentageInView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.lastActivePageData = data;
	      this.activePages = data.map(function (page) {
	        var item = null;
	
	        if (page) {
	          var publicationPageId = page.PublicationPageId ? page.PublicationPageId : page.PublicationPageID;
	          item = _this2._createActivePage(page, percentageInView["page_" + publicationPageId]);
	          item.articles = page.content.map(function (content) {
	            return _this2._createActiveArticle(content, percentageInView["article_" + content.ContentID]);
	          });
	        }
	        return item;
	      });
	    }
	
	    /**
	     * Sets pages that are currently active (viewed by user) in nextgen reader. Data for pages and
	     * articles can be setup in two ways:
	     *
	     * 1. generated based on page data from pubStore (this is used in bridge onPageAccess method)
	     * 2. data are taken from ER SDK that sends correct object already, so we can just replace current object
	     *
	     * @param {Object}  nextgenPage nextgen page object
	     * @param {Boolean} replace     should we assign nexgenPage to this.activePages as it is
	     */
	
	  }, {
	    key: "setActiveNextgenPage",
	    value: function setActiveNextgenPage(nextgenPage) {
	      var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (replace) {
	        this.activePages = nextgenPage;
	      } else {
	        var page = {
	          pageTemplate: nextgenPage.PageTemplate.Name,
	          pageReference: nextgenPage.PublicationPageId.toString(),
	          pagePosition: nextgenPage.PageNumber,
	          section: nextgenPage.PageCategory,
	          thumbnailURL: "" + (0, _utils.generatePreview)("640/900", nextgenPage.PublicationPageId),
	          percentageInView: 100,
	          properties: {},
	          articles: this._createActiveNextgenArticles(nextgenPage.PageTemplate.Blocks, nextgenPage)
	        };
	
	        this.activePages = [page];
	      }
	    }
	  }, {
	    key: "albClosed",
	    value: function albClosed() {
	      if (this.lastActivePageData) {
	        this.setActivePages(this.lastActivePageData);
	      }
	    }
	
	    /**
	     * Sets active page and active article when ALB is rendered
	     * @param {Object} page Active page
	     * @param {Object} article Article shown in ALB
	     */
	
	  }, {
	    key: "setActiveArticle",
	    value: function setActiveArticle(page, article) {
	      var activePage = this._createActivePage(page, 100);
	      activePage.articles = [this._createActiveArticle(article, 100)];
	      this.activePages = [activePage];
	    }
	  }, {
	    key: "setUserInfo",
	    value: function setUserInfo(data) {
	      var userReference = data[clientConfig.erUserReferenceType];
	      this.subscriptionReference = data.subscriptionReference;
	      this.userSubscriptionType = data.userSubscriptionType;
	
	      this.userInfo = {
	        userReference: userReference,
	        type: userReference === null ? "anonymous" : "subscriber",
	        subscriptionReference: this.subscriptionReference,
	        properties: {}
	      };
	    }
	  }, {
	    key: "setContentPackage",
	    value: function setContentPackage(data, cpDate, region, DownloadToken) {
	      this.contentPackage = {
	        bundleReference: data.ContentPackageId.toString(),
	        bundleDateTime: cpDate + "Z",
	        bundleName: data.ContentPackageName,
	        editionName: region !== null ? region.Description : null,
	        downloadToken: DownloadToken,
	        productName: data.ProductName,
	        properties: {}
	      };
	    }
	  }, {
	    key: "modifyContentPackage",
	    value: function modifyContentPackage(data) {
	      this.contentPackage.bundleReference = data.ContentPackageId.toString();
	      this.contentPackage.bundleDateTime = data.PublicationDate + "Z";
	    }
	
	    ////////////////
	
	  }, {
	    key: "_createActiveNextgenArticles",
	    value: function _createActiveNextgenArticles(blocks, page) {
	      return blocks.reduce(function (acc, block) {
	        block.Contents.forEach(function (content) {
	          acc.push({
	            articleReference: content.ExternalContentReference || (0, _utils.stripHtml)(content.Title),
	            title: (0, _utils.stripHtml)(content.Title),
	            author: content.Authors.length > 0 ? content.Authors[0].Name : null,
	            percentageInView: 0,
	            wordCount: 0,
	            properties: {
	              template: page.PageTemplate.Name,
	              block: block.Name,
	              blockPosition: content.ContentPosition,
	              numberOfImages: content.Media.Images.length,
	              numberOfVideos: content.Media.Videos.length
	            }
	          });
	        });
	
	        return acc;
	      }, []);
	    }
	  }, {
	    key: "_getAnalyticAppState",
	    value: function _getAnalyticAppState(event) {
	      return {
	        eventOrigin: event,
	        eventData: {
	          bundle: this._getBundleInfo()
	        },
	        user: this.userInfo,
	        deviceContext: {
	          app: this._getAppInfo(),
	          appContext: {
	            socialSharing: this.socialSharing
	          },
	          device: (0, _extends3.default)({
	            deviceType: "WebApp",
	            os: window.navigator.platform,
	            screenWidth: window.innerWidth,
	            screenHeight: window.innerHeight
	          }, this.browserDetails)
	        }
	      };
	    }
	  }, {
	    key: "_getBundleInfo",
	    value: function _getBundleInfo() {
	      return (0, _extends3.default)({}, this.contentPackage, {
	        publication: {
	          publicationReference: this.activePublication ? this.activePublication.Id : null,
	          publicationName: this.activePublication ? this.activePublication.Name : null,
	          format: this.activePublication ? this.activePublication.PublicationFormat : null,
	          type: this.activePublication ? this.activePublication.PublicationType : null,
	          properties: {},
	          pages: (0, _utils.compact)(this.activePages)
	        }
	      });
	    }
	  }, {
	    key: "_getAppInfo",
	    value: function _getAppInfo() {
	      return {
	        appVersion: this.buildVersion,
	        appName: clientPackage.client_fullname + " - webApp"
	      };
	    }
	  }, {
	    key: "_createActivePage",
	    value: function _createActivePage(page, percentageInView) {
	      var publicationPageId = page.PublicationPageId ? page.PublicationPageId : page.PublicationPageID;
	      var activePage = {
	        articles: page.articles,
	        pageReference: page.ExternalPageReference,
	        pagePosition: page.PageNumber,
	        section: page.PageCategory,
	        percentageInView: percentageInView === undefined ? this.defaultPagePercentageInView : percentageInView,
	        properties: {},
	        thumbnailURL: "" + (0, _utils.generatePreview)("240/440", publicationPageId)
	        //create thumbnailURL since noSecuredThumbUrl is onlyplaced after opening of bottomNavigation
	        // thumbnailURL: page.noSecuredThumbUrl,
	      };
	      return activePage;
	    }
	  }, {
	    key: "_createActiveArticle",
	    value: function _createActiveArticle(content, percentageInView) {
	      var article = {
	        author: content && content.contentItemContent() && content.contentItemContent().author ? content.contentItemContent().author.Author : "",
	        articleReference: content.ExternalContentReference,
	        title: content && content.contentItemContent() ? content.contentItemContent().title : "",
	        wordCount: content && content.contentItemContent() ? content.contentItemContent().wordCount : 0,
	        percentageInView: this._calculateArticlePercentageInView(content, percentageInView),
	        properties: {
	          numberOfImages: content && content.contentItemContent() ? content.contentItemContent().images.length : 0,
	          surfaceAreaPercentage: content.defaultPercentageInView
	        }
	      };
	      return article;
	    }
	  }, {
	    key: "_calculateArticlePercentageInView",
	    value: function _calculateArticlePercentageInView(content, passedPercentageInView) {
	      if (passedPercentageInView === undefined) {
	        return content.defaultPercentageInView * this.defaultPagePercentageInView / 100;
	      } else {
	        return passedPercentageInView;
	      }
	    }
	  }, {
	    key: "activePublication",
	    set: function set(data) {
	      if (data && data.PublicationFormat) {
	        data.PublicationFormat = data.PublicationFormat === "TabletOptimized" ? "Nextgen" : "Replica";
	      }
	      this._activePublication = data;
	    },
	    get: function get() {
	      return this._activePublication;
	    }
	  }]);
	  return AppStateBase;
	}(_es6EventEmitter2.default);
	
	exports.default = AppStateBase;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultAnalyticsConfig = function DefaultAnalyticsConfig() {
	  (0, _classCallCheck3.default)(this, DefaultAnalyticsConfig);
	};
	
	DefaultAnalyticsConfig.titleReplicaReader = "ReplicaReader";
	DefaultAnalyticsConfig.titleNextgenReader = "NextgenReader";
	DefaultAnalyticsConfig.titleReplicaReaderInBackground = "BackgroundReplicaReader";
	DefaultAnalyticsConfig.titleArticleLightBox = "ArticleLightBox";
	DefaultAnalyticsConfig.titleGallery = "ImageGallery";
	DefaultAnalyticsConfig.titleHome = "Home";
	DefaultAnalyticsConfig.titlePayWall = "PayWall";
	DefaultAnalyticsConfig.titleSupplementsOverview = "SupplementsOverview";
	DefaultAnalyticsConfig.erTag = "335c0dc60397467ab96682f73d5f6311";
	DefaultAnalyticsConfig.erUserReferenceType = "subscriptionUserReference";
	DefaultAnalyticsConfig.useGA = true;
	DefaultAnalyticsConfig.useGTM = false;
	DefaultAnalyticsConfig.xitiPageViewsOnlyTagging = true;
	exports.default = DefaultAnalyticsConfig;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DOMUtils = __webpack_require__(95);
	
	var _bridge = __webpack_require__(261);
	
	var _bridge2 = _interopRequireDefault(_bridge);
	
	var _URLRouter = __webpack_require__(40);
	
	var _URLRouter2 = _interopRequireDefault(_URLRouter);
	
	var _readerBrowsingHistoryComponent = __webpack_require__(273);
	
	var _readerBrowsingHistoryComponent2 = _interopRequireDefault(_readerBrowsingHistoryComponent);
	
	var _cpStore = __webpack_require__(286);
	
	var _cpStore2 = _interopRequireDefault(_cpStore);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _contentmanager = __webpack_require__(96);
	
	var _contentmanager2 = _interopRequireDefault(_contentmanager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This is mixin for appReader classes. It contains methods shared between touch and web
	 * appReader class
	 * @type {Object}
	 */
	var appReaderMixin = {
	  /**
	   * Injects nextgen style and js files (only for clients that have support for nextgen,
	   * see client package.json)
	   */
	  injectNextgenAssets: function injectNextgenAssets() {
	    if (true) {
	      (0, _DOMUtils.injectStyles)("../NextGenViewer/css/style.css?t=" + ("1.0.0.0"));
	      (0, _DOMUtils.injectScript)("../NextGenViewer/NextGenViewer.js?t=" + ("1.0.0.0"), this._appState.nextgenLoaded.bind(this._appState), true);
	    }
	  },
	
	
	  /**
	   * Initialises bridge object (only for clients that have support for nextgen,
	   * see client package.json)
	   */
	  initBridge: function initBridge() {
	    if (true) {
	      window.bridge = new _bridge2.default(this._appState, this.pubStore, this.options);
	    }
	  },
	
	
	  /**
	   * Initialises cp store
	   * @param  {array} additionalDownloadTokens additional download tokens
	   */
	  initCpStore: function initCpStore(additionalDownloadTokens) {
	    var _this = this;
	
	    this.cpStore = new _cpStore2.default(_apimanager2.default, _contentmanager2.default, this.contentPackageId, additionalDownloadTokens, this.options.cpStore);
	    this.cpStore.on("cpStore:loaded", function () {
	      _this.onCpLoaded();
	    });
	    this.cpStore.load();
	  },
	
	
	  /**
	   * Initialises browsing history
	   */
	  initHistory: function initHistory() {
	    this.history = new _URLRouter2.default();
	    this.readerBrowsingHistory = new _readerBrowsingHistoryComponent2.default(this.history, this._appState);
	    this.readerBrowsingHistory.trackHistory();
	  },
	
	
	  /**
	   * Setups active publication in app state
	   */
	  setupPublicationInAppState: function setupPublicationInAppState() {
	    this._appState.activePublication = {
	      Name: this.pubStore.PublicationToLoad.PublicationName,
	      Date: this.pubStore.PublicationToLoad.PublicationDate,
	      Id: this.pubStore.PublicationToLoad.PublicationId,
	      PublicationType: this.pubStore.PublicationToLoad.PublicationType,
	      PublicationFormat: this.pubStore.PublicationToLoad.PublicationTitleFormat
	    };
	  }
	};
	
	exports.default = appReaderMixin;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _albController = __webpack_require__(375);
	
	var _albController2 = _interopRequireDefault(_albController);
	
	var _enrichmentButton = __webpack_require__(117);
	
	var _enrichmentButton2 = _interopRequireDefault(_enrichmentButton);
	
	var _fontSizeService = __webpack_require__(266);
	
	var _fontSizeService2 = _interopRequireDefault(_fontSizeService);
	
	var _albPage = __webpack_require__(259);
	
	var _albPage2 = _interopRequireDefault(_albPage);
	
	var _sharingController = __webpack_require__(281);
	
	var _sharingController2 = _interopRequireDefault(_sharingController);
	
	var _URLRouter = __webpack_require__(40);
	
	var _URLRouter2 = _interopRequireDefault(_URLRouter);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line
	var ArticleLightBoxController = function (_Emitter) {
	  (0, _inherits3.default)(ArticleLightBoxController, _Emitter);
	
	  function ArticleLightBoxController(appState, data, options) {
	    (0, _classCallCheck3.default)(this, ArticleLightBoxController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ArticleLightBoxController.__proto__ || (0, _getPrototypeOf2.default)(ArticleLightBoxController)).call(this));
	
	    _this.appState = null;
	    _this.data = null;
	    _this.options = null;
	    _this.isSinglepage = true;
	    _this.DOMContainer = null;
	    _this.albPages = [];
	    _this.removeDoubles = true;
	    _this.currentContentIDs = [];
	    _this.navigated = false;
	    _this.lastIndex = null;
	    _this.fontSizeService = null;
	
	    _this.onOverlayClicked = function (e) {
	      if (e.target === e.currentTarget) {
	        _this.hide();
	        _this.appState.triggerEvent(_analyticsevents.CLICKAWAY_OVERLAY_ALB);
	        _this.appState.trigger("alb:overlayClicked");
	      }
	    };
	
	    _this.closeSharing = function (e, force) {
	      if (_this.sharingController) {
	        if (_this.sharingController.close(e, force)) {
	          var share = _this.DOMContainer.querySelector(".alb-nav-share");
	          if (share && share.classList.contains("open")) {
	            share.classList.remove("open");
	            _this.appState.triggerEvent(_analyticsevents.CLOSED_SHARE_MENU_ALB);
	          }
	          _this.DOMContainer.removeEventListener("click", _this.closeSharing);
	        }
	      }
	    };
	
	    _this.shareClicked = function (e) {
	      var share = e.currentTarget;
	      var sharingContainer = _this.DOMContainer.querySelector(".alb-nav-share .sharing-container");
	      if (sharingContainer) {
	        if (sharingContainer.classList.contains("hidden")) {
	          var albSlide = _this.getCurrentAlbSlide();
	          var showSharing = _this.showSocialSharing();
	          _this.sharingController = new _sharingController2.default(_this.appState, albSlide, sharingContainer, _this.options.sharing, showSharing);
	          if (share) {
	            share.classList.add("open");
	            e.stopPropagation();
	            _this.DOMContainer.addEventListener("click", _this.closeSharing);
	          }
	        }
	        if (e.target !== sharingContainer && !sharingContainer.contains(e.target)) {
	          _this.appState.triggerEvent(_analyticsevents.CLICKED_SHARE_ALB);
	        }
	      }
	    };
	
	    _this.back = function () {
	      _this.hide();
	      _this.appState.triggerEvent(_analyticsevents.CLICKED_BACK_ALB);
	    };
	
	    _this.font = function () {
	      _this.fontSizeService.increase();
	      _this.appState.triggerEvent(_analyticsevents.CLICKED_FONT_ALB);
	    };
	
	    _this.slideToPrev = function () {
	      _this.navigated = true;
	      _this.swiper.slidePrev();
	      _this.appState.triggerEvent(_analyticsevents.CLICKED_PREV_ALB);
	    };
	
	    _this.slideToNext = function () {
	      _this.navigated = true;
	      _this.swiper.slideNext();
	      _this.appState.triggerEvent(_analyticsevents.CLICKED_NEXT_ALB);
	    };
	
	    _this.extraButtonClicked = function () {
	      var albSlide = _this.getCurrentAlbSlide();
	      albSlide.scrollExtrasInView();
	      _this.appState.triggerEvent(_analyticsevents.CLICKED_ENRICHEMENT_ALB);
	    };
	
	    _this.setContentId = function () {
	      _this.goTo(_this.appState.currentPage, _this.appState.contentid);
	    };
	
	    _this.updateSharing = function () {
	      if (_this.appState && _this.appState.analyticsManager._options.cmp) {
	        if (_this.appState.analyticsManager.cmpManager && _this.appState.analyticsManager.cmpManager.isSocialSharingTrackingEnabled()) {
	          _this.showSharingIcon();
	        } else {
	          if (_this.options.printArticle) {
	            _this.activateSharing(true);
	          } else {
	            _this.inActivateSharing();
	          }
	        }
	      } else {
	        _this.showSharingIcon();
	      }
	    };
	
	    _this._onEscapeButtonKeyUp = function (e) {
	      var isImageViewerOpen = document.querySelector("#imageviewer").classList.contains("hidden");
	      if (isImageViewerOpen) {
	        if (e.keyCode === 27) {
	          _this.hide();
	        }
	      }
	    };
	
	    _this.appState = appState;
	    _this.data = data;
	    _this.options = options;
	    _this.isSinglepage = _this.data[0].length === 1;
	    _this.DOMContainer = document.querySelector("#alb");
	
	    if (_this.appState.analyticsManager.cmpManager) {
	      _this.appState.analyticsManager.cmpManager.on("userConsent:changed", function () {
	        if (_URLRouter2.default.isAlbURL()) {
	          _this.appState.triggerEvent(_analyticsevents.VIEW_ARTICLE_ALB);
	        }
	      });
	    }
	    return _this;
	  }
	
	  (0, _createClass3.default)(ArticleLightBoxController, [{
	    key: "createContext",
	    value: function createContext() {
	      var context = [];
	      context.extraButton = this.options.extraButtonOnSlider;
	      context.tablet = this.appState.isTablet || this.appState.isDesktop;
	      return context;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.DOMContainer !== null) {
	        Dust.render(_albController2.default, this.createContext(), function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	          _this2.initFontSize();
	          _this2.createSwiper();
	          _this2.attachClickHandlers();
	          _this2._toggleSwiperKeyboardControl();
	          if (_this2.appState.contentid) {
	            _this2.goTo(_this2.appState.currentPage, _this2.appState.contentid);
	          }
	        });
	      }
	    }
	  }, {
	    key: "createSwiper",
	    value: function createSwiper() {
	      var _this3 = this;
	
	      this.swiper = new Swiper("#alb .swiper-container-alb", {
	        keyboardControl: true,
	        simulateTouch: false,
	        onTransitionEnd: function onTransitionEnd() {
	          _this3.afterSlideChange();
	        }
	      });
	    }
	  }, {
	    key: "initFontSize",
	    value: function initFontSize() {
	      if (this.options.increaseFontSizeEnabled) {
	        var fontSize = this.DOMContainer.querySelector(".alb-nav-size");
	        if (fontSize) {
	          this.fontSizeService = new _fontSizeService2.default(this.options.fontSizeService);
	          fontSize.classList.remove("novisibility");
	        }
	      }
	    }
	  }, {
	    key: "attachClickHandlers",
	    value: function attachClickHandlers() {
	      var _this4 = this;
	
	      $(document).on("keydown", function (e) {
	        if (_this4.DOMContainer) {
	          var $activeSlideEl = $(_this4.DOMContainer.querySelector("#alb .swiper-slide-active .alb-content-scroll"));
	          if (!$activeSlideEl) return;
	          if (e.which === 40) {
	            // down
	            $activeSlideEl.focus();
	          } else if (e.which === 38) {
	            // up
	            $activeSlideEl.focus();
	          }
	        }
	      });
	      var back = this.DOMContainer.querySelector(".alb-nav-back");
	      if (back) {
	        back.addEventListener("click", this.back);
	      }
	      if (this.options.increaseFontSizeEnabled) {
	        var font = this.DOMContainer.querySelector(".alb-nav-size");
	        if (font) {
	          font.addEventListener("click", this.font);
	        }
	      }
	      var prev = this.DOMContainer.querySelector(".alb-nav-previous");
	      if (prev) {
	        prev.addEventListener("click", this.slideToPrev);
	      }
	      var next = this.DOMContainer.querySelector(".alb-nav-next");
	      if (next) {
	        next.addEventListener("click", this.slideToNext);
	      }
	      if (this.options.extraButtonOnSlider) {
	        var button = this.DOMContainer.querySelector(".alb-overall-extra-button-container");
	        if (button) {
	          button.addEventListener("click", this.extraButtonClicked);
	        }
	      }
	      if (this.options.sharingEnabled) {
	        var share = this.DOMContainer.querySelector(".alb-nav-share");
	        if (share) {
	          share.addEventListener("click", this.shareClicked);
	        }
	      }
	
	      //if clicked outside alb on overlay -> go out of alb
	      var overlay = this.DOMContainer.querySelector(".alb-container");
	      if (overlay) {
	        overlay.addEventListener("click", this.onOverlayClicked);
	      }
	
	      this.appState.on("appState:contentIdChanged", this.setContentId);
	      if (this.appState.analyticsManager.cmpManager) {
	        this.appState.analyticsManager.cmpManager.on("userConsent:changed", this.updateSharing);
	      }
	    }
	  }, {
	    key: "getSlideIndexOfCurrentSlide",
	    value: function getSlideIndexOfCurrentSlide() {
	      return $(this.swiper.slides[this.swiper.activeIndex]).data("sliden");
	    }
	  }, {
	    key: "_goToAddSlide",
	    value: function _goToAddSlide(index, contentid) {
	      var _this5 = this;
	
	      this.swiper.removeAllSlides();
	      var promise = new _promise2.default(function (resolve, reject) {
	        _this5.addPage(index, true).then(function () {
	          for (var i = 0; i < _this5.swiper.slides.length; i++) {
	            if (_this5.swiper.slides[i].getAttribute("data-contentid") === String(contentid)) {
	              _this5.show();
	              _this5.swiper.update(); //otherwise it doesnt open correct one
	              if (_this5.swiper.activeIndex !== i) {
	                _this5.swiper.slideTo(i, 0);
	              } else {
	                _this5.afterSlideChange();
	              }
	              resolve(true); // ab slide is visible
	            }
	          }
	          reject(false);
	        }).catch(function () {
	          reject(false);
	        });
	      });
	      return promise;
	    }
	  }, {
	    key: "goTo",
	    value: function goTo(page, contentid) {
	      var _this6 = this;
	
	      if (!contentid) {
	        this.hide();
	        return; //no cententid -> close alb
	      }
	      if (this.appState.articleLightBoxDisplayed) {
	        for (var i = 0; i < this.swiper.slides.length; i++) {
	          if (this.swiper.slides[i].getAttribute("data-contentid") === String(contentid)) {
	            if (this.swiper.activeIndex !== i) {
	              this.swiper.slideTo(i);
	            }
	            return; // ab slide is visible
	          }
	        }
	        //TODO: case that alb is open but no correct id
	      } else {
	        var index = page;
	        if (!this.isSinglepage) {
	          index = Math.round(index / 2);
	        }
	        this._goToAddSlide(index, contentid).then(function () {
	          //ok
	        }).catch(function () {
	          _this6._goToAddSlide(index + 1, contentid).then(function () {
	            //try next slide
	            //ok
	          }).catch(function () {
	            _this6._goToAddSlide(index - 1, contentid).then(function () {
	              //try previous slide
	              //ok
	            }).catch(function () {
	              // no content id in first page
	              _this6.appState.contentid = undefined;
	              _this6.hide();
	            });
	          });
	        });
	      }
	    }
	  }, {
	    key: "open",
	    value: function open(data) {
	      var _this7 = this;
	
	      this.addPage(data.slideIndex, true).then(function () {
	        var currentSlide = 0;
	        var slides = _this7.swiper.slides;
	        var length = slides.length;
	        for (var i = 0; i < length; i++) {
	          var slide = $(slides[i]);
	          if (String(slide.data("contentid")) === data.contentID) {
	            currentSlide = i;
	          }
	        }
	        _this7.show();
	        _this7.swiper.update(); //otherwise it doesnt open correct one
	        if (_this7.swiper.activeIndex === currentSlide) {
	          _this7.afterSlideChange();
	        } else {
	          _this7.swiper.slideTo(currentSlide, 0);
	        }
	        if (data.scrollToExtra) {
	          var albSlide = _this7.getCurrentAlbSlide();
	          albSlide.scrollExtrasInView();
	        }
	      });
	    }
	  }, {
	    key: "addPage",
	    value: function addPage(pageNumber, append) {
	      var _this8 = this;
	
	      var promise = new _promise2.default(function (resolve, reject) {
	        if (!_this8.albPages[pageNumber]) {
	          if (_this8.data[pageNumber]) {
	            var albPage = new _albPage2.default(_this8.appState, _this8.data[pageNumber], pageNumber, _this8.options.albslide);
	            albPage.on("albPage:hideExtraButton", function () {
	              _this8.hideExtraButton();
	            });
	            albPage.on("albPage:showExtraButton", function () {
	              _this8.showExtraButton();
	            });
	            _this8.albPages[pageNumber] = albPage;
	            albPage.render().then(function () {
	              _this8.addPageToSlider(pageNumber, append).then(function () {
	                resolve(true);
	              }).catch(function () {
	                reject(false);
	              });
	            }).catch(function () {
	              var newPageNumber = pageNumber;
	              if (append) {
	                newPageNumber++;
	              } else {
	                newPageNumber--;
	              }
	              _this8.addPage(newPageNumber, append).then(function () {
	                resolve(true);
	              }).catch(function () {
	                reject(false);
	              });
	            });
	          } else {
	            reject(false); //end
	          }
	        } else {
	          _this8.addPageToSlider(pageNumber, append).then(function () {
	            resolve(true);
	          }).catch(function () {
	            reject(false);
	          });
	        }
	      });
	
	      return promise;
	    }
	  }, {
	    key: "addPageToSlider",
	    value: function addPageToSlider(pageNumber, append) {
	      var _this9 = this;
	
	      var promise = new _promise2.default(function (resolve, reject) {
	        if (!_this9.addAlbPage(_this9.albPages[pageNumber], append)) {
	          var index = pageNumber;
	          if (append) {
	            index++;
	          } else {
	            index--;
	          }
	          _this9.addPage(index, append).then(function () {
	            resolve();
	          }).catch(function () {
	            reject();
	          });
	        } else {
	          resolve();
	        }
	      });
	      return promise;
	    }
	  }, {
	    key: "addAlbPage",
	    value: function addAlbPage(albPage, append) {
	      var slidesAdded = false;
	      var albSlides = albPage.getAllAlbSlides();
	      if (!append) {
	        albSlides.reverse();
	      }
	      for (var i = 0; i < albSlides.length; i++) {
	        var albSlide = albSlides[i];
	        if (this.currentContentIDs.indexOf(String(albSlide.contentID)) === -1) {
	          this.currentContentIDs.push(albSlide.slide.getAttribute("data-contentid"));
	          if (append) {
	            this.swiper.appendSlide(albSlide.slide);
	          } else {
	            this.swiper.prependSlide(albSlide.slide);
	          }
	          albSlide.onAddedToAlb();
	          slidesAdded = true;
	        }
	      }
	      this.swiper.update();
	      return slidesAdded;
	    }
	  }, {
	    key: "setCurrentPage",
	    value: function setCurrentPage() {
	      var _this10 = this;
	
	      var promise = new _promise2.default(function (resolve, reject) {
	        var currentPage = _this10.getCurrentPage();
	        if (currentPage >= 0 && _this10.appState.currentPage !== currentPage) {
	          _this10.appState.changeCurrentPage(currentPage, false, true).then(function () {
	            resolve(true);
	          }).catch(function () {
	            reject(false);
	          });
	        } else {
	          resolve(true);
	        }
	      });
	      return promise;
	    }
	  }, {
	    key: "getCurrentPage",
	    value: function getCurrentPage() {
	      var slide = this.swiper.slides[this.swiper.activeIndex];
	
	      var slideN = $(slide).data("sliden");
	
	      var currentPage = 0;
	      if (this.isSinglepage) {
	        currentPage = slideN;
	      } else {
	        var pageN = $(slide).data("pagen");
	        currentPage = slideN * 2 + (pageN - 1);
	      }
	      if (currentPage < 0 || !currentPage) {
	        currentPage = 0;
	      }
	
	      return currentPage;
	    }
	  }, {
	    key: "afterSlideChange",
	    value: function afterSlideChange() {
	      var _this11 = this;
	
	      if (!this.swiper || this.DOMContainer.classList.contains("hidden")) {
	        return;
	      }
	
	      this.closeSharing(null, true);
	
	      if (this.swiper.activeIndex === this.lastIndex) {
	        return;
	      }
	
	      if (!this.navigated && this.lastIndex !== null) {
	        //no navigation event and should allready be a lastIndex (otherwise first) //else a navigation event is allready triggered
	        if (this.lastIndex < this.swiper.activeIndex) {
	          this.appState.triggerEvent(_analyticsevents.SWIPED_FORWARD_ALB);
	        } else {
	          this.appState.triggerEvent(_analyticsevents.SWIPED_BACKWARD_ALB);
	        }
	      }
	
	      this.setCurrentPage().then(function () {
	        _this11.activateNavigation();
	
	        _this11.updateSlide();
	
	        _this11.setCurrentArticle();
	
	        var slide = _this11.swiper.slides[_this11.swiper.activeIndex];
	
	        if ($(slide).data("contentid") === _this11.appState.contentid) {
	          var activeIndex = _this11.swiper.activeIndex;
	          var lengt = _this11.swiper.slides.length;
	
	          if (activeIndex === 0 && activeIndex === lengt - 1) {
	            _this11.onReachBeginning();
	            _this11.onReachEnd();
	          } else if (activeIndex === 0) {
	            _this11.cleanupEnd();
	            _this11.onReachBeginning();
	          } else if (activeIndex === lengt - 1) {
	            _this11.cleanupFront();
	            _this11.onReachEnd();
	          }
	          _this11.appState.triggerEvent(_analyticsevents.VIEW_ARTICLE_ALB);
	        }
	      });
	    }
	  }, {
	    key: "setCurrentArticle",
	    value: function setCurrentArticle() {
	      var slide = this.swiper.slides[this.swiper.activeIndex];
	
	      var slideN = $(slide).data("sliden");
	      var pageN = $(slide).data("pagen");
	      var articleN = $(slide).data("articlen");
	
	      var page = this.data[slideN][pageN];
	      var article = page.content[articleN];
	      this.appState.contentid = $(slide).data("contentid");
	      this.appState.setActiveArticle(page, article);
	    }
	  }, {
	    key: "hideExtraButton",
	    value: function hideExtraButton() {
	      var button = this.DOMContainer.querySelector(".alb-overall-extra-button-container");
	      if (button) {
	        button.classList.add("hidden");
	      }
	    }
	  }, {
	    key: "showExtraButton",
	    value: function showExtraButton() {
	      var button = this.DOMContainer.querySelector(".alb-overall-extra-button-container");
	      if (button) {
	        button.classList.remove("hidden");
	      }
	    }
	  }, {
	    key: "getCurrentAlbSlide",
	    value: function getCurrentAlbSlide() {
	      var slide = this.swiper.slides[this.swiper.activeIndex];
	
	      var slideN = $(slide).data("sliden");
	      var pageN = $(slide).data("pagen");
	      var articleN = $(slide).data("articlen");
	
	      var albPage = this.albPages[slideN];
	      var albSlide = albPage ? albPage.albSlides[pageN][articleN] : null;
	
	      return albSlide;
	    }
	  }, {
	    key: "activateSharing",
	    value: function activateSharing(printIcon) {
	      var sharing = this.DOMContainer.querySelector(".alb-nav-share");
	      if (sharing) {
	        if (printIcon) {
	          sharing.classList.add("print");
	        } else {
	          sharing.classList.remove("print");
	        }
	        sharing.classList.remove("novisibility");
	      }
	    }
	  }, {
	    key: "inActivateSharing",
	    value: function inActivateSharing() {
	      var sharing = this.DOMContainer.querySelector(".alb-nav-share");
	      if (sharing) {
	        sharing.classList.add("novisibility");
	      }
	    }
	  }, {
	    key: "updateSlide",
	    value: function updateSlide() {
	      var albSlide = this.getCurrentAlbSlide();
	      albSlide.update();
	
	      this.updateSharing();
	
	      if (this.options.extraButtonOnSlider) {
	        var button = this.DOMContainer.querySelector(".alb-overall-extra-button-container");
	        if (button) {
	          if (albSlide.hasExtras()) {
	            var numberContainer = button.querySelector(".enrichment-number-container .enrichment-number");
	            if (numberContainer) {
	              numberContainer.innerHTML = albSlide.getNumberOfExtras();
	            }
	            var extraType = button.querySelector(".enrichment-type");
	            if (extraType) {
	              extraType.dataset.type = albSlide.getExtraType();
	            }
	            button.classList.remove("hidden");
	            albSlide.onScroll();
	          } else {
	            button.classList.add("hidden");
	          }
	        }
	      }
	    }
	  }, {
	    key: "showSharingIcon",
	    value: function showSharingIcon() {
	      var albSlide = this.getCurrentAlbSlide();
	      if (albSlide) {
	        if (this.options.shareFromReader && this.appState._sharingUrl || this.options.sharingEnabled && albSlide.getSharingLink()) {
	          this.activateSharing();
	        } else if (this.options.printArticle) {
	          this.activateSharing(true);
	        } else {
	          this.inActivateSharing();
	        }
	      }
	    }
	  }, {
	    key: "activateNavigation",
	    value: function activateNavigation() {
	      var next = this.DOMContainer.querySelector(".alb-nav-next");
	      if (next) {
	        next.classList.remove("inactive");
	      }
	      var previous = this.DOMContainer.querySelector(".alb-nav-previous");
	      if (previous) {
	        previous.classList.remove("inactive");
	      }
	    }
	  }, {
	    key: "inactivateNext",
	    value: function inactivateNext() {
	      var next = this.DOMContainer.querySelector(".alb-nav-next");
	      if (next) {
	        next.classList.add("inactive");
	      }
	    }
	  }, {
	    key: "inactivatePrevious",
	    value: function inactivatePrevious() {
	      var previous = this.DOMContainer.querySelector(".alb-nav-previous");
	      if (previous) {
	        previous.classList.add("inactive");
	      }
	    }
	  }, {
	    key: "onReachBeginning",
	    value: function onReachBeginning() {
	      var _this12 = this;
	
	      if (this.options.albSlideOnlyOnePage) {
	        this.inactivatePrevious();
	      } else {
	        this.addPage(this.getSlideIndexOfCurrentSlide() - 1, false).then(function () {
	          _this12.swiper.update();
	        }).catch(function () {
	          _this12.inactivatePrevious();
	        });
	      }
	    }
	  }, {
	    key: "onReachEnd",
	    value: function onReachEnd() {
	      var _this13 = this;
	
	      if (this.options.albSlideOnlyOnePage) {
	        this.inactivateNext();
	      } else {
	        this.addPage(this.getSlideIndexOfCurrentSlide() + 1, true).then(function () {
	          _this13.swiper.update();
	        }).catch(function () {
	          _this13.inactivateNext();
	        });
	      }
	    }
	
	    //cleanup
	
	  }, {
	    key: "cleanupFront",
	    value: function cleanupFront() {
	      var currentSlide = this.getSlideIndexOfCurrentSlide();
	      var slideBefore = this.swiper.slides[this.swiper.activeIndex - 1];
	      if (slideBefore && $(slideBefore).data("sliden") !== currentSlide) {
	        return;
	      }
	      var slides = this.swiper.slides;
	      for (var i = 0; i < slides.length; i++) {
	        var page = slides[i].getAttribute("data-sliden");
	        if (page < currentSlide) {
	          this.swiper.removeSlide(0);
	          var contentID = slides[i].getAttribute("data-contentid");
	          var contentIDIndex = this.currentContentIDs.indexOf(contentID);
	          if (contentIDIndex > -1) {
	            this.currentContentIDs.splice(contentIDIndex, 1);
	          }
	        } else {
	          break;
	        }
	      }
	    }
	  }, {
	    key: "cleanupEnd",
	    value: function cleanupEnd() {
	      var currentSlide = this.getSlideIndexOfCurrentSlide();
	      var slideAfter = this.swiper.slides[this.swiper.activeIndex + 1];
	      if (slideAfter && $(slideAfter).data("sliden") !== currentSlide) {
	        return;
	      }
	      var slides = this.swiper.slides;
	      for (var i = slides.length - 1; i >= 0; i--) {
	        var page = slides[i].getAttribute("data-sliden");
	        if (page > currentSlide) {
	          this.swiper.removeSlide(this.swiper.slides.length - 1);
	          var contentIDIndex = this.currentContentIDs.indexOf(slides[i].getAttribute("data-contentid"));
	          if (contentIDIndex > -1) {
	            this.currentContentIDs.splice(contentIDIndex, 1);
	          }
	        } else {
	          break;
	        }
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.appState.articleLightBoxDisplayed = true;
	      this.DOMContainer.classList.remove("hidden");
	      this.checkScrolling();
	      this.appState.triggerEvent(_analyticsevents.OPENED_ALB);
	      document.addEventListener("keyup", this._onEscapeButtonKeyUp);
	      this.appState.trigger("appState:articleLightboxOpened");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.trigger("albController:closeAlb");
	      if (!this.DOMContainer.classList.contains("hidden")) {
	        if (this.appState.authorized) {
	          this.swiper.removeAllSlides();
	          this.currentContentIDs = [];
	          this.DOMContainer.classList.add("hidden");
	          this.appState.contentid = undefined;
	          this.appState.articleLightBoxDisplayed = false;
	          this.lastIndex = null;
	          this.appState.trigger("appState:articleLightboxClosed");
	          this.appState.trigger("appState:openOrPageTurned");
	          this.appState.triggerEvent(_analyticsevents.CLOSED_ALB);
	          document.removeEventListener("keyup", this._onEscapeButtonKeyUp);
	        }
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.detatchClickHandlers();
	      this.swiper.destroy();
	      this.data = null;
	      this.options = null;
	      this.DOMContainer = null;
	      this.albPages = [];
	      this.currentContentIDs = [];
	      document.documentElement.removeAttribute("style");
	    }
	  }, {
	    key: "detatchClickHandlers",
	    value: function detatchClickHandlers() {
	      var back = this.DOMContainer.querySelector(".alb-nav-back");
	      if (back) {
	        back.removeEventListener("click", this.back);
	      }
	      if (this.options.increaseFontSizeEnabled) {
	        var font = this.DOMContainer.querySelector(".alb-nav-size");
	        if (font) {
	          font.removeEventListener("click", this.font);
	        }
	      }
	      var prev = this.DOMContainer.querySelector(".alb-nav-previous");
	      if (prev) {
	        prev.removeEventListener("click", this.slideToPrev);
	      }
	      var next = this.DOMContainer.querySelector(".alb-nav-next");
	      if (next) {
	        next.removeEventListener("click", this.slideToNext);
	      }
	      if (this.options.extraButtonOnSlider) {
	        var button = this.DOMContainer.querySelector(".alb-overall-extra-button-container");
	        if (button) {
	          button.removeEventListener("click", this.extraButtonClicked);
	        }
	      }
	      if (this.options.sharingEnabled) {
	        var share = this.DOMContainer.querySelector(".alb-nav-share");
	        if (share) {
	          share.removeEventListener("click", this.shareClicked);
	        }
	      }
	
	      //if clicked outside alb on overlay -> go out of alb
	      var overlay = this.DOMContainer.querySelector(".alb-container");
	      if (overlay) {
	        overlay.removeEventListener("click", this.onOverlayClicked);
	      }
	
	      this.appState.off("appState:contentIdChanged", this.setContentId);
	      if (this.appState.analyticsManager.cmpManager) {
	        this.appState.analyticsManager.cmpManager.off("userConsent:changed", this.updateSharing);
	      }
	    }
	  }, {
	    key: "checkScrolling",
	    value: function checkScrolling() {
	      if (this.appState.isDesktop && !this.scrollingChecked) {
	        this.scrollingChecked = true;
	        var scroll = document.querySelector(".alb-content-scroll");
	        var inner = document.querySelector(".alb-content");
	        var difference = scroll.getBoundingClientRect().width - inner.getBoundingClientRect().width;
	        if (difference > 0) {
	          this.DOMContainer.classList.add("scrollbarVisible");
	          //set class 'scrollbar' to document.query ('.alb')
	        }
	      }
	    }
	  }, {
	    key: "_toggleSwiperKeyboardControl",
	    value: function _toggleSwiperKeyboardControl() {
	      var _this14 = this;
	
	      this.appState.on("imageGallery:opened", function () {
	        _this14.swiper.disableKeyboardControl();
	      });
	
	      this.appState.on("imageGallery:closed", function () {
	        _this14.swiper.enableKeyboardControl();
	      });
	    }
	  }, {
	    key: "showSocialSharing",
	    value: function showSocialSharing() {
	      if (this.appState.analyticsManager.cmpManager) {
	        return this.appState.analyticsManager.cmpManager && this.appState.analyticsManager.cmpManager.isSocialSharingTrackingEnabled();
	      } else {
	        return true;
	      }
	    }
	  }]);
	  return ArticleLightBoxController;
	}(_es6EventEmitter2.default); // this is needed!
	
	
	exports.default = ArticleLightBoxController;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _toConsumableArray2 = __webpack_require__(85);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _albImageSlider = __webpack_require__(376);
	
	var _albImageSlider2 = _interopRequireDefault(_albImageSlider);
	
	var _spinner = __webpack_require__(49);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlbImageSlider = function () {
	
	  //TODO: check the swiper.update(); probably called to often but otherwise rotation breaks
	
	  //if allready added to alb
	  function AlbImageSlider(appState, DOMContainer, context, options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, AlbImageSlider);
	    this.appState = null;
	    this.DOMContainer = null;
	    this.loaderDOMContainer = null;
	    this.options = null;
	    this.renderingDone = false;
	    this.added = false;
	    this.canAdd = false;
	    this.rotated = false;
	    this.ratios = [];
	
	    this.loopSwiper = function () {
	      return !_this.context.singleImage && _this.appState.isDesktop;
	    };
	
	    this.imageGalleryLoadedCallback = function () {
	      _this.DOMContainer.classList.remove("image-viewer-loading");
	    };
	
	    this.appState = appState;
	    this.DOMContainer = DOMContainer;
	    this.options = options;
	    this.context = context;
	    this.appState.on("appState:heightChanged", function () {
	      if (_this.swiper) {
	        if (_this.canAdd && _this.renderingDone) {
	          _this.setImagesHeight();
	          _this.swiper.update();
	          _this.rotated = true;
	        }
	      }
	    });
	  }
	
	  (0, _createClass3.default)(AlbImageSlider, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      for (var i = 0; i < this.context.images.length; i++) {
	        this.context.images[i].imageIdentifier = "image_" + i; //identify each image in the ALB for easy image loading
	      }
	      Dust.render(_albImageSlider2.default, this.context, function (err, result) {
	        $(_this2.DOMContainer).html(result);
	        var images = [].concat((0, _toConsumableArray3.default)(_this2.context.images));
	        var promises = [];
	        for (var _i = 0; _i < images.length; _i++) {
	          var image = images[_i];
	          var element = _this2.DOMContainer.querySelector("." + image.imageIdentifier);
	          promises.push(_this2.appState.cdnAssetsDownloader.loadImageOnElement(_this2.options.sizes.nonHD, image.ContentItemId, element, true, false));
	        }
	        _promise2.default.all(promises).then(function (ratios) {
	          _this2.ratios = ratios;
	          _this2.renderingDone = true;
	          _this2.addToAlb();
	          _this2.attatchClickHandlers();
	        });
	      });
	    }
	  }, {
	    key: "attatchClickHandlers",
	    value: function attatchClickHandlers() {
	      var _this3 = this;
	
	      this.DOMContainer.querySelector(".alb-image-slider-wrapper").addEventListener("click", function () {
	        _this3.openImageViewer();
	      });
	    }
	  }, {
	    key: "openImageViewer",
	    value: function openImageViewer() {
	      this.renderLoader();
	      var slide = this.swiper.activeIndex;
	      if (this.appState.isDesktop) {
	        var ImageGallery = __webpack_require__(43).default;
	        new ImageGallery({
	          appState: this.appState,
	          slideNumber: slide,
	          context: this.context,
	          options: this.options.imageviewer,
	          loadedCallback: this.imageGalleryLoadedCallback,
	          loopSwiper: this.loopSwiper()
	        });
	      } else {
	        var ImageGalleryMobile = __webpack_require__(57).default;
	        new ImageGalleryMobile({
	          appState: this.appState,
	          slideNumber: slide,
	          context: this.context,
	          options: this.options.imageviewer,
	          loadedCallback: this.imageGalleryLoadedCallback,
	          loopSwiper: this.loopSwiper()
	        });
	      }
	      this.appState.triggerEvent(_analyticsevents.CLICKED_IMAGE_ALB);
	    }
	  }, {
	    key: "update",
	    value: function update() {
	      if (this.swiper) {
	        this.swiper.update();
	        this.swiper.slideTo(this.swiper.activeIndex);
	        this.swiper.update();
	      }
	    }
	  }, {
	    key: "onAddedToAlb",
	    value: function onAddedToAlb() {
	      if (this.swiper) {
	        if (this.rotated) {
	          this.setImagesHeight();
	          this.swiper.update();
	          this.rotated = false;
	        }
	        return;
	      }
	      this.canAdd = true;
	      this.addToAlb();
	    }
	  }, {
	    key: "addToAlb",
	    value: function addToAlb() {
	      if (this.canAdd && this.renderingDone) {
	        //if not yet added to alb and can add and rendering is done
	        this.createSwiper();
	      }
	    }
	  }, {
	    key: "createSwiper",
	    value: function createSwiper() {
	      var _this4 = this;
	
	      this.swiper = new Swiper(this.DOMContainer, {
	        pagination: $(this.DOMContainer).find(" .swiper-pagination-alb-image"),
	        paginationClickable: true,
	        initialSlide: 0,
	        spaceBetween: 20,
	        centeredSlides: true,
	        nested: true,
	        loopedSlides: this.DOMContainer.querySelector(".alb-image-slider-wrapper").children.length,
	        loop: this.loopSwiper(),
	        onSlideNextEnd: function onSlideNextEnd() {
	          _this4.appState.triggerEvent(_analyticsevents.SWIPED_FORWARD_IMAGEVIEWER);
	        },
	        onSlidePrevEnd: function onSlidePrevEnd() {
	          _this4.appState.triggerEvent(_analyticsevents.SWIPED_BACKWARD_IMAGEVIEWER);
	        }
	      });
	      this.setImagesHeight();
	    }
	  }, {
	    key: "setImagesHeight",
	    value: function setImagesHeight() {
	      var _this5 = this;
	
	      var $slides = $(this.DOMContainer).find(".swiper-slide-alb-img");
	      $slides.map(function (i, slide) {
	        _this5.setImageHeight(slide, _this5.ratios[i]);
	      });
	      this.swiper.update();
	    }
	  }, {
	    key: "setImageHeight",
	    value: function setImageHeight(slide, ratioImg) {
	      var container = slide.querySelector(".alb-slide-img-container");
	      if (container) {
	        var DOMContainer = document.querySelector("#alb");
	        if (DOMContainer) {
	          var image = container.querySelector(".alb-slide-img");
	          if (image) {
	            image.classList.remove("hidden");
	            if (this.options.fullWidthImage) {
	              image.setAttribute("style", "width: 100%;");
	            } else {
	              var isHidden = DOMContainer.classList.contains("hidden");
	              if (isHidden) {
	                DOMContainer.classList.remove("hidden");
	              }
	              var rect = container.getBoundingClientRect();
	              if (isHidden) {
	                DOMContainer.classList.add("hidden");
	              }
	              var ratioContainer = rect.height / rect.width;
	              if (ratioImg < ratioContainer) {
	                image.style.removeProperty("height");
	                // image.setAttribute('style', 'width: 100%;');   //TODO: 100% doesnt work on IOS but then there are no flickers when rotating
	                image.setAttribute("style", "width: " + rect.width + "px;");
	              } else {
	                image.style.removeProperty("width");
	                image.setAttribute("style", "height: 100%;");
	              }
	              container.classList.add("loaded");
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: "renderLoader",
	    value: function renderLoader() {
	      var _this6 = this;
	
	      this.loaderDOMContainer = this.DOMContainer.querySelector(".alb-image-slider-viewer-loader");
	      if (this.loaderDOMContainer && !this.loaderDOMContainer.hasChildNodes()) {
	        Dust.render(_spinner2.default, {}, function (err, result) {
	          _this6.loaderDOMContainer.innerHTML = result;
	          _this6.DOMContainer.classList.add("image-viewer-loading");
	        });
	      }
	    }
	  }]);
	  return AlbImageSlider;
	}();
	
	exports.default = AlbImageSlider;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _albSlide = __webpack_require__(260);
	
	var _albSlide2 = _interopRequireDefault(_albSlide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlbPage = function (_Emitter) {
	  (0, _inherits3.default)(AlbPage, _Emitter);
	
	  function AlbPage(appState, pages, pageNumber, options) {
	    (0, _classCallCheck3.default)(this, AlbPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AlbPage.__proto__ || (0, _getPrototypeOf2.default)(AlbPage)).call(this));
	
	    _this.appState = null;
	    _this.pages = null;
	    _this.options = null;
	    _this.pageNumber = null;
	    _this.albSlides = [];
	
	    _this.appState = appState;
	    _this.pages = pages;
	    _this.pageNumber = pageNumber;
	    _this.options = options;
	    return _this;
	  }
	
	  (0, _createClass3.default)(AlbPage, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var promise = new _promise2.default(function (resolve, reject) {
	        _promise2.default.all(_this2.pages.map(function (page, pageIndex) {
	          return _this2.createPage(page, pageIndex);
	        })).then(function (result) {
	          result.forEach(function (pageSlides) {
	            _this2.albSlides.push(pageSlides);
	          });
	          if (_this2.getAllAlbSlides().length === 0) {
	            reject(true);
	          } else {
	            resolve(true);
	          }
	        });
	      });
	      return promise;
	    }
	  }, {
	    key: "getAllAlbSlides",
	    value: function getAllAlbSlides() {
	      var result = [];
	      this.albSlides.forEach(function (slide) {
	        slide.forEach(function (s) {
	          result.push(s);
	        });
	      });
	      return Array.prototype.slice.call(result);
	    }
	  }, {
	    key: "createPage",
	    value: function createPage(page, pageIndex) {
	      var _this3 = this;
	
	      var promise = new _promise2.default(function (resolve) {
	        var albSlides = [];
	        // const slides = [];
	        if (page) {
	          _promise2.default.all(page.content.map(function (content, index) {
	            var albSide = new _albSlide2.default(_this3.appState, content, _this3.pageNumber, pageIndex, index, _this3.options);
	            albSide.on("albSlide:hideExtraButton", function () {
	              _this3.trigger("albPage:hideExtraButton");
	            });
	            albSide.on("albSlide:showExtraButton", function () {
	              _this3.trigger("albPage:showExtraButton");
	            });
	            albSlides.push(albSide);
	            return albSide.render();
	          })).then(function () {
	            resolve(albSlides);
	          });
	        } else {
	          resolve(albSlides);
	        }
	      });
	      return promise;
	    }
	  }, {
	    key: "onAddedToAlb",
	    value: function onAddedToAlb() {
	      this.albSlides.forEach(function (slide) {
	        slide.onAddedToAlb();
	      });
	    }
	  }]);
	  return AlbPage;
	}(_es6EventEmitter2.default);
	
	exports.default = AlbPage;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _albSlide = __webpack_require__(377);
	
	var _albSlide2 = _interopRequireDefault(_albSlide);
	
	var _albImageSlider = __webpack_require__(258);
	
	var _albImageSlider2 = _interopRequireDefault(_albImageSlider);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _utils = __webpack_require__(10);
	
	var _spinner = __webpack_require__(49);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _enrichmentButton = __webpack_require__(117);
	
	var _enrichmentButton2 = _interopRequireDefault(_enrichmentButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this is needed!
	
	var AlbSlide = function (_Emitter) {
	  (0, _inherits3.default)(AlbSlide, _Emitter);
	
	  function AlbSlide(appState, content, slideNumber, pageNumber, articleNumber, options) {
	    (0, _classCallCheck3.default)(this, AlbSlide);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AlbSlide.__proto__ || (0, _getPrototypeOf2.default)(AlbSlide)).call(this));
	
	    _this.appState = null;
	    _this.slide = null;
	    _this.contentID = null;
	    _this.slideNumber = null;
	    _this.pageNumber = null;
	    _this.articleNumber = null;
	    _this.content = null;
	    _this.options = null;
	    _this.loaderDOMContainer = null;
	
	    _this.appState = appState;
	    _this.content = content;
	    _this.options = options;
	
	    _this.slideNumber = slideNumber;
	    _this.pageNumber = pageNumber;
	    _this.articleNumber = articleNumber;
	
	    _this.contentID = _this.content.ContentID;
	    return _this;
	  }
	
	  (0, _createClass3.default)(AlbSlide, [{
	    key: "hasExtras",
	    value: function hasExtras() {
	      return this.content.contentItemContent().extras.length > 0;
	    }
	  }, {
	    key: "getNumberOfExtras",
	    value: function getNumberOfExtras() {
	      return this.content.contentItemContent().extras.length;
	    }
	  }, {
	    key: "getExtraType",
	    value: function getExtraType() {
	      return this.content.contentItemContent().extraType;
	    }
	  }, {
	    key: "getSharingLink",
	    value: function getSharingLink() {
	      if (this.content.contentItemContent().sharing) {
	        return (0, _utils.stripHtml)(this.content.contentItemContent().sharing.Title);
	      }
	      return null;
	    }
	  }, {
	    key: "getTitle",
	    value: function getTitle() {
	      if (this.content.contentItemContent().article) {
	        return (0, _utils.stripHtml)(this.content.contentItemContent().article.Title);
	      }
	      return null;
	    }
	  }, {
	    key: "getIntro",
	    value: function getIntro() {
	      if (this.content.contentItemContent().article) {
	        return (0, _utils.stripHtml)(this.content.contentItemContent().article.Introduction);
	      }
	      return null;
	    }
	  }, {
	    key: "createContext",
	    value: function createContext() {
	      var context = this.content.contentItemContent();
	      context.slideN = this.slideNumber;
	      context.pageN = this.pageNumber;
	      context.articleN = this.articleNumber;
	      context.id = this.content.ContentID;
	      context.fixedImgHeight = this.options.fixedImgHeight;
	      context.maxLines = this.options.captionMaxLines;
	      context.displayPageCategory = this.options.displayPageCategory;
	      context.urlTitle = _dictionary2.default.alsoRead;
	      context.videoTitle = _dictionary2.default.alsoWatch;
	      context.imageTitle = _dictionary2.default.alsoSee;
	
	      context.desktop = this.appState.isDesktop;
	
	      if (this.isImageOnlyArticle(context)) {
	        context.className = "fullImage";
	      }
	      if (this.hasExtras()) {
	        //`TODO: Use new downloader to load extra images`
	        context.extra = true;
	        context.numberExtras = this.getNumberOfExtras();
	        context.extraTitle = _dictionary2.default.Extra;
	        context.extraButton = this.options.extraButtonOnEachPage;
	        context.extraButtonTitle = this.options.extraButtonInTitle;
	        context.extraType = this.getExtraType();
	
	        context.extras.sort(function (firstItem, secondItem) {
	          return firstItem.ContentItemPosition - secondItem.ContentItemPosition;
	        });
	      }
	
	      if (this.content.contentItemContent().images.length > 0) {
	        context.imageSlider = true;
	        if (this.content.contentItemContent().images.length === 1) {
	          context.singleImage = true;
	        } else {
	          context.images.sort(function (firstItem, secondItem) {
	            return firstItem.ContentItemPosition - secondItem.ContentItemPosition;
	          });
	        }
	      }
	      return context;
	    }
	  }, {
	    key: "isImageOnlyArticle",
	    value: function isImageOnlyArticle(context) {
	      var hasNoSubTitle = !context.article.SubTitle || context.article.SubTitle === "";
	      var hasNoSupTitle = !context.article.SupTitle || context.article.SupTitle === "";
	      var hasNoIntroduction = !context.article.Introduction || context.article.Introduction === "";
	      var hasNoBody = !context.article.HtmlText || context.article.HtmlText === "";
	      var hasNoTitle = !context.article.Title || context.article.Title === "";
	      var isNotEnrichment = !context.extraType || context.extraType === "";
	
	      var hasImage = context.images && context.images.length === 1;
	
	      return hasImage && hasNoTitle && hasNoSubTitle && hasNoSupTitle && hasNoIntroduction && hasNoBody && isNotEnrichment;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      this.slide = document.createElement("div");
	      this.slide.classList.add("swiper-slide");
	      this.slide.classList.add("alb-slide");
	      this.slide.setAttribute("data-slideN", this.slideNumber);
	      this.slide.setAttribute("data-pageN", this.pageNumber);
	      this.slide.setAttribute("data-articleN", this.articleNumber);
	      this.slide.setAttribute("data-contentID", this.content.ContentID);
	
	      var promise = new _promise2.default(function (resolve) {
	        var context = _this2.createContext();
	        Dust.render(_albSlide2.default, context, function (err, result) {
	          // use jquery!! if innerHTML is used tags aren't properly closed if client provided cirreupt htmltext
	          $(_this2.slide).html(result);
	          if (context.imageSlider) {
	            _this2.createImageSlider(context);
	          }
	          _this2.attatchClickHandlers(context.extraImageViewer);
	          resolve(_this2.slide);
	        });
	      });
	      return promise;
	    }
	  }, {
	    key: "createImageSlider",
	    value: function createImageSlider(context) {
	      this.imageSlider = new _albImageSlider2.default(this.appState, this.slide.querySelector(".alb-image-slider-container"), context, this.options);
	      this.imageSlider.render();
	    }
	  }, {
	    key: "onAddedToAlb",
	    value: function onAddedToAlb() {
	      if (this.imageSlider) {
	        this.imageSlider.onAddedToAlb();
	      }
	    }
	  }, {
	    key: "update",
	    value: function update() {
	      if (this.imageSlider) {
	        this.imageSlider.update();
	      }
	    }
	  }, {
	    key: "attatchClickHandlers",
	    value: function attatchClickHandlers(context) {
	      var _this3 = this;
	
	      if (this.hasExtras()) {
	        this.extrasContainer = this.slide.querySelector(".alb-article-extras");
	        if (this.options.hideExtraButtonWhenInExtras) {
	          var scroll = this.slide.querySelector(".alb-content-scroll");
	          if (scroll) {
	            scroll.addEventListener("scroll", function () {
	              _this3.onScroll();
	            });
	          }
	        }
	        if (this.options.extraButtonOnEachPage) {
	          var button = this.slide.querySelector(".alb-extra-button-container");
	          this.buttonContainer = button;
	          if (button) {
	            button.addEventListener("click", function () {
	              _this3.scrollExtrasInView();
	            });
	          }
	        }
	        var link = this.slide.querySelector("a.alb-extra-ad");
	        if (link) {
	          link.addEventListener("click", function (event) {
	            var urlWithConsentParams = _this3.appState.analyticsManager.checkEnrichmentUrl(event.currentTarget.attributes.href.value);
	            if (urlWithConsentParams) {
	              window.open(urlWithConsentParams, "_blank");
	            } else {
	              window.open(event.currentTarget.attributes.href.value, "_blank");
	            }
	          });
	        }
	      }
	
	      $(this.slide).find(".alb-extra-image").on("click", function (e) {
	        _this3.openImageViewer(e, context);
	      });
	
	      var grab = this.slide.querySelector(".alb-content-scroll");
	      var alb = document.querySelector("#alb");
	      if (grab) {
	        var pushed = void 0;
	        var lastClientY = void 0;
	        grab.addEventListener("mousedown", function (e) {
	          pushed = 1;
	          lastClientY = e.clientY;
	          grab.style.cursor = "grabbing";
	        });
	        alb.addEventListener("mouseup", function () {
	          pushed = 0;
	          grab.style.cursor = "grab";
	        });
	        grab.addEventListener("mousemove", function (e) {
	          if (pushed) {
	            var scroller = grab.scroller || grab;
	            var newScrollY = -lastClientY + (lastClientY = e.clientY);
	            scroller.scrollTop -= newScrollY;
	          }
	        });
	      }
	    }
	  }, {
	    key: "openImageViewer",
	    value: function openImageViewer(e, context) {
	      var slide = Number(e.currentTarget.getAttribute("data-id"));
	      if (this.appState.isDesktop) {
	        this.renderEnrichmentLoader(e.currentTarget.closest(".alb-article-extras-item-content"));
	        var ImageGallery = __webpack_require__(43).default;
	        new ImageGallery({
	          appState: this.appState,
	          slideNumber: slide + 1,
	          context: context,
	          options: this.options.imageviewer,
	          loopSwiper: true,
	          loadedCallback: function loadedCallback() {
	            document.querySelector(".swiper-slide-active .alb-article-extras-item-content.loading").classList.remove("loading");
	          }
	        });
	      } else {
	        var ImageGalleryMobile = __webpack_require__(57).default;
	        new ImageGalleryMobile({
	          appState: this.appState,
	          slideNumber: slide,
	          context: context,
	          options: this.options.imageviewer
	        });
	      }
	    }
	  }, {
	    key: "scrollExtrasInView",
	    value: function scrollExtrasInView() {
	      if (this.extrasContainer) {
	        var scroll = this.slide.querySelector(".alb-content-scroll");
	        var cont = this.slide.querySelector(".alb-content");
	        this.extrasContainer.scrollIntoView();
	        if (scroll && cont) {
	          var x = $(this.extrasContainer).height() + scroll.scrollTop;
	          if (x > $(cont).height()) {
	            scroll.scrollTop -= this.options.marginScrollExtraInView;
	          }
	        }
	      }
	    }
	  }, {
	    key: "extrasInView",
	    value: function extrasInView() {
	      if (this.extrasContainer && this.slide) {
	        var rect = this.extrasContainer.getBoundingClientRect();
	        var view = this.slide.getBoundingClientRect();
	
	        if (rect.top < view.height + this.options.extrasInViewMargin) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: "hideExtraButton",
	    value: function hideExtraButton() {
	      if (this.buttonContainer) {
	        this.buttonContainer.classList.add("hidden");
	      } else {
	        this.trigger("albSlide:hideExtraButton");
	      }
	    }
	  }, {
	    key: "showExtraButton",
	    value: function showExtraButton() {
	      if (this.buttonContainer) {
	        this.buttonContainer.classList.remove("hidden");
	      } else {
	        this.trigger("albSlide:showExtraButton");
	      }
	    }
	  }, {
	    key: "onScroll",
	    value: function onScroll() {
	      //TODO: if button on swiper and not on slide
	      if (!this.options.hideExtraButtonWhenInExtras) {
	        return;
	      }
	      if (this.hasExtras()) {
	        if (this.extrasInView()) {
	          this.hideExtraButton();
	        } else {
	          this.showExtraButton();
	        }
	      }
	    }
	  }, {
	    key: "renderEnrichmentLoader",
	    value: function renderEnrichmentLoader(imageContainer) {
	      var _this4 = this;
	
	      this.loaderDOMContainer = imageContainer.querySelector(".alb-extra-image-viewer-loader");
	      if (this.loaderDOMContainer && !this.loaderDOMContainer.hasChildNodes()) {
	        Dust.render(_spinner2.default, {}, function (err, result) {
	          _this4.loaderDOMContainer.innerHTML = result;
	          imageContainer.classList.add("loading");
	        });
	      }
	    }
	  }]);
	  return AlbSlide;
	}(_es6EventEmitter2.default);
	// eslint-disable-next-line
	
	
	exports.default = AlbSlide;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(53);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _utils = __webpack_require__(10);
	
	var _imageGalleryMobile = __webpack_require__(57);
	
	var _imageGalleryMobile2 = _interopRequireDefault(_imageGalleryMobile);
	
	var _nextGenSharing = __webpack_require__(269);
	
	var _nextGenSharing2 = _interopRequireDefault(_nextGenSharing);
	
	var _imageGallery = __webpack_require__(43);
	
	var _imageGallery2 = _interopRequireDefault(_imageGallery);
	
	var _analyticsevents = __webpack_require__(9);
	
	var eventNames = _interopRequireWildcard(_analyticsevents);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _require = __webpack_require__(122),
	    client_fullname = _require.client_fullname;
	
	/**
	 * This is class with methods that allows integration
	 * between webapp and nextgen. The instance of this class should be exposed
	 * as property on window object, to make it available for nextgen
	 * app.
	 */
	
	
	var Bridge = function () {
	  function Bridge(appState, pubStore, options) {
	    (0, _classCallCheck3.default)(this, Bridge);
	
	    this._appState = appState;
	    this._pubStore = pubStore;
	    this._options = options;
	  }
	
	  (0, _createClass3.default)(Bridge, [{
	    key: "editionReady",
	    value: function editionReady(pages) {
	      this._pubStore.loadPagesFromReader(pages);
	    }
	  }, {
	    key: "onPageAccess",
	    value: function onPageAccess(pageIndex) {
	      this.setupPage(pageIndex);
	      if (pageIndex !== this._appState.currentPage) {
	        this._appState.changeCurrentPage(pageIndex);
	      }
	    }
	  }, {
	    key: "openImageViewer",
	    value: function openImageViewer(data) {
	      var _this = this;
	
	      data.images.forEach(function (image) {
	        image.src = (0, _utils.generateNextgenImageUrl)(_this._pubStore.CPackage.ContentPackageID, image.FileName);
	        image.srcHD = image.src;
	        image.HtmlText = image.Caption;
	      });
	      if (this._appState.isDesktop) {
	        new _imageGallery2.default({
	          appState: this._appState,
	          slideNumber: 0,
	          context: data,
	          options: this._options.imageviewer
	        });
	      } else {
	        new _imageGalleryMobile2.default({
	          appState: this._appState,
	          slideNumber: 0,
	          context: data,
	          options: this._options.imageviewer
	        });
	      }
	    }
	  }, {
	    key: "getSharedArticleDetails",
	    value: function getSharedArticleDetails(data) {
	      var _this2 = this;
	
	      var sharingContainer = void 0;
	      var currentPageId = "#page" + this._appState.currentPage;
	      var currentpage = document.querySelector(currentPageId);
	      var articleToShare = currentpage.querySelectorAll("[data-article-id='" + data.ContentId + "']");
	      if (data.Family == "tmgFamily") {
	        if (this.hasSharingContainer(articleToShare[0])) {
	          sharingContainer = articleToShare[0].querySelector(".sharing-menu");
	        } else if (this.hasSharingContainer(articleToShare[0].parentElement)) {
	          sharingContainer = articleToShare[0].parentElement.querySelector(".sharing-menu");
	        } else {
	          sharingContainer = articleToShare[0].parentElement.parentElement.querySelector(".sharing-menu");
	        }
	      } else {
	        if (articleToShare[0]) {
	          sharingContainer = articleToShare[0].querySelector(".sharing-menu");
	        }
	      }
	      if (sharingContainer) {
	        if (sharingContainer.classList.contains("hidden")) {
	          this.nextgenSharingController = new _nextGenSharing2.default(this._appState, data, sharingContainer, this._options.sharing);
	          sharingContainer.addEventListener("click", function (e) {
	            _this2.nextgenSharingController.close(e);
	          });
	        } else {
	          sharingContainer.classList.add("hidden");
	        }
	      }
	    }
	  }, {
	    key: "hasSharingContainer",
	    value: function hasSharingContainer(parent) {
	      return parent.querySelector(".sharing-menu");
	    }
	  }, {
	    key: "getEnvironmentData",
	    value: function getEnvironmentData() {
	      var data = {
	        SubscriptionReference: this._appState.subscriptionReference,
	        SubscriptionUserReference: this._appState.userInfo.userReference,
	        DeviceReference: this._appState.uuid,
	        DeviceType: "webApp",
	        AppName: client_fullname
	      };
	
	      if (window.app !== "undefined" && window.app.platform !== "undefined" && typeof window.app.platform.gotEnvironmentData === "function") {
	        window.app.platform.gotEnvironmentData(data);
	      }
	    }
	  }, {
	    key: "getUserNavigationData",
	    value: function getUserNavigationData() {
	      var data = {
	        userSubscription: {}
	      };
	
	      // @todo here there will be also METERED added at some point
	      if (this._appState.isLoggedIn) {
	        data.userSubscription.type = "SUBSCRIPTION";
	      } else {
	        data.userSubscription.type = "ANONYMOUS";
	      }
	
	      // @todo when freemium added, implement freemiumModelData -> see old webreader implementation
	      // @todo when metered added, implement meteredModelData -> see old webreader implementation
	
	      if (window.app !== "undefined" && window.app.platform !== "undefined" && typeof window.app.platform.gotUserNavigationData === "function") {
	        window.app.platform.gotUserNavigationData(data);
	      }
	    }
	  }, {
	    key: "getPublicationDetails",
	    value: function getPublicationDetails() {
	      var publicationDetails = {
	        cpId: this._pubStore.cpID,
	        pubId: this._pubStore.pubId,
	        pageNumber: this._appState.currentPage,
	        pageUrl: window.location.href
	      };
	
	      if (window.app !== "undefined" && window.app.platform !== "undefined" && typeof window.app.platform.gotUserNavigationData === "function") {
	        window.app.platform.gotPublicationDetails(publicationDetails);
	      }
	    }
	  }, {
	    key: "openExternalAuthenticationPopup",
	    value: function openExternalAuthenticationPopup() {
	      // @todo open external authentication popup
	    }
	  }, {
	    key: "redirectToHome",
	    value: function redirectToHome() {
	      if (this._options.nextgen.redirectUrl) {
	        window.open(this._options.nextgen.redirectUrl);
	      }
	    }
	  }, {
	    key: "setPageTitle",
	    value: function setPageTitle(title) {
	      document.title = title;
	    }
	  }, {
	    key: "shouldDisplayAds",
	    value: function shouldDisplayAds(subscriptionTypeAdvertised) {
	      var userSubscriptionType = this._appState.getUserSubscriptionType();
	      return subscriptionTypeAdvertised.indexOf(userSubscriptionType) !== -1;
	    }
	  }, {
	    key: "addCurrentPageToCredits",
	    value: function addCurrentPageToCredits() {
	      var userSubscriptionType = this._appState.getUserSubscriptionType();
	      if (userSubscriptionType !== "METERED") {
	        // @todo implement -> see readerApp.freemium.addFreePage function call in old webreader
	      }
	    }
	  }, {
	    key: "ERSendEvent",
	    value: function ERSendEvent(data, eventOrigin) {
	      var isNextgenEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      this._appState.setActiveNextgenPage(data, true);
	      var nextgenData = { nextgenEvent: isNextgenEvent };
	      this._appState.triggerEvent(eventNames.PERCENTAGE_IN_VIEW_COMPUTED, nextgenData, true);
	    }
	  }, {
	    key: "sendGoogleInfo",
	    value: function sendGoogleInfo(event, eventData) {
	      var eventName = "";
	      if ((typeof event === "undefined" ? "undefined" : (0, _typeof3.default)(event)) === "object") {
	        eventName = eventNames.VIEW_PAGE_NEXGEN;
	        this.setupPage(event.page - 1);
	      } else {
	        eventName = eventNames[event];
	      }
	
	      // @todo send data with Google Tag Manager depending on settings
	      this._appState.triggerEvent(eventName, eventData, true);
	    }
	  }, {
	    key: "sendGoogleEventInfo",
	    value: function sendGoogleEventInfo() {
	      // @todo send data with Google Tag Manager
	    }
	  }, {
	    key: "setupPage",
	    value: function setupPage(pageIndex) {
	      var page = this._pubStore.getCurrentPages(pageIndex);
	      if (page) this._appState.setActiveNextgenPage(page);
	    }
	  }]);
	  return Bridge;
	}();
	
	exports.default = Bridge;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(85);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _clickZonesComponent = __webpack_require__(378);
	
	var _clickZonesComponent2 = _interopRequireDefault(_clickZonesComponent);
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClickZonesComponent = function () {
	  function ClickZonesComponent(appState, page, index, options) {
	    var DOMContainer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : (0, _utils.requiredArg)("DOMContainer");
	    var prepend = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	    (0, _classCallCheck3.default)(this, ClickZonesComponent);
	
	    this._appState = appState;
	    this._page = page;
	    this._index = index;
	    this._options = options;
	    this._DOMContainer = DOMContainer;
	    this._prepend = prepend;
	  }
	
	  (0, _createClass3.default)(ClickZonesComponent, [{
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var context = {};
	      context.clickZone = this._createClickZones();
	      Dust.render(_clickZonesComponent2.default, context, function (err, result) {
	        if (_this._prepend) {
	          var div = document.createElement("div");
	          div.innerHTML = result;
	          div.classList.add("swiper-slide-page-click-container");
	          _this._DOMContainer.append(div);
	        } else {
	          _this._DOMContainer.innerHTML = result;
	        }
	      });
	    }
	
	    ////////////
	
	  }, {
	    key: "_createClickZones",
	    value: function _createClickZones() {
	      var _this2 = this;
	
	      return [].concat((0, _toConsumableArray3.default)(this._page.content)).sort(function (a, b) {
	        return a.Width * a.Height < b.Width * b.Height ? 1 : -1;
	      }).map(function (content, index) {
	        return _this2._createClickZone(content, index);
	      });
	    }
	  }, {
	    key: "_createClickZone",
	    value: function _createClickZone(content, index) {
	      var left = content.StartX / this._options.page_width_reference * 100;
	      var top = content.StartY / this._options.page_height_reference * 100;
	      var width = content.Width / this._options.page_width_reference * 100;
	      var height = content.Height / this._options.page_height_reference * 100;
	
	      //cut of zones that are > 100%
	      if (width > 100) {
	        width = 100;
	      }
	      if (height > 100) {
	        height = 100;
	      }
	
	      var clickZone = [];
	      clickZone.left = left;
	      clickZone.top = top;
	      clickZone.width = width;
	      clickZone.height = height;
	      clickZone.articleNumber = index;
	      clickZone.contentID = content.ContentID;
	      clickZone.index = this._index;
	      clickZone.pageID = this._page.PublicationPageID;
	
	      if (content.contentItemContent().extraType) {
	        clickZone.extra = true;
	        clickZone.extraType = content.contentItemContent().extraType;
	        clickZone.extraNumber = content.contentItemContent().extras.length;
	
	        if (clickZone.extraNumber === 1 && clickZone.extraType === ("url" || "video")) {
	          clickZone.extraUrl = content.contentItemContent().extras[0].ContentItemUrl;
	        }
	
	        if (this._options.extraLinkDirectAccess) {
	          if (clickZone.extraNumber === 1 && clickZone.extraType === ("url" || "video") && content.contentItemContent().images.length <= 0 && content.contentItemContent().article.HtmlText === "" && content.contentItemContent().article.Introduction === "") {
	            clickZone.hasOnlyLinkOrVideo = true;
	          }
	        }
	
	        if (content.contentItemContent().extraPlacement && content.contentItemContent().extraPlacement.PublicationPageID == this._page.PublicationPageID) {
	          var _content$contentItemC = content.contentItemContent(),
	              extraPlacement = _content$contentItemC.extraPlacement;
	
	          var readerDimentions = this._appState.isDesktop ? $("#turn-reader").turn("options") : {
	            width: $(".swiper-slide-active .swiper-slide-container").width(),
	            height: $(".swiper-slide-active .swiper-slide-container").height()
	          };
	          var pageWidth = readerDimentions.width / 2;
	          var pageHeight = readerDimentions.height;
	
	          var ratioWidth = this._options.page_width_reference / pageWidth;
	          var ratioHeight = this._options.page_height_reference / pageHeight;
	
	          var xOffset = 0;
	          var yOffset = 0;
	
	          switch (this._options.enrichment_placement_horizontal) {
	            case "right":
	              xOffset = extraPlacement.Width;
	              break;
	            case "center":
	              xOffset = extraPlacement.Width / 2;
	              break;
	            default:
	              break;
	          }
	
	          switch (this._options.enrichment_placement_vertical) {
	            case "bottom":
	              yOffset = extraPlacement.Height;
	              break;
	            case "center":
	              yOffset = extraPlacement.Height / 2;
	              break;
	            default:
	              break;
	          }
	
	          var enrichmentX = (extraPlacement.StartX + xOffset) / ratioWidth;
	          var enrichmentY = (extraPlacement.StartY + yOffset) / ratioHeight;
	
	          var enrichmentXPercent = enrichmentX / pageWidth * 100;
	          var enrichmentYPercent = enrichmentY / pageHeight * 100;
	
	          clickZone.extraPosition = {
	            top: enrichmentYPercent + "%",
	            left: enrichmentXPercent + "%",
	            corner: this._options.enrichment_placement_horizontal + "-" + this._options.enrichment_placement_vertical
	          };
	        }
	      }
	      return clickZone;
	    }
	  }]);
	  return ClickZonesComponent;
	}();
	
	exports.default = ClickZonesComponent;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _cookie = __webpack_require__(379);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _redirectorKeys = __webpack_require__(23);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Contstructs the Cookie view
	 */
	var Cookie = function () {
	  function Cookie(appState, DOMContainer, cookieManager, options) {
	    (0, _classCallCheck3.default)(this, Cookie);
	    this.appState = null;
	    this.DOMContainer = null;
	    this.cookieManager = null;
	    this.options = null;
	
	    this.appState = appState;
	    this.DOMContainer = DOMContainer;
	    this.cookieManager = cookieManager;
	    this.options = options;
	
	    // coockie warning when the cookie_info_cookie_name is defined
	    if (this.options.cookie_info_cookie_name) {
	      var fetchedString = this.cookieManager.getCookie(this.options.cookie_info_cookie_name);
	      if (typeof fetchedString !== "undefined") {
	        // cookie is allready accepted -> dont show cookie
	      } else {
	        this.showCookie();
	      }
	    }
	  }
	
	  (0, _createClass3.default)(Cookie, [{
	    key: "showCookie",
	    value: function showCookie() {
	      var _this = this;
	
	      if (this.DOMContainer !== null) {
	        //create context
	        var context = {};
	        context.text = _dictionary2.default.CookieInformText;
	        context.text_link = _dictionary2.default.CookieLinkText;
	        context.button = _dictionary2.default.CookieConfirmButton;
	        _apimanager2.default.getRedirectorUrl(_redirectorKeys.COOKIE_MORE_INFO, this.appState.buildVersion, this.appState.userId, this.appState.downloadToken).then(function (result) {
	          context.link = result;
	        }).catch(function () {
	          context.link = null;
	        }).then(function () {
	          Dust.render(_cookie2.default, context, function (err, result) {
	            _this.DOMContainer.innerHTML = result;
	            _this.attatchClickHandlers();
	          });
	        });
	      }
	    }
	  }, {
	    key: "attatchClickHandlers",
	    value: function attatchClickHandlers() {
	      var _this2 = this;
	
	      var cookieConfirm = document.querySelector(".cookie-confirm");
	      if (cookieConfirm !== null) {
	        cookieConfirm.addEventListener("click", function () {
	          _this2.confirmedCookie();
	        });
	      }
	    }
	  }, {
	    key: "confirmedCookie",
	    value: function confirmedCookie() {
	      $(".cookie-container").hide();
	      this.cookieManager.createCookie(this.options.cookie_info_cookie_name, true);
	      this.appState.triggerEvent(_analyticsevents.CLICKED_COOKIEACCEPT);
	    }
	  }]);
	  return Cookie;
	}();
	
	exports.default = Cookie;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(97);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _downloadButtonComponent = __webpack_require__(380);
	
	var _downloadButtonComponent2 = _interopRequireDefault(_downloadButtonComponent);
	
	var _utils = __webpack_require__(10);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _pdfDownloadComponent = __webpack_require__(271);
	
	var _pdfDownloadComponent2 = _interopRequireDefault(_pdfDownloadComponent);
	
	var _enums = __webpack_require__(84);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DownloadButtonComponent = function (_Emitter) {
	  (0, _inherits3.default)(DownloadButtonComponent, _Emitter);
	
	  function DownloadButtonComponent(pubStore, appState, options, sessionManager) {
	    (0, _classCallCheck3.default)(this, DownloadButtonComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DownloadButtonComponent.__proto__ || (0, _getPrototypeOf2.default)(DownloadButtonComponent)).call(this));
	
	    _this._closeDownloadOptions = function () {
	      _this.pdfDownloadComponent.close();
	    };
	
	    _this._reset = function () {
	      _this._pageToDownload = [];
	      _this._closeDownloadOptions();
	    };
	
	    _this._pubStore = pubStore;
	    _this._appState = appState;
	    _this._options = options;
	    _this.DOMContainer = document.querySelector(".top-bar-container .top-bar-access");
	    _this._fullpdfUrl = "";
	    _this._pageToDownload = [];
	    _this._sessionManager = sessionManager;
	    return _this;
	  }
	
	  (0, _createClass3.default)(DownloadButtonComponent, [{
	    key: "render",
	    value: function render() {
	      if (this._sessionManager.isFeatureEnabled(_enums.EEnabledFeatures.DOWNLOAD_PDF)) {
	        //If there is no FullPf available do not render the download component.
	        if (!this._pubStore.CPackage.FullPdfAvailable && !this._pubStore.PublicationToLoad.FullPdfAvailable) {
	          return;
	        }
	
	        if (this.DOMContainer) {
	          var context = {
	            useCustomToolTip: this._options.useCustomTooltips,
	            displayTopNavButtonlabel: this._options ? this._options.displayTopNavButtonlabel : false,
	            i18n: _dictionary2.default
	          };
	          Dust.render(_downloadButtonComponent2.default, context, this._renderDone.bind(this));
	        }
	      }
	    }
	  }, {
	    key: "_renderDone",
	    value: function _renderDone(err, result) {
	      if (this.DOMContainer.getElementsByClassName("download-button-component").length === 0) {
	        var div = (0, _utils.createDivWithClass)("download-button-component");
	        div.setAttribute("id", "download-publication");
	
	        if (this._options && this._options.displayTopNavButtonlabel) {
	          div.classList.add("labelDisplayed");
	        }
	        this.DOMContainer.appendChild(div);
	      }
	      var donwloadButtonContainer = this.DOMContainer.getElementsByClassName("download-button-component")[0];
	      donwloadButtonContainer.innerHTML = result;
	      var downloadOptionContainer = this.DOMContainer.querySelector(".download-button-component .downloadOption-container");
	      this.pdfDownloadComponent = new _pdfDownloadComponent2.default(this._appState, downloadOptionContainer, this._options);
	      this._attachEventListeners(); //When only full odf download is enabled.
	      this._enableDownloadOptions(downloadOptionContainer);
	    }
	  }, {
	    key: "_attachEventListeners",
	    value: function _attachEventListeners() {
	      var _this2 = this;
	
	      this.iconEl = document.getElementById("download-publication");
	      this._appState.on("alb:overlayClicked", this._closeDownloadOptions.bind(this));
	      this._appState.on("cropper:overlayClicked", this._closeDownloadOptions.bind(this));
	      this._appState.on("readerContainer:clicked", this._closeDownloadOptions.bind(this));
	      this._appState.on("printButton:clicked", this._closeDownloadOptions.bind(this));
	      this._appState.on("categoryDropdown:opened", this._closeDownloadOptions.bind(this));
	      this._appState.on("settingButton:clicked", this._closeDownloadOptions.bind(this));
	      this._appState.on("readerReadingMode:clicked", this._closeDownloadOptions.bind(this));
	      this._pubStore.on("pubStore:pubLoaded", function () {
	        _this2._closeDownloadOptions();
	        _this2._fullpdfUrl = "";
	      });
	
	      this.iconEl.addEventListener("click", function () {
	        _this2._appState.trigger("downloadButton:clicked");
	        //check if full pdf download only is enabled.
	        if (_this2._options.reader.fullPdfDownloadOnly) {
	          //If full pdf not yet fteched, fetch it.
	          _this2._fetchFullDownloadUrl().then(function () {
	            window.open(_this2._fullpdfUrl, "_self");
	            _this2._sendConfirmDownload();
	          }).catch(function () {
	            //TODO some error handling?
	          });
	        } else {
	          var pages = _this2._getPagesToDownload();
	          //fetch full and single pdf.
	          _promise2.default.all([_this2._options.reader.allowFullPdfDownload ? _this2._fetchFullDownloadUrl() : _promise2.default.resolve(), _this2._fetchSinglePdfUrls(pages)]).then(function () {
	            _this2.pdfDownloadComponent.toggleVisibility();
	          }).catch(function () {
	            //TODO some error handling?
	          });
	          _this2._appState.on("appState:currentpagechanged", _this2._reset.bind(_this2));
	        }
	      });
	    }
	  }, {
	    key: "_enableDownloadOptions",
	    value: function _enableDownloadOptions(downloadOptionContainer) {
	      var _this3 = this;
	
	      if (downloadOptionContainer) {
	        if (downloadOptionContainer.classList.contains("hidden")) {
	          this.pdfDownloadComponent.on("pdfDownloadComponent:downloadFullPdf", function () {
	            _this3._appState.triggerEvent(_analyticsevents.CLICKED_FULLPDFDOWNLOAD_READER);
	            _this3._closeDownloadOptions();
	            window.open(_this3._fullpdfUrl, "_blank");
	            _this3._sendConfirmDownload();
	          });
	          this.pdfDownloadComponent.on("pdfDownloadComponent:downloadSinglePagePdf", function () {
	            _this3._appState.triggerEvent(_analyticsevents.CLICKED_SINGLEPAGEPDFDOWNLOAD_READER);
	            _this3._closeDownloadOptions();
	            var url = _this3._pageToDownload[0].url;
	            window.open(url, "_blank");
	          });
	          this.pdfDownloadComponent.on("pdfDownloadComponent:downloadLeftPagePdf", function () {
	            _this3._appState.triggerEvent(_analyticsevents.CLICKED_SINGLEPAGEPDFDOWNLOAD_READER);
	            _this3._closeDownloadOptions();
	            var page = _this3._pageToDownload.filter(function (obj) {
	              return obj.position === "left";
	            });
	            window.open(page[0].url, "_blank");
	          });
	          this.pdfDownloadComponent.on("pdfDownloadComponent:downloadRightPagePdf", function () {
	            _this3._appState.triggerEvent(_analyticsevents.CLICKED_SINGLEPAGEPDFDOWNLOAD_READER);
	            _this3._closeDownloadOptions();
	            var page = _this3._pageToDownload.filter(function (obj) {
	              return obj.position === "right";
	            });
	            window.open(page[0].url, "_blank");
	          });
	        }
	      }
	    }
	
	    //close the download option box and remove the event
	
	  }, {
	    key: "_fetchFullDownloadUrl",
	
	
	    //fetch full pdf url donwload it and send confirm download
	    value: function _fetchFullDownloadUrl() {
	      var _this4 = this;
	
	      if (this._fullpdfUrl == "") {
	        var _pubStore$Publication = this._pubStore.PublicationToLoad,
	            FullPdfAvailable = _pubStore$Publication.FullPdfAvailable,
	            PublicationId = _pubStore$Publication.PublicationId;
	        var _appState = this._appState,
	            userId = _appState.userId,
	            sessionId = _appState.sessionId,
	            orderId = _appState.orderId,
	            subscriptionId = _appState.subscriptionId;
	
	
	        var args = [userId, sessionId, orderId, subscriptionId, this._pubStore.cpID, FullPdfAvailable ? PublicationId : null];
	
	        return _apimanager2.default.requestFullPDFDownload.apply(_apimanager2.default, args).then(function (response) {
	          if (response.Status !== "Failed") {
	            return _this4._fullpdfUrl = response.DownloadLink;
	          }
	          throw response.StatusMessage;
	        }).catch(function () {
	          throw "pdf could not be fetched";
	        });
	      } else {
	        return _promise2.default.resolve(this._fullpdfUrl);
	      }
	    }
	  }, {
	    key: "_sendConfirmDownload",
	    value: function _sendConfirmDownload() {
	      var ContentPackageID = this._pubStore.CPackage.ContentPackageID;
	      var _appState2 = this._appState,
	          userId = _appState2.userId,
	          sessionId = _appState2.sessionId,
	          downloadId = _appState2.downloadId;
	
	      _apimanager2.default.confirmDownload({
	        userId: userId,
	        sessionId: sessionId,
	        contentPackageId: ContentPackageID,
	        downloadId: downloadId,
	        downloadStatus: "confirmed"
	      });
	    }
	
	    //get indexes of pages to be printed
	
	  }, {
	    key: "_getPagesToDownload",
	    value: function _getPagesToDownload() {
	      var pagesToBeDownloaded = [];
	      var letPageIndex = this._getLeftPageIndex();
	      if (typeof letPageIndex !== "undefined") {
	        pagesToBeDownloaded.push({
	          position: "left",
	          index: letPageIndex,
	          url: ""
	        });
	      }
	
	      var rightPageIndex = this._getRightPageIndex();
	      if (typeof rightPageIndex !== "undefined") {
	        pagesToBeDownloaded.push({
	          position: "right",
	          index: rightPageIndex,
	          url: ""
	        });
	      }
	      return pagesToBeDownloaded;
	    }
	
	    //get the index of the left page of the currently 2 visible pages
	
	  }, {
	    key: "_getLeftPageIndex",
	    value: function _getLeftPageIndex() {
	      if (this._appState.activePages[0]) {
	        return this._appState.activePages[0].pagePosition - 1;
	      }
	    }
	
	    //get the index of the left page of the currently 2 visible pages
	
	  }, {
	    key: "_getRightPageIndex",
	    value: function _getRightPageIndex() {
	      if (this._appState.activePages[1]) {
	        return this._appState.activePages[1].pagePosition - 1;
	      }
	    }
	
	    //get the pdf of the pages to be downloaded based on their indexes.
	
	  }, {
	    key: "_fetchSinglePdfUrls",
	    value: function _fetchSinglePdfUrls(pages) {
	      var _this5 = this;
	
	      if (this._pageToDownload.length == 0) {
	        var _appState3 = this._appState,
	            userId = _appState3.userId,
	            sessionId = _appState3.sessionId,
	            downloadId = _appState3.downloadId;
	
	        var promises = [];
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          var _loop = function _loop() {
	            var page = _step.value;
	
	            var pageIndex = page.index;
	            if (_this5._pubStore.CPackagePages[pageIndex]) {
	              var args = [_this5._pubStore.CPackagePages[pageIndex].PublicationPageID, sessionId, userId, downloadId];
	
	              promises.push(_apimanager2.default.retreivePdfUrl.apply(_apimanager2.default, args).then(function (url) {
	                if (typeof url !== "undefined" && url !== "") {
	                  page.url = url;
	                  return _this5._pageToDownload.push(page);
	                }
	                throw "Not a valid URL";
	              }).catch(function () {
	                throw "pdf could not be fetched";
	              }));
	            }
	          };
	
	          for (var _iterator = (0, _getIterator3.default)(pages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return _promise2.default.all(promises);
	      } else {
	        return _promise2.default.resolve(this._pageToDownload);
	      }
	    }
	  }]);
	  return DownloadButtonComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = DownloadButtonComponent;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _utils = __webpack_require__(10);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _errorPopup = __webpack_require__(381);
	
	var _errorPopup2 = _interopRequireDefault(_errorPopup);
	
	var _topNavigationOverlay = __webpack_require__(118);
	
	var _topNavigationOverlay2 = _interopRequireDefault(_topNavigationOverlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this is needed!
	
	var ErrorPopup = function (_Emitter) {
	  (0, _inherits3.default)(ErrorPopup, _Emitter);
	
	  function ErrorPopup(appState, DOMContainer) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    (0, _classCallCheck3.default)(this, ErrorPopup);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ErrorPopup.__proto__ || (0, _getPrototypeOf2.default)(ErrorPopup)).call(this));
	
	    _this.appState = null;
	    _this.DOMContainer = null;
	    _this.options = null;
	    _this.publicationData = null;
	    _this.disabledScrolling = [];
	
	    _this.appState = appState;
	    _this.DOMContainer = DOMContainer;
	    _this.options = options;
	    _this.render();
	    return _this;
	  }
	
	  (0, _createClass3.default)(ErrorPopup, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.DOMContainer !== null) {
	        //create context
	        var context = {};
	        context.close = true;
	        context.back = true;
	        context.language = _dictionary2.default;
	        Dust.render(_errorPopup2.default, context, function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	          _this2.attachClickHandlers();
	        });
	      }
	    }
	  }, {
	    key: "attachClickHandlers",
	    value: function attachClickHandlers() {
	      var _this3 = this;
	
	      if (this.DOMContainer !== null) {
	        $(this.DOMContainer).on("click", function (e) {
	          if (e.target === _this3.DOMContainer) {
	            e.preventDefault();
	            _this3.hide();
	            _this3.trigger("errorPopup:close");
	          }
	        });
	        $(this.DOMContainer).on("click", ".overlay-navigation-close", function () {
	          _this3.onClose();
	        });
	        $(this.DOMContainer).on("click", "#btn_close", function () {
	          _this3.onClose();
	        });
	        $(this.DOMContainer).on("click", ".overlay-navigation-back", function () {
	          _this3.onBack();
	        });
	      }
	    }
	  }, {
	    key: "onClose",
	    value: function onClose() {
	      this.hide();
	      this.appState.triggerEvent(_analyticsevents.CLICKED_CLOSE_ERRORPOPUP);
	      this.trigger("errorPopup:close");
	    }
	  }, {
	    key: "onBack",
	    value: function onBack() {
	      this.hide();
	      this.appState.triggerEvent(_analyticsevents.CLICKED_BACK_ERRORPOPUP);
	      this.trigger("errorPopup:back");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (this.DOMContainer) {
	        this.DOMContainer.classList.add("hidden");
	      }
	      (0, _utils.enableAllScrolling)(this.disabledScrolling);
	
	      this.appState.triggerEvent(_analyticsevents.CLOSED_ERRORPOPUP);
	    }
	  }, {
	    key: "show",
	    value: function show(error) {
	      if (error) {
	        if (this.DOMContainer) {
	          var back = this.DOMContainer.querySelector(".overlay-navigation-back");
	          var titleContainer = this.DOMContainer.querySelector(".overlay-navigation-title");
	          var message = (0, _utils.getErrorMessage)(error, _dictionary2.default);
	          var errorContainer = this.DOMContainer.querySelector(".error-message");
	          if (back && titleContainer) {
	            titleContainer.innerHTML = _dictionary2.default.Sorry;
	            this.DOMContainer.classList.add("showOverlay");
	            back.classList.add("hidden");
	            titleContainer.classList.remove("hidden");
	          }
	          this.DOMContainer.classList.remove("hidden");
	          this.disabledScrolling = (0, _utils.disableAllScrolling)();
	          this.appState.triggerEvent(_analyticsevents.OPENED_ERRORPOPUP);
	          if (errorContainer) {
	            errorContainer.innerHTML = message;
	            errorContainer.classList.remove("hidden");
	          }
	        }
	      }
	    }
	  }]);
	  return ErrorPopup;
	}(_es6EventEmitter2.default);
	// eslint-disable-next-line
	
	
	exports.default = ErrorPopup;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _cookiemanager = __webpack_require__(24);
	
	var _cookiemanager2 = _interopRequireDefault(_cookiemanager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FontSizeService = function () {
	  function FontSizeService(options) {
	    (0, _classCallCheck3.default)(this, FontSizeService);
	    this.DOMContainer = null;
	    this.options = null;
	
	    this.options = options;
	    this.init();
	  }
	
	  (0, _createClass3.default)(FontSizeService, [{
	    key: "init",
	    value: function init() {
	      var cookie = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.FONTSIZE);
	      var size = this.options.rootFontSize;
	      if (cookie) {
	        size = JSON.parse(cookie).size;
	        if (size < 3) {
	          // Case for old cookies
	          size = this.options.rootFontSize;
	        }
	      }
	      document.documentElement.setAttribute("style", "font-size: " + size + "px;");
	    }
	  }, {
	    key: "increase",
	    value: function increase() {
	      var fontSize = parseInt(document.documentElement.style.fontSize);
	      if (fontSize < this.options.maxfontSize) {
	        fontSize += this.options.fontSizeStep;
	      } else {
	        fontSize = 10;
	      }
	      _cookiemanager2.default.createCookie(_cookiemanager2.default.cookieKeys.FONTSIZE, (0, _stringify2.default)({
	        size: fontSize
	      }));
	      document.documentElement.setAttribute("style", "font-size: " + fontSize + "px");
	    }
	  }]);
	  return FontSizeService;
	}();
	
	exports.default = FontSizeService;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _utils = __webpack_require__(10);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _redirectorKeys = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Contstructs the Kiosque view
	 */
	var CommonKiosque = function (_Emitter) {
	  (0, _inherits3.default)(CommonKiosque, _Emitter);
	
	  function CommonKiosque(appState, DOMContainer, dustFile, options) {
	    (0, _classCallCheck3.default)(this, CommonKiosque);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CommonKiosque.__proto__ || (0, _getPrototypeOf2.default)(CommonKiosque)).call(this));
	
	    _this.appState = null;
	    _this.DOMContainer = null;
	    _this.DOMContent = null;
	    _this.options = null;
	    _this._rerunSetMainNewsPaper = null;
	    _this.mainContentPackageId = null;
	
	    _this.appState = appState;
	    _this.DOMContainer = DOMContainer;
	    _this.options = options;
	    _this.render(dustFile);
	    return _this;
	  }
	
	  (0, _createClass3.default)(CommonKiosque, [{
	    key: "createContext",
	    value: function createContext() {
	      var _this2 = this;
	
	      var promise = new _promise2.default(function (resolve) {
	        //create context
	        var context = {};
	        context.i18n = _dictionary2.default;
	
	        if (_this2.appState.isDesktop) {
	          var promises = [_apimanager2.default.getRedirectorUrl(_redirectorKeys.IFRAME_KIOSQUE_TOP, _this2.appState.buildVersion, _this2.appState.userId, _this2.appState.downloadToken), _apimanager2.default.getRedirectorUrl(_redirectorKeys.IFRAME_KIOSQUE_BOTTOM, _this2.appState.buildVersion, _this2.appState.userId, _this2.appState.downloadToken), _apimanager2.default.getRedirectorUrl(_redirectorKeys.IFRAME_KIOSQUE_ARCHIVE, _this2.appState.buildVersion, _this2.appState.userId, _this2.appState.downloadToken), _apimanager2.default.getRedirectorUrl(_redirectorKeys.IFRAME_KIOSQUE_ARCHIVE_BOTTOM, _this2.appState.buildVersion, _this2.appState.userId, _this2.appState.downloadToken)];
	          _promise2.default.all(promises.map(_utils.reflect)).then(function (result) {
	            if (result[0].status === "resolved") {
	              context.iFrameTopURL = result[0].v;
	            }
	            if (result[1].status === "resolved") {
	              context.iFrameBottomURL = result[1].v;
	            }
	            if (result[2].status === "resolved") {
	              context.iframeArchiveURL = result[2].v;
	            }
	            if (result[3].status === "resolved") {
	              context.iframeArchiveBottomURL = result[3].v;
	            }
	            resolve(context);
	          });
	        } else {
	          _apimanager2.default.getRedirectorUrl(_redirectorKeys.IFRAME_KIOSQUE_MOBILE, _this2.appState.buildVersion, _this2.appState.userId, _this2.appState.downloadToken).then(function (result) {
	            context.iframebanner_source = result;
	          }).catch(function () {
	            context.iframebanner_source = null;
	          }).then(function () {
	            resolve(context);
	          });
	        }
	      });
	      return promise;
	    }
	  }, {
	    key: "render",
	    value: function render(dustFile) {
	      var _this3 = this;
	
	      if (this.DOMContainer) {
	        this.createContext().then(function (context) {
	          Dust.render(dustFile, context, function (err, result) {
	            _this3.DOMContainer.innerHTML = result;
	            _this3.DOMContent = _this3.DOMContainer.querySelector(".kiosque");
	            _this3.attatchCommonClickHandlers();
	            _this3.attatchClickHandlers();
	            _this3.renderDone();
	            // setMainNewsPaper can run before rendering ends
	            if (_this3._rerunSetMainNewsPaper) {
	              setTimeout(function () {
	                _this3.setMainNewsPaper(_this3._rerunSetMainNewsPaper);
	              }, 0);
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: "renderDone",
	    value: function renderDone() {}
	  }, {
	    key: "setContentPackages",
	    value: function setContentPackages(contentPackages) {
	      if (contentPackages) {
	        this.setMainNewsPaper(contentPackages[0]);
	        this.setArchive(contentPackages.slice(1, this.options.archiveLength - 1));
	      }
	    }
	  }, {
	    key: "attatchCommonClickHandlers",
	    value: function attatchCommonClickHandlers() {
	      var _this4 = this;
	
	      var mainImage = this.DOMContainer.querySelector(".main-paper-container .main-image-wrapper img.main-image");
	      if (mainImage) {
	        mainImage.addEventListener("click", function () {
	          _this4.appState.triggerEvent(_analyticsevents.CLICKED_MAIN_HOME);
	          _this4.mainClicked();
	        });
	      }
	
	      var mainButton = this.DOMContainer.querySelector(".main-paper-container .main-button-container .main-button-wrapper");
	      if (mainButton) {
	        mainButton.addEventListener("click", function () {
	          _this4.appState.triggerEvent(_analyticsevents.CLICKED_READ_HOME);
	          _this4.mainClicked();
	        });
	      }
	    }
	  }, {
	    key: "mainClicked",
	    value: function mainClicked() {
	      var publicationId = undefined;
	      var contentPackageId = this.mainContentPackageId;
	      var publicationData = {
	        contentPackageId: contentPackageId,
	        publicationId: publicationId
	      };
	      this.trigger("kiosque:onPublicationClicked", publicationData);
	    }
	  }, {
	    key: "setMainNewsPaper",
	    value: function setMainNewsPaper(contentPackage) {
	      var _this5 = this;
	
	      if (this.DOMContent) {
	        if (contentPackage) {
	          this.mainContentPackageId = contentPackage.ContentPackageId;
	          var mainImage = this.DOMContainer.querySelector(".main-paper-container .main-image-wrapper img.main-image");
	          if (mainImage) {
	            mainImage.setAttribute("src", (0, _utils.generateCoverURL)(this.mainContentPackageId, this.options.sizes.M, contentPackage.ThumbnailId, contentPackage.Version));
	            mainImage.classList.remove("hidden");
	            this._rerunSetMainNewsPaper = null;
	          } else {
	            this._rerunSetMainNewsPaper = contentPackage;
	          }
	          var label = this.DOMContainer.querySelector(".main-paper-container .main-label");
	          if (label) {
	            label.innerHTML = contentPackage.label;
	          }
	        }
	      } else {
	        setTimeout(function () {
	          _this5.setMainNewsPaper(contentPackage);
	        }, 100);
	      }
	    }
	  }, {
	    key: "onPublicationClick",
	    value: function onPublicationClick(e) {
	      var publicationId = e.currentTarget.getAttribute("data-publicationid");
	      var contentPackageId = e.currentTarget.getAttribute("data-contentpackageid");
	      var publicationData = {
	        contentPackageId: contentPackageId,
	        publicationId: publicationId
	      };
	      this.trigger("kiosque:onPublicationClicked", publicationData);
	    }
	  }]);
	  return CommonKiosque;
	}(_es6EventEmitter2.default);
	
	exports.default = CommonKiosque;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _spinner = __webpack_require__(49);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loader = function () {
	  function Loader() {
	    (0, _classCallCheck3.default)(this, Loader);
	    this.DOMContainer = null;
	
	    this.DOMContainer = document.querySelector("#loader");
	    this.render();
	  }
	
	  (0, _createClass3.default)(Loader, [{
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      Dust.render(_spinner2.default, {}, function (err, result) {
	        _this.DOMContainer.innerHTML = result;
	      });
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (this.DOMContainer) {
	        this.DOMContainer.classList.remove("hidden");
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (this.DOMContainer) {
	        this.DOMContainer.classList.add("hidden");
	      }
	    }
	  }]);
	  return Loader;
	}();
	
	exports.default = Loader;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _sharingComponent = __webpack_require__(93);
	
	var _sharingComponent2 = _interopRequireDefault(_sharingComponent);
	
	var _utils = __webpack_require__(10);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NextgenSharing = function () {
	  function NextgenSharing(appState, articleDetails, DOMContainer) {
	    var _this = this;
	
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    (0, _classCallCheck3.default)(this, NextgenSharing);
	
	    this.close = function () {
	      _this.DOMContainer.classList.add("hidden");
	      _this.DOMContainer.removeEventListener("click", function (evt) {
	        _this.close(evt);
	      });
	    };
	
	    this.appState = appState;
	    this.articleDetails = articleDetails;
	    this.DOMContainer = DOMContainer;
	    this.options = options;
	    this.init();
	  }
	
	  (0, _createClass3.default)(NextgenSharing, [{
	    key: "init",
	    value: function init() {
	      var url = this.createUrl();
	      var links = null;
	      if (url) {
	        links = (0, _utils.createSharingUrls)(url, {
	          title: this.articleDetails.Title ? this.articleDetails.Title : "",
	          intro: this.articleDetails.Introduction ? this.articleDetails.Introduction : ""
	        }, this.options.sharingOptions, this.appState.isDesktop);
	      }
	      this.shareComponent = new _sharingComponent2.default(this.appState, links, this.DOMContainer, this.options, _analyticsevents.OPENED_SHARE_MENU_NEXTGEN);
	      this.DOMContainer.classList.remove("hidden");
	    }
	  }, {
	    key: "createUrl",
	    value: function createUrl() {
	      var url = null;
	      if (this.options.shareFromNextgen) {
	        url = this.appState._nextgenSharingUrl;
	        if (url) {
	          url = url.replace(/\{0\}/g, this.articleDetails.ContentPackageId);
	          url = url.replace(/\{1\}/g, this.articleDetails.PublicationID);
	          url = url.replace(/\{2\}/g, this.articleDetails.PageNumber);
	          url = url.replace(/\{3\}/g, this.articleDetails.ContentId);
	          var intro = this.articleDetails.Introduction;
	          var title = this.articleDetails.Title;
	          if (intro) {
	            url = url.replace(/\{4\}/g, encodeURIComponent(intro));
	          } else {
	            url = url.replace(/\{4\}/g, encodeURIComponent(title));
	          }
	          url = url.replace(/\{5\}/g, encodeURIComponent(title));
	          url = url.replace(/\{6\}/g, encodeURIComponent(this.articleDetails.ImageUrl));
	        }
	
	        return url;
	      }
	    }
	  }]);
	  return NextgenSharing;
	}();
	
	exports.default = NextgenSharing;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _topNavigationOverlay = __webpack_require__(118);
	
	var _topNavigationOverlay2 = _interopRequireDefault(_topNavigationOverlay);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _utils = __webpack_require__(10);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _paywall = __webpack_require__(384);
	
	var _paywall2 = _interopRequireDefault(_paywall);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _redirectorKeys = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Contstructs the Paywall view
	 */
	// this is needed!
	var Paywall = function (_Emitter) {
	  (0, _inherits3.default)(Paywall, _Emitter);
	
	  function Paywall(appState, authenticatorAuthorisationController, DOMContainer, options) {
	    (0, _classCallCheck3.default)(this, Paywall);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Paywall.__proto__ || (0, _getPrototypeOf2.default)(Paywall)).call(this));
	
	    _this.appState = null;
	    _this.authenticatorAuthorisationController = null;
	    _this.DOMContainer = null;
	    _this.options = null;
	    _this.publicationData = null;
	    _this.disabledScrolling = [];
	
	    _this.appState = appState;
	    _this.authenticatorAuthorisationController = authenticatorAuthorisationController;
	    _this.DOMContainer = DOMContainer;
	    _this.options = options;
	    _this.render();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Paywall, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.DOMContainer !== null) {
	        //create context
	        var context = {};
	        context.title = _dictionary2.default.LogIn;
	        context.close = true;
	        context.back = true;
	        context.email = _dictionary2.default.Username;
	        context.password = _dictionary2.default.Password;
	        context.cancel = _dictionary2.default.Cancel;
	        context.login = _dictionary2.default.LogIn;
	        context.forgot = _dictionary2.default.ForgotPassword;
	        context.showPassword = !this.options.noPasswordLogin;
	
	        var aboBanner = this.appState.isDesktop ? _redirectorKeys.ABO_BANNER_DESKTOP : _redirectorKeys.ABO_BANNER_MOBILE;
	        _apimanager2.default.getRedirectorUrl(aboBanner, this.appState.buildVersion, this.appState.userId, this.appState.downloadToken).then(function (result) {
	          context.iframebannerSource = result;
	        }).catch(function () {
	          context.iframebannerSource = null;
	        }).then(function () {
	          Dust.render(_paywall2.default, context, function (err, result) {
	            _this2.DOMContainer.innerHTML = result;
	            _this2.attachClickHandlers();
	          });
	        });
	      }
	    }
	  }, {
	    key: "retreiveUrls",
	    value: function retreiveUrls() {}
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (this.DOMContainer) {
	        this.DOMContainer.classList.add("hidden");
	      }
	      (0, _utils.enableAllScrolling)(this.disabledScrolling);
	      this.removeContentInput();
	      //when focusing on input field and soft keybaord appears android scrolls to position input field in closest scrollcontainer from body!
	      // -> will scroll in scroll-container-kiosque and therefore this needs to be reset to 0
	      // let scroll = document.querySelector('body');
	      // if(scroll) {
	      //   scroll.scrollTop = 0;
	      // }
	      this.appState.triggerEvent(_analyticsevents.CLOSED_PAYWALL);
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      var publicationData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.publicationData = publicationData;
	      if (this.DOMContainer) {
	        var back = this.DOMContainer.querySelector(".overlay-navigation-back");
	        var titleContainer = this.DOMContainer.querySelector(".overlay-navigation-title");
	        if (back && titleContainer) {
	          if (title) {
	            titleContainer.innerHTML = title;
	            this.DOMContainer.classList.remove("showOverlay");
	            back.classList.remove("hidden");
	          } else {
	            titleContainer.innerHTML = _dictionary2.default.LogIn;
	            this.DOMContainer.classList.add("showOverlay");
	            back.classList.add("hidden");
	          }
	        }
	        this.DOMContainer.classList.remove("hidden");
	        this.disabledScrolling = (0, _utils.disableAllScrolling)();
	        //Load iframe after the paywal is displayed to avoid having wrong height
	        this.loadIframe();
	        this.appState.triggerEvent(_analyticsevents.OPENED_PAYWALL);
	      }
	    }
	  }, {
	    key: "attachClickHandlers",
	    value: function attachClickHandlers() {
	      var _this3 = this;
	
	      if (this.DOMContainer !== null) {
	        $(this.DOMContainer).on("click", function (e) {
	          if (e.target === _this3.DOMContainer) {
	            e.preventDefault();
	            _this3.hide();
	            _this3.trigger("paywall:close");
	          }
	        });
	        $(this.DOMContainer).on("click", ".overlay-navigation-close", function () {
	          _this3.onClose();
	        });
	        $(this.DOMContainer).on("click", ".overlay-navigation-back", function () {
	          _this3.onBack();
	        });
	        $(this.DOMContainer).on("click", ".paywall-button-login", function () {
	          _this3.onSubmit();
	        });
	        $(this.DOMContainer).on("click", ".forgot-password", function () {
	          _this3.onPasswordForgotten(_dictionary2.default.passwordForgottenLoadingText);
	        });
	        $("#login-username", this.DOMContainer).on("focus", this.usernameFieldFocusHandler.bind(this));
	        $("#login-password", this.DOMContainer).on("focus", this.passwordFieldFocusHandler.bind(this));
	      }
	      var inputUserName = this.DOMContainer.querySelector("#login-username");
	      if (inputUserName !== null) {
	        inputUserName.addEventListener("keyup", function (e) {
	          _this3.onKeyUpUserName(e);
	        });
	        inputUserName.addEventListener("focus", function () {
	          // this.scrollIntoView();   //TODO: not good solution: interfers with native centering input
	        });
	      }
	      var inputPassword = this.DOMContainer.querySelector("#login-password");
	      if (inputPassword !== null) {
	        inputPassword.addEventListener("keyup", function (e) {
	          _this3.onKeyUpPassword(e);
	        });
	        inputPassword.addEventListener("focus", function () {
	          // this.scrollIntoView();
	        });
	      }
	      // let virtualKeyboard = new VirtualKeyboard();
	      // virtualKeyboard.on('keyboardVisible', this.keyboardVisible);
	      // virtualKeyboard.on('keyboardHidden', this.keyboardHidden);
	    }
	  }, {
	    key: "scrollIntoView",
	    value: function scrollIntoView() {
	      if (this.appState.isTablet) {
	        var inputUserName = this.DOMContainer.querySelector("#login-username");
	        if (inputUserName) {
	          var offsetTop = $(inputUserName).offset().top;
	          $("html,body").scrollTop(offsetTop - 100);
	        }
	      }
	    }
	  }, {
	    key: "onClose",
	    value: function onClose() {
	      this.hide();
	      this.appState.triggerEvent(_analyticsevents.CLICKED_CLOSE_PAYWALL);
	      this.trigger("paywall:close");
	    }
	  }, {
	    key: "onBack",
	    value: function onBack() {
	      this.hide();
	      this.appState.triggerEvent(_analyticsevents.CLICKED_BACK_PAYWALL);
	      this.trigger("paywall:back");
	    }
	  }, {
	    key: "isAValidEmail",
	    value: function isAValidEmail(email) {
	      if (/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,20}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/.test(email)) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "onSubmit",
	    value: function onSubmit() {
	      var userName = $.trim($(this.DOMContainer).find("#login-username").val());
	      var password = this.options.noPasswordLogin ? "123456" : $.trim($(this.DOMContainer).find("#login-password").val());
	
	      //if one of the fields is empty show error
	      if (userName.length === 0 || password.length === 0) {
	        this.showError((0, _utils.createError)("PW-FIELDS", "Not all fields are filled in", {}));
	      } else if (this.options.subscription_validate_email && !this.isAValidEmail(userName)) {
	        this.showError((0, _utils.createError)("PW-EMAIL", "Username is not an email", {}));
	      } else {
	        this.login(userName, password);
	      }
	      this.appState.triggerEvent(_analyticsevents.CLICKED_LOGIN_PAYWALL);
	    }
	  }, {
	    key: "onPasswordForgotten",
	    value: function onPasswordForgotten(loadingScreenText) {
	      var emptyWindow = window.open("", "_blank");
	      emptyWindow.document.write(loadingScreenText);
	      this.appState.triggerEvent(_analyticsevents.CLICKED_FORGOTPW_PAYWALL);
	      _apimanager2.default.getRedirectorUrl(_redirectorKeys.PASSWORD_FORGOTTEN, this.appState.buildVersion, this.appState.userId, this.appState.downloadToken).then(function (result) {
	        if (result.substr(0, 7).toLowerCase() === "mailto:") {
	          window.location.href = result;
	        } else {
	          //window.open(result);
	          emptyWindow.location.href = result;
	        }
	      }).catch(function () {
	        //TODO: do nothing?
	      });
	    }
	  }, {
	    key: "onKeyUpUserName",
	    value: function onKeyUpUserName(e) {
	      if (e.keyCode === 13) {
	        this.DOMContainer.querySelector("#login-password").focus();
	      }
	    }
	  }, {
	    key: "onKeyUpPassword",
	    value: function onKeyUpPassword(e) {
	      if (e.keyCode === 13) {
	        this.DOMContainer.querySelector(".paywall-button-login").click();
	      }
	    }
	  }, {
	    key: "usernameFieldFocusHandler",
	    value: function usernameFieldFocusHandler() {
	      if (!this.DOMContainer.classList.contains("hidden")) {
	        this.appState.triggerEvent(_analyticsevents.FOCUS_USERNAME_PAYWALL);
	      }
	    }
	  }, {
	    key: "passwordFieldFocusHandler",
	    value: function passwordFieldFocusHandler() {
	      if (!this.DOMContainer.classList.contains("hidden")) {
	        this.appState.triggerEvent(_analyticsevents.FOCUS_PASSWORD_PAYWALL);
	      }
	    }
	  }, {
	    key: "login",
	    value: function login(userName, password) {
	      var _this4 = this;
	
	      this.showLoader();
	      if (this.publicationData) {
	        this.authenticatorAuthorisationController.authorizeByUserNamePassword(userName, password, this.publicationData, this.appState.isReader).then(function () {
	          // This is a workaround of the issue with direct access. When we have no valid session and we go directly to a publication,
	          // publication will be downloaded in parellel with authorization. But we need to be authorized before downloading images ->
	          // secure links (secure links demand session reader cookie). This is a corner case, so we do here this huck to be sure
	          // that in time we download publication we already have session reader cookie created.
	          // not needed anymore since authorisation now happens before opening
	          // if (this.appState.isReader && !this.appState.socialSharing) window.location.reload();
	
	          _this4.hide();
	          _this4.trigger("paywall:authorizeSucces", _this4.publicationData);
	          if (_this4.appState.socialSharing) {
	            _this4.appState.triggerEvent(_analyticsevents.PAYWALL_LOGIN_AFTER_SHARE);
	          }
	          if (_this4.appState.isReader && !_this4.appState.socialSharing) window.location.reload();
	        }).catch(function (error) {
	          _this4.showError(error);
	        }).then(function () {
	          _this4.hideLoader();
	        });
	      } else {
	        this.authenticatorAuthorisationController.authenticateByUserNamePassword(userName, password).then(function () {
	          _this4.hide();
	        }).catch(function (error) {
	          _this4.showError(error);
	        }).then(function () {
	          _this4.hideLoader();
	        });
	      }
	    }
	  }, {
	    key: "hideLoader",
	    value: function hideLoader() {
	      var loader = this.DOMContainer.querySelector(".loader-container");
	      if (loader) {
	        loader.classList.add("hidden");
	      }
	    }
	  }, {
	    key: "showLoader",
	    value: function showLoader() {
	      var loader = this.DOMContainer.querySelector(".loader-container");
	      if (loader) {
	        loader.classList.remove("hidden");
	      }
	    }
	  }, {
	    key: "hideError",
	    value: function hideError() {
	      var errorContainer = this.DOMContainer.querySelector(".paywall-error");
	      if (errorContainer) {
	        errorContainer.classList.add("hidden");
	      }
	    }
	  }, {
	    key: "showError",
	    value: function showError(error) {
	      if (error) {
	        var message = (0, _utils.getErrorMessage)(error, _dictionary2.default);
	        var errorContainer = this.DOMContainer.querySelector(".paywall-error");
	        if (errorContainer) {
	          errorContainer.innerHTML = message;
	          errorContainer.classList.remove("hidden");
	        }
	      }
	    }
	
	    //TODO: scrolling
	
	  }, {
	    key: "scrollToLoginInput",
	    value: function scrollToLoginInput() {
	      var inputToScrol = this.DOMContainer.querySelector("#login-username");
	      var paywallMain = this.DOMContainer.querySelector(".paywall-main");
	      if (inputToScrol && paywallMain) {
	        var rectInput = inputToScrol.getBoundingClientRect();
	        var rectBody = paywallMain.getBoundingClientRect();
	        var diff = rectInput.top - rectBody.top;
	        var total = diff - 10;
	        paywallMain.scrollTop += total;
	      }
	    }
	  }, {
	    key: "removeContentInput",
	    value: function removeContentInput() {
	      $(this.DOMContainer).find("#login-username").val("");
	      $(this.DOMContainer).find("#login-password").val("");
	      this.hideError();
	    }
	  }, {
	    key: "loadIframe",
	    value: function loadIframe() {
	      var iframe = this.DOMContainer.querySelector("#abo-banner-iframe");
	      if (iframe !== null && iframe.src === "") {
	        iframe.src = iframe.getAttribute("data-url");
	      }
	    }
	  }]);
	  return Paywall;
	}(_es6EventEmitter2.default);
	// eslint-disable-next-line
	
	
	exports.default = Paywall;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _pdfDownload = __webpack_require__(385);
	
	var _pdfDownload2 = _interopRequireDefault(_pdfDownload);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pdfDownloadComponent = function (_Emitter) {
	  (0, _inherits3.default)(pdfDownloadComponent, _Emitter);
	
	  function pdfDownloadComponent(appState, DOMContainer) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    (0, _classCallCheck3.default)(this, pdfDownloadComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (pdfDownloadComponent.__proto__ || (0, _getPrototypeOf2.default)(pdfDownloadComponent)).call(this));
	
	    _this.appState = appState;
	    _this.options = options;
	    _this.DOMContainer = DOMContainer;
	    _this.render();
	    return _this;
	  }
	
	  (0, _createClass3.default)(pdfDownloadComponent, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.DOMContainer) {
	        var context = {};
	        context.fullPdf = _dictionary2.default.fullPdfDownload;
	        context.singlePage = _dictionary2.default.pagePdfDownload;
	        context.leftPage = _dictionary2.default.LeftPage;
	        context.rightPage = _dictionary2.default.RightPage;
	        context.isSingle = this.isSinglePage();
	        context.allowFullPdfDownload = this.options.reader.allowFullPdfDownload;
	        Dust.render(_pdfDownload2.default, context, function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	          _this2.attatchClickHandlers();
	        });
	      }
	    }
	  }, {
	    key: "attatchClickHandlers",
	    value: function attatchClickHandlers() {
	      var _this3 = this;
	
	      var downloadItems = this.DOMContainer.querySelectorAll(".download-item");
	      downloadItems.forEach(function (item) {
	        var download = item.getAttribute("data-download");
	        item.addEventListener("click", function (e) {
	          e.stopPropagation();
	          switch (download) {
	            case "fullPdf":
	              _this3.trigger("pdfDownloadComponent:downloadFullPdf");
	              break;
	            case "singlePage":
	              _this3.trigger("pdfDownloadComponent:downloadSinglePagePdf");
	              break;
	            case "leftPage":
	              _this3.trigger("pdfDownloadComponent:downloadLeftPagePdf");
	              break;
	            case "rightPage":
	              _this3.trigger("pdfDownloadComponent:downloadRightPagePdf");
	              break;
	            default:
	          }
	        });
	      });
	    }
	  }, {
	    key: "toggleVisibility",
	    value: function toggleVisibility() {
	      this.render(); // The dropdown download menu needs to be re-rendered in order to start/stop displaying certain buttons
	      this.DOMContainer.classList.toggle("hidden");
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      if (!this.DOMContainer.classList.contains("hidden")) {
	        this.DOMContainer.classList.add("hidden");
	      }
	    }
	  }, {
	    key: "isSinglePage",
	    value: function isSinglePage() {
	      var activePages = this.appState.activePages;
	
	      if (activePages.length == 1) {
	        return true;
	      } else {
	        return activePages[0] == null || activePages[1] == null;
	      }
	    }
	  }]);
	  return pdfDownloadComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = pdfDownloadComponent;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NUMBER_OF_RETRIES = 2;
	
	var PdfPageBase = function () {
	  function PdfPageBase(appState, apiManager, DOMContainer, pageId, pageNumber, options) {
	    (0, _classCallCheck3.default)(this, PdfPageBase);
	    this.pdf = null;
	    this.pageId = null;
	    this.renderTask = null;
	    this.lastRendered = null;
	    this.DOMContainer = null;
	    this.pdfPage = null;
	    this.canvas = null;
	    this.apiManager = null;
	    this.cancelRender = false;
	    this.pageNumber = null;
	    this.options = null;
	    this._pdfRequestCounter = 0;
	    this._pdfRequestLimit = 10;
	
	    this.pageId = pageId;
	    this.DOMContainer = DOMContainer;
	    this.apiManager = apiManager;
	    this.appState = appState;
	    this.pageNumber = pageNumber;
	    this.options = options;
	    this.pdfPage = this.DOMContainer.querySelector(".page-pdf");
	    this.appState.on("appState:currentpagechanged", this.cleanup.bind(this));
	    this.pdfPromise = null;
	  }
	
	  (0, _createClass3.default)(PdfPageBase, [{
	    key: "destroy",
	    value: function destroy() {
	      this.pdf = null;
	      this.renderTask = null;
	      this.DOMContainer = null;
	      this.pdfPage = null;
	      this.canvas = null;
	      this.pdfPromise = null;
	      this.appState.off("appState:currentpagechanged", this.cleanup.bind(this));
	    }
	  }, {
	    key: "cleanup",
	    value: function cleanup() {}
	  }, {
	    key: "prefetchPDF",
	    value: function prefetchPDF() {
	      if (!this.pdfPromise) {
	        this.pdfPromise = this.retrievePdf();
	      }
	    }
	  }, {
	    key: "getPdfUrl",
	    value: function getPdfUrl() {
	      if (this.appState.newDownloaderFallbackMode) {
	        var _appState = this.appState,
	            userId = _appState.userId,
	            sessionId = _appState.sessionId,
	            downloadId = _appState.downloadId;
	
	        return this.apiManager.retreivePdfUrl(this.pageId, sessionId, userId, downloadId);
	      }
	      return _promise2.default.resolve(this.appState.cdnAssetsDownloader.getPdfUrl(this.pageId));
	    }
	  }, {
	    key: "retrievePdf",
	    value: function retrievePdf() {
	      var _this = this;
	
	      var numberOfTries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	      if (this.pdf === null) {
	        return this.getPdfUrl().then(function (url) {
	          return _this.loadPdfJs(function () {
	            var params = new Object();
	            params.url = url;
	            return PDFJS.getDocument(params).then(function (pdf) {
	              return pdf.getPage(1).then(function (page) {
	                // altijd de eerste p van de pdf nemen en tonen
	                _this.pdf = page; //CASHING
	                return _promise2.default.resolve();
	              });
	            }).catch(function (error) {
	              if (error.status == 403) {
	                if (numberOfTries < NUMBER_OF_RETRIES) {
	                  return _this.appState.cdnAssetsDownloader.requestDownloadCredentials().then(function () {
	                    return _this.retrievePdf(numberOfTries + 1);
	                  });
	                } else {
	                  _this.appState.newDownloaderFallbackMode = true;
	                  return _this.retrievePdf(numberOfTries + 1);
	                }
	              }
	              return _promise2.default.reject(error);
	            });
	          });
	        });
	      }
	      return _promise2.default.resolve();
	    }
	
	    /**
	     * Retreives the zoomscale that needs to be used for the pdf
	     */
	
	  }, {
	    key: "getZoomScale",
	    value: function getZoomScale() {
	      var viewport = this.pdf.getViewport(1);
	      var scaleX = this.DOMContainer.clientWidth / viewport.width;
	      var scaleY = this.DOMContainer.clientHeight / viewport.height;
	      var zoom = Math.min(scaleX, scaleY);
	      return zoom;
	    }
	  }]);
	  return PdfPageBase;
	}();
	
	exports.default = PdfPageBase;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This is shared component for tracking browsing history in the reader (touch and web)
	 */
	var ReaderBrowsingHistoryComponent = function () {
	  function ReaderBrowsingHistoryComponent(router, appState) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ReaderBrowsingHistoryComponent);
	
	    this._router = router;
	    this._appState = appState;
	    this._publicationChanged = false;
	    this._appState.on("appState:publicationChanged", function () {
	      _this._publicationChanged = true;
	    });
	  }
	
	  (0, _createClass3.default)(ReaderBrowsingHistoryComponent, [{
	    key: "trackHistory",
	    value: function trackHistory() {
	      var _this2 = this;
	
	      this._router.listen(this._doNavigation.bind(this));
	      this._appState.on("appState:currentpagechanged", function () {
	        if (!_this2._appState.articleLightBoxDisplayed) {
	          //set this change in contentidchanged, otherwise 2 location pushes for new alb slide (if slide to next  page)
	          _this2._router.page = _this2._appState.currentPage + 1;
	        }
	      });
	      this._appState.on("appState:contentIdChanged", function () {
	        _this2._router.updateLocation(_this2._appState.contentPackageId, _this2._appState._publicationId, _this2._appState.currentPage + 1, 0, _this2._appState.contentid, true);
	      });
	    }
	  }, {
	    key: "getPageFromHistory",
	    value: function getPageFromHistory() {
	      var page = this._router.page;
	      if (typeof page === "undefined") {
	        page = 0;
	      } else if (page > 0) {
	        page--;
	      }
	      return page;
	    }
	  }, {
	    key: "getContentIdFromHistory",
	    value: function getContentIdFromHistory() {
	      return this._router._contentid;
	    }
	
	    ////////////
	
	    /**
	     * When hash navigation changes go to the right page
	     */
	
	  }, {
	    key: "_doNavigation",
	    value: function _doNavigation() {
	      var _this3 = this;
	
	      var number = this.getPageFromHistory();
	      var content = this._router.contentid;
	      if (number !== this._appState.currentPage) {
	        this._appState.changeCurrentPage(number, this._publicationChanged, false).then(function () {
	          if (content !== _this3._appState.contentid) {
	            _this3._appState.contentid = content;
	          }
	        }).catch(function () {
	          //TODO: paywall
	        });
	        this._publicationChanged = false;
	      } else if (content !== this._appState.contentid) {
	        this._appState.contentid = content;
	      }
	    }
	  }]);
	  return ReaderBrowsingHistoryComponent;
	}();
	
	exports.default = ReaderBrowsingHistoryComponent;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _analyticsevents = __webpack_require__(9);
	
	var _URLRouter = __webpack_require__(40);
	
	var _URLRouter2 = _interopRequireDefault(_URLRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Contains shared functions between readers
	 * @type {Object}
	 */
	var readerMixin = {
	  /* *
	   * Triggers correct page view event depending on ALB is opened or not
	   */
	  triggerPageViewEvent: function triggerPageViewEvent() {
	    var analyticEvent = _URLRouter2.default.isAlbURL() ? _analyticsevents.VIEW_PAGE_IN_BACKGROUND : _analyticsevents.VIEW_PAGE;
	    this._appState.triggerEvent(analyticEvent, { mode: this._appState.isDoublePage ? "double page" : "single page" }, true);
	  }
	};
	
	exports.default = readerMixin;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _lodash = __webpack_require__(82);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _region_selector = __webpack_require__(388);
	
	var _region_selector2 = _interopRequireDefault(_region_selector);
	
	var _regionList = __webpack_require__(387);
	
	var _regionList2 = _interopRequireDefault(_regionList);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _utils = __webpack_require__(10);
	
	var _cookiemanager = __webpack_require__(24);
	
	var _cookiemanager2 = _interopRequireDefault(_cookiemanager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegionManager = function (_Emitter) {
	  (0, _inherits3.default)(RegionManager, _Emitter);
	
	  // object containing Description and DownloadToken
	
	  //TODO: cleanup
	  //FIXME still not cleaned up ^^ :/
	
	  function RegionManager(appState, apiManager, cookieManager, options) {
	    (0, _classCallCheck3.default)(this, RegionManager);
	
	    // load the cookie (this is sync)
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RegionManager.__proto__ || (0, _getPrototypeOf2.default)(RegionManager)).call(this));
	
	    _this.Regions = null;
	    _this.DOMContainer = null;
	    _this.SelectedRegion = null;
	    _this.SelectedRegionName = "";
	    _this.getRegionPromiseResolve = null;
	    _this.getRegionPromiseReject = null;
	    _this.RegionCookie = "TW_REGION";
	    _this._appState = null;
	    _this._apiManager = null;
	    _this._cookieManager = null;
	    _this.options = null;
	    _this.singleRegion = false;
	
	    _this.onScrollBtnClick = function () {
	      $(_this.DOMContainer).animate({
	        scrollTop: _this.DOMContainer.offsetHeight
	      }, 400);
	      _this.DOMContainer.scrollTop = _this.DOMContainer.offsetHeight;
	      var listContainer = _this.DOMContainer.querySelector(".region-selector-items");
	
	      if (listContainer) {
	        $(listContainer).animate({
	          scrollTop: listContainer.offsetHeight
	        }, 400);
	      }
	    };
	
	    _this.onListScroll = (0, _lodash2.default)(function (e) {
	      if (e.currentTarget.scrollHeight - e.currentTarget.offsetHeight === e.currentTarget.scrollTop) {
	        _this.scrollBtnEl.classList.add("hidden");
	        _this.scrollBtnEl.classList.remove("animated");
	      } else {
	        _this.scrollBtnEl.classList.remove("hidden");
	      }
	    }, 10);
	    _this._apiManager = apiManager;
	    _this._appState = appState;
	    _this._cookieManager = cookieManager;
	    _this.options = options; //defaultRegion
	    _this.fetchRegion();
	    _this.setRegions();
	    return _this;
	  }
	
	  (0, _createClass3.default)(RegionManager, [{
	    key: "getCurrentRegion",
	    value: function getCurrentRegion() {
	      return this.SelectedRegion;
	    }
	  }, {
	    key: "setRegion",
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(downloadToken) {
	        var regionFound, i, _downloadToken;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return this.setRegions();
	
	              case 3:
	                regionFound = false;
	                i = 0;
	
	              case 5:
	                if (!(i < this.Regions.length)) {
	                  _context.next = 17;
	                  break;
	                }
	
	                if (!(this.Regions[i].Value === downloadToken)) {
	                  _context.next = 14;
	                  break;
	                }
	
	                this.SelectedRegion = this.Regions[i];
	                this._appState.downloadToken = this.SelectedRegion.Value;
	                regionFound = true;
	                _downloadToken = (0, _utils.getParameterByName)("downloadToken");
	
	                if (_downloadToken) {
	                  window.location.href = (0, _utils.removeURLParameter)("downloadToken");
	                }
	                this.trigger("regionManager:regionChanged");
	                return _context.abrupt("break", 17);
	
	              case 14:
	                i += 1;
	                _context.next = 5;
	                break;
	
	              case 17:
	                // region is not found in region list (can be a HS for example)
	                if (!regionFound) {
	                  if (this._appState.downloadToken != downloadToken) {
	                    this._appState.downloadToken = downloadToken;
	                    this.trigger("regionManager:regionChanged");
	                  }
	                }
	                return _context.abrupt("return");
	
	              case 21:
	                _context.prev = 21;
	                _context.t0 = _context["catch"](0);
	
	              case 23:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[0, 21]]);
	      }));
	
	      function setRegion(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return setRegion;
	    }()
	  }, {
	    key: "getForceRegionCookie",
	    value: function getForceRegionCookie() {
	      var fetchedString = this._cookieManager.getCookie(this.options.forceRegionCookie); //TODO
	      if (typeof fetchedString !== "undefined") {
	        if (this.options.deleteForceRegionCookie) {
	          this._cookieManager.removeCookie(this.options.forceRegionCookie, this.options.forceRegionCookieOptions);
	        }
	        try {
	          var force = JSON.parse(fetchedString);
	          if (force && force.token) {
	            return force.token;
	          }
	        } catch (e) {
	          return fetchedString;
	        }
	      }
	      return null;
	    }
	
	    /**
	     * Retrieves the region from search params
	     * If the region is set inside the search param remove the params
	     */
	
	  }, {
	    key: "getQueryRegion",
	    value: function getQueryRegion() {
	      var downloadToken = (0, _utils.getParameterByName)("downloadToken");
	      if (downloadToken) {
	        return downloadToken;
	      }
	    }
	
	    /**
	     * Retrieves the region
	     * If no region is selected yet or forceReloadOfRegion is true
	     *        a view with a proceed button is rendered and the promise is only resolved if the button is pressed
	     *
	     * forceReloadOfRegion: force rendering and selectionscreen of region, even if there allready is a region
	     * @type {[type]}
	     */
	
	  }, {
	    key: "getRegion",
	    value: function getRegion(DOMContainer) {
	      var _this2 = this;
	
	      var forceReloadOfRegion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var regionClicked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var regionSearchParam = this.getQueryRegion();
	      this.DOMContainer = DOMContainer;
	      //FIXME Code like this should not exist, I would be ashamed to commit this
	      this.getRegionPromise = new _promise2.default(function (resolve, reject) {
	        _this2.getRegionPromiseReject = reject;
	        _this2.getRegionPromiseResolve = resolve;
	        _this2.setRegions().then(function () {
	          if (!forceReloadOfRegion) {
	            var region = void 0;
	            if (_this2.options.defaultDownloadToken) {
	              region = _this2.options.defaultDownloadToken;
	            } else if (regionSearchParam) {
	              region = regionSearchParam;
	            } else {
	              region = _this2.getForceRegionCookie();
	            }
	            if (region != null) {
	              for (var i = 0; i < _this2.Regions.length; i++) {
	                if (_this2.Regions[i].Value == region) {
	                  _this2.SelectedRegion = _this2.Regions[i];
	                  _this2.saveRegion(_this2.SelectedRegion);
	                  break;
	                }
	              }
	            }
	          }
	          if (!forceReloadOfRegion && _this2.SelectedRegion != null) {
	            _this2._appState.downloadToken = _this2.SelectedRegion.Value;
	            _this2.getRegionPromiseResolve(_this2.SelectedRegion);
	          } else {
	            if (regionClicked) {
	              _this2.populateRegionList(DOMContainer, true);
	            } else {
	              if (_this2.options.downloadToken && _this2.options.downloadToken != "") {
	                _this2._appState.downloadToken = "";
	              } else {
	                _this2.populateRegionList();
	              }
	            }
	          }
	        });
	      });
	      return this.getRegionPromise;
	      // return a promise that will be resolved when
	      // the onclick is done in onClickProceed or if region is
	      // allready selected
	    }
	
	    /**
	     * Renders a region selection screen in the DOMContainer
	     * If renderOnlyList is true only the region list is rendered
	     * @type {[type]}
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var DOMContainer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var _this3 = this;
	
	      var renderOnlyList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var hideAfterSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (DOMContainer) {
	        this.DOMContainer = DOMContainer;
	      }
	      this.setRegions().then(function () {
	        var context = {};
	        context.Buttontext = _dictionary2.default.Proceed;
	        context.ChooseRegionTranslation = _dictionary2.default.ChooseRegion;
	        context.regions = _this3.Regions;
	        if (_this3.options.defaultRegion === true) {
	          context.defaultRegion = true;
	        }
	        if (_this3.DOMContainer !== null) {
	          var dustFile = _region_selector2.default;
	          if (renderOnlyList) {
	            dustFile = _regionList2.default;
	          }
	          Dust.render(dustFile, context, function (err, result) {
	            _this3.DOMContainer.classList.remove("hidden");
	            _this3.DOMContainer.innerHTML = result;
	
	            _this3.setupListScrollButton();
	
	            if (_this3.SelectedRegion) {
	              for (var i = 0; i < _this3.Regions.length; i += 1) {
	                if (_this3.Regions[i].Description === _this3.SelectedRegion.Description) {
	                  $(_this3.DOMContainer).find(".region_" + i + "_label").trigger("click");
	                  var e = {};
	                  e.target = {};
	                  e.target.dataset = {};
	                  e.target.dataset.id = "region_" + i;
	                  _this3.onRegionSelected(e, false);
	                  break;
	                }
	              }
	            }
	            // atach the click handlers for the selection and handle here
	            if (!renderOnlyList) {
	              $(_this3.DOMContainer).find("#proceed-btn").on("click", function (e) {
	                _this3.onProceedTouch(e);
	              });
	            }
	            $(_this3.DOMContainer).find('input[name="region"]').on("change", function (e) {
	              if (renderOnlyList && hideAfterSelection) {
	                _this3.DOMContainer.classList.add("hidden");
	              }
	              _this3.onRegionSelected(e, true);
	            });
	          });
	        }
	      });
	      if (!renderOnlyList) {
	        this._appState.triggerEvent(_analyticsevents.OPENED_REGIONSELECT);
	      }
	    }
	
	    /**
	     * Saves the selected region
	     */
	
	  }, {
	    key: "saveSelectedRegion",
	    value: function saveSelectedRegion() {
	      for (var i = 0; i < this.Regions.length; i += 1) {
	        if (this.Regions[i].Description === this.SelectedRegionName) {
	          this.SelectedRegion = this.Regions[i];
	          this.saveRegion(this.SelectedRegion);
	          break;
	        }
	      }
	      this._appState.downloadToken = this.SelectedRegion.Value;
	    }
	
	    /**
	     * When proceed button is clicked
	     * resolve promise that is returned when getRegion was called
	     */
	
	  }, {
	    key: "onProceedTouch",
	    value: function onProceedTouch() {
	      if (this.DOMContainer) {
	        this.DOMContainer.classList.add("hidden");
	      }
	      this.getRegionPromiseResolve(this.SelectedRegion);
	      this._appState.triggerEvent(_analyticsevents.CLICKED_PROCEED_REGIONSELECT);
	    }
	
	    /**
	     * When a region is selected in the view
	     * it saves the region and it triggers a regionChanged event
	     */
	
	  }, {
	    key: "onRegionSelected",
	    value: function onRegionSelected(e, sendEvent) {
	      $(this.DOMContainer).find("#proceed-btn").removeClass("is-disabled");
	      var regionId = e.target.dataset.id;
	      $(this.DOMContainer).find(".is-selected").removeClass("is-selected");
	      $(this.DOMContainer).find("." + regionId + "_label").removeClass("is-notselected").addClass("is-selected");
	      $(this.DOMContainer).find("label:not(.is-selected)").addClass("is-notselected");
	      $(this.DOMContainer).find("." + regionId);
	      this.SelectedRegionName = $(this.DOMContainer).find("." + regionId).val();
	
	      if (sendEvent) {
	        this.saveSelectedRegion();
	        this.trigger("regionManager:regionChanged");
	        this._appState.triggerEvent(_analyticsevents.CLICKED_REGION_REGIONSELECT);
	      }
	    }
	  }, {
	    key: "beautifyRegions",
	    value: function beautifyRegions() {
	      var beautifyRegions = true;
	      if (beautifyRegions) {
	        //TODO: config?
	        this.Regions.forEach(function (region) {
	          var regExp = /(^[0-9]+[_])/;
	          if (regExp.test(region.Description)) {
	            region.Description = region.Description.replace(regExp, "");
	          }
	        });
	      }
	    }
	  }, {
	    key: "setRegions",
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!this.Regions) {
	                  _context2.next = 4;
	                  break;
	                }
	
	                return _context2.abrupt("return", this.Regions);
	
	              case 4:
	                _context2.next = 6;
	                return this._apiManager.getRegions();
	
	              case 6:
	                this.Regions = _context2.sent;
	
	                this.beautifyRegions();
	                this.validateSavedRegionInCookie();
	                if (this.Regions.length === 1) {
	                  this.singleRegion = true;
	                }
	                return _context2.abrupt("return", this.Regions);
	
	              case 11:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function setRegions() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return setRegions;
	    }()
	  }, {
	    key: "populateRegionList",
	    value: function populateRegionList() {
	      var _this4 = this;
	
	      var DOMContainer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var renderOnlyList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.setRegions().then(function () {
	        if (_this4.Regions.length === 1) {
	          _this4.setSelectedRegion(_this4.Regions[0]);
	          _this4.getRegionPromiseResolve(_this4.SelectedRegion);
	        } else {
	          _this4.render(DOMContainer, renderOnlyList);
	        }
	      });
	    }
	
	    // validate if the saved region is still on the regions list
	
	  }, {
	    key: "validateSavedRegionInCookie",
	    value: function validateSavedRegionInCookie() {
	      var savedRegion = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.REGION);
	      if (!savedRegion) return;
	
	      savedRegion = JSON.parse(savedRegion);
	      var regionInCurrentList = this.Regions.find(function (region) {
	        return region.Value === savedRegion.Value;
	      });
	
	      if (regionInCurrentList) return;
	      _cookiemanager2.default.removeCookie(_cookiemanager2.default.cookieKeys.REGION);
	      this.setSelectedRegion(this.Regions[0]);
	    }
	  }, {
	    key: "setSelectedRegion",
	    value: function setSelectedRegion(selectedRegion) {
	      this.SelectedRegion = selectedRegion;
	      this.saveRegion(selectedRegion);
	      this._appState.downloadToken = selectedRegion.Value;
	    }
	
	    /**
	     * saves a region in the cookie
	     */
	
	  }, {
	    key: "saveRegion",
	    value: function saveRegion(region) {
	      region.ContentPackages = [];
	      this._cookieManager.createCookie(this._cookieManager.cookieKeys.REGION, (0, _stringify2.default)(region));
	    }
	
	    /*
	    This fucntion will load the SelectedRegion out of the REGION cookie, we
	    use the cookie from the webapp v2 to make sure we are backward compatible.
	    It will do checking if the cookie content is correct.
	     */
	
	  }, {
	    key: "fetchRegion",
	    value: function fetchRegion() {
	      var fetchedString = this._cookieManager.getCookie(this._cookieManager.cookieKeys.REGION);
	      if (typeof fetchedString !== "undefined") {
	        this.SelectedRegion = JSON.parse(fetchedString);
	      } else {
	        this.SelectedRegion = null;
	      }
	    }
	  }, {
	    key: "setupListScrollButton",
	    value: function setupListScrollButton() {
	      var listContainer = this.DOMContainer.querySelector(".region-selector-items");
	
	      if (listContainer) {
	        if (listContainer.scrollHeight > listContainer.offsetHeight) {
	          this.scrollBtnEl = this.DOMContainer.querySelector(".scrolling-btn");
	          this.scrollBtnEl.classList.remove("hidden");
	          this.scrollBtnEl.addEventListener("click", this.onScrollBtnClick);
	          listContainer.addEventListener("scroll", this.onListScroll);
	        }
	      }
	    }
	  }]);
	  return RegionManager;
	}(_es6EventEmitter2.default);
	
	exports.default = RegionManager;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _settingAbout = __webpack_require__(390);
	
	var _settingAbout2 = _interopRequireDefault(_settingAbout);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _settingIFrame = __webpack_require__(92);
	
	var _settingIFrame2 = _interopRequireDefault(_settingIFrame);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _redirectorKeys = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingAbout = function (_Emitter) {
	  (0, _inherits3.default)(SettingAbout, _Emitter);
	
	  function SettingAbout(appState, sessionManager, options) {
	    (0, _classCallCheck3.default)(this, SettingAbout);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingAbout.__proto__ || (0, _getPrototypeOf2.default)(SettingAbout)).call(this));
	
	    _this.appState = null;
	    _this.options = null;
	    _this.sessionManager = null;
	
	    _this.appState = appState;
	    _this.sessionManager = sessionManager;
	    _this.options = options;
	    _this.render();
	    _this.fetchSettingsUrls();
	    return _this;
	  }
	
	  (0, _createClass3.default)(SettingAbout, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var context = {};
	      context.back = true;
	      context.close = true;
	
	      context.about = _dictionary2.default.about;
	
	      context.disclaimer = _dictionary2.default.disclaimer;
	
	      context.version = _dictionary2.default.version;
	      context.currentVersion = this.appState.buildVersion;
	
	      context.platformversion = _dictionary2.default.platformversion;
	      context.currentPlatformversion = ("platform/3.9.4");
	
	      context.uuid = _dictionary2.default.uuid;
	      context.currentUuid = this.sessionManager.UUID;
	
	      context.editor = _dictionary2.default.editor;
	      context.currentEditor = this.options.editor;
	
	      context.developer = _dictionary2.default.developer;
	      context.currentDeveloper = this.options.developer;
	      context.hideDisclaimer = this.options.hideDisclaimer;
	
	      //render layout with context
	      this.DOMContainer = document.querySelector("#sidemenu-about-container");
	      if (this.DOMContainer !== null) {
	        Dust.render(_settingAbout2.default, context, function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	
	          _this2.attachClickHandlers();
	
	          _this2.show();
	        });
	      }
	    }
	  }, {
	    key: "attachClickHandlers",
	    value: function attachClickHandlers() {
	      var _this3 = this;
	
	      var backButton = this.DOMContainer.querySelector(".overlay-navigation-back .overlay-navigation-icon");
	      if (backButton) {
	        backButton.addEventListener("click", function (e) {
	          _this3.onBackButtonClick(e);
	        });
	      }
	
	      var closeButton = this.DOMContainer.querySelector(".overlay-navigation-close .overlay-navigation-icon");
	      if (closeButton) {
	        closeButton.addEventListener("click", function (e) {
	          _this3.onCloseButtonClick(e);
	        });
	      }
	
	      var disclaimer = this.DOMContainer.querySelector(".about-disclaimer");
	      if (disclaimer) {
	        disclaimer.addEventListener("click", function (e) {
	          _this3.onDisclaimerClick(e);
	        });
	      }
	
	      var uuid = this.DOMContainer.querySelector(".about-uuid");
	      if (uuid) {
	        uuid.addEventListener("click", function (e) {
	          _this3.onUuidClick(e);
	        });
	      }
	
	      var editor = this.DOMContainer.querySelector(".about-editor");
	      if (editor) {
	        editor.addEventListener("click", function (e) {
	          _this3.onEditorClick(e);
	        });
	      }
	
	      var developer = this.DOMContainer.querySelector(".about-developer");
	      if (developer) {
	        developer.addEventListener("click", function (e) {
	          _this3.onDeveloperClick(e);
	        });
	      }
	    }
	  }, {
	    key: "fetchSettingsUrls",
	    value: function fetchSettingsUrls() {
	      var _this4 = this;
	
	      _apimanager2.default.getRedirectorUrl(_redirectorKeys.CONTACT_CLIENT, this.appState.buildVersion, this.appState.userId, this.appState.downloadToken).then(function (result) {
	        _this4.editorUrl = result;
	      }).catch(function () {});
	
	      _apimanager2.default.getRedirectorUrl(_redirectorKeys.CONTACT_TWIPE, this.appState.buildVersion, this.appState.userId, this.appState.downloadToken).then(function (result) {
	        _this4.developperUrl = result;
	      }).catch(function () {});
	
	      if (!this.options.hideDisclaimer) {
	        _apimanager2.default.getRedirectorUrl(_redirectorKeys.DISCLAIMER, this.appState.buildVersion, this.appState.userId, this.appState.downloadToken).then(function (result) {
	          _this4.disclaimerUrl = result;
	        }).catch(function () {});
	      }
	    }
	  }, {
	    key: "onEditorClick",
	    value: function onEditorClick() {
	      this.appState.triggerEvent(_analyticsevents.CLICKED_EDITOR_SETTINGS);
	      this._openInNewtab(this.editorUrl);
	    }
	  }, {
	    key: "onDeveloperClick",
	    value: function onDeveloperClick() {
	      this.appState.triggerEvent(_analyticsevents.CLICKED_DEVELOPER_SETTINGS);
	      this._openInNewtab(this.developperUrl);
	    }
	  }, {
	    key: "onDisclaimerClick",
	    value: function onDisclaimerClick() {
	      var _this5 = this;
	
	      if (this.appState.isDesktop || this.options.openHelpOnNewtab) {
	        this._openInNewtab(this.disclaimerUrl);
	      } else {
	        if (this.disclaimer && !this.disclaimer.isEmpty()) {
	          this.disclaimer.show();
	        } else {
	          this.disclaimer = new _settingIFrame2.default(this.appState, document.querySelector("#sidemenu-disclaimer-container"), "disclaimer", _dictionary2.default.disclaimer, this.disclaimerUrl, this.options);
	          this.disclaimer.on("settingIframe:closed", function () {
	            _this5.close();
	          });
	        }
	      }
	      this.appState.triggerEvent(_analyticsevents.CLICKED_DISCLAIMER_SETTINGS);
	    }
	  }, {
	    key: "onBackButtonClick",
	    value: function onBackButtonClick(e) {
	      e.stopPropagation();
	      this.hide();
	      this.appState.triggerEvent(_analyticsevents.CLICKED_BACK_ABOUT);
	    }
	  }, {
	    key: "onCloseButtonClick",
	    value: function onCloseButtonClick(e) {
	      e.stopPropagation();
	      this.close();
	      this.appState.triggerEvent(_analyticsevents.CLICKED_CLOSE_ABOUT);
	    }
	  }, {
	    key: "onUuidClick",
	    value: function onUuidClick() {
	      this.sentDeviceInfo();
	      this.appState.triggerEvent(_analyticsevents.CLICKED_UUID_SETTINGS);
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      if (this.DOMContainer !== null) {
	        this.DOMContainer.classList.add("hidden");
	      }
	      this.trigger("settingAbout:closed");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (this.DOMContainer !== null) {
	        this.DOMContainer.classList.add("hidden");
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (this.DOMContainer !== null) {
	        this.DOMContainer.classList.remove("hidden");
	      }
	      this.appState.triggerEvent(_analyticsevents.OPENED_ABOUT_SETTINGS);
	    }
	  }, {
	    key: "sentDeviceInfo",
	    value: function sentDeviceInfo() {
	      var subject = "device info webapp";
	
	      var version = this.appState.buildVersion;
	      var uuid = this.sessionManager.UUID;
	      var userAgent = navigator.userAgent;
	      var client = ("mhu-ds");
	      var userId = this.sessionManager.session.SessionInfo.UserId;
	      var sessionId = this.sessionManager.session.SessionInfo.SessionId;
	      var username = this.appState.username ? "userName: " + this.appState.username : "";
	
	      var url = "mailto:?subject=" + subject + "&body=" + "version: " + version + "%0D%0A" + "branch: " + ("platform/3.9.4") + "%0D%0A" + "platformversion: " + ("3.9.4") + "%0D%0A" + "uuid: " + uuid + "%0D%0A" + "client: " + client + "%0D%0A" + "userId: " + userId + "%0D%0A" + "sessionId: " + sessionId + "%0D%0A" + "userAgent: " + userAgent + "%0D%0A" + username;
	
	      window.location.href = url;
	    }
	  }, {
	    key: "_openInNewtab",
	    value: function _openInNewtab(url) {
	      var newWindow = window.open(url, "_blank");
	      newWindow.focus();
	    }
	  }]);
	  return SettingAbout;
	}(_es6EventEmitter2.default);
	
	exports.default = SettingAbout;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _settingLandscapeToggle = __webpack_require__(393);
	
	var _settingLandscapeToggle2 = _interopRequireDefault(_settingLandscapeToggle);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingLandscapeToggle = function (_Emitter) {
	  (0, _inherits3.default)(SettingLandscapeToggle, _Emitter);
	
	  function SettingLandscapeToggle(appState) {
	    (0, _classCallCheck3.default)(this, SettingLandscapeToggle);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingLandscapeToggle.__proto__ || (0, _getPrototypeOf2.default)(SettingLandscapeToggle)).call(this));
	
	    _this._appState = appState;
	    _this._DOMContainer = document.querySelector("#sidemenu-account-container");
	    return _this;
	  }
	
	  (0, _createClass3.default)(SettingLandscapeToggle, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var context = {};
	      context.back = true;
	      context.close = true;
	      context.i18n = _dictionary2.default;
	      context.doublePage = this._appState.isDoublePage;
	      context.title = this._appState.isDesktop ? _dictionary2.default.readingModeToggle : _dictionary2.default.landscapeToggle;
	      if (this._DOMContainer) {
	        Dust.render(_settingLandscapeToggle2.default, context, function (err, result) {
	          _this2._DOMContainer.innerHTML = result;
	          _this2._DOMContainer.classList.remove("hidden");
	          _this2._appState.triggerEvent(_analyticsevents.OPENED_LANDSCAPE_TOGGLE_SETTINGS);
	          _this2._attachListeners();
	        });
	      }
	    }
	
	    //////////////
	
	    /**
	     * @todo Top bar with back/close buttons and title might be separate component as
	     * logic there seems to be the same for all settings options - check that later
	     */
	
	  }, {
	    key: "_attachListeners",
	    value: function _attachListeners() {
	      this.backButtonEl = this._DOMContainer.querySelector(".overlay-navigation-back");
	      this.backButtonEl.addEventListener("click", this._backButtonClickHandler.bind(this));
	
	      this.closeButtonEl = this._DOMContainer.querySelector(".overlay-navigation-close");
	      this.closeButtonEl.addEventListener("click", this._closeButtonClickHandler.bind(this));
	
	      this.optionsEl = document.getElementById("landscape-options");
	      this.optionsEl.addEventListener("change", this._landscapeOptionsClickHandler.bind(this));
	    }
	  }, {
	    key: "_detachListeners",
	    value: function _detachListeners() {
	      this.backButtonEl.removeEventListener("click", this._backButtonClickHandler);
	      this.closeButtonEl.removeEventListener("click", this._closeButtonClickHandler);
	    }
	  }, {
	    key: "_backButtonClickHandler",
	    value: function _backButtonClickHandler() {
	      this._hide();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_BACK_LANDSCAPE_TOGGLE);
	    }
	  }, {
	    key: "_closeButtonClickHandler",
	    value: function _closeButtonClickHandler() {
	      this._hide();
	      this.trigger("settingLandscapeToggle:closed");
	      this._appState.triggerEvent(_analyticsevents.CLICKED_CLOSE_LANDSCAPE_TOGGLE);
	    }
	  }, {
	    key: "_landscapeOptionsClickHandler",
	    value: function _landscapeOptionsClickHandler(e) {
	      var options = this.optionsEl.querySelectorAll(".landscape-option");
	      [].forEach.call(options, function (node) {
	        node.classList.remove("is-selected");
	      });
	      $(e.target).closest(".landscape-option").addClass("is-selected");
	      this.chosenOption = e.target.value;
	      this.trigger("settingLandscapeToggle:changed", this.chosenOption);
	      if (this.chosenOption === "doublePage") {
	        this._appState.triggerEvent(_analyticsevents.CLICKED_DOUBLEPAGE_TOGGLE_SETTINGS);
	      } else {
	        this._appState.triggerEvent(_analyticsevents.CLICKED_SINGLEPAGE_TOGGLE_SETTINGS);
	      }
	    }
	  }, {
	    key: "_hide",
	    value: function _hide() {
	      if (this.chosenOption) {
	        this._appState.isDoublePage = this.chosenOption === "doublePage";
	      }
	      this._detachListeners();
	      this._DOMContainer.innerHTML = "";
	      this._DOMContainer.classList.add("hidden");
	    }
	  }]);
	  return SettingLandscapeToggle;
	}(_es6EventEmitter2.default);
	
	exports.default = SettingLandscapeToggle;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _settingPreferredViewer = __webpack_require__(394);
	
	var _settingPreferredViewer2 = _interopRequireDefault(_settingPreferredViewer);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingPreferredViewer = function (_Emitter) {
	  (0, _inherits3.default)(SettingPreferredViewer, _Emitter);
	
	  function SettingPreferredViewer(appState) {
	    (0, _classCallCheck3.default)(this, SettingPreferredViewer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingPreferredViewer.__proto__ || (0, _getPrototypeOf2.default)(SettingPreferredViewer)).call(this));
	
	    _this._appState = appState;
	    _this._DOMContainer = document.querySelector("#sidemenu-account-container");
	    return _this;
	  }
	
	  (0, _createClass3.default)(SettingPreferredViewer, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var context = {};
	      context.back = true;
	      context.close = true;
	      context.i18n = _dictionary2.default;
	      context.preferredViewer = this._appState.preferredViewer;
	
	      if (this._DOMContainer) {
	        Dust.render(_settingPreferredViewer2.default, context, function (err, result) {
	          _this2._DOMContainer.innerHTML = result;
	          _this2._DOMContainer.classList.remove("hidden");
	          _this2._appState.triggerEvent(_analyticsevents.OPENED_READING_MODE_SETTINGS);
	          _this2._attachListeners();
	        });
	      }
	    }
	
	    //////////////
	
	    /**
	     * @todo Top bar with back/close buttons and title might be separate component as
	     * logic there seems to be the same for all settings options - check that later
	     */
	
	  }, {
	    key: "_attachListeners",
	    value: function _attachListeners() {
	      this.backButtonEl = this._DOMContainer.querySelector(".overlay-navigation-back");
	      this.backButtonEl.addEventListener("click", this._backButtonClickHandler.bind(this));
	
	      this.closeButtonEl = this._DOMContainer.querySelector(".overlay-navigation-close");
	      this.closeButtonEl.addEventListener("click", this._closeButtonClickHandler.bind(this));
	
	      this.optionsEl = document.getElementById("viewer-options");
	      this.optionsEl.addEventListener("change", this._viewerOptionsClickHandler.bind(this));
	    }
	  }, {
	    key: "_detachListeners",
	    value: function _detachListeners() {
	      this.backButtonEl.removeEventListener("click", this._backButtonClickHandler);
	      this.closeButtonEl.removeEventListener("click", this._closeButtonClickHandler);
	    }
	  }, {
	    key: "_backButtonClickHandler",
	    value: function _backButtonClickHandler() {
	      this._hide();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_BACK_READING_MODE);
	    }
	  }, {
	    key: "_closeButtonClickHandler",
	    value: function _closeButtonClickHandler() {
	      this._hide();
	      this.trigger("settingPreferredViewer:closed");
	      this._appState.triggerEvent(_analyticsevents.CLICKED_CLOSE_READING_MODE);
	    }
	  }, {
	    key: "_viewerOptionsClickHandler",
	    value: function _viewerOptionsClickHandler(e) {
	      var options = this.optionsEl.querySelectorAll(".viewer-option");
	      [].forEach.call(options, function (node) {
	        node.classList.remove("is-selected");
	      });
	      $(e.target).closest(".viewer-option").addClass("is-selected");
	      this.chosenOption = e.target.value;
	
	      if (e.target.value === "nextgen") {
	        this._appState.triggerEvent(_analyticsevents.CLICKED_NEXTGEN_READING_MODE_SETTINGS);
	      } else {
	        this._appState.triggerEvent(_analyticsevents.CLICKED_REPLICA_READING_MODE_SETTINGS);
	      }
	    }
	  }, {
	    key: "_hide",
	    value: function _hide() {
	      if (this.chosenOption) this._appState.preferredViewer = this.chosenOption;
	      this._detachListeners();
	      this._DOMContainer.innerHTML = "";
	      this._DOMContainer.classList.add("hidden");
	    }
	  }]);
	  return SettingPreferredViewer;
	}(_es6EventEmitter2.default);
	
	exports.default = SettingPreferredViewer;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _topNavigationSetting = __webpack_require__(396);
	
	var _topNavigationSetting2 = _interopRequireDefault(_topNavigationSetting);
	
	var _settingRegion = __webpack_require__(395);
	
	var _settingRegion2 = _interopRequireDefault(_settingRegion);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-line
	var SettingRegion = function (_Emitter) {
	  (0, _inherits3.default)(SettingRegion, _Emitter);
	
	  function SettingRegion(appState, regionManager, options) {
	    (0, _classCallCheck3.default)(this, SettingRegion);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingRegion.__proto__ || (0, _getPrototypeOf2.default)(SettingRegion)).call(this));
	
	    _this.options = null;
	    _this.regionManager = null;
	
	    _this._appState = appState;
	    _this.regionManager = regionManager;
	    _this.options = options;
	    _this.render();
	    return _this;
	  }
	
	  (0, _createClass3.default)(SettingRegion, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var context = {};
	      context.back = true;
	      context.close = true;
	
	      context.title = _dictionary2.default.ChooseRegion;
	
	      //render layout with context
	      this.DOMContainer = document.querySelector("#sidemenu-region-container");
	      if (this.DOMContainer !== null) {
	        Dust.render(_settingRegion2.default, context, function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	
	          _this2.regionManager.render(_this2.DOMContainer.querySelector("#sidemenu-region-list-container"), true, false);
	
	          _this2.attachClickHandlers();
	          _this2.show();
	        });
	      }
	    }
	  }, {
	    key: "attachClickHandlers",
	    value: function attachClickHandlers() {
	      var _this3 = this;
	
	      var backButton = this.DOMContainer.querySelector(".overlay-navigation-back .overlay-navigation-icon");
	      if (backButton) {
	        backButton.addEventListener("click", function (e) {
	          _this3.onBackButtonClick(e);
	        });
	      }
	
	      var closeButton = this.DOMContainer.querySelector(".overlay-navigation-close .overlay-navigation-icon");
	      if (closeButton) {
	        closeButton.addEventListener("click", function (e) {
	          _this3.onCloseButtonClick(e);
	        });
	      }
	    }
	  }, {
	    key: "onBackButtonClick",
	    value: function onBackButtonClick(e) {
	      e.stopPropagation();
	      this.hide();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_BACK_REGIONSELECT);
	    }
	  }, {
	    key: "onCloseButtonClick",
	    value: function onCloseButtonClick(e) {
	      e.stopPropagation();
	      this.close();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_CLOSE_REGIONSELECT);
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.hide();
	      this.trigger("settingRegion:closed");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (this.DOMContainer !== null) {
	        this.DOMContainer.innerHTML = "";
	        this.DOMContainer.classList.add("hidden");
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (this.DOMContainer !== null) {
	        this.DOMContainer.classList.remove("hidden");
	      }
	      this._appState.triggerEvent(_analyticsevents.OPENED_REGIONSELECT_SETTINGS);
	    }
	  }]);
	  return SettingRegion;
	}(_es6EventEmitter2.default);
	
	exports.default = SettingRegion;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _settingAccount = __webpack_require__(391);
	
	var _settingAccount2 = _interopRequireDefault(_settingAccount);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _redirectorKeys = __webpack_require__(23);
	
	var _utils = __webpack_require__(10);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingAccount = function (_Emitter) {
	  (0, _inherits3.default)(SettingAccount, _Emitter);
	
	  function SettingAccount(appState, paywall, options) {
	    (0, _classCallCheck3.default)(this, SettingAccount);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingAccount.__proto__ || (0, _getPrototypeOf2.default)(SettingAccount)).call(this));
	
	    _this.paywall = null;
	    _this.options = null;
	
	    _this._appState = appState;
	    _this.paywall = paywall;
	    _this.options = options;
	    _this.render();
	    return _this;
	  }
	
	  (0, _createClass3.default)(SettingAccount, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var context = {};
	      context.back = true;
	      context.close = true;
	
	      if (_dictionary2.default.accountTitle) {
	        /*Postimees has a different translation for account in the setting  SCREEN
	        and account as the title of the account screen.
	        */
	        context.title = _dictionary2.default.accountTitle;
	      } else {
	        context.title = _dictionary2.default.account;
	      }
	
	      context.info = this._appState.username ? _dictionary2.default.accountLoggedWithInfo + " " + this._appState.username : _dictionary2.default.accountLoggedInInfo;
	      context.logout = _dictionary2.default.logout;
	
	      //render layout with context
	      this.DOMContainer = document.querySelector("#sidemenu-account-container");
	      if (this.DOMContainer !== null) {
	        Dust.render(_settingAccount2.default, context, function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	
	          _this2.attachClickHandlers();
	          _this2.show();
	        });
	      }
	    }
	  }, {
	    key: "attachClickHandlers",
	    value: function attachClickHandlers() {
	      var _this3 = this;
	
	      var backButton = this.DOMContainer.querySelector(".overlay-navigation-back .overlay-navigation-icon");
	      if (backButton) {
	        backButton.addEventListener("click", function (e) {
	          _this3.onBackButtonClick(e);
	        });
	      }
	
	      var closeButton = this.DOMContainer.querySelector(".overlay-navigation-close .overlay-navigation-icon");
	      if (closeButton) {
	        closeButton.addEventListener("click", function (e) {
	          _this3.onCloseButtonClick(e);
	        });
	      }
	
	      var logout = this.DOMContainer.querySelector(".paywall-logout .logout");
	      if (logout) {
	        logout.addEventListener("click", function (e) {
	          _this3.onLogoutClick(e);
	        });
	      }
	    }
	  }, {
	    key: "onBackButtonClick",
	    value: function onBackButtonClick(e) {
	      e.stopPropagation();
	      this.hide();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_BACK_PAYWALL);
	    }
	  }, {
	    key: "onCloseButtonClick",
	    value: function onCloseButtonClick(e) {
	      e.stopPropagation();
	      this.close();
	      this._appState.triggerEvent(_analyticsevents.CLICKED_CLOSE_PAYWALL);
	    }
	  }, {
	    key: "onLogoutClick",
	    value: function onLogoutClick() {
	      var _this4 = this;
	
	      if (this.options.generateSSOState) {
	        this.paywall.authenticatorAuthorisationController.removeSSOStateCookie();
	      }
	      this.hide();
	      if (this.options.paywallRedirectionUrl) {
	        _apimanager2.default.getUserProfileValue(_redirectorKeys.LOGOUT_REDIRECTION).then(function (result) {
	          _this4.paywall.authenticatorAuthorisationController.logOut();
	          _this4.hide();
	          if (result && result[0] && result[0].Value) {
	            window.top.location.href = (0, _utils2.default)(result[0].Value);
	            _this4.paywall.authenticatorAuthorisationController.logOut();
	          }
	        }).catch(function () {
	          _this4.paywall.authenticatorAuthorisationController.logOut();
	          _this4.hide();
	        });
	      } else {
	        this.paywall.authenticatorAuthorisationController.logOut();
	        this.hide();
	      }
	
	      this._appState.triggerEvent(_analyticsevents.CLICKED_LOGOUT_SETTINGS);
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.hide();
	      this.trigger("settingAccount:closed");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (this.DOMContainer !== null) {
	        this.DOMContainer.innerHTML = "";
	        this.DOMContainer.classList.add("hidden");
	        //REMOVE listeners
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      var _this5 = this;
	
	      if (!this._appState.isLoggedIn) {
	        if (_dictionary2.default.accountTitle) {
	          /*Postimees has a different translation for account in the setting  SCREEN
	          and account as the title of the account screen.
	          */
	          this.paywall.show(null, _dictionary2.default.accountTitle);
	        } else {
	          this.paywall.show(null, _dictionary2.default.account);
	        }
	        this.paywall.on("paywall:close", function () {
	          _this5.close();
	        });
	        // add listeners
	      } else if (this.DOMContainer !== null) {
	        this.DOMContainer.classList.remove("hidden");
	        this._appState.triggerEvent(_analyticsevents.OPENED_PAYWALL);
	      }
	    }
	  }]);
	  return SettingAccount;
	}(_es6EventEmitter2.default);
	
	exports.default = SettingAccount;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _sharingComponent = __webpack_require__(93);
	
	var _sharingComponent2 = _interopRequireDefault(_sharingComponent);
	
	var _utils = __webpack_require__(10);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SharingController = function () {
	  function SharingController(appState, albSlide, DOMContainer) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var showSharing = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	    (0, _classCallCheck3.default)(this, SharingController);
	
	    this.appState = appState;
	    this.albSlide = albSlide;
	    this.DOMContainer = DOMContainer;
	    this.options = options;
	    this._showSharing = showSharing;
	    this.init();
	  }
	
	  (0, _createClass3.default)(SharingController, [{
	    key: "close",
	    value: function close(e, force) {
	      return this.shareComponent.close(e, force);
	    }
	  }, {
	    key: "init",
	    value: function init() {
	      var url = this.createUrl();
	      var links = null;
	      if (this._showSharing) {
	        if (url) {
	          links = (0, _utils.createSharingUrls)(url, {
	            title: this.albSlide.getTitle(),
	            intro: this.albSlide.getIntro()
	          }, this.options.sharingOptions, this.appState.isDesktop);
	        }
	      }
	      this.shareComponent = new _sharingComponent2.default(this.appState, links, this.DOMContainer, this.options, _analyticsevents.OPENED_SHARE_MENU_ALB);
	      this.DOMContainer.classList.remove("hidden");
	    }
	  }, {
	    key: "createUrl",
	    value: function createUrl() {
	      var url = null;
	      if (this.options.shareFromReader) {
	        url = this.appState._sharingUrl;
	        if (url) {
	          url = url.replace(/\{0\}/g, this.appState.contentPackageId);
	          url = url.replace(/\{1\}/g, this.appState.publicationId);
	          url = url.replace(/\{2\}/g, this.appState.currentPage + 1);
	          url = url.replace(/\{3\}/g, this.appState.contentid);
	          var intro = this.albSlide.getIntro();
	          var title = this.albSlide.getTitle();
	          if (intro) {
	            url = url.replace(/\{4\}/g, encodeURIComponent(intro));
	          } else {
	            url = url.replace(/\{4\}/g, encodeURIComponent(title));
	          }
	          url = url.replace(/\{5\}/g, encodeURIComponent(title));
	          url = url.replace(/\{6\}/g, this.albSlide.content.PublicationPageID);
	          url = url.replace(/\{7\}/g, Date.now());
	          url = url.replace(/\{8\}/g, this.albSlide.content.ExternalContentReference);
	          url = url.replace(/\{9\}/g, this.appState.contentPackage.bundleDateTime);
	          url = url.replace(/\{10\}/g, this.appState.downloadToken);
	        }
	      } else {
	        url = this.albSlide.getSharingLink();
	      }
	      return url;
	    }
	  }]);
	  return SharingController;
	}();
	
	exports.default = SharingController;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _thumbsliderswiper = __webpack_require__(283);
	
	var _thumbsliderswiper2 = _interopRequireDefault(_thumbsliderswiper);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noUiSlider = __webpack_require__(246);
	
	var SliderNavigation = function () {
	  //thumbsNavigation
	
	  function SliderNavigation(appState, pages, options) {
	    (0, _classCallCheck3.default)(this, SliderNavigation);
	    this._appState = null;
	    this.pages = null;
	    this.slider = null;
	    this.thumbSlider = null;
	    this.options = null;
	    this.lastIndex = null;
	
	    this._appState = appState;
	    this.pages = pages;
	    this.options = options;
	    this.render();
	    this._appState.on("appState:currentpagechanged", this.setCurrentPage.bind(this));
	  }
	
	  (0, _createClass3.default)(SliderNavigation, [{
	    key: "load",
	    value: function load() {
	      if (this.thumbSlider) return;
	      this.thumbSlider = new _thumbsliderswiper2.default(this._appState, this.pages, this.options.sizes);
	      this.thumbSlider.load();
	    }
	  }, {
	    key: "resize",
	    value: function resize() {
	      if (this.thumbSlider) this.thumbSlider.resize();
	    }
	  }, {
	    key: "reload",
	    value: function reload(pages) {
	      this.pages = pages;
	      this.thumbSlider.destroy();
	      this.load();
	      this.resize();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      $(".reader-navigation").removeClass("invisible");
	      $(".page-num-min").text("1");
	      $(".page-num-max").text(this.pages.length);
	      var max = this.pages.length - 1;
	      this.slider = $(".slider-navigation")[0];
	      if (this.pages.length <= 1) {
	        max = this.pages.length;
	      }
	      noUiSlider.create(this.slider, {
	        start: 0,
	        connect: [true, false],
	        step: 1,
	        range: {
	          min: 0,
	          max: max
	        }
	      }, true);
	
	      this.setCurrentPage();
	
	      this.slider.noUiSlider.on("start", function () {
	        _this.showThumbs();
	      });
	
	      this.slider.noUiSlider.on("slide", function () {
	        _this.moveToPage();
	      });
	
	      this.slider.noUiSlider.on("change", function () {
	        _this.sliderChanged();
	      });
	    }
	  }, {
	    key: "showThumbs",
	    value: function showThumbs() {
	      if (!this.thumbSlider) this.load();
	      this.thumbSlider.show();
	      this.moveToPage();
	      this.lastIndex = parseInt(this.slider.noUiSlider.get(), 10);
	      this._appState.triggerEvent(_analyticsevents.CLICKED_BOTTOM_NAVIGATION_READER);
	    }
	  }, {
	    key: "hideThumbs",
	    value: function hideThumbs() {
	      this.thumbSlider.hide();
	    }
	  }, {
	    key: "moveToPage",
	    value: function moveToPage() {
	      this.thumbSlider.moveToPage(parseInt(this.slider.noUiSlider.get(), 10));
	    }
	  }, {
	    key: "sliderChanged",
	    value: function sliderChanged() {
	      this.moveToPage();
	      this.hideThumbs();
	      // We do the change here so that the topscroll happens before the page is changed
	      //to avoid the page to flicker.
	      if (this._appState.isDoublePage == false) {
	        var scrollingContainer = document.querySelector("#reader");
	        if (scrollingContainer) {
	          scrollingContainer.scrollTop = 0;
	        }
	      }
	      this._appState.changeCurrentPage(parseInt(this.slider.noUiSlider.get(), 10)).then(function () {}).catch(function () {});
	      if (this.lastIndex !== parseInt(this.slider.noUiSlider.get(), 10)) {
	        this._appState.triggerEvent(_analyticsevents.SWIPED_BOTTOM_NAVIGATION_READER);
	      }
	      this.lastIndex = parseInt(this.slider.noUiSlider.get(), 10);
	      this._appState.triggerEvent(_analyticsevents.RELEASE_BOTTOM_NAVIGATION_READER);
	    }
	  }, {
	    key: "setCurrentPage",
	    value: function setCurrentPage() {
	      if (!this.slider.noUiSlider) return;
	      var index = this._appState.currentPage;
	      this.slider.noUiSlider.set(index);
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this._appState.off("appState:currentpagechanged", this.setCurrentPage);
	      this.slider.noUiSlider.destroy();
	      if (this.thumbSlider) this.thumbSlider.destroy();
	    }
	  }]);
	  return SliderNavigation;
	}();
	
	exports.default = SliderNavigation;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _swiper = __webpack_require__(51);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _thumbslider = __webpack_require__(398);
	
	var _thumbslider2 = _interopRequireDefault(_thumbslider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThumbSlider = function () {
	  function ThumbSlider(appState, pages, sizes) {
	    (0, _classCallCheck3.default)(this, ThumbSlider);
	    this.pages = null;
	    this.DOMContainer = null;
	    this.isCentered = false;
	    this.min = null;
	    this.max = null;
	    this.imageSizes = null;
	
	    this.appState = appState;
	    this.pages = pages;
	    this.sizes = sizes;
	    this.DOMContainer = document.querySelector("#app-container .reader-thumbs-slider");
	
	    this.setThumbsCategories();
	    this.render();
	  }
	
	  (0, _createClass3.default)(ThumbSlider, [{
	    key: "load",
	    value: function load() {
	      this.canLoad = true;
	      if (this.isRendered) {
	        this.renderThumbs();
	      }
	    }
	  }, {
	    key: "renderThumbs",
	    value: function renderThumbs() {
	      var promises = [];
	      var slides = this.DOMContainer.querySelectorAll(".slide-thumb");
	      for (var i = 0; i < slides.length; i++) {
	        var pageId = "#page_" + i + "_thumb";
	        var element = this.DOMContainer.querySelector(pageId);
	        promises.push(this.appState.cdnAssetsDownloader.loadBackgroundPreviewOnElement(this.sizes, this.pages[i].PublicationPageID, element));
	      }
	      if (!_promise2.default.allSettled) return;
	      _promise2.default.allSettled(promises).then(this.resize.bind(this));
	    }
	  }, {
	    key: "setThumbsCategories",
	    value: function setThumbsCategories() {
	      var categories = [];
	      // create all thumb image url's
	      for (var x = 0; x < this.pages.length; x++) {
	        var page = this.pages[x];
	        page.thumbId = "page_" + x + "_thumb";
	        if (categories.indexOf(page.PageCategory) === -1) {
	          categories.push(page.PageCategory);
	          page.thumbCategory = page.PageCategory;
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var context = {};
	      context.pages = this.pages.map(this._adjustPageNumber.bind(this));
	
	      Dust.render(_thumbslider2.default, context, function (err, result) {
	        _this.DOMContainer.innerHTML = result;
	        _this.createSwiper();
	        _this.isRendered = true;
	        if (_this.canLoad) {
	          _this.renderThumbs();
	        }
	      });
	    }
	  }, {
	    key: "loadThumbs",
	    value: function loadThumbs() {
	      //load thumbs in advance
	      this.pages.forEach(function (page) {
	        var image = new Image();
	        image.src = page.thumbUrl;
	      });
	    }
	  }, {
	    key: "createSwiper",
	    value: function createSwiper() {
	      this.show();
	      var slideWidth = this.DOMContainer.querySelector(".slide-container").getBoundingClientRect().width;
	      var totalWidth = this.DOMContainer.getBoundingClientRect().width;
	
	      var number = totalWidth / slideWidth;
	
	      this.swiper = new _swiper2.default(".swiper-container-thumbs", {
	        initialSlide: 0,
	        slidesPerView: number,
	        centeredSlides: false
	      });
	
	      this.hide();
	
	      this.min = Math.floor(Math.floor(number) / 2);
	      this.max = this.swiper.slides.length - 1 - this.min;
	
	      this.moveToPage(this.appState.currentPage);
	    }
	  }, {
	    key: "resize",
	    value: function resize() {
	      this.show();
	      var slideWidth = this.DOMContainer.querySelector(".slide-container").getBoundingClientRect().width;
	      var totalWidth = this.DOMContainer.getBoundingClientRect().width;
	
	      var number = totalWidth / slideWidth;
	
	      this.swiper.params.slidesPerView = number;
	      this.swiper.update();
	
	      this.hide();
	
	      this.min = Math.floor(Math.floor(number) / 2);
	      this.max = this.swiper.slides.length - 1 - this.min;
	
	      this.moveToPage(this.appState.currentPage);
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.DOMContainer.classList.add("hidden");
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.DOMContainer.classList.remove("hidden");
	    }
	  }, {
	    key: "moveToPage",
	    value: function moveToPage(index) {
	      var realIndex = Math.min(index, this.appState.totalPages - 1);
	      realIndex = Math.max(realIndex, 0);
	      this.deActivateAllSlides();
	      if (this.min < realIndex && realIndex < this.max) {
	        if (!this.isCentered) {
	          this.isCentered = true;
	          this.swiper.params.centeredSlides = true;
	          this.swiper.update();
	        }
	        this.swiper.slideTo(realIndex);
	        this.swiper.slides[realIndex].classList.add("active");
	      } else {
	        if (this.isCentered) {
	          this.isCentered = false;
	          this.swiper.params.centeredSlides = false;
	          this.swiper.update();
	        }
	        if (realIndex <= this.min) {
	          this.swiper.slideTo(0);
	          this.swiper.slides[0].classList.remove("active");
	          this.swiper.slides[realIndex].classList.add("active");
	        } else if (realIndex >= this.max) {
	          this.swiper.slideTo(this.swiper.slides.length - 1);
	          this.swiper.slides[this.swiper.slides.length - 1].classList.remove("active");
	          this.swiper.slides[realIndex].classList.add("active");
	        }
	      }
	    }
	  }, {
	    key: "deActivateAllSlides",
	    value: function deActivateAllSlides() {
	      $(this.swiper.slides).removeClass("active");
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.swiper.removeAllSlides();
	      this.swiper.destroy();
	      this.DOMContainer.innerHTML = "";
	      this.swiper = null;
	      this.DOMContainer = null;
	    }
	  }, {
	    key: "_adjustPageNumber",
	    value: function _adjustPageNumber(page) {
	      page.ajustedPageNumber = page.adjustedIndex !== undefined ? page.adjustedIndex + 1 : page.PageNumber;
	      return page;
	    }
	  }]);
	  return ThumbSlider;
	}();
	
	exports.default = ThumbSlider;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Default configuration settings, can be overwritten by the client specif version */
	
	var defaultConfig = function () {
	  function defaultConfig() {
	    (0, _classCallCheck3.default)(this, defaultConfig);
	  }
	
	  (0, _createClass3.default)(defaultConfig, null, [{
	    key: "page_reference_ratio",
	    //if the caption of the imageViewershould be resricted in lines and clickable to expand
	
	    //imageviewer
	    //TODO: remove config?
	    //set in px
	
	
	    //albcontroller
	    // [top || bottom || center];
	    /**
	     * Determines where enrichments are placed horizontally inside the clickable area
	     * of an article. Options are `"left"`, `"right"` and `"center"`.
	     *
	     * Default is `"left"`.
	     */
	    //should be set for each client, depends on the packager wwhat sizes he produces
	    //time between pinch and pan to accept pan event
	
	
	    /**
	     * An object which represents if toggle buttons should be displayed for
	     * changing the reading mode between single page and double page. The toggle
	     * buttons can be made visible per device type.
	     *
	     * Default is `true` for tablets, `false` for phones and desktops.
	     */
	
	
	    //reader
	
	
	    //cookie
	
	    /**
	     * When fetching the SSO token from URL, the webapp will look in the URL
	     * for a parameter of which the name matches the value of this config.
	     *
	     * Only relevant if SSO login is enabled.
	     */
	
	    /**
	     * If set to `true`, the method `_removeSSOCookie()` will always work.
	     * Otherwise, it will only work under certain circumstances.
	     *
	     * Only relevant if SSO login is enabled.
	     */
	
	    /**
	     * Can be set to an object containing extra properties of the SSO cookie.
	     * This is typically a `path` and a `domain`.
	     *
	     * Only relevant if SSO login is enabled.
	     */
	
	
	    // ---------------------------------------
	    // AUTHENTICATION AND SSO (SINGLE SIGN-ON)
	    // ---------------------------------------
	
	    /**
	     * If set to `true`, enables SSO login.
	     */
	
	
	    //help
	
	    /**
	     * If set to true, displays a help button in the top navigation
	     * next to the login button.
	     *
	     * Default is `false`.
	     */
	    // null or link of client home if they provided there own home
	    //light or dark
	
	
	    //sidemenu
	
	
	    //swiper
	
	    /**
	     * If set to `true`, a new archive block will be added to the kiosk to
	     * display promospots. Promospots are fetched from the Twipe
	     * backend API using the `KiosquePublications` call. If there
	     * are no promospots to show, the archive will be hidden.
	     *
	     * Default is `true`.
	     */
	
	
	    //kiosque
	    /**
	     * If set to `true`, a new archive block will be added to the kiosk to
	     * display hors series. Hors series are fetched from the Twipe
	     * backend API using the `AdditionalDownloadTokens` call. If there
	     * are no hors series to show, the archive will be hidden.
	     *
	     * Default is `true`.
	     */
	    //1/3 of the page is displayed on the screen
	    get: function get() {
	      return this.page_height_reference / this.page_width_reference;
	    }
	
	    //imageviewerslide
	    //when to hide button
	
	
	    //alb slide
	
	    //sharing
	    /**
	     * Determines whether social sharing is allowed in the ALB.
	     * This does not guarantee that the sharing button will appear,
	     * as this also depends on other factors (including the social sharing
	     * link that has to be fetched from backend).
	     *
	     * Default is `true`.
	     */
	    // [left || right || center];
	
	    /**
	     * Determines where enrichments are placed vertically inside the clickable area
	     * of an article. Options are `"top"`, `"bottom"` and `"center"`.
	     *
	     * Default is `"top"`.
	     */
	
	
	    //readerPage
	    //treshold for when to accept pinch
	
	
	    // hammerSlide
	
	    /**
	     * An object which represents in which reading mode the reader should
	     * start initially. `false` means single page, `true` means double page.
	     * The initial reading mode can be configured per device type.
	     *
	     * Default is `true` for tablets and desktops, `false` for phones.
	     */
	    // Config to make the full page redirect to the reader when in an iframe
	
	
	    // --------------------
	    // SUBSCRIPTION OPTIONS
	    // --------------------
	
	    /**
	     * Allows for setting extra options related to subscriptions and login.
	     * Typically this consists of two things:
	     *
	     * - `subscriptionType`: `free` or `subscription`
	     * - `subscriptionProvider`: the provider of the subscription. Will be passed along when doing
	     * a `validateSubscription` call to the backend.
	     */
	
	    /**
	     * If set to true, the SSO state will be stored in a cookie.
	     * Otherwise, SSO state is managed via URL parameters.
	     *
	     * Only relevant if SSO login is enabled.
	     */
	
	    /**
	     * If set to `true`, the SSO token will be fetched
	     * from the URL after logging in via SSO.
	     *
	     * Only relevant if SSO login is enabled.
	     */
	
	    /**
	     * When authenticating via SSO,
	     * the webapp will look for a cookie with a name
	     * equal to the value of this config.
	     *
	     * Only relevant if SSO login is enabled.
	     */
	
	
	    //regionmanager
	
	
	    //about
	
	
	    //settings
	
	
	    //sidemenuswiper
	    //[{name: 'Site Nieuwsblad', link: 'http://www.nieuwsblad.be'}]; //{'Site Niewsblad': 'www.nieuwsblad.be'};   // example: {'Site Niewsblad': 'www.nieuwsblad.be'} of null
	    /* to stay on the same directory level use -1. CFR uses it. */
	    // [
	    //   { token: 'TWPPAR75', url: '', redirectingUrl: '/index.html', current: true },  //set current to true if it should be inactivated
	    //   { token: 'TWPPAR18H', url: '//par-18h-uat-api.twipecloud.net/', redirectingUrl: '//twipe-par-18h-uat-webreader.s3.amazonaws.com/index.html' },
	    //   { token: 'TWPPARECO', url: '', redirectingUrl: '/economie/index.html' },
	    //   { token: 'TWPPARETU', url: '', redirectingUrl: '/etudiant/index.html' },
	    //   { token: 'TWPPARPSN', url: '', redirectingUrl: '//www.kiosque.laparisienne.com/' },
	    // ];
	
	    //promospot
	
	    /**
	     * Determines the amount of publication to show in the archive.
	     * For most clients, this will be 30 publications,
	     * since publications are saved for one month in the backend.
	     *
	     * Default is `30`.
	     */
	
	    /**
	     * If set to `true`, a new archive block will be added to the kiosk to
	     * display past main publications.
	     *
	     * Default is `true`.
	     */
	
	    /**
	     * If set to `true`, social sharing links for ALBs will be constructed
	     * based on the WebappReplicaShareUrl profile value.
	     */
	
	
	    //reader
	
	    /**
	     * If set to `true`, displays text labels underneath icons in the
	     * top navigation bar.
	     *
	     * This config can only be enabled if the useCustomTooltips is disabled,
	     * because it does not make sense to have both.
	     *
	     * Default is `false`.
	     */
	
	    //image size
	    //should be set for each client, depends on the packager wwhat sizes he produces
	
	
	    // Sizes
	    // covers
	
	    // previews
	
	    // images
	
	    // print
	
	
	    // print
	
	
	    //pdf   : if you enable make sure CORS headers are correctly set in bakckend
	
	
	    // static usePdfPhoneNot = [
	    //   ['Safari', 'iOS', 'version_8'],
	    //   ['Safari', 'iOS', 'version_7'],
	    // ]
	    // static usePdfPhone = [
	    //   ['iOS', 'Chrome'],
	    //   ['iOS', 'FireFox'],
	    //   ['AndroidOS', 'Chrome'],
	    // ];
	
	    //zooming
	
	
	    /**
	     * Sets the default preferred viewer (`'replica'` or `'nextgen'`).
	     * Default is `'nextgen'`.
	     */
	
	    /**
	     * Determines whether to show options for switching between
	     * the Replica and NextGen viewer. This affects the following:
	     *
	     * - the switch button under the kiosk spotlight edition
	     * - the option in the settings menu
	     * - the switch icon in the reader
	     *
	     * Default is `false`.
	     */
	
	
	    /**
	     * Determines whether click boxes for enrichment articles containing an external link
	     * will be opened in a new browser tab, or just in the ALB.
	     *
	     * Default is `false`, which opens them in the ALB.
	     */
	
	
	    /**
	     * If set to `true`, the main archive is displayed as a single row
	     * with slider functionality. Else, all publications in the archive
	     * are displayed together in several rows.
	     *
	     * Default is `false`.
	     */
	
	
	    /**
	     * If set to `true`, the webapp will fetch a redirection url from the Twipe
	     * database and redirect users to that URL whenever a paywall should be shown.
	     * If set to `false` or `null`, the default paywall of the webapp will be used.
	     */
	
	
	    // time in ms
	
	    /**
	     * Determines how many times a user can be redirected between the Twipe webapp and an external SSO
	     * provider. Once this limit is surpassed, the webapp will show its own paywall instead.
	     * Default is 1 time.
	     */
	
	  }]);
	  return defaultConfig;
	}();
	
	defaultConfig.shareFromReader = false;
	defaultConfig.shareFromNextgen = false;
	defaultConfig.useCookiePostfix = false;
	defaultConfig.displayHorsSerieArchive = true;
	defaultConfig.displayArchive = true;
	defaultConfig.usePromoSpot = true;
	defaultConfig.customKiosqueTitle = "";
	defaultConfig.topNavButtonLabel = "";
	defaultConfig.archiveLength = 30;
	defaultConfig.toggleSubscriptionTopNavButtonOnUserLoggedIn = false;
	defaultConfig.newsstandRedirecting = null;
	defaultConfig.homeRelativeDepth = 0;
	defaultConfig.onlySupplementsInPromospot = false;
	defaultConfig.numberOfSlidesVisible = { phone: 3.5, tablet: 4.5 };
	defaultConfig.spaceBetweenSlides = { phone: 19, tablet: 40 };
	defaultConfig.recentlyLength = 10;
	defaultConfig.sidemenuThema = "light";
	defaultConfig.extraInfo = null;
	defaultConfig.homeRedirectionLink = null;
	defaultConfig.logo404 = "logo.png";
	defaultConfig.homeRedirectionLinkUAT = null;
	defaultConfig.homeRedirectionLinkPROD = null;
	defaultConfig.numberOfSlidesVisibleSideMenu = { phone: 2.3, tablet: 2.3 };
	defaultConfig.spaceBetweenSlidesSideMenu = { phone: 10, tablet: 10 };
	defaultConfig.turnOnSettings = true;
	defaultConfig.turnOnHeaderHelp = false;
	defaultConfig.editor = "";
	defaultConfig.developer = "Twipe";
	defaultConfig.defaultRegion = false;
	defaultConfig.defaultDownloadToken = null;
	defaultConfig.downloadToken = null;
	defaultConfig.SSOEnabled = false;
	defaultConfig.SSOCookieName = "PubSSOToken";
	defaultConfig.SSOCookieOptions = { path: "", domain: "" };
	defaultConfig.getSSOTokenFromUrl = false;
	defaultConfig.deleteSSOCookie = true;
	defaultConfig.generateSSOState = false;
	defaultConfig.urlSSOTokenParameter = "token";
	defaultConfig.subscriptionOptions = {
	  subscriptionType: "subscription",
	  subscriptionProvider: "TWIPE-DEMO"
	};
	defaultConfig.cookie_info_cookie_name = "TW_COOKIE";
	defaultConfig.cookieEnabled = false;
	defaultConfig.useFullWidthLandscapeSinglePage = { phone: true, tablet: true };
	defaultConfig.useFullWidthLandscapeDoublePage = { phone: false, tablet: false };
	defaultConfig.redirectReaderFromIframe = false;
	defaultConfig.returnToIframeurl = null;
	defaultConfig.replicaReadingModeToggle = {
	  phone: false,
	  tablet: true,
	  desktop: false
	};
	defaultConfig.replicaReadingModeDefault = {
	  phone: false,
	  tablet: true,
	  desktop: true
	};
	defaultConfig.enableTopNavDropdown = false;
	defaultConfig.pinchPanTimeInterval = 50;
	defaultConfig.pinchTreshold = 0.1;
	defaultConfig.max_zoom = 5;
	defaultConfig.page_ratio = 1.5;
	defaultConfig.normal_size = "900/900";
	defaultConfig.hd_size = "2600/1928";
	defaultConfig.page_width_reference = 150000;
	defaultConfig.page_height_reference = 150000;
	defaultConfig.enrichment_placement_vertical = "top";
	defaultConfig.enrichment_placement_horizontal = "left";
	defaultConfig.pdfThreshold = { width: 1270, height: 1750 };
	defaultConfig.pdfThresholdTouch = { width: 800, height: 1300 };
	defaultConfig.pdfLoadingTimeout = 200;
	defaultConfig.pdfCleanupDelta = 2;
	defaultConfig.activeAreaPercentage = 0.8;
	defaultConfig.extraButtonOnSlider = true;
	defaultConfig.increaseFontSizeEnabled = true;
	defaultConfig.albSlideOnlyOnePage = false;
	defaultConfig.rootFontSize = 10;
	defaultConfig.fontSizeStep = 2;
	defaultConfig.maxfontSize = 20;
	defaultConfig.extraUrlDirectAccess = false;
	defaultConfig.sharingEnabled = true;
	defaultConfig.sharingOptions = {
	  Facebook: true,
	  WhatsApp: true,
	  GooglePlus: false,
	  Twitter: true,
	  Mail: true,
	  MailSubject: null,
	  MailSubjectIntro: ""
	};
	defaultConfig.fixedImgHeight = true;
	defaultConfig.captionMaxLines = false;
	defaultConfig.extraButtonInTitle = false;
	defaultConfig.hideExtraButtonWhenInExtras = false;
	defaultConfig.extraButtonOnEachPage = false;
	defaultConfig.extrasInViewMargin = 50;
	defaultConfig.fullWidthImage = false;
	defaultConfig.marginScrollExtraInView = 30;
	defaultConfig.displayPageCategory = false;
	defaultConfig.imageviewerKeepScale = true;
	defaultConfig.imageViewerCaptionOnlyFirstLines = true;
	defaultConfig.channel = 3;
	defaultConfig.product_name_for_engage_readers = "Dagkrant";
	defaultConfig.bottomNavigation = true;
	defaultConfig.thumbsNavigation = true;
	defaultConfig.thumbSliderExtraSlidesVisible = { phone: 1, tablet: 2 };
	defaultConfig.positionExtraButton = { horizontal: "right", vertical: "bottom" };
	defaultConfig.readerEnableHorsseries = false;
	defaultConfig.preloadingHdPages = 1;
	defaultConfig.touchDownloadPdf = false;
	defaultConfig.useCustomTooltips = false;
	defaultConfig.displayTopNavButtonlabel = false;
	defaultConfig.fullPdfDownloadOnly = false;
	defaultConfig.allowFullPdfDownload = true;
	defaultConfig.thumbSize = "240/440";
	defaultConfig.thumbSizeM = "900/900";
	defaultConfig.thumbSizeL = "900/900";
	defaultConfig.newDownloaderCoverSizeS = "SMALL";
	defaultConfig.newDownloaderCoverSizeM = "MEDIUM";
	defaultConfig.namedSizeCoverS = "SMALL";
	defaultConfig.sizeCoverS = "240/440";
	defaultConfig.namedSizeCoverM = "MEDIUM";
	defaultConfig.sizeCoverM = "900/900";
	defaultConfig.namedSizePreviewS = "SMALL";
	defaultConfig.sizePreviewS = "240/440";
	defaultConfig.namedSizePreviewM = "MEDIUM";
	defaultConfig.sizePreviewM = "900/900";
	defaultConfig.namedSizePreviewL = "XLARGE";
	defaultConfig.sizePreviewL = "2600/1928";
	defaultConfig.namedSizeImageM = "MEDIUM";
	defaultConfig.sizeImageM = "240/440";
	defaultConfig.namedSizeImageL = "XLARGE";
	defaultConfig.sizeImageL = "2600/1928";
	defaultConfig.printImageSize = "2600/1928";
	defaultConfig.dropCapIfFirstBold = false;
	defaultConfig.dateFormat = "ddd D MMM";
	defaultConfig.sidemenuWidth = { phone: 250, tablet: 320 };
	defaultConfig.sidemenuAnimationDuration = { phone: 0.25, tablet: 0.25 };
	defaultConfig.printImageSize = "2600/1928";
	defaultConfig.printArticle = true;
	defaultConfig.printExtraMargin = 15;
	defaultConfig.printMarginLeft = 10;
	defaultConfig.printPadding = 10;
	defaultConfig.usePdfTablet = false;
	defaultConfig.usePdfTabletNot = false;
	defaultConfig.usePdfPhone = false;
	defaultConfig.usePdfPhoneNot = false;
	defaultConfig.usePdfDesktop = false;
	defaultConfig.usePdfDesktopNot = false;
	defaultConfig.desktopMaxZoom = {
	  doublePageMode: 5,
	  singlePageMode: 3
	};
	defaultConfig.zoomSteps = 8;
	defaultConfig.defaultPreferredViewer = "nextgen";
	defaultConfig.displayViewerOptions = false;
	defaultConfig.extraLinkDirectAccess = false;
	defaultConfig.socialSharingHash = false;
	defaultConfig.allowNextgenPageSharing = false;
	defaultConfig.logoRedirect = false;
	defaultConfig.useNameAsLabel = false;
	defaultConfig.useHSNameAsLabel = true;
	defaultConfig.useSliderForPromospot = false;
	defaultConfig.useSliderForHorsSeries = false;
	defaultConfig.useSliderForArchive = false;
	defaultConfig.forceRegionCookie = "TW_FORCE_REGION";
	defaultConfig.forceRegionCookieOptions = { path: "", domain: "" };
	defaultConfig.deleteForceRegionCookie = true;
	defaultConfig.paywallRedirectionUrl = null;
	defaultConfig.paywallRedirectionTimeReset = 1000 * 60 * 2;
	defaultConfig.paywallRedirectionNumber = 1;
	defaultConfig.subscription_validate_email = false;
	defaultConfig.cmpScript = "";
	defaultConfig.enableCookieConsent = false;
	defaultConfig.hasConsentScript = false;
	defaultConfig.showBackButtonParam = undefined;
	defaultConfig.urlRedirectParameter = "redirectionUrl";
	defaultConfig.displayPublicationNameInSidebar = false;
	defaultConfig.featuresToBeEnabledByBE = [];
	defaultConfig.disableCookieSameSitePolicy = false;
	defaultConfig.printCroppedPdf = true;
	defaultConfig.openHelpOnNewtab = true;
	defaultConfig.openPrivacyOnNewtab = true;
	defaultConfig.showPrivacyPolicy = false;
	defaultConfig.noPasswordLogin = false;
	defaultConfig.hideDisclaimer = false;
	defaultConfig.singlePageDisplayedProportion = 3;
	exports.default = defaultConfig;

/***/ },
/* 285 */,
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _maxSafeInteger = __webpack_require__(307);
	
	var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.sort = sort;
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CpStore = function (_Emitter) {
	  (0, _inherits3.default)(CpStore, _Emitter);
	
	  function CpStore(APIManager, ContentManager, contentPackageId, additionalDownloadTokens, options) {
	    (0, _classCallCheck3.default)(this, CpStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CpStore.__proto__ || (0, _getPrototypeOf2.default)(CpStore)).call(this));
	
	    _this._apiManager = null;
	    _this.contentManager = null;
	    _this.additionalDownloadTokens = null;
	    _this.cpID = null;
	    _this.CPackageInfo = null;
	    _this.CPackage = null;
	    _this.options = null;
	    _this.supplements = [];
	    _this.sharingUrl = null;
	    _this.nextgenSharingUrl = null;
	
	    _this._apiManager = APIManager;
	    _this.contentManager = ContentManager;
	    _this.cpID = contentPackageId;
	    _this.additionalDownloadTokens = additionalDownloadTokens;
	    _this.options = options;
	    return _this;
	  }
	
	  //contentPackageId
	
	
	  (0, _createClass3.default)(CpStore, [{
	    key: "load",
	    value: function load() {
	      var _this2 = this;
	
	      this.loadInfo().then(function () {
	        _promise2.default.all([_this2.loadCp(), _this2.loadSharingUrl(), _this2.loadNextSharingUrl()]).then(function () {
	          _this2.CPackageInfo.ProductName = _this2.options.product_name_for_engage_readers;
	          for (var i = 0; i < _this2.additionalDownloadTokens.length; i++) {
	            if (_this2.additionalDownloadTokens[i].Value === _this2.CPackage.DownloadToken) {
	              _this2.CPackageInfo.ProductName = _this2.additionalDownloadTokens[i].Description;
	            }
	          }
	          _this2.trigger("cpStore:loaded");
	        });
	      });
	    }
	  }, {
	    key: "loadSharingUrl",
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var result;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!this.options.shareFromReader) {
	                  _context.next = 10;
	                  break;
	                }
	
	                _context.prev = 1;
	                _context.next = 4;
	                return this._apiManager.getProfileValues("WebappReplicaShareUrl");
	
	              case 4:
	                result = _context.sent;
	
	                if (result && result[0] && result[0].Description) {
	                  this.sharingUrl = result[0].Description;
	                }
	                _context.next = 10;
	                break;
	
	              case 8:
	                _context.prev = 8;
	                _context.t0 = _context["catch"](1);
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[1, 8]]);
	      }));
	
	      function loadSharingUrl() {
	        return _ref.apply(this, arguments);
	      }
	
	      return loadSharingUrl;
	    }()
	  }, {
	    key: "loadNextSharingUrl",
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	        var result;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!this.options.shareFromNextgen) {
	                  _context2.next = 10;
	                  break;
	                }
	
	                _context2.prev = 1;
	                _context2.next = 4;
	                return this._apiManager.getProfileValues("WebappNextgenShareUrl");
	
	              case 4:
	                result = _context2.sent;
	
	                if (result && result[0] && result[0].Description) {
	                  this.nextgenSharingUrl = result[0].Description;
	                }
	                _context2.next = 10;
	                break;
	
	              case 8:
	                _context2.prev = 8;
	                _context2.t0 = _context2["catch"](1);
	
	              case 10:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[1, 8]]);
	      }));
	
	      function loadNextSharingUrl() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return loadNextSharingUrl;
	    }()
	
	    /**
	     * makes getContentPackageInfo API call and saves response in cpStore object
	     * @param {number} contentPackageId
	     * @returns {void} void promise
	     */
	
	  }, {
	    key: "loadInfo",
	    value: function loadInfo(contentPackageId) {
	      var _this3 = this;
	
	      if (contentPackageId) {
	        this.cpID = contentPackageId;
	      }
	      return this._apiManager.getContentPackageInfo(this.cpID).then(function (info) {
	        _this3.CPackageInfo = info;
	        var price = _maxSafeInteger2.default;
	        var channelPrice = void 0;
	        _this3.CPackageInfo.StoreProducts.forEach(function (product) {
	          if (product.Channel == _this3.options.channel) {
	            channelPrice = product;
	          }
	        });
	        // const channelPrice = this.CPackageInfo.StoreProducts.find(product => (product.Channel == this.options.channel));  // bug on old browsers, don't support find
	        if (channelPrice) {
	          price = channelPrice.Price;
	        }
	        _this3.CPackageInfo.price = price;
	      });
	    }
	  }, {
	    key: "getVersion",
	    value: function getVersion() {
	      return this.CPackageInfo ? this.CPackageInfo.Version : undefined;
	    }
	
	    /**
	     * makes getContentPackagePublications call for CP info & makes getNonExpiredShelfPublications call for all valid pubs within the CP. Pub info is normalised and added to CP info object
	     * cpstore:cpLoaded is triggered
	     * @returns {void} void
	     */
	
	  }, {
	    key: "loadCp",
	    value: function () {
	      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	        var shelf;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return this.contentManager.getContentPackagePublications(this.cpID);
	
	              case 2:
	                this.CPackage = _context3.sent;
	                _context3.prev = 3;
	                _context3.next = 6;
	                return this.contentManager.getNonExpiredShelfPublications(this.cpID);
	
	              case 6:
	                shelf = _context3.sent;
	
	                this.CPackage.ContentPackagePublication = this.CPackage.ContentPackagePublication.concat(sort(shelf));
	                _context3.next = 12;
	                break;
	
	              case 10:
	                _context3.prev = 10;
	                _context3.t0 = _context3["catch"](3);
	
	              case 12:
	                this.normalizeContentPackagePublications();
	                this.setSupplements();
	                this.trigger("cpStore:cpLoaded");
	                return _context3.abrupt("return", true);
	
	              case 16:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[3, 10]]);
	      }));
	
	      function loadCp() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return loadCp;
	    }()
	  }, {
	    key: "setSupplements",
	    value: function setSupplements() {
	      var _this4 = this;
	
	      this.CPackage.ContentPackagePublication.forEach(function (cpp) {
	        if (cpp.PublicationType === "Supplement") {
	          _this4.supplements.push(cpp);
	        }
	      });
	    }
	  }, {
	    key: "normalizeContentPackagePublications",
	    value: function normalizeContentPackagePublications() {
	      var _this5 = this;
	
	      this.CPackage.ContentPackagePublication.forEach(function (cpp) {
	        cpp.label = cpp.PublicationName;
	        if (cpp.ThumbnailPublicationPageId) {
	          cpp.ThumbnailId = cpp.ThumbnailPublicationPageId;
	        } else {
	          cpp.ThumbnailId = cpp.ThumbnailPublicationPageID;
	        }
	        if (cpp.ContentPackageID) {
	          cpp.ContentPackageId = cpp.ContentPackageID;
	        }
	        if (cpp.PublicationID) {
	          cpp.PublicationId = cpp.PublicationID;
	        }
	        if (!cpp.ContentPackageId) {
	          cpp.ContentPackageId = _this5.cpID;
	        }
	        if (!cpp.PublicationDate) {
	          cpp.PublicationDate = _this5.CPackage.PublicationDate;
	        }
	        if (!cpp.PublicationTitleFormat) {
	          cpp.PublicationTitleFormat = "Newspaper";
	        }
	        cpp.imageUrl = (0, _utils.generateCoverURL)(cpp.ContentPackageId, _this5.options.sizes.S, cpp.ThumbnailId, cpp.ContentPackageVersion || _this5.CPackageInfo.Version);
	        cpp.imageLargeUrl = (0, _utils.generateCoverURL)(cpp.ContentPackageId, _this5.options.sizes.M, cpp.ThumbnailId, cpp.ContentPackageVersion || _this5.CPackageInfo.Version);
	      });
	    }
	  }]);
	  return CpStore;
	}(_es6EventEmitter2.default);
	
	exports.default = CpStore;
	function sort(list) {
	  return list.sort(function (a, b) {
	    return new Date(b.PublicationDate) - new Date(a.PublicationDate);
	  });
	}

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsstandRedirectingStore = function (_Emitter) {
	  (0, _inherits3.default)(NewsstandRedirectingStore, _Emitter);
	
	  function NewsstandRedirectingStore(apiManager, data, imageSizes, downloadToken) {
	    (0, _classCallCheck3.default)(this, NewsstandRedirectingStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NewsstandRedirectingStore.__proto__ || (0, _getPrototypeOf2.default)(NewsstandRedirectingStore)).call(this));
	
	    _this.packages = [];
	    _this.data = null;
	    _this._apiManager = null;
	    _this._imageSizes = null;
	    _this._downloadToken = null;
	
	    _this._apiManager = apiManager;
	    _this.data = data;
	    _this._imageSizes = imageSizes;
	    _this._downloadToken = downloadToken;
	    return _this;
	  }
	
	  (0, _createClass3.default)(NewsstandRedirectingStore, [{
	    key: "getAllContentPackages",
	    value: function getAllContentPackages() {
	      return this.packages;
	    }
	  }, {
	    key: "loadNewsstandRedirecting",
	    value: function loadNewsstandRedirecting() {
	      var _this2 = this;
	
	      var promises = [];
	      this.data.forEach(function (singleData) {
	        promises.push(_this2.loadSingleNewsstandRedirecting(singleData));
	      });
	      _promise2.default.all(promises).then(function (data) {
	        _this2.packages = data;
	        _this2.trigger("NewsstandRedirecting:loaded");
	      });
	    }
	  }, {
	    key: "loadSingleNewsstandRedirecting",
	    value: function loadSingleNewsstandRedirecting(singleData) {
	      var _this3 = this;
	
	      var promise = new _promise2.default(function (resolve) {
	        _this3._apiManager.getContentPackageList(singleData.token, 1, singleData.url).then(function (json) {
	          if (json && json[0]) {
	            var result = _this3.normalizePub(json[0], singleData);
	            resolve(result);
	          } else {
	            resolve(null);
	          }
	        }).catch(function () {
	          resolve(null);
	        });
	      });
	      return promise;
	    }
	  }, {
	    key: "normalizePub",
	    value: function normalizePub(pub, singleData) {
	      var result = {};
	      result.imageUrl = (0, _utils.generateCoverURL)(pub.ContentPackageId, this._imageSizes.S, pub.ThumbnailId, pub.Version, singleData.url);
	      result.url = singleData.redirectingUrl;
	      result.current = singleData.current;
	      if (singleData.customLabel) {
	        result.customLabel = singleData.customLabel;
	      }
	
	      if (singleData.class) {
	        result.class = singleData.class;
	      }
	      return result;
	    }
	  }]);
	  return NewsstandRedirectingStore;
	}(_es6EventEmitter2.default);
	
	exports.default = NewsstandRedirectingStore;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromospotStore = function (_Emitter) {
	  (0, _inherits3.default)(PromospotStore, _Emitter);
	
	  function PromospotStore(apiManager, imageSizes, options) {
	    (0, _classCallCheck3.default)(this, PromospotStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PromospotStore.__proto__ || (0, _getPrototypeOf2.default)(PromospotStore)).call(this));
	
	    _this.promospotList = null;
	    _this._apiManager = null;
	    _this._imageSizes = null;
	
	    _this._apiManager = apiManager;
	    _this._imageSizes = imageSizes;
	    _this._options = options;
	    return _this;
	  }
	
	  (0, _createClass3.default)(PromospotStore, [{
	    key: "loadPromospot",
	    value: function loadPromospot(downloadToken) {
	      var _this2 = this;
	
	      var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this._apiManager.getPromospot(downloadToken).then(function (json) {
	        var kiosquePublications = json.KiosquePublications;
	        var publications = [];
	        var size = kiosquePublications.length;
	        for (var i = 0; i < size; i++) {
	          var kiosque = kiosquePublications[i];
	          var size1 = kiosque.Publications.length;
	          var cpid = kiosque.ContentPackageId;
	          var version = kiosque.Version;
	          for (var j = 0; j < size1; j++) {
	            var pub = kiosque.Publications[j];
	            var newPub = _this2.normalizePubForSwiper(pub, cpid, version, domain);
	            if (newPub) {
	              publications.push(newPub);
	            }
	          }
	        }
	        _this2.promospotList = publications;
	        _this2.sort();
	        _this2.trigger("promospot:loaded");
	      });
	    }
	  }, {
	    key: "getPromospotList",
	    value: function getPromospotList() {
	      return this.promospotList;
	    }
	  }, {
	    key: "sort",
	    value: function sort() {
	      this.promospotList.sort(function (a, b) {
	        return b.Priority - a.Priority;
	      });
	    }
	  }, {
	    key: "normalizePubForSwiper",
	    value: function normalizePubForSwiper(pub, contentPackageId, version) {
	      var domain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      if (this._options.onlySupplementsInPromospot && pub.PublicationType.toLowerCase() !== "supplement") {
	        return null;
	      }
	      var result = pub;
	      result.label = pub.PublicationName;
	      result.ThumbnailId = pub.ThumbnailPublicationPageId;
	      result.imageUrl = (0, _utils.generateCoverURL)(contentPackageId, this._imageSizes.S, pub.ThumbnailId, version, domain);
	      result.ContentPackageId = contentPackageId;
	      return result;
	    }
	  }]);
	  return PromospotStore;
	}(_es6EventEmitter2.default);
	
	exports.default = PromospotStore;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _cookiemanager = __webpack_require__(24);
	
	var _cookiemanager2 = _interopRequireDefault(_cookiemanager);
	
	var _utils = __webpack_require__(10);
	
	var _page = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NUMBER_OF_RETRIES = 2;
	
	var PubStore = function (_Emitter) {
	  (0, _inherits3.default)(PubStore, _Emitter);
	
	  //contentPackageId
	  function PubStore(APIManager, ContentManager, CPackage, contentPackageId, publicationId, cpVersion, appState, options) {
	    (0, _classCallCheck3.default)(this, PubStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PubStore.__proto__ || (0, _getPrototypeOf2.default)(PubStore)).call(this));
	
	    _this._apiManager = null;
	    _this.contentManager = null;
	    _this.cpID = null;
	    _this.pubId = null;
	    _this.CPackage = null;
	    _this.PublicationToLoad = null;
	    _this.CPackagePages = null;
	    _this.options = null;
	
	    _this._apiManager = APIManager;
	    _this.contentManager = ContentManager;
	    _this.CPackage = CPackage;
	    _this.cpID = contentPackageId;
	    _this.pubId = publicationId;
	    _this.cpVersion = cpVersion;
	    _this.options = options;
	    _this._appState = appState;
	    _this.setContentPackagePublication();
	
	    /*
	      Nextgen can be loaded before we initilize pubStore or it can be loaded later
	    */
	    _this._appState.on("nextgen:loaded", _this._loadNextgenPublication.bind(_this));
	    return _this;
	  }
	  //contentPackagePublicationId
	
	
	  (0, _createClass3.default)(PubStore, [{
	    key: "loadPub",
	    value: function loadPub() {
	      if (this.isCurrentPublicationReplica()) {
	        this._loadReplicaPublication();
	      } else {
	        this._loadNextgenPublication();
	      }
	    }
	  }, {
	    key: "setOriginalPageSize",
	    value: function setOriginalPageSize() {
	      var _this2 = this;
	
	      var promise = new _promise2.default(function (resolve) {
	        var imageSrc = (0, _utils.generatePreview)(_this2.options.replicaImageSize, _this2.CPackagePages[0].PublicationPageID);
	        // TODO use cover url, but then switching between long lasting supplements needs to have the correct contentPackageId
	        // const imageSrc = generateCoverURL(this.cpID,this.options.namedSizes.covers.S, this.CPackagePages[0].PublicationPageID, this.cpVersion);
	        var image = new Image();
	        image.onload = function () {
	          _this2.originalPageSize = {
	            height: image.height,
	            width: image.width
	          };
	          resolve();
	        };
	        image.onerror = function () {
	          _this2.ratio = _this2.options.ratio;
	          resolve();
	        };
	        image.src = imageSrc;
	      });
	      return promise;
	    }
	  }, {
	    key: "setRatio",
	    value: function setRatio() {
	      var _this3 = this;
	
	      var promise = new _promise2.default(function (resolve) {
	        // TODO use cover url, but then switching between long lasting supplements needs to have the correct contentPackageId
	        var imageSrc = (0, _utils.generateCoverURL)(_this3.cpID, _this3.options.sizes.S, _this3.CPackagePages[0].PublicationPageID, _this3.cpVersion);
	        var image = new Image();
	        image.onload = function () {
	          _this3.ratio = image.height / image.width;
	          resolve();
	        };
	        image.onerror = function () {
	          _this3.ratio = _this3.options.ratio;
	          resolve();
	        };
	        image.src = imageSrc;
	      });
	      return promise;
	    }
	  }, {
	    key: "reloadPub",
	    value: function reloadPub(publicationId, contentPackageId, version) {
	      if (contentPackageId) this.cpID = contentPackageId;
	      if (publicationId) this.pubId = publicationId;
	      if (version) this.cpVersion = version;
	
	      this.setContentPackagePublication();
	      this.loadPub();
	    }
	  }, {
	    key: "extractUniqueCategories",
	    value: function extractUniqueCategories() {
	      return this.CPackagePages.reduce(function (acc, page, index) {
	        var categories = acc.map(function (c) {
	          return c.name;
	        });
	
	        if (page.PageCategory !== "" && categories.indexOf(page.PageCategory) === -1) {
	          acc.push({
	            name: page.PageCategory,
	            page: index
	          });
	        }
	        return acc;
	      }, []);
	    }
	  }, {
	    key: "findPageByPageNumber",
	    value: function findPageByPageNumber(pageNumber) {
	      for (var i = 0, len = this.CPackagePages.length; i < len; i++) {
	        if (this.CPackagePages[i].PageNumber == pageNumber) {
	          return this.CPackagePages[i];
	        }
	      }
	    }
	
	    /**
	     * Returns object with current pages visible based on current page index
	     * @param  {Number} currentPageIndex current page index
	     * @return {Object} object with left and right page
	     */
	
	  }, {
	    key: "getCurrentPages",
	    value: function getCurrentPages() {
	      var currentPageIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (!this.CPackagePages) return;
	      var currentPage = this.CPackagePages[currentPageIndex];
	
	      if (!this.isCurrentPublicationReplica()) return currentPage;
	
	      var pages = {
	        left: null,
	        right: null
	      };
	      if (currentPage) {
	        switch (currentPage.PagePositionType) {
	          case _page.PAGE_POSITION_TYPE.FRONT:
	            pages.right = currentPage;
	            break;
	          case _page.PAGE_POSITION_TYPE.BACK:
	            if (this.CPackagePages[currentPageIndex - 1] && this.CPackagePages[currentPageIndex - 1].PagePositionType === "Left") {
	              pages.right = currentPage;
	              pages.left = this.CPackagePages[currentPageIndex - 1];
	            } else {
	              pages.left = currentPage;
	            }
	            break;
	          case _page.PAGE_POSITION_TYPE.LEFT:
	            pages.left = currentPage;
	            if (this._appState.isDoublePage) pages.right = this.CPackagePages[currentPageIndex + 1];
	            break;
	          default:
	            pages.right = currentPage;
	            if (this._appState.isDoublePage) pages.left = this.CPackagePages[currentPageIndex - 1];
	        }
	      }
	      return pages;
	    }
	  }, {
	    key: "getNewsPaper",
	    value: function getNewsPaper() {
	      return this.CPackage.ContentPackagePublication.filter(function (cp) {
	        return cp.PublicationType.toLowerCase() == "main" && cp.PublicationTitleFormat.toLowerCase() == "newspaper";
	      })[0];
	    }
	  }, {
	    key: "getNextgenPublication",
	    value: function getNextgenPublication() {
	      return this.CPackage.ContentPackagePublication.filter(function (cp) {
	        return cp.PublicationType.toLowerCase() === "main" && cp.PublicationTitleFormat.toLowerCase() === "tabletoptimized";
	      })[0];
	    }
	  }, {
	    key: "isCurrentPublicationReplica",
	    value: function isCurrentPublicationReplica() {
	      return this.PublicationToLoad.PublicationTitleFormat.toLowerCase() === "newspaper";
	    }
	  }, {
	    key: "setContentPackagePublication",
	    value: function setContentPackagePublication() {
	      var _this4 = this;
	
	      if (this.pubId) {
	        this.PublicationToLoad = this.CPackage.ContentPackagePublication.filter(function (cp) {
	          return cp.PublicationID == _this4.pubId;
	        })[0];
	      } else {
	        this.PublicationToLoad = this.getPublicationByType(this._appState.preferredViewer);
	        this.pubId = this.PublicationToLoad.PublicationID;
	      }
	      this._appState.isReplica = this.isCurrentPublicationReplica();
	    }
	  }, {
	    key: "createSlides",
	    value: function createSlides(singlePage) {
	      return (0, _utils.createSubArray)(this.CPackagePages, singlePage ? 1 : 2);
	    }
	
	    /**
	     * Loading pages from external reader application
	     * @param  {Array} pages Pages collection
	     */
	
	  }, {
	    key: "loadPagesFromReader",
	    value: function loadPagesFromReader(pages) {
	      this.CPackagePages = pages;
	      this._normalizeNextgen();
	      this.trigger("pubStore:pubLoaded");
	    }
	
	    /**
	     * Returns publication from content package by type
	     * @param  {String} type 'nextgen' or 'replica'
	     * @return {Object}      publication
	     */
	
	  }, {
	    key: "getPublicationByType",
	    value: function getPublicationByType(type) {
	      var publication = null;
	
	      if (type === "nextgen") {
	        publication = this.getNextgenPublication() || this.getNewsPaper();
	      } else {
	        publication = this.getNewsPaper() || this.getNextgenPublication();
	      }
	
	      if (!publication) throw new Error("Publication not found");
	
	      return publication;
	    }
	
	    /**
	     * Checks if current publication is main
	     * @return {Boolean}
	     */
	
	  }, {
	    key: "isCurrentPublicationMain",
	    value: function isCurrentPublicationMain() {
	      return this.PublicationToLoad.PublicationType.toLowerCase() === "main";
	    }
	
	    /**
	     * Checks if content package contains replica and nextgen
	     * @return {boolean}
	     */
	
	  }, {
	    key: "containsReplicaAndNextgen",
	    value: function containsReplicaAndNextgen() {
	      return this.CPackage.ContentPackagePublication.filter(function (cp) {
	        return cp.PublicationType === "Main";
	      }).length === 2;
	    }
	
	    ////////
	
	  }, {
	    key: "_loadReplicaPublication",
	    value: function _loadReplicaPublication() {
	      var _this5 = this;
	
	      var numberOfTries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	      var promises = [];
	      if (this._appState.newDownloaderFallbackMode) {
	        promises.push(this.contentManager.getPublicationPages(this.cpID, this.pubId, this.cpVersion));
	        promises.push(this.contentManager.getPublicationPageContent(this.cpID, this.pubId, this.cpVersion));
	        promises.push(this.contentManager.getPublicationContentItems(this.cpID, this.pubId, this.cpVersion));
	        promises.push(this.contentManager.getPublicationPageContentItems(this.cpID, this.pubId, this.cpVersion));
	      } else {
	        promises.push(this.contentManager.requestJson(this._appState.cdnAssetsDownloader.getJsonUrl("GetPublicationPages", this.pubId)));
	        promises.push(this.contentManager.requestJson(this._appState.cdnAssetsDownloader.getJsonUrl("GetPublicationPageContent", this.pubId)));
	        promises.push(this.contentManager.requestJson(this._appState.cdnAssetsDownloader.getJsonUrl("GetPublicationContentItems", this.pubId)));
	        promises.push(this.contentManager.requestJson(this._appState.cdnAssetsDownloader.getJsonUrl("GetPublicationPageContentItems", this.pubId)));
	      }
	      _promise2.default.all(promises).then(function (data) {
	        _this5.CPackagePages = data[0].Page.map(function (page) {
	          return (0, _extends3.default)({}, page, {
	            PageWidth: _this5.options.pageWidth,
	            PageHeight: _this5.options.pageHeight,
	            ActivePageArea: _this5.options.activePageArea,
	            content: data[1].PublicationPage.filter(function (pc) {
	              return pc.PublicationPageID == page.PublicationPageID;
	            }).map(function (pc) {
	              var _data$2$Content$filte = data[2].Content.filter(function (ci) {
	                return ci.ContentID == pc.ContentID;
	              })[0],
	                  ContentItem = _data$2$Content$filte.ContentItem,
	                  Category = _data$2$Content$filte.Category;
	
	
	              return (0, _extends3.default)({}, pc, {
	                defaultPercentageInView: Math.min(100, Math.max(1, Math.round(pc.Height * pc.Width * 100 / _this5.options.activePageArea))),
	                contentItem: ContentItem,
	                contentItemContent: _this5._getContent(ContentItem, data[3].PublicationPages.filter(function (pp) {
	                  return pp.ContentID == pc.ContentID;
	                })[0], _this5.options.dropCapIfFirstBold, Category)
	              });
	            })
	          });
	        });
	        _this5.setOriginalPageSize().then(function () {
	          _this5.setRatio().then(function () {
	            _this5.trigger("pubStore:pubLoaded");
	          });
	        });
	      }).catch(function (err) {
	        if (err === 403) {
	          if (numberOfTries < NUMBER_OF_RETRIES) {
	            _this5._appState.cdnAssetsDownloader.requestDownloadCredentials().then(function () {
	              _this5._loadReplicaPublication(numberOfTries + 1);
	            });
	          } else {
	            _this5._appState.newDownloaderFallbackMode = true;
	            _this5._loadReplicaPublication(numberOfTries + 1);
	          }
	        }
	      });
	    }
	  }, {
	    key: "_normalizeNextgen",
	    value: function _normalizeNextgen() {
	      this.CPackagePages.forEach(function (page) {
	        if (page.PublicationPageId) {
	          page.PublicationPageID = page.PublicationPageId;
	        }
	        if (page.PageNumber && !page.PageLabel) {
	          page.PageLabel = page.PageNumber;
	        }
	      });
	    }
	
	    /**
	     * For Nextgen - pages are loaded and parsed in nextgen application.
	     * Webapp only initialize Nextgen app and bridge between two apps
	     */
	
	  }, {
	    key: "_loadNextgenPublication",
	    value: function _loadNextgenPublication() {
	      if (!window.app) return; // nextgen is not loaded, we must wait
	
	      var packageDir = void 0;
	
	      if (true) {
	        packageDir = "../";
	      } else {
	        packageDir = "../reader/data/" + this.CPackage.ContentPackageID + "/";
	      }
	
	      window.app.init({
	        pub: this.PublicationToLoad.PublicationID,
	        packageId: this.CPackage.ContentPackageID,
	        appmode: this._appState.isDesktop ? "webappDesktop" : "webapp",
	        isPhone: !this._appState.isTablet && !this._appState.isDesktop,
	        packageDir: "" + packageDir,
	        prefetchPages: true,
	        articleId: this._appState.nextgenSharingArticle,
	        page: this._appState.currentPage
	      });
	    }
	  }, {
	    key: "_getContent",
	    value: function _getContent(contentItems, publicationPage, changeDropCap) {
	      var _this6 = this;
	
	      var category = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
	
	      var content = void 0;
	      return function () {
	        if (content) return content;
	        var _appState = _this6._appState,
	            sessionId = _appState.sessionId,
	            userId = _appState.userId,
	            downloadId = _appState.downloadId;
	
	        content = (0, _utils.getContent)(contentItems, publicationPage, changeDropCap, sessionId, userId, downloadId, category);
	        return content;
	      };
	    }
	  }, {
	    key: "_getReaderSessionData",
	    value: function _getReaderSessionData() {
	      var readerSessionCookie = _cookiemanager2.default.getCookie(_cookiemanager2.default.cookieKeys.READER_SESSION);
	      if (readerSessionCookie) {
	        return JSON.parse(readerSessionCookie);
	      }
	      return {};
	    }
	  }]);
	  return PubStore;
	}(_es6EventEmitter2.default);
	
	exports.default = PubStore;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _subscriptionmanagerfree = __webpack_require__(291);
	
	var _subscriptionmanagerfree2 = _interopRequireDefault(_subscriptionmanagerfree);
	
	var _subscriptionmanagersubscription = __webpack_require__(293);
	
	var _subscriptionmanagersubscription2 = _interopRequireDefault(_subscriptionmanagersubscription);
	
	var _subscriptionUtilities = __webpack_require__(55);
	
	var _paymentMethods = __webpack_require__(94);
	
	var _paymentMethods2 = _interopRequireDefault(_paymentMethods);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Contstructs the AuthenticatorAuthorisationController
	 */
	var AuthenticatorAuthorisationController = function (_Emitter) {
	  (0, _inherits3.default)(AuthenticatorAuthorisationController, _Emitter);
	
	  function AuthenticatorAuthorisationController(appState, sessionManager, cookieManager) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    (0, _classCallCheck3.default)(this, AuthenticatorAuthorisationController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AuthenticatorAuthorisationController.__proto__ || (0, _getPrototypeOf2.default)(AuthenticatorAuthorisationController)).call(this));
	
	    _this._appState = null;
	    _this._sessionManager = null;
	    _this._cookieManager = null;
	    _this._subscriptionManager = null;
	    _this._options = null;
	
	    _this._appState = appState;
	    _this._sessionManager = sessionManager;
	    _this._cookieManager = cookieManager;
	    _this._options = options;
	    _this._initialiseSubScriptionManager(options);
	    _this._initListeners();
	    return _this;
	  }
	
	  /**
	   * Returns the current authentication state
	   * @return {Boolean}
	   */
	
	
	  (0, _createClass3.default)(AuthenticatorAuthorisationController, [{
	    key: "logOut",
	    value: function logOut() {
	      return this._subscriptionManager.logOut();
	    }
	  }, {
	    key: "authenticate",
	    value: function authenticate() {
	      var downloadToken = this._appState.downloadToken;
	
	      return this._subscriptionManager.authenticate(downloadToken);
	    }
	  }, {
	    key: "authenticateByUserNamePassword",
	    value: function authenticateByUserNamePassword(username, password) {
	      var downloadToken = this._appState.downloadToken;
	
	      return this._subscriptionManager.authenticateByUserNamePassword(username, password, downloadToken);
	    }
	  }, {
	    key: "_authorize",
	    value: function _authorize(publicationData, confirmDownload) {
	      var _this2 = this;
	
	      var downloadToken = this._appState.downloadToken;
	
	      this._appState.isFreePublication = publicationData && publicationData.price === 0;
	      //check reader session
	      if (!(0, _subscriptionUtilities.checkReaderSession)(publicationData, this._cookieManager, this._appState)) {
	        var params = {
	          sessionManager: this._sessionManager,
	          contentPackageId: publicationData.contentPackageId,
	          subsId: this._getSubscriptionId(),
	          orderId: 0,
	          confirmDownload: confirmDownload
	        };
	
	        if (this._appState.isFreePublication) {
	          // check if free publication
	          //make a request download call which will create reader session on success.
	          return (0, _subscriptionUtilities.requestDownload)((0, _extends3.default)({}, params, {
	            paymentMethod: _paymentMethods2.default.FREE
	          }));
	        } else if (this._appState.timeBasedUnlimitedAccessEnabled) {
	          return (0, _subscriptionUtilities.requestDownload)((0, _extends3.default)({}, params, {
	            paymentMethod: _paymentMethods2.default.TIME_BASED_UNLIMITED_ACCESS
	          })).then(function () {
	            return _promise2.default.resolve();
	          }).catch(function (e) {
	            if (e.data && e.data.StatusMessage == "E27") {
	              _this2._appState.timeBasedUnlimitedAccessEnabled = false;
	              return _this2._subscriptionManager.authorize(publicationData, downloadToken, confirmDownload);
	            } else {
	              return _promise2.default.reject(e);
	            }
	          });
	        }
	
	        return this._subscriptionManager.authorize(publicationData, downloadToken, confirmDownload);
	      }
	      this.checkAuthentication();
	      return _promise2.default.resolve();
	    }
	  }, {
	    key: "checkAuthentication",
	    value: function checkAuthentication() {
	      //check for subscriptionCookie:
	      var cookie = this._cookieManager.getCookie(this._cookieManager.cookieKeys.LOGIN);
	      if (cookie) {
	        this._subscriptionManager._setLoginInformationFromCookie();
	        this._subscriptionManager._authenticated = true;
	        this._appState.triggerEvent(_analyticsevents.AUTHORIZED);
	        this._onAuthenticationStatusChanged();
	      }
	    }
	  }, {
	    key: "authorize",
	    value: function authorize(publicationData, confirmDownload) {
	      var _this3 = this;
	
	      return this._authorize(publicationData, confirmDownload).then(function () {
	        _this3._appState.saveReaderSessionCookie();
	        return _promise2.default.resolve();
	      });
	    }
	  }, {
	    key: "authorizePage",
	    value: function authorizePage(_ref) {
	      var contentPackageId = _ref.contentPackageId,
	          publicationId = _ref.publicationId,
	          pageId = _ref.pageId;
	
	      if (this._appState.isFreePublication || this._appState.timeBasedUnlimitedAccessEnabled) {
	        return _promise2.default.resolve();
	      }
	      return this._subscriptionManager.authorizePage(contentPackageId, publicationId, pageId);
	    }
	  }, {
	    key: "authorizeArticle",
	    value: function authorizeArticle(contentPackageId, publicationId, pageId, contentItemId) {
	      if (this._appState.isFreePublication || this._appState.timeBasedUnlimitedAccessEnabled) {
	        return _promise2.default.resolve();
	      }
	      return this._subscriptionManager.authorizeArticle(contentPackageId, publicationId, pageId, contentItemId);
	    }
	  }, {
	    key: "authorizeByUserNamePassword",
	    value: function authorizeByUserNamePassword(username, password, publicationData, confirmDownload) {
	      var _this4 = this;
	
	      var contentPackageId = publicationData.contentPackageId,
	          publicationId = publicationData.publicationId;
	
	
	      return this.authenticateByUserNamePassword(username, password).then(function () {
	        return _this4.authorize({ contentPackageId: contentPackageId, publicationId: publicationId }, confirmDownload);
	      }).then(function () {
	        return { contentPackageId: contentPackageId, publicationId: publicationId };
	      });
	    }
	
	    /////////
	
	  }, {
	    key: "_initListeners",
	    value: function _initListeners() {
	      this._subscriptionManager.on("subscriptionmanager:authenticationstatuschanged", this._onAuthenticationStatusChanged.bind(this));
	    }
	
	    /**
	     * Depending on options/managers instantiates right _subscriptionManager
	     * @param  {[String]} subscriptionType
	     */
	
	  }, {
	    key: "_initialiseSubScriptionManager",
	    value: function _initialiseSubScriptionManager(_ref2) {
	      var subscriptionType = _ref2.subscriptionOptions.subscriptionType;
	
	      switch (subscriptionType) {
	        case "free":
	          this._subscriptionManager = new _subscriptionmanagerfree2.default(this._appState, this._sessionManager, _apimanager2.default, this._cookieManager, this._options);
	          break;
	        case "subscription":
	          this._subscriptionManager = new _subscriptionmanagersubscription2.default(this._appState, this._sessionManager, _apimanager2.default, this._cookieManager, this._options);
	          break;
	        case "freemium":
	          //TODO
	          break;
	        case "metered":
	          //TODO
	          break;
	        default:
	      }
	    }
	  }, {
	    key: "_onAuthenticationStatusChanged",
	    value: function _onAuthenticationStatusChanged() {
	      this._appState.logedIn = this._subscriptionManager.isAuthenticated;
	    }
	  }, {
	    key: "_getSubscriptionId",
	    value: function _getSubscriptionId() {
	      var cookie = this._cookieManager.getCookie(this._cookieManager.cookieKeys.LOGIN);
	      if (cookie) {
	        try {
	          return JSON.parse(cookie).subsId;
	        } catch (error) {
	          return 0;
	        }
	      }
	      return 0;
	    }
	  }, {
	    key: "getSSOState",
	    value: function getSSOState() {
	      return this._subscriptionManager.getSSOState();
	    }
	  }, {
	    key: "createSSOStateCookie",
	    value: function createSSOStateCookie() {
	      var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return this._subscriptionManager.createSSOStateCookie(redirectUrl);
	    }
	  }, {
	    key: "removeSSOStateCookie",
	    value: function removeSSOStateCookie() {
	      this._subscriptionManager.removeSSOStateCookie();
	    }
	  }, {
	    key: "isAuthenticated",
	    get: function get() {
	      return this._subscriptionManager.isAuthenticated;
	    }
	  }]);
	  return AuthenticatorAuthorisationController;
	}(_es6EventEmitter2.default);
	
	exports.default = AuthenticatorAuthorisationController;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _subscriptionmanagerbase = __webpack_require__(56);
	
	var _subscriptionmanagerbase2 = _interopRequireDefault(_subscriptionmanagerbase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import {getPromospot} from './../../../common/utilities/apiRequest';
	
	// this class will implement al the necessary API communication
	// and cookie management to authenticate users and authorize
	// downloads. It does not implement any UI elements.
	var SubScriptionManagerFree = function (_SubScriptionManagerB) {
	  (0, _inherits3.default)(SubScriptionManagerFree, _SubScriptionManagerB);
	
	  function SubScriptionManagerFree() {
	    (0, _classCallCheck3.default)(this, SubScriptionManagerFree);
	    return (0, _possibleConstructorReturn3.default)(this, (SubScriptionManagerFree.__proto__ || (0, _getPrototypeOf2.default)(SubScriptionManagerFree)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SubScriptionManagerFree, [{
	    key: "authenticateByUserNamePassword",
	
	
	    // irrelevant for the SSO subscriptionmanager, will reject always
	    value: function authenticateByUserNamePassword() {
	      return _promise2.default.resolve(true);
	    }
	
	    // returns a promise that will either reject with an error code when authentication
	    // fails, either resolves to success. This is to be used in case of SSO, or
	    // to check if you are autenticated
	    // in any case it will also trigger the authenticationstatuschanged event if
	    // the current status changed.
	
	  }, {
	    key: "authenticate",
	    value: function authenticate() {
	      return _promise2.default.resolve(true);
	    }
	
	    /**
	     * As for free subscription we don't need authorization, it just returns
	     * resolved promise. Moreover, it creates reader sesssion cookie - this is needed
	     * for generating secure links -> see utils.generateSecurePreviewURL and
	     * utils.generateSecureImageURL
	     * @return {Promise}
	     */
	
	  }, {
	    key: "authorize",
	    value: function authorize() {
	      this._setReaderSession();
	      return _promise2.default.resolve(true);
	    }
	
	    // returns a promise that will either reject with an error code when authorization
	    // fails, either resolves to success. It will tagke as the assumption that
	    // the CP and Publication is authorized and only uses the pageId for freemium
	    // and metered model implementations
	
	  }, {
	    key: "authorizePage",
	    value: function authorizePage() {
	      return _promise2.default.resolve(true);
	    }
	  }, {
	    key: "authorizeArticle",
	    value: function authorizeArticle() {
	      return true;
	    }
	  }, {
	    key: "_setReaderSession",
	    value: function _setReaderSession() {
	      var _sessionManager$sessi = this._sessionManager.session.SessionInfo,
	          DownloadId = _sessionManager$sessi.DownloadId,
	          SessionId = _sessionManager$sessi.SessionId,
	          UserId = _sessionManager$sessi.UserId;
	
	      var info = {
	        userId: UserId,
	        sessionId: SessionId,
	        downloadId: DownloadId
	      };
	
	      this._cookieManager.createCookie(this._cookieManager.cookieKeys.READER_SESSION, (0, _stringify2.default)(info), {
	        path: "/"
	      });
	    }
	  }, {
	    key: "isAuthenticated",
	
	    // Returns the current authentication state.
	    get: function get() {
	      return true;
	    }
	  }]);
	  return SubScriptionManagerFree;
	}(_subscriptionmanagerbase2.default);
	
	exports.default = SubScriptionManagerFree;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _subscriptionmanagerbase = __webpack_require__(56);
	
	var _subscriptionmanagerbase2 = _interopRequireDefault(_subscriptionmanagerbase);
	
	var _utils = __webpack_require__(10);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this class will implement al the necessary API communication
	// and cookie management to authenticate users and authorize
	// downloads. It does not implement any UI elements.
	var SubScriptionManagerSSO = function (_SubScriptionManagerB) {
	  (0, _inherits3.default)(SubScriptionManagerSSO, _SubScriptionManagerB);
	
	  function SubScriptionManagerSSO() {
	    (0, _classCallCheck3.default)(this, SubScriptionManagerSSO);
	    return (0, _possibleConstructorReturn3.default)(this, (SubScriptionManagerSSO.__proto__ || (0, _getPrototypeOf2.default)(SubScriptionManagerSSO)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SubScriptionManagerSSO, [{
	    key: "authenticateByUserNamePassword",
	
	    // irrelevant for the SSO subscriptionmanager, will reject always
	    // eslint-disable-next-line
	    value: function authenticateByUserNamePassword(username, password) {
	      return _promise2.default.reject("not allowed in sso");
	    }
	
	    // returns a promise that will either reject with an error code when authentication
	    // fails, either resolves to success. This is to be used in case of SSO, or
	    // to check if you are autenticated
	    // in any case it will also trigger the authenticationstatuschanged event if
	    // the current status changed.
	
	  }, {
	    key: "authenticate",
	    value: function authenticate(downloadToken) {
	      var _this2 = this;
	
	      this.downloadToken = downloadToken;
	      var authenticationPromise = new _promise2.default(function (resolve, reject) {
	        var ssoToken = false;
	        var ssoState = false;
	        if (_this2._options.getSSOTokenFromUrl) {
	          ssoToken = _this2._getQueryVariable(_this2._options.urlSSOTokenParameter);
	          if (_this2._options.generateSSOState) {
	            ssoState = _this2._getQueryVariable("state");
	          }
	        }
	        if (!ssoToken) {
	          // check if there is an SSO cookie if the settings are SSO enabled,
	          var cookie = void 0;
	          var rawCookie = _this2._cookieManager.getCookie(_this2._options.SSOCookieName);
	          if (rawCookie) {
	            try {
	              cookie = JSON.parse(rawCookie);
	            } catch (e) {
	              _this2._removeSSOCookie();
	              ssoToken = rawCookie;
	            }
	          }
	
	          if (cookie && cookie.token) {
	            //always remove cookie
	            _this2._removeSSOCookie();
	            ssoToken = cookie.token;
	            if (typeof ssoToken == "number") {
	              ssoToken = ssoToken.toString();
	            }
	            if (cookie.hash) {
	              ssoToken = cookie.hash + "|" + ssoToken;
	            }
	          }
	        }
	        if (ssoToken) {
	          var stateExist = typeof ssoState == "string" ? true : false;
	          var isValidState = false;
	
	          if (stateExist && _this2._isStateValid()) {
	            if (ssoState === _this2.ssoState && ssoToken) {
	              isValidState = true;
	            }
	          }
	
	          if (!stateExist || isValidState) {
	            _this2._sessionManager.getSessionInfo().then(function (sessionId) {
	              var userId = _this2._sessionManager.userId;
	              var subsType = _this2._options.subscriptionOptions.subscriptionProvider;
	              _this2._apiManager.validateSubscriptionToken(userId, sessionId, ssoToken, downloadToken, subsType).then(function (data) {
	                if (data.Status.toLowerCase() === "success") {
	                  _this2._authenticatedSucces(data);
	                  _this2._appState.triggerEvent(_analyticsevents.AUTHENTICATED);
	                  resolve(data);
	                } else {
	                  _this2._removeSSOCookie(true);
	                  data.call = "validateSubscriptionToken";
	                  data.errorType = "authentication";
	                  reject((0, _utils.generateError)(data));
	                }
	              }).catch(function (error) {
	                // not valid SSO
	                //remove the sso cookie, since we where not able to aunthenticate with the sso cookie there is no need of keeping it
	                _this2._removeSSOCookie(true);
	                reject((0, _utils.createError)("VST-ERR", "ValidateSubscriptionToken failed", error));
	              }); // eslint-disable-next-line
	            }).catch(function () {
	              //no valid session
	              //remove the sso cookie, since we where not able to aunthenticate with the sso cookie there is no need of keeping it
	              _this2._removeSSOCookie(true);
	              reject("no valid session"); //TODO: right error code
	            });
	          }
	        } else {
	          //remove the sso cookie, since we where not able to aunthenticate with the sso cookie there is no need of keeping it
	          _this2._removeSSOCookie(true);
	          reject("no sso cookie"); //TODO: right error code
	        }
	      });
	      return authenticationPromise;
	    }
	  }, {
	    key: "_getQueryVariable",
	    value: function _getQueryVariable(variable) {
	      var urlQuery = window.location.search.substring(1);
	      var parameters = urlQuery.split("&");
	      for (var i = 0; i < parameters.length; i++) {
	        var pair = parameters[i].split("=");
	        if (pair[0] === variable) {
	          return pair[1];
	        }
	      }
	      return false;
	    }
	  }, {
	    key: "_removeSSOCookie",
	    value: function _removeSSOCookie() {
	      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (force || this._options.deleteSSOCookie) {
	        this._cookieManager.removeCookie(this._options.SSOCookieName, this._options.SSOCookieOptions);
	        this.removeSSOStateCookie(true);
	      }
	    }
	  }, {
	    key: "_authenticatedSucces",
	    value: function _authenticatedSucces(data) {
	      this._authenticated = true;
	      // store subscriptionCookie
	      this._createSubscriptionCookie(data.SubscriptionID, data.SubscriptionReference, data.SubscriptionUserReference, data.SubscriptionType);
	      this.trigger("subscriptionmanager:authenticationstatuschanged");
	      this.redirect();
	    }
	
	    // returns a promise that will either reject with an error code when authorization
	    // fails, either resolves to success. It will also execute the authentication
	    // if not yet authenticated. It will also potentially triger the
	    // authenticationstatuschanged event
	
	  }, {
	    key: "authorize",
	    value: function authorize() {
	      var _this3 = this;
	
	      var publicationData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        contentPackageId: -1,
	        publicationId: -1,
	        price: -1
	      };
	
	      var authorizationPromise = new _promise2.default(function (resolve, reject) {
	        if (publicationData.price !== 0) {
	          _this3.isFreePublication = false;
	          _this3.authenticate().then(function () {
	            // call Authorization methods and return the promises
	            resolve();
	          }).catch(function (error) {
	            // something went wrong reject it.
	            reject(error);
	          });
	        } else {
	          // 0 priced publications are always authorized
	          _this3.isFreePublication = true;
	          resolve();
	        }
	      });
	      return authorizationPromise;
	    }
	    //LUX Case
	
	  }, {
	    key: "setSSOState",
	    value: function setSSOState(redirectUrl) {
	      var stateCookieValue = this._cookieManager.getCookie(this._cookieManager.cookieKeys.SSO_STATE);
	      var date = new Date();
	      var minutes = 10;
	      date.setTime(date.getTime() + minutes * 60 * 1000);
	      if (!stateCookieValue) {
	        var ssoState = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + "-" + Date.now();
	        this._cookieManager.createCookie(this._cookieManager.cookieKeys.SSO_STATE, (0, _stringify2.default)({
	          state: ssoState,
	          redirectUrl: redirectUrl
	        }), {
	          expires: date,
	          path: "/",
	          useTime: true
	        });
	      } else {
	        /* To avoid always being redirected to the home even when we click on a publication we always update the url stored in the state cookie */
	        if (redirectUrl && redirectUrl != "") {
	          var cookieSSOState = JSON.parse(stateCookieValue).state;
	          this.removeSSOStateCookie(true);
	          this._cookieManager.createCookie(this._cookieManager.cookieKeys.SSO_STATE, (0, _stringify2.default)({
	            state: cookieSSOState,
	            redirectUrl: redirectUrl
	          }), {
	            expires: date,
	            path: "/",
	            useTime: true
	          });
	        }
	      }
	    }
	  }, {
	    key: "removeSSOStateCookie",
	    value: function removeSSOStateCookie() {
	      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var stateCookieValue = this._cookieManager.getCookie(this._cookieManager.cookieKeys.SSO_STATE);
	      if (stateCookieValue && force) {
	        this._cookieManager.removeCookie(this._cookieManager.cookieKeys.SSO_STATE, {
	          expires: -1,
	          path: "/"
	        });
	      }
	    }
	  }, {
	    key: "_isStateValid",
	    value: function _isStateValid() {
	      var stateTimestamp = this.ssoState.split("-")[1];
	      var stateTimeStampInSeconds = parseInt(Math.floor(stateTimestamp / 1000));
	      var stateTimeStampInMinutes = parseInt(Math.floor(stateTimeStampInSeconds / 60));
	
	      var now = parseInt(Math.floor(Date.now() / 1000));
	      var nowInMinutes = parseInt(Math.floor(now / 60));
	
	      if (nowInMinutes - stateTimeStampInMinutes > 10) {
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: "redirect",
	    value: function redirect() {
	      var stateCookieValue = this._cookieManager.getCookie(this._cookieManager.cookieKeys.SSO_STATE);
	      if (stateCookieValue) {
	        var redirectUrl = JSON.parse(stateCookieValue).redirectUrl;
	        if (redirectUrl && redirectUrl != null) {
	          this.removeSSOStateCookie(true);
	          window.location.href = decodeURIComponent(redirectUrl);
	        }
	      }
	    }
	  }, {
	    key: "isAuthenticated",
	
	    // Returns the current authentication state.
	    get: function get() {
	      return this._authenticated;
	    }
	  }, {
	    key: "ssoState",
	    get: function get() {
	      var stateCookieValue = this._cookieManager.getCookie(this._cookieManager.cookieKeys.SSO_STATE);
	      return JSON.parse(stateCookieValue).state;
	    }
	  }]);
	  return SubScriptionManagerSSO;
	}(_subscriptionmanagerbase2.default);
	
	exports.default = SubScriptionManagerSSO;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _subscriptionmanagerbase = __webpack_require__(56);
	
	var _subscriptionmanagerbase2 = _interopRequireDefault(_subscriptionmanagerbase);
	
	var _subscriptionmanagersso = __webpack_require__(292);
	
	var _subscriptionmanagersso2 = _interopRequireDefault(_subscriptionmanagersso);
	
	var _utils = __webpack_require__(10);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _paymentMethods = __webpack_require__(94);
	
	var _paymentMethods2 = _interopRequireDefault(_paymentMethods);
	
	var _subscriptionUtilities = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this class will implement al the necessary API communication
	// and cookie management to authenticate users and authorize
	// downloads. It does not implement any UI elements.
	var SubScriptionManagerSubscription = function (_SubScriptionManagerB) {
	  (0, _inherits3.default)(SubScriptionManagerSubscription, _SubScriptionManagerB);
	
	  function SubScriptionManagerSubscription() {
	    (0, _classCallCheck3.default)(this, SubScriptionManagerSubscription);
	    return (0, _possibleConstructorReturn3.default)(this, (SubScriptionManagerSubscription.__proto__ || (0, _getPrototypeOf2.default)(SubScriptionManagerSubscription)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SubScriptionManagerSubscription, [{
	    key: "authenticateByUserNamePassword",
	
	
	    // returns a promise that will either reject with an error code when authentication
	    // fails, either resolves to success
	    // in any case it will also trigger the authenticationstatuschanged event.
	    value: function authenticateByUserNamePassword(username, password) {
	      var _this2 = this;
	
	      var downloadToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	
	      var authenticationPromise = new _promise2.default(function (resolve, reject) {
	        // check if there is an SSO cookie if the settings are SSO enabled,
	        // else check for the subscription cookie.
	        _this2._sessionManager.getSessionInfo().then(function (sessionId) {
	          _this2._apiManager.validateSubscription(sessionId, downloadToken, username, password, _this2._options.subscriptionOptions.subscriptionProvider, "1.0.0.0", _this2._sessionManager.userId, _this2._options.subscriptionOptions.authenticationProvider).then(function (data) {
	            if (data.Status !== "Succes") {
	              _this2.removeAuthenticationCookies();
	              data.call = "validateSubscription";
	              data.errorType = "authentication";
	              var error = (0, _utils.generateError)(data);
	              reject(error);
	            } else {
	              data.username = username;
	              _this2._authenticatedSucces(data);
	              _this2._appState.triggerEvent(_analyticsevents.AUTHENTICATED);
	              resolve();
	            }
	          }).catch(function (data) {
	            reject((0, _utils.createError)("VS-ERR", "ValidateSubscription failed", data));
	          });
	        }).catch(function (data) {
	          _this2.removeAuthenticationCookies();
	          reject(data);
	        });
	      });
	      return authenticationPromise;
	    }
	  }, {
	    key: "_authenticatedSucces",
	    value: function _authenticatedSucces(data) {
	      this._authenticated = true;
	      // store subscriptionCookie
	      this._createSubscriptionCookie(data.SubscriptionID, data.SubscriptionReference, data.SubscriptionUserReference, data.SubscriptionType, data.username);
	      this.trigger("subscriptionmanager:authenticationstatuschanged");
	      if (this.sso) {
	        this.sso.redirect();
	      }
	    }
	
	    // returns a promise that will either reject with an error code when authentication
	    // fails, either resolves to success. This is to be used in case of SSO, or
	    // to check if you are autenticated
	    // in any case it will also trigger the authenticationstatuschanged event if
	    // the current status changed.
	    // returns subsID
	
	  }, {
	    key: "authenticate",
	    value: function authenticate(downloadToken) {
	      var _this3 = this;
	
	      var authenticationPromise = new _promise2.default(function (resolve, reject) {
	        // first check for new SSO cookie, using the SSOManager if options SSO enabled set
	        if (_this3._options.SSOEnabled) {
	          _this3.sso = new _subscriptionmanagersso2.default(_this3._appState, _this3._sessionManager, _this3._apiManager, _this3._cookieManager, _this3._options);
	          _this3.sso.authenticate(downloadToken).then(function (data) {
	            if (data.Status !== "success" || data.Status !== "Success") {
	              //TODO: type SSO
	              _this3._authenticateCookie(resolve, reject);
	            } else {
	              _this3._authenticatedSucces(data);
	              resolve();
	            } // eslint-disable-next-line
	          }).catch(function () {
	            //failed for some reason -> try normal way
	            _this3._authenticateCookie(resolve, reject);
	          });
	        } else {
	          // else check for subscription cookie
	          _this3._authenticateCookie(resolve, reject);
	        }
	      });
	      return authenticationPromise;
	    }
	  }, {
	    key: "_authenticateCookie",
	    value: function _authenticateCookie(resolve, reject) {
	      //check for subscriptionCookie:
	      var cookie = this._cookieManager.getCookie(this._cookieManager.cookieKeys.LOGIN);
	      if (cookie) {
	        this._setLoginInformationFromCookie();
	        //TODO: check if still good subscription? using hash
	        this._authenticated = true;
	        this.trigger("subscriptionmanager:authenticationstatuschanged");
	        resolve(JSON.parse(cookie).subsId);
	      } else {
	        this.removeAuthenticationCookies();
	        //no cookie  //TODO: show error?
	        reject();
	      }
	    }
	  }, {
	    key: "authorize",
	    value: function authorize() {
	      var publicationData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        contentPackageId: -1,
	        publicationId: -1,
	        price: -1
	      };
	
	      var _this4 = this;
	
	      var downloadToken = arguments[1];
	      var confirmDownload = arguments[2];
	
	      var promise = new _promise2.default(function (resolve, reject) {
	        _this4.authenticate(downloadToken).then(function (subsId) {
	          _this4._requestAuthorisation(publicationData, subsId, confirmDownload).then(function () {
	            _this4._appState.triggerEvent(_analyticsevents.AUTHORIZED);
	            resolve();
	          }).catch(function (error) {
	            reject(error);
	          });
	        }).catch(function (error) {
	          reject(error);
	        });
	      });
	      return promise;
	    }
	  }, {
	    key: "_requestAuthorisation",
	    value: function _requestAuthorisation(publicationData, subsId, confirmDownload) {
	      var _this5 = this;
	
	      if (publicationData && publicationData.contentPackageId) {
	        return this._sessionManager.getSessionInfo().then(function (sessionId) {
	          return _this5._apiManager.requestOrderPost(_this5._sessionManager.userId, sessionId, publicationData.contentPackageId, "1.0.0.0", _paymentMethods2.default.SUBSCRIPTION).then(function (data) {
	            if (typeof data.StatusMessage !== "string") {
	              var _error = (0, _utils.createError)("RO-SM", "RequestOrder without StatusMessage", data);
	              return _promise2.default.reject(_error);
	            } else if (data.Status !== "Succes") {
	              var _error2 = (0, _utils.createError)("RO-KO", "RequestOrder returned an error", data);
	              return _promise2.default.reject(_error2);
	            }
	            return (0, _subscriptionUtilities.requestDownload)({
	              sessionManager: _this5._sessionManager,
	              paymentMethod: _paymentMethods2.default.SUBSCRIPTION,
	              contentPackageId: publicationData.contentPackageId,
	              subsId: subsId,
	              orderId: data.OrderID,
	              confirmDownload: confirmDownload
	            });
	          }).catch(function (data) {
	            if (_this5._appState.isLoggedIn && data.data.errorType == "authentication") {
	              _this5.removeAuthenticationCookies();
	            }
	            return _promise2.default.reject(data);
	          });
	        }).catch(function (data) {
	          return _promise2.default.reject(data);
	        });
	      }
	      var error = (0, _utils.createError)("AUT-ERR", "no publicationData and contentPackageId", {});
	      return _promise2.default.reject(error);
	    }
	  }, {
	    key: "getSSOState",
	    value: function getSSOState() {
	      return this.sso.ssoState;
	    }
	  }, {
	    key: "createSSOStateCookie",
	    value: function createSSOStateCookie(redirectUrl) {
	      this.sso.setSSOState(redirectUrl);
	    }
	  }, {
	    key: "removeSSOStateCookie",
	    value: function removeSSOStateCookie() {
	      if (this.sso) {
	        this.sso.removeSSOStateCookie();
	      }
	    }
	  }, {
	    key: "isAuthenticated",
	
	    // Returns the current authentication state.
	    get: function get() {
	      // read subscrionCookie  //TODO: why read subscrionCookie? if there is a cookie this._authenticated is true?
	      return this._authenticated;
	    },
	    set: function set(authenticated) {
	      this._authenticated = authenticated;
	    }
	  }]);
	  return SubScriptionManagerSubscription;
	}(_subscriptionmanagerbase2.default);
	
	exports.default = SubScriptionManagerSubscription;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _utils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CREDENTIALS_TIMEOUT = 1000 * 3;
	var NUMBER_OF_RETRIES = 2;
	var DOWNLOAD_CREDENTIALS_EVENTS = {
	  SUCCESS: "download_credentails:success",
	  ERROR: "download_credentails:error"
	};
	
	var CDNAssetsDownloader = function (_Emitter) {
	  (0, _inherits3.default)(CDNAssetsDownloader, _Emitter);
	
	  function CDNAssetsDownloader(apiManager, appState, sessionManager) {
	    (0, _classCallCheck3.default)(this, CDNAssetsDownloader);
	
	    // you don’t need the whole appState,
	    // if this class is kept in the appState it is better that you just pass the userId, sessionId and downloadId
	    // if one of these 3 changes you have to pass it again to make sure you have the latest version (and do a new getDownloadCredentials call)
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CDNAssetsDownloader.__proto__ || (0, _getPrototypeOf2.default)(CDNAssetsDownloader)).call(this));
	
	    _this.credentials = null;
	    _this._requestPreviewDownloadCounter = 0;
	    _this._requestImgDownloadCounter = 0;
	    _this._requestDownloadLimit = 1000;
	    _this._downloadCredentialsTimeLimit = 60 * 5;
	    _this._downloadCredentialsLimit = 3;
	    _this._eventEmitter = new _es6EventEmitter2.default();
	    _this.apiManager = apiManager;
	    _this._appState = appState;
	    _this._sessionManager = sessionManager;
	    return _this;
	  }
	
	  (0, _createClass3.default)(CDNAssetsDownloader, [{
	    key: "_getPreviewUrl",
	    value: function _getPreviewUrl(size, pageId) {
	      if (this.credentials && this.credentials.PreviewPattern) {
	        var a = this.credentials.PreviewPattern.split("%PUBPAGE_ID%").join("" + pageId);
	        a = a.split("%SIZENAME%").join("" + size);
	        return a;
	      }
	    }
	  }, {
	    key: "getPdfUrl",
	    value: function getPdfUrl(pageId) {
	      if (this.credentials && this.credentials.PdfPattern) {
	        return this.credentials.PdfPattern.split("%PUBPAGE_ID%").join("" + pageId);
	      }
	    }
	  }, {
	    key: "getJsonUrl",
	    value: function getJsonUrl(name, pubId) {
	      if (this.credentials && this.credentials.JsonPattern) {
	        return this.credentials.JsonPattern.split("%JSON_NAME%").join(name + "-" + pubId);
	      }
	    }
	  }, {
	    key: "_getImageUrl",
	    value: function _getImageUrl(size, imageId) {
	      if (this.credentials && this.credentials.ImagePattern) {
	        var a = this.credentials.ImagePattern.split("%IMAGE_ID%").join("" + imageId);
	        a = a.split("%SIZENAME%").join("" + size);
	        return a;
	      }
	    }
	
	    /**
	     * Request credentials
	     * We will only generate new credentials when not in fallback mode and when no request is already ongoing
	     */
	
	  }, {
	    key: "requestDownloadCredentials",
	    value: function requestDownloadCredentials() {
	      var _this2 = this;
	
	      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this._appState.newDownloaderFallbackMode) {
	        return _promise2.default.resolve();
	      }
	      if (!this._appState.isReaderSessionCookieValid()) {
	        this._appState.replaceReaderSessionCookie();
	        this._requestDownloadPromiseInProgress = false;
	      }
	      if (!this._requestDownloadPromiseInProgress || force) {
	        this._requestDownloadPromiseInProgress = true;
	        return new _promise2.default(function (resolve, reject) {
	          _this2._getDownloadCredentials().then(function () {
	            _this2._eventEmitter.trigger(DOWNLOAD_CREDENTIALS_EVENTS.SUCCESS);
	            setTimeout(function () {
	              _this2._requestDownloadPromiseInProgress = false;
	              _this2._eventEmitter.trigger(DOWNLOAD_CREDENTIALS_EVENTS.SUCCESS);
	            }, CREDENTIALS_TIMEOUT);
	            resolve("resolved");
	          }).catch(function (error) {
	            _this2._requestDownloadPromiseInProgress = false;
	            _this2._eventEmitter.trigger(DOWNLOAD_CREDENTIALS_EVENTS.ERROR);
	            reject(error);
	          });
	        });
	      } else {
	        return new _promise2.default(function (resolve, reject) {
	          _this2._eventEmitter.on(DOWNLOAD_CREDENTIALS_EVENTS.SUCCESS, resolve);
	          _this2._eventEmitter.on(DOWNLOAD_CREDENTIALS_EVENTS.ERROR, reject);
	        });
	      }
	    }
	
	    /**
	     * requests credentials to the api if there is a valid downloadId available
	     */
	
	  }, {
	    key: "_getDownloadCredentials",
	    value: function _getDownloadCredentials() {
	      var _this3 = this;
	
	      var downloadId = this._appState.downloadId;
	      if (downloadId) {
	        return this.apiManager.getDownloadCredentials(this._appState.userId, this._appState.sessionId, downloadId).then(function (resp) {
	          if (resp && resp.status === 200) {
	            return resp.json().then(function (result) {
	              _this3.credentials = result;
	              return _this3.credentials;
	            });
	          } else {
	            return _promise2.default.reject();
	          }
	        });
	      } else {
	        // the downloadId is 0 when reading using social sharing
	        this._appState.newDownloaderFallbackMode = true;
	        return _promise2.default.resolve();
	      }
	    }
	
	    /**
	     * Loads a preview image as background on the given element
	     */
	
	  }, {
	    key: "loadBackgroundPreviewOnElement",
	    value: function loadBackgroundPreviewOnElement(sizes, publicationPageId, element) {
	      if (element) {
	        return this.loadPreview(sizes, publicationPageId, true).then(function (src) {
	          element.style.backgroundImage = "url(" + src + ")";
	          var imgAttribute = element.getAttribute("data-img");
	          if (imgAttribute === "") {
	            element.setAttribute("data-img", src);
	          }
	        });
	      }
	      return _promise2.default.reject();
	    }
	
	    /**
	     * Loads a preview image
	     * Returns either the image html element where the preview is loaded or the url that loads the image
	     */
	
	  }, {
	    key: "loadPreview",
	    value: function loadPreview(sizes, publicationPageId) {
	      var _this4 = this;
	
	      var returnUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var numberOfTries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	      var imageSrc = this._appState.newDownloaderFallbackMode ? (0, _utils.generateSecurePreviewURL)(sizes.nonNamedSize, publicationPageId, this._sessionManager.session.SessionInfo.SessionId, this._sessionManager.userId, this._appState.downloadId) : this._getPreviewUrl(sizes.namedSize, publicationPageId);
	      return this._loadUrlOnImageElement(imageSrc, numberOfTries <= NUMBER_OF_RETRIES && !this._appState.newDownloaderFallbackMode).then(function (image) {
	        return returnUrl ? imageSrc : image;
	      }).catch(function (error) {
	        if (error.status && error.status === 403) {
	          if (numberOfTries >= NUMBER_OF_RETRIES) {
	            _this4._appState.newDownloaderFallbackMode = true;
	            return _this4.loadPreview(sizes, publicationPageId, returnUrl, numberOfTries + 1);
	          } else {
	            return _this4.requestDownloadCredentials().then(function () {
	              return _this4.loadPreview(sizes, publicationPageId, returnUrl, numberOfTries + 1);
	            });
	          }
	        }
	        return _promise2.default.reject();
	      });
	    }
	
	    /**
	     * Loads an image onto an element
	     * This can be as an image or as a background image
	     * can return the ratio if needed
	     */
	
	  }, {
	    key: "loadImageOnElement",
	    value: function loadImageOnElement(sizes, contentItemId, element, getRatio, backgroundImage) {
	      if (element) {
	        return this._loadImage(sizes, contentItemId, backgroundImage ? undefined : element).then(function (src) {
	          if (backgroundImage) {
	            element.style.backgroundImage = "url(" + src + ")";
	          }
	          if (getRatio) {
	            return new _promise2.default(function (resolve) {
	              var image = new Image();
	              image.onload = function () {
	                resolve(image.height / image.width);
	              };
	              image.src = src;
	            });
	          }
	          return _promise2.default.resolve();
	        });
	      }
	      return _promise2.default.reject();
	    }
	
	    /**
	     * Loads an image onto a certain element if provided
	     */
	
	  }, {
	    key: "_loadImage",
	    value: function _loadImage(sizes, contentItemId, element) {
	      var _this5 = this;
	
	      var numberOfTries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	      var imageSrc = this._appState.newDownloaderFallbackMode ? (0, _utils.generateSecureImageURL)(sizes.nonNamedSize, contentItemId, this._sessionManager.session.SessionInfo.SessionId, this._sessionManager.userId, this._appState.downloadId) : this._getImageUrl(sizes.namedSize, contentItemId);
	      return this._loadUrlOnImageElement(imageSrc, numberOfTries <= NUMBER_OF_RETRIES && !this._appState.newDownloaderFallbackMode, element).then(function () {
	        return imageSrc;
	      }).catch(function (error) {
	        if (error.status && error.status === 403) {
	          if (numberOfTries >= NUMBER_OF_RETRIES) {
	            _this5._appState.newDownloaderFallbackMode = true;
	            return _this5._loadImage(sizes, contentItemId, element, numberOfTries + 1);
	          } else {
	            return _this5.requestDownloadCredentials().then(function () {
	              return _this5._loadImage(sizes, contentItemId, element, numberOfTries + 1);
	            });
	          }
	        }
	        return _promise2.default.reject();
	      });
	    }
	
	    /**
	     * Loads a url on an image element if passed, else it will generate a new one
	     * If getStatusCode is true then it will return the status code if a failure occurs
	     * @param {*} url
	     * @param {*} getStatusCode
	     */
	
	  }, {
	    key: "_loadUrlOnImageElement",
	    value: function _loadUrlOnImageElement(url, getStatusCode) {
	      var image = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      return new _promise2.default(function (resolve, reject) {
	        var img = image ? $(image) : $("<img />");
	        // remove previous event listeners in case of continues retries
	        img.off("load");
	        img.off("error");
	
	        // get CORS headers in response
	        img.crossOrigin = "Anonymous";
	
	        img.on("load", function () {
	          resolve(img);
	        });
	        img.on("error", function (err) {
	          if (getStatusCode) {
	            fetch(url).then(function (resp) {
	              if (resp.status === 200) {
	                resolve(img);
	              } else {
	                reject(resp);
	              }
	            });
	          } else {
	            reject(err);
	          }
	        });
	        img.attr("src", url);
	      });
	    }
	  }]);
	  return CDNAssetsDownloader;
	}(_es6EventEmitter2.default);
	
	exports.default = CDNAssetsDownloader;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appName = undefined;
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.getRequest = getRequest;
	exports.postRequest = postRequest;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appName = exports.appName = "webApp";
	
	function getRequest(url) {
	  return fetch(url).then(function (resp) {
	    return resp.json();
	  });
	}
	
	function postRequest(url, params) {
	  return fetch(url, {
	    headers: {
	      Accept: "application/json",
	      "Content-Type": "application/json"
	    },
	    method: "POST",
	    body: (0, _stringify2.default)(params)
	  }).then(function (resp) {
	    return resp.json();
	  });
	}

/***/ },
/* 296 */
/***/ function(module, exports) {

	"use strict";
	
	// Returns the ISO week of the date.
	Date.prototype.getWeek = function () {
	  var date = new Date(this.getTime());
	  date.setHours(0, 0, 0, 0);
	  // Thursday in current week decides the year.
	  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
	  // January 4 is always in week 1.
	  var week1 = new Date(date.getFullYear(), 0, 4);
	  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
	  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
	};
	
	// Returns the four-digit year corresponding to the ISO week of the date.
	Date.prototype.getWeekYear = function () {
	  var date = new Date(this.getTime());
	  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
	  return date.getFullYear();
	};

/***/ },
/* 297 */,
/* 298 */,
/* 299 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = applyGlobalCssStyling;
	/**
	 * We need some global css classes on html element for
	 * global styling change based on params in the URL
	 */
	function applyGlobalCssStyling() {
	  showRect();
	  hideTopbar();
	}
	
	////////
	
	/**
	 * Applies colour to replica articles layers to make them visible
	 */
	function showRect() {
	  if (window.location.search.indexOf("showrects") !== -1) {
	    document.documentElement.classList.add("show-rect");
	  }
	}
	
	/**
	 * Hides top bar
	 */
	function hideTopbar() {
	  if (window.location.search.indexOf("hidetopbar") !== -1) {
	    document.documentElement.classList.add("hide-topbar");
	  }
	}

/***/ },
/* 300 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleCrossOriginMessage;
	/**
	 * handle incomming messages
	 * Method is triggered when Iframe sends message to set height
	 */
	function handleCrossOriginMessage(e) {
	  var el = null;
	  var targetHeight = e.data.height;
	  if (e.data.action === "RESIZE_IFRAME_LOGIN") {
	    el = $("#abo-banner-iframe");
	  } else if (e.data.action === "RESIZE_IFRAME_TOP") {
	    el = $("#tw_iframe_top");
	  } else if (e.data.action === "RESIZE_IFRAME_ARCHIVE") {
	    el = $("#iframeArchive");
	  } else if (e.data.action === "RESIZE_IFRAME_BOTTOM") {
	    el = $("#tw_iframe_bottom");
	  } else if (e.data.action === "RESIZE_IFRAME_ARCHIVE_BOTTOM") {
	    el = $("#iframeArchiveBottom");
	  }
	
	  if (el !== null) {
	    // if (targetHeight > 10) // only add extra spacing if there is sufficient height with content
	    // targetHeight = targetHeight + 50;
	    el.height(targetHeight);
	  }
	}

/***/ },
/* 301 */,
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _utils = __webpack_require__(10);
	
	var _enums = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this class provides the functionality to:
	// - Create and managae the UUID
	// - perform an opensession call and keep track of the SessionManager
	// The constructor will make sures there is a UUID, and start the session request
	// call async
	var SessionManager = function () {
	  (0, _createClass3.default)(SessionManager, [{
	    key: "UUID",
	
	
	    // retrieve the UUID
	    get: function get() {
	      return this.userInfo.UUID;
	    }
	  }, {
	    key: "userId",
	    get: function get() {
	      return this.userInfo ? this.userInfo.userId : 0;
	    }
	  }]);
	
	  function SessionManager(apiManager, cookieManager, options) {
	    (0, _classCallCheck3.default)(this, SessionManager);
	    this.userInfo = null;
	    this.session = null;
	    this.version = "1.0.0";
	    this.enabledFeatures = null;
	    this.getSessionPromiseResolve = null;
	    this.getSessionPromiseReject = null;
	    this._apiManager = null;
	    this._cookieManager = null;
	
	    this._apiManager = apiManager;
	    this._cookieManager = cookieManager;
	    this._options = options;
	    // check if there is a cookie
	    this.userInfo = this._cookieManager.getCookie(this._cookieManager.cookieKeys.UUID);
	    if (!this.userInfo) {
	      // try backward compatibility cookie
	      this.userInfo = this._cookieManager.getCookie(this._cookieManager.cookieKeys.UUIDV1);
	      if (!this.userInfo) {
	        // create a uuid and store it in userinfo
	        this.userInfo = {
	          UUID: createUUID(),
	          userId: 0
	        };
	      } else if (this.userInfo.indexOf("UUID") === -1) {
	        // for backward compatibility we accept the fact that it might containing
	        // only a string and not an object
	        this.userInfo = {
	          UUID: this.userInfo,
	          userId: 0
	        };
	      } else {
	        // parse out the object from the string
	        this.userInfo = JSON.parse(this.userInfo);
	      }
	      // store the cookie with the latest info
	      this._cookieManager.createCookie(this._cookieManager.cookieKeys.UUID, (0, _stringify2.default)(this.userInfo));
	    } else {
	      // parse out the object from the string
	      this.userInfo = JSON.parse(this.userInfo);
	    }
	    // triger the getsession, it is always needed in any case, so it might be
	    // that the next getSessionInfo call is succesfull immediately.
	    this.getSessionInfo();
	  }
	
	  // returns a promises that can be used to chain the data, it returns the SessionId
	  // but the full data can be retrieved in the sessionmanager later
	  // in case the sessionmanager allready contains a session, it will
	  // not triger again, unless you provide the force parameter
	  // probably need to check if the session got expired or not would be better
	
	
	  (0, _createClass3.default)(SessionManager, [{
	    key: "getSessionInfo",
	    value: function getSessionInfo() {
	      var _this = this;
	
	      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.getSessionPromise) {
	        return this.getSessionPromise;
	      }
	      this.getSessionPromise = new _promise2.default(function (resolve, reject) {
	        _this.getSessionPromiseReject = reject;
	        _this.getSessionPromiseResolve = resolve;
	        if (!force && _this.session != null) {
	          _this.getSessionPromiseResolve(_this.session.SessionInfo.SessionId);
	        } else {
	          _this._apiManager.openSession(_this.version, _this.userId, "1.0.0", _this.UUID).then(function (session) {
	            if (typeof session.ReturnCode === "string" && session.ReturnCode.toLowerCase() === "error") {
	              _this.getSessionPromiseReject((0, _utils.createError)("OS-KO", "OpenSession returned an error", session.ReturnCode));
	            } else if (!session.SessionInfo) {
	              _this.getSessionPromiseReject((0, _utils.createError)("OS-SI", "OpenSession returned without SessionInfo", null));
	            } else {
	              _this.session = session;
	              _this.userInfo.userId = _this.session.SessionInfo.UserId;
	              _this._cookieManager.createCookie(_this._cookieManager.cookieKeys.UUID, (0, _stringify2.default)(_this.userInfo));
	
	              if (_this.session.UserData.UserProfiles) {
	                var enabledFeature = _this.session.UserData.UserProfiles.filter(function (userProfile) {
	                  return userProfile.Key == _enums.EUserProfileValues.ENABLED_FEATURES;
	                });
	                if (enabledFeature && enabledFeature[0]) {
	                  try {
	                    _this.enabledFeatures = JSON.parse(enabledFeature[0].Value);
	                  } catch (e) {
	                    _this.enabledFeatures = null;
	                  }
	                }
	              }
	
	              _this.getSessionPromiseResolve(_this.session.SessionInfo.SessionId);
	            }
	          }).catch(function (error) {
	            _this.getSessionPromiseReject((0, _utils.createError)("OS-ERR", "OpenSession failed", error));
	          });
	        }
	      });
	      return this.getSessionPromise;
	    }
	  }, {
	    key: "isFeatureEnabled",
	    value: function isFeatureEnabled(feature) {
	      //check if the feature is in the list of featured that should be enabled via the backend
	      if (this._options.featuresToBeEnabledByBE.indexOf(feature) >= 0) {
	        //check if the feature is returned by the backend
	        if (this.enabledFeatures && this.enabledFeatures[feature] != undefined) {
	          //return the feature value from the backend
	          return this.enabledFeatures[feature];
	        } else {
	          //In case the client support this feature, if the feature is not defined in the backend, the default behavior should be to disable the feature.
	          return false;
	        }
	      }
	      //by default the feature is enabled
	      return true;
	    }
	  }]);
	  return SessionManager;
	}();
	
	///////////////
	// internal functions, not exported, global to this module
	/////////////
	/* eslint-disable */
	
	exports.default = SessionManager;
	function createUUID() {
	  // Generate new guId
	  var guId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0,
	        v = c == "x" ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	  return guId;
	}

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Contstructs the Resizer
	 */
	var Resizer = function (_Emitter) {
	  (0, _inherits3.default)(Resizer, _Emitter);
	
	  function Resizer(DOMContainer, classNames) {
	    (0, _classCallCheck3.default)(this, Resizer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Resizer.__proto__ || (0, _getPrototypeOf2.default)(Resizer)).call(this));
	
	    _this.DOMContainer = null;
	    _this.body = null;
	    _this.oldAppHeight = null;
	    _this.oldAppWidth = window.innerWidth;
	    _this.portrait = window.innerWidth < window.innerHeight;
	    _this.classNames = [];
	
	    _this.onResize = function () {
	      _this.startAppHeight();
	    };
	
	    _this.onFocus = function () {
	      // console.log('focus');
	      _this.startAppHeight();
	    };
	
	    _this.onBlur = function () {
	      // console.log('blur');
	    };
	
	    _this.DOMContainer = DOMContainer;
	    _this.classNames = classNames;
	    _this.body = document.querySelector("body");
	    //css normalize not yet done
	    _this.body.setAttribute("style", "margin:0;");
	    _this.setAppHeight();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Resizer, [{
	    key: "afterScroll",
	    value: function afterScroll(scroll) {
	      var rect = this.DOMContainer.getBoundingClientRect();
	      var height = rect.height;
	      var newHeight = height - scroll;
	      newHeight = Math.min(newHeight, window.innerHeight);
	      this.DOMContainer.setAttribute("style", "height:" + newHeight + "px;");
	      this.body.scrollIntoView();
	      this.checkNewHeight(newHeight);
	      this.initListeners();
	    }
	  }, {
	    key: "checkScroll",
	    value: function checkScroll() {
	      var _this2 = this;
	
	      var scroll = $(this.body).scrollTop();
	      //TODO: sometimes when comig back from 2 tabs it is still old scroll
	      if (scroll === 1000) {
	        var checkScrollEvt = void 0;
	        clearTimeout(checkScrollEvt);
	        checkScrollEvt = setTimeout(function () {
	          _this2.checkScroll();
	        }, 100);
	      } else {
	        this.afterScroll(scroll);
	      }
	    }
	  }, {
	    key: "checkNewHeight",
	    value: function checkNewHeight(newHeight) {
	      if (newHeight !== this.oldAppHeight) {
	        if (this.oldAppHeight) {
	          this.oldAppHeight = newHeight;
	          this.portrait = window.innerWidth < window.innerHeight;
	          this.trigger("resizer:heightChanged");
	          if (this.oldAppWidth !== window.innerWidth) {
	            this.oldAppWidth = window.innerWidth;
	            this.trigger("resizer:rotated");
	          }
	        } else {
	          this.oldAppHeight = newHeight;
	        }
	      }
	    }
	  }, {
	    key: "setAppHeight",
	    value: function setAppHeight() {
	      var newHeight = window.innerHeight;
	      //start with full app height
	      this.DOMContainer.setAttribute("style", "height:" + newHeight + "px");
	      //android this is oke? //TODO: device lies checked
	
	      //ios?
	      //tag 100 oke (9.3.5) iphone 6
	      if (this.classNames.indexOf("TODO") >= 0) {
	        $(this.body).scrollTop(1000);
	        this.checkScroll(); //FIX for tablets open? //TODO: check
	      } else {
	        this.checkNewHeight(newHeight);
	        $(this.body).scrollTop(0);
	        this.initListeners();
	      }
	    }
	  }, {
	    key: "startAppHeight",
	    value: function startAppHeight() {
	      var _this3 = this;
	
	      this.removeListeners();
	      //wait untill resizing is really done
	      var event = void 0;
	      clearTimeout(event);
	      event = setTimeout(function () {
	        _this3.setAppHeight();
	      }, 200);
	    }
	  }, {
	    key: "initListeners",
	    value: function initListeners() {
	      this.initResizeListener();
	      this.initFocusListener();
	      this.initBlurListener();
	    }
	  }, {
	    key: "removeListeners",
	    value: function removeListeners() {
	      this.removeResizeListener();
	      this.removeFocusListener();
	      this.removeBlurListener();
	    }
	  }, {
	    key: "initResizeListener",
	    value: function initResizeListener() {
	      $(window).on("resize", this.onResize);
	    }
	  }, {
	    key: "removeResizeListener",
	    value: function removeResizeListener() {
	      $(window).off("resize", this.onResize);
	    }
	  }, {
	    key: "initFocusListener",
	    value: function initFocusListener() {
	      $(window).on("focus", this.onFocus);
	    }
	  }, {
	    key: "removeFocusListener",
	    value: function removeFocusListener() {
	      $(window).off("focus", this.onFocus);
	    }
	  }, {
	    key: "initBlurListener",
	    value: function initBlurListener() {
	      $(window).on("blur", this.onBlur);
	    }
	  }, {
	    key: "removeBlurListener",
	    value: function removeBlurListener() {
	      $(window).off("blur", this.onBlur);
	    }
	  }]);
	  return Resizer;
	}(_es6EventEmitter2.default);
	
	exports.default = Resizer;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _hammerSlide = __webpack_require__(241);
	
	var _hammerSlide2 = _interopRequireDefault(_hammerSlide);
	
	var _imageGallerySlide = __webpack_require__(91);
	
	var _imageGallerySlide2 = _interopRequireDefault(_imageGallerySlide);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGallerySlideMobile = function (_ImageGallerySlide) {
	  (0, _inherits3.default)(ImageGallerySlideMobile, _ImageGallerySlide);
	
	  function ImageGallerySlideMobile() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ImageGallerySlideMobile);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImageGallerySlideMobile.__proto__ || (0, _getPrototypeOf2.default)(ImageGallerySlideMobile)).call.apply(_ref, [this].concat(args))), _this), _this.hammerSlide = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ImageGallerySlideMobile, [{
	    key: "isZoomed",
	    value: function isZoomed() {
	      if (!this.hammerSlide) {
	        return false;
	      }
	      return this.hammerSlide.isZoomed();
	    }
	  }, {
	    key: "allowSwiping",
	    value: function allowSwiping(e) {
	      return this.hammerSlide.allowSwiping(e);
	    }
	  }, {
	    key: "panning",
	    value: function panning(e) {
	      this.hammerSlide.panning(e);
	    }
	  }, {
	    key: "panningEnd",
	    value: function panningEnd(e) {
	      this.hammerSlide.panningEnd(e);
	    }
	  }, {
	    key: "onPinch",
	    value: function onPinch(e) {
	      this.hammerSlide.onPinch(e);
	    }
	  }, {
	    key: "onPinchEnd",
	    value: function onPinchEnd(e) {
	      this.hammerSlide.onPinchEnd(e);
	    }
	  }, {
	    key: "onPinchStart",
	    value: function onPinchStart(e) {
	      this.hammerSlide.onPinchStart(e);
	    }
	  }, {
	    key: "initHammerSlide",
	    value: function initHammerSlide(ratio) {
	      this.ratio = ratio;
	      this.createHammerSlide(false);
	    }
	  }, {
	    key: "setUrl",
	    value: function setUrl(container) {
	      if (container) {
	        container.setAttribute("src", container.dataset.img);
	      }
	    }
	
	    //call only after image is loaded
	
	  }, {
	    key: "createHammerSlide",
	    value: function createHammerSlide(isResized) {
	      var _this2 = this;
	
	      if (!this.hammerSlide && (!this.takeResized || isResized)) {
	        var options = this.options.hammerslide;
	        this.hammerSlide = new _hammerSlide2.default(this.DOMContainer, this.DOMContainer.querySelector(".slide-imageviewer-container"), false, options, this.ratio);
	        this.hammerSlide.on("hammerSlide:notZoomed", function () {
	          _this2.notZoomed();
	        });
	        this.hammerSlide.on("hammerSlide:zoomed", function () {
	          _this2.zoomed();
	        });
	        this.hammerSlide.on("hammerSlide:zoominend", function () {
	          _this2.appState.triggerEvent(_analyticsevents.ZOOM_IN_IMAGE_GALLERY);
	        });
	        this.hammerSlide.on("hammerSlide:zoomoutend", function () {
	          _this2.appState.triggerEvent(_analyticsevents.ZOOM_OUT_IMAGE_GALLERY);
	        });
	        this.hammerSlide.on("hammerSlide:panend", function () {
	          _this2.appState.triggerEvent(_analyticsevents.PAN_ZOOMEDINIMAGE_GALLERY);
	        });
	        this.hammerSlide.init();
	      }
	    }
	  }, {
	    key: "resize",
	    value: function resize(height, keepScale) {
	      var _this3 = this;
	
	      if (this.hammerSlide) {
	        this.hammerSlide.resize(height, keepScale);
	      } else {
	        var img = this.DOMContainer.querySelector(".slide-imageviewer.non-hd");
	        this.takeResized = true;
	        $(img).on("load", function () {
	          //if called directly ratio is NAN because img is not laoded yet and has width of zero
	          _this3.createHammerSlide(true);
	        });
	      }
	    }
	  }, {
	    key: "zoomed",
	    value: function zoomed() {
	      this.hideCaption();
	      this.trigger("imageViewerSlide:zoomed");
	    }
	  }, {
	    key: "notZoomed",
	    value: function notZoomed() {
	      this.showCaption();
	      this.trigger("imageViewerSlide:notZoomed");
	    }
	  }, {
	    key: "hideCaption",
	    value: function hideCaption() {
	      if (this.caption) {
	        this.caption.classList.add("hidden");
	      }
	    }
	  }, {
	    key: "showCaption",
	    value: function showCaption() {
	      if (this.caption) {
	        this.caption.classList.remove("hidden");
	      }
	    }
	  }]);
	  return ImageGallerySlideMobile;
	}(_imageGallerySlide2.default);
	
	exports.default = ImageGallerySlideMobile;

/***/ },
/* 305 */,
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(316), __esModule: true };

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(319), __esModule: true };

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(321), __esModule: true };

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(323), __esModule: true };

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(326), __esModule: true };

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(328), __esModule: true };

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(329), __esModule: true };

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(330), __esModule: true };

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(315);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ },
/* 315 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(41);
	__webpack_require__(353);
	module.exports = __webpack_require__(13).Array.from;


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42);
	__webpack_require__(41);
	module.exports = __webpack_require__(352);


/***/ },
/* 318 */,
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(355);
	module.exports = 0x1fffffffffffff;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(356);
	module.exports = __webpack_require__(13).Object.assign;


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(357);
	var $Object = __webpack_require__(13).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(358);
	var $Object = __webpack_require__(13).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(359);
	var $Object = __webpack_require__(13).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(360);
	module.exports = __webpack_require__(13).Object.getPrototypeOf;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(361);
	module.exports = __webpack_require__(13).Object.keys;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(362);
	module.exports = __webpack_require__(13).Object.setPrototypeOf;


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(81);
	__webpack_require__(41);
	__webpack_require__(42);
	__webpack_require__(363);
	__webpack_require__(366);
	__webpack_require__(367);
	module.exports = __webpack_require__(13).Promise;


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(364);
	__webpack_require__(81);
	__webpack_require__(368);
	__webpack_require__(369);
	module.exports = __webpack_require__(13).Symbol;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(41);
	__webpack_require__(42);
	module.exports = __webpack_require__(79).f('iterator');


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(81);
	__webpack_require__(42);
	__webpack_require__(365);
	__webpack_require__(371);
	__webpack_require__(370);
	module.exports = __webpack_require__(13).WeakMap;


/***/ },
/* 331 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(29);
	var toLength = __webpack_require__(47);
	var toAbsoluteIndex = __webpack_require__(350);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var isArray = __webpack_require__(104);
	var SPECIES = __webpack_require__(17)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(333);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(71);
	var getWeak = __webpack_require__(45).getWeak;
	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(18);
	var anInstance = __webpack_require__(60);
	var forOf = __webpack_require__(44);
	var createArrayMethod = __webpack_require__(61);
	var $has = __webpack_require__(26);
	var validate = __webpack_require__(77);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(14);
	var $export = __webpack_require__(16);
	var meta = __webpack_require__(45);
	var fails = __webpack_require__(28);
	var hide = __webpack_require__(27);
	var redefineAll = __webpack_require__(71);
	var forOf = __webpack_require__(44);
	var anInstance = __webpack_require__(60);
	var isObject = __webpack_require__(18);
	var setToStringTag = __webpack_require__(39);
	var dP = __webpack_require__(22).f;
	var each = __webpack_require__(61)(0);
	var DESCRIPTORS = __webpack_require__(21);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(22);
	var createDesc = __webpack_require__(38);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(37);
	var gOPS = __webpack_require__(69);
	var pIE = __webpack_require__(46);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 339 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(67);
	var descriptor = __webpack_require__(38);
	var setToStringTag = __webpack_require__(39);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(27)(IteratorPrototype, __webpack_require__(17)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 341 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(14);
	var macrotask = __webpack_require__(115).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(35)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(22);
	var anObject = __webpack_require__(20);
	var getKeys = __webpack_require__(37);
	
	module.exports = __webpack_require__(21) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(29);
	var gOPN = __webpack_require__(109).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(16);
	var aFunction = __webpack_require__(34);
	var ctx = __webpack_require__(25);
	var forOf = __webpack_require__(44);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(16);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(18);
	var anObject = __webpack_require__(20);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(25)(Function.call, __webpack_require__(68).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(14);
	var core = __webpack_require__(13);
	var dP = __webpack_require__(22);
	var DESCRIPTORS = __webpack_require__(21);
	var SPECIES = __webpack_require__(17)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(75);
	var defined = __webpack_require__(62);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(75);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(14);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(20);
	var get = __webpack_require__(80);
	module.exports = __webpack_require__(13).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(25);
	var $export = __webpack_require__(16);
	var toObject = __webpack_require__(30);
	var call = __webpack_require__(105);
	var isArrayIter = __webpack_require__(103);
	var toLength = __webpack_require__(47);
	var createProperty = __webpack_require__(337);
	var getIterFn = __webpack_require__(80);
	
	$export($export.S + $export.F * !__webpack_require__(107)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(331);
	var step = __webpack_require__(341);
	var Iterators = __webpack_require__(33);
	var toIObject = __webpack_require__(29);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(106)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(16);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(16);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(108) });


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(16);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(67) });


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(16);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperty: __webpack_require__(22).f });


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(29);
	var $getOwnPropertyDescriptor = __webpack_require__(68).f;
	
	__webpack_require__(70)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(30);
	var $getPrototypeOf = __webpack_require__(110);
	
	__webpack_require__(70)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(30);
	var $keys = __webpack_require__(37);
	
	__webpack_require__(70)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(16);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(347).set });


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(36);
	var global = __webpack_require__(14);
	var ctx = __webpack_require__(25);
	var classof = __webpack_require__(86);
	var $export = __webpack_require__(16);
	var isObject = __webpack_require__(18);
	var aFunction = __webpack_require__(34);
	var anInstance = __webpack_require__(60);
	var forOf = __webpack_require__(44);
	var speciesConstructor = __webpack_require__(114);
	var task = __webpack_require__(115).set;
	var microtask = __webpack_require__(342)();
	var newPromiseCapabilityModule = __webpack_require__(66);
	var perform = __webpack_require__(112);
	var userAgent = __webpack_require__(351);
	var promiseResolve = __webpack_require__(113);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(17)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(71)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(39)($Promise, PROMISE);
	__webpack_require__(348)(PROMISE);
	Wrapper = __webpack_require__(13)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(107)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(14);
	var has = __webpack_require__(26);
	var DESCRIPTORS = __webpack_require__(21);
	var $export = __webpack_require__(16);
	var redefine = __webpack_require__(72);
	var META = __webpack_require__(45).KEY;
	var $fails = __webpack_require__(28);
	var shared = __webpack_require__(74);
	var setToStringTag = __webpack_require__(39);
	var uid = __webpack_require__(48);
	var wks = __webpack_require__(17);
	var wksExt = __webpack_require__(79);
	var wksDefine = __webpack_require__(78);
	var enumKeys = __webpack_require__(338);
	var isArray = __webpack_require__(104);
	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(18);
	var toObject = __webpack_require__(30);
	var toIObject = __webpack_require__(29);
	var toPrimitive = __webpack_require__(76);
	var createDesc = __webpack_require__(38);
	var _create = __webpack_require__(67);
	var gOPNExt = __webpack_require__(344);
	var $GOPD = __webpack_require__(68);
	var $GOPS = __webpack_require__(69);
	var $DP = __webpack_require__(22);
	var $keys = __webpack_require__(37);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(109).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(46).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(36)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(27)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(14);
	var each = __webpack_require__(61)(0);
	var redefine = __webpack_require__(72);
	var meta = __webpack_require__(45);
	var assign = __webpack_require__(108);
	var weak = __webpack_require__(335);
	var isObject = __webpack_require__(18);
	var validate = __webpack_require__(77);
	var NATIVE_WEAK_MAP = __webpack_require__(77);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(336)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(16);
	var core = __webpack_require__(13);
	var global = __webpack_require__(14);
	var speciesConstructor = __webpack_require__(114);
	var promiseResolve = __webpack_require__(113);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(16);
	var newPromiseCapability = __webpack_require__(66);
	var perform = __webpack_require__(112);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(78)('asyncIterator');


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(78)('observable');


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(345)('WeakMap');


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(346)('WeakMap');


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(372));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var T = [];
	
		    // Compute constants
		    (function () {
		        for (var i = 0; i < 64; i++) {
		            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
		        }
		    }());
	
		    /**
		     * MD5 hash algorithm.
		     */
		    var MD5 = C_algo.MD5 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
	
		            // Shortcuts
		            var H = this._hash.words;
	
		            var M_offset_0  = M[offset + 0];
		            var M_offset_1  = M[offset + 1];
		            var M_offset_2  = M[offset + 2];
		            var M_offset_3  = M[offset + 3];
		            var M_offset_4  = M[offset + 4];
		            var M_offset_5  = M[offset + 5];
		            var M_offset_6  = M[offset + 6];
		            var M_offset_7  = M[offset + 7];
		            var M_offset_8  = M[offset + 8];
		            var M_offset_9  = M[offset + 9];
		            var M_offset_10 = M[offset + 10];
		            var M_offset_11 = M[offset + 11];
		            var M_offset_12 = M[offset + 12];
		            var M_offset_13 = M[offset + 13];
		            var M_offset_14 = M[offset + 14];
		            var M_offset_15 = M[offset + 15];
	
		            // Working varialbes
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
	
		            // Computation
		            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
		            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
		            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
		            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
		            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
		            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
		            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
		            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
		            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
		            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
		            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
		            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
		            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
		            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
		            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
		            b = FF(b, c, d, a, M_offset_15, 22, T[15]);
	
		            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
		            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
		            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
		            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
		            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
		            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
		            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
		            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
		            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
		            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
		            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
		            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
		            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
		            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
		            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
		            b = GG(b, c, d, a, M_offset_12, 20, T[31]);
	
		            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
		            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
		            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
		            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
		            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
		            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
		            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
		            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
		            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
		            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
		            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
		            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
		            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
		            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
		            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
		            b = HH(b, c, d, a, M_offset_2,  23, T[47]);
	
		            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
		            d = II(d, a, b, c, M_offset_7,  10, T[49]);
		            c = II(c, d, a, b, M_offset_14, 15, T[50]);
		            b = II(b, c, d, a, M_offset_5,  21, T[51]);
		            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
		            d = II(d, a, b, c, M_offset_3,  10, T[53]);
		            c = II(c, d, a, b, M_offset_10, 15, T[54]);
		            b = II(b, c, d, a, M_offset_1,  21, T[55]);
		            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
		            d = II(d, a, b, c, M_offset_15, 10, T[57]);
		            c = II(c, d, a, b, M_offset_6,  15, T[58]);
		            b = II(b, c, d, a, M_offset_13, 21, T[59]);
		            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
		            d = II(d, a, b, c, M_offset_11, 10, T[61]);
		            c = II(c, d, a, b, M_offset_2,  15, T[62]);
		            b = II(b, c, d, a, M_offset_9,  21, T[63]);
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	
		            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
		            var nBitsTotalL = nBitsTotal;
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
		                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
		            );
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
		            );
	
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    function FF(a, b, c, d, x, s, t) {
		        var n = a + ((b & c) | (~b & d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function GG(a, b, c, d, x, s, t) {
		        var n = a + ((b & d) | (c & ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function HH(a, b, c, d, x, s, t) {
		        var n = a + (b ^ c ^ d) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function II(a, b, c, d, x, s, t) {
		        var n = a + (c ^ (b | ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.MD5('message');
		     *     var hash = CryptoJS.MD5(wordArray);
		     */
		    C.MD5 = Hasher._createHelper(MD5);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacMD5(message, key);
		     */
		    C.HmacMD5 = Hasher._createHmacHelper(MD5);
		}(Math));
	
	
		return CryptoJS.MD5;
	
	}));

/***/ },
/* 374 */,
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("albController",body_0);function body_0(chk,ctx){return chk.w("<div class=\"alb-container\">").x(ctx.get(["tablet"], false),ctx,{"else":body_1,"block":body_3},{}).w("</div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<!-- PHONE -->").x(ctx.get(["extraButton"], false),ctx,{"block":body_2},{}).w("<div class=\"alb\"><div class=\"alb-navigation\"><div class=\"alb-nav-item alb-nav-back\"><div class=\"back-icon\"></div></div><div class=\"alb-nav-item alb-nav-share novisibility\"><div class=\"share-icon\"></div><div class=\"sharing-container hidden\"></div></div><div class=\"alb-nav-item alb-nav-size novisibility\"><div class=\"font-icon\"></div></div><div class=\"alb-nav-item alb-nav-previous\"><div class=\"previous-icon\"></div></div><div class=\"alb-nav-item alb-nav-next\"><div class=\"next-icon\"></div></div></div><div class=\"swiper-container swiper-container-alb\"><div class=\"swiper-wrapper swiper-wrapper-alb\"></div></div></div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"alb-overall-extra-button-container hidden\">").p("enrichmentButton",ctx,ctx,{"number":0}).w("</div>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<!-- TABLET OR DESKTOP--><div class=\"alb\"><div class=\"alb-left-nav\"><div class=\"alb-nav-item alb-nav-previous alb-nav-round pointer\"><div class=\"previous-icon\"></div></div></div><div class=\"swiper-container swiper-container-alb\"><div class=\"swiper-wrapper swiper-wrapper-alb\"></div></div><div class=\"alb-right-nav\"><div class=\"alb-right-top-nav\"><div class=\"alb-nav-item alb-nav-back alb-nav-round pointer\"><div class=\"back-icon\"></div></div></div><div class=\"alb-right-middle-nav\"><div class=\"alb-nav-item alb-nav-next alb-nav-round pointer\"><div class=\"next-icon\"></div></div></div><div class=\"alb-right-bottom-nav\">").x(ctx.get(["extraButton"], false),ctx,{"block":body_4},{}).w("<div class=\"alb-nav-item alb-nav-share alb-nav-round novisibility pointer\"><div class=\"share-container\"><div class=\"share-icon\"></div></div><div class=\"sharing-container hidden\"></div></div><div class=\"alb-nav-item alb-nav-size alb-nav-round novisibility pointer\"><div class=\"font-icon\"></div></div></div></div></div>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<div class=\"alb-overall-extra-button-container hidden\">").p("enrichmentButton",ctx,ctx,{"number":0}).w("</div>");}body_4.__dustBody=!0;return body_0}(dust));
	module.exports = 'albController';

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("albImageSlider",body_0);function body_0(chk,ctx){return chk.w("<div class=\"alb-image-slider-viewer-loader\"></div><div class=\"swiper-wrapper alb-image-slider-wrapper\">").s(ctx.get(["images"], false),ctx,{"block":body_1},{}).w("</div><!-- Add Pagination --><div class=\"swiper-pagination swiper-pagination-alb-image ").x(ctx.get(["singleImage"], false),ctx,{"block":body_4},{}).w("\"></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"swiper-slide swiper-slide-alb-img pointer\"><div class=\"alb-slide-img-container ").x(ctx.get(["fixedImgHeight"], false),ctx,{"block":body_2},{}).w("\"><img class=\"").f(ctx.get(["imageIdentifier"], false),ctx,"h").w(" alb-slide-img hidden\"></div><div class=\"alb-slide-img-capture ").x(ctx.get(["maxLines"], false),ctx,{"block":body_3},{}).w("\">").f(ctx.get(["HtmlText"], false),ctx,"h",["s"]).w("</div></div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("fixedImgHeight");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("maxlines");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("hidden");}body_4.__dustBody=!0;return body_0}(dust));
	module.exports = 'albImageSlider';

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("albSlide",body_0);function body_0(chk,ctx){return chk.x(ctx.get(["extra"], false),ctx,{"block":body_1},{}).w("<div class=\"alb-content-scroll ").f(ctx.get(["className"], false),ctx,"h").w("\" tabindex=\"-1\"><div class=\"alb-content\">").s(ctx.get(["article"], false),ctx,{"block":body_3},{}).w("</div></div>").x(ctx.get(["desktop"], false),ctx,{"block":body_19},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.x(ctx.get(["extraButton"], false),ctx,{"block":body_2},{});}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"alb-extra-button-container\">").p("enrichmentButton",ctx,ctx,{"number":ctx.get(["numberExtras"], false),"type":ctx.get(["extraType"], false)}).w("</div>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.x(ctx.get(["SubTitle"], false),ctx,{"block":body_4},{}).w("<div class=\"alb-article-title\">").f(ctx.get(["Title"], false),ctx,"h",["s"]).w("</div>").x(ctx.get(["SupTitle"], false),ctx,{"block":body_5},{}).x(ctx.get(["imageSlider"], false),ctx,{"block":body_6},{}).x(ctx.get(["displayPageCategory"], false),ctx,{"else":body_7,"block":body_9},{}).x(ctx.get(["Introduction"], false),ctx,{"block":body_12},{}).w("<div class=\"alb-article-content\">").f(ctx.get(["HtmlText"], false),ctx,"h",["s"]).w("</div>").x(ctx.get(["extra"], false),ctx,{"block":body_13},{});}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<div class=\"alb-article-subtitle\">").f(ctx.get(["SubTitle"], false),ctx,"h",["s"]).w("</div>");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("<div class=\"alb-article-suptitle\">").f(ctx.get(["SupTitle"], false),ctx,"h",["s"]).w("</div>");}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("<div class=\"alb-image-slider-container swiper-container\"></div>");}body_6.__dustBody=!0;function body_7(chk,ctx){return chk.s(ctx.get(["author"], false),ctx,{"block":body_8},{});}body_7.__dustBody=!0;function body_8(chk,ctx){return chk.w("<div class=\"alb-article-author-container\"><div class=\"alb-article-author\">").f(ctx.get(["Author"], false),ctx,"h",["s"]).w("</div></div>");}body_8.__dustBody=!0;function body_9(chk,ctx){return chk.w("<div class=\"category-author-wrapper\">").x(ctx.get(["category"], false),ctx,{"block":body_10},{}).s(ctx.get(["author"], false),ctx,{"block":body_11},{}).w("</div>");}body_9.__dustBody=!0;function body_10(chk,ctx){return chk.w("<span class=\"alb-article-category\">").f(ctx.get(["category"], false),ctx,"h").w("</span>");}body_10.__dustBody=!0;function body_11(chk,ctx){return chk.w("<div class=\"alb-article-author-container\"><div class=\"alb-article-author\">").f(ctx.get(["Author"], false),ctx,"h",["s"]).w("</div></div>");}body_11.__dustBody=!0;function body_12(chk,ctx){return chk.w("<div class=\"alb-article-introduction\">").f(ctx.get(["Introduction"], false),ctx,"h",["s"]).w("</div>");}body_12.__dustBody=!0;function body_13(chk,ctx){return chk.w("<div class=\"alb-article-extras\"><div class=\"alb-article-extras-title\">").x(ctx.get(["extraButtonTitle"], false),ctx,{"block":body_14},{}).w("<div class=\"alb-article-extras-title-text\">").f(ctx.get(["extraTitle"], false),ctx,"h").w("</div></div><div class=\"alb-article-extras-content\">").s(ctx.get(["extras"], false),ctx,{"block":body_15},{}).w("</div></div>");}body_13.__dustBody=!0;function body_14(chk,ctx){return chk.w("<div class=\"alb-article-extras-title-button\">").p("enrichmentButton",ctx,ctx,{"number":ctx.get(["numberExtras"], false)}).w("</div>");}body_14.__dustBody=!0;function body_15(chk,ctx){return chk.w("<div class=\"alb-article-extras-item\" data-id=\"").f(ctx.get(["ContentItemId"], false),ctx,"h").w("\"><div class=\"alb-article-extras-item-content\">").h("eq",ctx,{"block":body_16},{"key":ctx.get(["ContentType"], false),"value":"ad/url"},"h").h("eq",ctx,{"block":body_17},{"key":ctx.get(["ContentType"], false),"value":"video/url"},"h").h("eq",ctx,{"block":body_18},{"key":ctx.get(["ContentType"], false),"value":"imageEnrichment/jpeg"},"h").w("</div><div class=\"alb-article-extras-item-title\">").f(ctx.get(["Byline"], false),ctx,"h").w("</div></div>");}body_15.__dustBody=!0;function body_16(chk,ctx){return chk.w("<a class=\"alb-extra-ad\" href=\"").f(ctx.get(["ContentItemUrl"], false),ctx,"h").w("\" target=\"_blank\"><div class=\"title\">").f(ctx.get(["urlTitle"], false),ctx,"h").w("</div><div class=\"emptyspace\"></div><div class=\"url\">").f(ctx.get(["ContentItemUrl"], false),ctx,"h").w("</div><div class=\"icon-wrapper\"><div class=\"icon-container\"><div class=\"icon\"></div></div></div></a>");}body_16.__dustBody=!0;function body_17(chk,ctx){return chk.w("<a class=\"alb-extra-video\" href=\"").f(ctx.get(["ContentItemUrl"], false),ctx,"h").w("\" target=\"_blank\"><div class=\"title\">").f(ctx.get(["videoTitle"], false),ctx,"h").w("</div><div class=\"emptyspace\"></div><div class=\"url\">").f(ctx.get(["ContentItemUrl"], false),ctx,"h").w("</div><div class=\"icon-wrapper\"><div class=\"icon-container\"><div class=\"icon\"></div></div></div></a>");}body_17.__dustBody=!0;function body_18(chk,ctx){return chk.w("<div class=\"alb-extra-image-viewer-loader\"></div><a class=\"alb-extra-image\" style=\"background-image:url('").f(ctx.get(["src"], false),ctx,"h").w("');\" data-id=\"").f(ctx.get(["id"], false),ctx,"h").w("\"><div class=\"title\">").f(ctx.get(["imageTitle"], false),ctx,"h").w("</div><div class=\"icon-wrapper\"><div class=\"icon-container\"><div class=\"icon\"></div></div></div></a>");}body_18.__dustBody=!0;function body_19(chk,ctx){return chk.w("<div class=\"scrollbar\"></div>");}body_19.__dustBody=!0;return body_0}(dust));
	module.exports = 'albSlide';

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("clickZonesComponent",body_0);function body_0(chk,ctx){return chk.s(ctx.get(["clickZone"], false),ctx,{"block":body_1},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.x(ctx.get(["extra"], false),ctx,{"block":body_2},{}).w("<div class=\"swiper-slide-page-click\" data-pageid=\"").f(ctx.get(["pageID"], false),ctx,"h").w("\" data-contentid=\"").f(ctx.get(["contentID"], false),ctx,"h").w("\" data-index=\"").f(ctx.get(["index"], false),ctx,"h").w("\" data-article=\"").f(ctx.get(["articleNumber"], false),ctx,"h").w("\" ").x(ctx.get(["hasOnlyLinkOrVideo"], false),ctx,{"block":body_5},{}).w(" style=\"left:").f(ctx.get(["left"], false),ctx,"h").w("%;top:").f(ctx.get(["top"], false),ctx,"h").w("%;width:").f(ctx.get(["width"], false),ctx,"h").w("%;height:").f(ctx.get(["height"], false),ctx,"h").w("%;\"></div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.s(ctx.get(["extraPosition"], false),ctx,{"block":body_3},{});}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<div class=\"extra-button-container ").f(ctx.get(["corner"], false),ctx,"h").w("\" data-extraType=\"").f(ctx.get(["extraType"], false),ctx,"h").w("\" data-extraNumber=\"").f(ctx.get(["extraNumber"], false),ctx,"h").w("\" data-contentid=\"").f(ctx.get(["contentID"], false),ctx,"h").w("\" data-index=\"").f(ctx.get(["index"], false),ctx,"h").w("\" ").x(ctx.get(["extraUrl"], false),ctx,{"block":body_4},{}).w(" style=\"left: ").f(ctx.get(["left"], false),ctx,"h").w("; top: ").f(ctx.get(["top"], false),ctx,"h").w(";\">").p("enrichmentButton",ctx,ctx,{"number":ctx.get(["extraNumber"], false),"type":ctx.get(["extraType"], false)}).w("</div>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("data-extraurl=\"").f(ctx.get(["extraUrl"], false),ctx,"h").w("\"");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("data-extraurl=\"").f(ctx.get(["extraUrl"], false),ctx,"h").w("\"");}body_5.__dustBody=!0;return body_0}(dust));
	module.exports = 'clickZonesComponent';

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("cookie",body_0);function body_0(chk,ctx){return chk.w("<div class=\"cookie-container\"><div class=\"cookie-text\">").f(ctx.get(["text"], false),ctx,"h").w("<a href=\"").f(ctx.get(["link"], false),ctx,"h").w("\" class=\"cookie-link\">").f(ctx.get(["text_link"], false),ctx,"h").w("</a></div><div class=\"cookie-button\"><div class=\"cookie-confirm pointer\">").f(ctx.get(["button"], false),ctx,"h").w("</div></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'cookie';

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("downloadButtonComponent",body_0);function body_0(chk,ctx){return chk.x(ctx.get(["useCustomToolTip"], false),ctx,{"else":body_1,"block":body_4},{}).w("<div class=\"downloadOption-container hidden\"></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.x(ctx.get(["displayTopNavButtonlabel"], false),ctx,{"else":body_2,"block":body_3},{});}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"download-icon\" title=\"").f(ctx.getPath(false, ["i18n","pdfDownloadTooltip"]),ctx,"h").w("\"></div>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<div class=\"download-icon\"  title=\"").f(ctx.getPath(false, ["i18n","pdfDownloadTooltip"]),ctx,"h").w("\"></div><span class=\"download-label\">").f(ctx.getPath(false, ["i18n","pdfDownloadTooltip"]),ctx,"h").w("</span>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<div class=\"download-icon tooltip\" tooltip=\"").f(ctx.getPath(false, ["i18n","pdfDownloadTooltip"]),ctx,"h").w("\"></div>");}body_4.__dustBody=!0;return body_0}(dust));
	module.exports = 'downloadButtonComponent';

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("errorPopup",body_0);function body_0(chk,ctx){return chk.w("<div class=\"error-container overlay-wrapper\">").p("topNavigationOverlay",ctx,ctx,{"title":ctx.get(["title"], false),"back":ctx.get(["back"], false),"close":ctx.get(["close"], false)}).w("<div class=\"error-main overlay-main\"><div class=\"error-message hidden\"></div><div id=\"btn_close\">").f(ctx.getPath(false, ["language","close"]),ctx,"h").w("</div></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'errorPopup';

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("imagegallery",body_0);function body_0(chk,ctx){return chk.w("<div class=\"imageviewer-container\"><div class=\"imageviewer-nav-back imageviewer-nav pointer\"><div class=\"back-icon\"></div></div><!-- Swiper --><div class=\"swiper-container swiper-container-imageviewer\"><div class=\"swiper-wrapper swiper-wrapper-imageviewer ").x(ctx.get(["fixedImgHeight"], false),ctx,{"else":body_1,"block":body_2},{}).w("\"></div><!-- Pagination --><div class=\"swiper-pagination swiper-pagination-imageviewer ").x(ctx.get(["singleImage"], false),ctx,{"block":body_3},{}).w("\"></div>").x(ctx.get(["navigation"], false),ctx,{"block":body_4},{}).w("</div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("fixedImgHeight");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk;}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("singleImage");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<!-- Add Arrows --><div class=\"swiper-button-next\"><div class=\"imageviewer-nav-next imageviewer-nav\"><div class=\"next-icon\"></div></div></div><div class=\"swiper-button-prev\"><div class=\"imageviewer-nav-prev imageviewer-nav\"><div class=\"prev-icon\"></div></div></div>");}body_4.__dustBody=!0;return body_0}(dust));
	module.exports = 'imagegallery';

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("imagegalleryslide",body_0);function body_0(chk,ctx){return chk.w("<div class=\"slide-imageviewer-container\">").x(ctx.get(["desktop"], false),ctx,{"else":body_1,"block":body_2},{}).w("</div><div class=\"imageviewer-caption-container\"><div class=\"imageviewer-caption ").x(ctx.get(["captionOnlyFirstLines"], false),ctx,{"block":body_3},{}).w(" ").x(ctx.get(["singleImage"], false),ctx,{"block":body_4},{}).w("\">").f(ctx.get(["HtmlText"], false),ctx,"h",["s"]).w("</div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<img class=\"").f(ctx.get(["hDImageIdentifier"], false),ctx,"h").w(" slide-imageviewer hd\"><img class=\"").f(ctx.get(["imageIdentifier"], false),ctx,"h").w(" slide-imageviewer non-hd\">");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"").f(ctx.get(["hDImageIdentifier"], false),ctx,"h").w(" slide-imageviewer hd\"></div><div class=\"").f(ctx.get(["imageIdentifier"], false),ctx,"h").w(" slide-imageviewer non-hd\"></div>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("maxlines");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("singleImage");}body_4.__dustBody=!0;return body_0}(dust));
	module.exports = 'imagegalleryslide';

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("paywall",body_0);function body_0(chk,ctx){return chk.w("<div class=\"paywall-container overlay-wrapper\">").p("topNavigationOverlay",ctx,ctx,{"title":ctx.get(["title"], false),"back":ctx.get(["back"], false),"close":ctx.get(["close"], false)}).w("<div class=\"paywall-main overlay-main\">").x(ctx.get(["iframebannerSource"], false),ctx,{"block":body_1},{}).w("<div class=\"paywall-login\"><div class=\"paywall-email paywall-login-item\"><input id=\"login-username\" class=\"login-input paywall-text-item\" type=\"email\" name=\"username\" placeholder=\"").f(ctx.get(["email"], false),ctx,"h").w("\" autocomplete=\"off\" autocorrect=\"off\" spellcheck=\"false\"></div>").x(ctx.get(["showPassword"], false),ctx,{"block":body_2},{}).w("<div class=\"paywall-error paywall-login-item hidden paywall-text-item\"><div class=\"paywall-text-item-content\"></div></div><div class=\"paywall-button paywall-login-item\"><div class=\"paywall-button-login paywall-button-item paywall-text-item\"><div class=\"paywall-text-item-content\">").f(ctx.get(["login"], false),ctx,"h").w("</div></div><div class=\"loader-container hidden\">").p("spinner",ctx,ctx,{}).w("</div></div>").x(ctx.get(["showPassword"], false),ctx,{"block":body_3},{}).w("</div></div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"abo-banner\"><iframe id=\"abo-banner-iframe\" width=\"100%\" data-url=\"").f(ctx.get(["iframebannerSource"], false),ctx,"h").w("\"></iframe></div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"paywall-password paywall-login-item\"><input id=\"login-password\" class=\"login-input paywall-text-item\" type=\"password\" name=\"password\" placeholder=\"").f(ctx.get(["password"], false),ctx,"h").w("\" autocomplete=\"off\" autocorrect=\"off\" spellcheck=\"false\"></div>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<div class=\"paywall-forgot-password paywall-login-item\"><div class=\"forgot-password paywall-text-item\"><div class=\"paywall-text-item-content\">").f(ctx.get(["forgot"], false),ctx,"h").w("</div></div></div>");}body_3.__dustBody=!0;return body_0}(dust));
	module.exports = 'paywall';

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("pdfDownload",body_0);function body_0(chk,ctx){return chk.w("<div class=\"downloadOption-component\">").x(ctx.get(["allowFullPdfDownload"], false),ctx,{"block":body_1},{}).x(ctx.get(["isSingle"], false),ctx,{"else":body_2,"block":body_3},{}).w("</div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<a target=\"_blank\" class=\"download-item\" data-download=\"fullPdf\" ><div class=\"download-title\">").f(ctx.get(["fullPdf"], false),ctx,"h").w("</div></a>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<a target=\"_blank\" class=\"download-item\" data-download=\"leftPage\"><div class=\"download-title\">").f(ctx.get(["leftPage"], false),ctx,"h").w("</div></a><a target=\"_blank\" class=\"download-item\" data-download=\"rightPage\"><div class=\"download-title\">").f(ctx.get(["rightPage"], false),ctx,"h").w("</div></a>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<a target=\"_blank\" class=\"download-item\" data-download=\"singlePage\"><div class=\"download-title\">").f(ctx.get(["singlePage"], false),ctx,"h").w("</div></a>");}body_3.__dustBody=!0;return body_0}(dust));
	module.exports = 'pdfDownload';

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("preferredViewerSwitcher",body_0);function body_0(chk,ctx){return chk.w("<div id=\"viewer-switcher\" class='").h("select",ctx,{"block":body_1},{},"h").w("'>").h("select",ctx,{"block":body_5},{"key":ctx.get(["type"], false)},"h").w("</div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.h("eq",ctx,{"block":body_2},{"key":ctx.get(["type"], false),"value":"segmentButton"},"h").h("eq",ctx,{"block":body_3},{"key":ctx.get(["type"], false),"value":"stackedButtons"},"h").h("none",ctx,{"block":body_4},{},"h");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("btn-segment");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("btn-stacked");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("icons-group");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.h("eq",ctx,{"block":body_6},{"key":ctx.get(["type"], false),"value":"segmentButton"},"h").h("eq",ctx,{"block":body_9},{"key":ctx.get(["type"], false),"value":"stackedButtons"},"h").h("none",ctx,{"block":body_12},{},"h");}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("<button class=\"btn btn-viewer ").h("eq",ctx,{"block":body_7},{"key":ctx.get(["preferredViewer"], false),"value":"replica"},"h").w("\" type=\"button\" value=\"replica\"  title=\"").f(ctx.getPath(false, ["i18n","PaperVersion"]),ctx,"h").w("\">").f(ctx.getPath(false, ["i18n","Paper"]),ctx,"h").w("</button><button class=\"btn btn-viewer ").h("eq",ctx,{"block":body_8},{"key":ctx.get(["preferredViewer"], false),"value":"nextgen"},"h").w("\" type=\"button\" value=\"nextgen\"  title=\"").f(ctx.getPath(false, ["i18n","DigitalVersion"]),ctx,"h").w("\">").f(ctx.getPath(false, ["i18n","Digital"]),ctx,"h").w("</button>");}body_6.__dustBody=!0;function body_7(chk,ctx){return chk.w("active");}body_7.__dustBody=!0;function body_8(chk,ctx){return chk.w("active");}body_8.__dustBody=!0;function body_9(chk,ctx){return chk.w("<button class=\"btn btn-viewer ").h("eq",ctx,{"block":body_10},{"key":ctx.get(["preferredViewer"], false),"value":"replica"},"h").w("\" type=\"button\" value=\"replica\" title=\"").f(ctx.getPath(false, ["i18n","PaperVersion"]),ctx,"h").w("\"><i class=\"icon document-icon\"></i>").f(ctx.getPath(false, ["i18n","PaperVersion"]),ctx,"h").w("</button><button class=\"btn btn-viewer ").h("eq",ctx,{"block":body_11},{"key":ctx.get(["preferredViewer"], false),"value":"nextgen"},"h").w("\" type=\"button\" value=\"nextgen\" title=\"").f(ctx.getPath(false, ["i18n","DigitalVersion"]),ctx,"h").w("\"><i class=\"icon phone-icon\"></i>").f(ctx.getPath(false, ["i18n","DigitalVersion"]),ctx,"h").w("</button>");}body_9.__dustBody=!0;function body_10(chk,ctx){return chk.w("active");}body_10.__dustBody=!0;function body_11(chk,ctx){return chk.w("active");}body_11.__dustBody=!0;function body_12(chk,ctx){return chk.x(ctx.get(["useCustomToolTip"], false),ctx,{"else":body_13,"block":body_20},{});}body_12.__dustBody=!0;function body_13(chk,ctx){return chk.x(ctx.get(["displayTopNavButtonlabel"], false),ctx,{"else":body_14,"block":body_17},{});}body_13.__dustBody=!0;function body_14(chk,ctx){return chk.w("<button class=\"btn document-icon icon ").h("eq",ctx,{"block":body_15},{"key":ctx.get(["preferredViewer"], false),"value":"replica"},"h").w("\" value=\"replica\" title=\"").f(ctx.getPath(false, ["i18n","PaperVersion"]),ctx,"h").w("\"></button><button class=\"btn phone-icon icon ").h("eq",ctx,{"block":body_16},{"key":ctx.get(["preferredViewer"], false),"value":"nextgen"},"h").w("\" value=\"nextgen\" title=\"").f(ctx.getPath(false, ["i18n","DigitalVersion"]),ctx,"h").w("\"></button>");}body_14.__dustBody=!0;function body_15(chk,ctx){return chk.w("active");}body_15.__dustBody=!0;function body_16(chk,ctx){return chk.w("active");}body_16.__dustBody=!0;function body_17(chk,ctx){return chk.w("<button class=\"btn  ").h("eq",ctx,{"block":body_18},{"key":ctx.get(["preferredViewer"], false),"value":"replica"},"h").w("\" value=\"replica\" title=\"").f(ctx.getPath(false, ["i18n","PaperVersion"]),ctx,"h").w("\"><span class=\"document-icon icon\"></span><span class=\"document-label icon-label\">").f(ctx.getPath(false, ["i18n","PaperVersion"]),ctx,"h").w("</span></button><button class=\"btn  ").h("eq",ctx,{"block":body_19},{"key":ctx.get(["preferredViewer"], false),"value":"nextgen"},"h").w("\" value=\"nextgen\" title=\"").f(ctx.getPath(false, ["i18n","DigitalVersion"]),ctx,"h").w("\"><span class=\"phone-icon icon\"></span><span class=\"phone-label icon-label\">").f(ctx.getPath(false, ["i18n","DigitalVersion"]),ctx,"h").w("</span></button>");}body_17.__dustBody=!0;function body_18(chk,ctx){return chk.w("active");}body_18.__dustBody=!0;function body_19(chk,ctx){return chk.w("active");}body_19.__dustBody=!0;function body_20(chk,ctx){return chk.w("<button class=\"btn document-icon icon tooltip ").h("eq",ctx,{"block":body_21},{"key":ctx.get(["preferredViewer"], false),"value":"replica"},"h").w("\" value=\"replica\" tooltip=\"").f(ctx.getPath(false, ["i18n","PaperVersion"]),ctx,"h").w("\"></button><button class=\"btn phone-icon icon  tooltip ").h("eq",ctx,{"block":body_22},{"key":ctx.get(["preferredViewer"], false),"value":"nextgen"},"h").w("\" value=\"nextgen\"  tooltip=\"").f(ctx.getPath(false, ["i18n","DigitalVersion"]),ctx,"h").w("\"></button>");}body_20.__dustBody=!0;function body_21(chk,ctx){return chk.w("active");}body_21.__dustBody=!0;function body_22(chk,ctx){return chk.w("active");}body_22.__dustBody=!0;return body_0}(dust));
	module.exports = 'preferredViewerSwitcher';

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("regionList",body_0);function body_0(chk,ctx){return chk.w("<div class=\"region-selector-items\"><ul class=\"regions list-style-none\">").s(ctx.get(["regions"], false),ctx,{"block":body_1},{}).w("</ul></div><button class=\"scrolling-btn animated hidden\"></button>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<li class=\"regionItem\"><label class=\"region_").f(ctx.get(["$idx"], false),ctx,"h").w("_label pointer\" >").f(ctx.get(["Description"], false),ctx,"h").w("<div class=\"checkMark\"><input type = \"radio\" name = \"region\" class=\"region_").f(ctx.get(["$idx"], false),ctx,"h").w("\" data-id=\"region_").f(ctx.get(["$idx"], false),ctx,"h").w("\" value=\"").f(ctx.get(["Description"], false),ctx,"h").w("\"").h("eq",ctx,{"block":body_2},{"key":ctx.getPath(false, ["homeConfig","defaultRegion"]),"value":"true","type":"boolean"},"h").w("/><div class=\"checkMarkImg\"></div></div></label></li>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.h("eq",ctx,{"block":body_3},{"key":ctx.get(["$idx"], false),"value":0},"h");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("checked = \"checked\"");}body_3.__dustBody=!0;return body_0}(dust));
	module.exports = 'regionList';

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("region_selector",body_0);function body_0(chk,ctx){return chk.w("<div class=\"region-selector-container\"><div class=\"region-selector\"><div class=\"region-selector-header\"><div class=\"region-selector-header-logo\"></div><div class=\"region-selector-title text-uppercase\">").f(ctx.get(["ChooseRegionTranslation"], false),ctx,"h").w("</div></div>").p("regionList",ctx,ctx,{}).w("<div class=\"region-selector-button-container\"><div id=\"proceed-btn\" class='pointer region-selector-button vertical-horizontal-center text-center text-capitalize ").h("eq",ctx,{"block":body_1},{"key":ctx.get(["defaultRegion"], false),"value":"false","type":"boolean"},"h").w("'>").f(ctx.get(["Buttontext"], false),ctx,"h").w("</div></div></div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("is-disabled");}body_1.__dustBody=!0;return body_0}(dust));
	module.exports = 'region_selector';

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("settings-setting",body_0);function body_0(chk,ctx){return chk.w("<div class=\"settings-container  overlay-wrapper\">").p("topNavigationOverlay",ctx,ctx,{"title":ctx.get(["settings"], false),"back":ctx.get(["back"], false),"close":ctx.get(["close"], false)}).w("<div id=\"sidemenu-region-container\" class=\"overlay-container hidden\"></div><div id=\"sidemenu-account-container\" class=\"overlay-container hidden\"></div><div id=\"sidemenu-help-container\" class=\"overlay-container hidden\"></div><div id=\"sidemenu-about-container\" class=\"overlay-container hidden\"></div><div id=\"sidemenu-disclaimer-container\" class=\"overlay-container hidden\"></div><div id=\"sidemenu-policy-container\" class=\"overlay-container hidden\"></div><div id=\"sidemenu-privacypolicy-container\" class=\"overlay-container hidden\"></div><div class=\"settings-main  overlay-main\"><div class=\"settings-region settings-main-item setting-overlay-main-item pointer\"><div class=\"settings-region-icon settings-main-item-icon setting-overlay-main-item-icon\"><div class=\"icon\"></div></div><div class=\"settings-region-title settings-main-item-title setting-overlay-main-item-title\">").f(ctx.get(["region"], false),ctx,"h").w("</div><div class=\"settings-region-extra settings-main-item-extra setting-overlay-main-item-extra\">").f(ctx.get(["currentRegion"], false),ctx,"h").w("</div></div>").x(ctx.get(["showAccount"], false),ctx,{"block":body_1},{}).x(ctx.get(["displayViewerOptions"], false),ctx,{"block":body_3},{}).x(ctx.get(["displayLandscapeToggle"], false),ctx,{"block":body_4},{}).w("<div class=\"settings-help settings-main-item setting-overlay-main-item pointer\"><div class=\"settings-help-icon settings-main-item-icon setting-overlay-main-item-icon\"><div class=\"icon\"></div></div><div class=\"settings-help-title settings-main-item-title setting-overlay-main-item-title\">").f(ctx.get(["help"], false),ctx,"h").w("</div></div><div class=\"settings-about settings-main-item setting-overlay-main-item pointer\"><div class=\"settings-about-icon settings-main-item-icon setting-overlay-main-item-icon\"><div class=\"icon\"></div></div><div class=\"settings-about-title settings-main-item-title setting-overlay-main-item-title\">").f(ctx.get(["about"], false),ctx,"h").w("</div></div>").x(ctx.get(["showLogoutButton"], false),ctx,{"block":body_7},{}).x(ctx.get(["showCMP"], false),ctx,{"block":body_8},{}).x(ctx.get(["showPrivacyPolicy"], false),ctx,{"block":body_9},{}).w("</div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"settings-login settings-main-item setting-overlay-main-item pointer\"><div class=\"settings-login-icon settings-main-item-icon setting-overlay-main-item-icon\"><div class=\"icon ").x(ctx.get(["isLoggedOut"], false),ctx,{"block":body_2},{}).w("\"></div></div><div class=\"settings-login-title settings-main-item-title setting-overlay-main-item-title\">").f(ctx.get(["account"], false),ctx,"h").w("</div><div class=\"settings-login-extra settings-main-item-extra setting-overlay-main-item-extra\">").f(ctx.get(["isLoggedIn"], false),ctx,"h").w("</div></div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("loggedOut");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<div class=\"settings-preferred-viewer settings-main-item setting-overlay-main-item pointer\"><div class=\"settings-preferred-viewer-icon settings-main-item-icon setting-overlay-main-item-icon\"><div class=\"icon\"></div></div><div class=\"settings-main-item-title setting-overlay-main-item-title\">").f(ctx.getPath(false, ["i18n","ReadingPreference"]),ctx,"h").w("</div><div class=\"settings-main-item-extra setting-overlay-main-item-extra\" id=\"preferred-viewer-extra\">").f(ctx.get(["preferredViewerLabel"], false),ctx,"h").w("</div></div>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<div class=\"settings-landscape-toggle settings-main-item setting-overlay-main-item pointer\"><div class=\"settings-landscape-toggle-icon settings-main-item-icon setting-overlay-main-item-icon\"><div class=\"icon\"></div></div><div class=\"settings-main-item-title setting-overlay-main-item-title\">").x(ctx.get(["isDesktop"], false),ctx,{"else":body_5,"block":body_6},{}).w("</div><div class=\"settings-main-item-extra setting-overlay-main-item-extra\" id=\"landscape-toggle-extra\">").f(ctx.get(["landscapeToggleLabel"], false),ctx,"h").w("</div></div>");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w(" ").f(ctx.getPath(false, ["i18n","landscapeToggle"]),ctx,"h").w(" ");}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w(" ").f(ctx.getPath(false, ["i18n","readingModeToggle"]),ctx,"h").w("  ");}body_6.__dustBody=!0;function body_7(chk,ctx){return chk.w("<div class=\"settings-signOut settings-main-item setting-overlay-main-item pointer ").f(ctx.get(["extraLogoutButtonClass"], false),ctx,"h").w("\"><div class=\"settings-signOut-icon settings-main-item-icon setting-overlay-main-item-icon\"><div class=\"icon\"></div></div><div class=\"settings-signOut-title settings-main-item-title setting-overlay-main-item-title\">").f(ctx.get(["SignOut"], false),ctx,"h").w("</div></div>");}body_7.__dustBody=!0;function body_8(chk,ctx){return chk.w("<div class=\"settings-cmp settings-main-item setting-overlay-main-item pointer ").f(ctx.get(["settingclass"], false),ctx,"h").w("\"><div class=\"settings-cmp-icon settings-main-item-icon setting-overlay-main-item-icon\"><div class=\"icon\"></div></div><div class=\"settings-cmp-title settings-main-item-title setting-overlay-main-item-title ").f(ctx.get(["settingclass"], false),ctx,"h").w("\">").f(ctx.getPath(false, ["i18n","openCMPSetting"]),ctx,"h").w("</div></div><div class=\"settings-policy settings-main-item setting-overlay-main-item pointer\"><div class=\"settings-policy-icon settings-main-item-icon setting-overlay-main-item-icon\"><div class=\"icon\"></div></div><div class=\"settings-policy-title settings-main-item-title setting-overlay-main-item-title\">").f(ctx.getPath(false, ["i18n","dataPolicy"]),ctx,"h").w("</div></div>");}body_8.__dustBody=!0;function body_9(chk,ctx){return chk.w("<div class=\"settings-privacypolicy settings-main-item setting-overlay-main-item pointer\"><div class=\"settings-privacypolicy-icon settings-main-item-icon setting-overlay-main-item-icon\"><div class=\"icon\"></div></div><div class=\"settings-privacypolicy-title settings-main-item-title setting-overlay-main-item-title\">").f(ctx.getPath(false, ["i18n","privacyPolicy"]),ctx,"h").w("</div></div>");}body_9.__dustBody=!0;return body_0}(dust));
	module.exports = 'settings-setting';

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("settings-settingAbout",body_0);function body_0(chk,ctx){return chk.w("<div class=\"about-container overlay-wrapper\">").p("topNavigationOverlay",ctx,ctx,{"title":ctx.get(["about"], false),"back":ctx.get(["back"], false),"close":ctx.get(["close"], false)}).w("<div class=\"about-main overlay-main\">").x(ctx.get(["hideDisclaimer"], false),ctx,{"else":body_1,"block":body_2},{}).w("<div class=\"about-version about-main-item setting-overlay-main-item\"><div class=\"about-version-title about-main-item-title  setting-overlay-main-item-title\">").f(ctx.get(["version"], false),ctx,"h").w("</div><div class=\"about-version-extra about-main-item-extra setting-overlay-main-item-extra\">").f(ctx.get(["currentVersion"], false),ctx,"h").w("</div></div><div class=\"about-platformversion about-main-item setting-overlay-main-item\"><div class=\"about-platformversion-title about-main-item-title  setting-overlay-main-item-title\">").f(ctx.get(["platformversion"], false),ctx,"h").w("</div><div class=\"about-version-extra about-main-item-extra setting-overlay-main-item-extra\">").f(ctx.get(["currentPlatformversion"], false),ctx,"h").w("</div></div><div class=\"about-uuid about-main-item setting-overlay-main-item pointer\"><div class=\"about-uuid-title about-main-item-title  setting-overlay-main-item-title\">").f(ctx.get(["uuid"], false),ctx,"h").w("</div><div class=\"about-uuid-extra about-main-item-extra setting-overlay-main-item-extra\">").f(ctx.get(["currentUuid"], false),ctx,"h").w("</div></div><div class=\"about-editor about-main-item setting-overlay-main-item pointer\"><div class=\"about-editor-title about-main-item-title  setting-overlay-main-item-title\">").f(ctx.get(["editor"], false),ctx,"h").w("</div><div class=\"about-editor-extra about-main-item-extra setting-overlay-main-item-extra\">").f(ctx.get(["currentEditor"], false),ctx,"h").w("</div></div><div class=\"about-developer about-main-item setting-overlay-main-item pointer\"><div class=\"about-developer-title about-main-item-title  setting-overlay-main-item-title\">").f(ctx.get(["developer"], false),ctx,"h").w("</div><div class=\"about-developer-extra about-main-item-extra setting-overlay-main-item-extra\">").f(ctx.get(["currentDeveloper"], false),ctx,"h").w("</div></div></div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"about-disclaimer about-main-item setting-overlay-main-item pointer\"><div class=\"about-disclaimer-title about-main-item-title  setting-overlay-main-item-title\">").f(ctx.get(["disclaimer"], false),ctx,"h").w("</div></div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk;}body_2.__dustBody=!0;return body_0}(dust));
	module.exports = 'settings-settingAbout';

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("settings-settingAccount",body_0);function body_0(chk,ctx){return chk.w("<div class=\"account-container overlay-wrapper paywall-main\">").p("topNavigationOverlay",ctx,ctx,{"title":ctx.get(["title"], false),"back":ctx.get(["back"], false),"close":ctx.get(["close"], false)}).w("<div class=\"account-main overlay-main paywall-login\"><div class=\"paywall-info paywall-login-item\"><div class=\"info paywall-text-item\"><div class=\"paywall-text-item-content\">").f(ctx.get(["info"], false),ctx,"h").w("</div></div></div><div class=\"paywall-logout paywall-login-item\"><div class=\"logout paywall-text-item\"><div class=\"paywall-text-item-content pointer\">").f(ctx.get(["logout"], false),ctx,"h").w("</div></div></div></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'settings-settingAccount';

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("settings-settingIframe",body_0);function body_0(chk,ctx){return chk.w("<div class=\"iframe-container iframe-").f(ctx.get(["name"], false),ctx,"h").w("-container overlay-wrapper\">").p("topNavigationOverlay",ctx,ctx,{"title":ctx.get(["title"], false),"back":ctx.get(["back"], false),"close":ctx.get(["close"], false)}).w("<div class=\"about-main overlay-main\"><iframe  src=\"").f(ctx.get(["iframe"], false),ctx,"h").w("\" width=\"100%\" height=\"100%\"></iframe></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'settings-settingIframe';

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("settings-settingLandscapeToggle",body_0);function body_0(chk,ctx){return chk.w("<div class=\"overlay-wrapper\">").p("topNavigationOverlay",ctx,ctx,{"title":ctx.get(["title"], false),"back":ctx.get(["back"], false),"close":ctx.get(["close"], false)}).w("<div class=\"region-selector-items overlay-main\"><ul class=\"regions list-style-none\" id=\"landscape-options\"><li class=\"regionItem\"><label for=\"singlePage-option\" class='landscape-option pointer ").x(ctx.get(["doublePage"], false),ctx,{"else":body_1,"block":body_2},{}).w("'>").f(ctx.getPath(false, ["i18n","singlePage"]),ctx,"h").w("<div class=\"checkMark\"><input id=\"singlePage-option\"type=\"radio\"name=\"landscapeType\"value=\"singlePage\"").x(ctx.get(["doublePage"], false),ctx,{"else":body_3,"block":body_4},{}).w(" /><div class=\"checkMarkImg\"></div></div></label></li><li class=\"regionItem\"><label for=\"doublePage-option\" class='landscape-option pointer ").x(ctx.get(["doublePage"], false),ctx,{"else":body_5,"block":body_6},{}).w("'>").f(ctx.getPath(false, ["i18n","doublePage"]),ctx,"h").w("<div class=\"checkMark\"><input id=\"doublePage-option\"type=\"radio\"name=\"landscapeType\"value=\"doublePage\"").x(ctx.get(["doublePage"], false),ctx,{"block":body_7},{}).w("/><div class=\"checkMarkImg\"></div></div></label></li></ul></div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("is-selected");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("is-notselected");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("checked");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk;}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("is-notselected");}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("is-selected");}body_6.__dustBody=!0;function body_7(chk,ctx){return chk.w("checked");}body_7.__dustBody=!0;return body_0}(dust));
	module.exports = 'settings-settingLandscapeToggle';

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("settings-settingPreferredViewer",body_0);function body_0(chk,ctx){return chk.w("<div class=\"overlay-wrapper\">").p("topNavigationOverlay",ctx,ctx,{"title":ctx.getPath(false, ["i18n","ReadingPreference"]),"back":ctx.get(["back"], false),"close":ctx.get(["close"], false)}).w("<div class=\"region-selector-items overlay-main\"><ul class=\"regions list-style-none\" id=\"viewer-options\"><li class=\"regionItem\"><label for=\"nextgen-option\" class='viewer-option pointer ").h("eq",ctx,{"else":body_1,"block":body_2},{"key":ctx.get(["preferredViewer"], false),"value":"nextgen"},"h").w("'>").f(ctx.getPath(false, ["i18n","DigitalVersion"]),ctx,"h").w("<div class=\"checkMark\"><input id=\"nextgen-option\"type=\"radio\"name=\"viewerType\"value=\"nextgen\"").h("eq",ctx,{"block":body_3},{"key":ctx.get(["preferredViewer"], false),"value":"nextgen"},"h").w(" /><div class=\"checkMarkImg\"></div></div></label></li><li class=\"regionItem\"><label for=\"replica-option\" class='viewer-option pointer ").h("eq",ctx,{"else":body_4,"block":body_5},{"key":ctx.get(["preferredViewer"], false),"value":"replica"},"h").w("'>").f(ctx.getPath(false, ["i18n","PaperVersion"]),ctx,"h").w("<div class=\"checkMark\"><input id=\"replica-option\"type=\"radio\"name=\"viewerType\"value=\"replica\"").h("eq",ctx,{"block":body_6},{"key":ctx.get(["preferredViewer"], false),"value":"replica"},"h").w("/><div class=\"checkMarkImg\"></div></div></label></li></ul></div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("is-notselected");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("is-selected");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("checked");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("is-notselected");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("is-selected");}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("checked");}body_6.__dustBody=!0;return body_0}(dust));
	module.exports = 'settings-settingPreferredViewer';

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("settings-settingRegion",body_0);function body_0(chk,ctx){return chk.w("<div class=\"region-container overlay-wrapper\">").p("topNavigationOverlay",ctx,ctx,{"title":ctx.get(["title"], false),"back":ctx.get(["back"], false),"close":ctx.get(["close"], false)}).w("<div class=\"region-main overlay-main\"><div id=\"sidemenu-region-list-container\"></div></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'settings-settingRegion';

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("settings-topNavigationSetting",body_0);function body_0(chk,ctx){return chk.w("<div class=\"settings-navigation\">").x(ctx.get(["back"], false),ctx,{"block":body_1},{}).w("<div class=\"settings-navigation-title\">").f(ctx.get(["title"], false),ctx,"h").w("</div>").x(ctx.get(["close"], false),ctx,{"block":body_2},{}).w("</div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"settings-navigation-back settings-navigation-outeritem\"><div class=\"settings-navigation-icon\"></div></div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"settings-navigation-close  settings-navigation-outeritem\"><div class=\"settings-navigation-icon\"></div></div>");}body_2.__dustBody=!0;return body_0}(dust));
	module.exports = 'settings-topNavigationSetting';

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("sharing",body_0);function body_0(chk,ctx){return chk.w("<div class=\"sharing-component\">").s(ctx.get(["sharing"], false),ctx,{"block":body_1},{}).x(ctx.get(["print"], false),ctx,{"block":body_2},{}).w("</div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<a target=\"_blank\" class=\"sharing-item ").f(ctx.get(["title"], false),ctx,"h").w(" pointer\" data-share=\"").f(ctx.get(["title"], false),ctx,"h").w("\" data-id=\"").f(ctx.get(["id"], false),ctx,"h").w("\"><div class=\"sharing-icon ").f(ctx.get(["title"], false),ctx,"h").w("\"></div><div class=\"sharing-title\">").f(ctx.get(["title"], false),ctx,"h").w("</div></a>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.x(ctx.get(["sharing"], false),ctx,{"else":body_3,"block":body_4},{});}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<a target=\"_blank\" class=\"sharing-item print-image pointer\" data-share=\"print-image\"><div class=\"sharing-icon print-image\"></div><div class=\"sharing-title\">").f(ctx.get(["image"], false),ctx,"h").w("</div></a><a target=\"_blank\" class=\"sharing-item print-text pointer\" data-share=\"print-text\"><div class=\"sharing-icon print-text\"></div><div class=\"sharing-title\">").f(ctx.get(["text"], false),ctx,"h").w("</div></a>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<a target=\"_blank\" class=\"sharing-item print pointer\" data-share=\"print\"><div class=\"sharing-icon print\"></div><div class=\"sharing-title\">").f(ctx.get(["print"], false),ctx,"h").w("</div><div class=\"print-triangle-icon\"></div></a><div class=\"sharing-component print-items hidden\"><a target=\"_blank\" class=\"sharing-item print-image pointer\" data-share=\"print-image\"><div class=\"sharing-icon print-image\"></div><div class=\"sharing-title\">").f(ctx.get(["image"], false),ctx,"h").w("</div></a><a target=\"_blank\" class=\"sharing-item print-text pointer\" data-share=\"print-text\"><div class=\"sharing-icon print-text\"></div><div class=\"sharing-title\">").f(ctx.get(["text"], false),ctx,"h").w("</div></a></div>");}body_4.__dustBody=!0;return body_0}(dust));
	module.exports = 'sharing';

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("thumbslider",body_0);function body_0(chk,ctx){return chk.w("<div class=\"swiper-container swiper-container-thumbs\"><div class=\"swiper-wrapper swiper-wrapper-thumbs\">").s(ctx.get(["pages"], false),ctx,{"block":body_1},{}).w("</div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"swiper-slide\"><div class=\"slide-container\"><div class=\"slide-wrapper\"><div class=\"slide-category\">").f(ctx.get(["thumbCategory"], false),ctx,"h").w("</div><div id=\"").f(ctx.get(["thumbId"], false),ctx,"h").w("\" class=\"slide-thumb\" data-img=\"\"></div><div class=\"slide-number\">").f(ctx.get(["ajustedPageNumber"], false),ctx,"h").w("</div></div></div></div>");}body_1.__dustBody=!0;return body_0}(dust));
	module.exports = 'thumbslider';

/***/ },
/* 399 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};

/***/ },
/* 400 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _PathUtils = __webpack_require__(120);
	
	var createLocation = exports.createLocation = function createLocation(path, state, key) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (!location.pathname) location.pathname = '/';
	
	    if (location.search && location.search.charAt(0) !== '?') location.search = '?' + location.search;
	
	    if (location.hash && location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  location.key = key;
	
	  return location;
	};
	
	var looseEqual = function looseEqual(a, b) {
	  if (a == null) return a == b;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  if (Array.isArray(a)) {
	    if (!Array.isArray(b) || a.length !== b.length) return false;
	
	    return a.every(function (item, index) {
	      return looseEqual(item, b[index]);
	    });
	  } else if (typeofA === 'object') {
	    var keysOfA = Object.keys(a);
	    var keysOfB = Object.keys(b);
	
	    if (keysOfA.length !== keysOfB.length) return false;
	
	    return keysOfA.every(function (key) {
	      return looseEqual(a[key], b[key]);
	    });
	  }
	
	  return a === b;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && looseEqual(a.state, b.state);
	};

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(232);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(404);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(401);
	
	var _PathUtils = __webpack_require__(120);
	
	var _createTransitionManager = __webpack_require__(403);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _ExecutionEnvironment = __webpack_require__(400);
	
	var _DOMUtils = __webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$basename = props.basename;
	  var basename = _props$basename === undefined ? '' : _props$basename;
	  var _props$getUserConfirm = props.getUserConfirmation;
	  var getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm;
	  var _props$hashType = props.hashType;
	  var hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	  var _HashPathCoders$hashT = HashPathCoders[hashType];
	  var encodePath = _HashPathCoders$hashT.encodePath;
	  var decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    if (basename) path = (0, _PathUtils.stripPrefix)(path, basename);
	
	    return (0, _PathUtils.parsePath)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      (function () {
	        var action = 'POP';
	
	        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	          if (ok) {
	            setState({ action: action, location: location });
	          } else {
	            revertPop(location);
	          }
	        });
	      })();
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var push = function push(path, state) {
	     false ? (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	         false ? (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	     false ? (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      return unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(232);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	     false ? (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time') : void 0;
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	           false ? (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(listener) {
	    listeners.push(listener);
	
	    return function () {
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 405 */,
/* 406 */
/***/ function(module, exports) {

	module.exports = {
		"AlsoToday": "Lees vandaag ook",
		"Archive": "Archief",
		"ClickHereForMoreInfo": "Klik hier voor meer info",
		"ClientWebServiceNotResponding": "De authenticatie service is momenteel onbeschikbaar",
		"Confirm": "Bevestig",
		"Digital": "Digitale",
		"DigitalVersion": "Digitale",
		"Edition": "Editie",
		"Help": "Hulp nodig?",
		"HorsSeries": "Extra",
		"LoadingNewspaperPleaseWait": "De krant wordt geladen, even geduld aub...",
		"LogIn": "Login",
		"LogInWith": "Of meld aan met:",
		"MaximumDeviceNumberReached": "U heeft met dit abonnement het maximaal aantal toegangen tot deze editie bereikt.",
		"ModernBrowserRequired": "U zoekt de digitale krant? Deze vereist Internet Explorer 9 of hoger. Wij raden u aan uw browser te updaten of via een andere browser te surfen (Chrome, Firefox,...).",
		"More": "Meer",
		"NewspaperCurrentlyUnavailable": "De krant kan momenteel niet geopend worden. Probeer later opnieuw.",
		"NoDigitalAccess": "U heeft momenteel geen digitale toegang",
		"OK": "OK",
		"Paper": "Papieren",
		"PaperVersion": "Papieren",
		"Password": "Wachtwoord",
		"PleaseFillInAllFields": "Gelieve alle velden in te vullen!",
		"Promospot": "Promospot",
		"ReadingPreference": "Leesvoorkeur",
		"ReadTheNewspaper": "Lees de krant",
		"Read": "Lees",
		"SelectEdition": "Selecteer een editie:",
		"SignIn": "Meld aan",
		"SignOut": "Meld af",
		"SSOValidationFailed": "Automatische authenticatie is mislukt.",
		"Subscription": "Abonnement",
		"TemporarilyUnavailable": "Tijdelijk onbeschikbaar",
		"TheUsernameAndOrPasswordIsIncorrect": "Fout wachtwoord en/of e-mailadres/gebruikersnaam",
		"UnknownError": "Er is een onverwachte fout opgetreden",
		"UnknownUser": "Fout e-mailadres/gebruikersnaam",
		"Username": "E-mailadres",
		"ValidationFailed": "De authenticatie service is momenteel onbeschikbaar.",
		"YourSessionHasExpired": "Uw sessie is verlopen",
		"downloadPDFerror": "U hebt de maximale download limiet bereikt voor deze editie. ",
		"ForgotPassword": "Paswoord vergeten",
		"Cancel": "Annuleer",
		"moment": "nl",
		"Extra": "Extra",
		"ChooseRegion": "Kies een regio alstublieft",
		"downloadingNewsPaper": "Uw krant is aan het downloaden, even geduld aub. ",
		"CookieConfirmButton": "OK",
		"CookieLinkText": "Meer informatie",
		"CookieInformText": "Deze website maakt gebruik van cookies. Door verder te surfen, stemt u in met deze cookies. ",
		"home": "Home",
		"recently": "Recent",
		"supplements": "Supplementen",
		"extras": "Extras",
		"inforAndExtras": "Info en extras",
		"regions": "Regio's",
		"settings": "Instellingen",
		"region": "Regio",
		"login": "Log in",
		"logout": "Log uit",
		"help": "Help",
		"about": "Over",
		"disclaimer": "Disclaimer",
		"account": "Account",
		"accountLoggedIn": "Ingelogd",
		"accountLoggedInInfo": "u bent momenteel ingelogd.",
		"accountLoggedWithInfo": "u bent momenteel ingelogd",
		"accountLoggedOut": "Niet ingelogd",
		"version": "Versie",
		"platformversion": "Platform versie",
		"uuid": "UUID",
		"editor": "Editor",
		"developer": "Ontwikkelaar",
		"downloading": "Downloaden...",
		"Proceed": "Volgende",
		"journal": "Krant",
		"alsoRead": "Lees ook",
		"alsoWatch": "Bekijk ook",
		"alsoSee": "Zie ook",
		"authorising": "Authorisatie...",
		"notSupported": "Deze website kan enkel op moderne browsers weergegeven worden. Gelieve uw browser bij te werken of Chrome te downloaden.",
		"printImage": "Afbeelding",
		"printText": "Tekst",
		"print": "Print",
		"jumpBack": "Back",
		"noInternetNoVideo": "U moet verbonden zijn met het internet om deze video te kunnen bekijken.",
		"download": "Download",
		"fullPdfDownload": "Volledige publicatie",
		"pagePdfDownload": "Huidige pagina",
		"pdfDownloadTooltip": "Downloaden",
		"logoTooltip": "Terug naar de kiosk",
		"readerLogoTooltip": "Terug naar de kiosk",
		"landscapeToggle": "Lezen in liggende modus",
		"singlePage": "Weergave van één pagina",
		"singlePageShort": "één pagina",
		"doublePage": "Weergave van twee pagina’s",
		"doublePageShort": "twee pagina’s",
		"passwordForgottenLoadingText": "Gelieve even te wachten terwijl de pagina laadt",
		"landscapeToggleEExplanation": "Wanneer u in liggende modus leest, kan u kiezen om één pagina in de volledige breedte weer te geven of om twee pagina’s naast elkaar weer te geven.",
		"PleaseFillInAValidEmail": "Gelieve een geldig e-mailadres in te vullen.",
		"LeftPage": "Linkerpagina",
		"RightPage": "Rechterpagina",
		"Sorry": "Sorry!",
		"close": "Sluiten",
		"printLeftPage": "Linkerpagina",
		"printRightPage": "Rechterpagina",
		"printSinglePage": "Huidige pagina",
		"cropPrint": "Print",
		"cropPrintInstruction": "Om de volledige pagina te printen, druk \"Print\".<br>Om een deel van de pagina of een specifiek artikel te printen, pas de grootte aan van de blauwe kader door de hoeken te verslepen en ze te plaatsen rond het deel van de pagina dat u zou willen printen.",
		"cropPrintTitle": "Print",
		"openCMPSetting": "Mijn privacy instellingen",
		"dataPolicy": "Persoonlijke gegevens",
		"privacyPolicy": "Cookie beleid",
		"singlePageMode": "Weergave van één pagina",
		"doublePageMode": "Weergave van twee pagina's",
		"readingModeToggle": "Leesmodus",
		"E1": "De systemen zijn niet beschikbaar, gelieve later opnieuw te proberen.",
		"E2": "",
		"E3": "De authenticatie service is momenteel onbeschikbaar",
		"E4": "De systemen zijn niet beschikbaar, gelieve later opnieuw te proberen.",
		"E5": "U heeft momenteel geen digitale toegang.",
		"E6": "Fout wachtwoord en/of e-mailadres/gebruikersnaam",
		"E7": "Fout wachtwoord en/of e-mailadres/gebruikersnaam",
		"E8": "De krant kan momenteel niet geopend worden. Probeer later opnieuw.",
		"E9": "De systemen zijn niet beschikbaar, gelieve later opnieuw te proberen.",
		"E11": "U heeft met dit abonnement het maximaal aantal toegangen tot deze editie bereikt.",
		"E13": "De systemen zijn niet beschikbaar, gelieve later opnieuw te proberen.",
		"E15": "De systemen zijn niet beschikbaar, gelieve later opnieuw te proberen.",
		"E16": "Er is een onverwachte fout opgetreden",
		"E17": "De authenticatie service is momenteel onbeschikbaar",
		"E20": "De authenticatie service is momenteel onbeschikbaar",
		"E21": "De authenticatie service is momenteel onbeschikbaar",
		"E24": "Uw abonnement heeft niet voldoende rechten om de publicatie te lezen.",
		"E25": "Maximum aantal gelijktijdige gebruikers bereikt voor dit abonnement. Probeer later opnieuw.",
		"E26": "Deze inloggegevens kunnen niet worden geverifieerd. Probeer het opnieuw of neem contact op met onze klantenservice."
	};

/***/ },
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var logger = {
	  error: function error(msg) {
	    console.error(msg); // eslint-disable-line
	  }
	};
	
	exports.default = logger;

/***/ },
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _appState = __webpack_require__(89);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	var _cookieComponent = __webpack_require__(263);
	
	var _cookieComponent2 = _interopRequireDefault(_cookieComponent);
	
	var _errorPopup = __webpack_require__(265);
	
	var _errorPopup2 = _interopRequireDefault(_errorPopup);
	
	var _loader = __webpack_require__(268);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _paywall = __webpack_require__(270);
	
	var _paywall2 = _interopRequireDefault(_paywall);
	
	var _regionmanager = __webpack_require__(275);
	
	var _regionmanager2 = _interopRequireDefault(_regionmanager);
	
	var _config = __webpack_require__(83);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _horsseriesStore = __webpack_require__(237);
	
	var _horsseriesStore2 = _interopRequireDefault(_horsseriesStore);
	
	var _authenticatorAuthorisationController = __webpack_require__(290);
	
	var _authenticatorAuthorisationController2 = _interopRequireDefault(_authenticatorAuthorisationController);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _cookiemanager = __webpack_require__(24);
	
	var _cookiemanager2 = _interopRequireDefault(_cookiemanager);
	
	var _iframeUtils = __webpack_require__(300);
	
	var _iframeUtils2 = _interopRequireDefault(_iframeUtils);
	
	var _sessionmanager = __webpack_require__(302);
	
	var _sessionmanager2 = _interopRequireDefault(_sessionmanager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsManager = __webpack_require__(88).default;
	var config = __webpack_require__(54).default;
	
	var App = function () {
	  function App() {
	    (0, _classCallCheck3.default)(this, App);
	    this.options = null;
	    this._appState = null;
	    this.DOMContainer = null;
	    this.sessionManager = null;
	    this.regionManager = null;
	    this.authenticatorAuthorisationController = null;
	
	    this.options = _config2.default.app;
	    this.DOMContainer = document.querySelector("#main-app");
	    if (window.location.search.indexOf("showpaywall") !== -1) {
	      this.options.sidemenu.settings.paywallRedirectionUrl = null;
	      this.options.settings.paywallRedirectionUrl = null;
	      this.options.downloadComponent.paywallRedirectionUrl = null;
	    }
	  }
	
	  (0, _createClass3.default)(App, [{
	    key: "initAppState",
	    value: function initAppState() {
	      var analyticsManager = new AnalyticsManager(config, this.options.showBackButtonParam);
	      this._appState = new _appState2.default(analyticsManager, this.options);
	    }
	  }, {
	    key: "init",
	    value: function init() {
	      var _this = this;
	
	      if (this.options.useCookiePostfix) {
	        _cookiemanager2.default.setPostFix(("mhu-ds").toUpperCase());
	      }
	      this.initAppState();
	      // only for debugging, make the app a global variable
	      if (false) {
	        window.appState = this._appState;
	      }
	      _cookiemanager2.default.refreshCookies();
	      this.sessionManager = new _sessionmanager2.default(_apimanager2.default, _cookiemanager2.default, this.options);
	      this.sessionManager.getSessionInfo().then(function () {
	        _this._appState.uuid = _this.sessionManager.UUID;
	        _this._appState.userId = _this.sessionManager.userId;
	        _this._appState.sessionId = _this.sessionManager.session.SessionInfo.SessionId;
	        _this._appState.timeBasedUnlimitedAccessEnabled = _this.sessionManager.session.AppConfigData.TimeBasedUnlimitedAccessEnabled ? _this.sessionManager.session.AppConfigData.TimeBasedUnlimitedAccessEnabled : false;
	        _this.regionManager = new _regionmanager2.default(_this._appState, _apimanager2.default, _cookiemanager2.default, _this.options.regionmanager);
	        if (_this.options.isReader) {
	          _this._appState.triggerEvent("RegionSet", _this.regionManager.getCurrentRegion());
	        }
	        //set number of articles that can be shared
	        _this._appState.socialSharingNumberOfArticles = _this.sessionManager.session.AppConfigData.SharingFreemiumLimit;
	        _this._appState.socialSharingReset = _this.sessionManager.session.AppConfigData.SocialSharingReset;
	        _this.authenticatorAuthorisationController = new _authenticatorAuthorisationController2.default(_this._appState, _this.sessionManager, _cookiemanager2.default, _this.options.authenticatorauthorisationcontroller);
	        _this.initRender();
	      }).catch(function () {
	        //TODO: show error dialog
	      });
	      window.addEventListener("message", function (e) {
	        (0, _iframeUtils2.default)(e);
	      }, false);
	    }
	  }, {
	    key: "render",
	    value: function render(dustfile) {
	      var _this2 = this;
	
	      if (this.DOMContainer !== null) {
	        Dust.render(dustfile, this.createContext(), function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	          _this2._appState.initResizer();
	          _this2.renderingDone();
	        });
	      }
	    }
	  }, {
	    key: "renderingDone",
	    value: function renderingDone() {
	      this.loader = new _loader2.default();
	      if (this.options.cookie.cookieEnabled) {
	        new _cookieComponent2.default(this._appState, this.DOMContainer.querySelector("#cookie"), _cookiemanager2.default, this.options.cookie);
	      }
	      this.paywall = new _paywall2.default(this._appState, this.authenticatorAuthorisationController, this.DOMContainer.querySelector("#paywall"), this.options.paywallcomponent);
	      this.errorPopup = new _errorPopup2.default(this._appState, this.DOMContainer.querySelector("#error"));
	      this.initAfterRendering();
	      this.attachListeners();
	      this.startApp();
	    }
	  }, {
	    key: "initHorsseriesStore",
	    value: function initHorsseriesStore(additionalDownloadTokens) {
	      var _this3 = this;
	
	      this.horsSeriesStore = new _horsseriesStore2.default(_apimanager2.default, additionalDownloadTokens, this.options.sizes.covers, this.options.horsserie, _dictionary2.default.moment, this.options.dateFormat);
	      this.horsSeriesStore.on("horsseries:loaded", function () {
	        _this3.onHorsseriesLoaded();
	      });
	      this.horsSeriesStore.loadHorsseries();
	    }
	
	    // methods to overwrite:
	
	  }, {
	    key: "initRender",
	    value: function initRender() {}
	  }, {
	    key: "createContext",
	    value: function createContext() {
	      return {};
	    }
	  }, {
	    key: "initAfterRendering",
	    value: function initAfterRendering() {}
	  }, {
	    key: "attachListeners",
	    value: function attachListeners() {}
	  }, {
	    key: "onHorsseriesLoaded",
	    value: function onHorsseriesLoaded() {}
	  }]);
	  return App;
	}();
	
	exports.default = App;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _helpButtonComponent = __webpack_require__(520);
	
	var _helpButtonComponent2 = _interopRequireDefault(_helpButtonComponent);
	
	var _utils = __webpack_require__(10);
	
	var _setting = __webpack_require__(234);
	
	var _setting2 = _interopRequireDefault(_setting);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpButtonComponent = function (_Emitter) {
	  (0, _inherits3.default)(HelpButtonComponent, _Emitter);
	
	  function HelpButtonComponent(appState, regionManager, sessionManager, paywall, options) {
	    (0, _classCallCheck3.default)(this, HelpButtonComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (HelpButtonComponent.__proto__ || (0, _getPrototypeOf2.default)(HelpButtonComponent)).call(this));
	
	    _this._appState = appState;
	    _this._regionManager = regionManager;
	    _this._sessionManager = sessionManager;
	    _this._paywall = paywall;
	    _this._options = options;
	    _this.DOMContainer = document.querySelector(".top-bar-container .top-bar-access");
	    _this._initSettings();
	    return _this;
	  }
	
	  (0, _createClass3.default)(HelpButtonComponent, [{
	    key: "render",
	    value: function render() {
	      var context = {
	        i18n: _dictionary2.default,
	        useCustomToolTip: this._options ? this._options.useCustomTooltips : false,
	        displayTopNavButtonlabel: this._options ? this._options.displayTopNavButtonlabel : false
	      };
	      if (this.DOMContainer) {
	        Dust.render(_helpButtonComponent2.default, context, this._renderDone.bind(this));
	      }
	    }
	
	    //////////////
	
	  }, {
	    key: "_renderDone",
	    value: function _renderDone(err, result) {
	      var div = (0, _utils.createDivWithClass)("help-button-component");
	      if (this._options && this._options.displayTopNavButtonlabel) {
	        div.classList.add("labelDisplayed");
	      }
	      div.innerHTML = result;
	      this.DOMContainer.appendChild(div);
	
	      this._attachEventListeners();
	    }
	  }, {
	    key: "_attachEventListeners",
	    value: function _attachEventListeners() {
	      var _this2 = this;
	
	      var help = this.DOMContainer.querySelector(".help-button-component");
	      if (help) {
	        help.addEventListener("click", function (e) {
	          _this2._onClickHandler(e);
	        });
	      }
	    }
	  }, {
	    key: "_initSettings",
	    value: function _initSettings() {
	      this.setting = new _setting2.default(this._appState, this._regionManager, this._sessionManager, this._paywall, this._options);
	    }
	  }, {
	    key: "_onClickHandler",
	    value: function _onClickHandler() {
	      var data = {
	        isReader: this._appState.isReader ? true : false
	      };
	      this._appState.triggerEvent(_analyticsevents.CLICKED_HELP, data, true);
	      this.setting.onHelpClick(true);
	    }
	  }]);
	  return HelpButtonComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = HelpButtonComponent;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _settingsButtonComponent = __webpack_require__(521);
	
	var _settingsButtonComponent2 = _interopRequireDefault(_settingsButtonComponent);
	
	var _utils = __webpack_require__(10);
	
	var _setting = __webpack_require__(234);
	
	var _setting2 = _interopRequireDefault(_setting);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingsButtonComponent = function (_Emitter) {
	  (0, _inherits3.default)(SettingsButtonComponent, _Emitter);
	
	  function SettingsButtonComponent(appState, regionManager, sessionManager, paywall, options) {
	    (0, _classCallCheck3.default)(this, SettingsButtonComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingsButtonComponent.__proto__ || (0, _getPrototypeOf2.default)(SettingsButtonComponent)).call(this));
	
	    _this._appState = appState;
	    _this._regionManager = regionManager;
	    _this._sessionManager = sessionManager;
	    _this._paywall = paywall;
	    _this._options = options;
	    _this.DOMContainer = document.querySelector(".top-bar-container .top-bar-access");
	    return _this;
	  }
	
	  (0, _createClass3.default)(SettingsButtonComponent, [{
	    key: "render",
	    value: function render() {
	      var context = {
	        i18n: _dictionary2.default,
	        useCustomToolTip: this._options ? this._options.useCustomTooltips : false,
	        displayTopNavButtonlabel: this._options ? this._options.displayTopNavButtonlabel : false
	      };
	      if (this.DOMContainer) {
	        Dust.render(_settingsButtonComponent2.default, context, this._renderDone.bind(this));
	      }
	    }
	
	    //////////////
	
	  }, {
	    key: "_renderDone",
	    value: function _renderDone(err, result) {
	      var div = (0, _utils.createDivWithClass)("settings-button-component");
	      if (this._options && this._options.displayTopNavButtonlabel) {
	        div.classList.add("labelDisplayed");
	      }
	      div.innerHTML = result;
	      this.DOMContainer.appendChild(div);
	
	      this._attachEventListeners();
	    }
	  }, {
	    key: "_attachEventListeners",
	    value: function _attachEventListeners() {
	      this.DOMContainer.querySelector(".settings-button-component").addEventListener("click", this._onClickHandler.bind(this));
	    }
	  }, {
	    key: "_initSettings",
	    value: function _initSettings() {
	      var _this2 = this;
	
	      this.setting = new _setting2.default(this._appState, this._regionManager, this._sessionManager, this._paywall, this._options);
	      this.setting.on("setting:onRegionChanged", function () {
	        _this2.trigger("settingComponent:onRegionChanged");
	      });
	      this.setting.on("setting:onLoginChanged", function () {
	        _this2.trigger("settingComponent:onLoginChanged");
	      });
	    }
	  }, {
	    key: "_onClickHandler",
	    value: function _onClickHandler() {
	      this._appState.triggerEvent(_analyticsevents.CLICKED_SETTINGS);
	      this._appState.trigger("settingButton:clicked");
	      if (!this.setting) {
	        this._initSettings();
	      }
	      this.setting.open();
	    }
	  }]);
	  return SettingsButtonComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = SettingsButtonComponent;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _logger = __webpack_require__(410);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _topBarComponent = __webpack_require__(522);
	
	var _topBarComponent2 = _interopRequireDefault(_topBarComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoHomePath;
	var logoReaderPath;
	try {
	  logoHomePath = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./../../../../clients/mhu-ds/images/logo_home.png\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	} catch (error) {
	  logoHomePath = __webpack_require__(423);
	}
	try {
	  logoReaderPath = __webpack_require__(524);
	} catch (error) {
	  logoReaderPath = __webpack_require__(423);
	}
	
	var TopBarComponent = function (_Emitter) {
	  (0, _inherits3.default)(TopBarComponent, _Emitter);
	
	  function TopBarComponent() {
	    (0, _classCallCheck3.default)(this, TopBarComponent);
	    return (0, _possibleConstructorReturn3.default)(this, (TopBarComponent.__proto__ || (0, _getPrototypeOf2.default)(TopBarComponent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TopBarComponent, [{
	    key: "render",
	    value: function render(pointer) {
	      var _this2 = this;
	
	      var useToolTip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var isReader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var DOMContainer = document.querySelector(".top-bar-container");
	      var context = {
	        useCustomToolTip: useToolTip,
	        isReader: isReader,
	        i18n: _dictionary2.default
	      };
	      if (!DOMContainer) {
	        _logger2.default.error("Node with class .top-bar-container not found");
	        return;
	      }
	      Dust.render(_topBarComponent2.default, context, function (err, result) {
	        DOMContainer.innerHTML = result;
	        var logo = DOMContainer.querySelector(".logo");
	        var logoContainer = DOMContainer.querySelector(".top-bar-logo");
	        if (pointer) {
	          logoContainer.style.cursor = "pointer";
	        }
	        logo.onload = function () {
	          _this2.trigger("topBar:rendered");
	          logoContainer.addEventListener("click", function () {
	            _this2.trigger("topBar:logoClicked");
	          });
	        };
	        logo.onerror = function () {
	          _this2.trigger("topBar:rendered");
	        };
	        var element = document.querySelector("#app-container");
	        if (element && element.classList.contains("app-home")) {
	          logo.src = logoHomePath;
	        } else {
	          logo.src = logoReaderPath;
	          if (!useToolTip) {
	            logo.setAttribute("title", _dictionary2.default.readerLogoTooltip);
	          }
	        }
	      });
	    }
	  }]);
	  return TopBarComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = TopBarComponent;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-home-templates-publicationList",body_0);function body_0(chk,ctx){return chk.w("  <div class=\"archiveTitle\">").f(ctx.get(["titleName"], false),ctx,"h").w("</div><div class=\"publicationList-container publicationList-").f(ctx.get(["name"], false),ctx,"h").w("\"><div class=\"publicationList-prev publicationList-").f(ctx.get(["name"], false),ctx,"h").w("-prev\"></div><div class=\"publications-container publications-container-").f(ctx.get(["name"], false),ctx,"h").w("\">").s(ctx.get(["contentPackages"], false),ctx,{"block":body_1},{}).w("</div><div class=\"publicationList-next publicationList-").f(ctx.get(["name"], false),ctx,"h").w("-next\"></div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.x(ctx.get(["imageUrl"], false),ctx,{"block":body_2},{});}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"thumb-wrapper publicationList pointer ").x(ctx.get(["current"], false),ctx,{"block":body_3},{}).w("\" data-tid=\"").f(ctx.get(["ThumbnailId"], false),ctx,"h").w("\" ").x(ctx.get(["PublicationId"], false),ctx,{"block":body_4},{}).w(" data-contentpackageid='").f(ctx.get(["ContentPackageId"], false),ctx,"h").w("' data-url=\"").f(ctx.get(["url"], false),ctx,"h").w("\"><div class=\"thumb\"><img src=").f(ctx.get(["imageUrl"], false),ctx,"h").w("></div><div class=\"subTitle ").x(ctx.get(["class"], false),ctx,{"block":body_5},{}).w("\">").x(ctx.get(["customLabel"], false),ctx,{"else":body_6,"block":body_7},{}).w("</div></div>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("current");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("data-publicationid='").f(ctx.get(["PublicationId"], false),ctx,"h").w("'");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.f(ctx.get(["class"], false),ctx,"h");}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.f(ctx.get(["label"], false),ctx,"h");}body_6.__dustBody=!0;function body_7(chk,ctx){return chk.w("<span>").f(ctx.get(["customLabel"], false),ctx,"h").w("</span>");}body_7.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-home-templates-publicationList';

/***/ },
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo.png";

/***/ },
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _appHome = __webpack_require__(461);
	
	var _appHome2 = _interopRequireDefault(_appHome);
	
	var _config = __webpack_require__(83);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__.e/* nsure */(6, function (require) {
	  __webpack_require__(421);
	});
	
	if (_config2.default.app.homeRedirectionLink) {
	  if ((window.location.pathname.includes("index_org.html") || window.location.pathname.includes("prod_index.html")) == false) {
	    window.location.assign(_config2.default.app.homeRedirectionLink);
	  }
	}
	
	var app = new _appHome2.default();
	
	if (false) {
	  window.app = app;
	}

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _downloadcomponent = __webpack_require__(90);
	
	var _downloadcomponent2 = _interopRequireDefault(_downloadcomponent);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _contentPackageStore = __webpack_require__(236);
	
	var _contentPackageStore2 = _interopRequireDefault(_contentPackageStore);
	
	var _newsstandRedirectingStore = __webpack_require__(287);
	
	var _newsstandRedirectingStore2 = _interopRequireDefault(_newsstandRedirectingStore);
	
	var _promospotStore = __webpack_require__(288);
	
	var _promospotStore2 = _interopRequireDefault(_promospotStore);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _cookiemanager = __webpack_require__(24);
	
	var _cookiemanager2 = _interopRequireDefault(_cookiemanager);
	
	var _redirectorKeys = __webpack_require__(23);
	
	var _utils = __webpack_require__(10);
	
	var _app = __webpack_require__(414);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _helpButtonComponent = __webpack_require__(415);
	
	var _helpButtonComponent2 = _interopRequireDefault(_helpButtonComponent);
	
	var _settingsButtonComponent = __webpack_require__(416);
	
	var _settingsButtonComponent2 = _interopRequireDefault(_settingsButtonComponent);
	
	var _topBarComponent = __webpack_require__(417);
	
	var _topBarComponent2 = _interopRequireDefault(_topBarComponent);
	
	var _kiosque = __webpack_require__(462);
	
	var _kiosque2 = _interopRequireDefault(_kiosque);
	
	var _topNavButtonComponent = __webpack_require__(465);
	
	var _topNavButtonComponent2 = _interopRequireDefault(_topNavButtonComponent);
	
	var _appHome = __webpack_require__(505);
	
	var _appHome2 = _interopRequireDefault(_appHome);
	
	var _topBarCenter = __webpack_require__(508);
	
	var _topBarCenter2 = _interopRequireDefault(_topBarCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppHome = function (_App) {
	  (0, _inherits3.default)(AppHome, _App);
	
	  function AppHome() {
	    (0, _classCallCheck3.default)(this, AppHome);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AppHome.__proto__ || (0, _getPrototypeOf2.default)(AppHome)).call(this));
	
	    _this.closeRegionSelector = function (e) {
	      var topNavRegionSelector = _this.DOMContainer.querySelector("#region-list-container");
	      var region = _this.DOMContainer.querySelector(".current-region");
	
	      if (topNavRegionSelector !== e.target && !topNavRegionSelector.contains(e.target) && !region.contains(e.target)) {
	        if (!topNavRegionSelector.classList.contains("hidden")) {
	          _this._appState.triggerEvent(_analyticsevents.CLICKEDAWAY_REGIONSELECT_TOPNAV);
	          topNavRegionSelector.classList.add("hidden");
	          document.removeEventListener("click", _this.closeRegionSelector);
	        }
	      }
	    };
	
	    _this.init();
	    return _this;
	  }
	
	  (0, _createClass3.default)(AppHome, [{
	    key: "initRender",
	    value: function initRender() {
	      this.render(_appHome2.default);
	    }
	  }, {
	    key: "createContext",
	    value: function createContext() {
	      var context = {};
	      if (this.options.authenticatorauthorisationcontroller.subscriptionOptions.subscriptionType !== "free") {
	        context.access = _dictionary2.default.SignIn;
	      }
	      return context;
	    }
	  }, {
	    key: "initAfterRendering",
	    value: function initAfterRendering() {
	      var _this2 = this;
	
	      this.topBar = new _topBarComponent2.default();
	      this.topBar.render(this.options.logoRedirect, this.options.useCustomTooltips);
	      this.topBar.on("topBar:logoClicked", function () {
	        if (_this2.options.logoRedirect) {
	          window.top.location.href = _this2.options.logoRedirect;
	        }
	      });
	      this.topBar.on("topBar:rendered", function () {
	        var access = _this2.DOMContainer.querySelector(".top-bar-access");
	        if (access) {
	          _this2.renderLoginLink(access);
	          _this2.renderTopNavButton(access);
	          _this2.renderSettingsOption();
	          _this2.renderHelpOption();
	        }
	        var container = _this2.DOMContainer.querySelector(".top-bar-center");
	        if (container) {
	          Dust.render(_topBarCenter2.default, {}, function (err, result) {
	            container.innerHTML = result;
	            //retreive region
	            _this2.regionManager.getRegion(_this2.DOMContainer.querySelector("#regionSelector")).then(function (region) {
	              if (!_this2.regionManager.singleRegion) {
	                var arrow = container.querySelector(".top-bar-arrow");
	                if (arrow) {
	                  arrow.classList.remove("hidden");
	                  arrow.addEventListener("click", function () {
	                    _this2.regionClicked();
	                  });
	                }
	                var _region = _this2.DOMContainer.querySelector(".top-bar-container .top-bar-center .current-region .top-bar-region");
	                if (_region) {
	                  _region.classList.add("pointer");
	                  _region.addEventListener("click", function () {
	                    _this2.regionClicked();
	                  });
	                }
	              }
	              var downloadToken = (0, _utils.getParameterByName)("downloadToken");
	              if (downloadToken) {
	                window.location.href = (0, _utils.removeURLParameter)("downloadToken");
	              }
	              _this2.authenticatorAuthorisationController.authenticate().then(function () {}).catch(function () {}).then(function () {
	                //PAR-PAR needs the region name sent when the OPENED_HOME event is fired
	                _this2._appState.triggerEvent(_analyticsevents.OPENED_HOME, { region: region.Description }, true);
	              });
	              // this.authenticatorAuthorisationController.authenticate();  //TODO: uncaught in promise
	            });
	          });
	        }
	      });
	      this.kiosque = new _kiosque2.default(this._appState, this.DOMContainer.querySelector("#app-content"), this.options.kiosque);
	    }
	  }, {
	    key: "onPublicationClicked",
	    value: function onPublicationClicked(publicationData) {
	      var _this3 = this;
	
	      publicationData.price = this.contentPackageStore.getContentPackagePrice(publicationData.contentPackageId);
	      if (publicationData.price === undefined) {
	        publicationData.price = this.horsSeriesStore.getContentPackagePrice(publicationData.contentPackageId);
	      }
	      this.loader.show();
	      var downloadComponent = new _downloadcomponent2.default(this.authenticatorAuthorisationController, this.paywall, this.options.downloadComponent, _apimanager2.default, this._appState, this.errorPopup);
	      downloadComponent.on("downloadComponent:succes", function (data) {
	        _this3.goToPublication(data);
	      });
	      downloadComponent.on("downloadComponent:close", function () {
	        _this3.loader.hide();
	      });
	      downloadComponent.validateDownload(publicationData, true);
	    }
	  }, {
	    key: "goToPublication",
	    value: function goToPublication(publicationData) {
	      this.loader.hide();
	      (0, _utils.goToPublication)(publicationData, this.options.kiosque.homeRelativeDepth);
	    }
	  }, {
	    key: "regionClicked",
	    value: function regionClicked() {
	      var element = this.DOMContainer.querySelector("#region-list-container");
	      if (element) {
	        if (element.classList.contains("hidden")) {
	          this.regionManager.getRegion(element, true, true).then(function () {});
	          document.addEventListener("click", this.closeRegionSelector);
	          this._appState.triggerEvent(_analyticsevents.CLICKED_REGIONSELECT_TOPNAV);
	        } else {
	          element.classList.add("hidden");
	          this._appState.triggerEvent(_analyticsevents.CLOSED_REGIONSELECT_TOPNAV);
	        }
	      }
	    }
	  }, {
	    key: "accessClicked",
	    value: function accessClicked() {
	      var _this4 = this;
	
	      if (this._appState.isLoggedIn) {
	        this.authenticatorAuthorisationController.logOut();
	        this._appState.triggerEvent(_analyticsevents.CLICKED_SIGNOUT_TOPNAV);
	      } else {
	        if (this.options.downloadComponent.paywallRedirectionUrl) {
	          var number = _cookiemanager2.default.getNumberOfRedirects();
	          if (number >= this.options.downloadComponent.paywallRedirectionNumber) {
	            this._appState.triggerEvent(_analyticsevents.REACHED_REDIRECT_LIMIT);
	            this.paywall.show();
	          } else {
	            _apimanager2.default.getUserProfileValue(_redirectorKeys.PAYWALL_REDIRECTION).then(function (result) {
	              if (result && result[0] && result[0].Value && result[0].Value.length > 0) {
	                _cookiemanager2.default.setNumberOfRedirects(number + 1, _this4.options.downloadComponent.paywallRedirectionTimeReset);
	                window.top.location.href = (0, _utils.createRedirectionUrl)(result[0].Value, _this4.authenticatorAuthorisationController, _this4.options.authenticatorauthorisationcontroller);
	              } else {
	                _this4.paywall.show();
	              }
	            }).catch(function () {
	              _this4.paywall.show();
	            });
	          }
	        } else {
	          this.paywall.show();
	        }
	        this._appState.triggerEvent(_analyticsevents.CLICKED_SIGNIN_TOPNAV);
	      }
	    }
	  }, {
	    key: "attachListeners",
	    value: function attachListeners() {
	      var _this5 = this;
	
	      this._appState.on("appState:authenticationstatuschanged", function () {
	        _this5.onAuthenticationStatusChanged();
	      });
	      this._appState.on("appState:downloadtokenchanged", function () {
	        _this5.onDownloadTokenChanged();
	      });
	      this.kiosque.on("kiosque:onPublicationClicked", function (publicationData) {
	        _this5.onPublicationClicked(publicationData);
	      });
	    }
	  }, {
	    key: "onDownloadTokenChanged",
	    value: function onDownloadTokenChanged() {
	      var region = this.DOMContainer.querySelector(".top-bar-container .top-bar-center .top-bar-region");
	      if (region) {
	        if (this.options.kiosque && this.options.kiosque.customKiosqueTitle.length > 0) {
	          region.innerHTML = this.options.kiosque.customKiosqueTitle;
	        } else {
	          region.innerHTML = this.regionManager.getCurrentRegion().Description;
	        }
	      }
	      this.initStores();
	    }
	  }, {
	    key: "onAuthenticationStatusChanged",
	    value: function onAuthenticationStatusChanged() {
	      var login = "";
	      var divLogin = this.DOMContainer.querySelector(".top-bar-container .top-bar-access .access-login");
	      if (this._appState.isLoggedIn) {
	        login = _dictionary2.default.SignOut;
	        divLogin.classList.add("signOut");
	        if (this.options.kiosque && this.options.kiosque.toggleSubscriptionTopNavButtonOnUserLoggedIn && divLogin) {
	          divLogin.classList.add("hidden");
	        }
	      } else {
	        login = _dictionary2.default.SignIn;
	        divLogin.classList.remove("signOut");
	        if (this.options.kiosque && this.options.kiosque.toggleSubscriptionTopNavButtonOnUserLoggedIn && divLogin) {
	          divLogin.classList.remove("hidden");
	        }
	      }
	
	      if (divLogin) {
	        divLogin.innerHTML = login;
	      }
	    }
	  }, {
	    key: "initStores",
	    value: function initStores() {
	      var _this6 = this;
	
	      _apimanager2.default.getAdditionalDownloadTokens().then(function (json) {
	        //for sidemenu
	        _this6.initHorsseriesStore(json);
	      }).catch(_utils.noop);
	      this.initContentPackageStore();
	      this.initPromospotStore();
	      this.initNewsstandRedirectingStore();
	    }
	  }, {
	    key: "initContentPackageStore",
	    value: function initContentPackageStore() {
	      var _this7 = this;
	
	      this.contentPackageStore = new _contentPackageStore2.default(_apimanager2.default, _dictionary2.default.moment, this.options.sizes.covers, this.options.dateFormat, this.options.contentPackageStore);
	      this.contentPackageStore.on("contentPackages:loaded", function () {
	        _this7.onContentPackagesLoaded();
	      });
	      this.contentPackageStore.loadContentPackages(this._appState.downloadToken, Math.max(this.options.kiosque.archiveLength, this.options.sidemenu.recentlyLength));
	    }
	  }, {
	    key: "initPromospotStore",
	    value: function initPromospotStore() {
	      var _this8 = this;
	
	      if (this.options.kiosque.usePromoSpot) {
	        this.promospotStore = new _promospotStore2.default(_apimanager2.default, this.options.sizes.covers, this.options.promospot);
	        this.promospotStore.on("promospot:loaded", function () {
	          _this8.onPromospotLoaded();
	        });
	        this.promospotStore.loadPromospot(this._appState.downloadToken);
	      }
	    }
	  }, {
	    key: "initNewsstandRedirectingStore",
	    value: function initNewsstandRedirectingStore() {
	      var _this9 = this;
	
	      if (this.options.newsstandRedirecting && this.options.newsstandRedirecting.length) {
	        this.newsstandRedirectingStore = new _newsstandRedirectingStore2.default(_apimanager2.default, this.options.newsstandRedirecting, this.options.sizes.covers, this._appState.downloadToken);
	        this.newsstandRedirectingStore.on("NewsstandRedirecting:loaded", function () {
	          _this9.onNewsstandRedirectingLoaded();
	        });
	        this.newsstandRedirectingStore.loadNewsstandRedirecting();
	      }
	    }
	  }, {
	    key: "onNewsstandRedirectingLoaded",
	    value: function onNewsstandRedirectingLoaded() {
	      var packages = this.newsstandRedirectingStore.getAllContentPackages();
	      this.kiosque.setNewsstandRedirecting(packages);
	    }
	  }, {
	    key: "onContentPackagesLoaded",
	    value: function onContentPackagesLoaded() {
	      var packages = this.contentPackageStore.getAllContentPackages();
	      this.kiosque.setContentPackages(packages);
	    }
	  }, {
	    key: "onPromospotLoaded",
	    value: function onPromospotLoaded() {
	      this.kiosque.setPromospot(this.promospotStore.getPromospotList());
	    }
	  }, {
	    key: "onHorsseriesLoaded",
	    value: function onHorsseriesLoaded() {
	      if (this.options.kiosque.displayHorsSerieArchive) {
	        var packages = this.horsSeriesStore.getHorsseries();
	        this.kiosque.setHorsseries(packages);
	      }
	    }
	  }, {
	    key: "startApp",
	    value: function startApp() {
	      //this._appState.triggerEvent(OPENED_HOME);
	    }
	  }, {
	    key: "renderTopNavButton",
	    value: function renderTopNavButton(container) {
	      if (this.options.kiosque.topNavBtnCookieConsent) {
	        new _topNavButtonComponent2.default(this._appState, container, this.options.kiosque, true);
	      } else {
	        new _topNavButtonComponent2.default(this._appState, container, this.options.kiosque);
	      }
	    }
	  }, {
	    key: "renderLoginLink",
	    value: function renderLoginLink(container) {
	      var _this10 = this;
	
	      var subscriptionType = this.options.settings.subscriptionOptions.subscriptionType;
	
	      if (!container || subscriptionType === "free") return;
	      var accessLogin = (0, _utils.createDivWithClass)("access-login");
	
	      if (this._appState.isLoggedIn) {
	        accessLogin.classList.add("signOut");
	        if (this.options.kiosque && this.options.kiosque.toggleSubscriptionTopNavButtonOnUserLoggedIn) {
	          accessLogin.classList.add("hidden");
	        }
	      } else {
	        accessLogin.classList.remove("signOut");
	      }
	
	      accessLogin.innerHTML = _dictionary2.default.SignIn;
	      accessLogin.classList.add("pointer");
	      container.appendChild(accessLogin);
	      accessLogin.addEventListener("click", function () {
	        _this10.accessClicked();
	      });
	    }
	  }, {
	    key: "renderSettingsOption",
	    value: function renderSettingsOption() {
	      if (this.options.settings.turnOnSettings) {
	        var settingsButtonComponent = new _settingsButtonComponent2.default(this._appState, this.regionManager, this.sessionManager, this.paywall, this.options.settings);
	        settingsButtonComponent.render();
	      }
	    }
	  }, {
	    key: "renderHelpOption",
	    value: function renderHelpOption() {
	      if (this.options.help && this.options.help.turnOnHeaderHelp) {
	        var helpButtonComponent = new _helpButtonComponent2.default(this._appState, this.regionManager, this.sessionManager, this.paywall, this.options.settings);
	        helpButtonComponent.render();
	      }
	    }
	  }]);
	  return AppHome;
	}(_app2.default);
	
	exports.default = AppHome;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _kiosque = __webpack_require__(267);
	
	var _kiosque2 = _interopRequireDefault(_kiosque);
	
	var _kiosque3 = __webpack_require__(506);
	
	var _kiosque4 = _interopRequireDefault(_kiosque3);
	
	var _publicationList2 = __webpack_require__(418);
	
	var _publicationList3 = _interopRequireDefault(_publicationList2);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _preferredViewerSwitcher = __webpack_require__(233);
	
	var _preferredViewerSwitcher2 = _interopRequireDefault(_preferredViewerSwitcher);
	
	var _publicationList4 = __webpack_require__(463);
	
	var _publicationList5 = _interopRequireDefault(_publicationList4);
	
	var _publicationListSwiper = __webpack_require__(464);
	
	var _publicationListSwiper2 = _interopRequireDefault(_publicationListSwiper);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Contstructs the Kiosque view
	 */
	var Kiosque = function (_CommonKiosque) {
	  (0, _inherits3.default)(Kiosque, _CommonKiosque);
	
	  function Kiosque(appState, DOMContainer, options) {
	    (0, _classCallCheck3.default)(this, Kiosque);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Kiosque.__proto__ || (0, _getPrototypeOf2.default)(Kiosque)).call(this, appState, DOMContainer, _kiosque4.default, options));
	
	    _this.onReadingModeChanged = function (readingModeType) {
	      if (readingModeType === "nextgen") {
	        _this.appState.triggerEvent(_analyticsevents.CLICKED_NEXTGEN_READING_MODE_HOME);
	      } else {
	        _this.appState.triggerEvent(_analyticsevents.CLICKED_REPLICA_READING_MODE_HOME);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Kiosque, [{
	    key: "attatchClickHandlers",
	    value: function attatchClickHandlers() {}
	  }, {
	    key: "renderDone",
	    value: function renderDone() {
	      if (this.options.displayViewerOptions) {
	        var preferredViewerSwitcher = new _preferredViewerSwitcher2.default(this.appState, document.getElementById("preferred-viewer-box"));
	        preferredViewerSwitcher.on("readingModeSwitcher:clicked", this.onReadingModeChanged);
	        preferredViewerSwitcher.render();
	      }
	    }
	  }, {
	    key: "setArchive",
	    value: function setArchive(contentPackages) {
	      var _this2 = this;
	
	      this.setPublicationList("archive", _dictionary2.default.Archive, contentPackages, _analyticsevents.CLICKED_ARCHIVE_HOME, _analyticsevents.SWIPED_ARCHIVE_HOME, _analyticsevents.CLICKED_ARROW_ARCHIVE_HOME, this.options.useSlider.useSliderForArchive).then(function () {
	        _this2.appState.triggerEvent("archive:loaded", _this2.appState._downloadToken);
	      });
	    }
	  }, {
	    key: "setPromospot",
	    value: function setPromospot(contentPackages) {
	      if (this.options.usePromoSpot) {
	        this.setPublicationList("promoSpot", _dictionary2.default.Promospot, contentPackages, _analyticsevents.CLICKED_PROMOSPOT_HOME, _analyticsevents.SWIPED_PROMOSPOT_HOME, _analyticsevents.CLICKED_ARROW_PROMOSPOT_HOME, this.options.useSlider.useSliderForPromospot);
	      }
	    }
	  }, {
	    key: "setHorsseries",
	    value: function setHorsseries(contentPackages) {
	      if (this.options.displayHorsSerieArchive) {
	        this.setPublicationList("horsserie", _dictionary2.default.HorsSeries, contentPackages, _analyticsevents.CLICKED_SPECIALS_HOME, _analyticsevents.SWIPED_SPECIALS_HOME, _analyticsevents.CLICKED_ARROW_SPECIALS_HOME, this.options.useSlider.useSliderForHorsSeries);
	      }
	    }
	  }, {
	    key: "setPublicationList",
	    value: function setPublicationList(name, titleName, contentPackages, clickedEvent, swipedEvent, arrowEvent) {
	      var _this3 = this;
	
	      var swiper = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	
	      if (this.DOMContent) {
	        var _publicationList = void 0;
	        if (swiper) {
	          _publicationList = new _publicationListSwiper2.default(this.appState, this.DOMContent, name, titleName, contentPackages, clickedEvent, swipedEvent, arrowEvent);
	        } else {
	          _publicationList = new _publicationList5.default(this.appState, this.DOMContent, name, titleName, contentPackages, clickedEvent);
	        }
	
	        _publicationList.on("publicationList:onPublicationClicked", function (e) {
	          _this3.onPublicationClick(e);
	        });
	        return _publicationList.render();
	      } else {
	        // FIXME The timeout existed before i wrapped the promise around it, please forgive me
	        return new _promise2.default(function (resolve) {
	          setTimeout(function () {
	            _this3.setPublicationList(name, titleName, contentPackages, clickedEvent, swipedEvent, arrowEvent, swiper).then(function () {
	              resolve();
	            });
	          }, 100);
	        });
	      }
	    }
	  }, {
	    key: "setNewsstandRedirecting",
	    value: function setNewsstandRedirecting(packages) {
	      var _this4 = this;
	
	      if (this.DOMContent) {
	        if (packages.length === 0) {
	          return;
	        }
	        var container = this.DOMContent.querySelector("#newsStand");
	        if (container) {
	          var context = {};
	          context.contentPackages = packages;
	          context.name = "newsstand";
	          context.titleName = _dictionary2.default.NewsStand;
	          Dust.render(_publicationList3.default, context, function (err, result) {
	            container.innerHTML = result;
	            $(container).on("click", ".thumb-wrapper", function (e) {
	              window.location = $(e.currentTarget).data("url");
	              _this4.appState.triggerEvent(_analyticsevents.CLICKED_NEWSSTAND);
	            });
	          });
	        }
	      } else {
	        setTimeout(function () {
	          _this4.setNewsstandRedirecting(packages);
	        }, 100);
	      }
	    }
	  }]);
	  return Kiosque;
	}(_kiosque2.default);
	
	exports.default = Kiosque;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _publicationList = __webpack_require__(418);
	
	var _publicationList2 = _interopRequireDefault(_publicationList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Contstructs the Kiosque view
	 */
	var PublicationList = function (_Emitter) {
	  (0, _inherits3.default)(PublicationList, _Emitter);
	
	  function PublicationList(appState, DOMContent, name, titleName, contentPackages, clickedEvent, options) {
	    (0, _classCallCheck3.default)(this, PublicationList);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PublicationList.__proto__ || (0, _getPrototypeOf2.default)(PublicationList)).call(this));
	
	    _this.appState = appState;
	    _this.DOMContent = DOMContent;
	    _this.name = name;
	    _this.titleName = titleName;
	    _this.contentPackages = contentPackages;
	    _this.clickedEvent = clickedEvent;
	    _this.options = options;
	    return _this;
	  }
	
	  (0, _createClass3.default)(PublicationList, [{
	    key: "createContext",
	    value: function createContext() {
	      var context = {};
	      context.contentPackages = this.contentPackages;
	      context.name = this.name;
	      context.titleName = this.titleName;
	      return context;
	    }
	
	    /**
	     * Functions that inserts the publication list into the DOM
	     * @returns {Promise} result of rendering
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.DOMContent) {
	        if (this.contentPackages.length === 0) {
	          return _promise2.default.resolve();
	        }
	        return new _promise2.default(function (resolve, reject) {
	          var container = _this2.DOMContent.querySelector("#" + _this2.name);
	          if (container) {
	            Dust.render(_publicationList2.default, _this2.createContext(), function (err, result) {
	              container.innerHTML = result;
	              $(container).on("click", ".thumb-wrapper", function (e) {
	                _this2.trigger("publicationList:onPublicationClicked", e);
	                _this2.appState.triggerEvent(_this2.clickedEvent);
	                resolve();
	              });
	            });
	          } else {
	            reject();
	          }
	        });
	      } else {
	        // FIXME The timeout existed before i wrapped the promise around it, please forgive me
	        return new _promise2.default(function (resolve) {
	          setTimeout(function () {
	            _this2.render().then(function () {
	              return resolve();
	            });
	          }, 100);
	        });
	      }
	    }
	  }]);
	  return PublicationList;
	}(_es6EventEmitter2.default);
	
	exports.default = PublicationList;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _swiper = __webpack_require__(51);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _lodash = __webpack_require__(82);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _publicationListSwiper = __webpack_require__(507);
	
	var _publicationListSwiper2 = _interopRequireDefault(_publicationListSwiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Contstructs the Kiosque view
	 */
	var PublicationListSwiper = function (_Emitter) {
	  (0, _inherits3.default)(PublicationListSwiper, _Emitter);
	
	  function PublicationListSwiper(appState, DOMContent, name, titleName, contentPackages, clickedEvent, swipedEvent, arrowEvent) {
	    (0, _classCallCheck3.default)(this, PublicationListSwiper);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PublicationListSwiper.__proto__ || (0, _getPrototypeOf2.default)(PublicationListSwiper)).call(this));
	
	    _this._onWidowResize = function () {
	      _this.resize();
	    };
	
	    _this.appState = appState;
	    _this.DOMContent = DOMContent;
	    _this.name = name;
	    _this.titleName = titleName;
	    _this.contentPackages = contentPackages;
	    _this.clickedEvent = clickedEvent;
	    _this.swipedEvent = swipedEvent;
	    _this.arrowEvent = arrowEvent;
	    _this._onWidowResize = (0, _lodash2.default)(_this._onWidowResize, 100);
	    return _this;
	  }
	
	  (0, _createClass3.default)(PublicationListSwiper, [{
	    key: "createContext",
	    value: function createContext() {
	      var context = {};
	      context.slides = this.contentPackages;
	      context.name = this.name;
	      context.titleName = this.titleName;
	      return context;
	    }
	
	    /**
	     * Functions that inserts the publication list into the DOM
	     * @returns {Promise} result of rendering
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.DOMContent) {
	        if (this.contentPackages.length === 0) {
	          return _promise2.default.resolve();
	        }
	        return new _promise2.default(function (resolve, reject) {
	          var container = _this2.DOMContent.querySelector("#" + _this2.name);
	          if (container) {
	            Dust.render(_publicationListSwiper2.default, _this2.createContext(), function (err, result) {
	              container.innerHTML = result;
	              _this2.setSwiperInstance();
	              resolve();
	            });
	          } else {
	            reject();
	          }
	        });
	      } else {
	        return new _promise2.default(function (resolve) {
	          setTimeout(function () {
	            _this2.render().then(resolve());
	          }, 100);
	        });
	      }
	    }
	  }, {
	    key: "attachListeners",
	    value: function attachListeners() {
	      var _this3 = this;
	
	      var divs = this.DOMContent.querySelectorAll(".swiper-wrapper-" + this.name + " .swiper-slide");
	      var size = divs.length;
	      for (var i = 0; i < size; i++) {
	        var div = divs[i];
	        div.addEventListener("click", function (e) {
	          _this3.trigger("publicationList:onPublicationClicked", e);
	          _this3.appState.triggerEvent(_this3.clickedEvent);
	        });
	      }
	      this.DOMContent.querySelector("#" + this.name + " .publicationList-prev").addEventListener("click", function () {
	        _this3.clickedArrow = true;
	        _this3.appState.triggerEvent(_this3.arrowEvent);
	        _this3.swiper.slidePrev();
	      });
	      this.DOMContent.querySelector("#" + this.name + " .publicationList-next").addEventListener("click", function () {
	        _this3.clickedArrow = true;
	        _this3.appState.triggerEvent(_this3.arrowEvent);
	        _this3.swiper.slideNext();
	      });
	    }
	  }, {
	    key: "hideNavigation",
	    value: function hideNavigation() {
	      this.DOMContent.querySelector("#" + this.name + " .publicationList-prev").classList.remove("sliderList");
	      this.DOMContent.querySelector("#" + this.name + " .publicationList-next").classList.remove("sliderList");
	    }
	  }, {
	    key: "showNavigation",
	    value: function showNavigation() {
	      this.DOMContent.querySelector("#" + this.name + " .publicationList-prev").classList.add("sliderList");
	      this.DOMContent.querySelector("#" + this.name + " .publicationList-next").classList.add("sliderList");
	    }
	
	    /**
	     * Calculates and returns a number of values needed to create a swiper.
	     * These values are calculated based on the sizing of certain
	     * elements in the DOMContent.
	     *
	     * WARNING: there is a known bug where the `.thumb-wrapper` selector finds unexpected
	     * elements (e.g. one of the buttons at the bottom of the kiosk in PAR-PAR).
	     * Root cause is that:
	     * - too many elements are marked with the class `.thumbnail-wrapper`
	     * - `DOMContent.querySelector()` uses a depth-first algorithm which
	     * may produce different results based on current DOM state.
	     * @returns an object containing a `number`, `width`, `margin` and `slidesOffsetAfter`.
	     */
	
	  }, {
	    key: "calculateSpecs",
	    value: function calculateSpecs() {
	      var dimensions = {};
	      var totalWidth = this.DOMContent.querySelector("#" + this.name).getBoundingClientRect().width - 2 * $(this.DOMContent.querySelector("#" + this.name + " .publicationList-next")).outerWidth(true);
	      var margin = 30;
	      var slideWidth = $(this.DOMContent.querySelector(".thumb-wrapper")).outerWidth(true) + margin;
	      var number = Math.floor(totalWidth / slideWidth);
	      var width = number * slideWidth - margin;
	
	      var restValue = this.contentPackages.length % number;
	      var slidesOffsetAfter = 0;
	      if (this.contentPackages.length > number && restValue > 0) {
	        slidesOffsetAfter = (number - restValue) * slideWidth;
	      }
	
	      if (this.contentPackages.length > 1 && this.contentPackages.length > number) {
	        this.showNavigation();
	      } else {
	        this.hideNavigation();
	      }
	
	      dimensions.number = number;
	      dimensions.width = width;
	      dimensions.margin = margin;
	      dimensions.slidesOffsetAfter = slidesOffsetAfter;
	      return dimensions;
	    }
	  }, {
	    key: "resize",
	    value: function resize() {
	      if (this.swiper) {
	        var dimensions = this.calculateSpecs();
	        this.swiper.params.slidesPerView = dimensions.number;
	        this.swiper.params.slidesPerGroup = dimensions.number;
	        this.swiper.params.width = dimensions.width;
	        this.swiper.params.slidesOffsetAfter = dimensions.slidesOffsetAfter;
	        this.DOMContent.querySelector(".swiper-container-" + this.name).style.width = dimensions.width + "px";
	        this.swiper.update();
	        this.checkArrows();
	      }
	    }
	  }, {
	    key: "checkArrows",
	    value: function checkArrows() {
	      if (this.swiper) {
	        if (this.swiper.activeIndex == 0) {
	          this.DOMContent.querySelector("#" + this.name + " .publicationList-prev").classList.add("inactive");
	        } else {
	          this.DOMContent.querySelector("#" + this.name + " .publicationList-prev").classList.remove("inactive");
	        }
	        if (this.swiper.activeIndex + this.swiper.params.slidesPerView >= this.contentPackages.length) {
	          this.DOMContent.querySelector("#" + this.name + " .publicationList-next").classList.add("inactive");
	        } else {
	          this.DOMContent.querySelector("#" + this.name + " .publicationList-next").classList.remove("inactive");
	        }
	      }
	    }
	  }, {
	    key: "setThumbHeight",
	    value: function setThumbHeight(container) {
	      var sliderThumbs = document.querySelectorAll(container + " .thumb-wrapper");
	      var biggestHeight = 0;
	      [].forEach.call(sliderThumbs, function (sliderThumb) {
	        if (sliderThumb.clientHeight > biggestHeight) {
	          biggestHeight = sliderThumb.clientHeight;
	        }
	      });
	      [].forEach.call(sliderThumbs, function (sliderThumb) {
	        sliderThumb.style.minHeight = biggestHeight + "px";
	      });
	    }
	  }, {
	    key: "setSwiperInstance",
	    value: function setSwiperInstance() {
	      var _this4 = this;
	
	      var dimensions = this.calculateSpecs();
	      this.DOMContent.querySelector(".swiper-container-" + this.name).style.width = dimensions.width + "px";
	      this.swiper = new _swiper2.default(".swiper-container-" + this.name, {
	        slidesPerView: dimensions.number,
	        slidesPerGroup: dimensions.number,
	        spaceBetween: dimensions.margin,
	        slidesOffsetAfter: dimensions.slidesOffsetAfter,
	        updateOnImagesReady: true,
	        width: dimensions.width,
	        onTransitionEnd: function onTransitionEnd() {
	          _this4.checkArrows();
	          if (_this4.clickedArrow) {
	            _this4.clickedArrow = false;
	          } else {
	            _this4.appState.triggerEvent(_this4.swipedEvent);
	          }
	        },
	        onImagesReady: function onImagesReady() {
	          _this4.setThumbHeight(".swiper-container-" + _this4.name);
	        }
	      });
	      window.addEventListener("resize", this._onWidowResize);
	      this.checkArrows();
	      this.attachListeners();
	    }
	  }]);
	  return PublicationListSwiper;
	}(_es6EventEmitter2.default);
	
	exports.default = PublicationListSwiper;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _utils = __webpack_require__(10);
	
	var _redirectorKeys = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TopNavButtonComponent = function (_Emitter) {
	  (0, _inherits3.default)(TopNavButtonComponent, _Emitter);
	
	  function TopNavButtonComponent(appState, DOMContainer, options) {
	    var isCookieConsentButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	    (0, _classCallCheck3.default)(this, TopNavButtonComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TopNavButtonComponent.__proto__ || (0, _getPrototypeOf2.default)(TopNavButtonComponent)).call(this));
	
	    _this.appState = null;
	    _this.DOMContainer = null;
	    _this.DOMContent = null;
	    _this.options = null;
	
	    _this.appState = appState;
	    _this.DOMContainer = DOMContainer;
	    _this.options = options;
	    _this.isCookieConsentButton = isCookieConsentButton; //any object whose function needs to be called when the topNavButton is clicked.
	    _this.render();
	    _this.attachListeners();
	    return _this;
	  }
	
	  (0, _createClass3.default)(TopNavButtonComponent, [{
	    key: "attachListeners",
	    value: function attachListeners() {
	      var _this2 = this;
	
	      this.appState.on("appState:authenticationstatuschanged", function () {
	        _this2.onAuthenticationStatusChanged();
	      });
	    }
	  }, {
	    key: "retrieveUrl",
	    value: function retrieveUrl() {
	      var _this3 = this;
	
	      var promise = new _promise2.default(function (resolve) {
	        if (_this3.appState.isDesktop) {
	          _apimanager2.default.getRedirectorUrl(_redirectorKeys.TOPNAV_BUTTON, _this3.appState.buildVersion, _this3.appState.userId, _this3.appState.downloadToken).then(function (url) {
	            //TODO: fill in parameters
	            _this3.url = url;
	            resolve(_this3.url);
	          }).catch(function () {
	            _this3.url = null;
	          });
	        }
	      });
	      return promise;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var topNavButton = (0, _utils.createDivWithClass)("top-nav_button");
	      if (this.options && this.options.topNavButtonHasFunction) {
	        this.createButton(topNavButton);
	        topNavButton.addEventListener("click", function () {
	          _this4.appState.analyticsManager.cmpManager.showPreference();
	        });
	      } else {
	        this.retrieveUrl().then(function () {
	          if (_this4.url && _this4.url != "") {
	            _this4.createButton(topNavButton);
	            topNavButton.addEventListener("click", function () {
	              window.open(_this4.url, "_blank");
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: "createButton",
	    value: function createButton(topNavButton) {
	      if (this.options && this.options.topNavButtonLabel) {
	        topNavButton.innerHTML = this.options.topNavButtonLabel;
	        topNavButton.classList.add("pointer");
	      }
	      if (this.options && this.options.toggleSubscriptionTopNavButtonOnUserLoggedIn && this.appState.isLoggedIn) {
	        topNavButton.classList.add("hidden");
	      }
	      this.DOMContainer.appendChild(topNavButton);
	    }
	  }, {
	    key: "onAuthenticationStatusChanged",
	    value: function onAuthenticationStatusChanged() {
	      var topNavButton = this.DOMContainer.querySelector(".top-nav_button");
	      if (this.appState.isLoggedIn) {
	        if (this.options && this.options.toggleSubscriptionTopNavButtonOnUserLoggedIn && topNavButton) {
	          topNavButton.classList.add("hidden");
	        }
	      } else {
	        if (this.options && this.options.toggleSubscriptionTopNavButtonOnUserLoggedIn && topNavButton) {
	          topNavButton.classList.remove("hidden");
	        }
	      }
	    }
	  }]);
	  return TopNavButtonComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = TopNavButtonComponent;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _appReader = __webpack_require__(467);
	
	var _appReader2 = _interopRequireDefault(_appReader);
	
	var _URLRouter = __webpack_require__(40);
	
	var _URLRouter2 = _interopRequireDefault(_URLRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__.e/* nsure */(6, function (require) {
	  __webpack_require__(421);
	});
	
	var urlRouter = new _URLRouter2.default();
	var cpid = urlRouter.contentpackageId;
	var pubid = urlRouter.publicationId;
	
	if (!cpid) {
	  console.log("URL is incorrect, could not parse out CPID"); // eslint-disable-line
	}
	
	new _appReader2.default({
	  contentPackageId: cpid,
	  publicationId: pubid
	});

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _app = __webpack_require__(414);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _appState = __webpack_require__(89);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	var _pubStore = __webpack_require__(289);
	
	var _pubStore2 = _interopRequireDefault(_pubStore);
	
	var _downloadcomponent = __webpack_require__(90);
	
	var _downloadcomponent2 = _interopRequireDefault(_downloadcomponent);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _contentmanager = __webpack_require__(96);
	
	var _contentmanager2 = _interopRequireDefault(_contentmanager);
	
	var _appReader = __webpack_require__(509);
	
	var _appReader2 = _interopRequireDefault(_appReader);
	
	var _viewer = __webpack_require__(479);
	
	var _viewer2 = _interopRequireDefault(_viewer);
	
	var _appReaderMixin = __webpack_require__(256);
	
	var _appReaderMixin2 = _interopRequireDefault(_appReaderMixin);
	
	var _globalStylingModifier = __webpack_require__(299);
	
	var _globalStylingModifier2 = _interopRequireDefault(_globalStylingModifier);
	
	var _utils = __webpack_require__(10);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _CDNAssetsDownloader = __webpack_require__(294);
	
	var _CDNAssetsDownloader2 = _interopRequireDefault(_CDNAssetsDownloader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsManager = __webpack_require__(88).default;
	var config = __webpack_require__(54).default;
	
	var AppReader = function (_App) {
	  (0, _inherits3.default)(AppReader, _App);
	
	  function AppReader(_ref) {
	    var contentPackageId = _ref.contentPackageId,
	        publicationId = _ref.publicationId;
	    (0, _classCallCheck3.default)(this, AppReader);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AppReader.__proto__ || (0, _getPrototypeOf2.default)(AppReader)).call(this));
	
	    _this.contentPackageId = null;
	    _this.publicationId = null;
	    _this.history = null;
	
	    _this.contentPackageId = contentPackageId;
	    _this.publicationId = publicationId;
	    _this.init();
	    (0, _globalStylingModifier2.default)();
	    return _this;
	  }
	
	  //initialise appState
	
	
	  (0, _createClass3.default)(AppReader, [{
	    key: "initAppState",
	    value: function initAppState() {
	      var analyticsManager = new AnalyticsManager(config, this.options.showBackButtonParam);
	      this.options.isReader = true;
	      this._appState = new _appState2.default(analyticsManager, this.options);
	      this._appState.initUsePdf(this.options.usePdf);
	      _appReaderMixin2.default.injectNextgenAssets.call(this);
	    }
	
	    //initialise rendering
	
	  }, {
	    key: "initRender",
	    value: function initRender() {
	      _appReaderMixin2.default.initHistory.call(this);
	      this._appState._authenticatorAuthorisationController = this.authenticatorAuthorisationController;
	      this._appState.contentPackageId = this.contentPackageId;
	      this.render(_appReader2.default);
	    }
	  }, {
	    key: "startApp",
	    value: function startApp() {
	      this.initStores();
	      this._appState.triggerEvent(_analyticsevents.INIT_READER);
	    }
	  }, {
	    key: "attachListeners",
	    value: function attachListeners() {
	      this._appState.on("preferredViewer:changed", this._onPreferredViewerChanged.bind(this));
	    }
	  }, {
	    key: "initStores",
	    value: function initStores() {
	      var _this2 = this;
	
	      _apimanager2.default.getAdditionalDownloadTokens().then(function (json) {
	        _appReaderMixin2.default.initCpStore.call(_this2, json);
	      }).catch(_utils.noop);
	    }
	  }, {
	    key: "onCpLoaded",
	    value: function onCpLoaded() {
	      var _this3 = this;
	
	      this.regionManager.setRegion(this.cpStore.CPackage.DownloadToken).then(function () {
	        _this3._appState.setContentPackage(_this3.cpStore.CPackageInfo, _this3.cpStore.CPackage.PublicationDate, _this3.regionManager.getCurrentRegion(), _this3.cpStore.CPackage.DownloadToken);
	        _this3._appState._sharingUrl = _this3.cpStore.sharingUrl;
	        _this3._appState._nextgenSharingUrl = _this3.cpStore.nextgenSharingUrl;
	        _this3.initOrUpdatePubStore(_this3.publicationId, false);
	      });
	    }
	
	    // call this method if pub id changes
	
	  }, {
	    key: "initOrUpdatePubStore",
	    value: function initOrUpdatePubStore(pubId) {
	      var _this4 = this;
	
	      var startFromZero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var init = !this.pubStore;
	      this.startFromZero = startFromZero;
	      if (init) {
	        this.pubStore = new _pubStore2.default(_apimanager2.default, _contentmanager2.default, this.cpStore.CPackage, this.contentPackageId, pubId, this.cpStore.getVersion(), this._appState, this.options.pubStore);
	        this.pubStore.on("pubStore:pubLoaded", this._onPublicationLoaded.bind(this));
	        _appReaderMixin2.default.initBridge.call(this);
	      }
	      this.publicationId = this.pubStore.pubId;
	      this._appState.publicationId = this.publicationId;
	      this.checkAuthorisation().then(function () {
	        //new dowload needed when navigating from main publication to supplements to retrieve the correct
	        //downloadCredentials
	        var newCredentialsNeeded = !_this4._appState.cdnAssetsDownloader || _this4.switchContentPackages;
	        if (!_this4._appState.cdnAssetsDownloader) {
	          _this4._appState.cdnAssetsDownloader = new _CDNAssetsDownloader2.default(_apimanager2.default, _this4._appState, _this4.sessionManager);
	        }
	        if (newCredentialsNeeded) {
	          _this4._appState.cdnAssetsDownloader.requestDownloadCredentials(true).then(function () {
	            if (init) {
	              _this4.pubStore.loadPub();
	            } else {
	              _this4.pubStore.reloadPub(pubId, _this4.contentPackageId, _this4.cpStore.getVersion());
	            }
	          });
	        } else {
	          if (init) {
	            _this4.pubStore.loadPub();
	          } else {
	            _this4.pubStore.reloadPub(pubId, _this4.contentPackageId, _this4.cpStore.getVersion());
	          }
	        }
	      });
	    }
	  }, {
	    key: "onPubStoreLoaded",
	    value: function onPubStoreLoaded() {
	      _appReaderMixin2.default.setupPublicationInAppState.call(this);
	
	      this._appState.totalPages = this.pubStore.CPackagePages.length;
	
	      this._appState.modifyContentPackage(this.pubStore.PublicationToLoad);
	
	      if (!this.viewer) {
	        this.initViewer();
	      } else {
	        this.viewer.reload();
	      }
	    }
	  }, {
	    key: "reCheckAuthorisation",
	    value: function reCheckAuthorisation() {
	      if (!this._appState.authorized) {
	        this.reCheck = true;
	        var publicationData = {
	          contentPackageId: this.contentPackageId,
	          publicationId: this.pubStore.pubId,
	          price: this.cpStore.CPackageInfo.price
	          // pageId: this._appState.currentPage
	        };
	        this.downloadcomponent.validateDownload(publicationData, true, true);
	      }
	    }
	  }, {
	    key: "onAuthorizeArticleFailed",
	    value: function onAuthorizeArticleFailed() {
	      if (this.viewer) {
	        this.viewer.checkAlb();
	        this.reCheckAuthorisation();
	      } else {
	        this.checkOnAuthorizeArticleFailed = true;
	      }
	    }
	  }, {
	    key: "initViewer",
	    value: function initViewer() {
	      var _this5 = this;
	
	      this._appState.on("appState:authorizeArticleFailed", function () {
	        _this5.onAuthorizeArticleFailed();
	      });
	      this._appState.on("appState:pageChangeNotAuthorised", function () {
	        _this5.reCheckAuthorisation();
	      });
	      this._appState.contentid = this.history.contentid;
	      this.history.updateLocation(this._appState.contentPackageId, this._appState._publicationId, this.history.page, 0, this.history.contentid, true);
	
	      this.viewer = new _viewer2.default({
	        appState: this._appState,
	        pubStore: this.pubStore,
	        cpStore: this.cpStore,
	        regionManager: this.regionManager,
	        paywall: this.paywall,
	        options: this.options,
	        sessionManager: this.sessionManager
	      });
	      if (this.checkOnAuthorizeArticleFailed) {
	        this.onAuthorizeArticleFailed();
	      }
	      this.viewer.on("albController:closeAlb", function () {
	        _this5.reCheckAuthorisation();
	      });
	      this.viewer.initComponents();
	      this.viewer.on("viewer:onRegionChanged", function () {
	        (0, _utils.goToHomeFromReader)();
	      });
	      this.viewer.on("viewer:onLoginChanged", function () {
	        _this5.checkAuthorisation();
	      });
	      this.viewer.on("viewer:publicationChanged", this._onPublicationChanged.bind(this));
	    }
	  }, {
	    key: "checkAuthorisation",
	    value: function checkAuthorisation() {
	      var _this6 = this;
	
	      return new _promise2.default(function (resolve) {
	        //checkAuthorisation
	        _this6.downloadcomponent = new _downloadcomponent2.default(_this6.authenticatorAuthorisationController, _this6.paywall, _this6.options.downloadComponent, _apimanager2.default, _this6._appState, _this6.errorPopup);
	        _this6.downloadcomponent.on("downloadComponent:succes", function () {
	          if (_this6.reCheck) {
	            _this6._appState.authorized = true;
	            _this6._appState.socialSharing = false;
	            _this6._appState.newDownloaderFallbackMode = false;
	            if (!_this6._appState.cdnAssetsDownloader) {
	              _this6._appState.cdnAssetsDownloader = new _CDNAssetsDownloader2.default(_apimanager2.default, _this6._appState, _this6.sessionManager);
	            }
	            _this6._appState.cdnAssetsDownloader.requestDownloadCredentials(true).then(function () {
	              resolve("autorization succeeded");
	            });
	          } else {
	            _this6._appState.changeCurrentPage(_this6.readerBrowsingHistory.getPageFromHistory(), true).then(function () {}).catch(function () {}).then(function () {
	              _this6._appState.authorized = true;
	              _this6._appState.socialSharing = false;
	              _this6._appState.newDownloaderFallbackMode = false;
	              resolve("authorization succeeded");
	            });
	          }
	        });
	        _this6.downloadcomponent.on("downloadComponent:close", function () {
	          if (!_this6.reCheck) {
	            (0, _utils.goToHomeFromReader)();
	          } else if (!_this6._appState.authorized && _this6._appState.socialSharing && _this6._appState.socialSharingNumberOfArticles == 0) {
	            (0, _utils.goToHomeFromReader)();
	          }
	        });
	        _this6.downloadcomponent.on("downloadComponent:fail", function () {
	          if (_this6._appState.socialSharing) {
	            _this6._appState.newDownloaderFallbackMode = true;
	            _this6._appState.triggerEvent(_analyticsevents.ACCESSED_SOCIALSHARING);
	            _this6._appState.changeCurrentPage(_this6.readerBrowsingHistory.getPageFromHistory(), false, true).then(function () {}).catch(function () {}).then(function () {
	              resolve("authorization succeeded");
	            });
	          }
	        });
	        var publicationData = {
	          contentPackageId: _this6.contentPackageId,
	          publicationId: _this6.pubStore.pubId,
	          price: _this6.cpStore.CPackageInfo.price
	          // pageId: this._appState.currentPage
	        };
	        var contentId = _this6.history.contentid || _this6._appState.nextgenSharingArticle || _this6.options.allowNextgenPageSharing;
	        var showPaywall = _this6._appState.socialSharing && contentId ? false : true;
	        _this6.downloadcomponent.validateDownload(publicationData, true, showPaywall);
	      });
	    }
	
	    //////////
	
	  }, {
	    key: "_onPublicationLoaded",
	    value: function _onPublicationLoaded() {
	      this.publicationId = this.pubStore.pubId;
	      this._appState.publicationId = this.publicationId;
	      this._appState.pageRatio = this.pubStore.ratio;
	      this._appState.replicaPageSize = this.pubStore.originalPageSize;
	      this.pubIsLoaded = false;
	      if (this.startFromZero) {
	        this.history.updateLocation(this._appState.contentPackageId, this._appState._publicationId, 1, 0);
	      }
	      this.onPubStoreLoaded();
	    }
	  }, {
	    key: "_onPublicationChanged",
	    value: function _onPublicationChanged(_ref2) {
	      var _this7 = this;
	
	      var publicationId = _ref2.publicationId,
	          cpId = _ref2.contentPackageId;
	
	      this.switchContentPackages = false;
	      var contentPackageId = parseInt(cpId);
	      if (contentPackageId) {
	        this.contentPackageId = contentPackageId;
	        if (contentPackageId != this._appState.contentPackageId) {
	          this.switchContentPackages = true;
	        }
	        this._appState.contentPackageId = contentPackageId;
	      }
	      if (publicationId) {
	        if (this.switchContentPackages) {
	          this.cpStore.loadInfo(contentPackageId).then(function () {
	            _this7.viewer.renderLoadingLayer();
	            _this7.initOrUpdatePubStore(publicationId, true);
	          });
	        } else {
	          this.viewer.renderLoadingLayer();
	          this.initOrUpdatePubStore(publicationId, true);
	        }
	      } else if (contentPackageId) {
	        // horsseries
	        (0, _utils.goToPublication)({ contentPackageId: contentPackageId }, 3);
	      }
	    }
	  }, {
	    key: "_onPreferredViewerChanged",
	    value: function _onPreferredViewerChanged(type) {
	      if (!this.pubStore.isCurrentPublicationMain() || !this.pubStore.containsReplicaAndNextgen()) return;
	
	      var _pubStore$getPublicat = this.pubStore.getPublicationByType(type),
	          PublicationId = _pubStore$getPublicat.PublicationId,
	          ContentPackageId = _pubStore$getPublicat.ContentPackageId;
	
	      var publicationData = {
	        publicationId: PublicationId,
	        contentPackageId: ContentPackageId
	      };
	      (0, _utils.goToPublication)(publicationData, 3);
	    }
	  }]);
	  return AppReader;
	}(_app2.default);
	
	exports.default = AppReader;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(82);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _logger = __webpack_require__(410);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _categoriesPickerComponent = __webpack_require__(510);
	
	var _categoriesPickerComponent2 = _interopRequireDefault(_categoriesPickerComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoriesPickerComponent = function () {
	  function CategoriesPickerComponent(pubStore, appState, options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, CategoriesPickerComponent);
	
	    this._closeDropDown = function () {
	      if (!$(".categories-picker-dropdown").hasClass("categories-picker-dropdown-is-hidden")) {
	        $(".categories-picker-dropdown").addClass("categories-picker-dropdown-is-hidden");
	        _this._appState.triggerEvent(_analyticsevents.CLOSED_CATEGORY_DROPDOWN_READER);
	      }
	    };
	
	    this._pubStore = pubStore;
	    this._appState = appState;
	    this.DOMContainer = document.querySelector(".top-bar-center");
	    this._options = options;
	    this._appState.on("appState:currentpagechanged", this._onPageChanged.bind(this));
	    this._pubStore.on("pubStore:pubLoaded", this.render.bind(this));
	    this._attachEventListeners();
	  }
	
	  (0, _createClass3.default)(CategoriesPickerComponent, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.DOMContainer) {
	        _logger2.default.error("Node with class .top-bar-middle-section not found");
	        return;
	      }
	
	      this.DOMContainer.classList.add("invisible");
	      var context = this._prepareContext();
	
	      Dust.render(_categoriesPickerComponent2.default, context, function (err, result) {
	        _this2.DOMContainer.innerHTML = result;
	        setTimeout(function () {
	          // Safari has problem with counting correct items dimentions
	          // right away after innerHTML
	          _this2._reRenderIfNotEnoughSpace(context);
	        }, 10);
	      });
	    }
	
	    ////////
	
	  }, {
	    key: "_attachEventListeners",
	    value: function _attachEventListeners() {
	      $(".top-bar-center").on("click", ".categories-picker-item-more", this._toggleDropdown.bind(this));
	      $(".top-bar-center").on("click", ".categories-picker-item:not(.categories-picker-item-more)", this._goToCategory.bind(this));
	      this._appState.on("alb:overlayClicked", this._closeDropDown);
	      this._appState.on("cropper:overlayClicked", this._closeDropDown);
	      this._appState.on("readerContainer:clicked", this._closeDropDown);
	      this._appState.on("replicaReader:clicked", this._closeDropDown);
	      this._appState.on("imageGallery:opened", this._closeDropDown);
	      this._appState.on("downloadButton:clicked", this._closeDropDown);
	      this._appState.on("printButton:clicked", this._closeDropDown);
	      this._appState.on("settingButton:clicked", this._closeDropDown);
	      this._appState.on("appState:currentpagechanged", this._closeDropDown);
	      this._appState.on("readerReadingMode:clicked", this._closeDropDown);
	      window.addEventListener("resize", (0, _lodash2.default)(this.render.bind(this), 300));
	    }
	  }, {
	    key: "_toggleDropdown",
	    value: function _toggleDropdown() {
	      if ($(".categories-picker-dropdown").hasClass("categories-picker-dropdown-is-hidden")) {
	        $(".categories-picker-dropdown").removeClass("categories-picker-dropdown-is-hidden");
	        this._appState.triggerEvent(_analyticsevents.OPENED_CATEGORY_DROPDOWN_READER);
	        this._appState.trigger("categoryDropdown:opened");
	      } else {
	        $(".categories-picker-dropdown").addClass("categories-picker-dropdown-is-hidden");
	        this._appState.triggerEvent(_analyticsevents.CLOSED_CATEGORY_DROPDOWN_READER);
	      }
	    }
	  }, {
	    key: "_onPageChanged",
	    value: function _onPageChanged() {
	      var currentCategoryEl = this.DOMContainer.querySelector("#current-category");
	
	      if (currentCategoryEl) {
	        currentCategoryEl.textContent = this._getCurrentCategoryName();
	      }
	
	      this._selectCategory();
	    }
	  }, {
	    key: "_selectCategory",
	    value: function _selectCategory() {
	      var pageCategory = this._getCurrentCategoryName();
	      $(".categories-picker-item").removeClass("selected");
	      $(".categories-picker-item[data-value=\"" + pageCategory + "\"]").addClass("selected");
	    }
	  }, {
	    key: "_goToCategory",
	    value: function _goToCategory(e) {
	      e.stopPropagation();
	      this._toggleDropdown();
	      if (typeof e.target.dataset.firstpageindex !== "undefined") {
	        this._appState.changeCurrentPage(e.target.dataset.firstpageindex);
	      }
	      var selectedcategory = { selectedSection: e.target.dataset.value };
	      this._appState.triggerEvent(_analyticsevents.CLICKED_CATEGORY_READER, selectedcategory, true);
	    }
	  }, {
	    key: "_reRenderIfNotEnoughSpace",
	    value: function _reRenderIfNotEnoughSpace(context) {
	      var logoContainer = document.querySelector(".top-bar-logo");
	      var topBarMenu = document.querySelector(".top-bar-access");
	      var containerAvailableSpace = this.DOMContainer.offsetWidth - logoContainer.offsetWidth - topBarMenu.offsetWidth;
	      var items = this.DOMContainer.querySelectorAll(".categories-picker-item");
	      var categories = context.categories;
	
	      var itemsWidth = 0;
	      var currentCategory = this._findCategoryByName(this._getCurrentCategoryName());
	
	      itemsWidth = [].reduce.call(items, function (acc, item) {
	        acc += item.clientWidth; // eslint-disable-line
	        return acc;
	      }, 0);
	
	      if (this._options.reader.enableTopNavDropdown || itemsWidth > containerAvailableSpace) {
	        this._reRender(currentCategory, categories);
	      }
	
	      this.DOMContainer.classList.remove("invisible");
	      this._selectCategory();
	    }
	  }, {
	    key: "_findCategoryByName",
	    value: function _findCategoryByName(catName) {
	      var categories = this._pubStore.extractUniqueCategories();
	      for (var i = 0, len = categories.length; i < len; i++) {
	        if (categories[i].name === catName) {
	          return categories[i];
	        }
	      }
	    }
	  }, {
	    key: "_reRender",
	    value: function _reRender(currentCategory, moreCategories) {
	      var _this3 = this;
	
	      var context = {
	        currentCategory: currentCategory,
	        showMore: true,
	        moreCategories: moreCategories
	      };
	
	      Dust.render(_categoriesPickerComponent2.default, context, function (err, result) {
	        _this3.DOMContainer.innerHTML = result;
	      });
	    }
	  }, {
	    key: "_getCurrentCategoryName",
	    value: function _getCurrentCategoryName() {
	      var rightPage = null;
	      var currentPage = this._pubStore.CPackagePages[this._appState.currentPage];
	      if (currentPage.PagePositionType === "Left") {
	        rightPage = this._pubStore.CPackagePages[this._appState.currentPage + 1];
	      }
	      return rightPage ? rightPage.PageCategory : currentPage.PageCategory;
	    }
	  }, {
	    key: "_prepareContext",
	    value: function _prepareContext() {
	      var context = {};
	      context.categories = this._pubStore.extractUniqueCategories();
	      return context;
	    }
	  }]);
	  return CategoriesPickerComponent;
	}();
	
	exports.default = CategoriesPickerComponent;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _cropperjs = __webpack_require__(490);
	
	var _cropperjs2 = _interopRequireDefault(_cropperjs);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _utils = __webpack_require__(10);
	
	var _cropperComponent = __webpack_require__(511);
	
	var _cropperComponent2 = _interopRequireDefault(_cropperComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CropperComponent = function (_Emitter) {
	  (0, _inherits3.default)(CropperComponent, _Emitter);
	
	  function CropperComponent() {
	    var DOMContainer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _utils.requiredParam)("DOMContainer");
	    var appState = arguments[1];
	    var options = arguments[2];
	    (0, _classCallCheck3.default)(this, CropperComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CropperComponent.__proto__ || (0, _getPrototypeOf2.default)(CropperComponent)).call(this));
	
	    _this.onOverlayClicked = function (e) {
	      if (e.target == _this._overlay) {
	        _this.hide();
	        _this._appState.trigger("cropper:overlayClicked");
	      }
	    };
	
	    _this._DOMContainer = DOMContainer;
	    _this._appState = appState;
	    _this._options = options;
	    _this.render();
	    return _this;
	  }
	
	  (0, _createClass3.default)(CropperComponent, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var context = {
	        i18n: _dictionary2.default,
	        close: true,
	        back: true
	      };
	      Dust.render(_cropperComponent2.default, context, function (err, result) {
	        _this2._DOMContainer.innerHTML = result;
	        _this2._imageContainer = document.querySelector("#image-container");
	        _this2.show();
	        _this2._attatchClickHandlers();
	      });
	    }
	  }, {
	    key: "_attatchClickHandlers",
	    value: function _attatchClickHandlers() {
	      var _this3 = this;
	
	      this._overlay = this._DOMContainer.querySelector(".cropper-container.overlay-wrapper");
	      if (this._overlay) {
	        this._overlay.addEventListener("click", this.onOverlayClicked);
	      }
	
	      this._closeBtn = document.querySelector(".cropper-nav-item.cropper-nav-back");
	      this._closeBtn.addEventListener("click", function (e) {
	        e.stopPropagation();
	        _this3.hide();
	      });
	
	      this._printBtn = document.querySelector("#crop-print-btn");
	      this._printBtn.addEventListener("click", function (e) {
	        e.stopPropagation();
	        _this3._appState.triggerEvent(_analyticsevents.CLICKED_PRINT_CROPPING);
	        _this3.print();
	      });
	    }
	  }, {
	    key: "_removeClickHandlers",
	    value: function _removeClickHandlers() {
	      var _this4 = this;
	
	      this._closeBtn.removeEventListener("click", function (e) {
	        e.stopPropagation();
	        _this4.hide();
	      });
	
	      this._printBtn.removeEventListener("click", function (e) {
	        e.stopPropagation();
	        _this4.print();
	      });
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (this._DOMContainer.classList.contains("hidden")) {
	        this._DOMContainer.classList.remove("hidden");
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (!this._DOMContainer.classList.contains("hidden")) {
	        this._DOMContainer.classList.add("hidden");
	      }
	      this._removeClickHandlers();
	    }
	  }, {
	    key: "loadImage",
	    value: function loadImage(url) {
	      this._url = url;
	      if (this._imageContainer) {
	        this._imageContainer.innerHTML = "";
	        var img = document.createElement("img");
	        img.src = url;
	        this._imageContainer.appendChild(img);
	        this.initializeCropper();
	      }
	    }
	  }, {
	    key: "initializeCropper",
	    value: function initializeCropper() {
	      var _this5 = this;
	
	      var image = document.querySelector(".cropper-container img");
	      if (!image.classList.contains("cropper-hidden")) {
	        image.classList.add("cropper-hidden");
	      }
	
	      image.addEventListener("cropend", function () {
	        _this5._appState.triggerEvent(_analyticsevents.ADJUSTED_BOX_CROPPING);
	      });
	
	      this.cropper = new _cropperjs2.default(image, {
	        movable: true,
	        viewMode: 1,
	        autoCropArea: 1,
	        rotatable: false,
	        scalable: false,
	        zoomable: false,
	        zoomOnTouch: false,
	        zoomOnWheel: false,
	        toggleDragModeOnDblclick: false,
	        dragMode: "move",
	        checkCrossOrigin: false
	      });
	    }
	  }, {
	    key: "print",
	    value: function print() {
	      var cropData = this.cropper.getData();
	      //This will help us create styling specific to text and image printing.
	      if (!document.body.classList.contains("imagePrinting")) {
	        document.body.classList.add("imagePrinting");
	      }
	      var printing = document.querySelector("#printing");
	      printing.innerHTML = "";
	      var container = document.createElement("div");
	      container.classList.add("canvas-container");
	      printing.appendChild(container);
	      var width = cropData.width;
	      var height = cropData.height;
	
	      var canvas = this.cropper.getCroppedCanvas({
	        width: width * 2,
	        height: height * 2,
	        fillColor: "#fff",
	        imageSmoothingEnabled: true,
	        imageSmoothingQuality: "high"
	      });
	
	      container.appendChild(canvas);
	      window.print();
	    }
	  }]);
	  return CropperComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = CropperComponent;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _fullscreenComponent = __webpack_require__(512);
	
	var _fullscreenComponent2 = _interopRequireDefault(_fullscreenComponent);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullScreenComponent = function (_Emitter) {
	  (0, _inherits3.default)(FullScreenComponent, _Emitter);
	
	  function FullScreenComponent(options, appState) {
	    (0, _classCallCheck3.default)(this, FullScreenComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FullScreenComponent.__proto__ || (0, _getPrototypeOf2.default)(FullScreenComponent)).call(this));
	
	    _this._requestFullScreen = function (element) {
	      var requestMethod = element.requestFullscreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen;
	
	      if (requestMethod) {
	        _this._documentBody.classList.add("full-screen-mode");
	        requestMethod.call(element);
	      }
	    };
	
	    _this._onFullScreenEnterClick = function () {
	      _this._appState.triggerEvent(_analyticsevents.CLICKED_FULLSCREEN_READER);
	      _this._appState.inFullScreenMode = true;
	      if (parent) {
	        parent.postMessage({ event: "OnFullScreenClicked" }, "*");
	      }
	      _this._requestFullScreen(document.body);
	    };
	
	    _this._onFullScreenExitClick = function () {
	      _this._appState.triggerEvent(_analyticsevents.CLICKED_FULLSCREEN_READER);
	      _this._appState.inFullScreenMode = false;
	      if (parent) {
	        parent.postMessage({ event: "onFullScreenExitClicked" }, "*");
	      }
	      _this._exitFullScreen(document);
	    };
	
	    _this._exitFullScreen = function (element) {
	      var requestMethod = element.exitFullscreen || element.webkitExitFullscreen || element.mozCancelFullScreen || element.msExitFullscreen;
	
	      if (requestMethod) {
	        _this._documentBody.classList.remove("full-screen-mode");
	        requestMethod.call(element);
	      }
	    };
	
	    _this._onFullScreenChange = function () {
	      var fullscreenElement = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
	
	      // if in fullscreen mode fullscreenElement won't be null
	      if (!fullscreenElement) {
	        /*When pressing exit the exitFullscreen is not called
	          but the fullscreen is fired that is why we remove the
	          full-screen-mode here*/
	        _this._documentBody.classList.remove("full-screen-mode");
	        /*When out of fullscreen mode do not listen to the escape keyup event*/
	        document.removeEventListener("keyup", _this._onEscapeButtonKeyUp);
	        _this.trigger("fullScreenComponent:stopFullScreen");
	        _this._appState.triggerEvent(_analyticsevents.EXIT_FULLSCREEN_READER);
	      } else {
	        /*When in fullscreen mode  listen to the escape keyup event*/
	        document.addEventListener("keyup", _this._onEscapeButtonKeyUp);
	        _this.trigger("fullScreenComponent:startFullScreen");
	        _this._appState.triggerEvent(_analyticsevents.OPENED_FULLSCREEN_READER);
	      }
	    };
	
	    _this._onEscapeButtonKeyUp = function (e) {
	      if (e.keyCode === 27) {
	        _this._appState.triggerEvent(_analyticsevents.CLICKED_ESCAPE_FULLSCREEN_READER);
	        _this._exitFullScreen(document);
	      }
	    };
	
	    _this._options = options;
	    _this._appState = appState;
	    _this._DOMContainer = document.querySelector("#fullscreen-component");
	    _this._documentBody = document.getElementsByTagName("BODY")[0];
	    _this.render();
	    return _this;
	  }
	
	  (0, _createClass3.default)(FullScreenComponent, [{
	    key: "render",
	    value: function render() {
	      Dust.render(_fullscreenComponent2.default, {}, this._renderDone.bind(this));
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this._detachEventListeners();
	      this._DOMContainer.innerHTML = "";
	    }
	  }, {
	    key: "_renderDone",
	    value: function _renderDone(err, result) {
	      if (err) return;
	      this._DOMContainer.innerHTML = result;
	      this._attachEventListeners();
	    }
	  }, {
	    key: "_attachEventListeners",
	    value: function _attachEventListeners() {
	      this.fullscreenEnter = this._DOMContainer.querySelector("#fullscreen-enter");
	      this.fullscreenExit = this._DOMContainer.querySelector("#fullscreen-exit");
	      document.addEventListener("fullscreenchange", this._onFullScreenChange, false);
	      document.addEventListener("MSFullscreenChange", this._onFullScreenChange, false);
	      document.addEventListener("webkitfullscreenchange", this._onFullScreenChange, false);
	      document.addEventListener("webkitfullscreeneventchange", this._onFullScreenChange, false);
	      document.addEventListener("mozfullscreenchange", this._onFullScreenChange, false);
	      this.fullscreenEnter.addEventListener("click", this._onFullScreenEnterClick);
	      this.fullscreenExit.addEventListener("click", this._onFullScreenExitClick);
	    }
	  }, {
	    key: "_detachEventListeners",
	    value: function _detachEventListeners() {
	      document.removeEventListener("fullscreenchange", this._onFullScreenChange);
	      document.removeEventListener("MSFullscreenChange", this._onFullScreenChange);
	      document.removeEventListener("webkitfullscreenchange", this._onFullScreenChange);
	      document.removeEventListener("webkitfullscreeneventchange", this._onFullScreenChange);
	      document.removeEventListener("mozfullscreenchange", this._onFullScreenChange);
	      document.removeEventListener("keyup", this._onEscapeButtonKeyUp);
	      this.fullscreenEnter.removeEventListener("click", this._onFullScreenEnterClick);
	      this.fullscreenExit.removeEventListener("click", this._onFullScreenExitClick);
	    }
	  }]);
	  return FullScreenComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = FullScreenComponent;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GrabToPan = __webpack_require__(523);
	
	var GrabToPanComponent = function () {
	  function GrabToPanComponent(DOMContainer) {
	    (0, _classCallCheck3.default)(this, GrabToPanComponent);
	    this.g2p = null;
	
	    this.DOMContainer = DOMContainer;
	    this._init();
	  }
	
	  (0, _createClass3.default)(GrabToPanComponent, [{
	    key: "_init",
	    value: function _init() {
	      this.g2p = new GrabToPan({
	        element: this.DOMContainer // required
	      });
	      this.g2p.activate();
	    }
	  }, {
	    key: "enableGrabToPan",
	    value: function enableGrabToPan() {
	      this.g2p.activate();
	    }
	  }, {
	    key: "disableGrabToPan",
	    value: function disableGrabToPan() {
	      this.g2p.deactivate();
	    }
	  }, {
	    key: "on",
	    value: function on() {
	      var _g2p;
	
	      (_g2p = this.g2p).on.apply(_g2p, arguments);
	    }
	  }, {
	    key: "off",
	    value: function off() {
	      var _g2p2;
	
	      (_g2p2 = this.g2p).off.apply(_g2p2, arguments);
	    }
	  }]);
	  return GrabToPanComponent;
	}();
	
	exports.default = GrabToPanComponent;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _nextgenReaderComponent = __webpack_require__(513);
	
	var _nextgenReaderComponent2 = _interopRequireDefault(_nextgenReaderComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NextgenReaderComponent = function (_Emitter) {
	  (0, _inherits3.default)(NextgenReaderComponent, _Emitter);
	
	  function NextgenReaderComponent(pubStore, appState, options) {
	    (0, _classCallCheck3.default)(this, NextgenReaderComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NextgenReaderComponent.__proto__ || (0, _getPrototypeOf2.default)(NextgenReaderComponent)).call(this));
	
	    _this._onCurrentPageChanged = function (pageIndex) {
	      window.app.state.goToPageIndex(pageIndex);
	    };
	
	    _this._pubStore = pubStore;
	    _this._appState = appState;
	    _this._options = options;
	    _this.DOMContainer = document.querySelector("#reader");
	    document.documentElement.setAttribute("style", "font-size: 10px;");
	    return _this;
	  }
	
	  (0, _createClass3.default)(NextgenReaderComponent, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      this._appState.on("appState:currentpagechanged", this._onCurrentPageChanged);
	
	      Dust.render(_nextgenReaderComponent2.default, {}, function (err, result) {
	        if (err) return;
	
	        _this2.DOMContainer.innerHTML = result;
	        if (window.app) {
	          // check if nextgen instance is there
	          window.app.initRendering({
	            pub: _this2._pubStore.PublicationToLoad.PublicationID,
	            packageId: _this2._pubStore.CPackage.ContentPackageID,
	            appmode: "webappDesktop",
	            isPhone: !_this2._appState.isTablet && !_this2._appState.isDesktop,
	            page: _this2._appState.currentPage,
	            articleId: _this2._appState.nextgenSharingArticle,
	            prefetchPages: true,
	            viewerDir: "../NextGenViewer/"
	          });
	        }
	
	        _this2.trigger("reader:rendered", "nextgen");
	      });
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      window.app.close();
	      this._appState.off("appState:currentpagechanged", this._onCurrentPageChanged);
	    }
	
	    ////////////
	
	  }]);
	  return NextgenReaderComponent;
	}(_es6EventEmitter2.default);
	
	NextgenReaderComponent.componentName = "NextgenReaderComponent";
	exports.default = NextgenReaderComponent;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pdfPageBase = __webpack_require__(272);
	
	var _pdfPageBase2 = _interopRequireDefault(_pdfPageBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PdfPage = function (_PdfPageBase) {
	  (0, _inherits3.default)(PdfPage, _PdfPageBase);
	
	  function PdfPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PdfPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PdfPage.__proto__ || (0, _getPrototypeOf2.default)(PdfPage)).call.apply(_ref, [this].concat(args))), _this), _this.panning = false, _this.toShow = false, _this.shown = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PdfPage, [{
	    key: "cleanup",
	    value: function cleanup() {
	      //only if not next to currentpage
	      if (this.pageNumber < this.appState.currentPage - this.options.pdfCleanupDelta || this.pageNumber > this.appState.currentPage + this.options.pdfCleanupDelta) {
	        this.lastRendered = null;
	        if (this.pdfPageView) this.pdfPageView.destroy();
	        this.pdfPageView = null;
	        if (this.pdfPage.querySelector(".page")) {
	          this.pdfPage.removeChild(this.pdfPage.querySelector(".page"));
	        }
	      }
	    }
	  }, {
	    key: "hideOrShow",
	    value: function hideOrShow() {
	      if (this.shown && !this.toShow) {
	        //hide
	        this.shown = false;
	        this.pdfPage.classList.add("hidden");
	      } else if (this.shown && this.panning) {
	        //hide because panning
	        this.shown = false;
	        this.pdfPage.classList.add("hidden");
	      } else if (!this.shown && !this.panning && this.toShow) {
	        //show
	        this.shown = true;
	        this.pdfPage.classList.remove("hidden");
	      }
	    }
	  }, {
	    key: "pdfPan",
	    value: function pdfPan(panning) {
	      this.panning = panning;
	      this.hideOrShow();
	    }
	  }, {
	    key: "stopRenderTask",
	    value: function stopRenderTask() {
	      this.cancelRender = true;
	    }
	
	    /**
	     * Hides the pdf part
	     */
	
	  }, {
	    key: "hidePdf",
	    value: function hidePdf() {
	      if (this.pdfPage) {
	        this.stopRenderTask();
	      }
	    }
	  }, {
	    key: "_update",
	    value: function _update(zoom) {
	      var _this2 = this;
	
	      this.toShow = false;
	      this.hideOrShow();
	      var now = Date.now();
	      this.lastRequestedZoom = zoom;
	      this.lastRequestedZoomTime = now;
	      var event = void 0;
	      clearTimeout(event);
	      event = setTimeout(function () {
	        if (_this2.lastRequestedZoom === zoom && _this2.lastRequestedZoomTime === now) {
	          if (!_this2.renderTask) {
	            _this2._render(zoom);
	          } else {
	            _this2.zoomTODO = zoom;
	          }
	        }
	      }, 200);
	    }
	  }, {
	    key: "_createPdfPageView",
	    value: function _createPdfPageView(zoom) {
	      this.pdfPageView = new PDFJS.PDFPageView({
	        container: this.pdfPage,
	        id: 1,
	        scale: zoom,
	        defaultViewport: this.pdf.getViewport(zoom)
	      });
	      this.pdfPageView.setPdfPage(this.pdf);
	      this.pdfPage.classList.add("hidden");
	    }
	  }, {
	    key: "_render",
	    value: function _render(zoom) {
	      var _this3 = this;
	
	      this.renderTask = true;
	      this.pdfPageView.update(zoom);
	      if (this.zoomInProgress === zoom) {
	        return;
	      }
	      this.zoomInProgress = zoom;
	      this.lastRendered = 0;
	      this.pdfPageView.draw().then(function () {
	        if (_this3.cancelRender) {
	          if (_this3.zoomTODO) {
	            if (_this3.zoomTODO === zoom) {
	              _this3.lastRendered = zoom;
	              _this3.renderTask = false;
	              _this3.zoomTODO = 0;
	              _this3.zoomInProgress = 0;
	              _this3.toShow = true;
	              _this3.hideOrShow();
	              // this.pdfPage.classList.remove('hidden');
	            } else {
	              _this3._render(_this3.zoomTODO);
	            }
	          } else {
	            _this3.lastRendered = 0;
	            _this3.renderTask = false;
	            _this3.zoomInProgress = 0;
	          }
	        } else {
	          _this3.lastRendered = zoom;
	          _this3.renderTask = false;
	          _this3.zoomTODO = 0;
	          _this3.zoomInProgress = 0;
	          _this3.toShow = true;
	          _this3.hideOrShow();
	        }
	      }).catch(function () {
	        _this3.renderTask = false;
	      });
	    }
	  }, {
	    key: "renderPdf",
	    value: function renderPdf() {
	      var _this4 = this;
	
	      if (this.pdfPage) {
	        if (this.shouldRenderPdf()) {
	          this.cancelRender = false;
	          if (!this.pdfPromise) this.prefetchPDF();
	          this.pdfPromise.then(function () {
	            if (!_this4.cancelRender) {
	              var zoom = _this4.getZoomScale();
	              if (!_this4.pdfPageView) {
	                _this4._createPdfPageView(zoom);
	                _this4._render(zoom);
	              } else {
	                _this4._update(zoom);
	              }
	            }
	          }).catch(function (error) {
	            console.log(error); //eslint-disable-line
	          });
	        } else {
	          this.toShow = false;
	          this.hideOrShow();
	          // this.pdfPage.classList.add('hidden');
	        }
	      }
	    }
	  }, {
	    key: "loadPdfJs",
	    value: function loadPdfJs(callback) {
	      return this.requirePdfJs().then(function () {
	        return callback();
	      });
	    }
	  }, {
	    key: "requirePdfJs",
	    value: function requirePdfJs() {
	      var promise = new _promise2.default(function (resolve) {
	        __webpack_require__.e/* nsure */(7, function (require) {
	          __webpack_require__(535); //eslint-disable-line
	          PDFJS.workerSrc = __webpack_require__(422); //eslint-disable-line
	          resolve();
	        });
	      });
	      return promise;
	    }
	  }, {
	    key: "shouldRenderPdf",
	    value: function shouldRenderPdf() {
	      if (this.appState.inFullScreenMode && this.appState.zoomScale > 1) return true;
	      if (this.DOMContainer.clientWidth > this.options.pdfThreshold.width || this.DOMContainer.clientHeight > this.options.pdfThreshold.height) {
	        return true;
	      }
	      return false;
	    }
	  }]);
	  return PdfPage;
	}(_pdfPageBase2.default);
	
	exports.default = PdfPage;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _enums = __webpack_require__(84);
	
	var _utils = __webpack_require__(10);
	
	var _printMenuComponent = __webpack_require__(475);
	
	var _printMenuComponent2 = _interopRequireDefault(_printMenuComponent);
	
	var _printButtonComponent = __webpack_require__(514);
	
	var _printButtonComponent2 = _interopRequireDefault(_printButtonComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintButtonComponent = function () {
	  function PrintButtonComponent() {
	    var DOMContainer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _utils.requiredParam)("DOMContainer");
	    var pubStore = arguments[1];
	    var appState = arguments[2];
	
	    var _this = this;
	
	    var options = arguments[3];
	    var sessionManager = arguments[4];
	    (0, _classCallCheck3.default)(this, PrintButtonComponent);
	
	    this._onClickHandler = function () {
	      _this._appState.trigger("printButton:clicked");
	      if (_this._options.print.printCroppedPdf) {
	        _this.printMenuComponent = new _printMenuComponent2.default(_this.printOptionContainer, _this._pubStore, _this._appState, _this._options, _this._sessionManager);
	        _this.printMenuComponent.toggleMenu();
	      } else {
	        _this._appState.triggerEvent(_analyticsevents.CLICKED_PRINT_PDF);
	        var currentPages = _this._pubStore.getCurrentPages(_this._appState.currentPage);
	        var params = {};
	        if (currentPages.left) params.leftImage = _this._prepareImageUrl(currentPages.left);
	        if (currentPages.right) params.rightImage = _this._prepareImageUrl(currentPages.right);
	
	        window.open("print.html?" + $.param(params));
	      }
	    };
	
	    this._toggleIcon = function () {
	      if (_this._pubStore.isCurrentPublicationReplica()) {
	        _this.printButtonEl.classList.remove("hidden");
	      } else {
	        _this.printButtonEl.classList.add("hidden");
	        if (_this.printOptionContainer && !_this.printOptionContainer.classList.contains("hidden")) {
	          _this.printOptionContainer.classList.add("hidden");
	        }
	      }
	    };
	
	    this._DOMContainer = DOMContainer;
	    this._pubStore = pubStore;
	    this._appState = appState;
	    this._options = options;
	    this._sessionManager = sessionManager;
	  }
	
	  (0, _createClass3.default)(PrintButtonComponent, [{
	    key: "render",
	    value: function render() {
	      if (this._sessionManager.isFeatureEnabled(_enums.EEnabledFeatures.PRINT)) {
	        var context = {
	          i18n: _dictionary2.default,
	          useCustomToolTip: this._options ? this._options.useCustomTooltips : false,
	          displayTopNavButtonlabel: this._options ? this._options.displayTopNavButtonlabel : false,
	          printCroppedPdf: this._options.print.printCroppedPdf
	        };
	        Dust.render(_printButtonComponent2.default, context, this._renderDone.bind(this));
	      }
	    }
	
	    ////////////
	
	  }, {
	    key: "_renderDone",
	    value: function _renderDone(err, result) {
	      if (err) return;
	
	      this.printButtonEl = (0, _utils.createDivWithClass)("print-button-component");
	      this.printButtonEl.setAttribute("id", "print-publication");
	      if (this._options && this._options.displayTopNavButtonlabel) {
	        this.printButtonEl.classList.add("labelDisplayed");
	      }
	
	      this.printButtonEl.innerHTML = result;
	      this.printButtonEl.classList.add("hidden");
	      this._DOMContainer.appendChild(this.printButtonEl);
	      this._attachEventListeners();
	      if (this._options.print.printCroppedPdf) {
	        this.printOptionContainer = this._DOMContainer.querySelector(".print-button-component .printOption-container");
	      }
	      this._toggleIcon();
	    }
	  }, {
	    key: "_attachEventListeners",
	    value: function _attachEventListeners() {
	      var el = document.getElementById("print-publication");
	      el.addEventListener("click", this._onClickHandler);
	      this._pubStore.on("pubStore:pubLoaded", this._toggleIcon);
	    }
	  }, {
	    key: "_prepareImageUrl",
	    value: function _prepareImageUrl(page) {
	      if (!page) return null;
	      var _appState = this._appState,
	          userId = _appState.userId,
	          sessionId = _appState.sessionId,
	          downloadId = _appState.downloadId;
	
	      return (0, _utils.generateSecurePreviewURL)(this._options.print.imageSize, page.PublicationPageID, sessionId, userId, downloadId);
	    }
	  }, {
	    key: "_destroy",
	    value: function _destroy() {
	      document.getElementById("print-publication").removeEventListener("click", this._onClickHandler);
	      this._pubStore.off("pubStore:pubLoaded", this._toggleIcon);
	    }
	  }]);
	  return PrintButtonComponent;
	}();
	
	exports.default = PrintButtonComponent;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _utils = __webpack_require__(10);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _page = __webpack_require__(235);
	
	var _cropperComponent = __webpack_require__(469);
	
	var _cropperComponent2 = _interopRequireDefault(_cropperComponent);
	
	var _printMenuComponent = __webpack_require__(515);
	
	var _printMenuComponent2 = _interopRequireDefault(_printMenuComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintMenuComponent = function (_Emitter) {
	  (0, _inherits3.default)(PrintMenuComponent, _Emitter);
	
	  function PrintMenuComponent() {
	    var DOMContainer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _utils.requiredParam)("DOMContainer");
	    var pubStore = arguments[1];
	    var appState = arguments[2];
	    var options = arguments[3];
	    var sessionManager = arguments[4];
	    (0, _classCallCheck3.default)(this, PrintMenuComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PrintMenuComponent.__proto__ || (0, _getPrototypeOf2.default)(PrintMenuComponent)).call(this));
	
	    _this._resetMenu = function () {
	      _this._removeClickHandlers();
	      _this.render();
	    };
	
	    _this._hideMenu = function () {
	      if (!_this._DOMContainer.classList.contains("hidden")) {
	        _this._DOMContainer.classList.add("hidden");
	      }
	    };
	
	    _this._DOMContainer = DOMContainer;
	    _this._pubStore = pubStore;
	    _this._appState = appState;
	    _this._options = options;
	    _this._sessionManager = sessionManager;
	    _this.render();
	    return _this;
	  }
	
	  (0, _createClass3.default)(PrintMenuComponent, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var context = {
	        i18n: _dictionary2.default,
	        printCroppedPdf: this._options.print.printCroppedPdf,
	        isSingle: (0, _utils.isSinglePage)(this._appState)
	      };
	      Dust.render(_printMenuComponent2.default, context, function (err, result) {
	        _this2._DOMContainer.innerHTML = result;
	        _this2._attatchClickHandlers();
	      });
	    }
	  }, {
	    key: "_attatchClickHandlers",
	    value: function _attatchClickHandlers() {
	      var _this3 = this;
	
	      this._appState.on("appState:currentpagechanged", this._resetMenu);
	      this._appState.on("alb:overlayClicked", this._hideMenu);
	      this._appState.on("cropper:overlayClicked", this._hideMenu);
	      this._appState.on("readerContainer:clicked", this._hideMenu);
	      this._appState.on("downloadButton:clicked", this._hideMenu);
	      this._appState.on("categoryDropdown:opened", this._hideMenu);
	      this._appState.on("settingButton:clicked", this._hideMenu);
	      this._appState.on("readerReadingMode:clicked", this._hideMenu);
	      var printItems = this._DOMContainer.querySelectorAll(".print-cropped-item");
	      printItems.forEach(function (item) {
	        var print = item.getAttribute("data-print");
	        item.addEventListener("click", function (e) {
	          e.stopPropagation();
	          var currentPages = _this3._pubStore.getCurrentPages(_this3._appState.currentPage);
	          switch (print) {
	            case "printSinglePage":
	              _this3._appState.triggerEvent(_analyticsevents.CLICKED_PRINT_READER);
	              if (currentPages.left == null || currentPages.right && [_page.PAGE_POSITION_TYPE.FRONT, _page.PAGE_POSITION_TYPE.BACK].includes(currentPages.right.PagePositionType)) {
	                _this3._openPage(_this3._prepareImageUrl(currentPages.right));
	              } else {
	                _this3._openPage(_this3._prepareImageUrl(currentPages.left));
	              }
	              break;
	            case "printLeftPage":
	              _this3._appState.triggerEvent(_analyticsevents.CLICKED_PRINT_READER);
	              _this3._openPage(_this3._prepareImageUrl(currentPages.left));
	              break;
	            case "printRightPage":
	              _this3._appState.triggerEvent(_analyticsevents.CLICKED_PRINT_READER);
	              _this3._openPage(_this3._prepareImageUrl(currentPages.right));
	              break;
	            default:
	          }
	        });
	      });
	    }
	  }, {
	    key: "_openPage",
	    value: function _openPage(pageUrl) {
	      this.toggleMenu();
	      if (!this._cropperOverlay) {
	        this._cropperOverlay = document.querySelector("#cropper");
	      }
	      this.cropComponent = new _cropperComponent2.default(this._cropperOverlay, this._appState, this._options);
	      this.cropComponent.loadImage(pageUrl);
	    }
	  }, {
	    key: "toggleMenu",
	    value: function toggleMenu() {
	      this._DOMContainer.classList.toggle("hidden");
	    }
	  }, {
	    key: "_prepareImageUrl",
	    value: function _prepareImageUrl(page) {
	      if (!page) return null;
	      var _appState = this._appState,
	          userId = _appState.userId,
	          sessionId = _appState.sessionId,
	          downloadId = _appState.downloadId;
	
	      return (0, _utils.generateSecurePreviewURL)(this._options.print.imageSize, page.PublicationPageID, sessionId, userId, downloadId);
	    }
	  }, {
	    key: "_removeClickHandlers",
	    value: function _removeClickHandlers() {
	      var _this4 = this;
	
	      this._appState.off("appState:currentpagechanged", this._resetMenu);
	      this._appState.off("alb:overlayClicked", this._hideMenu);
	      this._appState.off("cropper:overlayClicked", this._hideMenu);
	      this._appState.off("readerContainer:clicked", this._hideMenu);
	      this._appState.off("downloadButton:clicked", this._hideMenu);
	      this._appState.off("categoryDropdown:opened", this._hideMenu);
	      this._appState.off("settingButton:clicked", this._hideMenu);
	      this._appState.off("readerReadingMode:clicked", this._hideMenu);
	      var printItems = this._DOMContainer.querySelectorAll(".print-cropped-item");
	      printItems.forEach(function (item) {
	        var print = item.getAttribute("data-print");
	        item.removeEventListener("click", function (e) {
	          e.stopPropagation();
	          var currentPages = _this4._pubStore.getCurrentPages(_this4._appState.currentPage);
	          switch (print) {
	            case "printSinglePage":
	              if (currentPages.left == null) {
	                _this4._openPage(_this4._prepareImageUrl(currentPages.right));
	              } else {
	                _this4._openPage(_this4._prepareImageUrl(currentPages.left));
	              }
	              break;
	            case "printLeftPage":
	              _this4._openPage(_this4._prepareImageUrl(currentPages.left));
	              break;
	            case "printRightPage":
	              _this4._openPage(_this4._prepareImageUrl(currentPages.right));
	              break;
	            default:
	          }
	        });
	      });
	    }
	  }]);
	  return PrintMenuComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = PrintMenuComponent;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _readingModeButtonComponent = __webpack_require__(517);
	
	var _readingModeButtonComponent2 = _interopRequireDefault(_readingModeButtonComponent);
	
	var _utils = __webpack_require__(10);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//TODOD: move to web this is not a shared component
	var ReadingModeButtonComponent = function (_Emitter) {
	  (0, _inherits3.default)(ReadingModeButtonComponent, _Emitter);
	
	  function ReadingModeButtonComponent(appState, pubStore, options) {
	    (0, _classCallCheck3.default)(this, ReadingModeButtonComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ReadingModeButtonComponent.__proto__ || (0, _getPrototypeOf2.default)(ReadingModeButtonComponent)).call(this));
	
	    _this.toggleSinglePageMode = function () {
	      _this.updateIconandlabel();
	      if (_this._appState.isDoublePage || !_this._pubStore.isCurrentPublicationReplica()) {
	        if (document.body.classList.contains("singlePage")) document.body.classList.remove("singlePage");
	      } else {
	        if (!document.body.classList.contains("singlePage")) document.body.classList.add("singlePage");
	      }
	    };
	
	    _this._toggleIcon = function () {
	      var readingModeButton = document.querySelector(".reading-mode-button-component");
	      if (_this._pubStore.isCurrentPublicationReplica()) {
	        readingModeButton.classList.remove("hidden");
	      } else {
	        readingModeButton.classList.add("hidden");
	      }
	    };
	
	    _this._appState = appState;
	    _this._options = options;
	    _this._pubStore = pubStore;
	    _this.DOMContainer = document.querySelector(".top-bar-container .top-bar-access");
	    _this._appState.on("appState:isDoublePageChanged", _this.toggleSinglePageMode);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ReadingModeButtonComponent, [{
	    key: "render",
	    value: function render() {
	      var context = {
	        i18n: _dictionary2.default,
	        isDoublePage: this._appState.isDoublePage,
	        useCustomToolTip: this._options ? this._options.useCustomTooltips : false,
	        displayTopNavButtonlabel: this._options ? this._options.displayTopNavButtonlabel : false
	      };
	      if (this.DOMContainer) {
	        Dust.render(_readingModeButtonComponent2.default, context, this._renderDone.bind(this));
	      }
	    }
	
	    //////////////
	
	  }, {
	    key: "_renderDone",
	    value: function _renderDone(err, result) {
	      this.toggleSinglePageMode();
	      var div = (0, _utils.createDivWithClass)("reading-mode-button-component");
	      if (this._options && this._options.displayTopNavButtonlabel) {
	        div.classList.add("labelDisplayed");
	      }
	      div.innerHTML = result;
	      this.DOMContainer.appendChild(div);
	      this._toggleIcon();
	      this._attachEventListeners();
	    }
	  }, {
	    key: "_attachEventListeners",
	    value: function _attachEventListeners() {
	      var _this2 = this;
	
	      this._readingMode = this.DOMContainer.querySelector(".reading-mode-button-component");
	      if (this._readingMode) {
	        this._readingMode.addEventListener("click", function (e) {
	          _this2._onClickHandler(e);
	        });
	      }
	      this._pubStore.on("pubStore:pubLoaded", this._toggleIcon);
	    }
	  }, {
	    key: "_onClickHandler",
	    value: function _onClickHandler(e) {
	      this._appState.isDoublePage = !this._appState.isDoublePage;
	      if (e.target.classList.contains("single-page-mode")) {
	        this._appState.triggerEvent(_analyticsevents.CLICKED_TOP_NAV_SINGLE_PAGE_MODE);
	      } else {
	        this._appState.triggerEvent(_analyticsevents.CLICKED_TOP_NAV_DOUBLE_PAGE_MODE);
	      }
	      this._appState.trigger("readerReadingMode:clicked");
	      this.toggleSinglePageMode();
	      this.updateIconandlabel();
	    }
	  }, {
	    key: "updateIconandlabel",
	    value: function updateIconandlabel() {
	      var doublePageBtn = document.querySelector(".double-page-mode");
	      var doublePageLbl = document.querySelector(".double-page-mode-label");
	
	      var singlePageBtn = document.querySelector(".single-page-mode");
	      var singlePageLbl = document.querySelector(".single-page-mode-label");
	
	      if (this._appState.isDoublePage) {
	        if (doublePageBtn && doublePageBtn.classList.contains("active")) {
	          doublePageBtn.classList.remove("active");
	        }
	
	        if (doublePageLbl && doublePageLbl.classList.contains("active")) {
	          doublePageLbl.classList.remove("active");
	        }
	
	        if (singlePageBtn && !singlePageBtn.classList.contains("active")) {
	          singlePageBtn.classList.add("active");
	        }
	        if (singlePageLbl && !singlePageLbl.classList.contains("active")) {
	          singlePageLbl.classList.add("active");
	        }
	      } else {
	        if (doublePageBtn && !doublePageBtn.classList.contains("active")) {
	          doublePageBtn.classList.add("active");
	        }
	        if (doublePageLbl && !doublePageLbl.classList.contains("active")) {
	          doublePageLbl.classList.add("active");
	        }
	
	        if (singlePageBtn && singlePageBtn.classList.contains("active")) {
	          singlePageBtn.classList.remove("active");
	        }
	        if (singlePageLbl && singlePageLbl.classList.contains("active")) {
	          singlePageLbl.classList.remove("active");
	        }
	      }
	    }
	  }, {
	    key: "_destroy",
	    value: function _destroy() {
	      var _this3 = this;
	
	      this._pubStore.on("pubStore:pubLoaded", this._toggleIcon);
	      this._readingMode.removeEventListener("click", function (e) {
	        _this3._onClickHandler(e);
	      });
	    }
	  }]);
	  return ReadingModeButtonComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = ReadingModeButtonComponent;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(243);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(99);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(97);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _slicedToArray2 = __webpack_require__(483);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _lodash = __webpack_require__(82);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _analyticsevents = __webpack_require__(9);
	
	var _albController = __webpack_require__(257);
	
	var _albController2 = _interopRequireDefault(_albController);
	
	var _clickZonesComponent = __webpack_require__(262);
	
	var _clickZonesComponent2 = _interopRequireDefault(_clickZonesComponent);
	
	var _readerMixin = __webpack_require__(274);
	
	var _readerMixin2 = _interopRequireDefault(_readerMixin);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _percentageInViewUtils = __webpack_require__(240);
	
	var _readerComponent = __webpack_require__(516);
	
	var _readerComponent2 = _interopRequireDefault(_readerComponent);
	
	var _turn = __webpack_require__(481);
	
	var _fullscreenComponent = __webpack_require__(470);
	
	var _fullscreenComponent2 = _interopRequireDefault(_fullscreenComponent);
	
	var _grabToPanComponent = __webpack_require__(471);
	
	var _grabToPanComponent2 = _interopRequireDefault(_grabToPanComponent);
	
	var _pdfPageComponent = __webpack_require__(473);
	
	var _pdfPageComponent2 = _interopRequireDefault(_pdfPageComponent);
	
	var _zoomComponent = __webpack_require__(480);
	
	var _zoomComponent2 = _interopRequireDefault(_zoomComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this is needed!
	var ReplicaReaderComponent = function (_Emitter) {
	  (0, _inherits3.default)(ReplicaReaderComponent, _Emitter);
	
	  function ReplicaReaderComponent(pubStore, appState, options) {
	    (0, _classCallCheck3.default)(this, ReplicaReaderComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ReplicaReaderComponent.__proto__ || (0, _getPrototypeOf2.default)(ReplicaReaderComponent)).call(this));
	
	    _this._requestDownloadCounter = 0;
	    _this._requestDownloadLimit = 10;
	
	    _this.render = function () {
	      window.addEventListener("resize", _this._onWidowResize);
	      _this.totalPages = _this._appState.totalPages;
	
	      _this._initPdfPages();
	
	      return _this._renderComponent().then(function () {
	        _this._recalculatePercentageInView();
	        _readerMixin2.default.triggerPageViewEvent.call(_this);
	      });
	    };
	
	    _this._onPanStart = function () {
	      _this._pdfPan(false);
	    };
	
	    _this._onPanEnd = function () {
	      _this._pdfPan(false);
	      _this._recalculatePercentageInView();
	
	      // correct scrollLeft of container of first/last page when needed
	
	      var _$$turn = $("#turn-reader").turn("view"),
	          _$$turn2 = (0, _slicedToArray3.default)(_$$turn, 2),
	          leftPageNr = _$$turn2[0],
	          rightPageNr = _$$turn2[1];
	
	      var grabToPanContainer = _this.grabToPan.DOMContainer;
	
	      if (leftPageNr === 0 && grabToPanContainer.scrollLeft < grabToPanContainer.scrollWidth / 2) {
	        grabToPanContainer.scrollLeft = grabToPanContainer.scrollWidth / 2;
	      } else if (rightPageNr === 0 && grabToPanContainer.scrollWidth / 2 - grabToPanContainer.scrollLeft < grabToPanContainer.offsetWidth) {
	        grabToPanContainer.scrollLeft = grabToPanContainer.scrollWidth / 2 - grabToPanContainer.offsetWidth;
	      }
	      if (_this.zoomScale > 1) _this._appState.triggerEvent(_analyticsevents.PAN_PAGE);
	    };
	
	    _this._onReadingModeChanged = function () {
	      _this.destroy();
	      _this._onWidowResize();
	      _this._initGrabToPan();
	      _this._renderBook();
	      _this._attachEventListeners();
	    };
	
	    _this._goToPage = function (currentPageIndex, originIsReader) {
	      if (currentPageIndex + 1 !== $("#turn-reader").turn("page") || originIsReader) {
	        _this._resetZooming();
	
	        var turnDisabled = $("#turn-reader").turn("disabled");
	
	        if (turnDisabled) $("#turn-reader").turn("disabled", false);
	        $("#turn-reader").turn("page", currentPageIndex + 1);
	        if (turnDisabled) $("#turn-reader").turn("disabled", true);
	
	        // We want to trigger VIEW_PAGE event only if pages changed,
	        // not if router changed (for example because light box was opened)
	
	        var _$$turn3 = $("#turn-reader").turn("view"),
	            _$$turn4 = (0, _slicedToArray3.default)(_$$turn3, 2),
	            leftPageNr = _$$turn4[0],
	            rightPageNr = _$$turn4[1];
	
	        if (_this.currentRenderedPages[0] !== leftPageNr || _this.currentRenderedPages[1] !== rightPageNr) {
	          _this.currentRenderedPages = [leftPageNr, rightPageNr];
	          var leftPage = _this._pubStore.CPackagePages[leftPageNr - 1];
	          var rightPage = _this._pubStore.CPackagePages[rightPageNr - 1];
	
	          _this._appState.setActivePages([leftPage, rightPage]);
	          _readerMixin2.default.triggerPageViewEvent.call(_this);
	        }
	      }
	    };
	
	    _this._onKeydownHandler = function (e) {
	      var key = e.which || e.keyCode;
	      switch (key // eslint-disable-line
	      ) {case 37:
	          // 37 = left
	          if (!_this._appState.articleLightBoxDisplayed) {
	            _this._goToPreviousPage();
	          }
	          break;
	        case 39:
	          // 39 = right
	          if (!_this._appState.articleLightBoxDisplayed) {
	            _this._goToNextPage();
	          }
	          break;
	      }
	    };
	
	    _this._goToNextPage = function () {
	      _this._resetZooming();
	      _this._scrollTop();
	      $("#turn-reader").turn("next");
	      _this._appState.triggerEvent(_analyticsevents.CLICKED_PAGE_NEXT_READER);
	    };
	
	    _this._goToPreviousPage = function () {
	      _this._scrollTop();
	      _this._resetZooming();
	      $("#turn-reader").turn("previous");
	      _this._appState.triggerEvent(_analyticsevents.CLICKED_PAGE_PREV_READER);
	    };
	
	    _this._turnedPageHandler = function (event, page, view) {
	      _this._appState.changeCurrentPage(page - 1);
	      _this._setActivePagesInState(view);
	      _this._toggleNavigationButtons(page);
	      _this._startPdf(view);
	    };
	
	    _this._onFullScreenStart = function () {
	      _this.inFullScreenMode = true;
	      _this._onWidowResize();
	    };
	
	    _this._onFullScreenStop = function () {
	      _this.inFullScreenMode = false;
	      _this._onWidowResize();
	    };
	
	    _this._disablePageInteraction = function () {
	      _this.grabToPan.disableGrabToPan();
	      $("#turn-reader").turn("disable", true);
	    };
	
	    _this._enablePageInteraction = function () {
	      _this.grabToPan.enableGrabToPan();
	      $("#turn-reader").turn("disable", false);
	    };
	
	    _this._onZoneClickHandler = function (e) {
	      e.stopPropagation();
	      var currentTarget = e.currentTarget;
	      _this._appState.trigger("replicaReader:clicked");
	      _this.clicksOnReadingArea++;
	      if (_this.clicksOnReadingArea === 1) {
	        _this.readerClickTimeout = setTimeout(function () {
	          if (_this.clicksOnReadingArea === 1) {
	            _this._appState.triggerEvent(_analyticsevents.CLICKED_PAGE_ARTICLE_READER);
	            if (currentTarget.dataset.extraurl) {
	              var urlWithConsentParams = _this._appState.analyticsManager.checkEnrichmentUrl(currentTarget.dataset.extraurl);
	              if (urlWithConsentParams) {
	                window.open(urlWithConsentParams, "_blank");
	              } else {
	                window.open(currentTarget.dataset.extraurl, "_blank");
	              }
	            } else {
	              var contentID = currentTarget.dataset.contentid;
	              var slideIndex = currentTarget.dataset.index;
	              _this.alb.open({ contentID: contentID, slideIndex: slideIndex });
	              _this._disablePageInteraction();
	            }
	          }
	          _this.clicksOnReadingArea = 0;
	        }, 200);
	      }
	    };
	
	    _this._zoomOnScroll = (0, _lodash2.default)(function (_ref) {
	      var originalEvent = _ref.originalEvent;
	
	      if (_this._appState.isDoublePage) {
	        var zoomStep = _this.zoomComponent.zoomStep;
	
	        if (_this._mouseIsHoveringWhiteSpace(originalEvent)) return;
	
	        if (originalEvent.deltaY < 0 && _this.zoomScale < _this.desktopMaxZoom) {
	          var scale = _this.zoomScale + zoomStep > _this.desktopMaxZoom ? _this.desktopMaxZoom : _this.zoomScale + zoomStep;
	          _this._zoomMousePoint(scale, {
	            x: originalEvent.pageX,
	            y: originalEvent.pageY
	          }, true);
	          _this.zoomComponent.setProgress(_this.zoomScale);
	          _this._appState.triggerEvent(_analyticsevents.ZOOM_PAGE_IN_READER_ON_DESKTOP);
	        } else if (originalEvent.deltaY > 0 && _this.zoomScale > 1) {
	          var _scale = _this.zoomScale - zoomStep < 1 ? 1 : _this.zoomScale - zoomStep;
	          _this._zoomMousePoint(_scale, {
	            x: originalEvent.pageX,
	            y: originalEvent.pageY
	          }, true);
	          _this.zoomComponent.setProgress(_this.zoomScale);
	          _this._appState.triggerEvent(_analyticsevents.ZOOM_PAGE_OUT_READER_ON_DESKTOP);
	        }
	      }
	    }, 200);
	
	    _this._zoomPageInPoint = function (e) {
	      e.stopPropagation();
	      if (_this._mouseIsHoveringWhiteSpace(e)) return;
	      if (_this.zoomScale === _this.desktopMaxZoom) {
	        _this.zoomComponent.reset();
	        _this.zoomCenterPoint(1);
	        _this._appState.triggerEvent(_analyticsevents.ZOOM_PAGE_OUT_READER_ON_DESKTOP);
	      } else {
	        var zoomStep = _this.zoomScale + Math.floor(_this.desktopMaxZoom / 2);
	        zoomStep = zoomStep < _this.desktopMaxZoom ? zoomStep : _this.desktopMaxZoom;
	        _this.zoomCenterPoint(zoomStep, {
	          x: e.pageX - $(_this.DOMContainer).offset().left,
	          y: e.pageY - $(_this.DOMContainer).offset().top
	        });
	        _this.zoomComponent.setProgress(zoomStep);
	        _this._appState.triggerEvent(_analyticsevents.ZOOM_PAGE_IN_READER_ON_DESKTOP);
	      }
	    };
	
	    _this._onZoneButtonClickHandler = function (e) {
	      e.stopPropagation();
	      var currentTarget = e.currentTarget;
	      _this._appState.triggerEvent(_analyticsevents.CLICKED_PAGE_ENRICHMENTBUTTON_READER);
	      if (currentTarget.dataset.extraurl) {
	        var urlWithConsentParams = _this._appState.analyticsManager.checkEnrichmentUrl(currentTarget.dataset.extraurl);
	        if (urlWithConsentParams) {
	          window.open(urlWithConsentParams, "_blank");
	        } else {
	          window.open(currentTarget.dataset.extraurl, "_blank");
	        }
	      } else {
	        var contentID = currentTarget.dataset.contentid;
	        var slideIndex = currentTarget.dataset.index;
	        var scrollToExtra = true;
	        _this.alb.open({ contentID: contentID, scrollToExtra: scrollToExtra, slideIndex: slideIndex });
	      }
	    };
	
	    _this._onWidowResize = function () {
	      _this._setReaderDimensions();
	      _this._resizeBook();
	      setTimeout(function () {
	        _this.trigger("reader:resized");
	      }, 500);
	    };
	
	    _this.onPageScroll = (0, _lodash2.default)(function () {
	      /* we wait 3 sec after the scroll to send the pageview event.
	        the previous timer is cleared out if the user scrolls again before the 3sec
	      */
	      if (_this.timer) clearTimeout(_this.timer);
	      _this.timer = setTimeout(function () {
	        _this._recalculatePercentageInView();
	      }, 500);
	    });
	
	    _this._pubStore = pubStore;
	    _this._appState = appState;
	    _this._options = options;
	    _this.DOMContainer = document.getElementById("reader");
	    _this.pageContainerSelector = ".page";
	    _this.zoomScale = 1;
	    _this.desktopMaxZoom = appState.isDoublePage ? _this._options.zoom.desktopMaxZoom.doublePageMode : _this._options.zoom.desktopMaxZoom.singlePageMode;
	    _this.inFullScreenMode = false;
	    _this.resizeBookNumber = 0;
	    _this.clicksOnReadingArea = 0;
	    _this.readerClickTimeout = null;
	    _this._appState.setPagesPercentageInView(!_this._appState.isDoublePage);
	    _this._onKeydownHandler = (0, _lodash2.default)(_this._onKeydownHandler, 500);
	    _this._onWidowResize = (0, _lodash2.default)(_this._onWidowResize, 100);
	    if (_this._appState.analyticsManager.cmpManager) {
	      _this._appState.analyticsManager.cmpManager.on("userConsent:changed", function () {
	        if (_this._appState.isReader) {
	          _readerMixin2.default.triggerPageViewEvent.call(_this);
	        }
	      });
	    }
	    return _this;
	  }
	
	  (0, _createClass3.default)(ReplicaReaderComponent, [{
	    key: "zoomCenterPoint",
	    value: function zoomCenterPoint(zoomScale) {
	      var centerPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this._zoom(zoomScale);
	      var center = centerPoint || this._getCenter();
	      this.zoomScale = zoomScale;
	      this._resizeBook();
	      this._setReaderDimensions(true);
	      this._setCenter(center);
	      this._recalculatePercentageInView();
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      window.removeEventListener("resize", this._onWidowResize);
	      this._appState.off("appState:currentpagechanged", this._goToPage);
	      this._appState.off("appState:articleLightboxClosed", this._enablePageInteraction);
	      this._appState.off("appState:articleLightboxOpened", this._disablePageInteraction);
	
	      $("#turn-reader").turn("destroy");
	      this._resetContainerDimentions();
	      this.previousLink.removeEventListener("click", this._goToPreviousPage);
	      this.nextLink.removeEventListener("click", this._goToNextPage);
	      this.singlePagePreviousLink.removeEventListener("click", this._goToPreviousPage);
	      this.singlePageNextLink.removeEventListener("click", this._goToNextPage);
	      $(this.DOMContainer).off("click", this.pageContainerSelector + " .swiper-slide-page-click", this._onZoneClickHandler);
	      $(this.DOMContainer).off("click", this.pageContainerSelector + " .swiper-slide-page-click .extra-button-container", this._onZoneButtonClickHandler);
	      $("#turn-reader").off("dblclick", this._zoomPageInPoint);
	      $(this.DOMContainer).off("mousewheel", this._zoomOnScroll);
	      $(this.DOMContainer).off("wheel", this._zoomOnScroll);
	      if (this.readerClickTimeout) clearTimeout(this.readerClickTimeout);
	      this.fullScreenComponent.off("fullScreenComponent:startFullScreen", this._onFullScreenStart);
	      this.fullScreenComponent.off("fullScreenComponent:stopFullScreen", this._onFullScreenStop);
	      this.fullScreenComponent.destroy();
	      this.grabToPan.off("grabToPan:panEnd", this._onPanEnd);
	      this.grabToPan.off("grabToPan:panStart", this._onPanStart);
	      this.grabToPan.disableGrabToPan();
	      this.zoomComponent.destroy();
	      document.removeEventListener("keydown", this._onKeydownHandler);
	    }
	
	    //////////////
	
	  }, {
	    key: "_resetContainerDimentions",
	    value: function _resetContainerDimentions() {
	      var readerEl = document.querySelector("#reader");
	      readerEl.style.width = "initial";
	      readerEl.style.height = "initial";
	    }
	  }, {
	    key: "_zoomMousePoint",
	    value: function _zoomMousePoint(zoomScale, mouse) {
	      if (zoomScale === 1) {
	        this._resetZooming();
	        return;
	      }
	      this._zoom(zoomScale);
	      var center = this._getPoint(mouse);
	      this.zoomScale = zoomScale;
	      this._resizeBook(this._recalculatePercentageInView.bind(this));
	      this._setPoint(center, mouse);
	    }
	  }, {
	    key: "checkAlb",
	    value: function checkAlb() {
	      if (this.alb) {
	        this.alb.goTo(this._appState.currentPage, this._appState.contentid);
	      }
	    }
	  }, {
	    key: "_zoom",
	    value: function _zoom(zoomScale) {
	      if (zoomScale === this.zoomScale || zoomScale < 1 || zoomScale > this.desktopMaxZoom) {
	        return;
	      }
	      this._appState.zoomScale = zoomScale;
	      if (this.zoomScale === 1 && zoomScale > 1) {
	        this._disableTurning();
	      } else if (this.zoomScale !== 1 && zoomScale === 1) {
	        this._enableTurning();
	      }
	    }
	  }, {
	    key: "_initPdfPages",
	    value: function _initPdfPages() {
	      this.pdfPages = [];
	      for (var i = 0; i < this.totalPages; i++) {
	        this.pdfPages.push(null);
	      }
	    }
	  }, {
	    key: "_disableTurning",
	    value: function _disableTurning() {
	      $("#turn-reader").turn("disable", true);
	    }
	  }, {
	    key: "_enableTurning",
	    value: function _enableTurning() {
	      $("#turn-reader").turn("disable", false);
	    }
	  }, {
	    key: "_resetZooming",
	    value: function _resetZooming() {
	      this.zoomCenterPoint(1);
	      this.zoomComponent.reset();
	    }
	  }, {
	    key: "_renderComponent",
	    value: function _renderComponent() {
	      var _this2 = this;
	
	      return _promise2.default.resolve().then(function () {
	        Dust.render(_readerComponent2.default, {}, function (err, result) {
	          _this2.DOMContainer.innerHTML = result;
	          _this2.DOMContent = _this2.DOMContainer.querySelector(".reader-container");
	          _this2.$readerComponentEl = $(".reader-component");
	          _this2.previousLink = document.getElementById("reader-previous");
	          _this2.nextLink = document.getElementById("reader-next");
	          _this2.singlePageNextLink = document.getElementById("reader-next-singlePage");
	          _this2.singlePagePreviousLink = document.getElementById("reader-previous-singlePage");
	          _this2._initGrabToPan();
	          _this2._renderBook();
	          _this2._attachEventListeners();
	        });
	      });
	    }
	  }, {
	    key: "_setReaderDimensions",
	    value: function _setReaderDimensions() {
	      var afterZoom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this._dimensions = this._countRelativeDimentions();
	      var reader = this.DOMContainer.querySelector(".reader-wrapper");
	      var readerEl = document.querySelector("#reader");
	      if (reader) {
	        if (this._appState.isDoublePage) {
	          reader.setAttribute("style", "height:" + this._dimensions.height + "px; width:" + this._dimensions.width * 2 + "px");
	          readerEl.setAttribute("style", "height:" + this._dimensions.height + "px; width:" + this._dimensions.width * 2 + "px");
	        } else {
	          if (afterZoom) {
	            if (this.zoomScale == 1) {
	              reader.setAttribute("style", "height:" + this._dimensions.height * this.zoomScale + "px; width:" + this._dimensions.width + "px");
	            } else {
	              var width = document.querySelector("#turn-reader").offsetWidth;
	              readerEl.setAttribute("style", "width:" + this._dimensions.width + "px");
	              reader.setAttribute("style", "height:" + this._dimensions.height * this.zoomScale + "px; width:" + width + "px");
	            }
	          } else {
	            reader.setAttribute("style", "height:" + this._dimensions.height + "px; width:" + this._dimensions.width + "px");
	            readerEl.setAttribute("style", "width:" + this._dimensions.width + "px");
	          }
	        }
	      }
	    }
	  }, {
	    key: "_initGrabToPan",
	    value: function _initGrabToPan() {
	      var singlePageEl = this._appState.isDoublePage ? this.DOMContent : document.querySelector("#reader");
	      this.grabToPan = new _grabToPanComponent2.default(singlePageEl);
	      this.grabToPan.on("grabToPan:panStart", this._onPanStart);
	      this.grabToPan.on("grabToPan:panEnd", this._onPanEnd);
	    }
	  }, {
	    key: "_pdfPan",
	    value: function _pdfPan(panning) {
	      var _this3 = this;
	
	      if (this._appState.usePdf) {
	        var view = $("#turn-reader").turn("view");
	        view.forEach(function (pageNr) {
	          if (_this3.pdfPages[pageNr - 1]) {
	            _this3.pdfPages[pageNr - 1].pdfPan(panning);
	          }
	        });
	      }
	    }
	  }, {
	    key: "_attachEventListeners",
	    value: function _attachEventListeners() {
	      this._appState.on("appState:currentpagechanged", this._goToPage);
	      this._appState.on("appState:articleLightboxClosed", this._enablePageInteraction);
	      this._appState.on("appState:articleLightboxOpened", this._disablePageInteraction);
	      this.previousLink.addEventListener("click", this._goToPreviousPage);
	      this.singlePagePreviousLink.addEventListener("click", this._goToPreviousPage);
	      this.nextLink.addEventListener("click", this._goToNextPage);
	      this.singlePageNextLink.addEventListener("click", this._goToNextPage);
	      document.addEventListener("keydown", this._onKeydownHandler);
	
	      var scrollingContainer = document.querySelector("#reader");
	
	      scrollingContainer.addEventListener("scroll", this.onPageScroll);
	    }
	  }, {
	    key: "_scrollTop",
	    value: function _scrollTop() {
	      if (this._appState.isDoublePage == false) {
	        var scrollingContainer = document.querySelector("#reader");
	        scrollingContainer.scrollTop = 0;
	      }
	    }
	  }, {
	    key: "_stopPdf",
	    value: function _stopPdf(view) {
	      var _this4 = this;
	
	      view.forEach(function (pageNr) {
	        if (_this4.pdfPages[pageNr - 1]) {
	          _this4.pdfPages[pageNr - 1].hidePdf();
	        }
	      });
	    }
	  }, {
	    key: "_startPdf",
	    value: function _startPdf(view) {
	      var _this5 = this;
	
	      if (this._appState.usePdf) {
	        view.forEach(function (pageNr) {
	          if (!_this5.pdfPages[pageNr - 1]) {
	            var currentPage = _this5._pubStore.findPageByPageNumber(pageNr);
	            var pageContainer = _this5.DOMContainer.querySelector(".page-wrapper .page.p" + pageNr);
	            if (currentPage && pageContainer) {
	              _this5.pdfPages[pageNr - 1] = new _pdfPageComponent2.default(_this5._appState, _apimanager2.default, pageContainer, currentPage.PublicationPageID, pageNr, _this5._options.pdfPage);
	            }
	          }
	          if (_this5.pdfPages[pageNr - 1]) {
	            _this5.pdfPages[pageNr - 1].renderPdf();
	          }
	        });
	      }
	    }
	  }, {
	    key: "_prefetchPDF",
	    value: function _prefetchPDF(view) {
	      var _this6 = this;
	
	      if (this._appState.usePdf) {
	        view.forEach(function (pageNr) {
	          if (_this6.pdfPages[pageNr - 1]) {
	            _this6.pdfPages[pageNr - 1].prefetchPDF();
	          }
	        });
	      }
	    }
	  }, {
	    key: "_renderBook",
	    value: function _renderBook() {
	      var _this7 = this;
	
	      var currentPageNr = this._appState.currentPage + 1;
	      if (currentPageNr > this.totalPages) currentPageNr = 1;
	
	      var _released = null;
	
	      this._setReaderDimensions();
	
	      this._toggleNavigationButtons(this._appState.currentPage + 1);
	
	      $("#turn-reader").turn({
	        display: this._appState.isDoublePage ? "double" : "single",
	        height: this._dimensions.height,
	        width: this._appState.isDoublePage ? this._dimensions.width * 2 : this._dimensions.width,
	        gradients: true,
	        page: currentPageNr,
	        pages: this._pubStore.CPackagePages.length,
	        duration: 450,
	        when: {
	          missing: function missing(event, pages) {
	            for (var i = 0, len = pages.length; i < len; i++) {
	              _this7._addPage(pages[i]);
	            }
	          },
	          released: function released(event, coords) {
	            _released = coords.corner.substring(0, 1);
	          },
	          start: function start() {
	            _this7.grabToPan.disableGrabToPan();
	          },
	          turned: function turned(event, page, view) {
	            _this7._appState.changeCurrentPage(page - 1, false, false, true);
	            _this7._setActivePagesInState(view);
	            _this7._toggleNavigationButtons(page);
	            _this7._startPdf(view);
	          },
	          first: function first() {
	            _this7.previousLink.classList.add("hidden");
	            _this7.singlePagePreviousLink.classList.add("hidden");
	          },
	          last: function last() {
	            _this7.nextLink.classList.add("hidden");
	            _this7.singlePageNextLink.classList.add("hidden");
	          },
	          turning: function turning(event, page, view) {
	            if (!_released) return;
	
	            var futurePage = view[0] || view;
	            var eventName = "" + _released + (page <= futurePage ? "r" : "l");
	
	            switch (eventName // eslint-disable-line
	            ) {case "tl":
	                _this7._scrollTop();
	
	                _this7._appState.triggerEvent(_analyticsevents.CLICKED_PAGE_PREV_TOP_READER);
	                break;
	              case "tr":
	                _this7._scrollTop();
	
	                _this7._appState.triggerEvent(_analyticsevents.CLICKED_PAGE_NEXT_TOP_READER);
	                break;
	              case "bl":
	                _this7._scrollTop();
	
	                _this7._appState.triggerEvent(_analyticsevents.CLICKED_PAGE_PREV_BOT_READER);
	                break;
	              case "br":
	                _this7._scrollTop();
	                _this7._appState.triggerEvent(_analyticsevents.CLICKED_PAGE_NEXT_BOT_READER);
	                break;
	            }
	          },
	          end: function end() {
	            _this7.grabToPan.enableGrabToPan();
	            _released = null;
	          }
	        }
	      });
	
	      this.currentRenderedPages = $("#turn-reader").turn("view");
	
	      this.zoomComponent = new _zoomComponent2.default(this, this._options.zoom, this._appState);
	      this.zoomComponent.render();
	
	      this.fullScreenComponent = new _fullscreenComponent2.default(this._options.fullScreen, this._appState);
	      this.fullScreenComponent.on("fullScreenComponent:startFullScreen", this._onFullScreenStart);
	      this.fullScreenComponent.on("fullScreenComponent:stopFullScreen", this._onFullScreenStop);
	
	      this._initAlb();
	      this._startPdf($("#turn-reader").turn("view"));
	      this.trigger("reader:rendered", "replica");
	    }
	  }, {
	    key: "_initAlb",
	    value: function _initAlb() {
	      var _this8 = this;
	
	      this.alb = new _albController2.default(this._appState, this._pubStore.createSlides(false), this._options.albcontroller);
	      $(this.DOMContainer).on("click", this.pageContainerSelector + " .swiper-slide-page-click", this._onZoneClickHandler);
	      $(this.DOMContainer).on("click", this.pageContainerSelector + " .extra-button-container", this._onZoneButtonClickHandler);
	      $("#turn-reader").on("dblclick", this._zoomPageInPoint);
	      if (this._appState.isDoublePage) {
	        $(this.DOMContainer).on("wheel", this._zoomOnScroll);
	      } else {
	        $(this.DOMContainer).off("wheel", this._zoomOnScroll);
	      }
	      this.alb.on("albController:closeAlb", function () {
	        _this8.trigger("albController:closeAlb");
	      });
	      this.alb.render();
	    }
	  }, {
	    key: "_addPage",
	    value: function _addPage(pageNr) {
	      var pageElement = $("<div />", {});
	
	      if ($("#turn-reader").turn("addPage", pageElement, pageNr)) {
	        // add the initial HTML
	        pageElement.html('<div class="page-loader"></div>');
	
	        // load the page
	        this._loadPage(pageNr, pageElement);
	      }
	    }
	  }, {
	    key: "_loadPage",
	    value: function _loadPage(pageNr, pageElement) {
	      var _this9 = this;
	
	      var currentPage = this._pubStore.findPageByPageNumber(pageNr);
	
	      if (currentPage) {
	        var publicationPageId = currentPage.PublicationPageID;
	        this._appState.cdnAssetsDownloader.loadPreview(this._options.sizes.previews.HD, publicationPageId).then(function (image) {
	          image.mousedown(function (e) {
	            e.preventDefault();
	          });
	          image.css({ width: "100%", height: "auto" });
	          image.appendTo(pageElement);
	
	          // remove the loader indicator
	          pageElement.find(".page-loader").remove();
	          var readerPage = _this9._options.reader.readerSlide.readerPage;
	
	          var clickZonesComponent = new _clickZonesComponent2.default(_this9._appState, currentPage, Math.floor(pageNr / 2), readerPage, pageElement, true);
	          clickZonesComponent.render();
	        }).catch(function () {
	          // TODO
	        });
	      }
	
	      var pdf = $('<div class="page-pdf" />', {});
	      pageElement.append(pdf);
	    }
	  }, {
	    key: "_countRelativeDimentions",
	    value: function _countRelativeDimentions() {
	      if (!this.inFullScreenMode) {
	        this.SIDEBAR_AND_MARGIN = $("#sidebar").outerWidth(true);
	        // topbar + bottom nav slider + 10px space between reader and topbar
	        this.TOPBAR_AND_SLIDER = $(".top-bar-container")[0].offsetHeight + 10 + $(".reader-navigation").outerHeight(true);
	      } else {
	        this.SIDEBAR_AND_MARGIN = 0;
	        // topbar + bottom nav slider + 10px space between reader and topbar
	        this.TOPBAR_AND_SLIDER = 10 + $(".reader-navigation").outerHeight(true);
	      }
	      var relWidth = (document.body.clientWidth - this.SIDEBAR_AND_MARGIN) / 2;
	      var relHeight = relWidth * this._appState.pageRatio;
	
	      if (this._appState.isDoublePage) {
	        if (document.body.clientHeight < relHeight + this.TOPBAR_AND_SLIDER) {
	          relHeight = document.body.clientHeight - this.TOPBAR_AND_SLIDER;
	          relWidth = relHeight / this._appState.pageRatio;
	        }
	      } else {
	        var originalHeight = this._appState.replicaPageSize.width * this._appState.pageRatio;
	        //1/3 of the image must be visible on the window
	        var totalH = document.body.clientHeight - this.TOPBAR_AND_SLIDER;
	        var totalW = document.body.clientWidth - this.SIDEBAR_AND_MARGIN;
	        var isOneThird = originalHeight / totalH;
	        if (isOneThird < this._options.singlePageDisplayedProportion) {
	          relHeight = totalH * this._options.singlePageDisplayedProportion;
	          relWidth = relHeight / this._appState.pageRatio;
	
	          if (relWidth > totalW - 100) {
	            relWidth = totalW - 100;
	            relHeight = relWidth * this._appState.pageRatio;
	          }
	        } else {
	          relHeight = totalH * this._options.singlePageDisplayedProportion;
	          var potentialWidth = relHeight / this._appState.pageRatio;
	          if (potentialWidth < totalW - 100) {
	            relWidth = potentialWidth;
	          } else {
	            relWidth = totalW - 100;
	            relHeight = relWidth * this._appState.pageRatio;
	          }
	        }
	        //return { width: relWidth , height: relHeight  * this.zoomScale }
	      }
	      return { width: relWidth, height: relHeight };
	    }
	  }, {
	    key: "_resizeBook",
	    value: function _resizeBook() {
	      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	
	      var view = $("#turn-reader").turn("view");
	      $("#turn-reader").width(0);
	      $("#turn-reader").height(0);
	      if (this._appState.isDoublePage) {
	        $("#turn-reader").turn("size", this._dimensions.width * 2 * this.zoomScale, this._dimensions.height * this.zoomScale);
	      } else {
	        $("#turn-reader").turn("size", this._dimensions.width * this.zoomScale, this._dimensions.height * this.zoomScale);
	      }
	
	      if (this.zoomScale > 1) {
	        this._prefetchPDF(view);
	      }
	
	      // needed to fix double pdf rendering if it renders to fast
	      this.resizeBookNumber++;
	      this._stopPdf(view);
	      this.resizeBookNumber--;
	      if (this.resizeBookNumber === 0) {
	        this._startPdf(view);
	      }
	      callback();
	    }
	  }, {
	    key: "_toggleNavigationButtons",
	    value: function _toggleNavigationButtons(page) {
	      if (page === 1) {
	        this.previousLink.classList.add("hidden");
	        this.singlePagePreviousLink.classList.add("hidden");
	        this.nextLink.classList.remove("hidden");
	        this.singlePageNextLink.classList.remove("hidden");
	      } else if (page === this.totalPages) {
	        this.nextLink.classList.add("hidden");
	        this.singlePageNextLink.classList.add("hidden");
	        this.previousLink.classList.remove("hidden");
	        this.singlePagePreviousLink.classList.remove("hidden");
	      } else {
	        this.previousLink.classList.remove("hidden");
	        this.singlePagePreviousLink.classList.remove("hidden");
	        this.nextLink.classList.remove("hidden");
	        this.singlePageNextLink.classList.remove("hidden");
	      }
	    }
	  }, {
	    key: "_getCenter",
	    value: function _getCenter() {
	      var x = (this._dimensions.width + this.DOMContent.scrollLeft) / this.zoomScale;
	      var y = (this._dimensions.height / 2 + this.DOMContent.scrollTop) / this.zoomScale;
	      return {
	        x: x,
	        y: y
	      };
	    }
	  }, {
	    key: "_getPoint",
	    value: function _getPoint(mouse) {
	      var x = (mouse.x - $(this.DOMContainer).offset().left + this.DOMContent.scrollLeft) / this.zoomScale;
	      var y = (mouse.y - $(this.DOMContainer).offset().top + this.DOMContent.scrollTop) / this.zoomScale;
	      return {
	        x: x,
	        y: y
	      };
	    }
	  }, {
	    key: "_setPoint",
	    value: function _setPoint(point, mouse) {
	      this.DOMContent.scrollLeft = point.x * this.zoomScale - mouse.x + $(this.DOMContainer).offset().left;
	      this.DOMContent.scrollTop = point.y * this.zoomScale - mouse.y + $(this.DOMContainer).offset().top;
	    }
	  }, {
	    key: "_setCenter",
	    value: function _setCenter(center) {
	      var xModifier = 0;
	
	      var _$$turn5 = $("#turn-reader").turn("view"),
	          _$$turn6 = (0, _slicedToArray3.default)(_$$turn5, 2),
	          leftPageNr = _$$turn6[0],
	          rightPageNr = _$$turn6[1];
	
	      if (rightPageNr && leftPageNr === 0 && this.zoomScale < 2.5) {
	        xModifier = document.querySelector(".page.p" + rightPageNr).clientWidth / 2;
	      } else if (leftPageNr && rightPageNr === 0 && this.zoomScale < 2.5) {
	        xModifier = -1 * (document.querySelector(".page.p" + leftPageNr).clientWidth / 2);
	      }
	
	      this.DOMContent.scrollLeft = (center.x + xModifier) * this.zoomScale - this._dimensions.width;
	      this.DOMContent.scrollTop = center.y * this.zoomScale - this._dimensions.height / 2;
	    }
	  }, {
	    key: "_setActivePagesInState",
	    value: function _setActivePagesInState(_ref2) {
	      var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	          leftPageNr = _ref3[0],
	          rightPageNr = _ref3[1];
	
	      var percentageInView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var leftPage = this._pubStore.CPackagePages[leftPageNr - 1];
	      var rightPage = this._pubStore.CPackagePages[rightPageNr - 1];
	
	      this._appState.setActivePages([leftPage, rightPage], percentageInView);
	      this._appState.triggerEvent(_analyticsevents.PERCENTAGE_IN_VIEW_COMPUTED);
	    }
	  }, {
	    key: "_recalculatePercentageInView",
	    value: function _recalculatePercentageInView() {
	      var _$$turn7 = $("#turn-reader").turn("view"),
	          _$$turn8 = (0, _slicedToArray3.default)(_$$turn7, 2),
	          leftPageNr = _$$turn8[0],
	          rightPageNr = _$$turn8[1];
	
	      if (this.zoomScale === 1 && (leftPageNr === 0 || rightPageNr === 0)) {
	        var percentageInView = {};
	        var page = void 0;
	        //
	        if (leftPageNr === 0) {
	          page = this._pubStore.CPackagePages[rightPageNr - 1];
	        }
	
	        if (rightPageNr === 0) {
	          page = this._pubStore.CPackagePages[leftPageNr - 1];
	        }
	        percentageInView = (0, _percentageInViewUtils.getPercentInViewForSinglePage)(page);
	        this._setActivePagesInState($("#turn-reader").turn("view"), percentageInView);
	      } else {
	        var pagesData = this._calculatePagesPercentageInView();
	        var articlesData = this._calculateArticlesPercentageInView();
	
	        this._setActivePagesInState($("#turn-reader").turn("view"), (0, _extends3.default)({}, pagesData, articlesData));
	      }
	    }
	  }, {
	    key: "_mouseIsHoveringWhiteSpace",
	    value: function _mouseIsHoveringWhiteSpace(e) {
	      var _$$turn9 = $("#turn-reader").turn("view"),
	          _$$turn10 = (0, _slicedToArray3.default)(_$$turn9, 2),
	          leftPageNr = _$$turn10[0],
	          rightPageNr = _$$turn10[1];
	
	      if (leftPageNr === 0 && $("[page=" + rightPageNr + "]").offset() && e.pageX < $("[page=" + rightPageNr + "]").offset().left) {
	        return true;
	      } else if (rightPageNr === 0 && e.pageX > $("[page=" + leftPageNr + "]").width()) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: "_setCurrentReaderContainerDimentions",
	    value: function _setCurrentReaderContainerDimentions() {
	      //const readerContainerEl = document.querySelector('.reader-container');
	      var readerContainerEl = document.querySelector("#reader");
	      this.readerContainerDimentions = {
	        left: 0,
	        top: 0,
	        right: readerContainerEl.clientWidth,
	        bottom: readerContainerEl.clientHeight,
	        surfaceArea: readerContainerEl.clientWidth * readerContainerEl.clientHeight
	      };
	    }
	  }, {
	    key: "_calculateArticlesPercentageInView",
	    value: function _calculateArticlesPercentageInView() {
	      this._setCurrentReaderContainerDimentions();
	
	      var _$$turn11 = $("#turn-reader").turn("view"),
	          _$$turn12 = (0, _slicedToArray3.default)(_$$turn11, 2),
	          pageLeftNr = _$$turn12[0],
	          pageRightNr = _$$turn12[1];
	
	      var $rightPageEl = $("[page=\"" + pageRightNr + "\"]");
	      var rightPageModifier = $rightPageEl.length ? $rightPageEl.position().left : 0;
	
	      return (0, _extends3.default)({}, this._calculateArticlePercentageInView(pageLeftNr), this._calculateArticlePercentageInView(pageRightNr, rightPageModifier));
	    }
	  }, {
	    key: "_calculateArticlePercentageInView",
	    value: function _calculateArticlePercentageInView(pageNr) {
	      var _this10 = this;
	
	      var xModifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var articlesData = {};
	
	      document.querySelectorAll("[page=\"" + pageNr + "\"] .swiper-slide-page-click").forEach(function (el) {
	        var readerBookLeft = $("#turn-reader").position().left;
	        var readerBookTop = $("#turn-reader").position().top;
	        if (!_this10._appState.isDoublePage) {
	          readerBookLeft -= document.querySelector("#reader").scrollLeft;
	          readerBookTop -= document.querySelector("#reader").scrollTop;
	        }
	
	        var left = el.offsetLeft + readerBookLeft + xModifier;
	        var top = el.offsetTop + readerBookTop;
	        var right = left + el.clientWidth;
	        var bottom = top + el.clientHeight;
	        var articleCoordinates = {
	          left: left,
	          top: top,
	          right: right,
	          bottom: bottom
	        };
	
	        articlesData["article_" + el.dataset.contentid] = (0, _percentageInViewUtils.countPercentOfContainerInZoom)(_this10.readerContainerDimentions, articleCoordinates, _this10._options.activePageArea);
	      });
	      var normalizedArticlesData = this._appState.isDoublePage ? articlesData : this._normalizeArticlePercentageInView(articlesData);
	      return normalizedArticlesData;
	    }
	
	    // This function ensures that the percentage in view is never higher than 100 in single page mode.
	
	  }, {
	    key: "_normalizeArticlePercentageInView",
	    value: function _normalizeArticlePercentageInView(articlesData) {
	      var sumOfPercentageInView = 0;
	      var totalPercentage = this._appState.isDoublePage ? 50 : 100;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(articlesData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _key = _step.value;
	
	          sumOfPercentageInView += articlesData[_key];
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (sumOfPercentageInView > totalPercentage) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(articlesData)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var key = _step2.value;
	
	            articlesData[key] = Math.min(totalPercentage, articlesData[key] / sumOfPercentageInView * 100);
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	
	      return articlesData;
	    }
	  }, {
	    key: "_calculatePagesPercentageInView",
	    value: function _calculatePagesPercentageInView() {
	      this._setCurrentReaderContainerDimentions();
	
	      var _$$turn13 = $("#turn-reader").turn("view"),
	          _$$turn14 = (0, _slicedToArray3.default)(_$$turn13, 2),
	          pageLeftNr = _$$turn14[0],
	          pageRightNr = _$$turn14[1];
	
	      var leftPage = this._pubStore.CPackagePages[pageLeftNr - 1];
	      var rightPage = this._pubStore.CPackagePages[pageRightNr - 1];
	
	      var pageEl = document.querySelector("#turn-reader [page=\"" + (pageLeftNr || pageRightNr) + "\"]");
	
	      var readerBookLeft = $("#turn-reader").position().left;
	      var readerBookTop = $("#turn-reader").position().top;
	      if (!this._appState.isDoublePage) {
	        readerBookLeft -= document.querySelector("#reader").scrollLeft;
	        readerBookTop -= document.querySelector("#reader").scrollTop;
	      }
	
	      var pagePositionLeft = pageEl.offsetLeft;
	      var pagePositionTop = pageEl.offsetTop;
	
	      var left = pagePositionLeft + readerBookLeft;
	      var top = pagePositionTop + readerBookTop;
	      var right = left + pageEl.clientWidth;
	      var bottom = top + pageEl.clientHeight;
	
	      var pageCoordinates = {
	        left: left,
	        top: top,
	        right: right,
	        bottom: bottom
	      };
	
	      var percentOfSinglePageInView = (0, _percentageInViewUtils.countPercentOfContainerInZoom)(this.readerContainerDimentions, pageCoordinates);
	
	      if (pageLeftNr && pageRightNr) {
	        var _ref4;
	
	        return _ref4 = {}, (0, _defineProperty3.default)(_ref4, "page_" + leftPage.PublicationPageID, percentOfSinglePageInView), (0, _defineProperty3.default)(_ref4, "page_" + rightPage.PublicationPageID, Math.max(0, 100 - percentOfSinglePageInView)), _ref4;
	      }
	      if (pageLeftNr) {
	        return (0, _defineProperty3.default)({}, "page_" + leftPage.PublicationPageID, 100);
	      }
	      if (pageRightNr) {
	        return (0, _defineProperty3.default)({}, "page_" + rightPage.PublicationPageID, 100);
	      }
	    }
	  }]);
	  return ReplicaReaderComponent;
	}(_es6EventEmitter2.default);
	// eslint-disable-next-line
	
	
	ReplicaReaderComponent.componentName = "ReplicaReaderComponent";
	exports.default = ReplicaReaderComponent;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _sidebarComponent = __webpack_require__(518);
	
	var _sidebarComponent2 = _interopRequireDefault(_sidebarComponent);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarComponent = function (_EventEmitter) {
	  (0, _inherits3.default)(SidebarComponent, _EventEmitter);
	
	  function SidebarComponent(appState, pubStore) {
	    var publications = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var options = arguments[3];
	    (0, _classCallCheck3.default)(this, SidebarComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SidebarComponent.__proto__ || (0, _getPrototypeOf2.default)(SidebarComponent)).call(this));
	
	    _this._hideCurrentPub = function () {
	      var currenPublicationId = _this._appState.publicationId;
	      var currentPubcationNode = document.getElementById("publication-" + currenPublicationId);
	
	      $(".sidebar-component .publication").removeClass("hidden");
	      if (currentPubcationNode) currentPubcationNode.classList.add("hidden");
	    };
	
	    _this._onPublicationClickHandler = function (e) {
	      var publicationId = e.currentTarget.dataset.publicationId;
	      var contentPackageId = e.currentTarget.dataset.cpId;
	      var publicationType = e.currentTarget.dataset.publicationType;
	      _this.trigger("sidebar:publicationChanged", {
	        publicationId: publicationId,
	        contentPackageId: contentPackageId
	      });
	
	      if (publicationType === "Main") {
	        _this._appState.triggerEvent(_analyticsevents.CLICKED_BACK_TO_MAIN_READER);
	      } else {
	        /*Xiti and Xcense uses the name and publication date of the selected supplement */
	        var supplName = _this._getSupplementName(_this._publications, contentPackageId, publicationId);
	        var supplPubDate = _this._getSupplPublicationdate(_this._publications, contentPackageId);
	        var analyticsExtraData = {
	          selectedSection: supplName,
	          selectedEditionPubDate: supplPubDate
	        };
	        _this._appState.triggerEvent(_analyticsevents.CLICKED_SUPPLEMENT_READER, analyticsExtraData, true);
	      }
	    };
	
	    _this._appState = appState;
	    _this._pubStore = pubStore;
	    _this._publications = publications;
	    _this._DOMContainer = document.getElementById("sidebar");
	    _this._pubStore.on("pubStore:pubLoaded", _this._hideCurrentPub);
	    _this._options = options;
	    return _this;
	  }
	
	  (0, _createClass3.default)(SidebarComponent, [{
	    key: "render",
	    value: function render(publications) {
	      if (!this._DOMContainer) return;
	      if (publications) this._publications = publications;
	
	      if (this._publications.length <= 1) {
	        document.getElementById("reader-container").classList.add("no-sidebar");
	        return;
	      }
	      var context = {
	        publications: this._publications,
	        displayLabel: this._options.displayPublicationNameInSidebar
	      };
	      document.getElementById("sidebar").classList.remove("hidden");
	      Dust.render(_sidebarComponent2.default, context, this._renderDone.bind(this));
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      $(".sidebar-component .publications").off("click", ".publication", this._onPublicationClickHandler);
	      this._pubStore.off("pubStore:pubLoaded", this._hideCurrentPub);
	      this._DOMContainer.innerHTML = "";
	    }
	
	    /////////////
	
	  }, {
	    key: "_renderDone",
	    value: function _renderDone(err, result) {
	      if (err) return;
	      this._DOMContainer.innerHTML = result;
	      this._hideCurrentPub();
	      this._attachEventListeners();
	    }
	  }, {
	    key: "_attachEventListeners",
	    value: function _attachEventListeners() {
	      $(".sidebar-component .publications").off("click", ".publication", this._onPublicationClickHandler);
	      $(".sidebar-component .publications").on("click", ".publication", this._onPublicationClickHandler);
	    }
	  }, {
	    key: "_getSupplementName",
	    value: function _getSupplementName(supplements, cpID, pubID) {
	      var supplementName = "";
	      supplements.forEach(function (supplement) {
	        if (supplement.ContentPackageId == cpID && supplement.PublicationId == pubID) {
	          supplementName = supplement.label;
	        }
	      });
	      return supplementName;
	    }
	  }, {
	    key: "_getSupplPublicationdate",
	    value: function _getSupplPublicationdate(editions, cpID) {
	      var editionDate = "";
	      editions.forEach(function (edition) {
	        if (edition.ContentPackageId == cpID) {
	          editionDate = edition.PublicationDate;
	        }
	      });
	      return editionDate;
	    }
	  }]);
	  return SidebarComponent;
	}(_es6EventEmitter2.default);
	
	exports.default = SidebarComponent;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(85);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(4);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(82);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	var _topBarComponent = __webpack_require__(417);
	
	var _topBarComponent2 = _interopRequireDefault(_topBarComponent);
	
	var _categoriesPickerComponent = __webpack_require__(468);
	
	var _categoriesPickerComponent2 = _interopRequireDefault(_categoriesPickerComponent);
	
	var _replicaReaderComponent = __webpack_require__(477);
	
	var _replicaReaderComponent2 = _interopRequireDefault(_replicaReaderComponent);
	
	var _nextgenReaderComponent = __webpack_require__(472);
	
	var _nextgenReaderComponent2 = _interopRequireDefault(_nextgenReaderComponent);
	
	var _downloadButtonComponent = __webpack_require__(264);
	
	var _downloadButtonComponent2 = _interopRequireDefault(_downloadButtonComponent);
	
	var _printButtonComponent = __webpack_require__(474);
	
	var _printButtonComponent2 = _interopRequireDefault(_printButtonComponent);
	
	var _settingsButtonComponent = __webpack_require__(416);
	
	var _settingsButtonComponent2 = _interopRequireDefault(_settingsButtonComponent);
	
	var _helpButtonComponent = __webpack_require__(415);
	
	var _helpButtonComponent2 = _interopRequireDefault(_helpButtonComponent);
	
	var _sidebarComponent = __webpack_require__(478);
	
	var _sidebarComponent2 = _interopRequireDefault(_sidebarComponent);
	
	var _dictionary = __webpack_require__(12);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _horsseriesStore = __webpack_require__(237);
	
	var _horsseriesStore2 = _interopRequireDefault(_horsseriesStore);
	
	var _apimanager = __webpack_require__(15);
	
	var _apimanager2 = _interopRequireDefault(_apimanager);
	
	var _sliderNavigation = __webpack_require__(282);
	
	var _sliderNavigation2 = _interopRequireDefault(_sliderNavigation);
	
	var _preferredViewerSwitcher = __webpack_require__(233);
	
	var _preferredViewerSwitcher2 = _interopRequireDefault(_preferredViewerSwitcher);
	
	var _readingModeButtonComponent = __webpack_require__(476);
	
	var _readingModeButtonComponent2 = _interopRequireDefault(_readingModeButtonComponent);
	
	var _utils = __webpack_require__(10);
	
	var _eventBus = __webpack_require__(238);
	
	var _eventBus2 = _interopRequireDefault(_eventBus);
	
	var _eventBusActions = __webpack_require__(239);
	
	var _eventBusActions2 = _interopRequireDefault(_eventBusActions);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Viewer = function (_Emitter) {
	  (0, _inherits3.default)(Viewer, _Emitter);
	
	  function Viewer(_ref) {
	    var appState = _ref.appState,
	        pubStore = _ref.pubStore,
	        cpStore = _ref.cpStore,
	        regionManager = _ref.regionManager,
	        paywall = _ref.paywall,
	        options = _ref.options,
	        sessionManager = _ref.sessionManager;
	    (0, _classCallCheck3.default)(this, Viewer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Viewer.__proto__ || (0, _getPrototypeOf2.default)(Viewer)).call(this));
	
	    _this._onReaderRendered = function () {
	      $("#app-content").removeClass("loading");
	      _this.sliderNavigation = new _sliderNavigation2.default(_this._appState, _this._pubStore.CPackagePages, _this._options.slidernavigation);
	      _this.sliderNavigation.load();
	      _this.readerComponent.off("reader:rendered", _this._onReaderRendered);
	    };
	
	    _this._onPreferredViewerChanged = function () {
	      _this.sidebarComponent.render(_this._setSidebarPublications());
	    };
	
	    _this._onReadingModeChanged = function (readingModeType) {
	      if (readingModeType === "nextgen") {
	        _this._appState.triggerEvent(_analyticsevents.CLICKED_NEXTGEN_READING_MODE_READER);
	      } else {
	        _this._appState.triggerEvent(_analyticsevents.CLICKED_REPLICA_READING_MODE_READER);
	      }
	    };
	
	    _this._appState = appState;
	    _this._pubStore = pubStore;
	    _this._cpStore = cpStore;
	    _this._regionManager = regionManager;
	    _this._paywall = paywall;
	    _this._options = options;
	    _this._sessionManager = sessionManager;
	    _this._appState.on("preferredViewer:changed", _this._onPreferredViewerChanged);
	    _this._appState.on("appState:isDoublePageChanged", function () {
	      _this.reload();
	    });
	
	    var eventData = {
	      date: _this._pubStore.PublicationToLoad.PublicationDate,
	      region: _this._regionManager.SelectedRegion ? _this._regionManager.SelectedRegion.Description.toLocaleLowerCase() : null
	    };
	    _this._appState.triggerEvent(_analyticsevents.OPENED_PUBLICATION_READER, eventData, true);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Viewer, [{
	    key: "initComponents",
	    value: function initComponents() {
	      var topBarComponent = new _topBarComponent2.default(this._pubStore);
	      topBarComponent.on("topBar:rendered", this._renderTopBarContent.bind(this));
	      topBarComponent.on("topBar:logoClicked", this._logoClicked.bind(this));
	      topBarComponent.render(undefined, this._options.useCustomTooltips, true);
	      this._initReader();
	    }
	  }, {
	    key: "reload",
	    value: function reload() {
	      var _this2 = this;
	
	      this.readerComponent.destroy();
	
	      if (this._switchToReplica()) {
	        _eventBus2.default.trigger(_eventBusActions2.default.PUBLICATION_SWITCHED, { isNextgen: false });
	        $("#reader-container").removeClass("nextgen");
	        this.readerComponent = new _replicaReaderComponent2.default(this._pubStore, this._appState, this._options);
	        this.readerComponent.on("albController:closeAlb", function () {
	          _this2.trigger("albController:closeAlb");
	        });
	      } else if (this._switchToNextgen()) {
	        _eventBus2.default.trigger(_eventBusActions2.default.PUBLICATION_SWITCHED, { isNextgen: true });
	        $("#reader-container").addClass("nextgen");
	        this.readerComponent = new _nextgenReaderComponent2.default(this._pubStore, this._appState, this._options);
	      } else {
	        if (this._pubStore.isCurrentPublicationReplica()) {
	          $("#reader-container").removeClass("nextgen");
	          this.readerComponent = new _replicaReaderComponent2.default(this._pubStore, this._appState, this._options);
	          this.readerComponent.on("albController:closeAlb", function () {
	            _this2.trigger("albController:closeAlb");
	          });
	        } else {
	          $("#reader-container").addClass("nextgen");
	          this.readerComponent = new _nextgenReaderComponent2.default(this._pubStore, this._appState, this._options);
	        }
	      }
	
	      this.sliderNavigation.destroy();
	      this.sliderNavigation = null;
	      this.readerComponent.on("reader:rendered", this._onReaderRendered);
	      this.readerComponent.render();
	      $("#app-content").removeClass("loading-pub");
	      this._appState.triggerEvent(_analyticsevents.OPENED_PUBLICATION_READER);
	    }
	  }, {
	    key: "renderLoadingLayer",
	    value: function renderLoadingLayer() {
	      $("#app-content").addClass("loading-pub");
	    }
	  }, {
	    key: "checkAlb",
	    value: function checkAlb() {
	      if (this.readerComponent) {
	        this.readerComponent.checkAlb();
	      }
	    }
	
	    //////////
	
	  }, {
	    key: "_renderTopBarContent",
	    value: function _renderTopBarContent() {
	      var _this3 = this;
	
	      if (this._options.replicaReadingModeToggle.desktop) {
	        var readingModeButtonComponent = new _readingModeButtonComponent2.default(this._appState, this._pubStore, this._options);
	        readingModeButtonComponent.render();
	      }
	      var categoriesPickerComponent = new _categoriesPickerComponent2.default(this._pubStore, this._appState, this._options);
	      categoriesPickerComponent.render();
	
	      this.downloadButtonComponent = new _downloadButtonComponent2.default(this._pubStore, this._appState, this._options, this._sessionManager);
	      this.downloadButtonComponent.render();
	
	      var section = document.querySelector(".top-bar-container .top-bar-access");
	      var printButtonComponent = new _printButtonComponent2.default(section, this._pubStore, this._appState, this._options, this._sessionManager);
	      printButtonComponent.render();
	
	      if (this._options.settings.turnOnSettings) {
	        var settingsButtonComponent = new _settingsButtonComponent2.default(this._appState, this._regionManager, this._sessionManager, this._paywall, this._options.settings);
	        settingsButtonComponent.on("settingComponent:onRegionChanged", function () {
	          _this3.trigger("viewer:onRegionChanged");
	        });
	        settingsButtonComponent.on("settingComponent:onLoginChanged", function () {
	          _this3.trigger("viewer:onLoginChanged");
	        });
	        settingsButtonComponent.render();
	      }
	
	      if (this._options.help && this._options.help.turnOnHeaderHelp) {
	        var helpButtonComponent = new _helpButtonComponent2.default(this._appState, this._regionManager, this._sessionManager, this._paywall, this._options.settings);
	        helpButtonComponent.render();
	      }
	
	      if (this._options.displayViewerOptions) {
	        var preferredViewerComponent = new _preferredViewerSwitcher2.default(this._appState, document.getElementById("preferred-viewer-wrapper"), "icons", this._options);
	        preferredViewerComponent.on("readingModeSwitcher:clicked", this._onReadingModeChanged);
	        preferredViewerComponent.render();
	      }
	    }
	  }, {
	    key: "_initReader",
	    value: function _initReader() {
	      var _this4 = this;
	
	      if (this._pubStore.isCurrentPublicationReplica()) {
	        $("#reader-container").removeClass("nextgen");
	        this.readerComponent = new _replicaReaderComponent2.default(this._pubStore, this._appState, this._options);
	        this.readerComponent.on("albController:closeAlb", function () {
	          _this4.trigger("albController:closeAlb");
	        });
	      } else {
	        $("#reader-container").addClass("nextgen");
	        this.readerComponent = new _nextgenReaderComponent2.default(this._pubStore, this._appState, this._options);
	      }
	
	      this.readerComponent.on("reader:resized", this._onWidowResize.bind(this));
	      this.readerComponent.on("reader:rendered", this._onReaderRendered);
	      this.readerComponent.render();
	
	      if (this._options.desktopReader.readerEnableHorsseries) {
	        this._initHorsSeries();
	      } else {
	        this._initSidebar();
	      }
	      window.addEventListener("resize", (0, _lodash2.default)(this._onWidowResize.bind(this), 100));
	      var readerContainer = document.querySelector("#reader-container");
	      if (readerContainer) {
	        readerContainer.addEventListener("click", function () {
	          _this4._appState.trigger("readerContainer:clicked");
	          var shareMenu = document.querySelectorAll(".sharing-menu");
	          shareMenu.forEach(function (item) {
	            if (!item.classList.contains("hidden")) {
	              item.classList.add("hidden");
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: "_initHorsSeries",
	    value: function _initHorsSeries() {
	      var _this5 = this;
	
	      var horsSeriesStore = new _horsseriesStore2.default(_apimanager2.default, this._cpStore.additionalDownloadTokens, this._options.sizes.covers, _dictionary2.default.moment, this._options.dateFormat);
	      horsSeriesStore.on("horsseries:loaded", function () {
	        _this5.horsseries = horsSeriesStore.getHorsseries() || [];
	        _this5._initSidebar();
	      });
	      horsSeriesStore.loadHorsseries();
	    }
	  }, {
	    key: "_initSidebar",
	    value: function _initSidebar() {
	      var _this6 = this;
	
	      this.sidebarComponent = new _sidebarComponent2.default(this._appState, this._pubStore, this._setSidebarPublications(), this._options);
	      this.sidebarComponent.render();
	      this.sidebarComponent.on("sidebar:publicationChanged", function (data) {
	        _this6.trigger("viewer:publicationChanged", data);
	      });
	    }
	  }, {
	    key: "_logoClicked",
	    value: function _logoClicked() {
	      this._appState.triggerEvent(_analyticsevents.CLICKED_HOME_ICON_READER);
	      if (this._options.redirectReaderFromIframe) {
	        window.top.location = this._options.returnToIframeUrl;
	      } else if (this._options.homeRedirectionLink) {
	        window.top.location.href = this._options.homeRedirectionLink;
	      } else {
	        (0, _utils.goToHomeFromReader)();
	      }
	    }
	  }, {
	    key: "_onWidowResize",
	    value: function _onWidowResize() {
	      if (this.sliderNavigation) this.sliderNavigation.resize();
	    }
	  }, {
	    key: "_switchToReplica",
	    value: function _switchToReplica() {
	      return this.readerComponent.constructor.componentName === "NextgenReaderComponent" && this._pubStore.isCurrentPublicationReplica();
	    }
	  }, {
	    key: "_switchToNextgen",
	    value: function _switchToNextgen() {
	      return this.readerComponent.constructor.componentName === "ReplicaReaderComponent" && !this._pubStore.isCurrentPublicationReplica();
	    }
	  }, {
	    key: "_setSidebarPublications",
	    value: function _setSidebarPublications() {
	      var mainPublication = this._pubStore.getPublicationByType(this._appState.preferredViewer);
	      var horsseries = this.horsseries || [];
	
	      return [mainPublication].concat((0, _toConsumableArray3.default)(this._cpStore.supplements), (0, _toConsumableArray3.default)(horsseries));
	    }
	  }]);
	  return Viewer;
	}(_es6EventEmitter2.default);
	
	exports.default = Viewer;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _zoomComponent = __webpack_require__(519);
	
	var _zoomComponent2 = _interopRequireDefault(_zoomComponent);
	
	var _analyticsevents = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noUiSlider = __webpack_require__(246);
	
	var ZoomComponent = function () {
	  function ZoomComponent(readerComponent, options, appState) {
	    (0, _classCallCheck3.default)(this, ZoomComponent);
	
	    this._readerComponent = readerComponent;
	    this._appState = appState;
	    this._options = options;
	    this.zoomScale = 1;
	    this.desktopMaxZoom = appState.isDoublePage ? this._options.desktopMaxZoom.doublePageMode : this._options.desktopMaxZoom.singlePageMode;
	    this.zoomStep = (this.desktopMaxZoom - 1) / this._options.zoomSteps;
	    this._DOMContainer = document.querySelector("#zoom-component");
	  }
	
	  (0, _createClass3.default)(ZoomComponent, [{
	    key: "render",
	    value: function render() {
	      Dust.render(_zoomComponent2.default, {}, this._renderDone.bind(this));
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.zoomScale = 1;
	      this._checkZoomActivation();
	      this.setProgress();
	    }
	  }, {
	    key: "setProgress",
	    value: function setProgress(zoomScale) {
	      this.zoomScale = zoomScale || this.zoomScale;
	      this.slider.noUiSlider.set(((zoomScale || this.zoomScale) - 1) / this.zoomStep);
	      this._checkZoomActivation();
	    }
	  }, {
	    key: "getZoomLevel",
	    value: function getZoomLevel() {
	      return 1 + this.zoomStep * parseInt(this.slider.noUiSlider.get(), 10);
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.slider.noUiSlider.destroy();
	      this._DOMContainer.innerHTML = "";
	    }
	
	    ////////////
	
	  }, {
	    key: "_renderDone",
	    value: function _renderDone(err, result) {
	      if (err) return;
	      this._DOMContainer.innerHTML = result;
	      this._createSlider();
	      this._checkZoomActivation();
	      this._attachEventListeners();
	    }
	  }, {
	    key: "_zoom",
	    value: function _zoom(zoomScale) {
	      var oldScale = this.zoomScale;
	      this.zoomScale = Math.max(1, Math.min(this.desktopMaxZoom, Math.round(zoomScale * 10000) / 10000));
	      var newScale = this.zoomScale;
	      this._checkZoomActivation();
	      this._readerComponent.zoomCenterPoint(zoomScale);
	      if (oldScale < newScale) {
	        this._appState.triggerEvent(_analyticsevents.ZOOM_PAGE_IN_READER_ON_DESKTOP);
	      } else {
	        this._appState.triggerEvent(_analyticsevents.ZOOM_PAGE_OUT_READER_ON_DESKTOP);
	      }
	    }
	  }, {
	    key: "_attachEventListeners",
	    value: function _attachEventListeners() {
	      var _this = this;
	
	      var zoomIn = this._DOMContainer.querySelector("#zoom-in-button");
	      zoomIn.addEventListener("click", function () {
	        _this._zoom(_this.zoomScale + _this.zoomStep);
	        _this.setProgress();
	      });
	      var zoomOut = this._DOMContainer.querySelector("#zoom-out-button");
	      zoomOut.addEventListener("click", function () {
	        _this._zoom(_this.zoomScale - _this.zoomStep);
	        _this.setProgress();
	      });
	    }
	  }, {
	    key: "_checkZoomActivation",
	    value: function _checkZoomActivation() {
	      var zoomIn = this._DOMContainer.querySelector("#zoom-in-button");
	      if (zoomIn && this.zoomScale >= this.desktopMaxZoom) {
	        zoomIn.classList.add("inactive");
	      } else if (zoomIn) {
	        zoomIn.classList.remove("inactive");
	      }
	
	      var zoomOut = this._DOMContainer.querySelector("#zoom-out-button");
	      if (zoomOut && this.zoomScale === 1) {
	        zoomOut.classList.add("inactive");
	      } else if (zoomOut) {
	        zoomOut.classList.remove("inactive");
	      }
	    }
	  }, {
	    key: "_createSlider",
	    value: function _createSlider() {
	      var _this2 = this;
	
	      this.slider = $(".slider-zoom")[0];
	
	      noUiSlider.create(this.slider, {
	        start: 0,
	        connect: [true, false],
	        step: 1,
	        range: {
	          min: 0,
	          max: this._options.zoomSteps
	        }
	      }, true);
	
	      this.slider.noUiSlider.on("slide", function () {
	        _this2._appState.triggerEvent(_analyticsevents.CLICKED_ZOOM_SLIDER_READER);
	        _this2._zoom(1 + _this2.zoomStep * parseInt(_this2.slider.noUiSlider.get(), 10));
	      });
	    }
	  }]);
	  return ZoomComponent;
	}();
	
	exports.default = ZoomComponent;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = __webpack_require__(53);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * turn.js 4th release
	 * turnjs.com
	 * turnjs.com/license.txt
	 *
	 * Copyright (C) 2012 Emmanuel Garcia
	 * All rights reserved
	 **/
	
	(function ($) {
	  "use strict";
	
	  var has3d,
	      hasRot,
	      vendor = "",
	      _version = "4.1.0",
	      PI = Math.PI,
	      A90 = PI / 2,
	      isTouch = "ontouchstart" in window,
	      mouseEvents = isTouch ? {
	    down: "touchstart",
	    move: "touchmove",
	    up: "touchend",
	    over: "touchstart",
	    out: "touchend"
	  } : {
	    down: "mousedown",
	    move: "mousemove",
	    up: "mouseup",
	    over: "mouseover",
	    out: "mouseout"
	  },
	
	  // Contansts used for each corner
	  //   | tl * tr |
	  // l | *     * | r
	  //   | bl * br |
	
	  corners = {
	    backward: ["bl", "tl"],
	    forward: ["br", "tr"],
	    all: ["tl", "bl", "tr", "br", "l", "r"]
	  },
	
	  // Display values
	
	  displays = ["single", "double"],
	
	  // Direction values
	
	  directions = ["ltr", "rtl"],
	
	  // Default options
	
	  turnOptions = {
	    // Enables hardware acceleration
	
	    acceleration: true,
	
	    // Display
	
	    display: "double",
	
	    // Duration of transition in milliseconds
	
	    duration: 600,
	
	    // First page
	
	    page: 1,
	
	    // Enables gradients
	
	    gradients: true,
	
	    // Corners used when turning the page
	
	    turnCorners: "bl,br",
	
	    // Events
	
	    when: null
	  },
	      flipOptions = {
	    // Size of the active zone of each corner
	
	    cornerSize: 100
	  },
	
	  // Number of pages in the DOM, minimum value: 6
	
	  pagesInDOM = 6,
	      turnMethods = {
	    // Singleton constructor
	    // $('#selector').turn([options]);
	
	    init: function init(options) {
	      // Define constants
	
	      has3d = "WebKitCSSMatrix" in window || "MozPerspective" in document.body.style;
	      hasRot = rotationAvailable();
	      vendor = getPrefix();
	
	      var i,
	          that = this,
	          pageNum = 0,
	          data = this.data(),
	          ch = this.children();
	
	      // Set initial configuration
	
	      options = $.extend({
	        width: this.width(),
	        height: this.height(),
	        direction: this.attr("dir") || this.css("direction") || "ltr"
	      }, turnOptions, options);
	
	      data.opts = options;
	      data.pageObjs = {};
	      data.pages = {};
	      data.pageWrap = {};
	      data.pageZoom = {};
	      data.pagePlace = {};
	      data.pageMv = [];
	      data.zoom = 1;
	      data.totalPages = options.pages || 0;
	      data.eventHandlers = {
	        touchStart: $.proxy(turnMethods._touchStart, this),
	        touchMove: $.proxy(turnMethods._touchMove, this),
	        touchEnd: $.proxy(turnMethods._touchEnd, this),
	        start: $.proxy(turnMethods._eventStart, this)
	      };
	
	      // Add event listeners
	
	      if (options.when) for (i in options.when) {
	        if (has(i, options.when)) this.bind(i, options.when[i]);
	      } // Set the css
	
	      this.css({
	        position: "relative",
	        width: options.width,
	        height: options.height
	      });
	
	      // Set the initial display
	
	      this.turn("display", options.display);
	
	      // Set the direction
	
	      if (options.direction !== "") this.turn("direction", options.direction);
	
	      // Prevent blue screen problems of switching to hardware acceleration mode
	      // By forcing hardware acceleration for ever
	
	      if (has3d && !isTouch && options.acceleration) this.transform(translate(0, 0, true));
	
	      // Add pages from the DOM
	
	      for (i = 0; i < ch.length; i++) {
	        if ($(ch[i]).attr("ignore") != "1") {
	          this.turn("addPage", ch[i], ++pageNum);
	        }
	      }
	
	      // Event listeners
	
	      $(this).bind(mouseEvents.down, data.eventHandlers.touchStart).bind("end", turnMethods._eventEnd).bind("pressed", turnMethods._eventPressed).bind("released", turnMethods._eventReleased).bind("flip", turnMethods._flip);
	
	      $(this).parent().bind("start", data.eventHandlers.start);
	
	      $(document).bind(mouseEvents.move, data.eventHandlers.touchMove).bind(mouseEvents.up, data.eventHandlers.touchEnd);
	
	      // Set the initial page
	
	      this.turn("page", options.page);
	
	      // This flipbook is ready
	
	      data.done = true;
	
	      return this;
	    },
	
	    // Adds a page from external data
	
	    addPage: function addPage(element, page) {
	      // console.log("addPage no _");
	
	      var currentPage,
	          className,
	          incPages = false,
	          data = this.data(),
	          lastPage = data.totalPages + 1;
	
	      if (data.destroying) return false;
	
	      // Read the page number from the className of `element` - format: p[0-9]+
	
	      if (currentPage = /\bp([0-9]+)\b/.exec($(element).attr("class"))) page = parseInt(currentPage[1], 10);
	
	      if (page) {
	        if (page == lastPage) incPages = true;else if (page > lastPage) throw turnError('Page "' + page + '" cannot be inserted');
	      } else {
	        page = lastPage;
	        incPages = true;
	      }
	
	      if (page >= 1 && page <= lastPage) {
	        if (data.display == "double") className = page % 2 ? " odd" : " even";else className = "";
	
	        // Stop animations
	        if (data.done) this.turn("stop");
	
	        // Move pages if it's necessary
	        if (page in data.pageObjs) turnMethods._movePages.call(this, page, 1);
	
	        // Increase the number of pages
	        if (incPages) data.totalPages = lastPage;
	
	        // Add element
	        data.pageObjs[page] = $(element).css({
	          float: "left",
	          backgroundColor: "#ffffff",
	          display: "flex",
	          justifyContent: "center",
	          alignItems: "center"
	        }).addClass("page p" + page + className);
	
	        if (!hasHardPage() && data.pageObjs[page].hasClass("hard")) {
	          data.pageObjs[page].removeClass("hard");
	        }
	
	        // Add page
	        turnMethods._addPage.call(this, page);
	
	        // Remove pages out of range
	        turnMethods._removeFromDOM.call(this);
	      }
	
	      return this;
	    },
	
	    // Adds a page
	
	    _addPage: function _addPage(page) {
	      // console.log("ADDPAGE:: " + page);
	
	      var data = this.data(),
	          element = data.pageObjs[page];
	
	      if (element) if (turnMethods._necessPage.call(this, page)) {
	        if (!data.pageWrap[page]) {
	          // Wrapper
	          data.pageWrap[page] = $("<div/>", {
	            class: "page-wrapper",
	            page: page,
	            css: {
	              position: "absolute",
	              overflow: "hidden"
	            }
	          });
	
	          // Append to this flipbook
	          this.append(data.pageWrap[page]);
	
	          if (!data.pagePlace[page]) {
	            data.pagePlace[page] = page;
	            // Move `pageObjs[page]` to wrapper
	            data.pageObjs[page].appendTo(data.pageWrap[page]);
	          }
	
	          // Set the size of the page
	          var prop = turnMethods._pageSize.call(this, page, true);
	          element.css({
	            width: prop.width,
	            height: prop.height
	          });
	          data.pageWrap[page].css(prop);
	        }
	
	        if (data.pagePlace[page] == page) {
	          // If the page isn't in another place, create the flip effect
	          turnMethods._makeFlip.call(this, page);
	        }
	      } else {
	        // Place
	        data.pagePlace[page] = 0;
	
	        // Remove element from the DOM
	        if (data.pageObjs[page]) data.pageObjs[page].remove();
	      }
	    },
	
	    // Checks if a page is in memory
	
	    hasPage: function hasPage(page) {
	      return has(page, this.data().pageObjs);
	    },
	
	    // Centers the flipbook
	
	    center: function center(page) {
	      var data = this.data(),
	          size = $(this).turn("size"),
	          left = 0;
	
	      if (!data.noCenter) {
	        if (data.display == "double") {
	          var view = this.turn("view", page || data.tpage || data.page);
	
	          if (data.direction == "ltr") {
	            if (!view[0]) left -= size.width / 4;else if (!view[1]) left += size.width / 4;
	          } else {
	            if (!view[0]) left += size.width / 4;else if (!view[1]) left -= size.width / 4;
	          }
	        }
	
	        $(this).css({
	          marginLeft: left
	        });
	      }
	
	      return this;
	    },
	
	    // Destroys the flipbook
	
	    destroy: function destroy() {
	      var page,
	          flipbook = this,
	          data = this.data(),
	          events = ["end", "first", "flip", "last", "pressed", "released", "start", "turning", "turned", "zooming", "missing"];
	
	      if (trigger("destroying", this) == "prevented") return;
	
	      data.destroying = true;
	
	      $.each(events, function (index, eventName) {
	        flipbook.unbind(eventName);
	      });
	
	      this.parent().unbind("start", data.eventHandlers.start);
	
	      $(document).unbind(mouseEvents.move, data.eventHandlers.touchMove).unbind(mouseEvents.up, data.eventHandlers.touchEnd);
	
	      while (data.totalPages !== 0) {
	        this.turn("removePage", data.totalPages);
	      }
	
	      if (data.fparent) data.fparent.remove();
	
	      if (data.shadow) data.shadow.remove();
	
	      this.removeData();
	      data = null;
	
	      return this;
	    },
	
	    // Checks if this element is a flipbook
	
	    is: function is() {
	      return (0, _typeof3.default)(this.data().pages) == "object";
	    },
	
	    // Sets and gets the zoom value
	
	    zoom: function zoom(newZoom) {
	      var data = this.data();
	
	      if (typeof newZoom == "number") {
	        if (newZoom < 0.001 || newZoom > 100) throw turnError(newZoom + " is not a value for zoom");
	
	        if (trigger("zooming", this, [newZoom, data.zoom]) == "prevented") return this;
	
	        var size = this.turn("size"),
	            currentView = this.turn("view"),
	            iz = 1 / data.zoom,
	            newWidth = Math.round(size.width * iz * newZoom),
	            newHeight = Math.round(size.height * iz * newZoom);
	
	        data.zoom = newZoom;
	
	        $(this).turn("stop").turn("size", newWidth, newHeight);
	        /*.
	                  css({marginTop: size.height * iz / 2 - newHeight / 2});*/
	
	        if (data.opts.autoCenter) this.turn("center");
	        /*else
	                    $(this).css({marginLeft: size.width * iz / 2 - newWidth / 2});*/
	
	        turnMethods._updateShadow.call(this);
	
	        for (var i = 0; i < currentView.length; i++) {
	          if (currentView[i] && data.pageZoom[currentView[i]] != data.zoom) {
	            this.trigger("zoomed", [currentView[i], currentView, data.pageZoom[currentView[i]], data.zoom]);
	
	            data.pageZoom[currentView[i]] = data.zoom;
	          }
	        }
	
	        return this;
	      } else return data.zoom;
	    },
	
	    // Gets the size of a page
	
	    _pageSize: function _pageSize(page, position) {
	      var data = this.data(),
	          prop = {};
	
	      if (data.display == "single") {
	        prop.width = this.width();
	        prop.height = this.height();
	
	        if (position) {
	          prop.top = 0;
	          prop.left = 0;
	          prop.right = "auto";
	        }
	      } else {
	        var pageWidth = this.width() / 2,
	            pageHeight = this.height();
	
	        if (data.pageObjs[page].hasClass("own-size")) {
	          prop.width = data.pageObjs[page].width();
	          prop.height = data.pageObjs[page].height();
	        } else {
	          prop.width = pageWidth;
	          prop.height = pageHeight;
	        }
	
	        if (position) {
	          var odd = page % 2;
	          prop.top = (pageHeight - prop.height) / 2;
	
	          if (data.direction == "ltr") {
	            prop[odd ? "right" : "left"] = pageWidth - prop.width;
	            prop[odd ? "left" : "right"] = "auto";
	          } else {
	            prop[odd ? "left" : "right"] = pageWidth - prop.width;
	            prop[odd ? "right" : "left"] = "auto";
	          }
	        }
	      }
	
	      return prop;
	    },
	
	    // Prepares the flip effect for a page
	
	    _makeFlip: function _makeFlip(page) {
	      var data = this.data();
	
	      if (!data.pages[page] && data.pagePlace[page] == page) {
	        var single = data.display == "single",
	            odd = page % 2;
	
	        data.pages[page] = data.pageObjs[page].css(turnMethods._pageSize.call(this, page)).flip({
	          page: page,
	          next: odd || single ? page + 1 : page - 1,
	          turn: this
	        }).flip("disable", data.disabled);
	
	        // Issue about z-index
	        turnMethods._setPageLoc.call(this, page);
	
	        data.pageZoom[page] = data.zoom;
	      }
	
	      return data.pages[page];
	    },
	
	    // Makes pages within a range
	
	    _makeRange: function _makeRange() {
	      // console.log("makeRANGE");
	
	      var page,
	          range,
	          data = this.data();
	
	      if (data.totalPages < 1) return;
	
	      range = this.turn("range");
	
	      for (page = range[0]; page <= range[1]; page++) {
	        turnMethods._addPage.call(this, page);
	      }
	    },
	
	    // Returns a range of pages that should be in the DOM
	    // Example:
	    // - page in the current view, return true
	    // * page is in the range, return true
	    // Otherwise, return false
	    //
	    // 1 2-3 4-5 6-7 8-9 10-11 12-13
	    //   **  **  --   **  **
	
	    range: function range(page) {
	      var remainingPages,
	          left,
	          right,
	          view,
	          data = this.data();
	
	      page = page || data.tpage || data.page || 1;
	      view = turnMethods._view.call(this, page);
	
	      if (page < 1 || page > data.totalPages) throw turnError('"' + page + '" is not a valid page');
	
	      view[1] = view[1] || view[0];
	
	      if (view[0] >= 1 && view[1] <= data.totalPages) {
	        remainingPages = Math.floor((pagesInDOM - 2) / 2);
	
	        if (data.totalPages - view[1] > view[0]) {
	          left = Math.min(view[0] - 1, remainingPages);
	          right = 2 * remainingPages - left;
	        } else {
	          right = Math.min(data.totalPages - view[1], remainingPages);
	          left = 2 * remainingPages - right;
	        }
	      } else {
	        left = pagesInDOM - 1;
	        right = pagesInDOM - 1;
	      }
	
	      return [Math.max(1, view[0] - left), Math.min(data.totalPages, view[1] + right)];
	    },
	
	    // Detects if a page is within the range of `pagesInDOM` from the current view
	
	    _necessPage: function _necessPage(page) {
	      if (page === 0) return true;
	
	      var range = this.turn("range");
	
	      return this.data().pageObjs[page].hasClass("fixed") || page >= range[0] && page <= range[1];
	    },
	
	    // Releases memory by removing pages from the DOM
	
	    _removeFromDOM: function _removeFromDOM() {
	      var page,
	          data = this.data();
	
	      for (page in data.pageWrap) {
	        if (has(page, data.pageWrap) && !turnMethods._necessPage.call(this, page)) turnMethods._removePageFromDOM.call(this, page);
	      }
	    },
	
	    // Removes a page from DOM and its internal references
	
	    _removePageFromDOM: function _removePageFromDOM(page) {
	      // console.log("REMOVEPAGEFROMDOM" + page);
	      // return; //TODO
	
	      var data = this.data();
	
	      if (data.pages[page]) {
	        var dd = data.pages[page].data();
	
	        flipMethods._moveFoldingPage.call(data.pages[page], false);
	
	        if (dd.f && dd.f.fwrapper) dd.f.fwrapper.remove();
	
	        data.pages[page].removeData();
	        data.pages[page].remove();
	        delete data.pages[page];
	      }
	
	      if (data.pageObjs[page]) data.pageObjs[page].remove();
	
	      if (data.pageWrap[page]) {
	        data.pageWrap[page].remove();
	        delete data.pageWrap[page];
	      }
	
	      turnMethods._removeMv.call(this, page);
	
	      delete data.pagePlace[page];
	      delete data.pageZoom[page];
	    },
	
	    // Removes a page
	
	    removePage: function removePage(page) {
	      // console.log("removePage");
	
	      var data = this.data();
	
	      // Delete all the pages
	      if (page == "*") {
	        while (data.totalPages !== 0) {
	          this.turn("removePage", data.totalPages);
	        }
	      } else {
	        if (page < 1 || page > data.totalPages) throw turnError("The page " + page + " doesn't exist");
	
	        if (data.pageObjs[page]) {
	          // Stop animations
	          this.turn("stop");
	
	          // Remove `page`
	          turnMethods._removePageFromDOM.call(this, page);
	
	          delete data.pageObjs[page];
	        }
	
	        // Move the pages
	        turnMethods._movePages.call(this, page, -1);
	
	        // Resize the size of this flipbook
	        data.totalPages = data.totalPages - 1;
	
	        // Check the current view
	
	        if (data.page > data.totalPages) {
	          data.page = null;
	          turnMethods._fitPage.call(this, data.totalPages);
	        } else {
	          turnMethods._makeRange.call(this);
	          this.turn("update");
	        }
	      }
	
	      return this;
	    },
	
	    // Moves pages
	
	    _movePages: function _movePages(from, change) {
	      var page,
	          that = this,
	          data = this.data(),
	          single = data.display == "single",
	          move = function move(page) {
	        var next = page + change,
	            odd = next % 2,
	            className = odd ? " odd " : " even ";
	
	        if (data.pageObjs[page]) data.pageObjs[next] = data.pageObjs[page].removeClass("p" + page + " odd even").addClass("p" + next + className);
	
	        if (data.pagePlace[page] && data.pageWrap[page]) {
	          data.pagePlace[next] = next;
	
	          if (data.pageObjs[next].hasClass("fixed")) data.pageWrap[next] = data.pageWrap[page].attr("page", next);else data.pageWrap[next] = data.pageWrap[page].css(turnMethods._pageSize.call(that, next, true)).attr("page", next);
	
	          if (data.pages[page]) data.pages[next] = data.pages[page].flip("options", {
	            page: next,
	            next: single || odd ? next + 1 : next - 1
	          });
	
	          if (change) {
	            delete data.pages[page];
	            delete data.pagePlace[page];
	            delete data.pageZoom[page];
	            delete data.pageObjs[page];
	            delete data.pageWrap[page];
	          }
	        }
	      };
	
	      if (change > 0) for (page = data.totalPages; page >= from; page--) {
	        move(page);
	      } else for (page = from; page <= data.totalPages; page++) {
	        move(page);
	      }
	    },
	
	    // Sets or Gets the display mode
	
	    display: function display(_display) {
	      var data = this.data(),
	          currentDisplay = data.display;
	
	      if (_display === undefined) {
	        return currentDisplay;
	      } else {
	        if ($.inArray(_display, displays) == -1) throw turnError('"' + _display + '" is not a value for display');
	
	        switch (_display) {
	          case "single":
	            // Create a temporal page to use as folded page
	
	            if (!data.pageObjs[0]) {
	              this.turn("stop").css({
	                overflow: "hidden"
	              });
	
	              data.pageObjs[0] = $("<div />", {
	                class: "page p-temporal"
	              }).css({
	                width: this.width(),
	                height: this.height()
	              }).appendTo(this);
	            }
	
	            this.addClass("shadow");
	
	            break;
	          case "double":
	            // Remove the temporal page
	
	            if (data.pageObjs[0]) {
	              this.turn("stop").css({
	                overflow: ""
	              });
	              data.pageObjs[0].remove();
	              delete data.pageObjs[0];
	            }
	
	            this.removeClass("shadow");
	
	            break;
	        }
	
	        data.display = _display;
	
	        if (currentDisplay) {
	          var size = this.turn("size");
	          turnMethods._movePages.call(this, 1, 0);
	          this.turn("size", size.width, size.height).turn("update");
	        }
	
	        return this;
	      }
	    },
	
	    // Gets and sets the direction of the flipbook
	
	    direction: function direction(dir) {
	      var data = this.data();
	
	      if (dir === undefined) {
	        return data.direction;
	      } else {
	        dir = dir.toLowerCase();
	
	        if ($.inArray(dir, directions) == -1) throw turnError('"' + dir + '" is not a value for direction');
	
	        if (dir == "rtl") {
	          $(this).attr("dir", "ltr").css({
	            direction: "ltr"
	          });
	        }
	
	        data.direction = dir;
	
	        if (data.done) this.turn("size", $(this).width(), $(this).height());
	
	        return this;
	      }
	    },
	
	    // Detects animation
	
	    animating: function animating() {
	      return this.data().pageMv.length > 0;
	    },
	
	    // Gets the current activated corner
	
	    corner: function corner() {
	      var corner,
	          page,
	          data = this.data();
	
	      for (page in data.pages) {
	        if (has(page, data.pages)) if (corner = data.pages[page].flip("corner")) {
	          return corner;
	        }
	      }
	
	      return false;
	    },
	
	    // Gets the data stored in the flipbook
	
	    data: function data() {
	      return this.data();
	    },
	
	    // Disables and enables the effect
	
	    disable: function disable(_disable) {
	      var page,
	          data = this.data(),
	          view = this.turn("view");
	
	      data.disabled = _disable === undefined || _disable === true;
	
	      for (page in data.pages) {
	        if (has(page, data.pages)) data.pages[page].flip("disable", data.disabled ? true : $.inArray(parseInt(page, 10), view) == -1);
	      }
	
	      return this;
	    },
	
	    // Disables and enables the effect
	
	    disabled: function disabled(disable) {
	      if (disable === undefined) {
	        return this.data().disabled === true;
	      } else {
	        return this.turn("disable", disable);
	      }
	    },
	
	    // Gets and sets the size
	
	    size: function size(width, height) {
	      if (width === undefined || height === undefined) {
	        return {
	          width: this.width(),
	          height: this.height()
	        };
	      } else {
	        this.turn("stop");
	
	        var page,
	            prop,
	            data = this.data(),
	            pageWidth = data.display == "double" ? width / 2 : width;
	
	        this.css({
	          width: width,
	          height: height
	        });
	
	        if (data.pageObjs[0]) data.pageObjs[0].css({
	          width: pageWidth,
	          height: height
	        });
	
	        for (page in data.pageWrap) {
	          if (!has(page, data.pageWrap)) continue;
	
	          prop = turnMethods._pageSize.call(this, page, true);
	
	          data.pageObjs[page].css({
	            width: prop.width,
	            height: prop.height
	          });
	          data.pageWrap[page].css(prop);
	
	          if (data.pages[page]) data.pages[page].css({
	            width: prop.width,
	            height: prop.height
	          });
	        }
	
	        this.turn("resize");
	
	        return this;
	      }
	    },
	
	    // Resizes each page
	
	    resize: function resize() {
	      var page,
	          data = this.data();
	
	      if (data.pages[0]) {
	        data.pageWrap[0].css({
	          left: -this.width()
	        });
	        data.pages[0].flip("resize", true);
	      }
	
	      for (page = 1; page <= data.totalPages; page++) {
	        if (data.pages[page]) data.pages[page].flip("resize", true);
	      }turnMethods._updateShadow.call(this);
	
	      if (data.opts.autoCenter) this.turn("center");
	    },
	
	    // Removes an animation from the cache
	
	    _removeMv: function _removeMv(page) {
	      var i,
	          data = this.data();
	
	      for (i = 0; i < data.pageMv.length; i++) {
	        if (data.pageMv[i] == page) {
	          data.pageMv.splice(i, 1);
	          return true;
	        }
	      }return false;
	    },
	
	    // Adds an animation to the cache
	
	    _addMv: function _addMv(page) {
	      var data = this.data();
	
	      turnMethods._removeMv.call(this, page);
	      data.pageMv.push(page);
	    },
	
	    // Gets indexes for a view
	
	    _view: function _view(page) {
	      var data = this.data();
	
	      page = page || data.page;
	
	      if (data.display == "double") return page % 2 ? [page - 1, page] : [page, page + 1];else return [page];
	    },
	
	    // Gets a view
	
	    view: function view(page) {
	      var data = this.data(),
	          view = turnMethods._view.call(this, page);
	
	      if (data.display == "double") return [view[0] > 0 ? view[0] : 0, view[1] <= data.totalPages ? view[1] : 0];else return [view[0] > 0 && view[0] <= data.totalPages ? view[0] : 0];
	    },
	
	    // Stops animations
	
	    stop: function stop(ignore, animate) {
	      if (this.turn("animating")) {
	        var i,
	            opts,
	            page,
	            data = this.data();
	
	        if (data.tpage) {
	          data.page = data.tpage;
	          delete data["tpage"];
	        }
	
	        for (i = 0; i < data.pageMv.length; i++) {
	          if (!data.pageMv[i] || data.pageMv[i] === ignore) continue;
	
	          page = data.pages[data.pageMv[i]];
	          opts = page.data().f.opts;
	
	          page.flip("hideFoldedPage", animate);
	
	          if (!animate) flipMethods._moveFoldingPage.call(page, false);
	
	          if (opts.force) {
	            opts.next = opts.page % 2 === 0 ? opts.page - 1 : opts.page + 1;
	            delete opts["force"];
	          }
	        }
	      }
	
	      this.turn("update");
	
	      return this;
	    },
	
	    // Gets and sets the number of pages
	
	    pages: function pages(_pages) {
	      var data = this.data();
	
	      if (_pages) {
	        if (_pages < data.totalPages) {
	          for (var page = data.totalPages; page > _pages; page--) {
	            this.turn("removePage", page);
	          }
	        }
	
	        data.totalPages = _pages;
	        turnMethods._fitPage.call(this, data.page);
	
	        return this;
	      } else return data.totalPages;
	    },
	
	    // Checks missing pages
	
	    _missing: function _missing(page) {
	      var data = this.data();
	
	      if (data.totalPages < 1) return;
	
	      var p,
	          range = this.turn("range", page),
	          missing = [];
	
	      for (p = range[0]; p <= range[1]; p++) {
	        if (!data.pageObjs[p]) missing.push(p);
	      }
	
	      if (missing.length > 0) this.trigger("missing", [missing]);
	    },
	
	    // Sets a page without effect
	
	    _fitPage: function _fitPage(page) {
	      // console.log("_fitPage");
	
	      var data = this.data(),
	          newView = this.turn("view", page);
	
	      turnMethods._missing.call(this, page);
	
	      if (!data.pageObjs[page]) return;
	
	      data.page = page;
	
	      this.turn("stop");
	
	      for (var i = 0; i < newView.length; i++) {
	        if (newView[i] && data.pageZoom[newView[i]] != data.zoom) {
	          this.trigger("zoomed", [newView[i], newView, data.pageZoom[newView[i]], data.zoom]);
	
	          data.pageZoom[newView[i]] = data.zoom;
	        }
	      }
	
	      turnMethods._removeFromDOM.call(this);
	      turnMethods._makeRange.call(this);
	      turnMethods._updateShadow.call(this);
	      this.trigger("turned", [page, newView]);
	      this.turn("update");
	
	      if (data.opts.autoCenter) this.turn("center");
	    },
	
	    // Turns the page
	
	    _turnPage: function _turnPage(page) {
	      // console.log("_turnPage");
	
	      var current,
	          next,
	          data = this.data(),
	          place = data.pagePlace[page],
	          view = this.turn("view"),
	          newView = this.turn("view", page);
	
	      //turnMethods._makeRange.call(this);
	      // console.log("PAGE:");
	      // console.log([page, newView]);
	      if (data.page != page) {
	        var currentPage = data.page;
	
	        if (trigger("turning", this, [page, newView]) == "prevented") {
	          if (currentPage == data.page && $.inArray(place, data.pageMv) != -1) data.pages[place].flip("hideFoldedPage", true);
	
	          return;
	        }
	
	        if ($.inArray(1, newView) != -1) this.trigger("first");
	        if ($.inArray(data.totalPages, newView) != -1) this.trigger("last");
	      }
	
	      if (data.display == "single") {
	        current = view[0];
	        next = newView[0];
	      } else if (view[1] && page > view[1]) {
	        current = view[1];
	        next = newView[0];
	      } else if (view[0] && page < view[0]) {
	        current = view[0];
	        next = newView[1];
	      }
	
	      var optsCorners = data.opts.turnCorners.split(","),
	          flipData = data.pages[current].data().f,
	          opts = flipData.opts,
	          actualPoint = flipData.point;
	
	      turnMethods._missing.call(this, page);
	
	      if (!data.pageObjs[page]) return;
	
	      this.turn("stop");
	
	      data.page = page;
	      // console.log("PAGE:");
	      // console.log([page, newView]);
	      turnMethods._makeRange.call(this);
	      this.trigger("range", this); //TODO
	      //
	
	      data.tpage = next;
	
	      if (opts.next != next) {
	        opts.next = next;
	        opts.force = true;
	      }
	
	      this.turn("update");
	
	      flipData.point = actualPoint;
	
	      if (flipData.effect == "hard") {
	        if (data.direction == "ltr") data.pages[current].flip("turnPage", page > current ? "r" : "l");else data.pages[current].flip("turnPage", page > current ? "l" : "r");
	      } else {
	        if (data.direction == "ltr") data.pages[current].flip("turnPage", optsCorners[page > current ? 1 : 0]);else data.pages[current].flip("turnPage", optsCorners[page > current ? 0 : 1]);
	      }
	    },
	
	    // Gets and sets a page
	
	    page: function page(_page) {
	      var data = this.data();
	
	      if (_page === undefined) {
	        return data.page;
	      } else {
	        if (!data.disabled && !data.destroying) {
	          _page = parseInt(_page, 10);
	
	          if (_page > 0 && _page <= data.totalPages) {
	            if (_page != data.page) {
	              if (!data.done || $.inArray(_page, this.turn("view")) != -1) turnMethods._fitPage.call(this, _page);else turnMethods._turnPage.call(this, _page);
	            }
	
	            return this;
	          } else {
	            throw turnError("The page " + _page + " does not exist");
	          }
	        }
	      }
	    },
	
	    // Turns to the next view
	
	    next: function next() {
	      return this.turn("page", Math.min(this.data().totalPages, turnMethods._view.call(this, this.data().page).pop() + 1));
	    },
	
	    // Turns to the previous view
	
	    previous: function previous() {
	      return this.turn("page", Math.max(1, turnMethods._view.call(this, this.data().page).shift() - 1));
	    },
	
	    // Shows a peeling corner
	
	    peel: function peel(corner, animate) {
	      var data = this.data(),
	          view = this.turn("view");
	
	      animate = animate === undefined ? true : animate === true;
	
	      if (corner === false) {
	        this.turn("stop", null, animate);
	      } else {
	        if (data.display == "single") {
	          data.pages[data.page].flip("peel", corner, animate);
	        } else {
	          var page;
	
	          if (data.direction == "ltr") {
	            page = corner.indexOf("l") != -1 ? view[0] : view[1];
	          } else {
	            page = corner.indexOf("l") != -1 ? view[1] : view[0];
	          }
	
	          if (data.pages[page]) data.pages[page].flip("peel", corner, animate);
	        }
	      }
	
	      return this;
	    },
	
	    // Adds a motion to the internal list
	    // This event is called in context of flip
	
	    _addMotionPage: function _addMotionPage() {
	      var opts = $(this).data().f.opts,
	          turn = opts.turn,
	          dd = turn.data();
	
	      turnMethods._addMv.call(turn, opts.page);
	    },
	
	    // This event is called in context of flip
	
	    _eventStart: function _eventStart(e, opts, corner) {
	      var data = opts.turn.data(),
	          actualZoom = data.pageZoom[opts.page];
	
	      if (e.isDefaultPrevented()) {
	        turnMethods._updateShadow.call(opts.turn);
	        return;
	      }
	
	      if (actualZoom && actualZoom != data.zoom) {
	        opts.turn.trigger("zoomed", [opts.page, opts.turn.turn("view", opts.page), actualZoom, data.zoom]);
	
	        data.pageZoom[opts.page] = data.zoom;
	      }
	
	      if (data.display == "single" && corner) {
	        if (corner.charAt(1) == "l" && data.direction == "ltr" || corner.charAt(1) == "r" && data.direction == "rtl") {
	          opts.next = opts.next < opts.page ? opts.next : opts.page - 1;
	          opts.force = true;
	        } else {
	          opts.next = opts.next > opts.page ? opts.next : opts.page + 1;
	        }
	      }
	
	      turnMethods._addMotionPage.call(e.target);
	      turnMethods._updateShadow.call(opts.turn);
	    },
	
	    // This event is called in context of flip
	
	    _eventEnd: function _eventEnd(e, opts, turned) {
	      var that = $(e.target),
	          data = that.data().f,
	          turn = opts.turn,
	          dd = turn.data();
	
	      if (turned) {
	        var tpage = dd.tpage || dd.page;
	
	        if (tpage == opts.next || tpage == opts.page) {
	          delete dd.tpage;
	
	          turnMethods._fitPage.call(turn, tpage || opts.next, true);
	        }
	      } else {
	        turnMethods._removeMv.call(turn, opts.page);
	        turnMethods._updateShadow.call(turn);
	        turn.turn("update");
	      }
	    },
	
	    // This event is called in context of flip
	
	    _eventPressed: function _eventPressed(e) {
	      var page,
	          data = $(e.target).data().f,
	          turn = data.opts.turn,
	          turnData = turn.data(),
	          pages = turnData.pages;
	
	      turnData.mouseAction = true;
	
	      turn.turn("update");
	
	      return data.time = new Date().getTime();
	    },
	
	    // This event is called in context of flip
	
	    _eventReleased: function _eventReleased(e, point) {
	      var outArea,
	          page = $(e.target),
	          data = page.data().f,
	          turn = data.opts.turn,
	          turnData = turn.data();
	
	      if (turnData.display == "single") {
	        outArea = point.corner == "br" || point.corner == "tr" ? point.x < page.width() / 2 : point.x > page.width() / 2;
	      } else {
	        outArea = point.x < 0 || point.x > page.width();
	      }
	
	      if (new Date().getTime() - data.time < 200 || outArea) {
	        e.preventDefault();
	        turnMethods._turnPage.call(turn, data.opts.next);
	      }
	
	      turnData.mouseAction = false;
	    },
	
	    // This event is called in context of flip
	
	    _flip: function _flip(e) {
	      e.stopPropagation();
	
	      var opts = $(e.target).data().f.opts;
	
	      opts.turn.trigger("turn", [opts.next]);
	
	      if (opts.turn.data().opts.autoCenter) {
	        opts.turn.turn("center", opts.next);
	      }
	    },
	
	    //
	    _touchStart: function _touchStart() {
	      var data = this.data();
	      for (var page in data.pages) {
	        if (has(page, data.pages) && flipMethods._eventStart.apply(data.pages[page], arguments) === false) {
	          return false;
	        }
	      }
	    },
	
	    //
	    _touchMove: function _touchMove() {
	      var data = this.data();
	      for (var page in data.pages) {
	        if (has(page, data.pages)) {
	          flipMethods._eventMove.apply(data.pages[page], arguments);
	        }
	      }
	    },
	
	    //
	    _touchEnd: function _touchEnd() {
	      var data = this.data();
	      for (var page in data.pages) {
	        if (has(page, data.pages)) {
	          flipMethods._eventEnd.apply(data.pages[page], arguments);
	        }
	      }
	    },
	
	    // Calculate the z-index value for pages during the animation
	
	    calculateZ: function calculateZ(mv) {
	      var i,
	          page,
	          nextPage,
	          placePage,
	          dpage,
	          that = this,
	          data = this.data(),
	          view = this.turn("view"),
	          currentPage = view[0] || view[1],
	          total = mv.length - 1,
	          r = {
	        pageZ: {},
	        partZ: {},
	        pageV: {}
	      },
	          addView = function addView(page) {
	        var view = that.turn("view", page);
	        if (view[0]) r.pageV[view[0]] = true;
	        if (view[1]) r.pageV[view[1]] = true;
	      };
	
	      for (i = 0; i <= total; i++) {
	        page = mv[i];
	        nextPage = data.pages[page].data().f.opts.next;
	        placePage = data.pagePlace[page];
	        addView(page);
	        addView(nextPage);
	        dpage = data.pagePlace[nextPage] == nextPage ? nextPage : page;
	        r.pageZ[dpage] = data.totalPages - Math.abs(currentPage - dpage);
	        r.partZ[placePage] = data.totalPages * 2 - total + i;
	      }
	
	      return r;
	    },
	
	    // Updates the z-index and display property of every page
	
	    update: function update() {
	      var page,
	          data = this.data();
	
	      if (this.turn("animating") && data.pageMv[0] !== 0) {
	        // Update motion
	
	        var p,
	            apage,
	            fixed,
	            pos = this.turn("calculateZ", data.pageMv),
	            corner = this.turn("corner"),
	            actualView = this.turn("view"),
	            newView = this.turn("view", data.tpage);
	
	        for (page in data.pageWrap) {
	          if (!has(page, data.pageWrap)) continue;
	
	          fixed = data.pageObjs[page].hasClass("fixed");
	
	          data.pageWrap[page].css({
	            display: pos.pageV[page] || fixed ? "" : "none",
	            zIndex: (data.pageObjs[page].hasClass("hard") ? pos.partZ[page] : pos.pageZ[page]) || (fixed ? -1 : 0)
	          });
	
	          if (p = data.pages[page]) {
	            p.flip("z", pos.partZ[page] || null);
	
	            if (pos.pageV[page]) p.flip("resize");
	
	            if (data.tpage) {
	              // Is it turning the page to `tpage`?
	
	              p.flip("hover", false).flip("disable", $.inArray(parseInt(page, 10), data.pageMv) == -1 && page != newView[0] && page != newView[1]);
	            } else {
	              p.flip("hover", corner === false).flip("disable", page != actualView[0] && page != actualView[1]);
	            }
	          }
	        }
	      } else {
	        // Update static pages
	
	        for (page in data.pageWrap) {
	          if (!has(page, data.pageWrap)) continue;
	
	          var pageLocation = turnMethods._setPageLoc.call(this, page);
	
	          if (data.pages[page]) {
	            data.pages[page].flip("disable", data.disabled || pageLocation != 1).flip("hover", true).flip("z", null);
	          }
	        }
	      }
	
	      return this;
	    },
	
	    // Updates the position and size of the flipbook's shadow
	
	    _updateShadow: function _updateShadow() {
	      var view,
	          view2,
	          shadow,
	          data = this.data(),
	          width = this.width(),
	          height = this.height(),
	          pageWidth = data.display == "single" ? width : width / 2;
	
	      view = this.turn("view");
	
	      if (!data.shadow) {
	        data.shadow = $("<div />", {
	          class: "shadow",
	          css: divAtt(0, 0, 0).css
	        }).appendTo(this);
	      }
	
	      for (var i = 0; i < data.pageMv.length; i++) {
	        if (!view[0] || !view[1]) break;
	
	        view = this.turn("view", data.pages[data.pageMv[i]].data().f.opts.next);
	        view2 = this.turn("view", data.pageMv[i]);
	
	        view[0] = view[0] && view2[0];
	        view[1] = view[1] && view2[1];
	      }
	
	      if (!view[0]) shadow = data.direction == "ltr" ? 1 : 2;else if (!view[1]) shadow = data.direction == "ltr" ? 2 : 1;else shadow = 3;
	
	      switch (shadow) {
	        case 1:
	          data.shadow.css({
	            width: pageWidth,
	            height: height,
	            top: 0,
	            left: pageWidth
	          });
	          break;
	        case 2:
	          data.shadow.css({
	            width: pageWidth,
	            height: height,
	            top: 0,
	            left: 0
	          });
	          break;
	        case 3:
	          data.shadow.css({
	            width: width,
	            height: height,
	            top: 0,
	            left: 0
	          });
	          break;
	      }
	    },
	
	    // Sets the z-index and display property of a page
	    // It depends on the current view
	
	    _setPageLoc: function _setPageLoc(page) {
	      var data = this.data(),
	          view = this.turn("view"),
	          loc = 0;
	
	      if (page == view[0] || page == view[1]) loc = 1;else if (data.display == "single" && page == view[0] + 1 || data.display == "double" && page == view[0] - 2 || page == view[1] + 2) loc = 2;
	
	      if (!this.turn("animating")) switch (loc) {
	        case 1:
	          data.pageWrap[page].css({
	            zIndex: data.totalPages,
	            display: ""
	          });
	          break;
	        case 2:
	          data.pageWrap[page].css({
	            zIndex: data.totalPages - 1,
	            display: ""
	          });
	          break;
	        case 0:
	          data.pageWrap[page].css({
	            zIndex: 0,
	            display: data.pageObjs[page].hasClass("fixed") ? "" : "none"
	          });
	          break;
	      }
	
	      return loc;
	    },
	
	    // Gets and sets the options
	
	    options: function options(_options) {
	      if (_options === undefined) {
	        return this.data().opts;
	      } else {
	        var data = this.data();
	
	        // Set new values
	
	        $.extend(data.opts, _options);
	
	        // Set pages
	
	        if (_options.pages) this.turn("pages", _options.pages);
	
	        // Set page
	
	        if (_options.page) this.turn("page", _options.page);
	
	        // Set display
	
	        if (_options.display) this.turn("display", _options.display);
	
	        // Set direction
	
	        if (_options.direction) this.turn("direction", _options.direction);
	
	        // Set size
	
	        if (_options.width && _options.height) this.turn("size", _options.width, _options.height);
	
	        // Add event listeners
	
	        if (_options.when) for (var eventName in _options.when) {
	          if (has(eventName, _options.when)) {
	            this.unbind(eventName).bind(eventName, _options.when[eventName]);
	          }
	        }return this;
	      }
	    },
	
	    // Gets the current version
	
	    version: function version() {
	      return _version;
	    }
	  },
	
	  // Methods and properties for the flip page effect
	
	  flipMethods = {
	    // Constructor
	
	    init: function init(opts) {
	      this.data({
	        f: {
	          disabled: false,
	          hover: false,
	          effect: this.hasClass("hard") ? "hard" : "sheet"
	        }
	      });
	
	      this.flip("options", opts);
	
	      flipMethods._addPageWrapper.call(this);
	
	      return this;
	    },
	
	    setData: function setData(d) {
	      var data = this.data();
	
	      data.f = $.extend(data.f, d);
	
	      return this;
	    },
	
	    options: function options(opts) {
	      var data = this.data().f;
	
	      if (opts) {
	        flipMethods.setData.call(this, {
	          opts: $.extend({}, data.opts || flipOptions, opts)
	        });
	        return this;
	      } else return data.opts;
	    },
	
	    z: function z(_z) {
	      var data = this.data().f;
	
	      data.opts["z-index"] = _z;
	
	      if (data.fwrapper) data.fwrapper.css({
	        zIndex: _z || parseInt(data.parent.css("z-index"), 10) || 0
	      });
	
	      return this;
	    },
	
	    _cAllowed: function _cAllowed() {
	      var data = this.data().f,
	          page = data.opts.page,
	          turnData = data.opts.turn.data(),
	          odd = page % 2;
	
	      if (data.effect == "hard") {
	        return turnData.direction == "ltr" ? [odd ? "r" : "l"] : [odd ? "l" : "r"];
	      } else {
	        if (turnData.display == "single") {
	          if (page == 1) return turnData.direction == "ltr" ? corners["forward"] : corners["backward"];else if (page == turnData.totalPages) return turnData.direction == "ltr" ? corners["backward"] : corners["forward"];else return corners["all"];
	        } else {
	          return turnData.direction == "ltr" ? corners[odd ? "forward" : "backward"] : corners[odd ? "backward" : "forward"];
	        }
	      }
	    },
	
	    _cornerActivated: function _cornerActivated(p) {
	      var data = this.data().f,
	          width = this.width(),
	          height = this.height(),
	          point = {
	        x: p.x,
	        y: p.y,
	        corner: ""
	      },
	          csz = data.opts.cornerSize;
	
	      if (point.x <= 0 || point.y <= 0 || point.x >= width || point.y >= height) return false;
	
	      var allowedCorners = flipMethods._cAllowed.call(this);
	
	      switch (data.effect) {
	        case "hard":
	          if (point.x > width - csz) point.corner = "r";else if (point.x < csz) point.corner = "l";else return false;
	
	          break;
	
	        case "sheet":
	          if (point.y < csz) point.corner += "t";else if (point.y >= height - csz) point.corner += "b";else return false;
	
	          if (point.x <= csz) point.corner += "l";else if (point.x >= width - csz) point.corner += "r";else return false;
	
	          break;
	      }
	
	      return !point.corner || $.inArray(point.corner, allowedCorners) == -1 ? false : point;
	    },
	
	    _isIArea: function _isIArea(e) {
	      var pos = this.data().f.parent.offset();
	
	      e = isTouch && e.originalEvent ? e.originalEvent.touches[0] : e;
	
	      return flipMethods._cornerActivated.call(this, {
	        x: e.pageX - pos.left,
	        y: e.pageY - pos.top
	      });
	    },
	
	    _c: function _c(corner, opts) {
	      opts = opts || 0;
	
	      switch (corner) {
	        case "tl":
	          return point2D(opts, opts);
	        case "tr":
	          return point2D(this.width() - opts, opts);
	        case "bl":
	          return point2D(opts, this.height() - opts);
	        case "br":
	          return point2D(this.width() - opts, this.height() - opts);
	        case "l":
	          return point2D(opts, 0);
	        case "r":
	          return point2D(this.width() - opts, 0);
	      }
	    },
	
	    _c2: function _c2(corner) {
	      switch (corner) {
	        case "tl":
	          return point2D(this.width() * 2, 0);
	        case "tr":
	          return point2D(-this.width(), 0);
	        case "bl":
	          return point2D(this.width() * 2, this.height());
	        case "br":
	          return point2D(-this.width(), this.height());
	        case "l":
	          return point2D(this.width() * 2, 0);
	        case "r":
	          return point2D(-this.width(), 0);
	      }
	    },
	
	    _foldingPage: function _foldingPage() {
	      var data = this.data().f;
	
	      if (!data) return;
	
	      var opts = data.opts;
	
	      if (opts.turn) {
	        data = opts.turn.data();
	        if (data.display == "single") return opts.next > 1 || opts.page > 1 ? data.pageObjs[0] : null;else return data.pageObjs[opts.next];
	      }
	    },
	
	    _backGradient: function _backGradient() {
	      var data = this.data().f,
	          turnData = data.opts.turn.data(),
	          gradient = turnData.opts.gradients && (turnData.display == "single" || data.opts.page != 2 && data.opts.page != turnData.totalPages - 1);
	
	      if (gradient && !data.bshadow) data.bshadow = $("<div/>", divAtt(0, 0, 1)).css({
	        position: "",
	        width: this.width(),
	        height: this.height()
	      }).appendTo(data.parent);
	
	      return gradient;
	    },
	
	    type: function type() {
	      return this.data().f.effect;
	    },
	
	    resize: function resize(full) {
	      var data = this.data().f,
	          turnData = data.opts.turn.data(),
	          width = this.width(),
	          height = this.height();
	
	      switch (data.effect) {
	        case "hard":
	          if (full) {
	            data.wrapper.css({
	              width: width,
	              height: height
	            });
	            data.fpage.css({
	              width: width,
	              height: height
	            });
	            if (turnData.opts.gradients) {
	              data.ashadow.css({
	                width: width,
	                height: height
	              });
	              data.bshadow.css({
	                width: width,
	                height: height
	              });
	            }
	          }
	
	          break;
	        case "sheet":
	          if (full) {
	            var size = Math.round(Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2)));
	
	            data.wrapper.css({
	              width: size,
	              height: size
	            });
	            data.fwrapper.css({
	              width: size,
	              height: size
	            }).children(":first-child").css({
	              width: width,
	              height: height
	            });
	
	            data.fpage.css({
	              width: width,
	              height: height
	            });
	
	            if (turnData.opts.gradients) data.ashadow.css({
	              width: width,
	              height: height
	            });
	
	            if (flipMethods._backGradient.call(this)) data.bshadow.css({
	              width: width,
	              height: height
	            });
	          }
	
	          if (data.parent.is(":visible")) {
	            var offset = findPos(data.parent[0]);
	
	            data.fwrapper.css({
	              top: offset.top,
	              left: offset.left
	            });
	
	            //if (data.opts.turn) {
	            offset = findPos(data.opts.turn[0]);
	            data.fparent.css({
	              top: -offset.top,
	              left: -offset.left
	            });
	            //}
	          }
	
	          this.flip("z", data.opts["z-index"]);
	
	          break;
	      }
	    },
	
	    // Prepares the page by adding a general wrapper and another objects
	
	    _addPageWrapper: function _addPageWrapper() {
	      var att,
	          data = this.data().f,
	          turnData = data.opts.turn.data(),
	          parent = this.parent();
	
	      data.parent = parent;
	
	      if (!data.wrapper) switch (data.effect) {
	        case "hard":
	          var cssProperties = {};
	          cssProperties[vendor + "transform-style"] = "preserve-3d";
	          cssProperties[vendor + "backface-visibility"] = "hidden";
	
	          data.wrapper = $("<div/>", divAtt(0, 0, 2)).css(cssProperties).appendTo(parent).prepend(this);
	
	          data.fpage = $("<div/>", divAtt(0, 0, 1)).css(cssProperties).appendTo(parent);
	
	          if (turnData.opts.gradients) {
	            data.ashadow = $("<div/>", divAtt(0, 0, 0)).hide().appendTo(parent);
	
	            data.bshadow = $("<div/>", divAtt(0, 0, 0));
	          }
	
	          break;
	        case "sheet":
	          var width = this.width(),
	              height = this.height(),
	              size = Math.round(Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2)));
	
	          data.fparent = data.opts.turn.data().fparent;
	
	          if (!data.fparent) {
	            var fparent = $("<div/>", {
	              css: {
	                "pointer-events": "none"
	              }
	            }).hide();
	            fparent.data().flips = 0;
	            fparent.css(divAtt(0, 0, "auto", "visible").css).appendTo(data.opts.turn);
	
	            data.opts.turn.data().fparent = fparent;
	            data.fparent = fparent;
	          }
	
	          this.css({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            bottom: "auto",
	            right: "auto"
	          });
	
	          data.wrapper = $("<div/>", divAtt(0, 0, this.css("z-index"))).appendTo(parent).prepend(this);
	
	          data.fwrapper = $("<div/>", divAtt(parent.offset().top, parent.offset().left)).hide().appendTo(data.fparent);
	
	          data.fpage = $("<div/>", divAtt(0, 0, 0, "visible")).css({
	            cursor: "default"
	          }).appendTo(data.fwrapper);
	
	          if (turnData.opts.gradients) data.ashadow = $("<div/>", divAtt(0, 0, 1)).appendTo(data.fpage);
	
	          flipMethods.setData.call(this, data);
	
	          break;
	      }
	
	      // Set size
	      flipMethods.resize.call(this, true);
	    },
	
	    // Takes a 2P point from the screen and applies the transformation
	
	    _fold: function _fold(point) {
	      var data = this.data().f,
	          turnData = data.opts.turn.data(),
	          o = flipMethods._c.call(this, point.corner),
	          width = this.width(),
	          height = this.height();
	
	      switch (data.effect) {
	        case "hard":
	          if (point.corner == "l") point.x = Math.min(Math.max(point.x, 0), width * 2);else point.x = Math.max(Math.min(point.x, width), -width);
	
	          var leftPos,
	              shadow,
	              gradientX,
	              fpageOrigin,
	              parentOrigin,
	              totalPages = turnData.totalPages,
	              zIndex = data.opts["z-index"] || totalPages,
	              parentCss = {
	            overflow: "visible"
	          },
	              relX = o.x ? (o.x - point.x) / width : point.x / width,
	              angle = relX * 90,
	              half = angle < 90;
	
	          switch (point.corner) {
	            case "l":
	              fpageOrigin = "0% 50%";
	              parentOrigin = "100% 50%";
	
	              if (half) {
	                leftPos = 0;
	                shadow = data.opts.next - 1 > 0;
	                gradientX = 1;
	              } else {
	                leftPos = "100%";
	                shadow = data.opts.page + 1 < totalPages;
	                gradientX = 0;
	              }
	
	              break;
	            case "r":
	              fpageOrigin = "100% 50%";
	              parentOrigin = "0% 50%";
	              angle = -angle;
	              width = -width;
	
	              if (half) {
	                leftPos = 0;
	                shadow = data.opts.next + 1 < totalPages;
	                gradientX = 0;
	              } else {
	                leftPos = "-100%";
	                shadow = data.opts.page != 1;
	                gradientX = 1;
	              }
	
	              break;
	          }
	
	          parentCss[vendor + "perspective-origin"] = parentOrigin;
	
	          data.wrapper.transform("rotateY(" + angle + "deg)" + "translate3d(0px, 0px, " + (this.attr("depth") || 0) + "px)", parentOrigin);
	
	          data.fpage.transform("translateX(" + width + "px) rotateY(" + (180 + angle) + "deg)", fpageOrigin);
	
	          data.parent.css(parentCss);
	
	          if (half) {
	            relX = -relX + 1;
	            data.wrapper.css({
	              zIndex: zIndex + 1
	            });
	            data.fpage.css({
	              zIndex: zIndex
	            });
	          } else {
	            relX = relX - 1;
	            data.wrapper.css({
	              zIndex: zIndex
	            });
	            data.fpage.css({
	              zIndex: zIndex + 1
	            });
	          }
	
	          if (turnData.opts.gradients) {
	            if (shadow) data.ashadow.css({
	              display: "",
	              left: leftPos,
	              backgroundColor: "rgba(0,0,0," + 0.5 * relX + ")"
	            }).transform("rotateY(0deg)");else data.ashadow.hide();
	
	            data.bshadow.css({
	              opacity: -relX + 1
	            });
	
	            if (half) {
	              if (data.bshadow.parent()[0] != data.wrapper[0]) {
	                data.bshadow.appendTo(data.wrapper);
	              }
	            } else {
	              if (data.bshadow.parent()[0] != data.fpage[0]) {
	                data.bshadow.appendTo(data.fpage);
	              }
	            }
	            /*data.bshadow.css({
	                            backgroundColor: 'rgba(0,0,0,'+(0.1)+')'
	                          })*/
	            gradient(data.bshadow, point2D(gradientX * 100, 0), point2D((-gradientX + 1) * 100, 0), [[0, "rgba(0,0,0,0.3)"], [1, "rgba(0,0,0,0)"]], 2);
	          }
	
	          break;
	        case "sheet":
	          var that = this,
	              a = 0,
	              alpha = 0,
	              beta,
	              px,
	              gradientEndPointA,
	              gradientEndPointB,
	              gradientStartVal,
	              gradientSize,
	              gradientOpacity,
	              shadowVal,
	              mv = point2D(0, 0),
	              df = point2D(0, 0),
	              tr = point2D(0, 0),
	              folding = flipMethods._foldingPage.call(this),
	              tan = Math.tan(alpha),
	              ac = turnData.opts.acceleration,
	              h = data.wrapper[0].offsetHeight,
	              top = point.corner.substr(0, 1) == "t",
	              left = point.corner.substr(1, 1) == "l",
	              compute = function compute() {
	            var rel = point2D(0, 0);
	            var middle = point2D(0, 0);
	
	            rel.x = o.x ? o.x - point.x : point.x;
	
	            if (!hasRot) {
	              rel.y = 0;
	            } else {
	              rel.y = o.y ? o.y - point.y : point.y;
	            }
	
	            middle.x = left ? width - rel.x / 2 : point.x + rel.x / 2;
	            middle.y = rel.y / 2;
	
	            var alpha = A90 - Math.atan2(rel.y, rel.x),
	                gamma = alpha - Math.atan2(middle.y, middle.x),
	                distance = Math.max(0, Math.sin(gamma) * Math.sqrt(Math.pow(middle.x, 2) + Math.pow(middle.y, 2)));
	
	            a = deg(alpha);
	
	            tr = point2D(distance * Math.sin(alpha), distance * Math.cos(alpha));
	
	            if (alpha > A90) {
	              tr.x = tr.x + Math.abs(tr.y * rel.y / rel.x);
	              tr.y = 0;
	              if (Math.round(tr.x * Math.tan(PI - alpha)) < height) {
	                point.y = Math.sqrt(Math.pow(height, 2) + 2 * middle.x * rel.x);
	                if (top) point.y = height - point.y;
	                return compute();
	              }
	            }
	
	            if (alpha > A90) {
	              var beta = PI - alpha,
	                  dd = h - height / Math.sin(beta);
	              mv = point2D(Math.round(dd * Math.cos(beta)), Math.round(dd * Math.sin(beta)));
	              if (left) mv.x = -mv.x;
	              if (top) mv.y = -mv.y;
	            }
	
	            px = Math.round(tr.y / Math.tan(alpha) + tr.x);
	
	            var side = width - px,
	                sideX = side * Math.cos(alpha * 2),
	                sideY = side * Math.sin(alpha * 2);
	            df = point2D(Math.round(left ? side - sideX : px + sideX), Math.round(top ? sideY : height - sideY));
	
	            // Gradients
	            if (turnData.opts.gradients) {
	              gradientSize = side * Math.sin(alpha);
	
	              var endingPoint = flipMethods._c2.call(that, point.corner),
	                  far = Math.sqrt(Math.pow(endingPoint.x - point.x, 2) + Math.pow(endingPoint.y - point.y, 2)) / width;
	
	              shadowVal = Math.sin(A90 * (far > 1 ? 2 - far : far));
	
	              gradientOpacity = Math.min(far, 1);
	
	              gradientStartVal = gradientSize > 100 ? (gradientSize - 100) / gradientSize : 0;
	
	              gradientEndPointA = point2D(gradientSize * Math.sin(alpha) / width * 100, gradientSize * Math.cos(alpha) / height * 100);
	
	              if (flipMethods._backGradient.call(that)) {
	                gradientEndPointB = point2D(gradientSize * 1.2 * Math.sin(alpha) / width * 100, gradientSize * 1.2 * Math.cos(alpha) / height * 100);
	
	                if (!left) gradientEndPointB.x = 100 - gradientEndPointB.x;
	                if (!top) gradientEndPointB.y = 100 - gradientEndPointB.y;
	              }
	            }
	
	            tr.x = Math.round(tr.x);
	            tr.y = Math.round(tr.y);
	
	            return true;
	          },
	              transform = function transform(tr, c, x, a) {
	            var f = ["0", "auto"],
	                mvW = (width - h) * x[0] / 100,
	                mvH = (height - h) * x[1] / 100,
	                cssA = {
	              left: f[c[0]],
	              top: f[c[1]],
	              right: f[c[2]],
	              bottom: f[c[3]]
	            },
	                cssB = {},
	                aliasingFk = a != 90 && a != -90 ? left ? -1 : 1 : 0,
	                origin = x[0] + "% " + x[1] + "%";
	
	            that.css(cssA).transform(rotate(a) + translate(tr.x + aliasingFk, tr.y, ac), origin);
	
	            data.fpage.css(cssA).transform(rotate(a) + translate(tr.x + df.x - mv.x - width * x[0] / 100, tr.y + df.y - mv.y - height * x[1] / 100, ac) + rotate((180 / a - 2) * a), origin);
	
	            data.wrapper.transform(translate(-tr.x + mvW - aliasingFk, -tr.y + mvH, ac) + rotate(-a), origin);
	
	            data.fwrapper.transform(translate(-tr.x + mv.x + mvW, -tr.y + mv.y + mvH, ac) + rotate(-a), origin);
	
	            if (turnData.opts.gradients) {
	              if (x[0]) gradientEndPointA.x = 100 - gradientEndPointA.x;
	
	              if (x[1]) gradientEndPointA.y = 100 - gradientEndPointA.y;
	
	              cssB["box-shadow"] = "0 0 20px rgba(0,0,0," + 0.5 * shadowVal + ")";
	              folding.css(cssB);
	
	              gradient(data.ashadow, point2D(left ? 100 : 0, top ? 0 : 100), point2D(gradientEndPointA.x, gradientEndPointA.y), [[gradientStartVal, "rgba(0,0,0,0)"], [(1 - gradientStartVal) * 0.8 + gradientStartVal, "rgba(0,0,0," + 0.2 * gradientOpacity + ")"], [1, "rgba(255,255,255," + 0.2 * gradientOpacity + ")"]], 3, alpha);
	
	              if (flipMethods._backGradient.call(that)) gradient(data.bshadow, point2D(left ? 0 : 100, top ? 0 : 100), point2D(gradientEndPointB.x, gradientEndPointB.y), [[0.6, "rgba(0,0,0,0)"], [0.8, "rgba(0,0,0," + 0.3 * gradientOpacity + ")"], [1, "rgba(0,0,0,0)"]], 3);
	            }
	          };
	
	          switch (point.corner) {
	            case "l":
	              break;
	            case "r":
	              break;
	            case "tl":
	              point.x = Math.max(point.x, 1);
	              compute();
	              transform(tr, [1, 0, 0, 1], [100, 0], a);
	              break;
	            case "tr":
	              point.x = Math.min(point.x, width - 1);
	              compute();
	              transform(point2D(-tr.x, tr.y), [0, 0, 0, 1], [0, 0], -a);
	              break;
	            case "bl":
	              point.x = Math.max(point.x, 1);
	              compute();
	              transform(point2D(tr.x, -tr.y), [1, 1, 0, 0], [100, 100], -a);
	              break;
	            case "br":
	              point.x = Math.min(point.x, width - 1);
	              compute();
	              transform(point2D(-tr.x, -tr.y), [0, 1, 1, 0], [0, 100], a);
	              break;
	          }
	
	          break;
	      }
	
	      data.point = point;
	    },
	
	    _moveFoldingPage: function _moveFoldingPage(move) {
	      var data = this.data().f;
	
	      if (!data) return;
	
	      var turn = data.opts.turn,
	          turnData = turn.data(),
	          place = turnData.pagePlace;
	
	      if (move) {
	        var nextPage = data.opts.next;
	
	        if (place[nextPage] != data.opts.page) {
	          if (data.folding) flipMethods._moveFoldingPage.call(this, false);
	
	          var folding = flipMethods._foldingPage.call(this);
	
	          folding.appendTo(data.fpage);
	          place[nextPage] = data.opts.page;
	          data.folding = nextPage;
	        }
	
	        turn.turn("update");
	      } else {
	        if (data.folding) {
	          if (turnData.pages[data.folding]) {
	            // If we have flip available
	
	            var flipData = turnData.pages[data.folding].data().f;
	
	            turnData.pageObjs[data.folding].appendTo(flipData.wrapper);
	          } else if (turnData.pageWrap[data.folding]) {
	            // If we have the pageWrapper
	
	            turnData.pageObjs[data.folding].appendTo(turnData.pageWrap[data.folding]);
	          }
	
	          if (data.folding in place) {
	            place[data.folding] = data.folding;
	          }
	
	          delete data.folding;
	        }
	      }
	    },
	
	    _showFoldedPage: function _showFoldedPage(c, animate) {
	      var folding = flipMethods._foldingPage.call(this),
	          dd = this.data(),
	          data = dd.f,
	          visible = data.visible;
	
	      if (folding) {
	        if (!visible || !data.point || data.point.corner != c.corner) {
	          var corner = data.status == "hover" || data.status == "peel" || data.opts.turn.data().mouseAction ? c.corner : null;
	
	          visible = false;
	
	          if (trigger("start", this, [data.opts, corner]) == "prevented") return false;
	        }
	
	        if (animate) {
	          var that = this,
	              point = data.point && data.point.corner == c.corner ? data.point : flipMethods._c.call(this, c.corner, 1);
	
	          this.animatef({
	            from: [point.x, point.y],
	            to: [c.x, c.y],
	            duration: 500,
	            frame: function frame(v) {
	              c.x = Math.round(v[0]);
	              c.y = Math.round(v[1]);
	              flipMethods._fold.call(that, c);
	            }
	          });
	        } else {
	          flipMethods._fold.call(this, c);
	
	          if (dd.effect && !dd.effect.turning) this.animatef(false);
	        }
	
	        if (!visible) {
	          switch (data.effect) {
	            case "hard":
	              data.visible = true;
	              flipMethods._moveFoldingPage.call(this, true);
	              data.fpage.show();
	              if (data.opts.shadows) data.bshadow.show();
	
	              break;
	            case "sheet":
	              data.visible = true;
	              data.fparent.show().data().flips++;
	              flipMethods._moveFoldingPage.call(this, true);
	              data.fwrapper.show();
	              if (data.bshadow) data.bshadow.show();
	
	              break;
	          }
	        }
	
	        return true;
	      }
	
	      return false;
	    },
	
	    hide: function hide() {
	      var data = this.data().f,
	          turnData = data.opts.turn.data(),
	          folding = flipMethods._foldingPage.call(this);
	
	      switch (data.effect) {
	        case "hard":
	          if (turnData.opts.gradients) {
	            data.bshadowLoc = 0;
	            data.bshadow.remove();
	            data.ashadow.hide();
	          }
	
	          data.wrapper.transform("");
	          data.fpage.hide();
	
	          break;
	        case "sheet":
	          if (--data.fparent.data().flips === 0) data.fparent.hide();
	
	          this.css({
	            left: 0,
	            top: 0,
	            right: "auto",
	            bottom: "auto"
	          }).transform("");
	
	          data.wrapper.transform("");
	
	          data.fwrapper.hide();
	
	          if (data.bshadow) data.bshadow.hide();
	
	          folding.transform("");
	
	          break;
	      }
	
	      data.visible = false;
	
	      return this;
	    },
	
	    hideFoldedPage: function hideFoldedPage(animate) {
	      var data = this.data().f;
	
	      if (!data.point) return;
	
	      var that = this,
	          p1 = data.point,
	          hide = function hide() {
	        data.point = null;
	        data.status = "";
	        that.flip("hide");
	        that.trigger("end", [data.opts, false]);
	      };
	
	      if (animate) {
	        var p4 = flipMethods._c.call(this, p1.corner),
	            top = p1.corner.substr(0, 1) == "t",
	            delta = top ? Math.min(0, p1.y - p4.y) / 2 : Math.max(0, p1.y - p4.y) / 2,
	            p2 = point2D(p1.x, p1.y + delta),
	            p3 = point2D(p4.x, p4.y - delta);
	
	        this.animatef({
	          from: 0,
	          to: 1,
	          frame: function frame(v) {
	            var np = bezier(p1, p2, p3, p4, v);
	            p1.x = np.x;
	            p1.y = np.y;
	            flipMethods._fold.call(that, p1);
	          },
	          complete: hide,
	          duration: 800,
	          hiding: true
	        });
	      } else {
	        this.animatef(false);
	        hide();
	      }
	    },
	
	    turnPage: function turnPage(corner) {
	      var that = this,
	          data = this.data().f,
	          turnData = data.opts.turn.data();
	
	      corner = {
	        corner: data.corner ? data.corner.corner : corner || flipMethods._cAllowed.call(this)[0]
	      };
	
	      var p1 = data.point || flipMethods._c.call(this, corner.corner, data.opts.turn ? turnData.opts.elevation : 0),
	          p4 = flipMethods._c2.call(this, corner.corner);
	
	      this.trigger("flip").animatef({
	        from: 0,
	        to: 1,
	        frame: function frame(v) {
	          var np = bezier(p1, p1, p4, p4, v);
	          corner.x = np.x;
	          corner.y = np.y;
	          flipMethods._showFoldedPage.call(that, corner);
	        },
	        complete: function complete() {
	          that.trigger("end", [data.opts, true]);
	        },
	        duration: turnData.opts.duration,
	        turning: true
	      });
	
	      data.corner = null;
	    },
	
	    moving: function moving() {
	      return "effect" in this.data();
	    },
	
	    isTurning: function isTurning() {
	      return this.flip("moving") && this.data().effect.turning;
	    },
	
	    corner: function corner() {
	      return this.data().f.corner;
	    },
	
	    _eventStart: function _eventStart(e) {
	      var data = this.data().f,
	          turn = data.opts.turn;
	
	      if (!data.corner && !data.disabled && !this.flip("isTurning") && data.opts.page == turn.data().pagePlace[data.opts.page]) {
	        data.corner = flipMethods._isIArea.call(this, e);
	
	        if (data.corner && flipMethods._foldingPage.call(this)) {
	          this.trigger("pressed", [data.point]);
	          flipMethods._showFoldedPage.call(this, data.corner);
	
	          return false;
	        } else data.corner = null;
	      }
	    },
	
	    _eventMove: function _eventMove(e) {
	      var data = this.data().f;
	
	      if (!data.disabled) {
	        e = isTouch ? e.originalEvent.touches : [e];
	
	        if (data.corner) {
	          var pos = data.parent.offset();
	          data.corner.x = e[0].pageX - pos.left;
	          data.corner.y = e[0].pageY - pos.top;
	          flipMethods._showFoldedPage.call(this, data.corner);
	        } else if (data.hover && !this.data().effect && this.is(":visible")) {
	          var point = flipMethods._isIArea.call(this, e[0]);
	
	          if (point) {
	            if (data.effect == "sheet" && point.corner.length == 2 || data.effect == "hard") {
	              data.status = "hover";
	              var origin = flipMethods._c.call(this, point.corner, data.opts.cornerSize / 2);
	              point.x = origin.x;
	              point.y = origin.y;
	              flipMethods._showFoldedPage.call(this, point, true);
	            }
	          } else {
	            if (data.status == "hover") {
	              data.status = "";
	              flipMethods.hideFoldedPage.call(this, true);
	            }
	          }
	        }
	      }
	    },
	
	    _eventEnd: function _eventEnd() {
	      var data = this.data().f,
	          corner = data.corner;
	
	      if (!data.disabled && corner) {
	        if (trigger("released", this, [data.point || corner]) != "prevented") {
	          flipMethods.hideFoldedPage.call(this, true);
	        }
	      }
	
	      data.corner = null;
	    },
	
	    disable: function disable(_disable2) {
	      flipMethods.setData.call(this, {
	        disabled: _disable2
	      });
	      return this;
	    },
	
	    hover: function hover(_hover) {
	      flipMethods.setData.call(this, {
	        hover: _hover
	      });
	      return this;
	    },
	
	    peel: function peel(corner, animate) {
	      var data = this.data().f;
	
	      if (corner) {
	        if ($.inArray(corner, corners.all) == -1) throw turnError("Corner " + corner + " is not permitted");
	
	        if ($.inArray(corner, flipMethods._cAllowed.call(this)) != -1) {
	          var point = flipMethods._c.call(this, corner, data.opts.cornerSize / 2);
	
	          data.status = "peel";
	
	          flipMethods._showFoldedPage.call(this, {
	            corner: corner,
	            x: point.x,
	            y: point.y
	          }, animate);
	        }
	      } else {
	        data.status = "";
	
	        flipMethods.hideFoldedPage.call(this, animate);
	      }
	
	      return this;
	    }
	  };
	
	  // Processes classes
	
	  function dec(that, methods, args) {
	    if (!args[0] || (0, _typeof3.default)(args[0]) == "object") return methods.init.apply(that, args);else if (methods[args[0]]) return methods[args[0]].apply(that, Array.prototype.slice.call(args, 1));else throw turnError(args[0] + " is not a method or property");
	  }
	
	  // Attributes for a layer
	
	  function divAtt(top, left, zIndex, overf) {
	    return {
	      css: {
	        position: "absolute",
	        top: top,
	        left: left,
	        overflow: overf || "hidden",
	        zIndex: zIndex || "auto"
	      }
	    };
	  }
	
	  // Gets a 2D point from a bezier curve of four points
	
	  function bezier(p1, p2, p3, p4, t) {
	    var a = 1 - t,
	        b = a * a * a,
	        c = t * t * t;
	
	    return point2D(Math.round(b * p1.x + 3 * t * a * a * p2.x + 3 * t * t * a * p3.x + c * p4.x), Math.round(b * p1.y + 3 * t * a * a * p2.y + 3 * t * t * a * p3.y + c * p4.y));
	  }
	
	  // Converts an angle from degrees to radians
	
	  function rad(degrees) {
	    return degrees / 180 * PI;
	  }
	
	  // Converts an angle from radians to degrees
	
	  function deg(radians) {
	    return radians / PI * 180;
	  }
	
	  // Gets a 2D point
	
	  function point2D(x, y) {
	    return {
	      x: x,
	      y: y
	    };
	  }
	
	  // Webkit 534.3 on Android wrongly repaints elements that use overflow:hidden + rotation
	
	  function rotationAvailable() {
	    var parts;
	
	    if (parts = /AppleWebkit\/([0-9\.]+)/i.exec(navigator.userAgent)) {
	      var webkitVersion = parseFloat(parts[1]);
	      return webkitVersion > 534.3;
	    } else {
	      return true;
	    }
	  }
	
	  // Returns the traslate value
	
	  function translate(x, y, use3d) {
	    return has3d && use3d ? " translate3d(" + x + "px," + y + "px, 0px) " : " translate(" + x + "px, " + y + "px) ";
	  }
	
	  // Returns the rotation value
	
	  function rotate(degrees) {
	    return " rotate(" + degrees + "deg) ";
	  }
	
	  // Checks if a property belongs to an object
	
	  function has(property, object) {
	    return Object.prototype.hasOwnProperty.call(object, property);
	  }
	
	  // Gets the CSS3 vendor prefix
	
	  function getPrefix() {
	    var vendorPrefixes = ["Moz", "Webkit", "Khtml", "O", "ms"],
	        len = vendorPrefixes.length,
	        vendor = "";
	
	    while (len--) {
	      if (vendorPrefixes[len] + "Transform" in document.body.style) vendor = "-" + vendorPrefixes[len].toLowerCase() + "-";
	    }return vendor;
	  }
	
	  // Detects the transitionEnd Event
	
	  function getTransitionEnd() {
	    var t,
	        el = document.createElement("fakeelement"),
	        transitions = {
	      transition: "transitionend",
	      OTransition: "oTransitionEnd",
	      MSTransition: "transitionend",
	      MozTransition: "transitionend",
	      WebkitTransition: "webkitTransitionEnd"
	    };
	
	    for (t in transitions) {
	      if (el.style[t] !== undefined) {
	        return transitions[t];
	      }
	    }
	  }
	
	  // Gradients
	
	  function gradient(obj, p0, p1, colors, numColors) {
	    var j,
	        cols = [];
	
	    if (vendor == "-webkit-") {
	      for (j = 0; j < numColors; j++) {
	        cols.push("color-stop(" + colors[j][0] + ", " + colors[j][1] + ")");
	      }obj.css({
	        "background-image": "-webkit-gradient(linear, " + p0.x + "% " + p0.y + "%," + p1.x + "% " + p1.y + "%, " + cols.join(",") + " )"
	      });
	    } else {
	      p0 = {
	        x: p0.x / 100 * obj.width(),
	        y: p0.y / 100 * obj.height()
	      };
	      p1 = {
	        x: p1.x / 100 * obj.width(),
	        y: p1.y / 100 * obj.height()
	      };
	
	      var dx = p1.x - p0.x,
	          dy = p1.y - p0.y,
	          angle = Math.atan2(dy, dx),
	          angle2 = angle - Math.PI / 2,
	          diagonal = Math.abs(obj.width() * Math.sin(angle2)) + Math.abs(obj.height() * Math.cos(angle2)),
	          gradientDiagonal = Math.sqrt(dy * dy + dx * dx),
	          corner = point2D(p1.x < p0.x ? obj.width() : 0, p1.y < p0.y ? obj.height() : 0),
	          slope = Math.tan(angle),
	          inverse = -1 / slope,
	          x = (inverse * corner.x - corner.y - slope * p0.x + p0.y) / (inverse - slope),
	          c = {
	        x: x,
	        y: inverse * x - inverse * corner.x + corner.y
	      },
	          segA = Math.sqrt(Math.pow(c.x - p0.x, 2) + Math.pow(c.y - p0.y, 2));
	
	      for (j = 0; j < numColors; j++) {
	        cols.push(" " + colors[j][1] + " " + (segA + gradientDiagonal * colors[j][0]) * 100 / diagonal + "%");
	      }obj.css({
	        "background-image": vendor + "linear-gradient(" + -angle + "rad," + cols.join(",") + ")"
	      });
	    }
	  }
	
	  // Triggers an event
	
	  function trigger(eventName, context, args) {
	    // console.log("ARGS:");
	    // console.log(args);
	    var event = $.Event(eventName);
	    // console.log(event);
	    context.trigger(event, args);
	    if (event.isDefaultPrevented()) return "prevented";else if (event.isPropagationStopped()) return "stopped";else return "";
	  }
	
	  // JS Errors
	
	  function turnError(message) {
	    function TurnJsError(message) {
	      this.name = "TurnJsError";
	      this.message = message;
	    }
	
	    TurnJsError.prototype = new Error();
	    TurnJsError.prototype.constructor = TurnJsError;
	    return new TurnJsError(message);
	  }
	
	  // Find the offset of an element ignoring its transformation
	
	  function findPos(obj) {
	    var offset = {
	      top: 0,
	      left: 0
	    };
	
	    do {
	      offset.left += obj.offsetLeft;
	      offset.top += obj.offsetTop;
	    } while (obj = obj.offsetParent);
	
	    return offset;
	  }
	
	  // Checks if there's hard page compatibility
	  // IE9 is the only browser that does not support hard pages
	
	  function hasHardPage() {
	    return navigator.userAgent.indexOf("MSIE 9.0") == -1;
	  }
	
	  // Request an animation
	
	  window.requestAnim = function () {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
	      window.setTimeout(callback, 1000 / 60);
	    };
	  }();
	
	  // Extend $.fn
	
	  $.extend($.fn, {
	    flip: function flip() {
	      return dec($(this[0]), flipMethods, arguments);
	    },
	
	    turn: function turn() {
	      return dec($(this[0]), turnMethods, arguments);
	    },
	
	    transform: function transform(_transform, origin) {
	      var properties = {};
	
	      if (origin) properties[vendor + "transform-origin"] = origin;
	
	      properties[vendor + "transform"] = _transform;
	
	      return this.css(properties);
	    },
	
	    animatef: function animatef(point) {
	      var data = this.data();
	
	      if (data.effect) data.effect.stop();
	
	      if (point) {
	        if (!point.to.length) point.to = [point.to];
	        if (!point.from.length) point.from = [point.from];
	
	        var diff = [],
	            len = point.to.length,
	            animating = true,
	            that = this,
	            time = new Date().getTime(),
	            frame = function frame() {
	          if (!data.effect || !animating) return;
	
	          var v = [],
	              timeDiff = Math.min(point.duration, new Date().getTime() - time);
	
	          for (var i = 0; i < len; i++) {
	            v.push(data.effect.easing(1, timeDiff, point.from[i], diff[i], point.duration));
	          }point.frame(len == 1 ? v[0] : v);
	
	          if (timeDiff == point.duration) {
	            delete data["effect"];
	            that.data(data);
	            if (point.complete) point.complete();
	          } else {
	            window.requestAnim(frame);
	          }
	        };
	
	        for (var i = 0; i < len; i++) {
	          diff.push(point.to[i] - point.from[i]);
	        }data.effect = $.extend({
	          stop: function stop() {
	            animating = false;
	          },
	          easing: function easing(x, t, b, c, data) {
	            return c * Math.sqrt(1 - (t = t / data - 1) * t) + b;
	          }
	        }, point);
	
	        this.data(data);
	
	        frame();
	      } else {
	        delete data["effect"];
	      }
	    }
	  });
	
	  // Export some globals
	
	  $.isTouch = isTouch;
	  $.mouseEvents = mouseEvents;
	  $.cssPrefix = getPrefix;
	  $.cssTransitionEnd = getTransitionEnd;
	  $.findPos = findPos;
	})(jQuery);

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(488), __esModule: true };

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(482);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(97);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42);
	__webpack_require__(41);
	module.exports = __webpack_require__(489);


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(86);
	var ITERATOR = __webpack_require__(17)('iterator');
	var Iterators = __webpack_require__(33);
	module.exports = __webpack_require__(13).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Cropper.js v1.5.9
	 * https://fengyuanchen.github.io/cropperjs
	 *
	 * Copyright 2015-present Chen Fengyuan
	 * Released under the MIT license
	 *
	 * Date: 2020-09-10T13:16:26.743Z
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Cropper = factory());
	}(this, (function () { 'use strict';
	
	  function _typeof(obj) {
	    "@babel/helpers - typeof";
	
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function ownKeys(object, enumerableOnly) {
	    var keys = Object.keys(object);
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(object);
	      if (enumerableOnly) symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	      keys.push.apply(keys, symbols);
	    }
	
	    return keys;
	  }
	
	  function _objectSpread2(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	
	      if (i % 2) {
	        ownKeys(Object(source), true).forEach(function (key) {
	          _defineProperty(target, key, source[key]);
	        });
	      } else if (Object.getOwnPropertyDescriptors) {
	        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	      } else {
	        ownKeys(Object(source)).forEach(function (key) {
	          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	        });
	      }
	    }
	
	    return target;
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	  }
	
	  function _iterableToArray(iter) {
	    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	  }
	
	  function _unsupportedIterableToArray(o, minLen) {
	    if (!o) return;
	    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	    var n = Object.prototype.toString.call(o).slice(8, -1);
	    if (n === "Object" && o.constructor) n = o.constructor.name;
	    if (n === "Map" || n === "Set") return Array.from(o);
	    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	  }
	
	  function _arrayLikeToArray(arr, len) {
	    if (len == null || len > arr.length) len = arr.length;
	
	    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	
	    return arr2;
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	
	  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
	  var WINDOW = IS_BROWSER ? window : {};
	  var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
	  var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
	  var NAMESPACE = 'cropper'; // Actions
	
	  var ACTION_ALL = 'all';
	  var ACTION_CROP = 'crop';
	  var ACTION_MOVE = 'move';
	  var ACTION_ZOOM = 'zoom';
	  var ACTION_EAST = 'e';
	  var ACTION_WEST = 'w';
	  var ACTION_SOUTH = 's';
	  var ACTION_NORTH = 'n';
	  var ACTION_NORTH_EAST = 'ne';
	  var ACTION_NORTH_WEST = 'nw';
	  var ACTION_SOUTH_EAST = 'se';
	  var ACTION_SOUTH_WEST = 'sw'; // Classes
	
	  var CLASS_CROP = "".concat(NAMESPACE, "-crop");
	  var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
	  var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
	  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
	  var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
	  var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
	  var CLASS_MOVE = "".concat(NAMESPACE, "-move"); // Data keys
	
	  var DATA_ACTION = "".concat(NAMESPACE, "Action");
	  var DATA_PREVIEW = "".concat(NAMESPACE, "Preview"); // Drag modes
	
	  var DRAG_MODE_CROP = 'crop';
	  var DRAG_MODE_MOVE = 'move';
	  var DRAG_MODE_NONE = 'none'; // Events
	
	  var EVENT_CROP = 'crop';
	  var EVENT_CROP_END = 'cropend';
	  var EVENT_CROP_MOVE = 'cropmove';
	  var EVENT_CROP_START = 'cropstart';
	  var EVENT_DBLCLICK = 'dblclick';
	  var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
	  var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
	  var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
	  var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
	  var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
	  var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
	  var EVENT_READY = 'ready';
	  var EVENT_RESIZE = 'resize';
	  var EVENT_WHEEL = 'wheel';
	  var EVENT_ZOOM = 'zoom'; // Mime types
	
	  var MIME_TYPE_JPEG = 'image/jpeg'; // RegExps
	
	  var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
	  var REGEXP_DATA_URL = /^data:/;
	  var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
	  var REGEXP_TAG_NAME = /^img|canvas$/i; // Misc
	  // Inspired by the default width and height of a canvas element.
	
	  var MIN_CONTAINER_WIDTH = 200;
	  var MIN_CONTAINER_HEIGHT = 100;
	
	  var DEFAULTS = {
	    // Define the view mode of the cropper
	    viewMode: 0,
	    // 0, 1, 2, 3
	    // Define the dragging mode of the cropper
	    dragMode: DRAG_MODE_CROP,
	    // 'crop', 'move' or 'none'
	    // Define the initial aspect ratio of the crop box
	    initialAspectRatio: NaN,
	    // Define the aspect ratio of the crop box
	    aspectRatio: NaN,
	    // An object with the previous cropping result data
	    data: null,
	    // A selector for adding extra containers to preview
	    preview: '',
	    // Re-render the cropper when resize the window
	    responsive: true,
	    // Restore the cropped area after resize the window
	    restore: true,
	    // Check if the current image is a cross-origin image
	    checkCrossOrigin: true,
	    // Check the current image's Exif Orientation information
	    checkOrientation: true,
	    // Show the black modal
	    modal: true,
	    // Show the dashed lines for guiding
	    guides: true,
	    // Show the center indicator for guiding
	    center: true,
	    // Show the white modal to highlight the crop box
	    highlight: true,
	    // Show the grid background
	    background: true,
	    // Enable to crop the image automatically when initialize
	    autoCrop: true,
	    // Define the percentage of automatic cropping area when initializes
	    autoCropArea: 0.8,
	    // Enable to move the image
	    movable: true,
	    // Enable to rotate the image
	    rotatable: true,
	    // Enable to scale the image
	    scalable: true,
	    // Enable to zoom the image
	    zoomable: true,
	    // Enable to zoom the image by dragging touch
	    zoomOnTouch: true,
	    // Enable to zoom the image by wheeling mouse
	    zoomOnWheel: true,
	    // Define zoom ratio when zoom the image by wheeling mouse
	    wheelZoomRatio: 0.1,
	    // Enable to move the crop box
	    cropBoxMovable: true,
	    // Enable to resize the crop box
	    cropBoxResizable: true,
	    // Toggle drag mode between "crop" and "move" when click twice on the cropper
	    toggleDragModeOnDblclick: true,
	    // Size limitation
	    minCanvasWidth: 0,
	    minCanvasHeight: 0,
	    minCropBoxWidth: 0,
	    minCropBoxHeight: 0,
	    minContainerWidth: MIN_CONTAINER_WIDTH,
	    minContainerHeight: MIN_CONTAINER_HEIGHT,
	    // Shortcuts of events
	    ready: null,
	    cropstart: null,
	    cropmove: null,
	    cropend: null,
	    crop: null,
	    zoom: null
	  };
	
	  var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';
	
	  /**
	   * Check if the given value is not a number.
	   */
	
	  var isNaN = Number.isNaN || WINDOW.isNaN;
	  /**
	   * Check if the given value is a number.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
	   */
	
	  function isNumber(value) {
	    return typeof value === 'number' && !isNaN(value);
	  }
	  /**
	   * Check if the given value is a positive number.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
	   */
	
	  var isPositiveNumber = function isPositiveNumber(value) {
	    return value > 0 && value < Infinity;
	  };
	  /**
	   * Check if the given value is undefined.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
	   */
	
	  function isUndefined(value) {
	    return typeof value === 'undefined';
	  }
	  /**
	   * Check if the given value is an object.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
	   */
	
	  function isObject(value) {
	    return _typeof(value) === 'object' && value !== null;
	  }
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  /**
	   * Check if the given value is a plain object.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
	   */
	
	  function isPlainObject(value) {
	    if (!isObject(value)) {
	      return false;
	    }
	
	    try {
	      var _constructor = value.constructor;
	      var prototype = _constructor.prototype;
	      return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
	    } catch (error) {
	      return false;
	    }
	  }
	  /**
	   * Check if the given value is a function.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
	   */
	
	  function isFunction(value) {
	    return typeof value === 'function';
	  }
	  var slice = Array.prototype.slice;
	  /**
	   * Convert array-like or iterable object to an array.
	   * @param {*} value - The value to convert.
	   * @returns {Array} Returns a new array.
	   */
	
	  function toArray(value) {
	    return Array.from ? Array.from(value) : slice.call(value);
	  }
	  /**
	   * Iterate the given data.
	   * @param {*} data - The data to iterate.
	   * @param {Function} callback - The process function for each element.
	   * @returns {*} The original data.
	   */
	
	  function forEach(data, callback) {
	    if (data && isFunction(callback)) {
	      if (Array.isArray(data) || isNumber(data.length)
	      /* array-like */
	      ) {
	          toArray(data).forEach(function (value, key) {
	            callback.call(data, value, key, data);
	          });
	        } else if (isObject(data)) {
	        Object.keys(data).forEach(function (key) {
	          callback.call(data, data[key], key, data);
	        });
	      }
	    }
	
	    return data;
	  }
	  /**
	   * Extend the given object.
	   * @param {*} target - The target object to extend.
	   * @param {*} args - The rest objects for merging to the target object.
	   * @returns {Object} The extended object.
	   */
	
	  var assign = Object.assign || function assign(target) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (isObject(target) && args.length > 0) {
	      args.forEach(function (arg) {
	        if (isObject(arg)) {
	          Object.keys(arg).forEach(function (key) {
	            target[key] = arg[key];
	          });
	        }
	      });
	    }
	
	    return target;
	  };
	  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
	  /**
	   * Normalize decimal number.
	   * Check out {@link https://0.30000000000000004.com/}
	   * @param {number} value - The value to normalize.
	   * @param {number} [times=100000000000] - The times for normalizing.
	   * @returns {number} Returns the normalized number.
	   */
	
	  function normalizeDecimalNumber(value) {
	    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
	    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
	  }
	  var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
	  /**
	   * Apply styles to the given element.
	   * @param {Element} element - The target element.
	   * @param {Object} styles - The styles for applying.
	   */
	
	  function setStyle(element, styles) {
	    var style = element.style;
	    forEach(styles, function (value, property) {
	      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
	        value = "".concat(value, "px");
	      }
	
	      style[property] = value;
	    });
	  }
	  /**
	   * Check if the given element has a special class.
	   * @param {Element} element - The element to check.
	   * @param {string} value - The class to search.
	   * @returns {boolean} Returns `true` if the special class was found.
	   */
	
	  function hasClass(element, value) {
	    return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
	  }
	  /**
	   * Add classes to the given element.
	   * @param {Element} element - The target element.
	   * @param {string} value - The classes to be added.
	   */
	
	  function addClass(element, value) {
	    if (!value) {
	      return;
	    }
	
	    if (isNumber(element.length)) {
	      forEach(element, function (elem) {
	        addClass(elem, value);
	      });
	      return;
	    }
	
	    if (element.classList) {
	      element.classList.add(value);
	      return;
	    }
	
	    var className = element.className.trim();
	
	    if (!className) {
	      element.className = value;
	    } else if (className.indexOf(value) < 0) {
	      element.className = "".concat(className, " ").concat(value);
	    }
	  }
	  /**
	   * Remove classes from the given element.
	   * @param {Element} element - The target element.
	   * @param {string} value - The classes to be removed.
	   */
	
	  function removeClass(element, value) {
	    if (!value) {
	      return;
	    }
	
	    if (isNumber(element.length)) {
	      forEach(element, function (elem) {
	        removeClass(elem, value);
	      });
	      return;
	    }
	
	    if (element.classList) {
	      element.classList.remove(value);
	      return;
	    }
	
	    if (element.className.indexOf(value) >= 0) {
	      element.className = element.className.replace(value, '');
	    }
	  }
	  /**
	   * Add or remove classes from the given element.
	   * @param {Element} element - The target element.
	   * @param {string} value - The classes to be toggled.
	   * @param {boolean} added - Add only.
	   */
	
	  function toggleClass(element, value, added) {
	    if (!value) {
	      return;
	    }
	
	    if (isNumber(element.length)) {
	      forEach(element, function (elem) {
	        toggleClass(elem, value, added);
	      });
	      return;
	    } // IE10-11 doesn't support the second parameter of `classList.toggle`
	
	
	    if (added) {
	      addClass(element, value);
	    } else {
	      removeClass(element, value);
	    }
	  }
	  var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
	  /**
	   * Transform the given string from camelCase to kebab-case
	   * @param {string} value - The value to transform.
	   * @returns {string} The transformed value.
	   */
	
	  function toParamCase(value) {
	    return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
	  }
	  /**
	   * Get data from the given element.
	   * @param {Element} element - The target element.
	   * @param {string} name - The data key to get.
	   * @returns {string} The data value.
	   */
	
	  function getData(element, name) {
	    if (isObject(element[name])) {
	      return element[name];
	    }
	
	    if (element.dataset) {
	      return element.dataset[name];
	    }
	
	    return element.getAttribute("data-".concat(toParamCase(name)));
	  }
	  /**
	   * Set data to the given element.
	   * @param {Element} element - The target element.
	   * @param {string} name - The data key to set.
	   * @param {string} data - The data value.
	   */
	
	  function setData(element, name, data) {
	    if (isObject(data)) {
	      element[name] = data;
	    } else if (element.dataset) {
	      element.dataset[name] = data;
	    } else {
	      element.setAttribute("data-".concat(toParamCase(name)), data);
	    }
	  }
	  /**
	   * Remove data from the given element.
	   * @param {Element} element - The target element.
	   * @param {string} name - The data key to remove.
	   */
	
	  function removeData(element, name) {
	    if (isObject(element[name])) {
	      try {
	        delete element[name];
	      } catch (error) {
	        element[name] = undefined;
	      }
	    } else if (element.dataset) {
	      // #128 Safari not allows to delete dataset property
	      try {
	        delete element.dataset[name];
	      } catch (error) {
	        element.dataset[name] = undefined;
	      }
	    } else {
	      element.removeAttribute("data-".concat(toParamCase(name)));
	    }
	  }
	  var REGEXP_SPACES = /\s\s*/;
	
	  var onceSupported = function () {
	    var supported = false;
	
	    if (IS_BROWSER) {
	      var once = false;
	
	      var listener = function listener() {};
	
	      var options = Object.defineProperty({}, 'once', {
	        get: function get() {
	          supported = true;
	          return once;
	        },
	
	        /**
	         * This setter can fix a `TypeError` in strict mode
	         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
	         * @param {boolean} value - The value to set
	         */
	        set: function set(value) {
	          once = value;
	        }
	      });
	      WINDOW.addEventListener('test', listener, options);
	      WINDOW.removeEventListener('test', listener, options);
	    }
	
	    return supported;
	  }();
	  /**
	   * Remove event listener from the target element.
	   * @param {Element} element - The event target.
	   * @param {string} type - The event type(s).
	   * @param {Function} listener - The event listener.
	   * @param {Object} options - The event options.
	   */
	
	
	  function removeListener(element, type, listener) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var handler = listener;
	    type.trim().split(REGEXP_SPACES).forEach(function (event) {
	      if (!onceSupported) {
	        var listeners = element.listeners;
	
	        if (listeners && listeners[event] && listeners[event][listener]) {
	          handler = listeners[event][listener];
	          delete listeners[event][listener];
	
	          if (Object.keys(listeners[event]).length === 0) {
	            delete listeners[event];
	          }
	
	          if (Object.keys(listeners).length === 0) {
	            delete element.listeners;
	          }
	        }
	      }
	
	      element.removeEventListener(event, handler, options);
	    });
	  }
	  /**
	   * Add event listener to the target element.
	   * @param {Element} element - The event target.
	   * @param {string} type - The event type(s).
	   * @param {Function} listener - The event listener.
	   * @param {Object} options - The event options.
	   */
	
	  function addListener(element, type, listener) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var _handler = listener;
	    type.trim().split(REGEXP_SPACES).forEach(function (event) {
	      if (options.once && !onceSupported) {
	        var _element$listeners = element.listeners,
	            listeners = _element$listeners === void 0 ? {} : _element$listeners;
	
	        _handler = function handler() {
	          delete listeners[event][listener];
	          element.removeEventListener(event, _handler, options);
	
	          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          listener.apply(element, args);
	        };
	
	        if (!listeners[event]) {
	          listeners[event] = {};
	        }
	
	        if (listeners[event][listener]) {
	          element.removeEventListener(event, listeners[event][listener], options);
	        }
	
	        listeners[event][listener] = _handler;
	        element.listeners = listeners;
	      }
	
	      element.addEventListener(event, _handler, options);
	    });
	  }
	  /**
	   * Dispatch event on the target element.
	   * @param {Element} element - The event target.
	   * @param {string} type - The event type(s).
	   * @param {Object} data - The additional event data.
	   * @returns {boolean} Indicate if the event is default prevented or not.
	   */
	
	  function dispatchEvent(element, type, data) {
	    var event; // Event and CustomEvent on IE9-11 are global objects, not constructors
	
	    if (isFunction(Event) && isFunction(CustomEvent)) {
	      event = new CustomEvent(type, {
	        detail: data,
	        bubbles: true,
	        cancelable: true
	      });
	    } else {
	      event = document.createEvent('CustomEvent');
	      event.initCustomEvent(type, true, true, data);
	    }
	
	    return element.dispatchEvent(event);
	  }
	  /**
	   * Get the offset base on the document.
	   * @param {Element} element - The target element.
	   * @returns {Object} The offset data.
	   */
	
	  function getOffset(element) {
	    var box = element.getBoundingClientRect();
	    return {
	      left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
	      top: box.top + (window.pageYOffset - document.documentElement.clientTop)
	    };
	  }
	  var location = WINDOW.location;
	  var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
	  /**
	   * Check if the given URL is a cross origin URL.
	   * @param {string} url - The target URL.
	   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
	   */
	
	  function isCrossOriginURL(url) {
	    var parts = url.match(REGEXP_ORIGINS);
	    return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
	  }
	  /**
	   * Add timestamp to the given URL.
	   * @param {string} url - The target URL.
	   * @returns {string} The result URL.
	   */
	
	  function addTimestamp(url) {
	    var timestamp = "timestamp=".concat(new Date().getTime());
	    return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
	  }
	  /**
	   * Get transforms base on the given object.
	   * @param {Object} obj - The target object.
	   * @returns {string} A string contains transform values.
	   */
	
	  function getTransforms(_ref) {
	    var rotate = _ref.rotate,
	        scaleX = _ref.scaleX,
	        scaleY = _ref.scaleY,
	        translateX = _ref.translateX,
	        translateY = _ref.translateY;
	    var values = [];
	
	    if (isNumber(translateX) && translateX !== 0) {
	      values.push("translateX(".concat(translateX, "px)"));
	    }
	
	    if (isNumber(translateY) && translateY !== 0) {
	      values.push("translateY(".concat(translateY, "px)"));
	    } // Rotate should come first before scale to match orientation transform
	
	
	    if (isNumber(rotate) && rotate !== 0) {
	      values.push("rotate(".concat(rotate, "deg)"));
	    }
	
	    if (isNumber(scaleX) && scaleX !== 1) {
	      values.push("scaleX(".concat(scaleX, ")"));
	    }
	
	    if (isNumber(scaleY) && scaleY !== 1) {
	      values.push("scaleY(".concat(scaleY, ")"));
	    }
	
	    var transform = values.length ? values.join(' ') : 'none';
	    return {
	      WebkitTransform: transform,
	      msTransform: transform,
	      transform: transform
	    };
	  }
	  /**
	   * Get the max ratio of a group of pointers.
	   * @param {string} pointers - The target pointers.
	   * @returns {number} The result ratio.
	   */
	
	  function getMaxZoomRatio(pointers) {
	    var pointers2 = _objectSpread2({}, pointers);
	
	    var maxRatio = 0;
	    forEach(pointers, function (pointer, pointerId) {
	      delete pointers2[pointerId];
	      forEach(pointers2, function (pointer2) {
	        var x1 = Math.abs(pointer.startX - pointer2.startX);
	        var y1 = Math.abs(pointer.startY - pointer2.startY);
	        var x2 = Math.abs(pointer.endX - pointer2.endX);
	        var y2 = Math.abs(pointer.endY - pointer2.endY);
	        var z1 = Math.sqrt(x1 * x1 + y1 * y1);
	        var z2 = Math.sqrt(x2 * x2 + y2 * y2);
	        var ratio = (z2 - z1) / z1;
	
	        if (Math.abs(ratio) > Math.abs(maxRatio)) {
	          maxRatio = ratio;
	        }
	      });
	    });
	    return maxRatio;
	  }
	  /**
	   * Get a pointer from an event object.
	   * @param {Object} event - The target event object.
	   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
	   * @returns {Object} The result pointer contains start and/or end point coordinates.
	   */
	
	  function getPointer(_ref2, endOnly) {
	    var pageX = _ref2.pageX,
	        pageY = _ref2.pageY;
	    var end = {
	      endX: pageX,
	      endY: pageY
	    };
	    return endOnly ? end : _objectSpread2({
	      startX: pageX,
	      startY: pageY
	    }, end);
	  }
	  /**
	   * Get the center point coordinate of a group of pointers.
	   * @param {Object} pointers - The target pointers.
	   * @returns {Object} The center point coordinate.
	   */
	
	  function getPointersCenter(pointers) {
	    var pageX = 0;
	    var pageY = 0;
	    var count = 0;
	    forEach(pointers, function (_ref3) {
	      var startX = _ref3.startX,
	          startY = _ref3.startY;
	      pageX += startX;
	      pageY += startY;
	      count += 1;
	    });
	    pageX /= count;
	    pageY /= count;
	    return {
	      pageX: pageX,
	      pageY: pageY
	    };
	  }
	  /**
	   * Get the max sizes in a rectangle under the given aspect ratio.
	   * @param {Object} data - The original sizes.
	   * @param {string} [type='contain'] - The adjust type.
	   * @returns {Object} The result sizes.
	   */
	
	  function getAdjustedSizes(_ref4) // or 'cover'
	  {
	    var aspectRatio = _ref4.aspectRatio,
	        height = _ref4.height,
	        width = _ref4.width;
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
	    var isValidWidth = isPositiveNumber(width);
	    var isValidHeight = isPositiveNumber(height);
	
	    if (isValidWidth && isValidHeight) {
	      var adjustedWidth = height * aspectRatio;
	
	      if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
	        height = width / aspectRatio;
	      } else {
	        width = height * aspectRatio;
	      }
	    } else if (isValidWidth) {
	      height = width / aspectRatio;
	    } else if (isValidHeight) {
	      width = height * aspectRatio;
	    }
	
	    return {
	      width: width,
	      height: height
	    };
	  }
	  /**
	   * Get the new sizes of a rectangle after rotated.
	   * @param {Object} data - The original sizes.
	   * @returns {Object} The result sizes.
	   */
	
	  function getRotatedSizes(_ref5) {
	    var width = _ref5.width,
	        height = _ref5.height,
	        degree = _ref5.degree;
	    degree = Math.abs(degree) % 180;
	
	    if (degree === 90) {
	      return {
	        width: height,
	        height: width
	      };
	    }
	
	    var arc = degree % 90 * Math.PI / 180;
	    var sinArc = Math.sin(arc);
	    var cosArc = Math.cos(arc);
	    var newWidth = width * cosArc + height * sinArc;
	    var newHeight = width * sinArc + height * cosArc;
	    return degree > 90 ? {
	      width: newHeight,
	      height: newWidth
	    } : {
	      width: newWidth,
	      height: newHeight
	    };
	  }
	  /**
	   * Get a canvas which drew the given image.
	   * @param {HTMLImageElement} image - The image for drawing.
	   * @param {Object} imageData - The image data.
	   * @param {Object} canvasData - The canvas data.
	   * @param {Object} options - The options.
	   * @returns {HTMLCanvasElement} The result canvas.
	   */
	
	  function getSourceCanvas(image, _ref6, _ref7, _ref8) {
	    var imageAspectRatio = _ref6.aspectRatio,
	        imageNaturalWidth = _ref6.naturalWidth,
	        imageNaturalHeight = _ref6.naturalHeight,
	        _ref6$rotate = _ref6.rotate,
	        rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
	        _ref6$scaleX = _ref6.scaleX,
	        scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
	        _ref6$scaleY = _ref6.scaleY,
	        scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
	    var aspectRatio = _ref7.aspectRatio,
	        naturalWidth = _ref7.naturalWidth,
	        naturalHeight = _ref7.naturalHeight;
	    var _ref8$fillColor = _ref8.fillColor,
	        fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor,
	        _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
	        imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
	        _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
	        imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ,
	        _ref8$maxWidth = _ref8.maxWidth,
	        maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
	        _ref8$maxHeight = _ref8.maxHeight,
	        maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
	        _ref8$minWidth = _ref8.minWidth,
	        minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
	        _ref8$minHeight = _ref8.minHeight,
	        minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
	    var canvas = document.createElement('canvas');
	    var context = canvas.getContext('2d');
	    var maxSizes = getAdjustedSizes({
	      aspectRatio: aspectRatio,
	      width: maxWidth,
	      height: maxHeight
	    });
	    var minSizes = getAdjustedSizes({
	      aspectRatio: aspectRatio,
	      width: minWidth,
	      height: minHeight
	    }, 'cover');
	    var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
	    var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight)); // Note: should always use image's natural sizes for drawing as
	    // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90
	
	    var destMaxSizes = getAdjustedSizes({
	      aspectRatio: imageAspectRatio,
	      width: maxWidth,
	      height: maxHeight
	    });
	    var destMinSizes = getAdjustedSizes({
	      aspectRatio: imageAspectRatio,
	      width: minWidth,
	      height: minHeight
	    }, 'cover');
	    var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
	    var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
	    var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
	    canvas.width = normalizeDecimalNumber(width);
	    canvas.height = normalizeDecimalNumber(height);
	    context.fillStyle = fillColor;
	    context.fillRect(0, 0, width, height);
	    context.save();
	    context.translate(width / 2, height / 2);
	    context.rotate(rotate * Math.PI / 180);
	    context.scale(scaleX, scaleY);
	    context.imageSmoothingEnabled = imageSmoothingEnabled;
	    context.imageSmoothingQuality = imageSmoothingQuality;
	    context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function (param) {
	      return Math.floor(normalizeDecimalNumber(param));
	    }))));
	    context.restore();
	    return canvas;
	  }
	  var fromCharCode = String.fromCharCode;
	  /**
	   * Get string from char code in data view.
	   * @param {DataView} dataView - The data view for read.
	   * @param {number} start - The start index.
	   * @param {number} length - The read length.
	   * @returns {string} The read result.
	   */
	
	  function getStringFromCharCode(dataView, start, length) {
	    var str = '';
	    length += start;
	
	    for (var i = start; i < length; i += 1) {
	      str += fromCharCode(dataView.getUint8(i));
	    }
	
	    return str;
	  }
	  var REGEXP_DATA_URL_HEAD = /^data:.*,/;
	  /**
	   * Transform Data URL to array buffer.
	   * @param {string} dataURL - The Data URL to transform.
	   * @returns {ArrayBuffer} The result array buffer.
	   */
	
	  function dataURLToArrayBuffer(dataURL) {
	    var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
	    var binary = atob(base64);
	    var arrayBuffer = new ArrayBuffer(binary.length);
	    var uint8 = new Uint8Array(arrayBuffer);
	    forEach(uint8, function (value, i) {
	      uint8[i] = binary.charCodeAt(i);
	    });
	    return arrayBuffer;
	  }
	  /**
	   * Transform array buffer to Data URL.
	   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
	   * @param {string} mimeType - The mime type of the Data URL.
	   * @returns {string} The result Data URL.
	   */
	
	  function arrayBufferToDataURL(arrayBuffer, mimeType) {
	    var chunks = []; // Chunk Typed Array for better performance (#435)
	
	    var chunkSize = 8192;
	    var uint8 = new Uint8Array(arrayBuffer);
	
	    while (uint8.length > 0) {
	      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
	      // eslint-disable-next-line prefer-spread
	      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
	      uint8 = uint8.subarray(chunkSize);
	    }
	
	    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
	  }
	  /**
	   * Get orientation value from given array buffer.
	   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
	   * @returns {number} The read orientation value.
	   */
	
	  function resetAndGetOrientation(arrayBuffer) {
	    var dataView = new DataView(arrayBuffer);
	    var orientation; // Ignores range error when the image does not have correct Exif information
	
	    try {
	      var littleEndian;
	      var app1Start;
	      var ifdStart; // Only handle JPEG image (start by 0xFFD8)
	
	      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
	        var length = dataView.byteLength;
	        var offset = 2;
	
	        while (offset + 1 < length) {
	          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
	            app1Start = offset;
	            break;
	          }
	
	          offset += 1;
	        }
	      }
	
	      if (app1Start) {
	        var exifIDCode = app1Start + 4;
	        var tiffOffset = app1Start + 10;
	
	        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
	          var endianness = dataView.getUint16(tiffOffset);
	          littleEndian = endianness === 0x4949;
	
	          if (littleEndian || endianness === 0x4D4D
	          /* bigEndian */
	          ) {
	              if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
	                var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
	
	                if (firstIFDOffset >= 0x00000008) {
	                  ifdStart = tiffOffset + firstIFDOffset;
	                }
	              }
	            }
	        }
	      }
	
	      if (ifdStart) {
	        var _length = dataView.getUint16(ifdStart, littleEndian);
	
	        var _offset;
	
	        var i;
	
	        for (i = 0; i < _length; i += 1) {
	          _offset = ifdStart + i * 12 + 2;
	
	          if (dataView.getUint16(_offset, littleEndian) === 0x0112
	          /* Orientation */
	          ) {
	              // 8 is the offset of the current tag's value
	              _offset += 8; // Get the original orientation value
	
	              orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value
	
	              dataView.setUint16(_offset, 1, littleEndian);
	              break;
	            }
	        }
	      }
	    } catch (error) {
	      orientation = 1;
	    }
	
	    return orientation;
	  }
	  /**
	   * Parse Exif Orientation value.
	   * @param {number} orientation - The orientation to parse.
	   * @returns {Object} The parsed result.
	   */
	
	  function parseOrientation(orientation) {
	    var rotate = 0;
	    var scaleX = 1;
	    var scaleY = 1;
	
	    switch (orientation) {
	      // Flip horizontal
	      case 2:
	        scaleX = -1;
	        break;
	      // Rotate left 180°
	
	      case 3:
	        rotate = -180;
	        break;
	      // Flip vertical
	
	      case 4:
	        scaleY = -1;
	        break;
	      // Flip vertical and rotate right 90°
	
	      case 5:
	        rotate = 90;
	        scaleY = -1;
	        break;
	      // Rotate right 90°
	
	      case 6:
	        rotate = 90;
	        break;
	      // Flip horizontal and rotate right 90°
	
	      case 7:
	        rotate = 90;
	        scaleX = -1;
	        break;
	      // Rotate left 90°
	
	      case 8:
	        rotate = -90;
	        break;
	    }
	
	    return {
	      rotate: rotate,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	
	  var render = {
	    render: function render() {
	      this.initContainer();
	      this.initCanvas();
	      this.initCropBox();
	      this.renderCanvas();
	
	      if (this.cropped) {
	        this.renderCropBox();
	      }
	    },
	    initContainer: function initContainer() {
	      var element = this.element,
	          options = this.options,
	          container = this.container,
	          cropper = this.cropper;
	      var minWidth = Number(options.minContainerWidth);
	      var minHeight = Number(options.minContainerHeight);
	      addClass(cropper, CLASS_HIDDEN);
	      removeClass(element, CLASS_HIDDEN);
	      var containerData = {
	        width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
	        height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
	      };
	      this.containerData = containerData;
	      setStyle(cropper, {
	        width: containerData.width,
	        height: containerData.height
	      });
	      addClass(element, CLASS_HIDDEN);
	      removeClass(cropper, CLASS_HIDDEN);
	    },
	    // Canvas (image wrapper)
	    initCanvas: function initCanvas() {
	      var containerData = this.containerData,
	          imageData = this.imageData;
	      var viewMode = this.options.viewMode;
	      var rotated = Math.abs(imageData.rotate) % 180 === 90;
	      var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
	      var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
	      var aspectRatio = naturalWidth / naturalHeight;
	      var canvasWidth = containerData.width;
	      var canvasHeight = containerData.height;
	
	      if (containerData.height * aspectRatio > containerData.width) {
	        if (viewMode === 3) {
	          canvasWidth = containerData.height * aspectRatio;
	        } else {
	          canvasHeight = containerData.width / aspectRatio;
	        }
	      } else if (viewMode === 3) {
	        canvasHeight = containerData.width / aspectRatio;
	      } else {
	        canvasWidth = containerData.height * aspectRatio;
	      }
	
	      var canvasData = {
	        aspectRatio: aspectRatio,
	        naturalWidth: naturalWidth,
	        naturalHeight: naturalHeight,
	        width: canvasWidth,
	        height: canvasHeight
	      };
	      this.canvasData = canvasData;
	      this.limited = viewMode === 1 || viewMode === 2;
	      this.limitCanvas(true, true);
	      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
	      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
	      canvasData.left = (containerData.width - canvasData.width) / 2;
	      canvasData.top = (containerData.height - canvasData.height) / 2;
	      canvasData.oldLeft = canvasData.left;
	      canvasData.oldTop = canvasData.top;
	      this.initialCanvasData = assign({}, canvasData);
	    },
	    limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
	      var options = this.options,
	          containerData = this.containerData,
	          canvasData = this.canvasData,
	          cropBoxData = this.cropBoxData;
	      var viewMode = options.viewMode;
	      var aspectRatio = canvasData.aspectRatio;
	      var cropped = this.cropped && cropBoxData;
	
	      if (sizeLimited) {
	        var minCanvasWidth = Number(options.minCanvasWidth) || 0;
	        var minCanvasHeight = Number(options.minCanvasHeight) || 0;
	
	        if (viewMode > 1) {
	          minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
	          minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
	
	          if (viewMode === 3) {
	            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
	              minCanvasWidth = minCanvasHeight * aspectRatio;
	            } else {
	              minCanvasHeight = minCanvasWidth / aspectRatio;
	            }
	          }
	        } else if (viewMode > 0) {
	          if (minCanvasWidth) {
	            minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
	          } else if (minCanvasHeight) {
	            minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
	          } else if (cropped) {
	            minCanvasWidth = cropBoxData.width;
	            minCanvasHeight = cropBoxData.height;
	
	            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
	              minCanvasWidth = minCanvasHeight * aspectRatio;
	            } else {
	              minCanvasHeight = minCanvasWidth / aspectRatio;
	            }
	          }
	        }
	
	        var _getAdjustedSizes = getAdjustedSizes({
	          aspectRatio: aspectRatio,
	          width: minCanvasWidth,
	          height: minCanvasHeight
	        });
	
	        minCanvasWidth = _getAdjustedSizes.width;
	        minCanvasHeight = _getAdjustedSizes.height;
	        canvasData.minWidth = minCanvasWidth;
	        canvasData.minHeight = minCanvasHeight;
	        canvasData.maxWidth = Infinity;
	        canvasData.maxHeight = Infinity;
	      }
	
	      if (positionLimited) {
	        if (viewMode > (cropped ? 0 : 1)) {
	          var newCanvasLeft = containerData.width - canvasData.width;
	          var newCanvasTop = containerData.height - canvasData.height;
	          canvasData.minLeft = Math.min(0, newCanvasLeft);
	          canvasData.minTop = Math.min(0, newCanvasTop);
	          canvasData.maxLeft = Math.max(0, newCanvasLeft);
	          canvasData.maxTop = Math.max(0, newCanvasTop);
	
	          if (cropped && this.limited) {
	            canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
	            canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
	            canvasData.maxLeft = cropBoxData.left;
	            canvasData.maxTop = cropBoxData.top;
	
	            if (viewMode === 2) {
	              if (canvasData.width >= containerData.width) {
	                canvasData.minLeft = Math.min(0, newCanvasLeft);
	                canvasData.maxLeft = Math.max(0, newCanvasLeft);
	              }
	
	              if (canvasData.height >= containerData.height) {
	                canvasData.minTop = Math.min(0, newCanvasTop);
	                canvasData.maxTop = Math.max(0, newCanvasTop);
	              }
	            }
	          }
	        } else {
	          canvasData.minLeft = -canvasData.width;
	          canvasData.minTop = -canvasData.height;
	          canvasData.maxLeft = containerData.width;
	          canvasData.maxTop = containerData.height;
	        }
	      }
	    },
	    renderCanvas: function renderCanvas(changed, transformed) {
	      var canvasData = this.canvasData,
	          imageData = this.imageData;
	
	      if (transformed) {
	        var _getRotatedSizes = getRotatedSizes({
	          width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
	          height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
	          degree: imageData.rotate || 0
	        }),
	            naturalWidth = _getRotatedSizes.width,
	            naturalHeight = _getRotatedSizes.height;
	
	        var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
	        var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
	        canvasData.left -= (width - canvasData.width) / 2;
	        canvasData.top -= (height - canvasData.height) / 2;
	        canvasData.width = width;
	        canvasData.height = height;
	        canvasData.aspectRatio = naturalWidth / naturalHeight;
	        canvasData.naturalWidth = naturalWidth;
	        canvasData.naturalHeight = naturalHeight;
	        this.limitCanvas(true, false);
	      }
	
	      if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
	        canvasData.left = canvasData.oldLeft;
	      }
	
	      if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
	        canvasData.top = canvasData.oldTop;
	      }
	
	      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
	      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
	      this.limitCanvas(false, true);
	      canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
	      canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
	      canvasData.oldLeft = canvasData.left;
	      canvasData.oldTop = canvasData.top;
	      setStyle(this.canvas, assign({
	        width: canvasData.width,
	        height: canvasData.height
	      }, getTransforms({
	        translateX: canvasData.left,
	        translateY: canvasData.top
	      })));
	      this.renderImage(changed);
	
	      if (this.cropped && this.limited) {
	        this.limitCropBox(true, true);
	      }
	    },
	    renderImage: function renderImage(changed) {
	      var canvasData = this.canvasData,
	          imageData = this.imageData;
	      var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
	      var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
	      assign(imageData, {
	        width: width,
	        height: height,
	        left: (canvasData.width - width) / 2,
	        top: (canvasData.height - height) / 2
	      });
	      setStyle(this.image, assign({
	        width: imageData.width,
	        height: imageData.height
	      }, getTransforms(assign({
	        translateX: imageData.left,
	        translateY: imageData.top
	      }, imageData))));
	
	      if (changed) {
	        this.output();
	      }
	    },
	    initCropBox: function initCropBox() {
	      var options = this.options,
	          canvasData = this.canvasData;
	      var aspectRatio = options.aspectRatio || options.initialAspectRatio;
	      var autoCropArea = Number(options.autoCropArea) || 0.8;
	      var cropBoxData = {
	        width: canvasData.width,
	        height: canvasData.height
	      };
	
	      if (aspectRatio) {
	        if (canvasData.height * aspectRatio > canvasData.width) {
	          cropBoxData.height = cropBoxData.width / aspectRatio;
	        } else {
	          cropBoxData.width = cropBoxData.height * aspectRatio;
	        }
	      }
	
	      this.cropBoxData = cropBoxData;
	      this.limitCropBox(true, true); // Initialize auto crop area
	
	      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
	      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight); // The width/height of auto crop area must large than "minWidth/Height"
	
	      cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
	      cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
	      cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
	      cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
	      cropBoxData.oldLeft = cropBoxData.left;
	      cropBoxData.oldTop = cropBoxData.top;
	      this.initialCropBoxData = assign({}, cropBoxData);
	    },
	    limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
	      var options = this.options,
	          containerData = this.containerData,
	          canvasData = this.canvasData,
	          cropBoxData = this.cropBoxData,
	          limited = this.limited;
	      var aspectRatio = options.aspectRatio;
	
	      if (sizeLimited) {
	        var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
	        var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
	        var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
	        var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height; // The min/maxCropBoxWidth/Height must be less than container's width/height
	
	        minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
	        minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
	
	        if (aspectRatio) {
	          if (minCropBoxWidth && minCropBoxHeight) {
	            if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
	              minCropBoxHeight = minCropBoxWidth / aspectRatio;
	            } else {
	              minCropBoxWidth = minCropBoxHeight * aspectRatio;
	            }
	          } else if (minCropBoxWidth) {
	            minCropBoxHeight = minCropBoxWidth / aspectRatio;
	          } else if (minCropBoxHeight) {
	            minCropBoxWidth = minCropBoxHeight * aspectRatio;
	          }
	
	          if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
	            maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
	          } else {
	            maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
	          }
	        } // The minWidth/Height must be less than maxWidth/Height
	
	
	        cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
	        cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
	        cropBoxData.maxWidth = maxCropBoxWidth;
	        cropBoxData.maxHeight = maxCropBoxHeight;
	      }
	
	      if (positionLimited) {
	        if (limited) {
	          cropBoxData.minLeft = Math.max(0, canvasData.left);
	          cropBoxData.minTop = Math.max(0, canvasData.top);
	          cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
	          cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
	        } else {
	          cropBoxData.minLeft = 0;
	          cropBoxData.minTop = 0;
	          cropBoxData.maxLeft = containerData.width - cropBoxData.width;
	          cropBoxData.maxTop = containerData.height - cropBoxData.height;
	        }
	      }
	    },
	    renderCropBox: function renderCropBox() {
	      var options = this.options,
	          containerData = this.containerData,
	          cropBoxData = this.cropBoxData;
	
	      if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
	        cropBoxData.left = cropBoxData.oldLeft;
	      }
	
	      if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
	        cropBoxData.top = cropBoxData.oldTop;
	      }
	
	      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
	      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
	      this.limitCropBox(false, true);
	      cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
	      cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
	      cropBoxData.oldLeft = cropBoxData.left;
	      cropBoxData.oldTop = cropBoxData.top;
	
	      if (options.movable && options.cropBoxMovable) {
	        // Turn to move the canvas when the crop box is equal to the container
	        setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
	      }
	
	      setStyle(this.cropBox, assign({
	        width: cropBoxData.width,
	        height: cropBoxData.height
	      }, getTransforms({
	        translateX: cropBoxData.left,
	        translateY: cropBoxData.top
	      })));
	
	      if (this.cropped && this.limited) {
	        this.limitCanvas(true, true);
	      }
	
	      if (!this.disabled) {
	        this.output();
	      }
	    },
	    output: function output() {
	      this.preview();
	      dispatchEvent(this.element, EVENT_CROP, this.getData());
	    }
	  };
	
	  var preview = {
	    initPreview: function initPreview() {
	      var element = this.element,
	          crossOrigin = this.crossOrigin;
	      var preview = this.options.preview;
	      var url = crossOrigin ? this.crossOriginUrl : this.url;
	      var alt = element.alt || 'The image to preview';
	      var image = document.createElement('img');
	
	      if (crossOrigin) {
	        image.crossOrigin = crossOrigin;
	      }
	
	      image.src = url;
	      image.alt = alt;
	      this.viewBox.appendChild(image);
	      this.viewBoxImage = image;
	
	      if (!preview) {
	        return;
	      }
	
	      var previews = preview;
	
	      if (typeof preview === 'string') {
	        previews = element.ownerDocument.querySelectorAll(preview);
	      } else if (preview.querySelector) {
	        previews = [preview];
	      }
	
	      this.previews = previews;
	      forEach(previews, function (el) {
	        var img = document.createElement('img'); // Save the original size for recover
	
	        setData(el, DATA_PREVIEW, {
	          width: el.offsetWidth,
	          height: el.offsetHeight,
	          html: el.innerHTML
	        });
	
	        if (crossOrigin) {
	          img.crossOrigin = crossOrigin;
	        }
	
	        img.src = url;
	        img.alt = alt;
	        /**
	         * Override img element styles
	         * Add `display:block` to avoid margin top issue
	         * Add `height:auto` to override `height` attribute on IE8
	         * (Occur only when margin-top <= -height)
	         */
	
	        img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
	        el.innerHTML = '';
	        el.appendChild(img);
	      });
	    },
	    resetPreview: function resetPreview() {
	      forEach(this.previews, function (element) {
	        var data = getData(element, DATA_PREVIEW);
	        setStyle(element, {
	          width: data.width,
	          height: data.height
	        });
	        element.innerHTML = data.html;
	        removeData(element, DATA_PREVIEW);
	      });
	    },
	    preview: function preview() {
	      var imageData = this.imageData,
	          canvasData = this.canvasData,
	          cropBoxData = this.cropBoxData;
	      var cropBoxWidth = cropBoxData.width,
	          cropBoxHeight = cropBoxData.height;
	      var width = imageData.width,
	          height = imageData.height;
	      var left = cropBoxData.left - canvasData.left - imageData.left;
	      var top = cropBoxData.top - canvasData.top - imageData.top;
	
	      if (!this.cropped || this.disabled) {
	        return;
	      }
	
	      setStyle(this.viewBoxImage, assign({
	        width: width,
	        height: height
	      }, getTransforms(assign({
	        translateX: -left,
	        translateY: -top
	      }, imageData))));
	      forEach(this.previews, function (element) {
	        var data = getData(element, DATA_PREVIEW);
	        var originalWidth = data.width;
	        var originalHeight = data.height;
	        var newWidth = originalWidth;
	        var newHeight = originalHeight;
	        var ratio = 1;
	
	        if (cropBoxWidth) {
	          ratio = originalWidth / cropBoxWidth;
	          newHeight = cropBoxHeight * ratio;
	        }
	
	        if (cropBoxHeight && newHeight > originalHeight) {
	          ratio = originalHeight / cropBoxHeight;
	          newWidth = cropBoxWidth * ratio;
	          newHeight = originalHeight;
	        }
	
	        setStyle(element, {
	          width: newWidth,
	          height: newHeight
	        });
	        setStyle(element.getElementsByTagName('img')[0], assign({
	          width: width * ratio,
	          height: height * ratio
	        }, getTransforms(assign({
	          translateX: -left * ratio,
	          translateY: -top * ratio
	        }, imageData))));
	      });
	    }
	  };
	
	  var events = {
	    bind: function bind() {
	      var element = this.element,
	          options = this.options,
	          cropper = this.cropper;
	
	      if (isFunction(options.cropstart)) {
	        addListener(element, EVENT_CROP_START, options.cropstart);
	      }
	
	      if (isFunction(options.cropmove)) {
	        addListener(element, EVENT_CROP_MOVE, options.cropmove);
	      }
	
	      if (isFunction(options.cropend)) {
	        addListener(element, EVENT_CROP_END, options.cropend);
	      }
	
	      if (isFunction(options.crop)) {
	        addListener(element, EVENT_CROP, options.crop);
	      }
	
	      if (isFunction(options.zoom)) {
	        addListener(element, EVENT_ZOOM, options.zoom);
	      }
	
	      addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));
	
	      if (options.zoomable && options.zoomOnWheel) {
	        addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
	          passive: false,
	          capture: true
	        });
	      }
	
	      if (options.toggleDragModeOnDblclick) {
	        addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
	      }
	
	      addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
	      addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));
	
	      if (options.responsive) {
	        addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
	      }
	    },
	    unbind: function unbind() {
	      var element = this.element,
	          options = this.options,
	          cropper = this.cropper;
	
	      if (isFunction(options.cropstart)) {
	        removeListener(element, EVENT_CROP_START, options.cropstart);
	      }
	
	      if (isFunction(options.cropmove)) {
	        removeListener(element, EVENT_CROP_MOVE, options.cropmove);
	      }
	
	      if (isFunction(options.cropend)) {
	        removeListener(element, EVENT_CROP_END, options.cropend);
	      }
	
	      if (isFunction(options.crop)) {
	        removeListener(element, EVENT_CROP, options.crop);
	      }
	
	      if (isFunction(options.zoom)) {
	        removeListener(element, EVENT_ZOOM, options.zoom);
	      }
	
	      removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);
	
	      if (options.zoomable && options.zoomOnWheel) {
	        removeListener(cropper, EVENT_WHEEL, this.onWheel, {
	          passive: false,
	          capture: true
	        });
	      }
	
	      if (options.toggleDragModeOnDblclick) {
	        removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
	      }
	
	      removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
	      removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
	
	      if (options.responsive) {
	        removeListener(window, EVENT_RESIZE, this.onResize);
	      }
	    }
	  };
	
	  var handlers = {
	    resize: function resize() {
	      if (this.disabled) {
	        return;
	      }
	
	      var options = this.options,
	          container = this.container,
	          containerData = this.containerData;
	      var ratio = container.offsetWidth / containerData.width; // Resize when width changed or height changed
	
	      if (ratio !== 1 || container.offsetHeight !== containerData.height) {
	        var canvasData;
	        var cropBoxData;
	
	        if (options.restore) {
	          canvasData = this.getCanvasData();
	          cropBoxData = this.getCropBoxData();
	        }
	
	        this.render();
	
	        if (options.restore) {
	          this.setCanvasData(forEach(canvasData, function (n, i) {
	            canvasData[i] = n * ratio;
	          }));
	          this.setCropBoxData(forEach(cropBoxData, function (n, i) {
	            cropBoxData[i] = n * ratio;
	          }));
	        }
	      }
	    },
	    dblclick: function dblclick() {
	      if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
	        return;
	      }
	
	      this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
	    },
	    wheel: function wheel(event) {
	      var _this = this;
	
	      var ratio = Number(this.options.wheelZoomRatio) || 0.1;
	      var delta = 1;
	
	      if (this.disabled) {
	        return;
	      }
	
	      event.preventDefault(); // Limit wheel speed to prevent zoom too fast (#21)
	
	      if (this.wheeling) {
	        return;
	      }
	
	      this.wheeling = true;
	      setTimeout(function () {
	        _this.wheeling = false;
	      }, 50);
	
	      if (event.deltaY) {
	        delta = event.deltaY > 0 ? 1 : -1;
	      } else if (event.wheelDelta) {
	        delta = -event.wheelDelta / 120;
	      } else if (event.detail) {
	        delta = event.detail > 0 ? 1 : -1;
	      }
	
	      this.zoom(-delta * ratio, event);
	    },
	    cropStart: function cropStart(event) {
	      var buttons = event.buttons,
	          button = event.button;
	
	      if (this.disabled // Handle mouse event and pointer event and ignore touch event
	      || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && ( // No primary button (Usually the left button)
	      isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 // Open context menu
	      || event.ctrlKey)) {
	        return;
	      }
	
	      var options = this.options,
	          pointers = this.pointers;
	      var action;
	
	      if (event.changedTouches) {
	        // Handle touch event
	        forEach(event.changedTouches, function (touch) {
	          pointers[touch.identifier] = getPointer(touch);
	        });
	      } else {
	        // Handle mouse event and pointer event
	        pointers[event.pointerId || 0] = getPointer(event);
	      }
	
	      if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
	        action = ACTION_ZOOM;
	      } else {
	        action = getData(event.target, DATA_ACTION);
	      }
	
	      if (!REGEXP_ACTIONS.test(action)) {
	        return;
	      }
	
	      if (dispatchEvent(this.element, EVENT_CROP_START, {
	        originalEvent: event,
	        action: action
	      }) === false) {
	        return;
	      } // This line is required for preventing page zooming in iOS browsers
	
	
	      event.preventDefault();
	      this.action = action;
	      this.cropping = false;
	
	      if (action === ACTION_CROP) {
	        this.cropping = true;
	        addClass(this.dragBox, CLASS_MODAL);
	      }
	    },
	    cropMove: function cropMove(event) {
	      var action = this.action;
	
	      if (this.disabled || !action) {
	        return;
	      }
	
	      var pointers = this.pointers;
	      event.preventDefault();
	
	      if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
	        originalEvent: event,
	        action: action
	      }) === false) {
	        return;
	      }
	
	      if (event.changedTouches) {
	        forEach(event.changedTouches, function (touch) {
	          // The first parameter should not be undefined (#432)
	          assign(pointers[touch.identifier] || {}, getPointer(touch, true));
	        });
	      } else {
	        assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
	      }
	
	      this.change(event);
	    },
	    cropEnd: function cropEnd(event) {
	      if (this.disabled) {
	        return;
	      }
	
	      var action = this.action,
	          pointers = this.pointers;
	
	      if (event.changedTouches) {
	        forEach(event.changedTouches, function (touch) {
	          delete pointers[touch.identifier];
	        });
	      } else {
	        delete pointers[event.pointerId || 0];
	      }
	
	      if (!action) {
	        return;
	      }
	
	      event.preventDefault();
	
	      if (!Object.keys(pointers).length) {
	        this.action = '';
	      }
	
	      if (this.cropping) {
	        this.cropping = false;
	        toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
	      }
	
	      dispatchEvent(this.element, EVENT_CROP_END, {
	        originalEvent: event,
	        action: action
	      });
	    }
	  };
	
	  var change = {
	    change: function change(event) {
	      var options = this.options,
	          canvasData = this.canvasData,
	          containerData = this.containerData,
	          cropBoxData = this.cropBoxData,
	          pointers = this.pointers;
	      var action = this.action;
	      var aspectRatio = options.aspectRatio;
	      var left = cropBoxData.left,
	          top = cropBoxData.top,
	          width = cropBoxData.width,
	          height = cropBoxData.height;
	      var right = left + width;
	      var bottom = top + height;
	      var minLeft = 0;
	      var minTop = 0;
	      var maxWidth = containerData.width;
	      var maxHeight = containerData.height;
	      var renderable = true;
	      var offset; // Locking aspect ratio in "free mode" by holding shift key
	
	      if (!aspectRatio && event.shiftKey) {
	        aspectRatio = width && height ? width / height : 1;
	      }
	
	      if (this.limited) {
	        minLeft = cropBoxData.minLeft;
	        minTop = cropBoxData.minTop;
	        maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
	        maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
	      }
	
	      var pointer = pointers[Object.keys(pointers)[0]];
	      var range = {
	        x: pointer.endX - pointer.startX,
	        y: pointer.endY - pointer.startY
	      };
	
	      var check = function check(side) {
	        switch (side) {
	          case ACTION_EAST:
	            if (right + range.x > maxWidth) {
	              range.x = maxWidth - right;
	            }
	
	            break;
	
	          case ACTION_WEST:
	            if (left + range.x < minLeft) {
	              range.x = minLeft - left;
	            }
	
	            break;
	
	          case ACTION_NORTH:
	            if (top + range.y < minTop) {
	              range.y = minTop - top;
	            }
	
	            break;
	
	          case ACTION_SOUTH:
	            if (bottom + range.y > maxHeight) {
	              range.y = maxHeight - bottom;
	            }
	
	            break;
	        }
	      };
	
	      switch (action) {
	        // Move crop box
	        case ACTION_ALL:
	          left += range.x;
	          top += range.y;
	          break;
	        // Resize crop box
	
	        case ACTION_EAST:
	          if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
	            renderable = false;
	            break;
	          }
	
	          check(ACTION_EAST);
	          width += range.x;
	
	          if (width < 0) {
	            action = ACTION_WEST;
	            width = -width;
	            left -= width;
	          }
	
	          if (aspectRatio) {
	            height = width / aspectRatio;
	            top += (cropBoxData.height - height) / 2;
	          }
	
	          break;
	
	        case ACTION_NORTH:
	          if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
	            renderable = false;
	            break;
	          }
	
	          check(ACTION_NORTH);
	          height -= range.y;
	          top += range.y;
	
	          if (height < 0) {
	            action = ACTION_SOUTH;
	            height = -height;
	            top -= height;
	          }
	
	          if (aspectRatio) {
	            width = height * aspectRatio;
	            left += (cropBoxData.width - width) / 2;
	          }
	
	          break;
	
	        case ACTION_WEST:
	          if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
	            renderable = false;
	            break;
	          }
	
	          check(ACTION_WEST);
	          width -= range.x;
	          left += range.x;
	
	          if (width < 0) {
	            action = ACTION_EAST;
	            width = -width;
	            left -= width;
	          }
	
	          if (aspectRatio) {
	            height = width / aspectRatio;
	            top += (cropBoxData.height - height) / 2;
	          }
	
	          break;
	
	        case ACTION_SOUTH:
	          if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
	            renderable = false;
	            break;
	          }
	
	          check(ACTION_SOUTH);
	          height += range.y;
	
	          if (height < 0) {
	            action = ACTION_NORTH;
	            height = -height;
	            top -= height;
	          }
	
	          if (aspectRatio) {
	            width = height * aspectRatio;
	            left += (cropBoxData.width - width) / 2;
	          }
	
	          break;
	
	        case ACTION_NORTH_EAST:
	          if (aspectRatio) {
	            if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
	              renderable = false;
	              break;
	            }
	
	            check(ACTION_NORTH);
	            height -= range.y;
	            top += range.y;
	            width = height * aspectRatio;
	          } else {
	            check(ACTION_NORTH);
	            check(ACTION_EAST);
	
	            if (range.x >= 0) {
	              if (right < maxWidth) {
	                width += range.x;
	              } else if (range.y <= 0 && top <= minTop) {
	                renderable = false;
	              }
	            } else {
	              width += range.x;
	            }
	
	            if (range.y <= 0) {
	              if (top > minTop) {
	                height -= range.y;
	                top += range.y;
	              }
	            } else {
	              height -= range.y;
	              top += range.y;
	            }
	          }
	
	          if (width < 0 && height < 0) {
	            action = ACTION_SOUTH_WEST;
	            height = -height;
	            width = -width;
	            top -= height;
	            left -= width;
	          } else if (width < 0) {
	            action = ACTION_NORTH_WEST;
	            width = -width;
	            left -= width;
	          } else if (height < 0) {
	            action = ACTION_SOUTH_EAST;
	            height = -height;
	            top -= height;
	          }
	
	          break;
	
	        case ACTION_NORTH_WEST:
	          if (aspectRatio) {
	            if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
	              renderable = false;
	              break;
	            }
	
	            check(ACTION_NORTH);
	            height -= range.y;
	            top += range.y;
	            width = height * aspectRatio;
	            left += cropBoxData.width - width;
	          } else {
	            check(ACTION_NORTH);
	            check(ACTION_WEST);
	
	            if (range.x <= 0) {
	              if (left > minLeft) {
	                width -= range.x;
	                left += range.x;
	              } else if (range.y <= 0 && top <= minTop) {
	                renderable = false;
	              }
	            } else {
	              width -= range.x;
	              left += range.x;
	            }
	
	            if (range.y <= 0) {
	              if (top > minTop) {
	                height -= range.y;
	                top += range.y;
	              }
	            } else {
	              height -= range.y;
	              top += range.y;
	            }
	          }
	
	          if (width < 0 && height < 0) {
	            action = ACTION_SOUTH_EAST;
	            height = -height;
	            width = -width;
	            top -= height;
	            left -= width;
	          } else if (width < 0) {
	            action = ACTION_NORTH_EAST;
	            width = -width;
	            left -= width;
	          } else if (height < 0) {
	            action = ACTION_SOUTH_WEST;
	            height = -height;
	            top -= height;
	          }
	
	          break;
	
	        case ACTION_SOUTH_WEST:
	          if (aspectRatio) {
	            if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
	              renderable = false;
	              break;
	            }
	
	            check(ACTION_WEST);
	            width -= range.x;
	            left += range.x;
	            height = width / aspectRatio;
	          } else {
	            check(ACTION_SOUTH);
	            check(ACTION_WEST);
	
	            if (range.x <= 0) {
	              if (left > minLeft) {
	                width -= range.x;
	                left += range.x;
	              } else if (range.y >= 0 && bottom >= maxHeight) {
	                renderable = false;
	              }
	            } else {
	              width -= range.x;
	              left += range.x;
	            }
	
	            if (range.y >= 0) {
	              if (bottom < maxHeight) {
	                height += range.y;
	              }
	            } else {
	              height += range.y;
	            }
	          }
	
	          if (width < 0 && height < 0) {
	            action = ACTION_NORTH_EAST;
	            height = -height;
	            width = -width;
	            top -= height;
	            left -= width;
	          } else if (width < 0) {
	            action = ACTION_SOUTH_EAST;
	            width = -width;
	            left -= width;
	          } else if (height < 0) {
	            action = ACTION_NORTH_WEST;
	            height = -height;
	            top -= height;
	          }
	
	          break;
	
	        case ACTION_SOUTH_EAST:
	          if (aspectRatio) {
	            if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
	              renderable = false;
	              break;
	            }
	
	            check(ACTION_EAST);
	            width += range.x;
	            height = width / aspectRatio;
	          } else {
	            check(ACTION_SOUTH);
	            check(ACTION_EAST);
	
	            if (range.x >= 0) {
	              if (right < maxWidth) {
	                width += range.x;
	              } else if (range.y >= 0 && bottom >= maxHeight) {
	                renderable = false;
	              }
	            } else {
	              width += range.x;
	            }
	
	            if (range.y >= 0) {
	              if (bottom < maxHeight) {
	                height += range.y;
	              }
	            } else {
	              height += range.y;
	            }
	          }
	
	          if (width < 0 && height < 0) {
	            action = ACTION_NORTH_WEST;
	            height = -height;
	            width = -width;
	            top -= height;
	            left -= width;
	          } else if (width < 0) {
	            action = ACTION_SOUTH_WEST;
	            width = -width;
	            left -= width;
	          } else if (height < 0) {
	            action = ACTION_NORTH_EAST;
	            height = -height;
	            top -= height;
	          }
	
	          break;
	        // Move canvas
	
	        case ACTION_MOVE:
	          this.move(range.x, range.y);
	          renderable = false;
	          break;
	        // Zoom canvas
	
	        case ACTION_ZOOM:
	          this.zoom(getMaxZoomRatio(pointers), event);
	          renderable = false;
	          break;
	        // Create crop box
	
	        case ACTION_CROP:
	          if (!range.x || !range.y) {
	            renderable = false;
	            break;
	          }
	
	          offset = getOffset(this.cropper);
	          left = pointer.startX - offset.left;
	          top = pointer.startY - offset.top;
	          width = cropBoxData.minWidth;
	          height = cropBoxData.minHeight;
	
	          if (range.x > 0) {
	            action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
	          } else if (range.x < 0) {
	            left -= width;
	            action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
	          }
	
	          if (range.y < 0) {
	            top -= height;
	          } // Show the crop box if is hidden
	
	
	          if (!this.cropped) {
	            removeClass(this.cropBox, CLASS_HIDDEN);
	            this.cropped = true;
	
	            if (this.limited) {
	              this.limitCropBox(true, true);
	            }
	          }
	
	          break;
	      }
	
	      if (renderable) {
	        cropBoxData.width = width;
	        cropBoxData.height = height;
	        cropBoxData.left = left;
	        cropBoxData.top = top;
	        this.action = action;
	        this.renderCropBox();
	      } // Override
	
	
	      forEach(pointers, function (p) {
	        p.startX = p.endX;
	        p.startY = p.endY;
	      });
	    }
	  };
	
	  var methods = {
	    // Show the crop box manually
	    crop: function crop() {
	      if (this.ready && !this.cropped && !this.disabled) {
	        this.cropped = true;
	        this.limitCropBox(true, true);
	
	        if (this.options.modal) {
	          addClass(this.dragBox, CLASS_MODAL);
	        }
	
	        removeClass(this.cropBox, CLASS_HIDDEN);
	        this.setCropBoxData(this.initialCropBoxData);
	      }
	
	      return this;
	    },
	    // Reset the image and crop box to their initial states
	    reset: function reset() {
	      if (this.ready && !this.disabled) {
	        this.imageData = assign({}, this.initialImageData);
	        this.canvasData = assign({}, this.initialCanvasData);
	        this.cropBoxData = assign({}, this.initialCropBoxData);
	        this.renderCanvas();
	
	        if (this.cropped) {
	          this.renderCropBox();
	        }
	      }
	
	      return this;
	    },
	    // Clear the crop box
	    clear: function clear() {
	      if (this.cropped && !this.disabled) {
	        assign(this.cropBoxData, {
	          left: 0,
	          top: 0,
	          width: 0,
	          height: 0
	        });
	        this.cropped = false;
	        this.renderCropBox();
	        this.limitCanvas(true, true); // Render canvas after crop box rendered
	
	        this.renderCanvas();
	        removeClass(this.dragBox, CLASS_MODAL);
	        addClass(this.cropBox, CLASS_HIDDEN);
	      }
	
	      return this;
	    },
	
	    /**
	     * Replace the image's src and rebuild the cropper
	     * @param {string} url - The new URL.
	     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
	     * @returns {Cropper} this
	     */
	    replace: function replace(url) {
	      var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!this.disabled && url) {
	        if (this.isImg) {
	          this.element.src = url;
	        }
	
	        if (hasSameSize) {
	          this.url = url;
	          this.image.src = url;
	
	          if (this.ready) {
	            this.viewBoxImage.src = url;
	            forEach(this.previews, function (element) {
	              element.getElementsByTagName('img')[0].src = url;
	            });
	          }
	        } else {
	          if (this.isImg) {
	            this.replaced = true;
	          }
	
	          this.options.data = null;
	          this.uncreate();
	          this.load(url);
	        }
	      }
	
	      return this;
	    },
	    // Enable (unfreeze) the cropper
	    enable: function enable() {
	      if (this.ready && this.disabled) {
	        this.disabled = false;
	        removeClass(this.cropper, CLASS_DISABLED);
	      }
	
	      return this;
	    },
	    // Disable (freeze) the cropper
	    disable: function disable() {
	      if (this.ready && !this.disabled) {
	        this.disabled = true;
	        addClass(this.cropper, CLASS_DISABLED);
	      }
	
	      return this;
	    },
	
	    /**
	     * Destroy the cropper and remove the instance from the image
	     * @returns {Cropper} this
	     */
	    destroy: function destroy() {
	      var element = this.element;
	
	      if (!element[NAMESPACE]) {
	        return this;
	      }
	
	      element[NAMESPACE] = undefined;
	
	      if (this.isImg && this.replaced) {
	        element.src = this.originalUrl;
	      }
	
	      this.uncreate();
	      return this;
	    },
	
	    /**
	     * Move the canvas with relative offsets
	     * @param {number} offsetX - The relative offset distance on the x-axis.
	     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
	     * @returns {Cropper} this
	     */
	    move: function move(offsetX) {
	      var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
	      var _this$canvasData = this.canvasData,
	          left = _this$canvasData.left,
	          top = _this$canvasData.top;
	      return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
	    },
	
	    /**
	     * Move the canvas to an absolute point
	     * @param {number} x - The x-axis coordinate.
	     * @param {number} [y=x] - The y-axis coordinate.
	     * @returns {Cropper} this
	     */
	    moveTo: function moveTo(x) {
	      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
	      var canvasData = this.canvasData;
	      var changed = false;
	      x = Number(x);
	      y = Number(y);
	
	      if (this.ready && !this.disabled && this.options.movable) {
	        if (isNumber(x)) {
	          canvasData.left = x;
	          changed = true;
	        }
	
	        if (isNumber(y)) {
	          canvasData.top = y;
	          changed = true;
	        }
	
	        if (changed) {
	          this.renderCanvas(true);
	        }
	      }
	
	      return this;
	    },
	
	    /**
	     * Zoom the canvas with a relative ratio
	     * @param {number} ratio - The target ratio.
	     * @param {Event} _originalEvent - The original event if any.
	     * @returns {Cropper} this
	     */
	    zoom: function zoom(ratio, _originalEvent) {
	      var canvasData = this.canvasData;
	      ratio = Number(ratio);
	
	      if (ratio < 0) {
	        ratio = 1 / (1 - ratio);
	      } else {
	        ratio = 1 + ratio;
	      }
	
	      return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
	    },
	
	    /**
	     * Zoom the canvas to an absolute ratio
	     * @param {number} ratio - The target ratio.
	     * @param {Object} pivot - The zoom pivot point coordinate.
	     * @param {Event} _originalEvent - The original event if any.
	     * @returns {Cropper} this
	     */
	    zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
	      var options = this.options,
	          canvasData = this.canvasData;
	      var width = canvasData.width,
	          height = canvasData.height,
	          naturalWidth = canvasData.naturalWidth,
	          naturalHeight = canvasData.naturalHeight;
	      ratio = Number(ratio);
	
	      if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
	        var newWidth = naturalWidth * ratio;
	        var newHeight = naturalHeight * ratio;
	
	        if (dispatchEvent(this.element, EVENT_ZOOM, {
	          ratio: ratio,
	          oldRatio: width / naturalWidth,
	          originalEvent: _originalEvent
	        }) === false) {
	          return this;
	        }
	
	        if (_originalEvent) {
	          var pointers = this.pointers;
	          var offset = getOffset(this.cropper);
	          var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
	            pageX: _originalEvent.pageX,
	            pageY: _originalEvent.pageY
	          }; // Zoom from the triggering point of the event
	
	          canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
	          canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
	        } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
	          canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
	          canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
	        } else {
	          // Zoom from the center of the canvas
	          canvasData.left -= (newWidth - width) / 2;
	          canvasData.top -= (newHeight - height) / 2;
	        }
	
	        canvasData.width = newWidth;
	        canvasData.height = newHeight;
	        this.renderCanvas(true);
	      }
	
	      return this;
	    },
	
	    /**
	     * Rotate the canvas with a relative degree
	     * @param {number} degree - The rotate degree.
	     * @returns {Cropper} this
	     */
	    rotate: function rotate(degree) {
	      return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
	    },
	
	    /**
	     * Rotate the canvas to an absolute degree
	     * @param {number} degree - The rotate degree.
	     * @returns {Cropper} this
	     */
	    rotateTo: function rotateTo(degree) {
	      degree = Number(degree);
	
	      if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
	        this.imageData.rotate = degree % 360;
	        this.renderCanvas(true, true);
	      }
	
	      return this;
	    },
	
	    /**
	     * Scale the image on the x-axis.
	     * @param {number} scaleX - The scale ratio on the x-axis.
	     * @returns {Cropper} this
	     */
	    scaleX: function scaleX(_scaleX) {
	      var scaleY = this.imageData.scaleY;
	      return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
	    },
	
	    /**
	     * Scale the image on the y-axis.
	     * @param {number} scaleY - The scale ratio on the y-axis.
	     * @returns {Cropper} this
	     */
	    scaleY: function scaleY(_scaleY) {
	      var scaleX = this.imageData.scaleX;
	      return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
	    },
	
	    /**
	     * Scale the image
	     * @param {number} scaleX - The scale ratio on the x-axis.
	     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
	     * @returns {Cropper} this
	     */
	    scale: function scale(scaleX) {
	      var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
	      var imageData = this.imageData;
	      var transformed = false;
	      scaleX = Number(scaleX);
	      scaleY = Number(scaleY);
	
	      if (this.ready && !this.disabled && this.options.scalable) {
	        if (isNumber(scaleX)) {
	          imageData.scaleX = scaleX;
	          transformed = true;
	        }
	
	        if (isNumber(scaleY)) {
	          imageData.scaleY = scaleY;
	          transformed = true;
	        }
	
	        if (transformed) {
	          this.renderCanvas(true, true);
	        }
	      }
	
	      return this;
	    },
	
	    /**
	     * Get the cropped area position and size data (base on the original image)
	     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
	     * @returns {Object} The result cropped data.
	     */
	    getData: function getData() {
	      var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var options = this.options,
	          imageData = this.imageData,
	          canvasData = this.canvasData,
	          cropBoxData = this.cropBoxData;
	      var data;
	
	      if (this.ready && this.cropped) {
	        data = {
	          x: cropBoxData.left - canvasData.left,
	          y: cropBoxData.top - canvasData.top,
	          width: cropBoxData.width,
	          height: cropBoxData.height
	        };
	        var ratio = imageData.width / imageData.naturalWidth;
	        forEach(data, function (n, i) {
	          data[i] = n / ratio;
	        });
	
	        if (rounded) {
	          // In case rounding off leads to extra 1px in right or bottom border
	          // we should round the top-left corner and the dimension (#343).
	          var bottom = Math.round(data.y + data.height);
	          var right = Math.round(data.x + data.width);
	          data.x = Math.round(data.x);
	          data.y = Math.round(data.y);
	          data.width = right - data.x;
	          data.height = bottom - data.y;
	        }
	      } else {
	        data = {
	          x: 0,
	          y: 0,
	          width: 0,
	          height: 0
	        };
	      }
	
	      if (options.rotatable) {
	        data.rotate = imageData.rotate || 0;
	      }
	
	      if (options.scalable) {
	        data.scaleX = imageData.scaleX || 1;
	        data.scaleY = imageData.scaleY || 1;
	      }
	
	      return data;
	    },
	
	    /**
	     * Set the cropped area position and size with new data
	     * @param {Object} data - The new data.
	     * @returns {Cropper} this
	     */
	    setData: function setData(data) {
	      var options = this.options,
	          imageData = this.imageData,
	          canvasData = this.canvasData;
	      var cropBoxData = {};
	
	      if (this.ready && !this.disabled && isPlainObject(data)) {
	        var transformed = false;
	
	        if (options.rotatable) {
	          if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
	            imageData.rotate = data.rotate;
	            transformed = true;
	          }
	        }
	
	        if (options.scalable) {
	          if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
	            imageData.scaleX = data.scaleX;
	            transformed = true;
	          }
	
	          if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
	            imageData.scaleY = data.scaleY;
	            transformed = true;
	          }
	        }
	
	        if (transformed) {
	          this.renderCanvas(true, true);
	        }
	
	        var ratio = imageData.width / imageData.naturalWidth;
	
	        if (isNumber(data.x)) {
	          cropBoxData.left = data.x * ratio + canvasData.left;
	        }
	
	        if (isNumber(data.y)) {
	          cropBoxData.top = data.y * ratio + canvasData.top;
	        }
	
	        if (isNumber(data.width)) {
	          cropBoxData.width = data.width * ratio;
	        }
	
	        if (isNumber(data.height)) {
	          cropBoxData.height = data.height * ratio;
	        }
	
	        this.setCropBoxData(cropBoxData);
	      }
	
	      return this;
	    },
	
	    /**
	     * Get the container size data.
	     * @returns {Object} The result container data.
	     */
	    getContainerData: function getContainerData() {
	      return this.ready ? assign({}, this.containerData) : {};
	    },
	
	    /**
	     * Get the image position and size data.
	     * @returns {Object} The result image data.
	     */
	    getImageData: function getImageData() {
	      return this.sized ? assign({}, this.imageData) : {};
	    },
	
	    /**
	     * Get the canvas position and size data.
	     * @returns {Object} The result canvas data.
	     */
	    getCanvasData: function getCanvasData() {
	      var canvasData = this.canvasData;
	      var data = {};
	
	      if (this.ready) {
	        forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
	          data[n] = canvasData[n];
	        });
	      }
	
	      return data;
	    },
	
	    /**
	     * Set the canvas position and size with new data.
	     * @param {Object} data - The new canvas data.
	     * @returns {Cropper} this
	     */
	    setCanvasData: function setCanvasData(data) {
	      var canvasData = this.canvasData;
	      var aspectRatio = canvasData.aspectRatio;
	
	      if (this.ready && !this.disabled && isPlainObject(data)) {
	        if (isNumber(data.left)) {
	          canvasData.left = data.left;
	        }
	
	        if (isNumber(data.top)) {
	          canvasData.top = data.top;
	        }
	
	        if (isNumber(data.width)) {
	          canvasData.width = data.width;
	          canvasData.height = data.width / aspectRatio;
	        } else if (isNumber(data.height)) {
	          canvasData.height = data.height;
	          canvasData.width = data.height * aspectRatio;
	        }
	
	        this.renderCanvas(true);
	      }
	
	      return this;
	    },
	
	    /**
	     * Get the crop box position and size data.
	     * @returns {Object} The result crop box data.
	     */
	    getCropBoxData: function getCropBoxData() {
	      var cropBoxData = this.cropBoxData;
	      var data;
	
	      if (this.ready && this.cropped) {
	        data = {
	          left: cropBoxData.left,
	          top: cropBoxData.top,
	          width: cropBoxData.width,
	          height: cropBoxData.height
	        };
	      }
	
	      return data || {};
	    },
	
	    /**
	     * Set the crop box position and size with new data.
	     * @param {Object} data - The new crop box data.
	     * @returns {Cropper} this
	     */
	    setCropBoxData: function setCropBoxData(data) {
	      var cropBoxData = this.cropBoxData;
	      var aspectRatio = this.options.aspectRatio;
	      var widthChanged;
	      var heightChanged;
	
	      if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
	        if (isNumber(data.left)) {
	          cropBoxData.left = data.left;
	        }
	
	        if (isNumber(data.top)) {
	          cropBoxData.top = data.top;
	        }
	
	        if (isNumber(data.width) && data.width !== cropBoxData.width) {
	          widthChanged = true;
	          cropBoxData.width = data.width;
	        }
	
	        if (isNumber(data.height) && data.height !== cropBoxData.height) {
	          heightChanged = true;
	          cropBoxData.height = data.height;
	        }
	
	        if (aspectRatio) {
	          if (widthChanged) {
	            cropBoxData.height = cropBoxData.width / aspectRatio;
	          } else if (heightChanged) {
	            cropBoxData.width = cropBoxData.height * aspectRatio;
	          }
	        }
	
	        this.renderCropBox();
	      }
	
	      return this;
	    },
	
	    /**
	     * Get a canvas drawn the cropped image.
	     * @param {Object} [options={}] - The config options.
	     * @returns {HTMLCanvasElement} - The result canvas.
	     */
	    getCroppedCanvas: function getCroppedCanvas() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (!this.ready || !window.HTMLCanvasElement) {
	        return null;
	      }
	
	      var canvasData = this.canvasData;
	      var source = getSourceCanvas(this.image, this.imageData, canvasData, options); // Returns the source canvas if it is not cropped.
	
	      if (!this.cropped) {
	        return source;
	      }
	
	      var _this$getData = this.getData(),
	          initialX = _this$getData.x,
	          initialY = _this$getData.y,
	          initialWidth = _this$getData.width,
	          initialHeight = _this$getData.height;
	
	      var ratio = source.width / Math.floor(canvasData.naturalWidth);
	
	      if (ratio !== 1) {
	        initialX *= ratio;
	        initialY *= ratio;
	        initialWidth *= ratio;
	        initialHeight *= ratio;
	      }
	
	      var aspectRatio = initialWidth / initialHeight;
	      var maxSizes = getAdjustedSizes({
	        aspectRatio: aspectRatio,
	        width: options.maxWidth || Infinity,
	        height: options.maxHeight || Infinity
	      });
	      var minSizes = getAdjustedSizes({
	        aspectRatio: aspectRatio,
	        width: options.minWidth || 0,
	        height: options.minHeight || 0
	      }, 'cover');
	
	      var _getAdjustedSizes = getAdjustedSizes({
	        aspectRatio: aspectRatio,
	        width: options.width || (ratio !== 1 ? source.width : initialWidth),
	        height: options.height || (ratio !== 1 ? source.height : initialHeight)
	      }),
	          width = _getAdjustedSizes.width,
	          height = _getAdjustedSizes.height;
	
	      width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
	      height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext('2d');
	      canvas.width = normalizeDecimalNumber(width);
	      canvas.height = normalizeDecimalNumber(height);
	      context.fillStyle = options.fillColor || 'transparent';
	      context.fillRect(0, 0, width, height);
	      var _options$imageSmoothi = options.imageSmoothingEnabled,
	          imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
	          imageSmoothingQuality = options.imageSmoothingQuality;
	      context.imageSmoothingEnabled = imageSmoothingEnabled;
	
	      if (imageSmoothingQuality) {
	        context.imageSmoothingQuality = imageSmoothingQuality;
	      } // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
	
	
	      var sourceWidth = source.width;
	      var sourceHeight = source.height; // Source canvas parameters
	
	      var srcX = initialX;
	      var srcY = initialY;
	      var srcWidth;
	      var srcHeight; // Destination canvas parameters
	
	      var dstX;
	      var dstY;
	      var dstWidth;
	      var dstHeight;
	
	      if (srcX <= -initialWidth || srcX > sourceWidth) {
	        srcX = 0;
	        srcWidth = 0;
	        dstX = 0;
	        dstWidth = 0;
	      } else if (srcX <= 0) {
	        dstX = -srcX;
	        srcX = 0;
	        srcWidth = Math.min(sourceWidth, initialWidth + srcX);
	        dstWidth = srcWidth;
	      } else if (srcX <= sourceWidth) {
	        dstX = 0;
	        srcWidth = Math.min(initialWidth, sourceWidth - srcX);
	        dstWidth = srcWidth;
	      }
	
	      if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
	        srcY = 0;
	        srcHeight = 0;
	        dstY = 0;
	        dstHeight = 0;
	      } else if (srcY <= 0) {
	        dstY = -srcY;
	        srcY = 0;
	        srcHeight = Math.min(sourceHeight, initialHeight + srcY);
	        dstHeight = srcHeight;
	      } else if (srcY <= sourceHeight) {
	        dstY = 0;
	        srcHeight = Math.min(initialHeight, sourceHeight - srcY);
	        dstHeight = srcHeight;
	      }
	
	      var params = [srcX, srcY, srcWidth, srcHeight]; // Avoid "IndexSizeError"
	
	      if (dstWidth > 0 && dstHeight > 0) {
	        var scale = width / initialWidth;
	        params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
	      } // All the numerical parameters should be integer for `drawImage`
	      // https://github.com/fengyuanchen/cropper/issues/476
	
	
	      context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function (param) {
	        return Math.floor(normalizeDecimalNumber(param));
	      }))));
	      return canvas;
	    },
	
	    /**
	     * Change the aspect ratio of the crop box.
	     * @param {number} aspectRatio - The new aspect ratio.
	     * @returns {Cropper} this
	     */
	    setAspectRatio: function setAspectRatio(aspectRatio) {
	      var options = this.options;
	
	      if (!this.disabled && !isUndefined(aspectRatio)) {
	        // 0 -> NaN
	        options.aspectRatio = Math.max(0, aspectRatio) || NaN;
	
	        if (this.ready) {
	          this.initCropBox();
	
	          if (this.cropped) {
	            this.renderCropBox();
	          }
	        }
	      }
	
	      return this;
	    },
	
	    /**
	     * Change the drag mode.
	     * @param {string} mode - The new drag mode.
	     * @returns {Cropper} this
	     */
	    setDragMode: function setDragMode(mode) {
	      var options = this.options,
	          dragBox = this.dragBox,
	          face = this.face;
	
	      if (this.ready && !this.disabled) {
	        var croppable = mode === DRAG_MODE_CROP;
	        var movable = options.movable && mode === DRAG_MODE_MOVE;
	        mode = croppable || movable ? mode : DRAG_MODE_NONE;
	        options.dragMode = mode;
	        setData(dragBox, DATA_ACTION, mode);
	        toggleClass(dragBox, CLASS_CROP, croppable);
	        toggleClass(dragBox, CLASS_MOVE, movable);
	
	        if (!options.cropBoxMovable) {
	          // Sync drag mode to crop box when it is not movable
	          setData(face, DATA_ACTION, mode);
	          toggleClass(face, CLASS_CROP, croppable);
	          toggleClass(face, CLASS_MOVE, movable);
	        }
	      }
	
	      return this;
	    }
	  };
	
	  var AnotherCropper = WINDOW.Cropper;
	
	  var Cropper = /*#__PURE__*/function () {
	    /**
	     * Create a new Cropper.
	     * @param {Element} element - The target element for cropping.
	     * @param {Object} [options={}] - The configuration options.
	     */
	    function Cropper(element) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _classCallCheck(this, Cropper);
	
	      if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
	        throw new Error('The first argument is required and must be an <img> or <canvas> element.');
	      }
	
	      this.element = element;
	      this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
	      this.cropped = false;
	      this.disabled = false;
	      this.pointers = {};
	      this.ready = false;
	      this.reloading = false;
	      this.replaced = false;
	      this.sized = false;
	      this.sizing = false;
	      this.init();
	    }
	
	    _createClass(Cropper, [{
	      key: "init",
	      value: function init() {
	        var element = this.element;
	        var tagName = element.tagName.toLowerCase();
	        var url;
	
	        if (element[NAMESPACE]) {
	          return;
	        }
	
	        element[NAMESPACE] = this;
	
	        if (tagName === 'img') {
	          this.isImg = true; // e.g.: "img/picture.jpg"
	
	          url = element.getAttribute('src') || '';
	          this.originalUrl = url; // Stop when it's a blank image
	
	          if (!url) {
	            return;
	          } // e.g.: "https://example.com/img/picture.jpg"
	
	
	          url = element.src;
	        } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
	          url = element.toDataURL();
	        }
	
	        this.load(url);
	      }
	    }, {
	      key: "load",
	      value: function load(url) {
	        var _this = this;
	
	        if (!url) {
	          return;
	        }
	
	        this.url = url;
	        this.imageData = {};
	        var element = this.element,
	            options = this.options;
	
	        if (!options.rotatable && !options.scalable) {
	          options.checkOrientation = false;
	        } // Only IE10+ supports Typed Arrays
	
	
	        if (!options.checkOrientation || !window.ArrayBuffer) {
	          this.clone();
	          return;
	        } // Detect the mime type of the image directly if it is a Data URL
	
	
	        if (REGEXP_DATA_URL.test(url)) {
	          // Read ArrayBuffer from Data URL of JPEG images directly for better performance
	          if (REGEXP_DATA_URL_JPEG.test(url)) {
	            this.read(dataURLToArrayBuffer(url));
	          } else {
	            // Only a JPEG image may contains Exif Orientation information,
	            // the rest types of Data URLs are not necessary to check orientation at all.
	            this.clone();
	          }
	
	          return;
	        } // 1. Detect the mime type of the image by a XMLHttpRequest.
	        // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.
	
	
	        var xhr = new XMLHttpRequest();
	        var clone = this.clone.bind(this);
	        this.reloading = true;
	        this.xhr = xhr; // 1. Cross origin requests are only supported for protocol schemes:
	        // http, https, data, chrome, chrome-extension.
	        // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
	        // in some browsers as IE11 and Safari.
	
	        xhr.onabort = clone;
	        xhr.onerror = clone;
	        xhr.ontimeout = clone;
	
	        xhr.onprogress = function () {
	          // Abort the request directly if it not a JPEG image for better performance
	          if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) {
	            xhr.abort();
	          }
	        };
	
	        xhr.onload = function () {
	          _this.read(xhr.response);
	        };
	
	        xhr.onloadend = function () {
	          _this.reloading = false;
	          _this.xhr = null;
	        }; // Bust cache when there is a "crossOrigin" property to avoid browser cache error
	
	
	        if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
	          url = addTimestamp(url);
	        }
	
	        xhr.open('GET', url);
	        xhr.responseType = 'arraybuffer';
	        xhr.withCredentials = element.crossOrigin === 'use-credentials';
	        xhr.send();
	      }
	    }, {
	      key: "read",
	      value: function read(arrayBuffer) {
	        var options = this.options,
	            imageData = this.imageData; // Reset the orientation value to its default value 1
	        // as some iOS browsers will render image with its orientation
	
	        var orientation = resetAndGetOrientation(arrayBuffer);
	        var rotate = 0;
	        var scaleX = 1;
	        var scaleY = 1;
	
	        if (orientation > 1) {
	          // Generate a new URL which has the default orientation value
	          this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
	
	          var _parseOrientation = parseOrientation(orientation);
	
	          rotate = _parseOrientation.rotate;
	          scaleX = _parseOrientation.scaleX;
	          scaleY = _parseOrientation.scaleY;
	        }
	
	        if (options.rotatable) {
	          imageData.rotate = rotate;
	        }
	
	        if (options.scalable) {
	          imageData.scaleX = scaleX;
	          imageData.scaleY = scaleY;
	        }
	
	        this.clone();
	      }
	    }, {
	      key: "clone",
	      value: function clone() {
	        var element = this.element,
	            url = this.url;
	        var crossOrigin = element.crossOrigin;
	        var crossOriginUrl = url;
	
	        if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
	          if (!crossOrigin) {
	            crossOrigin = 'anonymous';
	          } // Bust cache when there is not a "crossOrigin" property (#519)
	
	
	          crossOriginUrl = addTimestamp(url);
	        }
	
	        this.crossOrigin = crossOrigin;
	        this.crossOriginUrl = crossOriginUrl;
	        var image = document.createElement('img');
	
	        if (crossOrigin) {
	          image.crossOrigin = crossOrigin;
	        }
	
	        image.src = crossOriginUrl || url;
	        image.alt = element.alt || 'The image to crop';
	        this.image = image;
	        image.onload = this.start.bind(this);
	        image.onerror = this.stop.bind(this);
	        addClass(image, CLASS_HIDE);
	        element.parentNode.insertBefore(image, element.nextSibling);
	      }
	    }, {
	      key: "start",
	      value: function start() {
	        var _this2 = this;
	
	        var image = this.image;
	        image.onload = null;
	        image.onerror = null;
	        this.sizing = true; // Match all browsers that use WebKit as the layout engine in iOS devices,
	        // such as Safari for iOS, Chrome for iOS, and in-app browsers.
	
	        var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);
	
	        var done = function done(naturalWidth, naturalHeight) {
	          assign(_this2.imageData, {
	            naturalWidth: naturalWidth,
	            naturalHeight: naturalHeight,
	            aspectRatio: naturalWidth / naturalHeight
	          });
	          _this2.initialImageData = assign({}, _this2.imageData);
	          _this2.sizing = false;
	          _this2.sized = true;
	
	          _this2.build();
	        }; // Most modern browsers (excepts iOS WebKit)
	
	
	        if (image.naturalWidth && !isIOSWebKit) {
	          done(image.naturalWidth, image.naturalHeight);
	          return;
	        }
	
	        var sizingImage = document.createElement('img');
	        var body = document.body || document.documentElement;
	        this.sizingImage = sizingImage;
	
	        sizingImage.onload = function () {
	          done(sizingImage.width, sizingImage.height);
	
	          if (!isIOSWebKit) {
	            body.removeChild(sizingImage);
	          }
	        };
	
	        sizingImage.src = image.src; // iOS WebKit will convert the image automatically
	        // with its orientation once append it into DOM (#279)
	
	        if (!isIOSWebKit) {
	          sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
	          body.appendChild(sizingImage);
	        }
	      }
	    }, {
	      key: "stop",
	      value: function stop() {
	        var image = this.image;
	        image.onload = null;
	        image.onerror = null;
	        image.parentNode.removeChild(image);
	        this.image = null;
	      }
	    }, {
	      key: "build",
	      value: function build() {
	        if (!this.sized || this.ready) {
	          return;
	        }
	
	        var element = this.element,
	            options = this.options,
	            image = this.image; // Create cropper elements
	
	        var container = element.parentNode;
	        var template = document.createElement('div');
	        template.innerHTML = TEMPLATE;
	        var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
	        var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
	        var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
	        var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
	        var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
	        this.container = container;
	        this.cropper = cropper;
	        this.canvas = canvas;
	        this.dragBox = dragBox;
	        this.cropBox = cropBox;
	        this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
	        this.face = face;
	        canvas.appendChild(image); // Hide the original image
	
	        addClass(element, CLASS_HIDDEN); // Inserts the cropper after to the current image
	
	        container.insertBefore(cropper, element.nextSibling); // Show the image if is hidden
	
	        if (!this.isImg) {
	          removeClass(image, CLASS_HIDE);
	        }
	
	        this.initPreview();
	        this.bind();
	        options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
	        options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
	        options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
	        addClass(cropBox, CLASS_HIDDEN);
	
	        if (!options.guides) {
	          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
	        }
	
	        if (!options.center) {
	          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
	        }
	
	        if (options.background) {
	          addClass(cropper, "".concat(NAMESPACE, "-bg"));
	        }
	
	        if (!options.highlight) {
	          addClass(face, CLASS_INVISIBLE);
	        }
	
	        if (options.cropBoxMovable) {
	          addClass(face, CLASS_MOVE);
	          setData(face, DATA_ACTION, ACTION_ALL);
	        }
	
	        if (!options.cropBoxResizable) {
	          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
	          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
	        }
	
	        this.render();
	        this.ready = true;
	        this.setDragMode(options.dragMode);
	
	        if (options.autoCrop) {
	          this.crop();
	        }
	
	        this.setData(options.data);
	
	        if (isFunction(options.ready)) {
	          addListener(element, EVENT_READY, options.ready, {
	            once: true
	          });
	        }
	
	        dispatchEvent(element, EVENT_READY);
	      }
	    }, {
	      key: "unbuild",
	      value: function unbuild() {
	        if (!this.ready) {
	          return;
	        }
	
	        this.ready = false;
	        this.unbind();
	        this.resetPreview();
	        this.cropper.parentNode.removeChild(this.cropper);
	        removeClass(this.element, CLASS_HIDDEN);
	      }
	    }, {
	      key: "uncreate",
	      value: function uncreate() {
	        if (this.ready) {
	          this.unbuild();
	          this.ready = false;
	          this.cropped = false;
	        } else if (this.sizing) {
	          this.sizingImage.onload = null;
	          this.sizing = false;
	          this.sized = false;
	        } else if (this.reloading) {
	          this.xhr.onabort = null;
	          this.xhr.abort();
	        } else if (this.image) {
	          this.stop();
	        }
	      }
	      /**
	       * Get the no conflict cropper class.
	       * @returns {Cropper} The cropper class.
	       */
	
	    }], [{
	      key: "noConflict",
	      value: function noConflict() {
	        window.Cropper = AnotherCropper;
	        return Cropper;
	      }
	      /**
	       * Change the default options.
	       * @param {Object} options - The new default options.
	       */
	
	    }, {
	      key: "setDefaults",
	      value: function setDefaults(options) {
	        assign(DEFAULTS, isPlainObject(options) && options);
	      }
	    }]);
	
	    return Cropper;
	  }();
	
	  assign(Cropper.prototype, render, preview, events, handlers, change, methods);
	
	  return Cropper;
	
	})));


/***/ },
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-home-templates-appHome",body_0);function body_0(chk,ctx){return chk.w("<div id=\"cookie\" class=\"cookie\"></div><div id=\"loader\" class=\"hidden overlay-container showOverlay\"></div><div id=\"paywall\" class=\"hidden overlay-container showOverlay\"></div><div id=\"error\" class=\"hidden overlay-container showOverlay\"></div><div id=\"regionSelector\" class=\"hidden\"></div><div id=\"settings\" class=\"hidden overlay-container showOverlay\"></div><div id=\"app-container\" class=\"app-home\"><div class=\"top-bar-container\"></div><div id=\"app-content\"></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-home-templates-appHome';

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-home-templates-kiosque",body_0);function body_0(chk,ctx){return chk.w("<div class=\"kiosque\"><div class=\"kiosque-top\"><div class=\"kiosque-left\">").x(ctx.get(["iFrameTopURL"], false),ctx,{"block":body_1},{}).w("<div class=\"main-paper-container\"><div class=\"main-paper-wrapper\"><div class=\"main-label\"></div><div class=\"main-image-wrapper\"><img class=\"main-image hidden pointer\" src=\"\" ></div><div id=\"preferred-viewer-box\"></div><div class=\"main-button-container\"><div class=\"main-button-wrapper pointer\"><div class=\"main-button\">").f(ctx.getPath(false, ["i18n","Read"]),ctx,"h").w("</div></div></div></div></div>").x(ctx.get(["iFrameBottomURL"], false),ctx,{"block":body_2},{}).w("</div><div class=\"kiosque-right\"><div id=\"newsStand\" class=\"publications\"></div>").x(ctx.get(["iframeArchiveURL"], false),ctx,{"block":body_3},{}).w("<div id=\"promoSpot\" class=\"publications\"></div><div id=\"archive\" class=\"publications\"></div><div id=\"horsserie\" class=\"publications\"></div>").x(ctx.get(["iframeArchiveBottomURL"], false),ctx,{"block":body_4},{}).w("</div></div><div class=\"footer\"></div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div><iframe id=\"tw_iframe_top\" style=\"width:100%\" src=\"").f(ctx.get(["iFrameTopURL"], false),ctx,"h").w("\"></iframe></div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div><iframe id=\"tw_iframe_bottom\" style=\"width:100%\" src=\"").f(ctx.get(["iFrameBottomURL"], false),ctx,"h").w("\"></iframe></div>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<div class=\"iframe-archive\"><iframe id=\"iframeArchive\" style=\"width:100%\" src=\"").f(ctx.get(["iframeArchiveURL"], false),ctx,"h").w("\"></iframe></div>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<div class=\"iframe-archive-bottom\"><iframe id=\"iframeArchiveBottom\" style=\"width:100%\" src=\"").f(ctx.get(["iframeArchiveBottomURL"], false),ctx,"h").w("\"></iframe></div>");}body_4.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-home-templates-kiosque';

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-home-templates-publicationListSwiper",body_0);function body_0(chk,ctx){return chk.w("<div class=\"archiveTitle\">").f(ctx.get(["titleName"], false),ctx,"h").w("</div><div class=\"publicationList-container publicationList-").f(ctx.get(["name"], false),ctx,"h").w("\"><div class=\"publicationList-prev sliderList publicationList-").f(ctx.get(["name"], false),ctx,"h").w("-prev pointer\"></div><div class=\"swiper-container swiper-container-").f(ctx.get(["name"], false),ctx,"h").w("\"><div class=\"swiper-wrapper swiper-wrapper-").f(ctx.get(["name"], false),ctx,"h").w("\">").s(ctx.get(["slides"], false),ctx,{"block":body_1},{}).w("</div></div><div class=\"publicationList-next sliderList publicationList-").f(ctx.get(["name"], false),ctx,"h").w("-next pointer\"></div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"swiper-slide ").x(ctx.get(["current"], false),ctx,{"block":body_2},{}).w("\" data-tid=\"").f(ctx.get(["ThumbnailId"], false),ctx,"h").w("\" ").x(ctx.get(["PublicationId"], false),ctx,{"block":body_3},{}).w(" data-contentpackageid='").f(ctx.get(["ContentPackageId"], false),ctx,"h").w("' data-url=\"").f(ctx.get(["url"], false),ctx,"h").w("\"><div class=\"slide-wrapper pointer\"><div class=\"thumb-wrapper\"><img src=").f(ctx.get(["imageUrl"], false),ctx,"h").w("></div><div class=\"subTitle\">").f(ctx.get(["label"], false),ctx,"h").w("</div></div></div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("current");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("data-publicationid='").f(ctx.get(["PublicationId"], false),ctx,"h").w("'");}body_3.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-home-templates-publicationListSwiper';

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-home-templates-topBarCenter",body_0);function body_0(chk,ctx){return chk.w("<div class=\"current-region\"><div class=\"top-bar-region\"></div><div class=\"top-bar-arrow hidden  pointer\"></div></div><div id=\"region-list-container\" class=\"hidden\"></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-home-templates-topBarCenter';

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-appReader",body_0);function body_0(chk,ctx){return chk.w("<div id=\"cookie\" class=\"cookie\"></div><div id=\"loader\" class=\"hidden overlay-container showOverlay\"></div><div id=\"paywall\" class=\"hidden overlay-container showOverlay\"></div><div id=\"error\" class=\"hidden overlay-container showOverlay\"></div><div id=\"cropper\" class=\"hidden\"></div><div id=\"alb\" class=\"hidden\"></div><div id=\"imageviewer\" class=\"hidden\"></div><div id=\"settings\" class=\"hidden overlay-container showOverlay\"></div><div id=\"app-container\" class=\"app-reader\"><div class=\"top-bar-container\"></div><div id=\"app-content\" class=\"loading\"><div id=\"reader-container\"><div class=\"reader-box\"><div class=\"nav-col nav-col-prev\" id=\"reader-previous-singlePage\"><div class=\"previous-icon\"></div></div><div class=\"nav-col nav-col-next\" id=\"reader-next-singlePage\"><div class=\"next-icon\"></div></div><div id=\"reader\"></div><div class=\"reader-thumbs-slider hidden\"></div><div class=\"reader-navigation invisible\"><span class=\"page-num page-num-min\"></span><div class=\"slider-navigation slider-component\"></div><span class=\"page-num page-num-max\"></span><div id=\"zoom-component\"></div><div id=\"fullscreen-component\"></div></div></div><div id=\"sidebar\" class=\"hidden\"></div></div><div id=\"archive\"></div></div><div id=\"app_overlay\" class=\"app_hide\"></div> <!-- nextgen specific --></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-appReader';

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-categoriesPickerComponent",body_0);function body_0(chk,ctx){return chk.w("<div class=\"categories-picker-component\">").s(ctx.get(["categories"], false),ctx,{"block":body_1},{}).x(ctx.get(["showMore"], false),ctx,{"block":body_2},{}).w("</div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"categories-picker-item\" data-value=\"").f(ctx.get(["name"], false),ctx,"h").w("\" data-firstpageindex=\"").f(ctx.get(["page"], false),ctx,"h").w("\">").f(ctx.get(["name"], false),ctx,"h").w("</div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"categories-picker-item categories-picker-item-more\"><span class=\"categories-picker-item-more-toggle\"><span id=\"current-category\">").f(ctx.getPath(false, ["currentCategory","name"]),ctx,"h").w("</span> <i class=\"icon\"></i></span><ul class=\"categories-picker-dropdown categories-picker-dropdown-is-hidden\">").s(ctx.get(["moreCategories"], false),ctx,{"block":body_3},{}).w("</ul></div>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<li class=\"categories-picker-item categories-picker-dropdown-item\" data-firstpageindex=").f(ctx.get(["page"], false),ctx,"h").w(" data-value=\"").f(ctx.get(["name"], false),ctx,"h").w("\">").f(ctx.get(["name"], false),ctx,"h").w("</li>");}body_3.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-categoriesPickerComponent';

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-cropperComponent",body_0);function body_0(chk,ctx){return chk.w("<div class=\"cropper-container  overlay-wrapper\"><div class=\"cropper-view\"><div class=\"cropper-navigation\"><div class=\"cropper-nav-item cropper-nav-back\"><div class=\"back-icon\"></div></div><div class=\"cropper-nav-item  instruction-container\"><p class=\"instruction\">").f(ctx.getPath(false, ["i18n","cropPrintInstruction"]),ctx,"h",["s"]).w("</p> </div><div id=\"crop-print-btn\" class=\"cropper-nav-item crop-print\">").f(ctx.getPath(false, ["i18n","cropPrint"]),ctx,"h").w("</div></div><div id=\"image-container\"></div></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-cropperComponent';

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-fullscreenComponent",body_0);function body_0(chk,ctx){return chk.w("  <div id=\"fullscreen-enter\" class=\"fullscreen-enter-icon fullscreen-icon\"></div><div id=\"fullscreen-exit\" class=\"fullscreen-exit-icon fullscreen-icon\"></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-fullscreenComponent';

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-nextgenReaderComponent",body_0);function body_0(chk,ctx){return chk.w("<div class=\"nextgen-reader\"><div id=\"app_wrapper\"><div id=\"app_viewport\"><div id=\"app_arrows\"></div></div></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-nextgenReaderComponent';

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-printButtonComponent",body_0);function body_0(chk,ctx){return chk.x(ctx.get(["useCustomToolTip"], false),ctx,{"else":body_1,"block":body_4},{}).x(ctx.get(["printCroppedPdf"], false),ctx,{"block":body_5},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.x(ctx.get(["displayTopNavButtonlabel"], false),ctx,{"else":body_2,"block":body_3},{});}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<button class=\"print-icon\" title=\"").f(ctx.getPath(false, ["i18n","print"]),ctx,"h").w("\"></button>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<button class=\"print-icon\" title=\"").f(ctx.getPath(false, ["i18n","print"]),ctx,"h").w("\"></button><span class=\"print-label\">").f(ctx.getPath(false, ["i18n","print"]),ctx,"h").w("</span>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<button class=\"print-icon tooltip\" tooltip=\"").f(ctx.getPath(false, ["i18n","print"]),ctx,"h").w("\"></button>");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("<div class=\"printOption-container hidden\"></div>");}body_5.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-printButtonComponent';

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-printMenuComponent",body_0);function body_0(chk,ctx){return chk.w("  <div class=\"printOption-component\"> ").x(ctx.get(["isSingle"], false),ctx,{"else":body_1,"block":body_2},{}).w("</div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<a target=\"_blank\" class=\"print-cropped-item\" data-print=\"printLeftPage\"><div class=\"print-title\">").f(ctx.getPath(false, ["i18n","printLeftPage"]),ctx,"h").w("</div></a><a target=\"_blank\" class=\"print-cropped-item\" data-print=\"printRightPage\"><div class=\"print-title\">").f(ctx.getPath(false, ["i18n","printRightPage"]),ctx,"h").w("</div></a>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<a target=\"_blank\" class=\"print-cropped-item\" data-print=\"printSinglePage\"><div class=\"download-title\">").f(ctx.getPath(false, ["i18n","printSinglePage"]),ctx,"h").w("</div></a>");}body_2.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-printMenuComponent';

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-readerComponent",body_0);function body_0(chk,ctx){return chk.w("<div class=\"reader-component\"><div class=\"reader-wrapper\"><div class=\"nav-col nav-col-prev\" id=\"reader-previous\"><div class=\"previous-icon\"></div></div><div class=\"nav-col nav-col-next\" id=\"reader-next\"><div class=\"next-icon\"></div></div><div class=\"reader-container\"><div id=\"turn-reader\"></div></div></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-readerComponent';

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-readingModeButtonComponent",body_0);function body_0(chk,ctx){return chk.x(ctx.get(["useCustomToolTip"], false),ctx,{"else":body_1,"block":body_13},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.x(ctx.get(["displayTopNavButtonlabel"], false),ctx,{"else":body_2,"block":body_6},{});}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<button class=\"reading-mode-icon single-page-mode ").x(ctx.get(["isDoublePage"], false),ctx,{"block":body_3},{}).w("\" title=\"").f(ctx.getPath(false, ["i18n","singlePageMode"]),ctx,"h").w("\"></button><button class=\"reading-mode-icon double-page-mode ").x(ctx.get(["isDoublePage"], false),ctx,{"else":body_4,"block":body_5},{}).w("\" title=\"").f(ctx.getPath(false, ["i18n","doublePageMode"]),ctx,"h").w("\"></button>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("active");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("active");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk;}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("<button class=\"reading-mode-icon single-page-mode ").x(ctx.get(["isDoublePage"], false),ctx,{"block":body_7},{}).w("\" title=\"").f(ctx.getPath(false, ["i18n","singlePageMode"]),ctx,"h").w("\"></button><span class=\"reading-mode-label single-page-mode-label ").x(ctx.get(["isDoublePage"], false),ctx,{"block":body_8},{}).w("\">").f(ctx.getPath(false, ["i18n","singlePageMode"]),ctx,"h").w("</span><button class=\"reading-mode-icon double-page-mode ").x(ctx.get(["isDoublePage"], false),ctx,{"else":body_9,"block":body_10},{}).w("\" title=\"").f(ctx.getPath(false, ["i18n","doublePageMode"]),ctx,"h").w("\"></button><span class=\"reading-mode-label double-page-mode-label ").x(ctx.get(["isDoublePage"], false),ctx,{"else":body_11,"block":body_12},{}).w("\">").f(ctx.getPath(false, ["i18n","doublePageMode"]),ctx,"h").w("</span>");}body_6.__dustBody=!0;function body_7(chk,ctx){return chk.w("active");}body_7.__dustBody=!0;function body_8(chk,ctx){return chk.w("active");}body_8.__dustBody=!0;function body_9(chk,ctx){return chk.w("active");}body_9.__dustBody=!0;function body_10(chk,ctx){return chk;}body_10.__dustBody=!0;function body_11(chk,ctx){return chk.w("active");}body_11.__dustBody=!0;function body_12(chk,ctx){return chk.w(" ");}body_12.__dustBody=!0;function body_13(chk,ctx){return chk.w("<button class=\"reading-mode-icon single-page-mode tooltip ").x(ctx.get(["isDoublePage"], false),ctx,{"block":body_14},{}).w("\" tooltip=\"").f(ctx.getPath(false, ["i18n","singlePageMode"]),ctx,"h").w("\"></button><button class=\"reading-mode-icon double-page-mode tooltip ").x(ctx.get(["isDoublePage"], false),ctx,{"else":body_15,"block":body_16},{}).w("\" tooltip=\"").f(ctx.getPath(false, ["i18n","doublePageMode"]),ctx,"h").w("\"></button>");}body_13.__dustBody=!0;function body_14(chk,ctx){return chk.w("active");}body_14.__dustBody=!0;function body_15(chk,ctx){return chk.w("active");}body_15.__dustBody=!0;function body_16(chk,ctx){return chk;}body_16.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-readingModeButtonComponent';

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-sidebarComponent",body_0);function body_0(chk,ctx){return chk.w("<div class=\"sidebar-component\"><ul class=\"publications\">").s(ctx.get(["publications"], false),ctx,{"block":body_1},{}).w("</ul></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.x(ctx.get(["displayLabel"], false),ctx,{"else":body_2,"block":body_4},{});}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.x(ctx.get(["imageUrl"], false),ctx,{"block":body_3},{});}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<li class=\"publication animated fade-in\"id=\"publication-").f(ctx.get(["PublicationId"], false),ctx,"h").w("\"data-publication-id=\"").f(ctx.get(["PublicationId"], false),ctx,"h").w("\"data-publication-type=\"").f(ctx.get(["PublicationType"], false),ctx,"h").w("\"data-cp-id=\"").f(ctx.get(["ContentPackageId"], false),ctx,"h").w("\"><img src=").f(ctx.get(["imageUrl"], false),ctx,"h").w(" alt=\"cover\" /></li>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.x(ctx.get(["imageUrl"], false),ctx,{"block":body_5},{});}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("<li class=\"publication animated fade-in\"id=\"publication-").f(ctx.get(["PublicationId"], false),ctx,"h").w("\"data-publication-id=\"").f(ctx.get(["PublicationId"], false),ctx,"h").w("\"data-publication-type=\"").f(ctx.get(["PublicationType"], false),ctx,"h").w("\"data-cp-id=\"").f(ctx.get(["ContentPackageId"], false),ctx,"h").w("\"><img src=").f(ctx.get(["imageUrl"], false),ctx,"h").w(" alt=\"cover\" />").x(ctx.get(["label"], false),ctx,{"block":body_6},{}).w("</li>");}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("<div class=\"publication-name\">").f(ctx.get(["label"], false),ctx,"h").w("</div>");}body_6.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-sidebarComponent';

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-reader-templates-zoomComponent",body_0);function body_0(chk,ctx){return chk.w("<div id=\"zoom-out-button\" class=\"zoom-button\"><div class=\"zoom-out-icon zoom-icon\"></div></div><div id=\"zoom-slider\" class=\"zoom-slider\"><div class=\"slider-zoom slider-component\"></div></div><div id=\"zoom-in-button\" class=\"zoom-button\"><div class=\"zoom-in-icon zoom-icon\"></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-reader-templates-zoomComponent';

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-shared-templates-helpButtonComponent",body_0);function body_0(chk,ctx){return chk.x(ctx.get(["useCustomToolTip"], false),ctx,{"else":body_1,"block":body_4},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.x(ctx.get(["displayTopNavButtonlabel"], false),ctx,{"else":body_2,"block":body_3},{});}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<button class=\"help-icon\" title=\"").f(ctx.getPath(false, ["i18n","help"]),ctx,"h").w("\"></button>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<button class=\"help-icon\" title=\"").f(ctx.getPath(false, ["i18n","help"]),ctx,"h").w("\"></button><span class=\"help-label\">").f(ctx.getPath(false, ["i18n","help"]),ctx,"h").w("</span>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<button class=\"help-icon tooltip\" tooltip=\"").f(ctx.getPath(false, ["i18n","help"]),ctx,"h").w("\"></button>");}body_4.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-shared-templates-helpButtonComponent';

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-shared-templates-settingsButtonComponent",body_0);function body_0(chk,ctx){return chk.x(ctx.get(["useCustomToolTip"], false),ctx,{"else":body_1,"block":body_4},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.x(ctx.get(["displayTopNavButtonlabel"], false),ctx,{"else":body_2,"block":body_3},{});}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<button class=\"settings-icon\" title=\"").f(ctx.getPath(false, ["i18n","settings"]),ctx,"h").w("\"></button>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<button class=\"settings-icon\" title=\"").f(ctx.getPath(false, ["i18n","settings"]),ctx,"h").w("\"></button><span class=\"settings-label\">").f(ctx.getPath(false, ["i18n","settings"]),ctx,"h").w("</span>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<button class=\"settings-icon tooltip\" tooltip=\"").f(ctx.getPath(false, ["i18n","settings"]),ctx,"h").w("\"></button>");}body_4.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-shared-templates-settingsButtonComponent';

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var dust = __webpack_require__(7);
	(function(dust){dust.register("src-web-shared-templates-topBarComponent",body_0);function body_0(chk,ctx){return chk.x(ctx.get(["useCustomToolTip"], false),ctx,{"else":body_1,"block":body_2},{}).w("<img class=\"logo\" /></div><div class=\"top-bar-item top-bar-center\"></div><div class=\"top-bar-item top-bar-outer top-bar-access\"><div id=\"preferred-viewer-wrapper\"></div></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"top-bar-item top-bar-outer top-bar-logo\">");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"top-bar-item top-bar-outer top-bar-logo tooltip\" tooltip=\"").x(ctx.get(["isReader"], false),ctx,{"else":body_3,"block":body_4},{}).w("\">");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.f(ctx.getPath(false, ["i18n","logoTooltip"]),ctx,"h");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.f(ctx.getPath(false, ["i18n","readerLogoTooltip"]),ctx,"h");}body_4.__dustBody=!0;return body_0}(dust));
	module.exports = 'src-web-shared-templates-topBarComponent';

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _es6EventEmitter = __webpack_require__(8);
	
	var _es6EventEmitter2 = _interopRequireDefault(_es6EventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	"use strict"; /* Copyright 2013 Rob Wu <gwnRob@gmail.com>
	               * https://github.com/Rob--W/grab-to-pan.js
	               *
	               * Licensed under the Apache License, Version 2.0 (the "License");
	               * you may not use this file except in compliance with the License.
	               * You may obtain a copy of the License at
	               *
	               *     http://www.apache.org/licenses/LICENSE-2.0
	               *
	               * Unless required by applicable law or agreed to in writing, software
	               * distributed under the License is distributed on an "AS IS" BASIS,
	               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	               * See the License for the specific language governing permissions and
	               * limitations under the License.
	               */
	
	var GrabToPan = function GrabToPanClosure() {
	  /**
	   * Construct a GrabToPan instance for a given HTML element.
	   * @param options.element {Element}
	   * @param options.ignoreTarget {function} optional. See `ignoreTarget(node)`
	   * @param options.onActiveChanged {function(boolean)} optional. Called
	   *  when grab-to-pan is (de)activated. The first argument is a boolean that
	   *  shows whether grab-to-pan is activated.
	   */
	  function GrabToPan(options) {
	    this.element = options.element;
	    this.document = options.element.ownerDocument;
	    if (typeof options.ignoreTarget === "function") {
	      this.ignoreTarget = options.ignoreTarget;
	    }
	    this.onActiveChanged = options.onActiveChanged;
	
	    // Bind the contexts to ensure that `this` always points to
	    // the GrabToPan instance.
	    this.activate = this.activate.bind(this);
	    this.deactivate = this.deactivate.bind(this);
	    this.toggle = this.toggle.bind(this);
	    this._onmousedown = this._onmousedown.bind(this);
	    this._onmousemove = this._onmousemove.bind(this);
	    this._endPan = this._endPan.bind(this);
	    this.events = {};
	    this.eventLength = 0;
	
	    // This overlay will be inserted in the document when the mouse moves during
	    // a grab operation, to ensure that the cursor has the desired appearance.
	    var overlay = this.overlay = document.createElement("div");
	    // Inline styles to get maximum CSS specifity
	    overlay.style.position = "fixed";
	    overlay.style.background = "transparent";
	    overlay.style.display = "block";
	    overlay.style.top = "0";
	    overlay.style.left = "0";
	    overlay.style.right = "0";
	    overlay.style.bottom = "0";
	    overlay.style.height = "auto";
	    overlay.style.width = "auto";
	    overlay.style.overflow = "hidden";
	    overlay.style.zIndex = "2000000000";
	    // Inherit cursor style via CSS style sheet:
	    overlay.className = "grab-to-pan-grabbing";
	  }
	
	  GrabToPan.prototype = {
	    on: function on() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _es6EventEmitter2.default.prototype.on.apply(this, args);
	    },
	
	    off: function off(event, callback) {
	      if (callback) {
	        _es6EventEmitter2.default.prototype.off.call(this, event, callback);
	      } else {
	        this.eventLength -= this.events[event].length;
	        this.events[event] = [];
	      }
	    },
	
	    trigger: function trigger() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      _es6EventEmitter2.default.prototype.trigger.apply(this, args);
	    },
	    /**
	     * Class name of element which can be grabbed
	     */
	    CSS_CLASS_GRAB: "grab-to-pan-grab",
	
	    /**
	     * Bind a mousedown event to the element to enable grab-detection.
	     */
	    activate: function GrabToPan_activate() {
	      if (!this.active) {
	        this.active = true;
	        this.element.addEventListener("click", this.clicked);
	        this.element.addEventListener("mousedown", this._onmousedown, true);
	        this.element.classList.add(this.CSS_CLASS_GRAB);
	        if (this.onActiveChanged) {
	          this.onActiveChanged(true);
	        }
	      }
	    },
	
	    clicked: function clicked_mouse() {},
	
	    /**
	     * Removes all events. Any pending pan session is immediately stopped.
	     */
	    deactivate: function GrabToPan_deactivate() {
	      if (this.active) {
	        this.active = false;
	        this.element.removeEventListener("mousedown", this._onmousedown, true);
	        this._endPan();
	        this.element.classList.remove(this.CSS_CLASS_GRAB);
	        if (this.onActiveChanged) {
	          this.onActiveChanged(false);
	        }
	      }
	    },
	
	    toggle: function GrabToPan_toggle() {
	      if (this.active) {
	        this.deactivate();
	      } else {
	        this.activate();
	      }
	    },
	
	    /**
	     * Whether to not pan if the target element is clicked.
	     * Override this method to change the default behaviour.
	     *
	     * @param node {Element} The target of the event
	     * @return {boolean} Whether to not react to the click event.
	     */
	    ignoreTarget: function GrabToPan_ignoreTarget(node) {
	      // Use matchesSelector to check whether the clicked element
	      // is (a child of) an input element / link
	      return node[matchesSelector]("a[href], a[href] *, input, textarea, button, button *, select, option");
	    },
	
	    /**
	     * @private
	     */
	    _onmousedown: function GrabToPan__onmousedown(event) {
	      if (event.button !== 0 || this.ignoreTarget(event.target)) {
	        return;
	      }
	      if (event.originalTarget) {
	        try {
	          /* jshint expr:true */
	          event.originalTarget.tagName;
	        } catch (e) {
	          // Mozilla-specific: element is a scrollbar (XUL element)
	          return;
	        }
	      }
	
	      this.scrollLeftStart = this.element.scrollLeft;
	      this.scrollTopStart = this.element.scrollTop;
	      this.clientXStart = event.clientX;
	      this.clientYStart = event.clientY;
	      this.trigger("grabToPan:panStart");
	      this.document.addEventListener("mousemove", this._onmousemove, true);
	      this.document.addEventListener("mouseup", this._endPan, true);
	      // When a scroll event occurs before a mousemove, assume that the user
	      // dragged a scrollbar (necessary for Opera Presto, Safari and IE)
	      // (not needed for Chrome/Firefox)
	      this.element.addEventListener("scroll", this._endPan, true);
	      event.preventDefault();
	      event.stopPropagation();
	      this.document.documentElement.classList.add(this.CSS_CLASS_GRABBING);
	    },
	
	    /**
	     * @private
	     */
	    _onmousemove: function GrabToPan__onmousemove(event) {
	      this.element.removeEventListener("scroll", this._endPan, true);
	      if (isLeftMouseReleased(event)) {
	        this._endPan();
	        return;
	      }
	      var xDiff = event.clientX - this.clientXStart;
	      var yDiff = event.clientY - this.clientYStart;
	      this.element.scrollTop = this.scrollTopStart - yDiff;
	      this.element.scrollLeft = this.scrollLeftStart - xDiff;
	      if (!this.overlay.parentNode) {
	        document.body.appendChild(this.overlay);
	      }
	    },
	
	    /**
	     * @private
	     */
	    _endPan: function GrabToPan__endPan() {
	      this.element.removeEventListener("scroll", this._endPan, true);
	      this.document.removeEventListener("mousemove", this._onmousemove, true);
	      this.document.removeEventListener("mouseup", this._endPan, true);
	      this.trigger("grabToPan:panEnd");
	      if (this.overlay.parentNode) {
	        this.overlay.parentNode.removeChild(this.overlay);
	      }
	    }
	  };
	
	  // Get the correct (vendor-prefixed) name of the matches method.
	  var matchesSelector;
	  ["webkitM", "mozM", "msM", "oM", "m"].some(function (prefix) {
	    var name = prefix + "atches";
	    if (name in document.documentElement) {
	      matchesSelector = name;
	    }
	    name += "Selector";
	    if (name in document.documentElement) {
	      matchesSelector = name;
	    }
	    return matchesSelector; // If found, then truthy, and [].some() ends.
	  });
	
	  // Browser sniffing because it's impossible to feature-detect
	  // whether event.which for onmousemove is reliable
	  var isNotIEorIsIE10plus = !document.documentMode || document.documentMode > 9;
	  var chrome = window.chrome;
	  var isChrome15OrOpera15plus = chrome && (chrome.webstore || chrome.app);
	  //                                       ^ Chrome 15+       ^ Opera 15+
	  var isSafari6plus = /Apple/.test(navigator.vendor) && /Version\/([6-9]\d*|[1-5]\d+)/.test(navigator.userAgent);
	
	  /**
	   * Whether the left mouse is not pressed.
	   * @param event {MouseEvent}
	   * @return {boolean} True if the left mouse button is not pressed.
	   *                   False if unsure or if the left mouse button is pressed.
	   */
	  function isLeftMouseReleased(event) {
	    if ("buttons" in event && isNotIEorIsIE10plus) {
	      // http://www.w3.org/TR/DOM-Level-3-Events/#events-MouseEvent-buttons
	      // Firefox 15+
	      // Internet Explorer 10+
	      return !(event.buttons | 1);
	    }
	    if (isChrome15OrOpera15plus || isSafari6plus) {
	      // Chrome 14+
	      // Opera 15+
	      // Safari 6.0+
	      return event.which === 0;
	    }
	  }
	
	  return GrabToPan;
	}();
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = GrabToPan;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_reader.png";

/***/ }
]);


// WEBPACK FOOTER //
// partial/web.js